(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec789"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec789"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9HB6H", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fy1yK"));

});
parcelRegister("fy1yK", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $b51b3dabc534165f$export$ffb0004e005737fa; }, function (v) { return $b51b3dabc534165f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $b51b3dabc534165f$export$34b9dba7ce09269b; }, function (v) { return $b51b3dabc534165f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $b51b3dabc534165f$export$25062201e9e25d76; }, function (v) { return $b51b3dabc534165f$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b51b3dabc534165f$export$ffb0004e005737fa;
var $b51b3dabc534165f$export$34b9dba7ce09269b;
var $b51b3dabc534165f$export$25062201e9e25d76;
'use strict';

var $iD6kw = parcelRequire("iD6kw");
var $b51b3dabc534165f$var$k = Symbol.for("react.element"), $b51b3dabc534165f$var$l = Symbol.for("react.fragment"), $b51b3dabc534165f$var$m = Object.prototype.hasOwnProperty, $b51b3dabc534165f$var$n = $iD6kw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $b51b3dabc534165f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b51b3dabc534165f$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$b51b3dabc534165f$var$m.call(a, b) && !$b51b3dabc534165f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $b51b3dabc534165f$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $b51b3dabc534165f$var$n.current
    };
}
$b51b3dabc534165f$export$ffb0004e005737fa = $b51b3dabc534165f$var$l;
$b51b3dabc534165f$export$34b9dba7ce09269b = $b51b3dabc534165f$var$q;
$b51b3dabc534165f$export$25062201e9e25d76 = $b51b3dabc534165f$var$q;

});
parcelRegister("iD6kw", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jowWt"));

});
parcelRegister("jowWt", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $e1e9cfd39d0569dc$export$dca3b0875bd9a954; }, function (v) { return $e1e9cfd39d0569dc$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $e1e9cfd39d0569dc$export$16fa2f45be04daa8; }, function (v) { return $e1e9cfd39d0569dc$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e1e9cfd39d0569dc$export$ffb0004e005737fa; }, function (v) { return $e1e9cfd39d0569dc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $e1e9cfd39d0569dc$export$e2c29f18771995cb; }, function (v) { return $e1e9cfd39d0569dc$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $e1e9cfd39d0569dc$export$221d75b3f55bb0bd; }, function (v) { return $e1e9cfd39d0569dc$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e1e9cfd39d0569dc$export$5f8d39834fd61797; }, function (v) { return $e1e9cfd39d0569dc$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e1e9cfd39d0569dc$export$74bf444e3cd11ea5; }, function (v) { return $e1e9cfd39d0569dc$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e1e9cfd39d0569dc$export$ae55be85d98224ed; }, function (v) { return $e1e9cfd39d0569dc$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $e1e9cfd39d0569dc$export$3ba232387fd5d6dd; }, function (v) { return $e1e9cfd39d0569dc$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $e1e9cfd39d0569dc$export$e530037191fcd5d7; }, function (v) { return $e1e9cfd39d0569dc$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $e1e9cfd39d0569dc$export$fd42f52fd3ae1109; }, function (v) { return $e1e9cfd39d0569dc$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $e1e9cfd39d0569dc$export$c8a8987d4410bf2d; }, function (v) { return $e1e9cfd39d0569dc$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $e1e9cfd39d0569dc$export$d38cd72104c1f0e9; }, function (v) { return $e1e9cfd39d0569dc$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $e1e9cfd39d0569dc$export$7d1e3a5e95ceca43; }, function (v) { return $e1e9cfd39d0569dc$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $e1e9cfd39d0569dc$export$257a8862b851cb5b; }, function (v) { return $e1e9cfd39d0569dc$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $e1e9cfd39d0569dc$export$a8257692ac88316c; }, function (v) { return $e1e9cfd39d0569dc$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $e1e9cfd39d0569dc$export$488013bae63b21da; }, function (v) { return $e1e9cfd39d0569dc$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $e1e9cfd39d0569dc$export$7c73462e0d25e514; }, function (v) { return $e1e9cfd39d0569dc$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $e1e9cfd39d0569dc$export$7568632d0d33d16d; }, function (v) { return $e1e9cfd39d0569dc$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $e1e9cfd39d0569dc$export$88948ce120ea2619; }, function (v) { return $e1e9cfd39d0569dc$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $e1e9cfd39d0569dc$export$35808ee640e87ca7; }, function (v) { return $e1e9cfd39d0569dc$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $e1e9cfd39d0569dc$export$fae74005e78b1a27; }, function (v) { return $e1e9cfd39d0569dc$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $e1e9cfd39d0569dc$export$dc8fbce3eb94dc1e; }, function (v) { return $e1e9cfd39d0569dc$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $e1e9cfd39d0569dc$export$6a7bc4e911dc01cf; }, function (v) { return $e1e9cfd39d0569dc$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $e1e9cfd39d0569dc$export$6d9c69b0de29b591; }, function (v) { return $e1e9cfd39d0569dc$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $e1e9cfd39d0569dc$export$f680877a34711e37; }, function (v) { return $e1e9cfd39d0569dc$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $e1e9cfd39d0569dc$export$d5a552a76deda3c2; }, function (v) { return $e1e9cfd39d0569dc$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $e1e9cfd39d0569dc$export$aaabe4eda9ed9969; }, function (v) { return $e1e9cfd39d0569dc$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $e1e9cfd39d0569dc$export$e5c5a5f917a5871c; }, function (v) { return $e1e9cfd39d0569dc$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $e1e9cfd39d0569dc$export$1538c33de8887b59; }, function (v) { return $e1e9cfd39d0569dc$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $e1e9cfd39d0569dc$export$13e3392192263954; }, function (v) { return $e1e9cfd39d0569dc$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $e1e9cfd39d0569dc$export$b8f5890fc79d6aca; }, function (v) { return $e1e9cfd39d0569dc$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $e1e9cfd39d0569dc$export$60241385465d0a34; }, function (v) { return $e1e9cfd39d0569dc$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $e1e9cfd39d0569dc$export$306c0aa65ff9ec16; }, function (v) { return $e1e9cfd39d0569dc$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $e1e9cfd39d0569dc$export$7b286972b8d8ccbf; }, function (v) { return $e1e9cfd39d0569dc$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $e1e9cfd39d0569dc$export$83d89fbfd8236492; }, function (v) { return $e1e9cfd39d0569dc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5djcY = parcelRequire("5djcY");
var $e1e9cfd39d0569dc$export$dca3b0875bd9a954;
var $e1e9cfd39d0569dc$export$16fa2f45be04daa8;
var $e1e9cfd39d0569dc$export$ffb0004e005737fa;
var $e1e9cfd39d0569dc$export$e2c29f18771995cb;
var $e1e9cfd39d0569dc$export$221d75b3f55bb0bd;
var $e1e9cfd39d0569dc$export$5f8d39834fd61797;
var $e1e9cfd39d0569dc$export$74bf444e3cd11ea5;
var $e1e9cfd39d0569dc$export$ae55be85d98224ed;
var $e1e9cfd39d0569dc$export$3ba232387fd5d6dd;
var $e1e9cfd39d0569dc$export$e530037191fcd5d7;
var $e1e9cfd39d0569dc$export$fd42f52fd3ae1109;
var $e1e9cfd39d0569dc$export$c8a8987d4410bf2d;
var $e1e9cfd39d0569dc$export$d38cd72104c1f0e9;
var $e1e9cfd39d0569dc$export$7d1e3a5e95ceca43;
var $e1e9cfd39d0569dc$export$257a8862b851cb5b;
var $e1e9cfd39d0569dc$export$a8257692ac88316c;
var $e1e9cfd39d0569dc$export$488013bae63b21da;
var $e1e9cfd39d0569dc$export$7c73462e0d25e514;
var $e1e9cfd39d0569dc$export$7568632d0d33d16d;
var $e1e9cfd39d0569dc$export$88948ce120ea2619;
var $e1e9cfd39d0569dc$export$35808ee640e87ca7;
var $e1e9cfd39d0569dc$export$fae74005e78b1a27;
var $e1e9cfd39d0569dc$export$dc8fbce3eb94dc1e;
var $e1e9cfd39d0569dc$export$6a7bc4e911dc01cf;
var $e1e9cfd39d0569dc$export$6d9c69b0de29b591;
var $e1e9cfd39d0569dc$export$f680877a34711e37;
var $e1e9cfd39d0569dc$export$d5a552a76deda3c2;
var $e1e9cfd39d0569dc$export$aaabe4eda9ed9969;
var $e1e9cfd39d0569dc$export$e5c5a5f917a5871c;
var $e1e9cfd39d0569dc$export$1538c33de8887b59;
var $e1e9cfd39d0569dc$export$13e3392192263954;
var $e1e9cfd39d0569dc$export$b8f5890fc79d6aca;
var $e1e9cfd39d0569dc$export$60241385465d0a34;
var $e1e9cfd39d0569dc$export$306c0aa65ff9ec16;
var $e1e9cfd39d0569dc$export$7b286972b8d8ccbf;
var $e1e9cfd39d0569dc$export$83d89fbfd8236492;
'use strict';
var $e1e9cfd39d0569dc$var$l = Symbol.for("react.element"), $e1e9cfd39d0569dc$var$n = Symbol.for("react.portal"), $e1e9cfd39d0569dc$var$p = Symbol.for("react.fragment"), $e1e9cfd39d0569dc$var$q = Symbol.for("react.strict_mode"), $e1e9cfd39d0569dc$var$r = Symbol.for("react.profiler"), $e1e9cfd39d0569dc$var$t = Symbol.for("react.provider"), $e1e9cfd39d0569dc$var$u = Symbol.for("react.context"), $e1e9cfd39d0569dc$var$v = Symbol.for("react.forward_ref"), $e1e9cfd39d0569dc$var$w = Symbol.for("react.suspense"), $e1e9cfd39d0569dc$var$x = Symbol.for("react.memo"), $e1e9cfd39d0569dc$var$y = Symbol.for("react.lazy"), $e1e9cfd39d0569dc$var$z = Symbol.iterator;
function $e1e9cfd39d0569dc$var$A(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a))) return null;
    a = $e1e9cfd39d0569dc$var$z && a[$e1e9cfd39d0569dc$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e1e9cfd39d0569dc$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $e1e9cfd39d0569dc$var$C = Object.assign, $e1e9cfd39d0569dc$var$D = {};
function $e1e9cfd39d0569dc$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e1e9cfd39d0569dc$var$D;
    this.updater = e || $e1e9cfd39d0569dc$var$B;
}
$e1e9cfd39d0569dc$var$E.prototype.isReactComponent = {};
$e1e9cfd39d0569dc$var$E.prototype.setState = function(a, b) {
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$e1e9cfd39d0569dc$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $e1e9cfd39d0569dc$var$F() {}
$e1e9cfd39d0569dc$var$F.prototype = $e1e9cfd39d0569dc$var$E.prototype;
function $e1e9cfd39d0569dc$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e1e9cfd39d0569dc$var$D;
    this.updater = e || $e1e9cfd39d0569dc$var$B;
}
var $e1e9cfd39d0569dc$var$H = $e1e9cfd39d0569dc$var$G.prototype = new $e1e9cfd39d0569dc$var$F;
$e1e9cfd39d0569dc$var$H.constructor = $e1e9cfd39d0569dc$var$G;
$e1e9cfd39d0569dc$var$C($e1e9cfd39d0569dc$var$H, $e1e9cfd39d0569dc$var$E.prototype);
$e1e9cfd39d0569dc$var$H.isPureReactComponent = !0;
var $e1e9cfd39d0569dc$var$I = Array.isArray, $e1e9cfd39d0569dc$var$J = Object.prototype.hasOwnProperty, $e1e9cfd39d0569dc$var$K = {
    current: null
}, $e1e9cfd39d0569dc$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e1e9cfd39d0569dc$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$e1e9cfd39d0569dc$var$J.call(b, d) && !$e1e9cfd39d0569dc$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $e1e9cfd39d0569dc$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $e1e9cfd39d0569dc$var$K.current
    };
}
function $e1e9cfd39d0569dc$var$N(a, b) {
    return {
        $$typeof: $e1e9cfd39d0569dc$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $e1e9cfd39d0569dc$var$O(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && null !== a && a.$$typeof === $e1e9cfd39d0569dc$var$l;
}
function $e1e9cfd39d0569dc$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $e1e9cfd39d0569dc$var$P = /\/+/g;
function $e1e9cfd39d0569dc$var$Q(a, b) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && null !== a && null != a.key ? $e1e9cfd39d0569dc$var$escape("" + a.key) : b.toString(36);
}
function $e1e9cfd39d0569dc$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $e1e9cfd39d0569dc$var$l:
                case $e1e9cfd39d0569dc$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $e1e9cfd39d0569dc$var$Q(h, 0) : d, $e1e9cfd39d0569dc$var$I(c) ? (e = "", null != a && (e = a.replace($e1e9cfd39d0569dc$var$P, "$&/") + "/"), $e1e9cfd39d0569dc$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($e1e9cfd39d0569dc$var$O(c) && (c = $e1e9cfd39d0569dc$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($e1e9cfd39d0569dc$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($e1e9cfd39d0569dc$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $e1e9cfd39d0569dc$var$Q(k, g);
        h += $e1e9cfd39d0569dc$var$R(k, b, e, f, c);
    }
    else if (f = $e1e9cfd39d0569dc$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $e1e9cfd39d0569dc$var$Q(k, g++), h += $e1e9cfd39d0569dc$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $e1e9cfd39d0569dc$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $e1e9cfd39d0569dc$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $e1e9cfd39d0569dc$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $e1e9cfd39d0569dc$var$U = {
    current: null
}, $e1e9cfd39d0569dc$var$V = {
    transition: null
}, $e1e9cfd39d0569dc$var$W = {
    ReactCurrentDispatcher: $e1e9cfd39d0569dc$var$U,
    ReactCurrentBatchConfig: $e1e9cfd39d0569dc$var$V,
    ReactCurrentOwner: $e1e9cfd39d0569dc$var$K
};
function $e1e9cfd39d0569dc$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$e1e9cfd39d0569dc$export$dca3b0875bd9a954 = {
    map: $e1e9cfd39d0569dc$var$S,
    forEach: function forEach(a, b, e) {
        $e1e9cfd39d0569dc$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $e1e9cfd39d0569dc$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $e1e9cfd39d0569dc$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$e1e9cfd39d0569dc$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$e1e9cfd39d0569dc$export$16fa2f45be04daa8 = $e1e9cfd39d0569dc$var$E;
$e1e9cfd39d0569dc$export$ffb0004e005737fa = $e1e9cfd39d0569dc$var$p;
$e1e9cfd39d0569dc$export$e2c29f18771995cb = $e1e9cfd39d0569dc$var$r;
$e1e9cfd39d0569dc$export$221d75b3f55bb0bd = $e1e9cfd39d0569dc$var$G;
$e1e9cfd39d0569dc$export$5f8d39834fd61797 = $e1e9cfd39d0569dc$var$q;
$e1e9cfd39d0569dc$export$74bf444e3cd11ea5 = $e1e9cfd39d0569dc$var$w;
$e1e9cfd39d0569dc$export$ae55be85d98224ed = $e1e9cfd39d0569dc$var$W;
$e1e9cfd39d0569dc$export$3ba232387fd5d6dd = $e1e9cfd39d0569dc$var$X;
$e1e9cfd39d0569dc$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $e1e9cfd39d0569dc$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $e1e9cfd39d0569dc$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$e1e9cfd39d0569dc$var$J.call(b, f) && !$e1e9cfd39d0569dc$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $e1e9cfd39d0569dc$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$e1e9cfd39d0569dc$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $e1e9cfd39d0569dc$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $e1e9cfd39d0569dc$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$e1e9cfd39d0569dc$export$c8a8987d4410bf2d = $e1e9cfd39d0569dc$var$M;
$e1e9cfd39d0569dc$export$d38cd72104c1f0e9 = function(a) {
    var b = $e1e9cfd39d0569dc$var$M.bind(null, a);
    b.type = a;
    return b;
};
$e1e9cfd39d0569dc$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e1e9cfd39d0569dc$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $e1e9cfd39d0569dc$var$v,
        render: a
    };
};
$e1e9cfd39d0569dc$export$a8257692ac88316c = $e1e9cfd39d0569dc$var$O;
$e1e9cfd39d0569dc$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $e1e9cfd39d0569dc$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $e1e9cfd39d0569dc$var$T
    };
};
$e1e9cfd39d0569dc$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $e1e9cfd39d0569dc$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$e1e9cfd39d0569dc$export$7568632d0d33d16d = function(a) {
    var b = $e1e9cfd39d0569dc$var$V.transition;
    $e1e9cfd39d0569dc$var$V.transition = {};
    try {
        a();
    } finally{
        $e1e9cfd39d0569dc$var$V.transition = b;
    }
};
$e1e9cfd39d0569dc$export$88948ce120ea2619 = $e1e9cfd39d0569dc$var$X;
$e1e9cfd39d0569dc$export$35808ee640e87ca7 = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useCallback(a, b);
};
$e1e9cfd39d0569dc$export$fae74005e78b1a27 = function(a) {
    return $e1e9cfd39d0569dc$var$U.current.useContext(a);
};
$e1e9cfd39d0569dc$export$dc8fbce3eb94dc1e = function() {};
$e1e9cfd39d0569dc$export$6a7bc4e911dc01cf = function(a) {
    return $e1e9cfd39d0569dc$var$U.current.useDeferredValue(a);
};
$e1e9cfd39d0569dc$export$6d9c69b0de29b591 = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useEffect(a, b);
};
$e1e9cfd39d0569dc$export$f680877a34711e37 = function() {
    return $e1e9cfd39d0569dc$var$U.current.useId();
};
$e1e9cfd39d0569dc$export$d5a552a76deda3c2 = function(a, b, e) {
    return $e1e9cfd39d0569dc$var$U.current.useImperativeHandle(a, b, e);
};
$e1e9cfd39d0569dc$export$aaabe4eda9ed9969 = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useInsertionEffect(a, b);
};
$e1e9cfd39d0569dc$export$e5c5a5f917a5871c = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useLayoutEffect(a, b);
};
$e1e9cfd39d0569dc$export$1538c33de8887b59 = function(a, b) {
    return $e1e9cfd39d0569dc$var$U.current.useMemo(a, b);
};
$e1e9cfd39d0569dc$export$13e3392192263954 = function(a, b, e) {
    return $e1e9cfd39d0569dc$var$U.current.useReducer(a, b, e);
};
$e1e9cfd39d0569dc$export$b8f5890fc79d6aca = function(a) {
    return $e1e9cfd39d0569dc$var$U.current.useRef(a);
};
$e1e9cfd39d0569dc$export$60241385465d0a34 = function(a) {
    return $e1e9cfd39d0569dc$var$U.current.useState(a);
};
$e1e9cfd39d0569dc$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $e1e9cfd39d0569dc$var$U.current.useSyncExternalStore(a, b, e);
};
$e1e9cfd39d0569dc$export$7b286972b8d8ccbf = function() {
    return $e1e9cfd39d0569dc$var$U.current.useTransition();
};
$e1e9cfd39d0569dc$export$83d89fbfd8236492 = "18.3.1";

});
parcelRegister("5djcY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3cbd10fe5fe1c504$export$71511d61b312f219; });
function $3cbd10fe5fe1c504$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRegister("kwI20", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $ef18f37ed0802d0c$export$882461b6382ed46c; }, function (v) { return $ef18f37ed0802d0c$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $ef18f37ed0802d0c$export$757ceba2d55c277e; }, function (v) { return $ef18f37ed0802d0c$export$757ceba2d55c277e = v; });
var $ef18f37ed0802d0c$export$882461b6382ed46c;
var $ef18f37ed0802d0c$export$757ceba2d55c277e;
'use strict';

var $kqzqZ = parcelRequire("kqzqZ");
var $ef18f37ed0802d0c$var$i;
$ef18f37ed0802d0c$export$882461b6382ed46c = $kqzqZ.createRoot;
$ef18f37ed0802d0c$export$757ceba2d55c277e = $kqzqZ.hydrateRoot;

});
parcelRegister("kqzqZ", function(module, exports) {
'use strict';
function $edf1b8dfeeff597d$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($edf1b8dfeeff597d$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$edf1b8dfeeff597d$var$checkDCE();

module.exports = (parcelRequire("gr7iX"));

});
parcelRegister("gr7iX", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bf74d58b74973e6b$export$ae55be85d98224ed; }, function (v) { return $bf74d58b74973e6b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $bf74d58b74973e6b$export$d39a5bbd09211389; }, function (v) { return $bf74d58b74973e6b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $bf74d58b74973e6b$export$882461b6382ed46c; }, function (v) { return $bf74d58b74973e6b$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $bf74d58b74973e6b$export$466bfc07425424d5; }, function (v) { return $bf74d58b74973e6b$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $bf74d58b74973e6b$export$cd75ccfd720a3cd4; }, function (v) { return $bf74d58b74973e6b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $bf74d58b74973e6b$export$fa8d919ba61d84db; }, function (v) { return $bf74d58b74973e6b$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $bf74d58b74973e6b$export$757ceba2d55c277e; }, function (v) { return $bf74d58b74973e6b$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $bf74d58b74973e6b$export$b3890eb0ae9dca99; }, function (v) { return $bf74d58b74973e6b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $bf74d58b74973e6b$export$502457920280e6be; }, function (v) { return $bf74d58b74973e6b$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $bf74d58b74973e6b$export$c78a37762a8d58e1; }, function (v) { return $bf74d58b74973e6b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $bf74d58b74973e6b$export$dc54d992c10e8a18; }, function (v) { return $bf74d58b74973e6b$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $bf74d58b74973e6b$export$83d89fbfd8236492; }, function (v) { return $bf74d58b74973e6b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $5djcY = parcelRequire("5djcY");
var $bf74d58b74973e6b$export$ae55be85d98224ed;
var $bf74d58b74973e6b$export$d39a5bbd09211389;
var $bf74d58b74973e6b$export$882461b6382ed46c;
var $bf74d58b74973e6b$export$466bfc07425424d5;
var $bf74d58b74973e6b$export$cd75ccfd720a3cd4;
var $bf74d58b74973e6b$export$fa8d919ba61d84db;
var $bf74d58b74973e6b$export$757ceba2d55c277e;
var $bf74d58b74973e6b$export$b3890eb0ae9dca99;
var $bf74d58b74973e6b$export$502457920280e6be;
var $bf74d58b74973e6b$export$c78a37762a8d58e1;
var $bf74d58b74973e6b$export$dc54d992c10e8a18;
var $bf74d58b74973e6b$export$83d89fbfd8236492;
'use strict';

var $iD6kw = parcelRequire("iD6kw");

var $ojHeY = parcelRequire("ojHeY");
function $bf74d58b74973e6b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $bf74d58b74973e6b$var$da = new Set, $bf74d58b74973e6b$var$ea = {};
function $bf74d58b74973e6b$var$fa(a, b) {
    $bf74d58b74973e6b$var$ha(a, b);
    $bf74d58b74973e6b$var$ha(a + "Capture", b);
}
function $bf74d58b74973e6b$var$ha(a, b) {
    $bf74d58b74973e6b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$bf74d58b74973e6b$var$da.add(b[a]);
}
var $bf74d58b74973e6b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $bf74d58b74973e6b$var$ja = Object.prototype.hasOwnProperty, $bf74d58b74973e6b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $bf74d58b74973e6b$var$la = {}, $bf74d58b74973e6b$var$ma = {};
function $bf74d58b74973e6b$var$oa(a) {
    if ($bf74d58b74973e6b$var$ja.call($bf74d58b74973e6b$var$ma, a)) return !0;
    if ($bf74d58b74973e6b$var$ja.call($bf74d58b74973e6b$var$la, a)) return !1;
    if ($bf74d58b74973e6b$var$ka.test(a)) return $bf74d58b74973e6b$var$ma[a] = !0;
    $bf74d58b74973e6b$var$la[a] = !0;
    return !1;
}
function $bf74d58b74973e6b$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $5djcY._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $bf74d58b74973e6b$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $bf74d58b74973e6b$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $bf74d58b74973e6b$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $bf74d58b74973e6b$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $bf74d58b74973e6b$var$z[b] = new $bf74d58b74973e6b$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $bf74d58b74973e6b$var$ra = /[\-:]([a-z])/g;
function $bf74d58b74973e6b$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($bf74d58b74973e6b$var$ra, $bf74d58b74973e6b$var$sa);
    $bf74d58b74973e6b$var$z[b] = new $bf74d58b74973e6b$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($bf74d58b74973e6b$var$ra, $bf74d58b74973e6b$var$sa);
    $bf74d58b74973e6b$var$z[b] = new $bf74d58b74973e6b$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($bf74d58b74973e6b$var$ra, $bf74d58b74973e6b$var$sa);
    $bf74d58b74973e6b$var$z[b] = new $bf74d58b74973e6b$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$bf74d58b74973e6b$var$z.xlinkHref = new $bf74d58b74973e6b$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $bf74d58b74973e6b$var$z[a] = new $bf74d58b74973e6b$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $bf74d58b74973e6b$var$ta(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$z.hasOwnProperty(b) ? $bf74d58b74973e6b$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $bf74d58b74973e6b$var$qa(b, c, e, d) && (c = null), d || null === e ? $bf74d58b74973e6b$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $bf74d58b74973e6b$var$ua = $iD6kw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $bf74d58b74973e6b$var$va = Symbol.for("react.element"), $bf74d58b74973e6b$var$wa = Symbol.for("react.portal"), $bf74d58b74973e6b$var$ya = Symbol.for("react.fragment"), $bf74d58b74973e6b$var$za = Symbol.for("react.strict_mode"), $bf74d58b74973e6b$var$Aa = Symbol.for("react.profiler"), $bf74d58b74973e6b$var$Ba = Symbol.for("react.provider"), $bf74d58b74973e6b$var$Ca = Symbol.for("react.context"), $bf74d58b74973e6b$var$Da = Symbol.for("react.forward_ref"), $bf74d58b74973e6b$var$Ea = Symbol.for("react.suspense"), $bf74d58b74973e6b$var$Fa = Symbol.for("react.suspense_list"), $bf74d58b74973e6b$var$Ga = Symbol.for("react.memo"), $bf74d58b74973e6b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $bf74d58b74973e6b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $bf74d58b74973e6b$var$Ja = Symbol.iterator;
function $bf74d58b74973e6b$var$Ka(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a))) return null;
    a = $bf74d58b74973e6b$var$Ja && a[$bf74d58b74973e6b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $bf74d58b74973e6b$var$A = Object.assign, $bf74d58b74973e6b$var$La;
function $bf74d58b74973e6b$var$Ma(a) {
    if (void 0 === $bf74d58b74973e6b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $bf74d58b74973e6b$var$La = b && b[1] || "";
    }
    return "\n" + $bf74d58b74973e6b$var$La + a;
}
var $bf74d58b74973e6b$var$Na = !1;
function $bf74d58b74973e6b$var$Oa(a, b) {
    if (!a || $bf74d58b74973e6b$var$Na) return "";
    $bf74d58b74973e6b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === (typeof Reflect === "undefined" ? "undefined" : (0, $5djcY._)(Reflect)) && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $bf74d58b74973e6b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $bf74d58b74973e6b$var$Ma(a) : "";
}
function $bf74d58b74973e6b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $bf74d58b74973e6b$var$Ma(a.type);
        case 16:
            return $bf74d58b74973e6b$var$Ma("Lazy");
        case 13:
            return $bf74d58b74973e6b$var$Ma("Suspense");
        case 19:
            return $bf74d58b74973e6b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $bf74d58b74973e6b$var$Oa(a.type, !1), a;
        case 11:
            return a = $bf74d58b74973e6b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $bf74d58b74973e6b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $bf74d58b74973e6b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $bf74d58b74973e6b$var$ya:
            return "Fragment";
        case $bf74d58b74973e6b$var$wa:
            return "Portal";
        case $bf74d58b74973e6b$var$Aa:
            return "Profiler";
        case $bf74d58b74973e6b$var$za:
            return "StrictMode";
        case $bf74d58b74973e6b$var$Ea:
            return "Suspense";
        case $bf74d58b74973e6b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a))) switch(a.$$typeof){
        case $bf74d58b74973e6b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $bf74d58b74973e6b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $bf74d58b74973e6b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $bf74d58b74973e6b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $bf74d58b74973e6b$var$Qa(a.type) || "Memo";
        case $bf74d58b74973e6b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $bf74d58b74973e6b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $bf74d58b74973e6b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $bf74d58b74973e6b$var$Qa(b);
        case 8:
            return b === $bf74d58b74973e6b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $bf74d58b74973e6b$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $bf74d58b74973e6b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $bf74d58b74973e6b$var$Ua(a) {
    var b = $bf74d58b74973e6b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $bf74d58b74973e6b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $bf74d58b74973e6b$var$Ua(a));
}
function $bf74d58b74973e6b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $bf74d58b74973e6b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $bf74d58b74973e6b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $bf74d58b74973e6b$var$Ya(a, b) {
    var c = b.checked;
    return $bf74d58b74973e6b$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $bf74d58b74973e6b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $bf74d58b74973e6b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $bf74d58b74973e6b$var$ab(a, b) {
    b = b.checked;
    null != b && $bf74d58b74973e6b$var$ta(a, "checked", b, !1);
}
function $bf74d58b74973e6b$var$bb(a, b) {
    $bf74d58b74973e6b$var$ab(a, b);
    var c = $bf74d58b74973e6b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $bf74d58b74973e6b$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $bf74d58b74973e6b$var$cb(a, b.type, $bf74d58b74973e6b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $bf74d58b74973e6b$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $bf74d58b74973e6b$var$cb(a, b, c) {
    if ("number" !== b || $bf74d58b74973e6b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $bf74d58b74973e6b$var$eb = Array.isArray;
function $bf74d58b74973e6b$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $bf74d58b74973e6b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $bf74d58b74973e6b$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($bf74d58b74973e6b$var$p(91));
    return $bf74d58b74973e6b$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $bf74d58b74973e6b$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($bf74d58b74973e6b$var$p(92));
            if ($bf74d58b74973e6b$var$eb(c)) {
                if (1 < c.length) throw Error($bf74d58b74973e6b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $bf74d58b74973e6b$var$Sa(c)
    };
}
function $bf74d58b74973e6b$var$ib(a, b) {
    var c = $bf74d58b74973e6b$var$Sa(b.value), d = $bf74d58b74973e6b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $bf74d58b74973e6b$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $bf74d58b74973e6b$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $bf74d58b74973e6b$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $bf74d58b74973e6b$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $bf74d58b74973e6b$var$mb, $bf74d58b74973e6b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $bf74d58b74973e6b$var$mb = $bf74d58b74973e6b$var$mb || document.createElement("div");
        $bf74d58b74973e6b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $bf74d58b74973e6b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $bf74d58b74973e6b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $bf74d58b74973e6b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $bf74d58b74973e6b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($bf74d58b74973e6b$var$pb).forEach(function(a) {
    $bf74d58b74973e6b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $bf74d58b74973e6b$var$pb[b] = $bf74d58b74973e6b$var$pb[a];
    });
});
function $bf74d58b74973e6b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $bf74d58b74973e6b$var$pb.hasOwnProperty(a) && $bf74d58b74973e6b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $bf74d58b74973e6b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $bf74d58b74973e6b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $bf74d58b74973e6b$var$tb = $bf74d58b74973e6b$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $bf74d58b74973e6b$var$ub(a, b) {
    if (b) {
        if ($bf74d58b74973e6b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($bf74d58b74973e6b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($bf74d58b74973e6b$var$p(60));
            if ("object" !== (0, $5djcY._)(b.dangerouslySetInnerHTML) || !("__html" in b.dangerouslySetInnerHTML)) throw Error($bf74d58b74973e6b$var$p(61));
        }
        if (null != b.style && "object" !== (0, $5djcY._)(b.style)) throw Error($bf74d58b74973e6b$var$p(62));
    }
}
function $bf74d58b74973e6b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $bf74d58b74973e6b$var$wb = null;
function $bf74d58b74973e6b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $bf74d58b74973e6b$var$yb = null, $bf74d58b74973e6b$var$zb = null, $bf74d58b74973e6b$var$Ab = null;
function $bf74d58b74973e6b$var$Bb(a) {
    if (a = $bf74d58b74973e6b$var$Cb(a)) {
        if ("function" !== typeof $bf74d58b74973e6b$var$yb) throw Error($bf74d58b74973e6b$var$p(280));
        var b = a.stateNode;
        b && (b = $bf74d58b74973e6b$var$Db(b), $bf74d58b74973e6b$var$yb(a.stateNode, a.type, b));
    }
}
function $bf74d58b74973e6b$var$Eb(a) {
    $bf74d58b74973e6b$var$zb ? $bf74d58b74973e6b$var$Ab ? $bf74d58b74973e6b$var$Ab.push(a) : $bf74d58b74973e6b$var$Ab = [
        a
    ] : $bf74d58b74973e6b$var$zb = a;
}
function $bf74d58b74973e6b$var$Fb() {
    if ($bf74d58b74973e6b$var$zb) {
        var a = $bf74d58b74973e6b$var$zb, b = $bf74d58b74973e6b$var$Ab;
        $bf74d58b74973e6b$var$Ab = $bf74d58b74973e6b$var$zb = null;
        $bf74d58b74973e6b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$bf74d58b74973e6b$var$Bb(b[a]);
    }
}
function $bf74d58b74973e6b$var$Gb(a, b) {
    return a(b);
}
function $bf74d58b74973e6b$var$Hb() {}
var $bf74d58b74973e6b$var$Ib = !1;
function $bf74d58b74973e6b$var$Jb(a, b, c) {
    if ($bf74d58b74973e6b$var$Ib) return a(b, c);
    $bf74d58b74973e6b$var$Ib = !0;
    try {
        return $bf74d58b74973e6b$var$Gb(a, b, c);
    } finally{
        if ($bf74d58b74973e6b$var$Ib = !1, null !== $bf74d58b74973e6b$var$zb || null !== $bf74d58b74973e6b$var$Ab) $bf74d58b74973e6b$var$Hb(), $bf74d58b74973e6b$var$Fb();
    }
}
function $bf74d58b74973e6b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $bf74d58b74973e6b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($bf74d58b74973e6b$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $5djcY._)(c)));
    return c;
}
var $bf74d58b74973e6b$var$Lb = !1;
if ($bf74d58b74973e6b$var$ia) try {
    var $bf74d58b74973e6b$var$Mb = {};
    Object.defineProperty($bf74d58b74973e6b$var$Mb, "passive", {
        get: function get() {
            $bf74d58b74973e6b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $bf74d58b74973e6b$var$Mb, $bf74d58b74973e6b$var$Mb);
    window.removeEventListener("test", $bf74d58b74973e6b$var$Mb, $bf74d58b74973e6b$var$Mb);
} catch (a) {
    $bf74d58b74973e6b$var$Lb = !1;
}
function $bf74d58b74973e6b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $bf74d58b74973e6b$var$Ob = !1, $bf74d58b74973e6b$var$Pb = null, $bf74d58b74973e6b$var$Qb = !1, $bf74d58b74973e6b$var$Rb = null, $bf74d58b74973e6b$var$Sb = {
    onError: function onError(a) {
        $bf74d58b74973e6b$var$Ob = !0;
        $bf74d58b74973e6b$var$Pb = a;
    }
};
function $bf74d58b74973e6b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $bf74d58b74973e6b$var$Ob = !1;
    $bf74d58b74973e6b$var$Pb = null;
    $bf74d58b74973e6b$var$Nb.apply($bf74d58b74973e6b$var$Sb, arguments);
}
function $bf74d58b74973e6b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $bf74d58b74973e6b$var$Tb.apply(this, arguments);
    if ($bf74d58b74973e6b$var$Ob) {
        if ($bf74d58b74973e6b$var$Ob) {
            var l = $bf74d58b74973e6b$var$Pb;
            $bf74d58b74973e6b$var$Ob = !1;
            $bf74d58b74973e6b$var$Pb = null;
        } else throw Error($bf74d58b74973e6b$var$p(198));
        $bf74d58b74973e6b$var$Qb || ($bf74d58b74973e6b$var$Qb = !0, $bf74d58b74973e6b$var$Rb = l);
    }
}
function $bf74d58b74973e6b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $bf74d58b74973e6b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $bf74d58b74973e6b$var$Xb(a) {
    if ($bf74d58b74973e6b$var$Vb(a) !== a) throw Error($bf74d58b74973e6b$var$p(188));
}
function $bf74d58b74973e6b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $bf74d58b74973e6b$var$Vb(a);
        if (null === b) throw Error($bf74d58b74973e6b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $bf74d58b74973e6b$var$Xb(e), a;
                if (f === d) return $bf74d58b74973e6b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($bf74d58b74973e6b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($bf74d58b74973e6b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($bf74d58b74973e6b$var$p(190));
    }
    if (3 !== c.tag) throw Error($bf74d58b74973e6b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $bf74d58b74973e6b$var$Zb(a) {
    a = $bf74d58b74973e6b$var$Yb(a);
    return null !== a ? $bf74d58b74973e6b$var$$b(a) : null;
}
function $bf74d58b74973e6b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $bf74d58b74973e6b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $bf74d58b74973e6b$var$ac = $ojHeY.unstable_scheduleCallback, $bf74d58b74973e6b$var$bc = $ojHeY.unstable_cancelCallback, $bf74d58b74973e6b$var$cc = $ojHeY.unstable_shouldYield, $bf74d58b74973e6b$var$dc = $ojHeY.unstable_requestPaint, $bf74d58b74973e6b$var$B = $ojHeY.unstable_now, $bf74d58b74973e6b$var$ec = $ojHeY.unstable_getCurrentPriorityLevel, $bf74d58b74973e6b$var$fc = $ojHeY.unstable_ImmediatePriority, $bf74d58b74973e6b$var$gc = $ojHeY.unstable_UserBlockingPriority, $bf74d58b74973e6b$var$hc = $ojHeY.unstable_NormalPriority, $bf74d58b74973e6b$var$ic = $ojHeY.unstable_LowPriority, $bf74d58b74973e6b$var$jc = $ojHeY.unstable_IdlePriority, $bf74d58b74973e6b$var$kc = null, $bf74d58b74973e6b$var$lc = null;
function $bf74d58b74973e6b$var$mc(a) {
    if ($bf74d58b74973e6b$var$lc && "function" === typeof $bf74d58b74973e6b$var$lc.onCommitFiberRoot) try {
        $bf74d58b74973e6b$var$lc.onCommitFiberRoot($bf74d58b74973e6b$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $bf74d58b74973e6b$var$oc = Math.clz32 ? Math.clz32 : $bf74d58b74973e6b$var$nc, $bf74d58b74973e6b$var$pc = Math.log, $bf74d58b74973e6b$var$qc = Math.LN2;
function $bf74d58b74973e6b$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($bf74d58b74973e6b$var$pc(a) / $bf74d58b74973e6b$var$qc | 0) | 0;
}
var $bf74d58b74973e6b$var$rc = 64, $bf74d58b74973e6b$var$sc = 4194304;
function $bf74d58b74973e6b$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $bf74d58b74973e6b$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $bf74d58b74973e6b$var$tc(h) : (f &= g, 0 !== f && (d = $bf74d58b74973e6b$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $bf74d58b74973e6b$var$tc(g) : 0 !== f && (d = $bf74d58b74973e6b$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $bf74d58b74973e6b$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $bf74d58b74973e6b$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $bf74d58b74973e6b$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $bf74d58b74973e6b$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $bf74d58b74973e6b$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $bf74d58b74973e6b$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $bf74d58b74973e6b$var$yc() {
    var a = $bf74d58b74973e6b$var$rc;
    $bf74d58b74973e6b$var$rc <<= 1;
    0 === ($bf74d58b74973e6b$var$rc & 4194240) && ($bf74d58b74973e6b$var$rc = 64);
    return a;
}
function $bf74d58b74973e6b$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $bf74d58b74973e6b$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $bf74d58b74973e6b$var$oc(b);
    a[b] = c;
}
function $bf74d58b74973e6b$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $bf74d58b74973e6b$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $bf74d58b74973e6b$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $bf74d58b74973e6b$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $bf74d58b74973e6b$var$C = 0;
function $bf74d58b74973e6b$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $bf74d58b74973e6b$var$Ec, $bf74d58b74973e6b$var$Fc, $bf74d58b74973e6b$var$Gc, $bf74d58b74973e6b$var$Hc, $bf74d58b74973e6b$var$Ic, $bf74d58b74973e6b$var$Jc = !1, $bf74d58b74973e6b$var$Kc = [], $bf74d58b74973e6b$var$Lc = null, $bf74d58b74973e6b$var$Mc = null, $bf74d58b74973e6b$var$Nc = null, $bf74d58b74973e6b$var$Oc = new Map, $bf74d58b74973e6b$var$Pc = new Map, $bf74d58b74973e6b$var$Qc = [], $bf74d58b74973e6b$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $bf74d58b74973e6b$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $bf74d58b74973e6b$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $bf74d58b74973e6b$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $bf74d58b74973e6b$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $bf74d58b74973e6b$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $bf74d58b74973e6b$var$Pc.delete(b.pointerId);
    }
}
function $bf74d58b74973e6b$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $bf74d58b74973e6b$var$Cb(b), null !== b && $bf74d58b74973e6b$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $bf74d58b74973e6b$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $bf74d58b74973e6b$var$Lc = $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $bf74d58b74973e6b$var$Mc = $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $bf74d58b74973e6b$var$Nc = $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $bf74d58b74973e6b$var$Oc.set(f, $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $bf74d58b74973e6b$var$Pc.set(f, $bf74d58b74973e6b$var$Tc($bf74d58b74973e6b$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $bf74d58b74973e6b$var$Vc(a) {
    var b = $bf74d58b74973e6b$var$Wc(a.target);
    if (null !== b) {
        var c = $bf74d58b74973e6b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $bf74d58b74973e6b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $bf74d58b74973e6b$var$Ic(a.priority, function() {
                        $bf74d58b74973e6b$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $bf74d58b74973e6b$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $bf74d58b74973e6b$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $bf74d58b74973e6b$var$wb = d;
            c.target.dispatchEvent(d);
            $bf74d58b74973e6b$var$wb = null;
        } else return b = $bf74d58b74973e6b$var$Cb(c), null !== b && $bf74d58b74973e6b$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $bf74d58b74973e6b$var$Zc(a, b, c) {
    $bf74d58b74973e6b$var$Xc(a) && c.delete(b);
}
function $bf74d58b74973e6b$var$$c() {
    $bf74d58b74973e6b$var$Jc = !1;
    null !== $bf74d58b74973e6b$var$Lc && $bf74d58b74973e6b$var$Xc($bf74d58b74973e6b$var$Lc) && ($bf74d58b74973e6b$var$Lc = null);
    null !== $bf74d58b74973e6b$var$Mc && $bf74d58b74973e6b$var$Xc($bf74d58b74973e6b$var$Mc) && ($bf74d58b74973e6b$var$Mc = null);
    null !== $bf74d58b74973e6b$var$Nc && $bf74d58b74973e6b$var$Xc($bf74d58b74973e6b$var$Nc) && ($bf74d58b74973e6b$var$Nc = null);
    $bf74d58b74973e6b$var$Oc.forEach($bf74d58b74973e6b$var$Zc);
    $bf74d58b74973e6b$var$Pc.forEach($bf74d58b74973e6b$var$Zc);
}
function $bf74d58b74973e6b$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $bf74d58b74973e6b$var$Jc || ($bf74d58b74973e6b$var$Jc = !0, $ojHeY.unstable_scheduleCallback($ojHeY.unstable_NormalPriority, $bf74d58b74973e6b$var$$c)));
}
function $bf74d58b74973e6b$var$bd(a) {
    function b(b) {
        return $bf74d58b74973e6b$var$ad(b, a);
    }
    if (0 < $bf74d58b74973e6b$var$Kc.length) {
        $bf74d58b74973e6b$var$ad($bf74d58b74973e6b$var$Kc[0], a);
        for(var c = 1; c < $bf74d58b74973e6b$var$Kc.length; c++){
            var d = $bf74d58b74973e6b$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $bf74d58b74973e6b$var$Lc && $bf74d58b74973e6b$var$ad($bf74d58b74973e6b$var$Lc, a);
    null !== $bf74d58b74973e6b$var$Mc && $bf74d58b74973e6b$var$ad($bf74d58b74973e6b$var$Mc, a);
    null !== $bf74d58b74973e6b$var$Nc && $bf74d58b74973e6b$var$ad($bf74d58b74973e6b$var$Nc, a);
    $bf74d58b74973e6b$var$Oc.forEach(b);
    $bf74d58b74973e6b$var$Pc.forEach(b);
    for(c = 0; c < $bf74d58b74973e6b$var$Qc.length; c++)d = $bf74d58b74973e6b$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $bf74d58b74973e6b$var$Qc.length && (c = $bf74d58b74973e6b$var$Qc[0], null === c.blockedOn);)$bf74d58b74973e6b$var$Vc(c), null === c.blockedOn && $bf74d58b74973e6b$var$Qc.shift();
}
var $bf74d58b74973e6b$var$cd = $bf74d58b74973e6b$var$ua.ReactCurrentBatchConfig, $bf74d58b74973e6b$var$dd = !0;
function $bf74d58b74973e6b$var$ed(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$C, f = $bf74d58b74973e6b$var$cd.transition;
    $bf74d58b74973e6b$var$cd.transition = null;
    try {
        $bf74d58b74973e6b$var$C = 1, $bf74d58b74973e6b$var$fd(a, b, c, d);
    } finally{
        $bf74d58b74973e6b$var$C = e, $bf74d58b74973e6b$var$cd.transition = f;
    }
}
function $bf74d58b74973e6b$var$gd(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$C, f = $bf74d58b74973e6b$var$cd.transition;
    $bf74d58b74973e6b$var$cd.transition = null;
    try {
        $bf74d58b74973e6b$var$C = 4, $bf74d58b74973e6b$var$fd(a, b, c, d);
    } finally{
        $bf74d58b74973e6b$var$C = e, $bf74d58b74973e6b$var$cd.transition = f;
    }
}
function $bf74d58b74973e6b$var$fd(a, b, c, d) {
    if ($bf74d58b74973e6b$var$dd) {
        var e = $bf74d58b74973e6b$var$Yc(a, b, c, d);
        if (null === e) $bf74d58b74973e6b$var$hd(a, b, d, $bf74d58b74973e6b$var$id, c), $bf74d58b74973e6b$var$Sc(a, d);
        else if ($bf74d58b74973e6b$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($bf74d58b74973e6b$var$Sc(a, d), b & 4 && -1 < $bf74d58b74973e6b$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $bf74d58b74973e6b$var$Cb(e);
                null !== f && $bf74d58b74973e6b$var$Ec(f);
                f = $bf74d58b74973e6b$var$Yc(a, b, c, d);
                null === f && $bf74d58b74973e6b$var$hd(a, b, d, $bf74d58b74973e6b$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $bf74d58b74973e6b$var$hd(a, b, d, null, c);
    }
}
var $bf74d58b74973e6b$var$id = null;
function $bf74d58b74973e6b$var$Yc(a, b, c, d) {
    $bf74d58b74973e6b$var$id = null;
    a = $bf74d58b74973e6b$var$xb(d);
    a = $bf74d58b74973e6b$var$Wc(a);
    if (null !== a) {
        if (b = $bf74d58b74973e6b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $bf74d58b74973e6b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $bf74d58b74973e6b$var$id = a;
    return null;
}
function $bf74d58b74973e6b$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($bf74d58b74973e6b$var$ec()){
                case $bf74d58b74973e6b$var$fc:
                    return 1;
                case $bf74d58b74973e6b$var$gc:
                    return 4;
                case $bf74d58b74973e6b$var$hc:
                case $bf74d58b74973e6b$var$ic:
                    return 16;
                case $bf74d58b74973e6b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $bf74d58b74973e6b$var$kd = null, $bf74d58b74973e6b$var$ld = null, $bf74d58b74973e6b$var$md = null;
function $bf74d58b74973e6b$var$nd() {
    if ($bf74d58b74973e6b$var$md) return $bf74d58b74973e6b$var$md;
    var a, b = $bf74d58b74973e6b$var$ld, c = b.length, d, e = "value" in $bf74d58b74973e6b$var$kd ? $bf74d58b74973e6b$var$kd.value : $bf74d58b74973e6b$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $bf74d58b74973e6b$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $bf74d58b74973e6b$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $bf74d58b74973e6b$var$pd() {
    return !0;
}
function $bf74d58b74973e6b$var$qd() {
    return !1;
}
function $bf74d58b74973e6b$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $bf74d58b74973e6b$var$pd : $bf74d58b74973e6b$var$qd;
        this.isPropagationStopped = $bf74d58b74973e6b$var$qd;
        return this;
    }
    $bf74d58b74973e6b$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $5djcY._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $bf74d58b74973e6b$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $5djcY._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $bf74d58b74973e6b$var$pd);
        },
        persist: function persist() {},
        isPersistent: $bf74d58b74973e6b$var$pd
    });
    return b;
}
var $bf74d58b74973e6b$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $bf74d58b74973e6b$var$td = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$sd), $bf74d58b74973e6b$var$ud = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    view: 0,
    detail: 0
}), $bf74d58b74973e6b$var$vd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$ud), $bf74d58b74973e6b$var$wd, $bf74d58b74973e6b$var$xd, $bf74d58b74973e6b$var$yd, $bf74d58b74973e6b$var$Ad = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $bf74d58b74973e6b$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $bf74d58b74973e6b$var$yd && ($bf74d58b74973e6b$var$yd && "mousemove" === a.type ? ($bf74d58b74973e6b$var$wd = a.screenX - $bf74d58b74973e6b$var$yd.screenX, $bf74d58b74973e6b$var$xd = a.screenY - $bf74d58b74973e6b$var$yd.screenY) : $bf74d58b74973e6b$var$xd = $bf74d58b74973e6b$var$wd = 0, $bf74d58b74973e6b$var$yd = a);
        return $bf74d58b74973e6b$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $bf74d58b74973e6b$var$xd;
    }
}), $bf74d58b74973e6b$var$Bd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Ad), $bf74d58b74973e6b$var$Cd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$Ad, {
    dataTransfer: 0
}), $bf74d58b74973e6b$var$Dd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Cd), $bf74d58b74973e6b$var$Ed = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$ud, {
    relatedTarget: 0
}), $bf74d58b74973e6b$var$Fd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Ed), $bf74d58b74973e6b$var$Gd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bf74d58b74973e6b$var$Hd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Gd), $bf74d58b74973e6b$var$Id = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $bf74d58b74973e6b$var$Jd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Id), $bf74d58b74973e6b$var$Kd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    data: 0
}), $bf74d58b74973e6b$var$Ld = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Kd), $bf74d58b74973e6b$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $bf74d58b74973e6b$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $bf74d58b74973e6b$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $bf74d58b74973e6b$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $bf74d58b74973e6b$var$Od[a]) ? !!b[a] : !1;
}
function $bf74d58b74973e6b$var$zd() {
    return $bf74d58b74973e6b$var$Pd;
}
var $bf74d58b74973e6b$var$Qd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $bf74d58b74973e6b$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $bf74d58b74973e6b$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $bf74d58b74973e6b$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $bf74d58b74973e6b$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $bf74d58b74973e6b$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $bf74d58b74973e6b$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $bf74d58b74973e6b$var$Rd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Qd), $bf74d58b74973e6b$var$Sd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $bf74d58b74973e6b$var$Td = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Sd), $bf74d58b74973e6b$var$Ud = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $bf74d58b74973e6b$var$zd
}), $bf74d58b74973e6b$var$Vd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Ud), $bf74d58b74973e6b$var$Wd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bf74d58b74973e6b$var$Xd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Wd), $bf74d58b74973e6b$var$Yd = $bf74d58b74973e6b$var$A({}, $bf74d58b74973e6b$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $bf74d58b74973e6b$var$Zd = $bf74d58b74973e6b$var$rd($bf74d58b74973e6b$var$Yd), $bf74d58b74973e6b$var$$d = [
    9,
    13,
    27,
    32
], $bf74d58b74973e6b$var$ae = $bf74d58b74973e6b$var$ia && "CompositionEvent" in window, $bf74d58b74973e6b$var$be = null;
$bf74d58b74973e6b$var$ia && "documentMode" in document && ($bf74d58b74973e6b$var$be = document.documentMode);
var $bf74d58b74973e6b$var$ce = $bf74d58b74973e6b$var$ia && "TextEvent" in window && !$bf74d58b74973e6b$var$be, $bf74d58b74973e6b$var$de = $bf74d58b74973e6b$var$ia && (!$bf74d58b74973e6b$var$ae || $bf74d58b74973e6b$var$be && 8 < $bf74d58b74973e6b$var$be && 11 >= $bf74d58b74973e6b$var$be), $bf74d58b74973e6b$var$ee = String.fromCharCode(32), $bf74d58b74973e6b$var$fe = !1;
function $bf74d58b74973e6b$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $bf74d58b74973e6b$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $bf74d58b74973e6b$var$he(a) {
    a = a.detail;
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && "data" in a ? a.data : null;
}
var $bf74d58b74973e6b$var$ie = !1;
function $bf74d58b74973e6b$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $bf74d58b74973e6b$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $bf74d58b74973e6b$var$fe = !0;
            return $bf74d58b74973e6b$var$ee;
        case "textInput":
            return a = b.data, a === $bf74d58b74973e6b$var$ee && $bf74d58b74973e6b$var$fe ? null : a;
        default:
            return null;
    }
}
function $bf74d58b74973e6b$var$ke(a, b) {
    if ($bf74d58b74973e6b$var$ie) return "compositionend" === a || !$bf74d58b74973e6b$var$ae && $bf74d58b74973e6b$var$ge(a, b) ? (a = $bf74d58b74973e6b$var$nd(), $bf74d58b74973e6b$var$md = $bf74d58b74973e6b$var$ld = $bf74d58b74973e6b$var$kd = null, $bf74d58b74973e6b$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $bf74d58b74973e6b$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $bf74d58b74973e6b$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $bf74d58b74973e6b$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$bf74d58b74973e6b$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $bf74d58b74973e6b$var$ne(a, b, c, d) {
    $bf74d58b74973e6b$var$Eb(d);
    b = $bf74d58b74973e6b$var$oe(b, "onChange");
    0 < b.length && (c = new $bf74d58b74973e6b$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $bf74d58b74973e6b$var$pe = null, $bf74d58b74973e6b$var$qe = null;
function $bf74d58b74973e6b$var$re(a) {
    $bf74d58b74973e6b$var$se(a, 0);
}
function $bf74d58b74973e6b$var$te(a) {
    var b = $bf74d58b74973e6b$var$ue(a);
    if ($bf74d58b74973e6b$var$Wa(b)) return a;
}
function $bf74d58b74973e6b$var$ve(a, b) {
    if ("change" === a) return b;
}
var $bf74d58b74973e6b$var$we = !1;
if ($bf74d58b74973e6b$var$ia) {
    var $bf74d58b74973e6b$var$xe;
    if ($bf74d58b74973e6b$var$ia) {
        var $bf74d58b74973e6b$var$ye = "oninput" in document;
        if (!$bf74d58b74973e6b$var$ye) {
            var $bf74d58b74973e6b$var$ze = document.createElement("div");
            $bf74d58b74973e6b$var$ze.setAttribute("oninput", "return;");
            $bf74d58b74973e6b$var$ye = "function" === typeof $bf74d58b74973e6b$var$ze.oninput;
        }
        $bf74d58b74973e6b$var$xe = $bf74d58b74973e6b$var$ye;
    } else $bf74d58b74973e6b$var$xe = !1;
    $bf74d58b74973e6b$var$we = $bf74d58b74973e6b$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $bf74d58b74973e6b$var$Ae() {
    $bf74d58b74973e6b$var$pe && ($bf74d58b74973e6b$var$pe.detachEvent("onpropertychange", $bf74d58b74973e6b$var$Be), $bf74d58b74973e6b$var$qe = $bf74d58b74973e6b$var$pe = null);
}
function $bf74d58b74973e6b$var$Be(a) {
    if ("value" === a.propertyName && $bf74d58b74973e6b$var$te($bf74d58b74973e6b$var$qe)) {
        var b = [];
        $bf74d58b74973e6b$var$ne(b, $bf74d58b74973e6b$var$qe, a, $bf74d58b74973e6b$var$xb(a));
        $bf74d58b74973e6b$var$Jb($bf74d58b74973e6b$var$re, b);
    }
}
function $bf74d58b74973e6b$var$Ce(a, b, c) {
    "focusin" === a ? ($bf74d58b74973e6b$var$Ae(), $bf74d58b74973e6b$var$pe = b, $bf74d58b74973e6b$var$qe = c, $bf74d58b74973e6b$var$pe.attachEvent("onpropertychange", $bf74d58b74973e6b$var$Be)) : "focusout" === a && $bf74d58b74973e6b$var$Ae();
}
function $bf74d58b74973e6b$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $bf74d58b74973e6b$var$te($bf74d58b74973e6b$var$qe);
}
function $bf74d58b74973e6b$var$Ee(a, b) {
    if ("click" === a) return $bf74d58b74973e6b$var$te(b);
}
function $bf74d58b74973e6b$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $bf74d58b74973e6b$var$te(b);
}
function $bf74d58b74973e6b$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bf74d58b74973e6b$var$He = "function" === typeof Object.is ? Object.is : $bf74d58b74973e6b$var$Ge;
function $bf74d58b74973e6b$var$Ie(a, b) {
    if ($bf74d58b74973e6b$var$He(a, b)) return !0;
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, $5djcY._)(b)) || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$bf74d58b74973e6b$var$ja.call(b, e) || !$bf74d58b74973e6b$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $bf74d58b74973e6b$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $bf74d58b74973e6b$var$Ke(a, b) {
    var c = $bf74d58b74973e6b$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $bf74d58b74973e6b$var$Je(c);
    }
}
function $bf74d58b74973e6b$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $bf74d58b74973e6b$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $bf74d58b74973e6b$var$Me() {
    for(var a = window, b = $bf74d58b74973e6b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $bf74d58b74973e6b$var$Xa(a.document);
    }
    return b;
}
function $bf74d58b74973e6b$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $bf74d58b74973e6b$var$Oe(a) {
    var b = $bf74d58b74973e6b$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $bf74d58b74973e6b$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $bf74d58b74973e6b$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $bf74d58b74973e6b$var$Ke(c, f);
                var g = $bf74d58b74973e6b$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $bf74d58b74973e6b$var$Pe = $bf74d58b74973e6b$var$ia && "documentMode" in document && 11 >= document.documentMode, $bf74d58b74973e6b$var$Qe = null, $bf74d58b74973e6b$var$Re = null, $bf74d58b74973e6b$var$Se = null, $bf74d58b74973e6b$var$Te = !1;
function $bf74d58b74973e6b$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $bf74d58b74973e6b$var$Te || null == $bf74d58b74973e6b$var$Qe || $bf74d58b74973e6b$var$Qe !== $bf74d58b74973e6b$var$Xa(d) || (d = $bf74d58b74973e6b$var$Qe, "selectionStart" in d && $bf74d58b74973e6b$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $bf74d58b74973e6b$var$Se && $bf74d58b74973e6b$var$Ie($bf74d58b74973e6b$var$Se, d) || ($bf74d58b74973e6b$var$Se = d, d = $bf74d58b74973e6b$var$oe($bf74d58b74973e6b$var$Re, "onSelect"), 0 < d.length && (b = new $bf74d58b74973e6b$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $bf74d58b74973e6b$var$Qe)));
}
function $bf74d58b74973e6b$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $bf74d58b74973e6b$var$We = {
    animationend: $bf74d58b74973e6b$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $bf74d58b74973e6b$var$Ve("Animation", "AnimationIteration"),
    animationstart: $bf74d58b74973e6b$var$Ve("Animation", "AnimationStart"),
    transitionend: $bf74d58b74973e6b$var$Ve("Transition", "TransitionEnd")
}, $bf74d58b74973e6b$var$Xe = {}, $bf74d58b74973e6b$var$Ye = {};
$bf74d58b74973e6b$var$ia && ($bf74d58b74973e6b$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $bf74d58b74973e6b$var$We.animationend.animation, delete $bf74d58b74973e6b$var$We.animationiteration.animation, delete $bf74d58b74973e6b$var$We.animationstart.animation), "TransitionEvent" in window || delete $bf74d58b74973e6b$var$We.transitionend.transition);
function $bf74d58b74973e6b$var$Ze(a) {
    if ($bf74d58b74973e6b$var$Xe[a]) return $bf74d58b74973e6b$var$Xe[a];
    if (!$bf74d58b74973e6b$var$We[a]) return a;
    var b = $bf74d58b74973e6b$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $bf74d58b74973e6b$var$Ye) return $bf74d58b74973e6b$var$Xe[a] = b[c];
    return a;
}
var $bf74d58b74973e6b$var$$e = $bf74d58b74973e6b$var$Ze("animationend"), $bf74d58b74973e6b$var$af = $bf74d58b74973e6b$var$Ze("animationiteration"), $bf74d58b74973e6b$var$bf = $bf74d58b74973e6b$var$Ze("animationstart"), $bf74d58b74973e6b$var$cf = $bf74d58b74973e6b$var$Ze("transitionend"), $bf74d58b74973e6b$var$df = new Map, $bf74d58b74973e6b$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $bf74d58b74973e6b$var$ff(a, b) {
    $bf74d58b74973e6b$var$df.set(a, b);
    $bf74d58b74973e6b$var$fa(b, [
        a
    ]);
}
for(var $bf74d58b74973e6b$var$gf = 0; $bf74d58b74973e6b$var$gf < $bf74d58b74973e6b$var$ef.length; $bf74d58b74973e6b$var$gf++){
    var $bf74d58b74973e6b$var$hf = $bf74d58b74973e6b$var$ef[$bf74d58b74973e6b$var$gf], $bf74d58b74973e6b$var$jf = $bf74d58b74973e6b$var$hf.toLowerCase(), $bf74d58b74973e6b$var$kf = $bf74d58b74973e6b$var$hf[0].toUpperCase() + $bf74d58b74973e6b$var$hf.slice(1);
    $bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$jf, "on" + $bf74d58b74973e6b$var$kf);
}
$bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$$e, "onAnimationEnd");
$bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$af, "onAnimationIteration");
$bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$bf, "onAnimationStart");
$bf74d58b74973e6b$var$ff("dblclick", "onDoubleClick");
$bf74d58b74973e6b$var$ff("focusin", "onFocus");
$bf74d58b74973e6b$var$ff("focusout", "onBlur");
$bf74d58b74973e6b$var$ff($bf74d58b74973e6b$var$cf, "onTransitionEnd");
$bf74d58b74973e6b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$bf74d58b74973e6b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$bf74d58b74973e6b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$bf74d58b74973e6b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$bf74d58b74973e6b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$bf74d58b74973e6b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$bf74d58b74973e6b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$bf74d58b74973e6b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$bf74d58b74973e6b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$bf74d58b74973e6b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $bf74d58b74973e6b$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $bf74d58b74973e6b$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($bf74d58b74973e6b$var$lf));
function $bf74d58b74973e6b$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $bf74d58b74973e6b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $bf74d58b74973e6b$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bf74d58b74973e6b$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bf74d58b74973e6b$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($bf74d58b74973e6b$var$Qb) throw a = $bf74d58b74973e6b$var$Rb, $bf74d58b74973e6b$var$Qb = !1, $bf74d58b74973e6b$var$Rb = null, a;
}
function $bf74d58b74973e6b$var$D(a, b) {
    var c = b[$bf74d58b74973e6b$var$of];
    void 0 === c && (c = b[$bf74d58b74973e6b$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($bf74d58b74973e6b$var$pf(b, a, 2, !1), c.add(d));
}
function $bf74d58b74973e6b$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $bf74d58b74973e6b$var$pf(c, a, d, b);
}
var $bf74d58b74973e6b$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $bf74d58b74973e6b$var$sf(a) {
    if (!a[$bf74d58b74973e6b$var$rf]) {
        a[$bf74d58b74973e6b$var$rf] = !0;
        $bf74d58b74973e6b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($bf74d58b74973e6b$var$mf.has(b) || $bf74d58b74973e6b$var$qf(b, !1, a), $bf74d58b74973e6b$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$bf74d58b74973e6b$var$rf] || (b[$bf74d58b74973e6b$var$rf] = !0, $bf74d58b74973e6b$var$qf("selectionchange", !1, b));
    }
}
function $bf74d58b74973e6b$var$pf(a, b, c, d) {
    switch($bf74d58b74973e6b$var$jd(b)){
        case 1:
            var e = $bf74d58b74973e6b$var$ed;
            break;
        case 4:
            e = $bf74d58b74973e6b$var$gd;
            break;
        default:
            e = $bf74d58b74973e6b$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$bf74d58b74973e6b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $bf74d58b74973e6b$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $bf74d58b74973e6b$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $bf74d58b74973e6b$var$Jb(function() {
        var _$d = f, _$e = $bf74d58b74973e6b$var$xb(c), g = [];
        a: {
            var h = $bf74d58b74973e6b$var$df.get(a);
            if (void 0 !== h) {
                var k = $bf74d58b74973e6b$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $bf74d58b74973e6b$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $bf74d58b74973e6b$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $bf74d58b74973e6b$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $bf74d58b74973e6b$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $bf74d58b74973e6b$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $bf74d58b74973e6b$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $bf74d58b74973e6b$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $bf74d58b74973e6b$var$Vd;
                        break;
                    case $bf74d58b74973e6b$var$$e:
                    case $bf74d58b74973e6b$var$af:
                    case $bf74d58b74973e6b$var$bf:
                        k = $bf74d58b74973e6b$var$Hd;
                        break;
                    case $bf74d58b74973e6b$var$cf:
                        k = $bf74d58b74973e6b$var$Xd;
                        break;
                    case "scroll":
                        k = $bf74d58b74973e6b$var$vd;
                        break;
                    case "wheel":
                        k = $bf74d58b74973e6b$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $bf74d58b74973e6b$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $bf74d58b74973e6b$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $bf74d58b74973e6b$var$Kb(w, x), null != F && t.push($bf74d58b74973e6b$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $bf74d58b74973e6b$var$wb && (n = c.relatedTarget || c.fromElement) && ($bf74d58b74973e6b$var$Wc(n) || n[$bf74d58b74973e6b$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $bf74d58b74973e6b$var$Wc(n) : null, null !== n && (J = $bf74d58b74973e6b$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $bf74d58b74973e6b$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $bf74d58b74973e6b$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $bf74d58b74973e6b$var$ue(k);
                        u = null == n ? h : $bf74d58b74973e6b$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $bf74d58b74973e6b$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $bf74d58b74973e6b$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $bf74d58b74973e6b$var$vf(F))u++;
                            for(; 0 < w - u;)t = $bf74d58b74973e6b$var$vf(t), w--;
                            for(; 0 < u - w;)x = $bf74d58b74973e6b$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $bf74d58b74973e6b$var$vf(t);
                                x = $bf74d58b74973e6b$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $bf74d58b74973e6b$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $bf74d58b74973e6b$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $bf74d58b74973e6b$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $bf74d58b74973e6b$var$ve;
                else if ($bf74d58b74973e6b$var$me(h)) {
                    if ($bf74d58b74973e6b$var$we) na = $bf74d58b74973e6b$var$Fe;
                    else {
                        na = $bf74d58b74973e6b$var$De;
                        var xa = $bf74d58b74973e6b$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $bf74d58b74973e6b$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $bf74d58b74973e6b$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $bf74d58b74973e6b$var$cb(h, "number", h.value);
            }
            xa = _$d ? $bf74d58b74973e6b$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($bf74d58b74973e6b$var$me(xa) || "true" === xa.contentEditable) $bf74d58b74973e6b$var$Qe = xa, $bf74d58b74973e6b$var$Re = _$d, $bf74d58b74973e6b$var$Se = null;
                    break;
                case "focusout":
                    $bf74d58b74973e6b$var$Se = $bf74d58b74973e6b$var$Re = $bf74d58b74973e6b$var$Qe = null;
                    break;
                case "mousedown":
                    $bf74d58b74973e6b$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $bf74d58b74973e6b$var$Te = !1;
                    $bf74d58b74973e6b$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($bf74d58b74973e6b$var$Pe) break;
                case "keydown":
                case "keyup":
                    $bf74d58b74973e6b$var$Ue(g, c, _$e);
            }
            var $a;
            if ($bf74d58b74973e6b$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $bf74d58b74973e6b$var$ie ? $bf74d58b74973e6b$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($bf74d58b74973e6b$var$de && "ko" !== c.locale && ($bf74d58b74973e6b$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $bf74d58b74973e6b$var$ie && ($a = $bf74d58b74973e6b$var$nd()) : ($bf74d58b74973e6b$var$kd = _$e, $bf74d58b74973e6b$var$ld = "value" in $bf74d58b74973e6b$var$kd ? $bf74d58b74973e6b$var$kd.value : $bf74d58b74973e6b$var$kd.textContent, $bf74d58b74973e6b$var$ie = !0)), xa = $bf74d58b74973e6b$var$oe(_$d, ba), 0 < xa.length && (ba = new $bf74d58b74973e6b$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $bf74d58b74973e6b$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $bf74d58b74973e6b$var$ce ? $bf74d58b74973e6b$var$je(a, c) : $bf74d58b74973e6b$var$ke(a, c)) _$d = $bf74d58b74973e6b$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $bf74d58b74973e6b$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $bf74d58b74973e6b$var$se(g, b);
    });
}
function $bf74d58b74973e6b$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $bf74d58b74973e6b$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $bf74d58b74973e6b$var$Kb(a, c), null != f && d.unshift($bf74d58b74973e6b$var$tf(a, f, e)), f = $bf74d58b74973e6b$var$Kb(a, b), null != f && d.push($bf74d58b74973e6b$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $bf74d58b74973e6b$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $bf74d58b74973e6b$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $bf74d58b74973e6b$var$Kb(c, f), null != k && g.unshift($bf74d58b74973e6b$var$tf(c, k, h))) : e || (k = $bf74d58b74973e6b$var$Kb(c, f), null != k && g.push($bf74d58b74973e6b$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $bf74d58b74973e6b$var$xf = /\r\n?/g, $bf74d58b74973e6b$var$yf = /\u0000|\uFFFD/g;
function $bf74d58b74973e6b$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($bf74d58b74973e6b$var$xf, "\n").replace($bf74d58b74973e6b$var$yf, "");
}
function $bf74d58b74973e6b$var$Af(a, b, c) {
    b = $bf74d58b74973e6b$var$zf(b);
    if ($bf74d58b74973e6b$var$zf(a) !== b && c) throw Error($bf74d58b74973e6b$var$p(425));
}
function $bf74d58b74973e6b$var$Bf() {}
var $bf74d58b74973e6b$var$Cf = null, $bf74d58b74973e6b$var$Df = null;
function $bf74d58b74973e6b$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, $5djcY._)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $bf74d58b74973e6b$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $bf74d58b74973e6b$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $bf74d58b74973e6b$var$Hf = "function" === typeof Promise ? Promise : void 0, $bf74d58b74973e6b$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $bf74d58b74973e6b$var$Hf ? function Jf(a) {
    return $bf74d58b74973e6b$var$Hf.resolve(null).then(a).catch($bf74d58b74973e6b$var$If);
} : $bf74d58b74973e6b$var$Ff;
function $bf74d58b74973e6b$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $bf74d58b74973e6b$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $bf74d58b74973e6b$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $bf74d58b74973e6b$var$bd(b);
}
function $bf74d58b74973e6b$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $bf74d58b74973e6b$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $bf74d58b74973e6b$var$Nf = Math.random().toString(36).slice(2), $bf74d58b74973e6b$var$Of = "__reactFiber$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$Pf = "__reactProps$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$uf = "__reactContainer$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$of = "__reactEvents$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$Qf = "__reactListeners$" + $bf74d58b74973e6b$var$Nf, $bf74d58b74973e6b$var$Rf = "__reactHandles$" + $bf74d58b74973e6b$var$Nf;
function $bf74d58b74973e6b$var$Wc(a) {
    var b = a[$bf74d58b74973e6b$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$bf74d58b74973e6b$var$uf] || c[$bf74d58b74973e6b$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $bf74d58b74973e6b$var$Mf(a); null !== a;){
                if (c = a[$bf74d58b74973e6b$var$Of]) return c;
                a = $bf74d58b74973e6b$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $bf74d58b74973e6b$var$Cb(a) {
    a = a[$bf74d58b74973e6b$var$Of] || a[$bf74d58b74973e6b$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $bf74d58b74973e6b$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($bf74d58b74973e6b$var$p(33));
}
function $bf74d58b74973e6b$var$Db(a) {
    return a[$bf74d58b74973e6b$var$Pf] || null;
}
var $bf74d58b74973e6b$var$Sf = [], $bf74d58b74973e6b$var$Tf = -1;
function $bf74d58b74973e6b$var$Uf(a) {
    return {
        current: a
    };
}
function $bf74d58b74973e6b$var$E(a) {
    0 > $bf74d58b74973e6b$var$Tf || (a.current = $bf74d58b74973e6b$var$Sf[$bf74d58b74973e6b$var$Tf], $bf74d58b74973e6b$var$Sf[$bf74d58b74973e6b$var$Tf] = null, $bf74d58b74973e6b$var$Tf--);
}
function $bf74d58b74973e6b$var$G(a, b) {
    $bf74d58b74973e6b$var$Tf++;
    $bf74d58b74973e6b$var$Sf[$bf74d58b74973e6b$var$Tf] = a.current;
    a.current = b;
}
var $bf74d58b74973e6b$var$Vf = {}, $bf74d58b74973e6b$var$H = $bf74d58b74973e6b$var$Uf($bf74d58b74973e6b$var$Vf), $bf74d58b74973e6b$var$Wf = $bf74d58b74973e6b$var$Uf(!1), $bf74d58b74973e6b$var$Xf = $bf74d58b74973e6b$var$Vf;
function $bf74d58b74973e6b$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $bf74d58b74973e6b$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $bf74d58b74973e6b$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $bf74d58b74973e6b$var$$f() {
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf);
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H);
}
function $bf74d58b74973e6b$var$ag(a, b, c) {
    if ($bf74d58b74973e6b$var$H.current !== $bf74d58b74973e6b$var$Vf) throw Error($bf74d58b74973e6b$var$p(168));
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$H, b);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wf, c);
}
function $bf74d58b74973e6b$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($bf74d58b74973e6b$var$p(108, $bf74d58b74973e6b$var$Ra(a) || "Unknown", e));
    return $bf74d58b74973e6b$var$A({}, c, d);
}
function $bf74d58b74973e6b$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $bf74d58b74973e6b$var$Vf;
    $bf74d58b74973e6b$var$Xf = $bf74d58b74973e6b$var$H.current;
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$H, a);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wf, $bf74d58b74973e6b$var$Wf.current);
    return !0;
}
function $bf74d58b74973e6b$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($bf74d58b74973e6b$var$p(169));
    c ? (a = $bf74d58b74973e6b$var$bg(a, b, $bf74d58b74973e6b$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf), $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H), $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$H, a)) : $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wf, c);
}
var $bf74d58b74973e6b$var$eg = null, $bf74d58b74973e6b$var$fg = !1, $bf74d58b74973e6b$var$gg = !1;
function $bf74d58b74973e6b$var$hg(a) {
    null === $bf74d58b74973e6b$var$eg ? $bf74d58b74973e6b$var$eg = [
        a
    ] : $bf74d58b74973e6b$var$eg.push(a);
}
function $bf74d58b74973e6b$var$ig(a) {
    $bf74d58b74973e6b$var$fg = !0;
    $bf74d58b74973e6b$var$hg(a);
}
function $bf74d58b74973e6b$var$jg() {
    if (!$bf74d58b74973e6b$var$gg && null !== $bf74d58b74973e6b$var$eg) {
        $bf74d58b74973e6b$var$gg = !0;
        var a = 0, b = $bf74d58b74973e6b$var$C;
        try {
            var c = $bf74d58b74973e6b$var$eg;
            for($bf74d58b74973e6b$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $bf74d58b74973e6b$var$eg = null;
            $bf74d58b74973e6b$var$fg = !1;
        } catch (e) {
            throw null !== $bf74d58b74973e6b$var$eg && ($bf74d58b74973e6b$var$eg = $bf74d58b74973e6b$var$eg.slice(a + 1)), $bf74d58b74973e6b$var$ac($bf74d58b74973e6b$var$fc, $bf74d58b74973e6b$var$jg), e;
        } finally{
            $bf74d58b74973e6b$var$C = b, $bf74d58b74973e6b$var$gg = !1;
        }
    }
    return null;
}
var $bf74d58b74973e6b$var$kg = [], $bf74d58b74973e6b$var$lg = 0, $bf74d58b74973e6b$var$mg = null, $bf74d58b74973e6b$var$ng = 0, $bf74d58b74973e6b$var$og = [], $bf74d58b74973e6b$var$pg = 0, $bf74d58b74973e6b$var$qg = null, $bf74d58b74973e6b$var$rg = 1, $bf74d58b74973e6b$var$sg = "";
function $bf74d58b74973e6b$var$tg(a, b) {
    $bf74d58b74973e6b$var$kg[$bf74d58b74973e6b$var$lg++] = $bf74d58b74973e6b$var$ng;
    $bf74d58b74973e6b$var$kg[$bf74d58b74973e6b$var$lg++] = $bf74d58b74973e6b$var$mg;
    $bf74d58b74973e6b$var$mg = a;
    $bf74d58b74973e6b$var$ng = b;
}
function $bf74d58b74973e6b$var$ug(a, b, c) {
    $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$rg;
    $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$sg;
    $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$qg;
    $bf74d58b74973e6b$var$qg = a;
    var d = $bf74d58b74973e6b$var$rg;
    a = $bf74d58b74973e6b$var$sg;
    var e = 32 - $bf74d58b74973e6b$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $bf74d58b74973e6b$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $bf74d58b74973e6b$var$rg = 1 << 32 - $bf74d58b74973e6b$var$oc(b) + e | c << e | d;
        $bf74d58b74973e6b$var$sg = f + a;
    } else $bf74d58b74973e6b$var$rg = 1 << f | c << e | d, $bf74d58b74973e6b$var$sg = a;
}
function $bf74d58b74973e6b$var$vg(a) {
    null !== a.return && ($bf74d58b74973e6b$var$tg(a, 1), $bf74d58b74973e6b$var$ug(a, 1, 0));
}
function $bf74d58b74973e6b$var$wg(a) {
    for(; a === $bf74d58b74973e6b$var$mg;)$bf74d58b74973e6b$var$mg = $bf74d58b74973e6b$var$kg[--$bf74d58b74973e6b$var$lg], $bf74d58b74973e6b$var$kg[$bf74d58b74973e6b$var$lg] = null, $bf74d58b74973e6b$var$ng = $bf74d58b74973e6b$var$kg[--$bf74d58b74973e6b$var$lg], $bf74d58b74973e6b$var$kg[$bf74d58b74973e6b$var$lg] = null;
    for(; a === $bf74d58b74973e6b$var$qg;)$bf74d58b74973e6b$var$qg = $bf74d58b74973e6b$var$og[--$bf74d58b74973e6b$var$pg], $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg] = null, $bf74d58b74973e6b$var$sg = $bf74d58b74973e6b$var$og[--$bf74d58b74973e6b$var$pg], $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg] = null, $bf74d58b74973e6b$var$rg = $bf74d58b74973e6b$var$og[--$bf74d58b74973e6b$var$pg], $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg] = null;
}
var $bf74d58b74973e6b$var$xg = null, $bf74d58b74973e6b$var$yg = null, $bf74d58b74973e6b$var$I = !1, $bf74d58b74973e6b$var$zg = null;
function $bf74d58b74973e6b$var$Ag(a, b) {
    var c = $bf74d58b74973e6b$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $bf74d58b74973e6b$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $bf74d58b74973e6b$var$xg = a, $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $bf74d58b74973e6b$var$xg = a, $bf74d58b74973e6b$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $bf74d58b74973e6b$var$qg ? {
                id: $bf74d58b74973e6b$var$rg,
                overflow: $bf74d58b74973e6b$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $bf74d58b74973e6b$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $bf74d58b74973e6b$var$xg = a, $bf74d58b74973e6b$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $bf74d58b74973e6b$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $bf74d58b74973e6b$var$Eg(a) {
    if ($bf74d58b74973e6b$var$I) {
        var b = $bf74d58b74973e6b$var$yg;
        if (b) {
            var c = b;
            if (!$bf74d58b74973e6b$var$Cg(a, b)) {
                if ($bf74d58b74973e6b$var$Dg(a)) throw Error($bf74d58b74973e6b$var$p(418));
                b = $bf74d58b74973e6b$var$Lf(c.nextSibling);
                var d = $bf74d58b74973e6b$var$xg;
                b && $bf74d58b74973e6b$var$Cg(a, b) ? $bf74d58b74973e6b$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $bf74d58b74973e6b$var$I = !1, $bf74d58b74973e6b$var$xg = a);
            }
        } else {
            if ($bf74d58b74973e6b$var$Dg(a)) throw Error($bf74d58b74973e6b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $bf74d58b74973e6b$var$I = !1;
            $bf74d58b74973e6b$var$xg = a;
        }
    }
}
function $bf74d58b74973e6b$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $bf74d58b74973e6b$var$xg = a;
}
function $bf74d58b74973e6b$var$Gg(a) {
    if (a !== $bf74d58b74973e6b$var$xg) return !1;
    if (!$bf74d58b74973e6b$var$I) return $bf74d58b74973e6b$var$Fg(a), $bf74d58b74973e6b$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$bf74d58b74973e6b$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $bf74d58b74973e6b$var$yg)) {
        if ($bf74d58b74973e6b$var$Dg(a)) throw $bf74d58b74973e6b$var$Hg(), Error($bf74d58b74973e6b$var$p(418));
        for(; b;)$bf74d58b74973e6b$var$Ag(a, b), b = $bf74d58b74973e6b$var$Lf(b.nextSibling);
    }
    $bf74d58b74973e6b$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($bf74d58b74973e6b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $bf74d58b74973e6b$var$yg = null;
        }
    } else $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$xg ? $bf74d58b74973e6b$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $bf74d58b74973e6b$var$Hg() {
    for(var a = $bf74d58b74973e6b$var$yg; a;)a = $bf74d58b74973e6b$var$Lf(a.nextSibling);
}
function $bf74d58b74973e6b$var$Ig() {
    $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$xg = null;
    $bf74d58b74973e6b$var$I = !1;
}
function $bf74d58b74973e6b$var$Jg(a) {
    null === $bf74d58b74973e6b$var$zg ? $bf74d58b74973e6b$var$zg = [
        a
    ] : $bf74d58b74973e6b$var$zg.push(a);
}
var $bf74d58b74973e6b$var$Kg = $bf74d58b74973e6b$var$ua.ReactCurrentBatchConfig;
function $bf74d58b74973e6b$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a))) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($bf74d58b74973e6b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($bf74d58b74973e6b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($bf74d58b74973e6b$var$p(284));
        if (!c._owner) throw Error($bf74d58b74973e6b$var$p(290, a));
    }
    return a;
}
function $bf74d58b74973e6b$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($bf74d58b74973e6b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $bf74d58b74973e6b$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $bf74d58b74973e6b$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $bf74d58b74973e6b$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $bf74d58b74973e6b$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $bf74d58b74973e6b$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f && f.$$typeof === $bf74d58b74973e6b$var$Ha && $bf74d58b74973e6b$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $bf74d58b74973e6b$var$Lg(a, b, c), d.return = a, d;
        d = $bf74d58b74973e6b$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $bf74d58b74973e6b$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $bf74d58b74973e6b$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $bf74d58b74973e6b$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $bf74d58b74973e6b$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === (typeof b === "undefined" ? "undefined" : (0, $5djcY._)(b)) && null !== b) {
            switch(b.$$typeof){
                case $bf74d58b74973e6b$var$va:
                    return c = $bf74d58b74973e6b$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $bf74d58b74973e6b$var$Lg(a, null, b), c.return = a, c;
                case $bf74d58b74973e6b$var$wa:
                    return b = $bf74d58b74973e6b$var$Sg(b, a.mode, c), b.return = a, b;
                case $bf74d58b74973e6b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($bf74d58b74973e6b$var$eb(b) || $bf74d58b74973e6b$var$Ka(b)) return b = $bf74d58b74973e6b$var$Tg(b, a.mode, c, null), b.return = a, b;
            $bf74d58b74973e6b$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === (typeof c === "undefined" ? "undefined" : (0, $5djcY._)(c)) && null !== c) {
            switch(c.$$typeof){
                case $bf74d58b74973e6b$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $bf74d58b74973e6b$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $bf74d58b74973e6b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($bf74d58b74973e6b$var$eb(c) || $bf74d58b74973e6b$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $bf74d58b74973e6b$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === (typeof d === "undefined" ? "undefined" : (0, $5djcY._)(d)) && null !== d) {
            switch(d.$$typeof){
                case $bf74d58b74973e6b$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $bf74d58b74973e6b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $bf74d58b74973e6b$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($bf74d58b74973e6b$var$eb(d) || $bf74d58b74973e6b$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $bf74d58b74973e6b$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $bf74d58b74973e6b$var$Ka(h);
        if ("function" !== typeof l) throw Error($bf74d58b74973e6b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($bf74d58b74973e6b$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $bf74d58b74973e6b$var$I && $bf74d58b74973e6b$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f && f.type === $bf74d58b74973e6b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f) {
            switch(f.$$typeof){
                case $bf74d58b74973e6b$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $bf74d58b74973e6b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === (typeof k === "undefined" ? "undefined" : (0, $5djcY._)(k)) && null !== k && k.$$typeof === $bf74d58b74973e6b$var$Ha && $bf74d58b74973e6b$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $bf74d58b74973e6b$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $bf74d58b74973e6b$var$ya ? (d = $bf74d58b74973e6b$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $bf74d58b74973e6b$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $bf74d58b74973e6b$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $bf74d58b74973e6b$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $bf74d58b74973e6b$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $bf74d58b74973e6b$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($bf74d58b74973e6b$var$eb(f)) return n(a, d, f, h);
            if ($bf74d58b74973e6b$var$Ka(f)) return t(a, d, f, h);
            $bf74d58b74973e6b$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $bf74d58b74973e6b$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $bf74d58b74973e6b$var$Ug = $bf74d58b74973e6b$var$Og(!0), $bf74d58b74973e6b$var$Vg = $bf74d58b74973e6b$var$Og(!1), $bf74d58b74973e6b$var$Wg = $bf74d58b74973e6b$var$Uf(null), $bf74d58b74973e6b$var$Xg = null, $bf74d58b74973e6b$var$Yg = null, $bf74d58b74973e6b$var$Zg = null;
function $bf74d58b74973e6b$var$$g() {
    $bf74d58b74973e6b$var$Zg = $bf74d58b74973e6b$var$Yg = $bf74d58b74973e6b$var$Xg = null;
}
function $bf74d58b74973e6b$var$ah(a) {
    var b = $bf74d58b74973e6b$var$Wg.current;
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wg);
    a._currentValue = b;
}
function $bf74d58b74973e6b$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $bf74d58b74973e6b$var$ch(a, b) {
    $bf74d58b74973e6b$var$Xg = a;
    $bf74d58b74973e6b$var$Zg = $bf74d58b74973e6b$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($bf74d58b74973e6b$var$dh = !0), a.firstContext = null);
}
function $bf74d58b74973e6b$var$eh(a) {
    var b = a._currentValue;
    if ($bf74d58b74973e6b$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $bf74d58b74973e6b$var$Yg) {
            if (null === $bf74d58b74973e6b$var$Xg) throw Error($bf74d58b74973e6b$var$p(308));
            $bf74d58b74973e6b$var$Yg = a;
            $bf74d58b74973e6b$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $bf74d58b74973e6b$var$Yg = $bf74d58b74973e6b$var$Yg.next = a;
    }
    return b;
}
var $bf74d58b74973e6b$var$fh = null;
function $bf74d58b74973e6b$var$gh(a) {
    null === $bf74d58b74973e6b$var$fh ? $bf74d58b74973e6b$var$fh = [
        a
    ] : $bf74d58b74973e6b$var$fh.push(a);
}
function $bf74d58b74973e6b$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $bf74d58b74973e6b$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $bf74d58b74973e6b$var$ih(a, d);
}
function $bf74d58b74973e6b$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $bf74d58b74973e6b$var$jh = !1;
function $bf74d58b74973e6b$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $bf74d58b74973e6b$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $bf74d58b74973e6b$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $bf74d58b74973e6b$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($bf74d58b74973e6b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $bf74d58b74973e6b$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $bf74d58b74973e6b$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $bf74d58b74973e6b$var$ih(a, c);
}
function $bf74d58b74973e6b$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bf74d58b74973e6b$var$Cc(a, c);
    }
}
function $bf74d58b74973e6b$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $bf74d58b74973e6b$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $bf74d58b74973e6b$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $bf74d58b74973e6b$var$A({}, q, r);
                            break a;
                        case 2:
                            $bf74d58b74973e6b$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $bf74d58b74973e6b$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $bf74d58b74973e6b$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($bf74d58b74973e6b$var$p(191, e));
            e.call(d);
        }
    }
}
var $bf74d58b74973e6b$var$th = {}, $bf74d58b74973e6b$var$uh = $bf74d58b74973e6b$var$Uf($bf74d58b74973e6b$var$th), $bf74d58b74973e6b$var$vh = $bf74d58b74973e6b$var$Uf($bf74d58b74973e6b$var$th), $bf74d58b74973e6b$var$wh = $bf74d58b74973e6b$var$Uf($bf74d58b74973e6b$var$th);
function $bf74d58b74973e6b$var$xh(a) {
    if (a === $bf74d58b74973e6b$var$th) throw Error($bf74d58b74973e6b$var$p(174));
    return a;
}
function $bf74d58b74973e6b$var$yh(a, b) {
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$wh, b);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$vh, a);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$uh, $bf74d58b74973e6b$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $bf74d58b74973e6b$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $bf74d58b74973e6b$var$lb(b, a);
    }
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$uh);
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$uh, b);
}
function $bf74d58b74973e6b$var$zh() {
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$uh);
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$vh);
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$wh);
}
function $bf74d58b74973e6b$var$Ah(a) {
    $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$wh.current);
    var b = $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$uh.current);
    var c = $bf74d58b74973e6b$var$lb(b, a.type);
    b !== c && ($bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$vh, a), $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$uh, c));
}
function $bf74d58b74973e6b$var$Bh(a) {
    $bf74d58b74973e6b$var$vh.current === a && ($bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$uh), $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$vh));
}
var $bf74d58b74973e6b$var$L = $bf74d58b74973e6b$var$Uf(0);
function $bf74d58b74973e6b$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $bf74d58b74973e6b$var$Dh = [];
function $bf74d58b74973e6b$var$Eh() {
    for(var a = 0; a < $bf74d58b74973e6b$var$Dh.length; a++)$bf74d58b74973e6b$var$Dh[a]._workInProgressVersionPrimary = null;
    $bf74d58b74973e6b$var$Dh.length = 0;
}
var $bf74d58b74973e6b$var$Fh = $bf74d58b74973e6b$var$ua.ReactCurrentDispatcher, $bf74d58b74973e6b$var$Gh = $bf74d58b74973e6b$var$ua.ReactCurrentBatchConfig, $bf74d58b74973e6b$var$Hh = 0, $bf74d58b74973e6b$var$M = null, $bf74d58b74973e6b$var$N = null, $bf74d58b74973e6b$var$O = null, $bf74d58b74973e6b$var$Ih = !1, $bf74d58b74973e6b$var$Jh = !1, $bf74d58b74973e6b$var$Kh = 0, $bf74d58b74973e6b$var$Lh = 0;
function $bf74d58b74973e6b$var$P() {
    throw Error($bf74d58b74973e6b$var$p(321));
}
function $bf74d58b74973e6b$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$bf74d58b74973e6b$var$He(a[c], b[c])) return !1;
    return !0;
}
function $bf74d58b74973e6b$var$Nh(a, b, c, d, e, f) {
    $bf74d58b74973e6b$var$Hh = f;
    $bf74d58b74973e6b$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $bf74d58b74973e6b$var$Fh.current = null === a || null === a.memoizedState ? $bf74d58b74973e6b$var$Oh : $bf74d58b74973e6b$var$Ph;
    a = c(d, e);
    if ($bf74d58b74973e6b$var$Jh) {
        f = 0;
        do {
            $bf74d58b74973e6b$var$Jh = !1;
            $bf74d58b74973e6b$var$Kh = 0;
            if (25 <= f) throw Error($bf74d58b74973e6b$var$p(301));
            f += 1;
            $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$N = null;
            b.updateQueue = null;
            $bf74d58b74973e6b$var$Fh.current = $bf74d58b74973e6b$var$Qh;
            a = c(d, e);
        }while ($bf74d58b74973e6b$var$Jh);
    }
    $bf74d58b74973e6b$var$Fh.current = $bf74d58b74973e6b$var$Rh;
    b = null !== $bf74d58b74973e6b$var$N && null !== $bf74d58b74973e6b$var$N.next;
    $bf74d58b74973e6b$var$Hh = 0;
    $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$N = $bf74d58b74973e6b$var$M = null;
    $bf74d58b74973e6b$var$Ih = !1;
    if (b) throw Error($bf74d58b74973e6b$var$p(300));
    return a;
}
function $bf74d58b74973e6b$var$Sh() {
    var a = 0 !== $bf74d58b74973e6b$var$Kh;
    $bf74d58b74973e6b$var$Kh = 0;
    return a;
}
function $bf74d58b74973e6b$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $bf74d58b74973e6b$var$O ? $bf74d58b74973e6b$var$M.memoizedState = $bf74d58b74973e6b$var$O = a : $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$O.next = a;
    return $bf74d58b74973e6b$var$O;
}
function $bf74d58b74973e6b$var$Uh() {
    if (null === $bf74d58b74973e6b$var$N) {
        var a = $bf74d58b74973e6b$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $bf74d58b74973e6b$var$N.next;
    var b = null === $bf74d58b74973e6b$var$O ? $bf74d58b74973e6b$var$M.memoizedState : $bf74d58b74973e6b$var$O.next;
    if (null !== b) $bf74d58b74973e6b$var$O = b, $bf74d58b74973e6b$var$N = a;
    else {
        if (null === a) throw Error($bf74d58b74973e6b$var$p(310));
        $bf74d58b74973e6b$var$N = a;
        a = {
            memoizedState: $bf74d58b74973e6b$var$N.memoizedState,
            baseState: $bf74d58b74973e6b$var$N.baseState,
            baseQueue: $bf74d58b74973e6b$var$N.baseQueue,
            queue: $bf74d58b74973e6b$var$N.queue,
            next: null
        };
        null === $bf74d58b74973e6b$var$O ? $bf74d58b74973e6b$var$M.memoizedState = $bf74d58b74973e6b$var$O = a : $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$O.next = a;
    }
    return $bf74d58b74973e6b$var$O;
}
function $bf74d58b74973e6b$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $bf74d58b74973e6b$var$Wh(a) {
    var b = $bf74d58b74973e6b$var$Uh(), c = b.queue;
    if (null === c) throw Error($bf74d58b74973e6b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $bf74d58b74973e6b$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($bf74d58b74973e6b$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $bf74d58b74973e6b$var$M.lanes |= m;
                $bf74d58b74973e6b$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $bf74d58b74973e6b$var$He(d, b.memoizedState) || ($bf74d58b74973e6b$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $bf74d58b74973e6b$var$M.lanes |= f, $bf74d58b74973e6b$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $bf74d58b74973e6b$var$Xh(a) {
    var b = $bf74d58b74973e6b$var$Uh(), c = b.queue;
    if (null === c) throw Error($bf74d58b74973e6b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $bf74d58b74973e6b$var$He(f, b.memoizedState) || ($bf74d58b74973e6b$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $bf74d58b74973e6b$var$Yh() {}
function $bf74d58b74973e6b$var$Zh(a, b) {
    var c = $bf74d58b74973e6b$var$M, d = $bf74d58b74973e6b$var$Uh(), e = b(), f = !$bf74d58b74973e6b$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $bf74d58b74973e6b$var$dh = !0);
    d = d.queue;
    $bf74d58b74973e6b$var$$h($bf74d58b74973e6b$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $bf74d58b74973e6b$var$O && $bf74d58b74973e6b$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $bf74d58b74973e6b$var$bi(9, $bf74d58b74973e6b$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $bf74d58b74973e6b$var$Q) throw Error($bf74d58b74973e6b$var$p(349));
        0 !== ($bf74d58b74973e6b$var$Hh & 30) || $bf74d58b74973e6b$var$di(c, b, e);
    }
    return e;
}
function $bf74d58b74973e6b$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $bf74d58b74973e6b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bf74d58b74973e6b$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $bf74d58b74973e6b$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $bf74d58b74973e6b$var$ei(b) && $bf74d58b74973e6b$var$fi(a);
}
function $bf74d58b74973e6b$var$ai(a, b, c) {
    return c(function() {
        $bf74d58b74973e6b$var$ei(b) && $bf74d58b74973e6b$var$fi(a);
    });
}
function $bf74d58b74973e6b$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$bf74d58b74973e6b$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $bf74d58b74973e6b$var$fi(a) {
    var b = $bf74d58b74973e6b$var$ih(a, 1);
    null !== b && $bf74d58b74973e6b$var$gi(b, a, 1, -1);
}
function $bf74d58b74973e6b$var$hi(a) {
    var b = $bf74d58b74973e6b$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $bf74d58b74973e6b$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $bf74d58b74973e6b$var$ii.bind(null, $bf74d58b74973e6b$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $bf74d58b74973e6b$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $bf74d58b74973e6b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bf74d58b74973e6b$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $bf74d58b74973e6b$var$ji() {
    return $bf74d58b74973e6b$var$Uh().memoizedState;
}
function $bf74d58b74973e6b$var$ki(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$Th();
    $bf74d58b74973e6b$var$M.flags |= a;
    e.memoizedState = $bf74d58b74973e6b$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $bf74d58b74973e6b$var$li(a, b, c, d) {
    var e = $bf74d58b74973e6b$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $bf74d58b74973e6b$var$N) {
        var g = $bf74d58b74973e6b$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $bf74d58b74973e6b$var$Mh(d, g.deps)) {
            e.memoizedState = $bf74d58b74973e6b$var$bi(b, c, f, d);
            return;
        }
    }
    $bf74d58b74973e6b$var$M.flags |= a;
    e.memoizedState = $bf74d58b74973e6b$var$bi(1 | b, c, f, d);
}
function $bf74d58b74973e6b$var$mi(a, b) {
    return $bf74d58b74973e6b$var$ki(8390656, 8, a, b);
}
function $bf74d58b74973e6b$var$$h(a, b) {
    return $bf74d58b74973e6b$var$li(2048, 8, a, b);
}
function $bf74d58b74973e6b$var$ni(a, b) {
    return $bf74d58b74973e6b$var$li(4, 2, a, b);
}
function $bf74d58b74973e6b$var$oi(a, b) {
    return $bf74d58b74973e6b$var$li(4, 4, a, b);
}
function $bf74d58b74973e6b$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $bf74d58b74973e6b$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $bf74d58b74973e6b$var$li(4, 4, $bf74d58b74973e6b$var$pi.bind(null, b, a), c);
}
function $bf74d58b74973e6b$var$ri() {}
function $bf74d58b74973e6b$var$si(a, b) {
    var c = $bf74d58b74973e6b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bf74d58b74973e6b$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bf74d58b74973e6b$var$ti(a, b) {
    var c = $bf74d58b74973e6b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bf74d58b74973e6b$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bf74d58b74973e6b$var$ui(a, b, c) {
    if (0 === ($bf74d58b74973e6b$var$Hh & 21)) return a.baseState && (a.baseState = !1, $bf74d58b74973e6b$var$dh = !0), a.memoizedState = c;
    $bf74d58b74973e6b$var$He(c, b) || (c = $bf74d58b74973e6b$var$yc(), $bf74d58b74973e6b$var$M.lanes |= c, $bf74d58b74973e6b$var$rh |= c, a.baseState = !0);
    return b;
}
function $bf74d58b74973e6b$var$vi(a, b) {
    var c = $bf74d58b74973e6b$var$C;
    $bf74d58b74973e6b$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $bf74d58b74973e6b$var$Gh.transition;
    $bf74d58b74973e6b$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $bf74d58b74973e6b$var$C = c, $bf74d58b74973e6b$var$Gh.transition = d;
    }
}
function $bf74d58b74973e6b$var$wi() {
    return $bf74d58b74973e6b$var$Uh().memoizedState;
}
function $bf74d58b74973e6b$var$xi(a, b, c) {
    var d = $bf74d58b74973e6b$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bf74d58b74973e6b$var$zi(a)) $bf74d58b74973e6b$var$Ai(b, c);
    else if (c = $bf74d58b74973e6b$var$hh(a, b, c, d), null !== c) {
        var e = $bf74d58b74973e6b$var$R();
        $bf74d58b74973e6b$var$gi(c, a, d, e);
        $bf74d58b74973e6b$var$Bi(c, b, d);
    }
}
function $bf74d58b74973e6b$var$ii(a, b, c) {
    var d = $bf74d58b74973e6b$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bf74d58b74973e6b$var$zi(a)) $bf74d58b74973e6b$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($bf74d58b74973e6b$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $bf74d58b74973e6b$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $bf74d58b74973e6b$var$hh(a, b, e, d);
        null !== c && (e = $bf74d58b74973e6b$var$R(), $bf74d58b74973e6b$var$gi(c, a, d, e), $bf74d58b74973e6b$var$Bi(c, b, d));
    }
}
function $bf74d58b74973e6b$var$zi(a) {
    var b = a.alternate;
    return a === $bf74d58b74973e6b$var$M || null !== b && b === $bf74d58b74973e6b$var$M;
}
function $bf74d58b74973e6b$var$Ai(a, b) {
    $bf74d58b74973e6b$var$Jh = $bf74d58b74973e6b$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $bf74d58b74973e6b$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bf74d58b74973e6b$var$Cc(a, c);
    }
}
var $bf74d58b74973e6b$var$Rh = {
    readContext: $bf74d58b74973e6b$var$eh,
    useCallback: $bf74d58b74973e6b$var$P,
    useContext: $bf74d58b74973e6b$var$P,
    useEffect: $bf74d58b74973e6b$var$P,
    useImperativeHandle: $bf74d58b74973e6b$var$P,
    useInsertionEffect: $bf74d58b74973e6b$var$P,
    useLayoutEffect: $bf74d58b74973e6b$var$P,
    useMemo: $bf74d58b74973e6b$var$P,
    useReducer: $bf74d58b74973e6b$var$P,
    useRef: $bf74d58b74973e6b$var$P,
    useState: $bf74d58b74973e6b$var$P,
    useDebugValue: $bf74d58b74973e6b$var$P,
    useDeferredValue: $bf74d58b74973e6b$var$P,
    useTransition: $bf74d58b74973e6b$var$P,
    useMutableSource: $bf74d58b74973e6b$var$P,
    useSyncExternalStore: $bf74d58b74973e6b$var$P,
    useId: $bf74d58b74973e6b$var$P,
    unstable_isNewReconciler: !1
}, $bf74d58b74973e6b$var$Oh = {
    readContext: $bf74d58b74973e6b$var$eh,
    useCallback: function useCallback(a, b) {
        $bf74d58b74973e6b$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $bf74d58b74973e6b$var$eh,
    useEffect: $bf74d58b74973e6b$var$mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $bf74d58b74973e6b$var$ki(4194308, 4, $bf74d58b74973e6b$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $bf74d58b74973e6b$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $bf74d58b74973e6b$var$ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $bf74d58b74973e6b$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $bf74d58b74973e6b$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $bf74d58b74973e6b$var$xi.bind(null, $bf74d58b74973e6b$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $bf74d58b74973e6b$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $bf74d58b74973e6b$var$hi,
    useDebugValue: $bf74d58b74973e6b$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        return $bf74d58b74973e6b$var$Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $bf74d58b74973e6b$var$hi(!1), b = a[0];
        a = $bf74d58b74973e6b$var$vi.bind(null, a[1]);
        $bf74d58b74973e6b$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $bf74d58b74973e6b$var$M, e = $bf74d58b74973e6b$var$Th();
        if ($bf74d58b74973e6b$var$I) {
            if (void 0 === c) throw Error($bf74d58b74973e6b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $bf74d58b74973e6b$var$Q) throw Error($bf74d58b74973e6b$var$p(349));
            0 !== ($bf74d58b74973e6b$var$Hh & 30) || $bf74d58b74973e6b$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $bf74d58b74973e6b$var$mi($bf74d58b74973e6b$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $bf74d58b74973e6b$var$bi(9, $bf74d58b74973e6b$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $bf74d58b74973e6b$var$Th(), b = $bf74d58b74973e6b$var$Q.identifierPrefix;
        if ($bf74d58b74973e6b$var$I) {
            var c = $bf74d58b74973e6b$var$sg;
            var d = $bf74d58b74973e6b$var$rg;
            c = (d & ~(1 << 32 - $bf74d58b74973e6b$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $bf74d58b74973e6b$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $bf74d58b74973e6b$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $bf74d58b74973e6b$var$Ph = {
    readContext: $bf74d58b74973e6b$var$eh,
    useCallback: $bf74d58b74973e6b$var$si,
    useContext: $bf74d58b74973e6b$var$eh,
    useEffect: $bf74d58b74973e6b$var$$h,
    useImperativeHandle: $bf74d58b74973e6b$var$qi,
    useInsertionEffect: $bf74d58b74973e6b$var$ni,
    useLayoutEffect: $bf74d58b74973e6b$var$oi,
    useMemo: $bf74d58b74973e6b$var$ti,
    useReducer: $bf74d58b74973e6b$var$Wh,
    useRef: $bf74d58b74973e6b$var$ji,
    useState: function useState() {
        return $bf74d58b74973e6b$var$Wh($bf74d58b74973e6b$var$Vh);
    },
    useDebugValue: $bf74d58b74973e6b$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $bf74d58b74973e6b$var$Uh();
        return $bf74d58b74973e6b$var$ui(b, $bf74d58b74973e6b$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $bf74d58b74973e6b$var$Wh($bf74d58b74973e6b$var$Vh)[0], b = $bf74d58b74973e6b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bf74d58b74973e6b$var$Yh,
    useSyncExternalStore: $bf74d58b74973e6b$var$Zh,
    useId: $bf74d58b74973e6b$var$wi,
    unstable_isNewReconciler: !1
}, $bf74d58b74973e6b$var$Qh = {
    readContext: $bf74d58b74973e6b$var$eh,
    useCallback: $bf74d58b74973e6b$var$si,
    useContext: $bf74d58b74973e6b$var$eh,
    useEffect: $bf74d58b74973e6b$var$$h,
    useImperativeHandle: $bf74d58b74973e6b$var$qi,
    useInsertionEffect: $bf74d58b74973e6b$var$ni,
    useLayoutEffect: $bf74d58b74973e6b$var$oi,
    useMemo: $bf74d58b74973e6b$var$ti,
    useReducer: $bf74d58b74973e6b$var$Xh,
    useRef: $bf74d58b74973e6b$var$ji,
    useState: function useState() {
        return $bf74d58b74973e6b$var$Xh($bf74d58b74973e6b$var$Vh);
    },
    useDebugValue: $bf74d58b74973e6b$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $bf74d58b74973e6b$var$Uh();
        return null === $bf74d58b74973e6b$var$N ? b.memoizedState = a : $bf74d58b74973e6b$var$ui(b, $bf74d58b74973e6b$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $bf74d58b74973e6b$var$Xh($bf74d58b74973e6b$var$Vh)[0], b = $bf74d58b74973e6b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bf74d58b74973e6b$var$Yh,
    useSyncExternalStore: $bf74d58b74973e6b$var$Zh,
    useId: $bf74d58b74973e6b$var$wi,
    unstable_isNewReconciler: !1
};
function $bf74d58b74973e6b$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $bf74d58b74973e6b$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $bf74d58b74973e6b$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $bf74d58b74973e6b$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $bf74d58b74973e6b$var$Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $bf74d58b74973e6b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $bf74d58b74973e6b$var$R(), e = $bf74d58b74973e6b$var$yi(a), f = $bf74d58b74973e6b$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bf74d58b74973e6b$var$nh(a, f, e);
        null !== b && ($bf74d58b74973e6b$var$gi(b, a, e, d), $bf74d58b74973e6b$var$oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $bf74d58b74973e6b$var$R(), e = $bf74d58b74973e6b$var$yi(a), f = $bf74d58b74973e6b$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bf74d58b74973e6b$var$nh(a, f, e);
        null !== b && ($bf74d58b74973e6b$var$gi(b, a, e, d), $bf74d58b74973e6b$var$oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $bf74d58b74973e6b$var$R(), d = $bf74d58b74973e6b$var$yi(a), e = $bf74d58b74973e6b$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $bf74d58b74973e6b$var$nh(a, e, d);
        null !== b && ($bf74d58b74973e6b$var$gi(b, a, d, c), $bf74d58b74973e6b$var$oh(b, a, d));
    }
};
function $bf74d58b74973e6b$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$bf74d58b74973e6b$var$Ie(c, d) || !$bf74d58b74973e6b$var$Ie(e, f) : !0;
}
function $bf74d58b74973e6b$var$Gi(a, b, c) {
    var d = !1, e = $bf74d58b74973e6b$var$Vf;
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f ? f = $bf74d58b74973e6b$var$eh(f) : (e = $bf74d58b74973e6b$var$Zf(b) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $bf74d58b74973e6b$var$Yf(a, e) : $bf74d58b74973e6b$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $bf74d58b74973e6b$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $bf74d58b74973e6b$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $bf74d58b74973e6b$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $bf74d58b74973e6b$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $bf74d58b74973e6b$var$kh(a);
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $5djcY._)(f)) && null !== f ? e.context = $bf74d58b74973e6b$var$eh(f) : (f = $bf74d58b74973e6b$var$Zf(b) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current, e.context = $bf74d58b74973e6b$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($bf74d58b74973e6b$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $bf74d58b74973e6b$var$Ei.enqueueReplaceState(e, e.state, null), $bf74d58b74973e6b$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $bf74d58b74973e6b$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $bf74d58b74973e6b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $bf74d58b74973e6b$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $bf74d58b74973e6b$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $bf74d58b74973e6b$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $bf74d58b74973e6b$var$Ni(a, b, c) {
    c = $bf74d58b74973e6b$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $bf74d58b74973e6b$var$Oi || ($bf74d58b74973e6b$var$Oi = !0, $bf74d58b74973e6b$var$Pi = d);
        $bf74d58b74973e6b$var$Li(a, b);
    };
    return c;
}
function $bf74d58b74973e6b$var$Qi(a, b, c) {
    c = $bf74d58b74973e6b$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $bf74d58b74973e6b$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $bf74d58b74973e6b$var$Li(a, b);
        "function" !== typeof d && (null === $bf74d58b74973e6b$var$Ri ? $bf74d58b74973e6b$var$Ri = new Set([
            this
        ]) : $bf74d58b74973e6b$var$Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $bf74d58b74973e6b$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $bf74d58b74973e6b$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $bf74d58b74973e6b$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $bf74d58b74973e6b$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $bf74d58b74973e6b$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $bf74d58b74973e6b$var$mh(-1, 1), b.tag = 2, $bf74d58b74973e6b$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $bf74d58b74973e6b$var$Wi = $bf74d58b74973e6b$var$ua.ReactCurrentOwner, $bf74d58b74973e6b$var$dh = !1;
function $bf74d58b74973e6b$var$Xi(a, b, c, d) {
    b.child = null === a ? $bf74d58b74973e6b$var$Vg(b, null, c, d) : $bf74d58b74973e6b$var$Ug(b, a.child, c, d);
}
function $bf74d58b74973e6b$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $bf74d58b74973e6b$var$ch(b, e);
    d = $bf74d58b74973e6b$var$Nh(a, b, c, d, f, e);
    c = $bf74d58b74973e6b$var$Sh();
    if (null !== a && !$bf74d58b74973e6b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bf74d58b74973e6b$var$Zi(a, b, e);
    $bf74d58b74973e6b$var$I && c && $bf74d58b74973e6b$var$vg(b);
    b.flags |= 1;
    $bf74d58b74973e6b$var$Xi(a, b, d, e);
    return b.child;
}
function $bf74d58b74973e6b$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$bf74d58b74973e6b$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $bf74d58b74973e6b$var$bj(a, b, f, d, e);
        a = $bf74d58b74973e6b$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $bf74d58b74973e6b$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $bf74d58b74973e6b$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $bf74d58b74973e6b$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $bf74d58b74973e6b$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($bf74d58b74973e6b$var$Ie(f, d) && a.ref === b.ref) {
            if ($bf74d58b74973e6b$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($bf74d58b74973e6b$var$dh = !0);
            else return b.lanes = a.lanes, $bf74d58b74973e6b$var$Zi(a, b, e);
        }
    }
    return $bf74d58b74973e6b$var$cj(a, b, c, d, e);
}
function $bf74d58b74973e6b$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$ej, $bf74d58b74973e6b$var$fj), $bf74d58b74973e6b$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$ej, $bf74d58b74973e6b$var$fj), $bf74d58b74973e6b$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$ej, $bf74d58b74973e6b$var$fj);
            $bf74d58b74973e6b$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$ej, $bf74d58b74973e6b$var$fj), $bf74d58b74973e6b$var$fj |= d;
    $bf74d58b74973e6b$var$Xi(a, b, e, c);
    return b.child;
}
function $bf74d58b74973e6b$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $bf74d58b74973e6b$var$cj(a, b, c, d, e) {
    var f = $bf74d58b74973e6b$var$Zf(c) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current;
    f = $bf74d58b74973e6b$var$Yf(b, f);
    $bf74d58b74973e6b$var$ch(b, e);
    c = $bf74d58b74973e6b$var$Nh(a, b, c, d, f, e);
    d = $bf74d58b74973e6b$var$Sh();
    if (null !== a && !$bf74d58b74973e6b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bf74d58b74973e6b$var$Zi(a, b, e);
    $bf74d58b74973e6b$var$I && d && $bf74d58b74973e6b$var$vg(b);
    b.flags |= 1;
    $bf74d58b74973e6b$var$Xi(a, b, c, e);
    return b.child;
}
function $bf74d58b74973e6b$var$hj(a, b, c, d, e) {
    if ($bf74d58b74973e6b$var$Zf(c)) {
        var f = !0;
        $bf74d58b74973e6b$var$cg(b);
    } else f = !1;
    $bf74d58b74973e6b$var$ch(b, e);
    if (null === b.stateNode) $bf74d58b74973e6b$var$ij(a, b), $bf74d58b74973e6b$var$Gi(b, c, d), $bf74d58b74973e6b$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === (typeof l === "undefined" ? "undefined" : (0, $5djcY._)(l)) && null !== l ? l = $bf74d58b74973e6b$var$eh(l) : (l = $bf74d58b74973e6b$var$Zf(c) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current, l = $bf74d58b74973e6b$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $bf74d58b74973e6b$var$Hi(b, g, d, l);
        $bf74d58b74973e6b$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $bf74d58b74973e6b$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $bf74d58b74973e6b$var$Wf.current || $bf74d58b74973e6b$var$jh ? ("function" === typeof m && ($bf74d58b74973e6b$var$Di(b, c, m, d), k = b.memoizedState), (h = $bf74d58b74973e6b$var$jh || $bf74d58b74973e6b$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $bf74d58b74973e6b$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $bf74d58b74973e6b$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === (typeof k === "undefined" ? "undefined" : (0, $5djcY._)(k)) && null !== k ? k = $bf74d58b74973e6b$var$eh(k) : (k = $bf74d58b74973e6b$var$Zf(c) ? $bf74d58b74973e6b$var$Xf : $bf74d58b74973e6b$var$H.current, k = $bf74d58b74973e6b$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $bf74d58b74973e6b$var$Hi(b, g, d, k);
        $bf74d58b74973e6b$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $bf74d58b74973e6b$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $bf74d58b74973e6b$var$Wf.current || $bf74d58b74973e6b$var$jh ? ("function" === typeof y && ($bf74d58b74973e6b$var$Di(b, c, y, d), n = b.memoizedState), (l = $bf74d58b74973e6b$var$jh || $bf74d58b74973e6b$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $bf74d58b74973e6b$var$jj(a, b, c, d, f, e);
}
function $bf74d58b74973e6b$var$jj(a, b, c, d, e, f) {
    $bf74d58b74973e6b$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $bf74d58b74973e6b$var$dg(b, c, !1), $bf74d58b74973e6b$var$Zi(a, b, f);
    d = b.stateNode;
    $bf74d58b74973e6b$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $bf74d58b74973e6b$var$Ug(b, a.child, null, f), b.child = $bf74d58b74973e6b$var$Ug(b, null, h, f)) : $bf74d58b74973e6b$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $bf74d58b74973e6b$var$dg(b, c, !0);
    return b.child;
}
function $bf74d58b74973e6b$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $bf74d58b74973e6b$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $bf74d58b74973e6b$var$ag(a, b.context, !1);
    $bf74d58b74973e6b$var$yh(a, b.containerInfo);
}
function $bf74d58b74973e6b$var$lj(a, b, c, d, e) {
    $bf74d58b74973e6b$var$Ig();
    $bf74d58b74973e6b$var$Jg(e);
    b.flags |= 256;
    $bf74d58b74973e6b$var$Xi(a, b, c, d);
    return b.child;
}
var $bf74d58b74973e6b$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $bf74d58b74973e6b$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $bf74d58b74973e6b$var$oj(a, b, c) {
    var d = b.pendingProps, e = $bf74d58b74973e6b$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, e & 1);
    if (null === a) {
        $bf74d58b74973e6b$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $bf74d58b74973e6b$var$pj(g, d, 0, null), a = $bf74d58b74973e6b$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $bf74d58b74973e6b$var$nj(c), b.memoizedState = $bf74d58b74973e6b$var$mj, a) : $bf74d58b74973e6b$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $bf74d58b74973e6b$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $bf74d58b74973e6b$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $bf74d58b74973e6b$var$Pg(h, f) : (f = $bf74d58b74973e6b$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $bf74d58b74973e6b$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $bf74d58b74973e6b$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $bf74d58b74973e6b$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $bf74d58b74973e6b$var$qj(a, b) {
    b = $bf74d58b74973e6b$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $bf74d58b74973e6b$var$sj(a, b, c, d) {
    null !== d && $bf74d58b74973e6b$var$Jg(d);
    $bf74d58b74973e6b$var$Ug(b, a.child, null, c);
    a = $bf74d58b74973e6b$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $bf74d58b74973e6b$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $bf74d58b74973e6b$var$Ki(Error($bf74d58b74973e6b$var$p(422))), $bf74d58b74973e6b$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $bf74d58b74973e6b$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $bf74d58b74973e6b$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $bf74d58b74973e6b$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $bf74d58b74973e6b$var$nj(g);
        b.memoizedState = $bf74d58b74973e6b$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $bf74d58b74973e6b$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($bf74d58b74973e6b$var$p(419));
        d = $bf74d58b74973e6b$var$Ki(f, d, void 0);
        return $bf74d58b74973e6b$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($bf74d58b74973e6b$var$dh || h) {
        d = $bf74d58b74973e6b$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $bf74d58b74973e6b$var$ih(a, e), $bf74d58b74973e6b$var$gi(d, a, e, -1));
        }
        $bf74d58b74973e6b$var$tj();
        d = $bf74d58b74973e6b$var$Ki(Error($bf74d58b74973e6b$var$p(421)));
        return $bf74d58b74973e6b$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $bf74d58b74973e6b$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$Lf(e.nextSibling);
    $bf74d58b74973e6b$var$xg = b;
    $bf74d58b74973e6b$var$I = !0;
    $bf74d58b74973e6b$var$zg = null;
    null !== a && ($bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$rg, $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$sg, $bf74d58b74973e6b$var$og[$bf74d58b74973e6b$var$pg++] = $bf74d58b74973e6b$var$qg, $bf74d58b74973e6b$var$rg = a.id, $bf74d58b74973e6b$var$sg = a.overflow, $bf74d58b74973e6b$var$qg = b);
    b = $bf74d58b74973e6b$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $bf74d58b74973e6b$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $bf74d58b74973e6b$var$bh(a.return, b, c);
}
function $bf74d58b74973e6b$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $bf74d58b74973e6b$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $bf74d58b74973e6b$var$Xi(a, b, d.children, c);
    d = $bf74d58b74973e6b$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $bf74d58b74973e6b$var$vj(a, c, b);
            else if (19 === a.tag) $bf74d58b74973e6b$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $bf74d58b74973e6b$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $bf74d58b74973e6b$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $bf74d58b74973e6b$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $bf74d58b74973e6b$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $bf74d58b74973e6b$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $bf74d58b74973e6b$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $bf74d58b74973e6b$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $bf74d58b74973e6b$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($bf74d58b74973e6b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $bf74d58b74973e6b$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $bf74d58b74973e6b$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $bf74d58b74973e6b$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $bf74d58b74973e6b$var$kj(b);
            $bf74d58b74973e6b$var$Ig();
            break;
        case 5:
            $bf74d58b74973e6b$var$Ah(b);
            break;
        case 1:
            $bf74d58b74973e6b$var$Zf(b.type) && $bf74d58b74973e6b$var$cg(b);
            break;
        case 4:
            $bf74d58b74973e6b$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $bf74d58b74973e6b$var$oj(a, b, c);
                $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current & 1);
                a = $bf74d58b74973e6b$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $bf74d58b74973e6b$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $bf74d58b74973e6b$var$dj(a, b, c);
    }
    return $bf74d58b74973e6b$var$Zi(a, b, c);
}
var $bf74d58b74973e6b$var$zj, $bf74d58b74973e6b$var$Aj, $bf74d58b74973e6b$var$Bj, $bf74d58b74973e6b$var$Cj;
$bf74d58b74973e6b$var$zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$bf74d58b74973e6b$var$Aj = function Aj() {};
$bf74d58b74973e6b$var$Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $bf74d58b74973e6b$var$Ya(a, e);
                d = $bf74d58b74973e6b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $bf74d58b74973e6b$var$A({}, e, {
                    value: void 0
                });
                d = $bf74d58b74973e6b$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $bf74d58b74973e6b$var$gb(a, e);
                d = $bf74d58b74973e6b$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $bf74d58b74973e6b$var$Bf);
        }
        $bf74d58b74973e6b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($bf74d58b74973e6b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($bf74d58b74973e6b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $bf74d58b74973e6b$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$bf74d58b74973e6b$var$Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $bf74d58b74973e6b$var$Dj(a, b) {
    if (!$bf74d58b74973e6b$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $bf74d58b74973e6b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $bf74d58b74973e6b$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $bf74d58b74973e6b$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $bf74d58b74973e6b$var$S(b), null;
        case 1:
            return $bf74d58b74973e6b$var$Zf(b.type) && $bf74d58b74973e6b$var$$f(), $bf74d58b74973e6b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $bf74d58b74973e6b$var$zh();
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf);
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H);
            $bf74d58b74973e6b$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $bf74d58b74973e6b$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $bf74d58b74973e6b$var$zg && ($bf74d58b74973e6b$var$Fj($bf74d58b74973e6b$var$zg), $bf74d58b74973e6b$var$zg = null));
            $bf74d58b74973e6b$var$Aj(a, b);
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 5:
            $bf74d58b74973e6b$var$Bh(b);
            var e = $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $bf74d58b74973e6b$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($bf74d58b74973e6b$var$p(166));
                    $bf74d58b74973e6b$var$S(b);
                    return null;
                }
                a = $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$uh.current);
                if ($bf74d58b74973e6b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$bf74d58b74973e6b$var$Of] = b;
                    d[$bf74d58b74973e6b$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $bf74d58b74973e6b$var$D("cancel", d);
                            $bf74d58b74973e6b$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $bf74d58b74973e6b$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $bf74d58b74973e6b$var$lf.length; e++)$bf74d58b74973e6b$var$D($bf74d58b74973e6b$var$lf[e], d);
                            break;
                        case "source":
                            $bf74d58b74973e6b$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $bf74d58b74973e6b$var$D("error", d);
                            $bf74d58b74973e6b$var$D("load", d);
                            break;
                        case "details":
                            $bf74d58b74973e6b$var$D("toggle", d);
                            break;
                        case "input":
                            $bf74d58b74973e6b$var$Za(d, f);
                            $bf74d58b74973e6b$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $bf74d58b74973e6b$var$D("invalid", d);
                            break;
                        case "textarea":
                            $bf74d58b74973e6b$var$hb(d, f), $bf74d58b74973e6b$var$D("invalid", d);
                    }
                    $bf74d58b74973e6b$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $bf74d58b74973e6b$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $bf74d58b74973e6b$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $bf74d58b74973e6b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $bf74d58b74973e6b$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $bf74d58b74973e6b$var$Va(d);
                            $bf74d58b74973e6b$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $bf74d58b74973e6b$var$Va(d);
                            $bf74d58b74973e6b$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $bf74d58b74973e6b$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $bf74d58b74973e6b$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$bf74d58b74973e6b$var$Of] = b;
                    a[$bf74d58b74973e6b$var$Pf] = d;
                    $bf74d58b74973e6b$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $bf74d58b74973e6b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $bf74d58b74973e6b$var$D("cancel", a);
                                $bf74d58b74973e6b$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $bf74d58b74973e6b$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $bf74d58b74973e6b$var$lf.length; e++)$bf74d58b74973e6b$var$D($bf74d58b74973e6b$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $bf74d58b74973e6b$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $bf74d58b74973e6b$var$D("error", a);
                                $bf74d58b74973e6b$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $bf74d58b74973e6b$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $bf74d58b74973e6b$var$Za(a, d);
                                e = $bf74d58b74973e6b$var$Ya(a, d);
                                $bf74d58b74973e6b$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $bf74d58b74973e6b$var$A({}, d, {
                                    value: void 0
                                });
                                $bf74d58b74973e6b$var$D("invalid", a);
                                break;
                            case "textarea":
                                $bf74d58b74973e6b$var$hb(a, d);
                                e = $bf74d58b74973e6b$var$gb(a, d);
                                $bf74d58b74973e6b$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $bf74d58b74973e6b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $bf74d58b74973e6b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $bf74d58b74973e6b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $bf74d58b74973e6b$var$ob(a, k) : "number" === typeof k && $bf74d58b74973e6b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($bf74d58b74973e6b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $bf74d58b74973e6b$var$D("scroll", a) : null != k && $bf74d58b74973e6b$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $bf74d58b74973e6b$var$Va(a);
                                $bf74d58b74973e6b$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $bf74d58b74973e6b$var$Va(a);
                                $bf74d58b74973e6b$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $bf74d58b74973e6b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $bf74d58b74973e6b$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $bf74d58b74973e6b$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $bf74d58b74973e6b$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $bf74d58b74973e6b$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($bf74d58b74973e6b$var$p(166));
                c = $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$wh.current);
                $bf74d58b74973e6b$var$xh($bf74d58b74973e6b$var$uh.current);
                if ($bf74d58b74973e6b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$bf74d58b74973e6b$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $bf74d58b74973e6b$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $bf74d58b74973e6b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $bf74d58b74973e6b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$bf74d58b74973e6b$var$Of] = b, b.stateNode = d;
            }
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 13:
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($bf74d58b74973e6b$var$I && null !== $bf74d58b74973e6b$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $bf74d58b74973e6b$var$Hg(), $bf74d58b74973e6b$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $bf74d58b74973e6b$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($bf74d58b74973e6b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($bf74d58b74973e6b$var$p(317));
                        f[$bf74d58b74973e6b$var$Of] = b;
                    } else $bf74d58b74973e6b$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $bf74d58b74973e6b$var$S(b);
                    f = !1;
                } else null !== $bf74d58b74973e6b$var$zg && ($bf74d58b74973e6b$var$Fj($bf74d58b74973e6b$var$zg), $bf74d58b74973e6b$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($bf74d58b74973e6b$var$L.current & 1) ? 0 === $bf74d58b74973e6b$var$T && ($bf74d58b74973e6b$var$T = 3) : $bf74d58b74973e6b$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 4:
            return $bf74d58b74973e6b$var$zh(), $bf74d58b74973e6b$var$Aj(a, b), null === a && $bf74d58b74973e6b$var$sf(b.stateNode.containerInfo), $bf74d58b74973e6b$var$S(b), null;
        case 10:
            return $bf74d58b74973e6b$var$ah(b.type._context), $bf74d58b74973e6b$var$S(b), null;
        case 17:
            return $bf74d58b74973e6b$var$Zf(b.type) && $bf74d58b74973e6b$var$$f(), $bf74d58b74973e6b$var$S(b), null;
        case 19:
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
            f = b.memoizedState;
            if (null === f) return $bf74d58b74973e6b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $bf74d58b74973e6b$var$Dj(f, !1);
                else {
                    if (0 !== $bf74d58b74973e6b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $bf74d58b74973e6b$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $bf74d58b74973e6b$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, $bf74d58b74973e6b$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $bf74d58b74973e6b$var$B() > $bf74d58b74973e6b$var$Gj && (b.flags |= 128, d = !0, $bf74d58b74973e6b$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $bf74d58b74973e6b$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $bf74d58b74973e6b$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$bf74d58b74973e6b$var$I) return $bf74d58b74973e6b$var$S(b), null;
                    } else 2 * $bf74d58b74973e6b$var$B() - f.renderingStartTime > $bf74d58b74973e6b$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $bf74d58b74973e6b$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $bf74d58b74973e6b$var$B(), b.sibling = null, c = $bf74d58b74973e6b$var$L.current, $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$L, d ? c & 1 | 2 : c & 1), b;
            $bf74d58b74973e6b$var$S(b);
            return null;
        case 22:
        case 23:
            return $bf74d58b74973e6b$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($bf74d58b74973e6b$var$fj & 1073741824) && ($bf74d58b74973e6b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $bf74d58b74973e6b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($bf74d58b74973e6b$var$p(156, b.tag));
}
function $bf74d58b74973e6b$var$Ij(a, b) {
    $bf74d58b74973e6b$var$wg(b);
    switch(b.tag){
        case 1:
            return $bf74d58b74973e6b$var$Zf(b.type) && $bf74d58b74973e6b$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $bf74d58b74973e6b$var$zh(), $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf), $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H), $bf74d58b74973e6b$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $bf74d58b74973e6b$var$Bh(b), null;
        case 13:
            $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($bf74d58b74973e6b$var$p(340));
                $bf74d58b74973e6b$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L), null;
        case 4:
            return $bf74d58b74973e6b$var$zh(), null;
        case 10:
            return $bf74d58b74973e6b$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $bf74d58b74973e6b$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $bf74d58b74973e6b$var$Jj = !1, $bf74d58b74973e6b$var$U = !1, $bf74d58b74973e6b$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $bf74d58b74973e6b$var$V = null;
function $bf74d58b74973e6b$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $bf74d58b74973e6b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $bf74d58b74973e6b$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $bf74d58b74973e6b$var$W(a, b, d);
    }
}
var $bf74d58b74973e6b$var$Nj = !1;
function $bf74d58b74973e6b$var$Oj(a, b) {
    $bf74d58b74973e6b$var$Cf = $bf74d58b74973e6b$var$dd;
    a = $bf74d58b74973e6b$var$Me();
    if ($bf74d58b74973e6b$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $bf74d58b74973e6b$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $bf74d58b74973e6b$var$dd = !1;
    for($bf74d58b74973e6b$var$V = b; null !== $bf74d58b74973e6b$var$V;)if (b = $bf74d58b74973e6b$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $bf74d58b74973e6b$var$V = a;
    else for(; null !== $bf74d58b74973e6b$var$V;){
        b = $bf74d58b74973e6b$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $bf74d58b74973e6b$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($bf74d58b74973e6b$var$p(163));
            }
        } catch (F) {
            $bf74d58b74973e6b$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $bf74d58b74973e6b$var$V = a;
            break;
        }
        $bf74d58b74973e6b$var$V = b.return;
    }
    n = $bf74d58b74973e6b$var$Nj;
    $bf74d58b74973e6b$var$Nj = !1;
    return n;
}
function $bf74d58b74973e6b$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $bf74d58b74973e6b$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $bf74d58b74973e6b$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $bf74d58b74973e6b$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $bf74d58b74973e6b$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $bf74d58b74973e6b$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$bf74d58b74973e6b$var$Of], delete b[$bf74d58b74973e6b$var$Pf], delete b[$bf74d58b74973e6b$var$of], delete b[$bf74d58b74973e6b$var$Qf], delete b[$bf74d58b74973e6b$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $bf74d58b74973e6b$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $bf74d58b74973e6b$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $bf74d58b74973e6b$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $bf74d58b74973e6b$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $bf74d58b74973e6b$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($bf74d58b74973e6b$var$Vj(a, b, c), a = a.sibling; null !== a;)$bf74d58b74973e6b$var$Vj(a, b, c), a = a.sibling;
}
function $bf74d58b74973e6b$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($bf74d58b74973e6b$var$Wj(a, b, c), a = a.sibling; null !== a;)$bf74d58b74973e6b$var$Wj(a, b, c), a = a.sibling;
}
var $bf74d58b74973e6b$var$X = null, $bf74d58b74973e6b$var$Xj = !1;
function $bf74d58b74973e6b$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$bf74d58b74973e6b$var$Zj(a, b, c), c = c.sibling;
}
function $bf74d58b74973e6b$var$Zj(a, b, c) {
    if ($bf74d58b74973e6b$var$lc && "function" === typeof $bf74d58b74973e6b$var$lc.onCommitFiberUnmount) try {
        $bf74d58b74973e6b$var$lc.onCommitFiberUnmount($bf74d58b74973e6b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $bf74d58b74973e6b$var$U || $bf74d58b74973e6b$var$Lj(c, b);
        case 6:
            var d = $bf74d58b74973e6b$var$X, e = $bf74d58b74973e6b$var$Xj;
            $bf74d58b74973e6b$var$X = null;
            $bf74d58b74973e6b$var$Yj(a, b, c);
            $bf74d58b74973e6b$var$X = d;
            $bf74d58b74973e6b$var$Xj = e;
            null !== $bf74d58b74973e6b$var$X && ($bf74d58b74973e6b$var$Xj ? (a = $bf74d58b74973e6b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $bf74d58b74973e6b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $bf74d58b74973e6b$var$X && ($bf74d58b74973e6b$var$Xj ? (a = $bf74d58b74973e6b$var$X, c = c.stateNode, 8 === a.nodeType ? $bf74d58b74973e6b$var$Kf(a.parentNode, c) : 1 === a.nodeType && $bf74d58b74973e6b$var$Kf(a, c), $bf74d58b74973e6b$var$bd(a)) : $bf74d58b74973e6b$var$Kf($bf74d58b74973e6b$var$X, c.stateNode));
            break;
        case 4:
            d = $bf74d58b74973e6b$var$X;
            e = $bf74d58b74973e6b$var$Xj;
            $bf74d58b74973e6b$var$X = c.stateNode.containerInfo;
            $bf74d58b74973e6b$var$Xj = !0;
            $bf74d58b74973e6b$var$Yj(a, b, c);
            $bf74d58b74973e6b$var$X = d;
            $bf74d58b74973e6b$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$bf74d58b74973e6b$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $bf74d58b74973e6b$var$Mj(c, b, g) : 0 !== (f & 4) && $bf74d58b74973e6b$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $bf74d58b74973e6b$var$Yj(a, b, c);
            break;
        case 1:
            if (!$bf74d58b74973e6b$var$U && ($bf74d58b74973e6b$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $bf74d58b74973e6b$var$W(c, b, h);
            }
            $bf74d58b74973e6b$var$Yj(a, b, c);
            break;
        case 21:
            $bf74d58b74973e6b$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($bf74d58b74973e6b$var$U = (d = $bf74d58b74973e6b$var$U) || null !== c.memoizedState, $bf74d58b74973e6b$var$Yj(a, b, c), $bf74d58b74973e6b$var$U = d) : $bf74d58b74973e6b$var$Yj(a, b, c);
            break;
        default:
            $bf74d58b74973e6b$var$Yj(a, b, c);
    }
}
function $bf74d58b74973e6b$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $bf74d58b74973e6b$var$Kj);
        b.forEach(function(b) {
            var d = $bf74d58b74973e6b$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $bf74d58b74973e6b$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $bf74d58b74973e6b$var$X = h.stateNode;
                        $bf74d58b74973e6b$var$Xj = !1;
                        break a;
                    case 3:
                        $bf74d58b74973e6b$var$X = h.stateNode.containerInfo;
                        $bf74d58b74973e6b$var$Xj = !0;
                        break a;
                    case 4:
                        $bf74d58b74973e6b$var$X = h.stateNode.containerInfo;
                        $bf74d58b74973e6b$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $bf74d58b74973e6b$var$X) throw Error($bf74d58b74973e6b$var$p(160));
            $bf74d58b74973e6b$var$Zj(f, g, e);
            $bf74d58b74973e6b$var$X = null;
            $bf74d58b74973e6b$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $bf74d58b74973e6b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$bf74d58b74973e6b$var$dk(b, a), b = b.sibling;
}
function $bf74d58b74973e6b$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            if (d & 4) {
                try {
                    $bf74d58b74973e6b$var$Pj(3, a, a.return), $bf74d58b74973e6b$var$Qj(3, a);
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
                try {
                    $bf74d58b74973e6b$var$Pj(5, a, a.return);
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            d & 512 && null !== c && $bf74d58b74973e6b$var$Lj(c, c.return);
            break;
        case 5:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            d & 512 && null !== c && $bf74d58b74973e6b$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $bf74d58b74973e6b$var$ob(e, "");
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $bf74d58b74973e6b$var$ab(e, f);
                    $bf74d58b74973e6b$var$vb(h, g);
                    var l = $bf74d58b74973e6b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $bf74d58b74973e6b$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $bf74d58b74973e6b$var$nb(e, q) : "children" === m ? $bf74d58b74973e6b$var$ob(e, q) : $bf74d58b74973e6b$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $bf74d58b74973e6b$var$bb(e, f);
                            break;
                        case "textarea":
                            $bf74d58b74973e6b$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $bf74d58b74973e6b$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $bf74d58b74973e6b$var$fb(e, !!f.multiple, f.defaultValue, !0) : $bf74d58b74973e6b$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$bf74d58b74973e6b$var$Pf] = f;
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($bf74d58b74973e6b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $bf74d58b74973e6b$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $bf74d58b74973e6b$var$bd(b.containerInfo);
            } catch (t) {
                $bf74d58b74973e6b$var$W(a, a.return, t);
            }
            break;
        case 4:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            break;
        case 13:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($bf74d58b74973e6b$var$fk = $bf74d58b74973e6b$var$B()));
            d & 4 && $bf74d58b74973e6b$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($bf74d58b74973e6b$var$U = (l = $bf74d58b74973e6b$var$U) || m, $bf74d58b74973e6b$var$ck(b, a), $bf74d58b74973e6b$var$U = l) : $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($bf74d58b74973e6b$var$V = a, m = a.child; null !== m;){
                    for(q = $bf74d58b74973e6b$var$V = m; null !== $bf74d58b74973e6b$var$V;){
                        r = $bf74d58b74973e6b$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $bf74d58b74973e6b$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $bf74d58b74973e6b$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $bf74d58b74973e6b$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $bf74d58b74973e6b$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $bf74d58b74973e6b$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $bf74d58b74973e6b$var$V = y) : $bf74d58b74973e6b$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $bf74d58b74973e6b$var$rb("display", g));
                            } catch (t) {
                                $bf74d58b74973e6b$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $bf74d58b74973e6b$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $bf74d58b74973e6b$var$ck(b, a);
            $bf74d58b74973e6b$var$ek(a);
            d & 4 && $bf74d58b74973e6b$var$ak(a);
            break;
        case 21:
            break;
        default:
            $bf74d58b74973e6b$var$ck(b, a), $bf74d58b74973e6b$var$ek(a);
    }
}
function $bf74d58b74973e6b$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($bf74d58b74973e6b$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($bf74d58b74973e6b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($bf74d58b74973e6b$var$ob(e, ""), d.flags &= -33);
                    var f = $bf74d58b74973e6b$var$Uj(a);
                    $bf74d58b74973e6b$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $bf74d58b74973e6b$var$Uj(a);
                    $bf74d58b74973e6b$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($bf74d58b74973e6b$var$p(161));
            }
        } catch (k) {
            $bf74d58b74973e6b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $bf74d58b74973e6b$var$hk(a, b, c) {
    $bf74d58b74973e6b$var$V = a;
    $bf74d58b74973e6b$var$ik(a, b, c);
}
function $bf74d58b74973e6b$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $bf74d58b74973e6b$var$V;){
        var e = $bf74d58b74973e6b$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $bf74d58b74973e6b$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $bf74d58b74973e6b$var$U;
                h = $bf74d58b74973e6b$var$Jj;
                var l = $bf74d58b74973e6b$var$U;
                $bf74d58b74973e6b$var$Jj = g;
                if (($bf74d58b74973e6b$var$U = k) && !l) for($bf74d58b74973e6b$var$V = e; null !== $bf74d58b74973e6b$var$V;)g = $bf74d58b74973e6b$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $bf74d58b74973e6b$var$jk(e) : null !== k ? (k.return = g, $bf74d58b74973e6b$var$V = k) : $bf74d58b74973e6b$var$jk(e);
                for(; null !== f;)$bf74d58b74973e6b$var$V = f, $bf74d58b74973e6b$var$ik(f, b, c), f = f.sibling;
                $bf74d58b74973e6b$var$V = e;
                $bf74d58b74973e6b$var$Jj = h;
                $bf74d58b74973e6b$var$U = l;
            }
            $bf74d58b74973e6b$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $bf74d58b74973e6b$var$V = f) : $bf74d58b74973e6b$var$kk(a, b, c);
    }
}
function $bf74d58b74973e6b$var$kk(a) {
    for(; null !== $bf74d58b74973e6b$var$V;){
        var b = $bf74d58b74973e6b$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $bf74d58b74973e6b$var$U || $bf74d58b74973e6b$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$bf74d58b74973e6b$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $bf74d58b74973e6b$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $bf74d58b74973e6b$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $bf74d58b74973e6b$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $bf74d58b74973e6b$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($bf74d58b74973e6b$var$p(163));
                }
                $bf74d58b74973e6b$var$U || b.flags & 512 && $bf74d58b74973e6b$var$Rj(b);
            } catch (r) {
                $bf74d58b74973e6b$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $bf74d58b74973e6b$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $bf74d58b74973e6b$var$V = c;
            break;
        }
        $bf74d58b74973e6b$var$V = b.return;
    }
}
function $bf74d58b74973e6b$var$gk(a) {
    for(; null !== $bf74d58b74973e6b$var$V;){
        var b = $bf74d58b74973e6b$var$V;
        if (b === a) {
            $bf74d58b74973e6b$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $bf74d58b74973e6b$var$V = c;
            break;
        }
        $bf74d58b74973e6b$var$V = b.return;
    }
}
function $bf74d58b74973e6b$var$jk(a) {
    for(; null !== $bf74d58b74973e6b$var$V;){
        var b = $bf74d58b74973e6b$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $bf74d58b74973e6b$var$Qj(4, b);
                    } catch (k) {
                        $bf74d58b74973e6b$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $bf74d58b74973e6b$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $bf74d58b74973e6b$var$Rj(b);
                    } catch (k) {
                        $bf74d58b74973e6b$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $bf74d58b74973e6b$var$Rj(b);
                    } catch (k) {
                        $bf74d58b74973e6b$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $bf74d58b74973e6b$var$W(b, b.return, k);
        }
        if (b === a) {
            $bf74d58b74973e6b$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $bf74d58b74973e6b$var$V = h;
            break;
        }
        $bf74d58b74973e6b$var$V = b.return;
    }
}
var $bf74d58b74973e6b$var$lk = Math.ceil, $bf74d58b74973e6b$var$mk = $bf74d58b74973e6b$var$ua.ReactCurrentDispatcher, $bf74d58b74973e6b$var$nk = $bf74d58b74973e6b$var$ua.ReactCurrentOwner, $bf74d58b74973e6b$var$ok = $bf74d58b74973e6b$var$ua.ReactCurrentBatchConfig, $bf74d58b74973e6b$var$K = 0, $bf74d58b74973e6b$var$Q = null, $bf74d58b74973e6b$var$Y = null, $bf74d58b74973e6b$var$Z = 0, $bf74d58b74973e6b$var$fj = 0, $bf74d58b74973e6b$var$ej = $bf74d58b74973e6b$var$Uf(0), $bf74d58b74973e6b$var$T = 0, $bf74d58b74973e6b$var$pk = null, $bf74d58b74973e6b$var$rh = 0, $bf74d58b74973e6b$var$qk = 0, $bf74d58b74973e6b$var$rk = 0, $bf74d58b74973e6b$var$sk = null, $bf74d58b74973e6b$var$tk = null, $bf74d58b74973e6b$var$fk = 0, $bf74d58b74973e6b$var$Gj = Infinity, $bf74d58b74973e6b$var$uk = null, $bf74d58b74973e6b$var$Oi = !1, $bf74d58b74973e6b$var$Pi = null, $bf74d58b74973e6b$var$Ri = null, $bf74d58b74973e6b$var$vk = !1, $bf74d58b74973e6b$var$wk = null, $bf74d58b74973e6b$var$xk = 0, $bf74d58b74973e6b$var$yk = 0, $bf74d58b74973e6b$var$zk = null, $bf74d58b74973e6b$var$Ak = -1, $bf74d58b74973e6b$var$Bk = 0;
function $bf74d58b74973e6b$var$R() {
    return 0 !== ($bf74d58b74973e6b$var$K & 6) ? $bf74d58b74973e6b$var$B() : -1 !== $bf74d58b74973e6b$var$Ak ? $bf74d58b74973e6b$var$Ak : $bf74d58b74973e6b$var$Ak = $bf74d58b74973e6b$var$B();
}
function $bf74d58b74973e6b$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($bf74d58b74973e6b$var$K & 2) && 0 !== $bf74d58b74973e6b$var$Z) return $bf74d58b74973e6b$var$Z & -$bf74d58b74973e6b$var$Z;
    if (null !== $bf74d58b74973e6b$var$Kg.transition) return 0 === $bf74d58b74973e6b$var$Bk && ($bf74d58b74973e6b$var$Bk = $bf74d58b74973e6b$var$yc()), $bf74d58b74973e6b$var$Bk;
    a = $bf74d58b74973e6b$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $bf74d58b74973e6b$var$jd(a.type);
    return a;
}
function $bf74d58b74973e6b$var$gi(a, b, c, d) {
    if (50 < $bf74d58b74973e6b$var$yk) throw $bf74d58b74973e6b$var$yk = 0, $bf74d58b74973e6b$var$zk = null, Error($bf74d58b74973e6b$var$p(185));
    $bf74d58b74973e6b$var$Ac(a, c, d);
    if (0 === ($bf74d58b74973e6b$var$K & 2) || a !== $bf74d58b74973e6b$var$Q) a === $bf74d58b74973e6b$var$Q && (0 === ($bf74d58b74973e6b$var$K & 2) && ($bf74d58b74973e6b$var$qk |= c), 4 === $bf74d58b74973e6b$var$T && $bf74d58b74973e6b$var$Ck(a, $bf74d58b74973e6b$var$Z)), $bf74d58b74973e6b$var$Dk(a, d), 1 === c && 0 === $bf74d58b74973e6b$var$K && 0 === (b.mode & 1) && ($bf74d58b74973e6b$var$Gj = $bf74d58b74973e6b$var$B() + 500, $bf74d58b74973e6b$var$fg && $bf74d58b74973e6b$var$jg());
}
function $bf74d58b74973e6b$var$Dk(a, b) {
    var c = a.callbackNode;
    $bf74d58b74973e6b$var$wc(a, b);
    var d = $bf74d58b74973e6b$var$uc(a, a === $bf74d58b74973e6b$var$Q ? $bf74d58b74973e6b$var$Z : 0);
    if (0 === d) null !== c && $bf74d58b74973e6b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $bf74d58b74973e6b$var$bc(c);
        if (1 === b) 0 === a.tag ? $bf74d58b74973e6b$var$ig($bf74d58b74973e6b$var$Ek.bind(null, a)) : $bf74d58b74973e6b$var$hg($bf74d58b74973e6b$var$Ek.bind(null, a)), $bf74d58b74973e6b$var$Jf(function() {
            0 === ($bf74d58b74973e6b$var$K & 6) && $bf74d58b74973e6b$var$jg();
        }), c = null;
        else {
            switch($bf74d58b74973e6b$var$Dc(d)){
                case 1:
                    c = $bf74d58b74973e6b$var$fc;
                    break;
                case 4:
                    c = $bf74d58b74973e6b$var$gc;
                    break;
                case 16:
                    c = $bf74d58b74973e6b$var$hc;
                    break;
                case 536870912:
                    c = $bf74d58b74973e6b$var$jc;
                    break;
                default:
                    c = $bf74d58b74973e6b$var$hc;
            }
            c = $bf74d58b74973e6b$var$Fk(c, $bf74d58b74973e6b$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $bf74d58b74973e6b$var$Gk(a, b) {
    $bf74d58b74973e6b$var$Ak = -1;
    $bf74d58b74973e6b$var$Bk = 0;
    if (0 !== ($bf74d58b74973e6b$var$K & 6)) throw Error($bf74d58b74973e6b$var$p(327));
    var c = a.callbackNode;
    if ($bf74d58b74973e6b$var$Hk() && a.callbackNode !== c) return null;
    var d = $bf74d58b74973e6b$var$uc(a, a === $bf74d58b74973e6b$var$Q ? $bf74d58b74973e6b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $bf74d58b74973e6b$var$Ik(a, d);
    else {
        b = d;
        var e = $bf74d58b74973e6b$var$K;
        $bf74d58b74973e6b$var$K |= 2;
        var f = $bf74d58b74973e6b$var$Jk();
        if ($bf74d58b74973e6b$var$Q !== a || $bf74d58b74973e6b$var$Z !== b) $bf74d58b74973e6b$var$uk = null, $bf74d58b74973e6b$var$Gj = $bf74d58b74973e6b$var$B() + 500, $bf74d58b74973e6b$var$Kk(a, b);
        for(;;)try {
            $bf74d58b74973e6b$var$Lk();
            break;
        } catch (h) {
            $bf74d58b74973e6b$var$Mk(a, h);
        }
        $bf74d58b74973e6b$var$$g();
        $bf74d58b74973e6b$var$mk.current = f;
        $bf74d58b74973e6b$var$K = e;
        null !== $bf74d58b74973e6b$var$Y ? b = 0 : ($bf74d58b74973e6b$var$Q = null, $bf74d58b74973e6b$var$Z = 0, b = $bf74d58b74973e6b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $bf74d58b74973e6b$var$xc(a), 0 !== e && (d = e, b = $bf74d58b74973e6b$var$Nk(a, e)));
        if (1 === b) throw c = $bf74d58b74973e6b$var$pk, $bf74d58b74973e6b$var$Kk(a, 0), $bf74d58b74973e6b$var$Ck(a, d), $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B()), c;
        if (6 === b) $bf74d58b74973e6b$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$bf74d58b74973e6b$var$Ok(e) && (b = $bf74d58b74973e6b$var$Ik(a, d), 2 === b && (f = $bf74d58b74973e6b$var$xc(a), 0 !== f && (d = f, b = $bf74d58b74973e6b$var$Nk(a, f))), 1 === b)) throw c = $bf74d58b74973e6b$var$pk, $bf74d58b74973e6b$var$Kk(a, 0), $bf74d58b74973e6b$var$Ck(a, d), $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($bf74d58b74973e6b$var$p(345));
                case 2:
                    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
                    break;
                case 3:
                    $bf74d58b74973e6b$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $bf74d58b74973e6b$var$fk + 500 - $bf74d58b74973e6b$var$B(), 10 < b)) {
                        if (0 !== $bf74d58b74973e6b$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $bf74d58b74973e6b$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $bf74d58b74973e6b$var$Ff($bf74d58b74973e6b$var$Pk.bind(null, a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk), b);
                        break;
                    }
                    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
                    break;
                case 4:
                    $bf74d58b74973e6b$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $bf74d58b74973e6b$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $bf74d58b74973e6b$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $bf74d58b74973e6b$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $bf74d58b74973e6b$var$Ff($bf74d58b74973e6b$var$Pk.bind(null, a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk), d);
                        break;
                    }
                    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
                    break;
                case 5:
                    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
                    break;
                default:
                    throw Error($bf74d58b74973e6b$var$p(329));
            }
        }
    }
    $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B());
    return a.callbackNode === c ? $bf74d58b74973e6b$var$Gk.bind(null, a) : null;
}
function $bf74d58b74973e6b$var$Nk(a, b) {
    var c = $bf74d58b74973e6b$var$sk;
    a.current.memoizedState.isDehydrated && ($bf74d58b74973e6b$var$Kk(a, b).flags |= 256);
    a = $bf74d58b74973e6b$var$Ik(a, b);
    2 !== a && (b = $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$tk = c, null !== b && $bf74d58b74973e6b$var$Fj(b));
    return a;
}
function $bf74d58b74973e6b$var$Fj(a) {
    null === $bf74d58b74973e6b$var$tk ? $bf74d58b74973e6b$var$tk = a : $bf74d58b74973e6b$var$tk.push.apply($bf74d58b74973e6b$var$tk, a);
}
function $bf74d58b74973e6b$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$bf74d58b74973e6b$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $bf74d58b74973e6b$var$Ck(a, b) {
    b &= ~$bf74d58b74973e6b$var$rk;
    b &= ~$bf74d58b74973e6b$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $bf74d58b74973e6b$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $bf74d58b74973e6b$var$Ek(a) {
    if (0 !== ($bf74d58b74973e6b$var$K & 6)) throw Error($bf74d58b74973e6b$var$p(327));
    $bf74d58b74973e6b$var$Hk();
    var b = $bf74d58b74973e6b$var$uc(a, 0);
    if (0 === (b & 1)) return $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B()), null;
    var c = $bf74d58b74973e6b$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $bf74d58b74973e6b$var$xc(a);
        0 !== d && (b = d, c = $bf74d58b74973e6b$var$Nk(a, d));
    }
    if (1 === c) throw c = $bf74d58b74973e6b$var$pk, $bf74d58b74973e6b$var$Kk(a, 0), $bf74d58b74973e6b$var$Ck(a, b), $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B()), c;
    if (6 === c) throw Error($bf74d58b74973e6b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $bf74d58b74973e6b$var$Pk(a, $bf74d58b74973e6b$var$tk, $bf74d58b74973e6b$var$uk);
    $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B());
    return null;
}
function $bf74d58b74973e6b$var$Qk(a, b) {
    var c = $bf74d58b74973e6b$var$K;
    $bf74d58b74973e6b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $bf74d58b74973e6b$var$K = c, 0 === $bf74d58b74973e6b$var$K && ($bf74d58b74973e6b$var$Gj = $bf74d58b74973e6b$var$B() + 500, $bf74d58b74973e6b$var$fg && $bf74d58b74973e6b$var$jg());
    }
}
function $bf74d58b74973e6b$var$Rk(a) {
    null !== $bf74d58b74973e6b$var$wk && 0 === $bf74d58b74973e6b$var$wk.tag && 0 === ($bf74d58b74973e6b$var$K & 6) && $bf74d58b74973e6b$var$Hk();
    var b = $bf74d58b74973e6b$var$K;
    $bf74d58b74973e6b$var$K |= 1;
    var c = $bf74d58b74973e6b$var$ok.transition, d = $bf74d58b74973e6b$var$C;
    try {
        if ($bf74d58b74973e6b$var$ok.transition = null, $bf74d58b74973e6b$var$C = 1, a) return a();
    } finally{
        $bf74d58b74973e6b$var$C = d, $bf74d58b74973e6b$var$ok.transition = c, $bf74d58b74973e6b$var$K = b, 0 === ($bf74d58b74973e6b$var$K & 6) && $bf74d58b74973e6b$var$jg();
    }
}
function $bf74d58b74973e6b$var$Hj() {
    $bf74d58b74973e6b$var$fj = $bf74d58b74973e6b$var$ej.current;
    $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$ej);
}
function $bf74d58b74973e6b$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $bf74d58b74973e6b$var$Gf(c));
    if (null !== $bf74d58b74973e6b$var$Y) for(c = $bf74d58b74973e6b$var$Y.return; null !== c;){
        var d = c;
        $bf74d58b74973e6b$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $bf74d58b74973e6b$var$$f();
                break;
            case 3:
                $bf74d58b74973e6b$var$zh();
                $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$Wf);
                $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$H);
                $bf74d58b74973e6b$var$Eh();
                break;
            case 5:
                $bf74d58b74973e6b$var$Bh(d);
                break;
            case 4:
                $bf74d58b74973e6b$var$zh();
                break;
            case 13:
                $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
                break;
            case 19:
                $bf74d58b74973e6b$var$E($bf74d58b74973e6b$var$L);
                break;
            case 10:
                $bf74d58b74973e6b$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $bf74d58b74973e6b$var$Hj();
        }
        c = c.return;
    }
    $bf74d58b74973e6b$var$Q = a;
    $bf74d58b74973e6b$var$Y = a = $bf74d58b74973e6b$var$Pg(a.current, null);
    $bf74d58b74973e6b$var$Z = $bf74d58b74973e6b$var$fj = b;
    $bf74d58b74973e6b$var$T = 0;
    $bf74d58b74973e6b$var$pk = null;
    $bf74d58b74973e6b$var$rk = $bf74d58b74973e6b$var$qk = $bf74d58b74973e6b$var$rh = 0;
    $bf74d58b74973e6b$var$tk = $bf74d58b74973e6b$var$sk = null;
    if (null !== $bf74d58b74973e6b$var$fh) {
        for(b = 0; b < $bf74d58b74973e6b$var$fh.length; b++)if (c = $bf74d58b74973e6b$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $bf74d58b74973e6b$var$fh = null;
    }
    return a;
}
function $bf74d58b74973e6b$var$Mk(a, b) {
    do {
        var c = $bf74d58b74973e6b$var$Y;
        try {
            $bf74d58b74973e6b$var$$g();
            $bf74d58b74973e6b$var$Fh.current = $bf74d58b74973e6b$var$Rh;
            if ($bf74d58b74973e6b$var$Ih) {
                for(var d = $bf74d58b74973e6b$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $bf74d58b74973e6b$var$Ih = !1;
            }
            $bf74d58b74973e6b$var$Hh = 0;
            $bf74d58b74973e6b$var$O = $bf74d58b74973e6b$var$N = $bf74d58b74973e6b$var$M = null;
            $bf74d58b74973e6b$var$Jh = !1;
            $bf74d58b74973e6b$var$Kh = 0;
            $bf74d58b74973e6b$var$nk.current = null;
            if (null === c || null === c.return) {
                $bf74d58b74973e6b$var$T = 1;
                $bf74d58b74973e6b$var$pk = b;
                $bf74d58b74973e6b$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $bf74d58b74973e6b$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === (typeof k === "undefined" ? "undefined" : (0, $5djcY._)(k)) && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $bf74d58b74973e6b$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $bf74d58b74973e6b$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $bf74d58b74973e6b$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $bf74d58b74973e6b$var$Si(f, l, b);
                            $bf74d58b74973e6b$var$tj();
                            break a;
                        }
                        k = Error($bf74d58b74973e6b$var$p(426));
                    }
                } else if ($bf74d58b74973e6b$var$I && h.mode & 1) {
                    var J = $bf74d58b74973e6b$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $bf74d58b74973e6b$var$Vi(J, g, h, f, b);
                        $bf74d58b74973e6b$var$Jg($bf74d58b74973e6b$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $bf74d58b74973e6b$var$Ji(k, h);
                4 !== $bf74d58b74973e6b$var$T && ($bf74d58b74973e6b$var$T = 2);
                null === $bf74d58b74973e6b$var$sk ? $bf74d58b74973e6b$var$sk = [
                    f
                ] : $bf74d58b74973e6b$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $bf74d58b74973e6b$var$Ni(f, k, b);
                            $bf74d58b74973e6b$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $bf74d58b74973e6b$var$Ri || !$bf74d58b74973e6b$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $bf74d58b74973e6b$var$Qi(f, h, b);
                                $bf74d58b74973e6b$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $bf74d58b74973e6b$var$Sk(c);
        } catch (na) {
            b = na;
            $bf74d58b74973e6b$var$Y === c && null !== c && ($bf74d58b74973e6b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $bf74d58b74973e6b$var$Jk() {
    var a = $bf74d58b74973e6b$var$mk.current;
    $bf74d58b74973e6b$var$mk.current = $bf74d58b74973e6b$var$Rh;
    return null === a ? $bf74d58b74973e6b$var$Rh : a;
}
function $bf74d58b74973e6b$var$tj() {
    if (0 === $bf74d58b74973e6b$var$T || 3 === $bf74d58b74973e6b$var$T || 2 === $bf74d58b74973e6b$var$T) $bf74d58b74973e6b$var$T = 4;
    null === $bf74d58b74973e6b$var$Q || 0 === ($bf74d58b74973e6b$var$rh & 268435455) && 0 === ($bf74d58b74973e6b$var$qk & 268435455) || $bf74d58b74973e6b$var$Ck($bf74d58b74973e6b$var$Q, $bf74d58b74973e6b$var$Z);
}
function $bf74d58b74973e6b$var$Ik(a, b) {
    var c = $bf74d58b74973e6b$var$K;
    $bf74d58b74973e6b$var$K |= 2;
    var d = $bf74d58b74973e6b$var$Jk();
    if ($bf74d58b74973e6b$var$Q !== a || $bf74d58b74973e6b$var$Z !== b) $bf74d58b74973e6b$var$uk = null, $bf74d58b74973e6b$var$Kk(a, b);
    for(;;)try {
        $bf74d58b74973e6b$var$Tk();
        break;
    } catch (e) {
        $bf74d58b74973e6b$var$Mk(a, e);
    }
    $bf74d58b74973e6b$var$$g();
    $bf74d58b74973e6b$var$K = c;
    $bf74d58b74973e6b$var$mk.current = d;
    if (null !== $bf74d58b74973e6b$var$Y) throw Error($bf74d58b74973e6b$var$p(261));
    $bf74d58b74973e6b$var$Q = null;
    $bf74d58b74973e6b$var$Z = 0;
    return $bf74d58b74973e6b$var$T;
}
function $bf74d58b74973e6b$var$Tk() {
    for(; null !== $bf74d58b74973e6b$var$Y;)$bf74d58b74973e6b$var$Uk($bf74d58b74973e6b$var$Y);
}
function $bf74d58b74973e6b$var$Lk() {
    for(; null !== $bf74d58b74973e6b$var$Y && !$bf74d58b74973e6b$var$cc();)$bf74d58b74973e6b$var$Uk($bf74d58b74973e6b$var$Y);
}
function $bf74d58b74973e6b$var$Uk(a) {
    var b = $bf74d58b74973e6b$var$Vk(a.alternate, a, $bf74d58b74973e6b$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $bf74d58b74973e6b$var$Sk(a) : $bf74d58b74973e6b$var$Y = b;
    $bf74d58b74973e6b$var$nk.current = null;
}
function $bf74d58b74973e6b$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $bf74d58b74973e6b$var$Ej(c, b, $bf74d58b74973e6b$var$fj), null !== c) {
                $bf74d58b74973e6b$var$Y = c;
                return;
            }
        } else {
            c = $bf74d58b74973e6b$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $bf74d58b74973e6b$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $bf74d58b74973e6b$var$T = 6;
                $bf74d58b74973e6b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $bf74d58b74973e6b$var$Y = b;
            return;
        }
        $bf74d58b74973e6b$var$Y = b = a;
    }while (null !== b);
    0 === $bf74d58b74973e6b$var$T && ($bf74d58b74973e6b$var$T = 5);
}
function $bf74d58b74973e6b$var$Pk(a, b, c) {
    var d = $bf74d58b74973e6b$var$C, e = $bf74d58b74973e6b$var$ok.transition;
    try {
        $bf74d58b74973e6b$var$ok.transition = null, $bf74d58b74973e6b$var$C = 1, $bf74d58b74973e6b$var$Wk(a, b, c, d);
    } finally{
        $bf74d58b74973e6b$var$ok.transition = e, $bf74d58b74973e6b$var$C = d;
    }
    return null;
}
function $bf74d58b74973e6b$var$Wk(a, b, c, d) {
    do $bf74d58b74973e6b$var$Hk();
    while (null !== $bf74d58b74973e6b$var$wk);
    if (0 !== ($bf74d58b74973e6b$var$K & 6)) throw Error($bf74d58b74973e6b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($bf74d58b74973e6b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $bf74d58b74973e6b$var$Bc(a, f);
    a === $bf74d58b74973e6b$var$Q && ($bf74d58b74973e6b$var$Y = $bf74d58b74973e6b$var$Q = null, $bf74d58b74973e6b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $bf74d58b74973e6b$var$vk || ($bf74d58b74973e6b$var$vk = !0, $bf74d58b74973e6b$var$Fk($bf74d58b74973e6b$var$hc, function() {
        $bf74d58b74973e6b$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $bf74d58b74973e6b$var$ok.transition;
        $bf74d58b74973e6b$var$ok.transition = null;
        var g = $bf74d58b74973e6b$var$C;
        $bf74d58b74973e6b$var$C = 1;
        var h = $bf74d58b74973e6b$var$K;
        $bf74d58b74973e6b$var$K |= 4;
        $bf74d58b74973e6b$var$nk.current = null;
        $bf74d58b74973e6b$var$Oj(a, c);
        $bf74d58b74973e6b$var$dk(c, a);
        $bf74d58b74973e6b$var$Oe($bf74d58b74973e6b$var$Df);
        $bf74d58b74973e6b$var$dd = !!$bf74d58b74973e6b$var$Cf;
        $bf74d58b74973e6b$var$Df = $bf74d58b74973e6b$var$Cf = null;
        a.current = c;
        $bf74d58b74973e6b$var$hk(c, a, e);
        $bf74d58b74973e6b$var$dc();
        $bf74d58b74973e6b$var$K = h;
        $bf74d58b74973e6b$var$C = g;
        $bf74d58b74973e6b$var$ok.transition = f;
    } else a.current = c;
    $bf74d58b74973e6b$var$vk && ($bf74d58b74973e6b$var$vk = !1, $bf74d58b74973e6b$var$wk = a, $bf74d58b74973e6b$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($bf74d58b74973e6b$var$Ri = null);
    $bf74d58b74973e6b$var$mc(c.stateNode, d);
    $bf74d58b74973e6b$var$Dk(a, $bf74d58b74973e6b$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($bf74d58b74973e6b$var$Oi) throw $bf74d58b74973e6b$var$Oi = !1, a = $bf74d58b74973e6b$var$Pi, $bf74d58b74973e6b$var$Pi = null, a;
    0 !== ($bf74d58b74973e6b$var$xk & 1) && 0 !== a.tag && $bf74d58b74973e6b$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $bf74d58b74973e6b$var$zk ? $bf74d58b74973e6b$var$yk++ : ($bf74d58b74973e6b$var$yk = 0, $bf74d58b74973e6b$var$zk = a) : $bf74d58b74973e6b$var$yk = 0;
    $bf74d58b74973e6b$var$jg();
    return null;
}
function $bf74d58b74973e6b$var$Hk() {
    if (null !== $bf74d58b74973e6b$var$wk) {
        var a = $bf74d58b74973e6b$var$Dc($bf74d58b74973e6b$var$xk), b = $bf74d58b74973e6b$var$ok.transition, c = $bf74d58b74973e6b$var$C;
        try {
            $bf74d58b74973e6b$var$ok.transition = null;
            $bf74d58b74973e6b$var$C = 16 > a ? 16 : a;
            if (null === $bf74d58b74973e6b$var$wk) var d = !1;
            else {
                a = $bf74d58b74973e6b$var$wk;
                $bf74d58b74973e6b$var$wk = null;
                $bf74d58b74973e6b$var$xk = 0;
                if (0 !== ($bf74d58b74973e6b$var$K & 6)) throw Error($bf74d58b74973e6b$var$p(331));
                var e = $bf74d58b74973e6b$var$K;
                $bf74d58b74973e6b$var$K |= 4;
                for($bf74d58b74973e6b$var$V = a.current; null !== $bf74d58b74973e6b$var$V;){
                    var f = $bf74d58b74973e6b$var$V, g = f.child;
                    if (0 !== ($bf74d58b74973e6b$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($bf74d58b74973e6b$var$V = l; null !== $bf74d58b74973e6b$var$V;){
                                    var m = $bf74d58b74973e6b$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $bf74d58b74973e6b$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $bf74d58b74973e6b$var$V = q;
                                    else for(; null !== $bf74d58b74973e6b$var$V;){
                                        m = $bf74d58b74973e6b$var$V;
                                        var r = m.sibling, y = m.return;
                                        $bf74d58b74973e6b$var$Sj(m);
                                        if (m === l) {
                                            $bf74d58b74973e6b$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $bf74d58b74973e6b$var$V = r;
                                            break;
                                        }
                                        $bf74d58b74973e6b$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $bf74d58b74973e6b$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $bf74d58b74973e6b$var$V = g;
                    else b: for(; null !== $bf74d58b74973e6b$var$V;){
                        f = $bf74d58b74973e6b$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $bf74d58b74973e6b$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $bf74d58b74973e6b$var$V = x;
                            break b;
                        }
                        $bf74d58b74973e6b$var$V = f.return;
                    }
                }
                var w = a.current;
                for($bf74d58b74973e6b$var$V = w; null !== $bf74d58b74973e6b$var$V;){
                    g = $bf74d58b74973e6b$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $bf74d58b74973e6b$var$V = u;
                    else b: for(g = w; null !== $bf74d58b74973e6b$var$V;){
                        h = $bf74d58b74973e6b$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $bf74d58b74973e6b$var$Qj(9, h);
                            }
                        } catch (na) {
                            $bf74d58b74973e6b$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $bf74d58b74973e6b$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $bf74d58b74973e6b$var$V = F;
                            break b;
                        }
                        $bf74d58b74973e6b$var$V = h.return;
                    }
                }
                $bf74d58b74973e6b$var$K = e;
                $bf74d58b74973e6b$var$jg();
                if ($bf74d58b74973e6b$var$lc && "function" === typeof $bf74d58b74973e6b$var$lc.onPostCommitFiberRoot) try {
                    $bf74d58b74973e6b$var$lc.onPostCommitFiberRoot($bf74d58b74973e6b$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $bf74d58b74973e6b$var$C = c, $bf74d58b74973e6b$var$ok.transition = b;
        }
    }
    return !1;
}
function $bf74d58b74973e6b$var$Xk(a, b, c) {
    b = $bf74d58b74973e6b$var$Ji(c, b);
    b = $bf74d58b74973e6b$var$Ni(a, b, 1);
    a = $bf74d58b74973e6b$var$nh(a, b, 1);
    b = $bf74d58b74973e6b$var$R();
    null !== a && ($bf74d58b74973e6b$var$Ac(a, 1, b), $bf74d58b74973e6b$var$Dk(a, b));
}
function $bf74d58b74973e6b$var$W(a, b, c) {
    if (3 === a.tag) $bf74d58b74973e6b$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $bf74d58b74973e6b$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $bf74d58b74973e6b$var$Ri || !$bf74d58b74973e6b$var$Ri.has(d))) {
                a = $bf74d58b74973e6b$var$Ji(c, a);
                a = $bf74d58b74973e6b$var$Qi(b, a, 1);
                b = $bf74d58b74973e6b$var$nh(b, a, 1);
                a = $bf74d58b74973e6b$var$R();
                null !== b && ($bf74d58b74973e6b$var$Ac(b, 1, a), $bf74d58b74973e6b$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $bf74d58b74973e6b$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $bf74d58b74973e6b$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $bf74d58b74973e6b$var$Q === a && ($bf74d58b74973e6b$var$Z & c) === c && (4 === $bf74d58b74973e6b$var$T || 3 === $bf74d58b74973e6b$var$T && ($bf74d58b74973e6b$var$Z & 130023424) === $bf74d58b74973e6b$var$Z && 500 > $bf74d58b74973e6b$var$B() - $bf74d58b74973e6b$var$fk ? $bf74d58b74973e6b$var$Kk(a, 0) : $bf74d58b74973e6b$var$rk |= c);
    $bf74d58b74973e6b$var$Dk(a, b);
}
function $bf74d58b74973e6b$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $bf74d58b74973e6b$var$sc, $bf74d58b74973e6b$var$sc <<= 1, 0 === ($bf74d58b74973e6b$var$sc & 130023424) && ($bf74d58b74973e6b$var$sc = 4194304)));
    var c = $bf74d58b74973e6b$var$R();
    a = $bf74d58b74973e6b$var$ih(a, b);
    null !== a && ($bf74d58b74973e6b$var$Ac(a, b, c), $bf74d58b74973e6b$var$Dk(a, c));
}
function $bf74d58b74973e6b$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $bf74d58b74973e6b$var$Yk(a, c);
}
function $bf74d58b74973e6b$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($bf74d58b74973e6b$var$p(314));
    }
    null !== d && d.delete(b);
    $bf74d58b74973e6b$var$Yk(a, c);
}
var $bf74d58b74973e6b$var$Vk;
$bf74d58b74973e6b$var$Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $bf74d58b74973e6b$var$Wf.current) $bf74d58b74973e6b$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $bf74d58b74973e6b$var$dh = !1, $bf74d58b74973e6b$var$yj(a, b, c);
            $bf74d58b74973e6b$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $bf74d58b74973e6b$var$dh = !1, $bf74d58b74973e6b$var$I && 0 !== (b.flags & 1048576) && $bf74d58b74973e6b$var$ug(b, $bf74d58b74973e6b$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $bf74d58b74973e6b$var$ij(a, b);
            a = b.pendingProps;
            var e = $bf74d58b74973e6b$var$Yf(b, $bf74d58b74973e6b$var$H.current);
            $bf74d58b74973e6b$var$ch(b, c);
            e = $bf74d58b74973e6b$var$Nh(null, b, d, a, e, c);
            var f = $bf74d58b74973e6b$var$Sh();
            b.flags |= 1;
            "object" === (typeof e === "undefined" ? "undefined" : (0, $5djcY._)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $bf74d58b74973e6b$var$Zf(d) ? (f = !0, $bf74d58b74973e6b$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $bf74d58b74973e6b$var$kh(b), e.updater = $bf74d58b74973e6b$var$Ei, b.stateNode = e, e._reactInternals = b, $bf74d58b74973e6b$var$Ii(b, d, a, c), b = $bf74d58b74973e6b$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $bf74d58b74973e6b$var$I && f && $bf74d58b74973e6b$var$vg(b), $bf74d58b74973e6b$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $bf74d58b74973e6b$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $bf74d58b74973e6b$var$Zk(d);
                a = $bf74d58b74973e6b$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $bf74d58b74973e6b$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $bf74d58b74973e6b$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $bf74d58b74973e6b$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $bf74d58b74973e6b$var$$i(null, b, d, $bf74d58b74973e6b$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($bf74d58b74973e6b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bf74d58b74973e6b$var$Ci(d, e), $bf74d58b74973e6b$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bf74d58b74973e6b$var$Ci(d, e), $bf74d58b74973e6b$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $bf74d58b74973e6b$var$kj(b);
                if (null === a) throw Error($bf74d58b74973e6b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $bf74d58b74973e6b$var$lh(a, b);
                $bf74d58b74973e6b$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $bf74d58b74973e6b$var$Ji(Error($bf74d58b74973e6b$var$p(423)), b);
                        b = $bf74d58b74973e6b$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $bf74d58b74973e6b$var$Ji(Error($bf74d58b74973e6b$var$p(424)), b);
                        b = $bf74d58b74973e6b$var$lj(a, b, d, c, e);
                        break a;
                    } else for($bf74d58b74973e6b$var$yg = $bf74d58b74973e6b$var$Lf(b.stateNode.containerInfo.firstChild), $bf74d58b74973e6b$var$xg = b, $bf74d58b74973e6b$var$I = !0, $bf74d58b74973e6b$var$zg = null, c = $bf74d58b74973e6b$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $bf74d58b74973e6b$var$Ig();
                    if (d === e) {
                        b = $bf74d58b74973e6b$var$Zi(a, b, c);
                        break a;
                    }
                    $bf74d58b74973e6b$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $bf74d58b74973e6b$var$Ah(b), null === a && $bf74d58b74973e6b$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $bf74d58b74973e6b$var$Ef(d, e) ? g = null : null !== f && $bf74d58b74973e6b$var$Ef(d, f) && (b.flags |= 32), $bf74d58b74973e6b$var$gj(a, b), $bf74d58b74973e6b$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $bf74d58b74973e6b$var$Eg(b), null;
        case 13:
            return $bf74d58b74973e6b$var$oj(a, b, c);
        case 4:
            return $bf74d58b74973e6b$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $bf74d58b74973e6b$var$Ug(b, null, d, c) : $bf74d58b74973e6b$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bf74d58b74973e6b$var$Ci(d, e), $bf74d58b74973e6b$var$Yi(a, b, d, e, c);
        case 7:
            return $bf74d58b74973e6b$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $bf74d58b74973e6b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $bf74d58b74973e6b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $bf74d58b74973e6b$var$G($bf74d58b74973e6b$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($bf74d58b74973e6b$var$He(f.value, g)) {
                        if (f.children === e.children && !$bf74d58b74973e6b$var$Wf.current) {
                            b = $bf74d58b74973e6b$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $bf74d58b74973e6b$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $bf74d58b74973e6b$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($bf74d58b74973e6b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $bf74d58b74973e6b$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $bf74d58b74973e6b$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $bf74d58b74973e6b$var$ch(b, c), e = $bf74d58b74973e6b$var$eh(e), d = d(e), b.flags |= 1, $bf74d58b74973e6b$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $bf74d58b74973e6b$var$Ci(d, b.pendingProps), e = $bf74d58b74973e6b$var$Ci(d.type, e), $bf74d58b74973e6b$var$$i(a, b, d, e, c);
        case 15:
            return $bf74d58b74973e6b$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bf74d58b74973e6b$var$Ci(d, e), $bf74d58b74973e6b$var$ij(a, b), b.tag = 1, $bf74d58b74973e6b$var$Zf(d) ? (a = !0, $bf74d58b74973e6b$var$cg(b)) : a = !1, $bf74d58b74973e6b$var$ch(b, c), $bf74d58b74973e6b$var$Gi(b, d, e), $bf74d58b74973e6b$var$Ii(b, d, e, c), $bf74d58b74973e6b$var$jj(null, b, d, !0, a, c);
        case 19:
            return $bf74d58b74973e6b$var$xj(a, b, c);
        case 22:
            return $bf74d58b74973e6b$var$dj(a, b, c);
    }
    throw Error($bf74d58b74973e6b$var$p(156, b.tag));
};
function $bf74d58b74973e6b$var$Fk(a, b) {
    return $bf74d58b74973e6b$var$ac(a, b);
}
function $bf74d58b74973e6b$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $bf74d58b74973e6b$var$Bg(a, b, c, d) {
    return new $bf74d58b74973e6b$var$$k(a, b, c, d);
}
function $bf74d58b74973e6b$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $bf74d58b74973e6b$var$Zk(a) {
    if ("function" === typeof a) return $bf74d58b74973e6b$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $bf74d58b74973e6b$var$Da) return 11;
        if (a === $bf74d58b74973e6b$var$Ga) return 14;
    }
    return 2;
}
function $bf74d58b74973e6b$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $bf74d58b74973e6b$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $bf74d58b74973e6b$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $bf74d58b74973e6b$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $bf74d58b74973e6b$var$ya:
            return $bf74d58b74973e6b$var$Tg(c.children, e, f, b);
        case $bf74d58b74973e6b$var$za:
            g = 8;
            e |= 8;
            break;
        case $bf74d58b74973e6b$var$Aa:
            return a = $bf74d58b74973e6b$var$Bg(12, c, b, e | 2), a.elementType = $bf74d58b74973e6b$var$Aa, a.lanes = f, a;
        case $bf74d58b74973e6b$var$Ea:
            return a = $bf74d58b74973e6b$var$Bg(13, c, b, e), a.elementType = $bf74d58b74973e6b$var$Ea, a.lanes = f, a;
        case $bf74d58b74973e6b$var$Fa:
            return a = $bf74d58b74973e6b$var$Bg(19, c, b, e), a.elementType = $bf74d58b74973e6b$var$Fa, a.lanes = f, a;
        case $bf74d58b74973e6b$var$Ia:
            return $bf74d58b74973e6b$var$pj(c, e, f, b);
        default:
            if ("object" === (typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) && null !== a) switch(a.$$typeof){
                case $bf74d58b74973e6b$var$Ba:
                    g = 10;
                    break a;
                case $bf74d58b74973e6b$var$Ca:
                    g = 9;
                    break a;
                case $bf74d58b74973e6b$var$Da:
                    g = 11;
                    break a;
                case $bf74d58b74973e6b$var$Ga:
                    g = 14;
                    break a;
                case $bf74d58b74973e6b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($bf74d58b74973e6b$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a), ""));
    }
    b = $bf74d58b74973e6b$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $bf74d58b74973e6b$var$Tg(a, b, c, d) {
    a = $bf74d58b74973e6b$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $bf74d58b74973e6b$var$pj(a, b, c, d) {
    a = $bf74d58b74973e6b$var$Bg(22, a, d, b);
    a.elementType = $bf74d58b74973e6b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $bf74d58b74973e6b$var$Qg(a, b, c) {
    a = $bf74d58b74973e6b$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $bf74d58b74973e6b$var$Sg(a, b, c) {
    b = $bf74d58b74973e6b$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $bf74d58b74973e6b$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $bf74d58b74973e6b$var$zc(0);
    this.expirationTimes = $bf74d58b74973e6b$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $bf74d58b74973e6b$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $bf74d58b74973e6b$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $bf74d58b74973e6b$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $bf74d58b74973e6b$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $bf74d58b74973e6b$var$kh(f);
    return a;
}
function $bf74d58b74973e6b$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $bf74d58b74973e6b$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $bf74d58b74973e6b$var$dl(a) {
    if (!a) return $bf74d58b74973e6b$var$Vf;
    a = a._reactInternals;
    a: {
        if ($bf74d58b74973e6b$var$Vb(a) !== a || 1 !== a.tag) throw Error($bf74d58b74973e6b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($bf74d58b74973e6b$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($bf74d58b74973e6b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($bf74d58b74973e6b$var$Zf(c)) return $bf74d58b74973e6b$var$bg(a, c, b);
    }
    return b;
}
function $bf74d58b74973e6b$var$el(a, b, c, d, e, f, g, h, k) {
    a = $bf74d58b74973e6b$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $bf74d58b74973e6b$var$dl(null);
    c = a.current;
    d = $bf74d58b74973e6b$var$R();
    e = $bf74d58b74973e6b$var$yi(c);
    f = $bf74d58b74973e6b$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $bf74d58b74973e6b$var$nh(c, f, e);
    a.current.lanes = e;
    $bf74d58b74973e6b$var$Ac(a, e, d);
    $bf74d58b74973e6b$var$Dk(a, d);
    return a;
}
function $bf74d58b74973e6b$var$fl(a, b, c, d) {
    var e = b.current, f = $bf74d58b74973e6b$var$R(), g = $bf74d58b74973e6b$var$yi(e);
    c = $bf74d58b74973e6b$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $bf74d58b74973e6b$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $bf74d58b74973e6b$var$nh(e, b, g);
    null !== a && ($bf74d58b74973e6b$var$gi(a, e, g, f), $bf74d58b74973e6b$var$oh(a, e, g));
    return g;
}
function $bf74d58b74973e6b$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $bf74d58b74973e6b$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $bf74d58b74973e6b$var$il(a, b) {
    $bf74d58b74973e6b$var$hl(a, b);
    (a = a.alternate) && $bf74d58b74973e6b$var$hl(a, b);
}
function $bf74d58b74973e6b$var$jl() {
    return null;
}
var $bf74d58b74973e6b$var$kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function $bf74d58b74973e6b$var$ll(a) {
    this._internalRoot = a;
}
$bf74d58b74973e6b$var$ml.prototype.render = $bf74d58b74973e6b$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($bf74d58b74973e6b$var$p(409));
    $bf74d58b74973e6b$var$fl(a, b, null, null);
};
$bf74d58b74973e6b$var$ml.prototype.unmount = $bf74d58b74973e6b$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $bf74d58b74973e6b$var$Rk(function() {
            $bf74d58b74973e6b$var$fl(null, a, null, null);
        });
        b[$bf74d58b74973e6b$var$uf] = null;
    }
};
function $bf74d58b74973e6b$var$ml(a) {
    this._internalRoot = a;
}
$bf74d58b74973e6b$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $bf74d58b74973e6b$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $bf74d58b74973e6b$var$Qc.length && 0 !== b && b < $bf74d58b74973e6b$var$Qc[c].priority; c++);
        $bf74d58b74973e6b$var$Qc.splice(c, 0, a);
        0 === c && $bf74d58b74973e6b$var$Vc(a);
    }
};
function $bf74d58b74973e6b$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $bf74d58b74973e6b$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $bf74d58b74973e6b$var$pl() {}
function $bf74d58b74973e6b$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $bf74d58b74973e6b$var$gl(g);
                f.call(_$a);
            };
        }
        var g = $bf74d58b74973e6b$var$el(b, d, a, 0, null, !1, !1, "", $bf74d58b74973e6b$var$pl);
        a._reactRootContainer = g;
        a[$bf74d58b74973e6b$var$uf] = g.current;
        $bf74d58b74973e6b$var$sf(8 === a.nodeType ? a.parentNode : a);
        $bf74d58b74973e6b$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $bf74d58b74973e6b$var$gl(k);
            h.call(_$a);
        };
    }
    var k = $bf74d58b74973e6b$var$bl(a, 0, !1, null, null, !1, !1, "", $bf74d58b74973e6b$var$pl);
    a._reactRootContainer = k;
    a[$bf74d58b74973e6b$var$uf] = k.current;
    $bf74d58b74973e6b$var$sf(8 === a.nodeType ? a.parentNode : a);
    $bf74d58b74973e6b$var$Rk(function() {
        $bf74d58b74973e6b$var$fl(b, k, c, d);
    });
    return k;
}
function $bf74d58b74973e6b$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $bf74d58b74973e6b$var$gl(g);
                h.call(_$a);
            };
        }
        $bf74d58b74973e6b$var$fl(b, g, a, e);
    } else g = $bf74d58b74973e6b$var$ql(c, b, a, e, d);
    return $bf74d58b74973e6b$var$gl(g);
}
$bf74d58b74973e6b$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $bf74d58b74973e6b$var$tc(b.pendingLanes);
                0 !== c && ($bf74d58b74973e6b$var$Cc(b, c | 1), $bf74d58b74973e6b$var$Dk(b, $bf74d58b74973e6b$var$B()), 0 === ($bf74d58b74973e6b$var$K & 6) && ($bf74d58b74973e6b$var$Gj = $bf74d58b74973e6b$var$B() + 500, $bf74d58b74973e6b$var$jg()));
            }
            break;
        case 13:
            $bf74d58b74973e6b$var$Rk(function() {
                var b = $bf74d58b74973e6b$var$ih(a, 1);
                if (null !== b) {
                    var c = $bf74d58b74973e6b$var$R();
                    $bf74d58b74973e6b$var$gi(b, a, 1, c);
                }
            }), $bf74d58b74973e6b$var$il(a, 1);
    }
};
$bf74d58b74973e6b$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $bf74d58b74973e6b$var$ih(a, 134217728);
        if (null !== b) {
            var c = $bf74d58b74973e6b$var$R();
            $bf74d58b74973e6b$var$gi(b, a, 134217728, c);
        }
        $bf74d58b74973e6b$var$il(a, 134217728);
    }
};
$bf74d58b74973e6b$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $bf74d58b74973e6b$var$yi(a), c = $bf74d58b74973e6b$var$ih(a, b);
        if (null !== c) {
            var d = $bf74d58b74973e6b$var$R();
            $bf74d58b74973e6b$var$gi(c, a, b, d);
        }
        $bf74d58b74973e6b$var$il(a, b);
    }
};
$bf74d58b74973e6b$var$Hc = function Hc() {
    return $bf74d58b74973e6b$var$C;
};
$bf74d58b74973e6b$var$Ic = function Ic(a, b) {
    var c = $bf74d58b74973e6b$var$C;
    try {
        return $bf74d58b74973e6b$var$C = a, b();
    } finally{
        $bf74d58b74973e6b$var$C = c;
    }
};
$bf74d58b74973e6b$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $bf74d58b74973e6b$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $bf74d58b74973e6b$var$Db(d);
                        if (!e) throw Error($bf74d58b74973e6b$var$p(90));
                        $bf74d58b74973e6b$var$Wa(d);
                        $bf74d58b74973e6b$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $bf74d58b74973e6b$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $bf74d58b74973e6b$var$fb(a, !!c.multiple, b, !1);
    }
};
$bf74d58b74973e6b$var$Gb = $bf74d58b74973e6b$var$Qk;
$bf74d58b74973e6b$var$Hb = $bf74d58b74973e6b$var$Rk;
var $bf74d58b74973e6b$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $bf74d58b74973e6b$var$Cb,
        $bf74d58b74973e6b$var$ue,
        $bf74d58b74973e6b$var$Db,
        $bf74d58b74973e6b$var$Eb,
        $bf74d58b74973e6b$var$Fb,
        $bf74d58b74973e6b$var$Qk
    ]
}, $bf74d58b74973e6b$var$tl = {
    findFiberByHostInstance: $bf74d58b74973e6b$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $bf74d58b74973e6b$var$ul = {
    bundleType: $bf74d58b74973e6b$var$tl.bundleType,
    version: $bf74d58b74973e6b$var$tl.version,
    rendererPackageName: $bf74d58b74973e6b$var$tl.rendererPackageName,
    rendererConfig: $bf74d58b74973e6b$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $bf74d58b74973e6b$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $bf74d58b74973e6b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $bf74d58b74973e6b$var$tl.findFiberByHostInstance || $bf74d58b74973e6b$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $bf74d58b74973e6b$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$bf74d58b74973e6b$var$vl.isDisabled && $bf74d58b74973e6b$var$vl.supportsFiber) try {
        $bf74d58b74973e6b$var$kc = $bf74d58b74973e6b$var$vl.inject($bf74d58b74973e6b$var$ul), $bf74d58b74973e6b$var$lc = $bf74d58b74973e6b$var$vl;
    } catch (a) {}
}
$bf74d58b74973e6b$export$ae55be85d98224ed = $bf74d58b74973e6b$var$sl;
$bf74d58b74973e6b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$bf74d58b74973e6b$var$nl(b)) throw Error($bf74d58b74973e6b$var$p(200));
    return $bf74d58b74973e6b$var$cl(a, b, null, c);
};
$bf74d58b74973e6b$export$882461b6382ed46c = function(a, b) {
    if (!$bf74d58b74973e6b$var$nl(a)) throw Error($bf74d58b74973e6b$var$p(299));
    var c = !1, d = "", e = $bf74d58b74973e6b$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $bf74d58b74973e6b$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$bf74d58b74973e6b$var$uf] = b.current;
    $bf74d58b74973e6b$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $bf74d58b74973e6b$var$ll(b);
};
$bf74d58b74973e6b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($bf74d58b74973e6b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($bf74d58b74973e6b$var$p(268, a));
    }
    a = $bf74d58b74973e6b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$bf74d58b74973e6b$export$cd75ccfd720a3cd4 = function(a) {
    return $bf74d58b74973e6b$var$Rk(a);
};
$bf74d58b74973e6b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$bf74d58b74973e6b$var$ol(b)) throw Error($bf74d58b74973e6b$var$p(200));
    return $bf74d58b74973e6b$var$rl(null, a, b, !0, c);
};
$bf74d58b74973e6b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$bf74d58b74973e6b$var$nl(a)) throw Error($bf74d58b74973e6b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $bf74d58b74973e6b$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $bf74d58b74973e6b$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$bf74d58b74973e6b$var$uf] = b.current;
    $bf74d58b74973e6b$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $bf74d58b74973e6b$var$ml(b);
};
$bf74d58b74973e6b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$bf74d58b74973e6b$var$ol(b)) throw Error($bf74d58b74973e6b$var$p(200));
    return $bf74d58b74973e6b$var$rl(null, a, b, !1, c);
};
$bf74d58b74973e6b$export$502457920280e6be = function(a) {
    if (!$bf74d58b74973e6b$var$ol(a)) throw Error($bf74d58b74973e6b$var$p(40));
    return a._reactRootContainer ? ($bf74d58b74973e6b$var$Rk(function() {
        $bf74d58b74973e6b$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$bf74d58b74973e6b$var$uf] = null;
        });
    }), !0) : !1;
};
$bf74d58b74973e6b$export$c78a37762a8d58e1 = $bf74d58b74973e6b$var$Qk;
$bf74d58b74973e6b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$bf74d58b74973e6b$var$ol(c)) throw Error($bf74d58b74973e6b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($bf74d58b74973e6b$var$p(38));
    return $bf74d58b74973e6b$var$rl(a, b, c, !1, d);
};
$bf74d58b74973e6b$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("ojHeY", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5wZqJ"));

});
parcelRegister("5wZqJ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $406f97a93edc2f95$export$c4744153514ff05d; }, function (v) { return $406f97a93edc2f95$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $406f97a93edc2f95$export$3e506c1ccc9cc1a7; }, function (v) { return $406f97a93edc2f95$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $406f97a93edc2f95$export$e26fe2ed2fa76875; }, function (v) { return $406f97a93edc2f95$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $406f97a93edc2f95$export$502329bbf4b505b1; }, function (v) { return $406f97a93edc2f95$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $406f97a93edc2f95$export$6e3807111c4874c4; }, function (v) { return $406f97a93edc2f95$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $406f97a93edc2f95$export$c27134553091fb3a; }, function (v) { return $406f97a93edc2f95$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $406f97a93edc2f95$export$33ee1acdc04fd2a2; }, function (v) { return $406f97a93edc2f95$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $406f97a93edc2f95$export$b00a404bbd5edef2; }, function (v) { return $406f97a93edc2f95$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $406f97a93edc2f95$export$8352ce38b91d0c62; }, function (v) { return $406f97a93edc2f95$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $406f97a93edc2f95$export$d66a1c1c77bd778b; }, function (v) { return $406f97a93edc2f95$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $406f97a93edc2f95$export$d3dfb8e4810cb555; }, function (v) { return $406f97a93edc2f95$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $406f97a93edc2f95$export$839f9183b0465a69; }, function (v) { return $406f97a93edc2f95$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $406f97a93edc2f95$export$72fdf0e06517287b; }, function (v) { return $406f97a93edc2f95$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $406f97a93edc2f95$export$4b844e58a3e414b4; }, function (v) { return $406f97a93edc2f95$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $406f97a93edc2f95$export$816d2913ae6b83b1; }, function (v) { return $406f97a93edc2f95$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $406f97a93edc2f95$export$61bcfe829111a1d0; }, function (v) { return $406f97a93edc2f95$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $406f97a93edc2f95$export$7ee8c9beb337bc3f; }, function (v) { return $406f97a93edc2f95$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $406f97a93edc2f95$export$b5836b71941fa3ed; }, function (v) { return $406f97a93edc2f95$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $406f97a93edc2f95$export$cf845f2c119da08a; }, function (v) { return $406f97a93edc2f95$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5djcY = parcelRequire("5djcY");
var $406f97a93edc2f95$export$c4744153514ff05d;
var $406f97a93edc2f95$export$3e506c1ccc9cc1a7;
var $406f97a93edc2f95$export$e26fe2ed2fa76875;
var $406f97a93edc2f95$export$502329bbf4b505b1;
var $406f97a93edc2f95$export$6e3807111c4874c4;
var $406f97a93edc2f95$export$c27134553091fb3a;
var $406f97a93edc2f95$export$33ee1acdc04fd2a2;
var $406f97a93edc2f95$export$b00a404bbd5edef2;
var $406f97a93edc2f95$export$8352ce38b91d0c62;
var $406f97a93edc2f95$export$d66a1c1c77bd778b;
var $406f97a93edc2f95$export$d3dfb8e4810cb555;
var $406f97a93edc2f95$export$839f9183b0465a69;
var $406f97a93edc2f95$export$72fdf0e06517287b;
var $406f97a93edc2f95$export$4b844e58a3e414b4;
var $406f97a93edc2f95$export$816d2913ae6b83b1;
var $406f97a93edc2f95$export$61bcfe829111a1d0;
var $406f97a93edc2f95$export$7ee8c9beb337bc3f;
var $406f97a93edc2f95$export$b5836b71941fa3ed;
var $406f97a93edc2f95$export$cf845f2c119da08a;
'use strict';
function $406f97a93edc2f95$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $406f97a93edc2f95$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $406f97a93edc2f95$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $406f97a93edc2f95$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $406f97a93edc2f95$var$g(C, c)) n < e && 0 > $406f97a93edc2f95$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $406f97a93edc2f95$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $406f97a93edc2f95$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $5djcY._)(performance)) && "function" === typeof performance.now) {
    var $406f97a93edc2f95$var$l = performance;
    $406f97a93edc2f95$export$c4744153514ff05d = function() {
        return $406f97a93edc2f95$var$l.now();
    };
} else {
    var $406f97a93edc2f95$var$p = Date, $406f97a93edc2f95$var$q = $406f97a93edc2f95$var$p.now();
    $406f97a93edc2f95$export$c4744153514ff05d = function() {
        return $406f97a93edc2f95$var$p.now() - $406f97a93edc2f95$var$q;
    };
}
var $406f97a93edc2f95$var$r = [], $406f97a93edc2f95$var$t = [], $406f97a93edc2f95$var$u = 1, $406f97a93edc2f95$var$v = null, $406f97a93edc2f95$var$y = 3, $406f97a93edc2f95$var$z = !1, $406f97a93edc2f95$var$A = !1, $406f97a93edc2f95$var$B = !1, $406f97a93edc2f95$var$D = "function" === typeof setTimeout ? setTimeout : null, $406f97a93edc2f95$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $406f97a93edc2f95$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $406f97a93edc2f95$var$G(a) {
    for(var b = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t); null !== b;){
        if (null === b.callback) $406f97a93edc2f95$var$k($406f97a93edc2f95$var$t);
        else if (b.startTime <= a) $406f97a93edc2f95$var$k($406f97a93edc2f95$var$t), b.sortIndex = b.expirationTime, $406f97a93edc2f95$var$f($406f97a93edc2f95$var$r, b);
        else break;
        b = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t);
    }
}
function $406f97a93edc2f95$var$H(a) {
    $406f97a93edc2f95$var$B = !1;
    $406f97a93edc2f95$var$G(a);
    if (!$406f97a93edc2f95$var$A) {
        if (null !== $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r)) $406f97a93edc2f95$var$A = !0, $406f97a93edc2f95$var$I($406f97a93edc2f95$var$J);
        else {
            var b = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t);
            null !== b && $406f97a93edc2f95$var$K($406f97a93edc2f95$var$H, b.startTime - a);
        }
    }
}
function $406f97a93edc2f95$var$J(a, b) {
    $406f97a93edc2f95$var$A = !1;
    $406f97a93edc2f95$var$B && ($406f97a93edc2f95$var$B = !1, $406f97a93edc2f95$var$E($406f97a93edc2f95$var$L), $406f97a93edc2f95$var$L = -1);
    $406f97a93edc2f95$var$z = !0;
    var c = $406f97a93edc2f95$var$y;
    try {
        $406f97a93edc2f95$var$G(b);
        for($406f97a93edc2f95$var$v = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r); null !== $406f97a93edc2f95$var$v && (!($406f97a93edc2f95$var$v.expirationTime > b) || a && !$406f97a93edc2f95$var$M());){
            var d = $406f97a93edc2f95$var$v.callback;
            if ("function" === typeof d) {
                $406f97a93edc2f95$var$v.callback = null;
                $406f97a93edc2f95$var$y = $406f97a93edc2f95$var$v.priorityLevel;
                var e = d($406f97a93edc2f95$var$v.expirationTime <= b);
                b = $406f97a93edc2f95$export$c4744153514ff05d();
                "function" === typeof e ? $406f97a93edc2f95$var$v.callback = e : $406f97a93edc2f95$var$v === $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r) && $406f97a93edc2f95$var$k($406f97a93edc2f95$var$r);
                $406f97a93edc2f95$var$G(b);
            } else $406f97a93edc2f95$var$k($406f97a93edc2f95$var$r);
            $406f97a93edc2f95$var$v = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r);
        }
        if (null !== $406f97a93edc2f95$var$v) var w = !0;
        else {
            var m = $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t);
            null !== m && $406f97a93edc2f95$var$K($406f97a93edc2f95$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $406f97a93edc2f95$var$v = null, $406f97a93edc2f95$var$y = c, $406f97a93edc2f95$var$z = !1;
    }
}
var $406f97a93edc2f95$var$N = !1, $406f97a93edc2f95$var$O = null, $406f97a93edc2f95$var$L = -1, $406f97a93edc2f95$var$P = 5, $406f97a93edc2f95$var$Q = -1;
function $406f97a93edc2f95$var$M() {
    return $406f97a93edc2f95$export$c4744153514ff05d() - $406f97a93edc2f95$var$Q < $406f97a93edc2f95$var$P ? !1 : !0;
}
function $406f97a93edc2f95$var$R() {
    if (null !== $406f97a93edc2f95$var$O) {
        var a = $406f97a93edc2f95$export$c4744153514ff05d();
        $406f97a93edc2f95$var$Q = a;
        var b = !0;
        try {
            b = $406f97a93edc2f95$var$O(!0, a);
        } finally{
            b ? $406f97a93edc2f95$var$S() : ($406f97a93edc2f95$var$N = !1, $406f97a93edc2f95$var$O = null);
        }
    } else $406f97a93edc2f95$var$N = !1;
}
var $406f97a93edc2f95$var$S;
if ("function" === typeof $406f97a93edc2f95$var$F) $406f97a93edc2f95$var$S = function S() {
    $406f97a93edc2f95$var$F($406f97a93edc2f95$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $406f97a93edc2f95$var$T = new MessageChannel, $406f97a93edc2f95$var$U = $406f97a93edc2f95$var$T.port2;
    $406f97a93edc2f95$var$T.port1.onmessage = $406f97a93edc2f95$var$R;
    $406f97a93edc2f95$var$S = function S() {
        $406f97a93edc2f95$var$U.postMessage(null);
    };
} else $406f97a93edc2f95$var$S = function S() {
    $406f97a93edc2f95$var$D($406f97a93edc2f95$var$R, 0);
};
function $406f97a93edc2f95$var$I(a) {
    $406f97a93edc2f95$var$O = a;
    $406f97a93edc2f95$var$N || ($406f97a93edc2f95$var$N = !0, $406f97a93edc2f95$var$S());
}
function $406f97a93edc2f95$var$K(a, b) {
    $406f97a93edc2f95$var$L = $406f97a93edc2f95$var$D(function() {
        a($406f97a93edc2f95$export$c4744153514ff05d());
    }, b);
}
$406f97a93edc2f95$export$3e506c1ccc9cc1a7 = 5;
$406f97a93edc2f95$export$e26fe2ed2fa76875 = 1;
$406f97a93edc2f95$export$502329bbf4b505b1 = 4;
$406f97a93edc2f95$export$6e3807111c4874c4 = 3;
$406f97a93edc2f95$export$c27134553091fb3a = null;
$406f97a93edc2f95$export$33ee1acdc04fd2a2 = 2;
$406f97a93edc2f95$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$406f97a93edc2f95$export$8352ce38b91d0c62 = function() {
    $406f97a93edc2f95$var$A || $406f97a93edc2f95$var$z || ($406f97a93edc2f95$var$A = !0, $406f97a93edc2f95$var$I($406f97a93edc2f95$var$J));
};
$406f97a93edc2f95$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $406f97a93edc2f95$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$406f97a93edc2f95$export$d3dfb8e4810cb555 = function() {
    return $406f97a93edc2f95$var$y;
};
$406f97a93edc2f95$export$839f9183b0465a69 = function() {
    return $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r);
};
$406f97a93edc2f95$export$72fdf0e06517287b = function(a) {
    switch($406f97a93edc2f95$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $406f97a93edc2f95$var$y;
    }
    var c = $406f97a93edc2f95$var$y;
    $406f97a93edc2f95$var$y = b;
    try {
        return a();
    } finally{
        $406f97a93edc2f95$var$y = c;
    }
};
$406f97a93edc2f95$export$4b844e58a3e414b4 = function() {};
$406f97a93edc2f95$export$816d2913ae6b83b1 = function() {};
$406f97a93edc2f95$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $406f97a93edc2f95$var$y;
    $406f97a93edc2f95$var$y = a;
    try {
        return b();
    } finally{
        $406f97a93edc2f95$var$y = c;
    }
};
$406f97a93edc2f95$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $406f97a93edc2f95$export$c4744153514ff05d();
    "object" === (typeof c === "undefined" ? "undefined" : (0, $5djcY._)(c)) && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $406f97a93edc2f95$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $406f97a93edc2f95$var$f($406f97a93edc2f95$var$t, a), null === $406f97a93edc2f95$var$h($406f97a93edc2f95$var$r) && a === $406f97a93edc2f95$var$h($406f97a93edc2f95$var$t) && ($406f97a93edc2f95$var$B ? ($406f97a93edc2f95$var$E($406f97a93edc2f95$var$L), $406f97a93edc2f95$var$L = -1) : $406f97a93edc2f95$var$B = !0, $406f97a93edc2f95$var$K($406f97a93edc2f95$var$H, c - d))) : (a.sortIndex = e, $406f97a93edc2f95$var$f($406f97a93edc2f95$var$r, a), $406f97a93edc2f95$var$A || $406f97a93edc2f95$var$z || ($406f97a93edc2f95$var$A = !0, $406f97a93edc2f95$var$I($406f97a93edc2f95$var$J)));
    return a;
};
$406f97a93edc2f95$export$b5836b71941fa3ed = $406f97a93edc2f95$var$M;
$406f97a93edc2f95$export$cf845f2c119da08a = function(a) {
    var b = $406f97a93edc2f95$var$y;
    return function() {
        var c = $406f97a93edc2f95$var$y;
        $406f97a93edc2f95$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $406f97a93edc2f95$var$y = c;
        }
    };
};

});





parcelRegister("kWfK0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f3e56f3eac89eefa$export$71511d61b312f219; });

var $6tY97 = parcelRequire("6tY97");
function $f3e56f3eac89eefa$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $6tY97._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("6tY97", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4b841b45c75a3225$export$71511d61b312f219; });
function $4b841b45c75a3225$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hApvp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ccd99553ef7f1c61$export$71511d61b312f219; });
function $ccd99553ef7f1c61$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ccd99553ef7f1c61$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $ccd99553ef7f1c61$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("6ZpBv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $516c4cfaa4b34746$export$71511d61b312f219; });

var $ceUCx = parcelRequire("ceUCx");

var $e1lIn = parcelRequire("e1lIn");

var $OKxK3 = parcelRequire("OKxK3");

var $J66Jb = parcelRequire("J66Jb");
function $516c4cfaa4b34746$export$71511d61b312f219(arr, i) {
    return (0, $ceUCx._)(arr) || (0, $e1lIn._)(arr, i) || (0, $J66Jb._)(arr, i) || (0, $OKxK3._)();
}

});
parcelRegister("ceUCx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8e92b680619f4fa4$export$71511d61b312f219; });
function $8e92b680619f4fa4$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("e1lIn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a35200cd1f91429a$export$71511d61b312f219; });
function $a35200cd1f91429a$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("OKxK3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0988c6241722d902$export$71511d61b312f219; });
function $0988c6241722d902$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("J66Jb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0878f0e8b254b036$export$71511d61b312f219; });

var $2PuG4 = parcelRequire("2PuG4");
function $0878f0e8b254b036$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2PuG4._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2PuG4._)(o, minLen);
}

});
parcelRegister("2PuG4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $20f8241f6119e7d1$export$71511d61b312f219; });
function $20f8241f6119e7d1$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("lYyrX", function(module, exports) {

$parcel$export(module.exports, "CountdownButton", function () { return $8e65ca618ab5c5e9$export$9102eb354f72d4f2; });
$parcel$export(module.exports, "default", function () { return $8e65ca618ab5c5e9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "LoadingButton", function () { return $8e65ca618ab5c5e9$export$4ec83e90d030b2f3; });
$parcel$export(module.exports, "PrimaryButton", function () { return $8e65ca618ab5c5e9$export$ac16a6a04d9b7c84; });
$parcel$export(module.exports, "TertiaryButton", function () { return $8e65ca618ab5c5e9$export$3a30621a8b0c1490; });
$parcel$export(module.exports, "DangerButton", function () { return $8e65ca618ab5c5e9$export$3b92dabad355f5d4; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $6ZpBv = parcelRequire("6ZpBv");

var $9HB6H = parcelRequire("9HB6H");

var $iD6kw = parcelRequire("iD6kw");
function $8e65ca618ab5c5e9$export$9102eb354f72d4f2(props) {
    var durationInMilliseconds = props.duration * 1000; // Convert seconds to milliseconds
    var interval = 50; // Update every 50ms
    var _useState = (0, $6ZpBv._)((0, $iD6kw.useState)(durationInMilliseconds), 2), remainingTime = _useState[0], setRemainingTime = _useState[1];
    var degree = Math.round(360 / durationInMilliseconds * remainingTime);
    var remainingTimeInSeconds = Math.ceil(remainingTime / 1000);
    var progressStyle = {
        '--progress': "".concat(degree, "deg")
    };
    (0, $iD6kw.useEffect)(function() {
        var timer;
        if (remainingTime > 0) timer = setInterval(function() {
            setRemainingTime(function(prevTime) {
                if (prevTime <= 0) {
                    clearInterval(timer);
                    return 0;
                }
                return prevTime - interval;
            });
        }, interval);
        return function() {
            return clearInterval(timer);
        };
    }, []);
    (0, $iD6kw.useEffect)(function() {
        var _props_onClick;
        if (remainingTime <= 0) (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props);
    }, [
        remainingTime
    ]);
    var onCountdownButtonClick = function() {
        return setRemainingTime(0);
    };
    return remainingTime > 0 ? /*#__PURE__*/ (0, $9HB6H.jsxs)($8e65ca618ab5c5e9$export$2e2bcd8739ae039, (0, $hApvp._)((0, $kWfK0._)({}, props), {
        hasCountdown: true,
        onClick: onCountdownButtonClick,
        children: [
            props.children,
            /*#__PURE__*/ (0, $9HB6H.jsxs)("span", {
                style: progressStyle,
                children: [
                    remainingTimeInSeconds,
                    "s"
                ]
            })
        ]
    })) : /*#__PURE__*/ (0, $9HB6H.jsx)($8e65ca618ab5c5e9$export$4ec83e90d030b2f3, (0, $hApvp._)((0, $kWfK0._)({}, props), {
        loading: true
    }));
}
function $8e65ca618ab5c5e9$export$4ec83e90d030b2f3(props) {
    return /*#__PURE__*/ (0, $9HB6H.jsx)($8e65ca618ab5c5e9$export$2e2bcd8739ae039, (0, $hApvp._)((0, $kWfK0._)({}, props), {
        hasLoader: true
    }));
}
function $8e65ca618ab5c5e9$export$ac16a6a04d9b7c84(props) {
    return /*#__PURE__*/ (0, $9HB6H.jsx)($8e65ca618ab5c5e9$export$2e2bcd8739ae039, (0, $hApvp._)((0, $kWfK0._)({}, props), {
        primary: true
    }));
}
function $8e65ca618ab5c5e9$export$3a30621a8b0c1490(props) {
    return /*#__PURE__*/ (0, $9HB6H.jsx)($8e65ca618ab5c5e9$export$2e2bcd8739ae039, (0, $hApvp._)((0, $kWfK0._)({}, props), {
        tertiary: true
    }));
}
function $8e65ca618ab5c5e9$export$3b92dabad355f5d4(props) {
    return /*#__PURE__*/ (0, $9HB6H.jsx)($8e65ca618ab5c5e9$export$2e2bcd8739ae039, (0, $hApvp._)((0, $kWfK0._)({}, props), {
        danger: true
    }));
}
function $8e65ca618ab5c5e9$export$2e2bcd8739ae039(param) {
    var _param_blank = param.blank, blank = _param_blank === void 0 ? false : _param_blank, children = param.children, _param_danger = param.danger, danger = _param_danger === void 0 ? false : _param_danger, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_hasCountdown = param.hasCountdown, hasCountdown = _param_hasCountdown === void 0 ? false : _param_hasCountdown, _param_hasLoader = param.hasLoader, hasLoader = _param_hasLoader === void 0 ? false : _param_hasLoader, _param_href = param.href, href = _param_href === void 0 ? '' : _param_href, _param_id = param.id, id = _param_id === void 0 ? '' : _param_id, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {} : _param_onClick, _param_primary = param.primary, primary = _param_primary === void 0 ? false : _param_primary, _param_specifier = param.specifier, specifier = _param_specifier === void 0 ? '' : _param_specifier, _param_sso = param.sso, sso = _param_sso === void 0 ? false : _param_sso, _param_ssoId = param.ssoId, ssoId = _param_ssoId === void 0 ? '' : _param_ssoId, _param_tertiary = param.tertiary, tertiary = _param_tertiary === void 0 ? false : _param_tertiary, _param_testId = param.testId, testId = _param_testId === void 0 ? '' : _param_testId, _param_type = param.type, type = _param_type === void 0 ? 'button' : _param_type;
    var props = {
        disabled: disabled
    };
    var classes = [
        'btn'
    ];
    if (primary) classes.push('btn--primary');
    if (tertiary) classes.push('btn--tertiary');
    if (danger) classes.push('btn--danger');
    if (specifier) classes.push("btn--".concat(specifier));
    if (hasCountdown) classes.push('btn--countdown');
    if (hasLoader) classes.push('btn--loader');
    if (loading) classes.push('btn--loading');
    // Handle SSO-specific classes
    if (sso) {
        classes.push('btn--sso');
        if (ssoId) classes.push("btn--sso--".concat(ssoId));
    }
    var elementProps = (0, $kWfK0._)((0, $hApvp._)((0, $kWfK0._)({}, props), {
        className: classes.join(' ')
    }), id ? {
        id: id
    } : {}, testId ? {
        'data-testid': testId
    } : {});
    if (href) return /*#__PURE__*/ (0, $9HB6H.jsx)("a", (0, $hApvp._)((0, $kWfK0._)((0, $hApvp._)((0, $kWfK0._)({}, elementProps), {
        href: href
    }), blank ? {
        target: '_blank',
        rel: 'noopener noreferrer'
    } : {}), {
        children: hasLoader ? /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
            children: children
        }) : children
    }));
    else return /*#__PURE__*/ (0, $9HB6H.jsx)("button", (0, $hApvp._)((0, $kWfK0._)({}, elementProps), {
        type: type,
        onClick: onClick,
        children: hasLoader ? /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
            children: children
        }) : children
    }));
}

});

parcelRegister("dxEC4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9dbddc5847e39269$export$71511d61b312f219; });
function $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9dbddc5847e39269$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("gh3Df", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bd910d1ee9896911$export$71511d61b312f219; });
function $bd910d1ee9896911$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});

parcelRegister("7w4mz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("iit9R")).default; });

var $iit9R = parcelRequire("iit9R");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
var $578ee7fc346fcfbe$export$1c00760e9e5a4e95 = (0, $iit9R.default).Axios, $578ee7fc346fcfbe$export$c1fbed17c2f6a328 = (0, $iit9R.default).AxiosError, $578ee7fc346fcfbe$export$1ab0c6b20d94fa14 = (0, $iit9R.default).CanceledError, $578ee7fc346fcfbe$export$3b22524397b493c6 = (0, $iit9R.default).isCancel, $578ee7fc346fcfbe$export$fd08e3cb425f0d61 = (0, $iit9R.default).CancelToken, $578ee7fc346fcfbe$export$a4ad2735b021c132 = (0, $iit9R.default).VERSION, $578ee7fc346fcfbe$export$84bf76cd7afc7469 = (0, $iit9R.default).all, $578ee7fc346fcfbe$export$848c9b7ead0df967 = (0, $iit9R.default).Cancel, $578ee7fc346fcfbe$export$fbafdbe06a5b5a9a = (0, $iit9R.default).isAxiosError, $578ee7fc346fcfbe$export$3ae0fd4797ed47c8 = (0, $iit9R.default).spread, $578ee7fc346fcfbe$export$10ae0d317ea97f8b = (0, $iit9R.default).toFormData, $578ee7fc346fcfbe$export$4e7d6ff0f3e6520 = (0, $iit9R.default).AxiosHeaders, $578ee7fc346fcfbe$export$a972f69c851492b3 = (0, $iit9R.default).HttpStatusCode, $578ee7fc346fcfbe$export$86d7c59254d6a2c9 = (0, $iit9R.default).formToJSON, $578ee7fc346fcfbe$export$17ddc20a97d669e2 = (0, $iit9R.default).getAdapter, $578ee7fc346fcfbe$export$7ec1ebcfa9d8bd6a = (0, $iit9R.default).mergeConfig, $578ee7fc346fcfbe$export$185802fd694ee1f5 = (0, $iit9R.default).create;

});
parcelRegister("iit9R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d520869c18a43ed2$export$2e2bcd8739ae039; });

var $bOBNq = parcelRequire("bOBNq");

var $2Xvug = parcelRequire("2Xvug");

var $lAX1b = parcelRequire("lAX1b");

var $3SOIK = parcelRequire("3SOIK");

var $bF7tY = parcelRequire("bF7tY");

var $vFFoL = parcelRequire("vFFoL");

var $a6CVI = parcelRequire("a6CVI");

var $6eLzy = parcelRequire("6eLzy");

var $7CoXk = parcelRequire("7CoXk");

var $bMHPm = parcelRequire("bMHPm");

var $8S0fp = parcelRequire("8S0fp");

var $3B0hl = parcelRequire("3B0hl");

var $6lGMv = parcelRequire("6lGMv");

var $jvd11 = parcelRequire("jvd11");

var $dgBgw = parcelRequire("dgBgw");

var $hJdf9 = parcelRequire("hJdf9");

var $bSaYg = parcelRequire("bSaYg");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $d520869c18a43ed2$var$createInstance(defaultConfig) {
    var context = new (0, $lAX1b.default)(defaultConfig);
    var instance = (0, $2Xvug.default)((0, $lAX1b.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $bOBNq.default).extend(instance, (0, $lAX1b.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $bOBNq.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $d520869c18a43ed2$var$createInstance((0, $3SOIK.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $d520869c18a43ed2$var$axios = $d520869c18a43ed2$var$createInstance((0, $bF7tY.default));
// Expose Axios class to allow class inheritance
$d520869c18a43ed2$var$axios.Axios = (0, $lAX1b.default);
// Expose Cancel & CancelToken
$d520869c18a43ed2$var$axios.CanceledError = (0, $a6CVI.default);
$d520869c18a43ed2$var$axios.CancelToken = (0, $6eLzy.default);
$d520869c18a43ed2$var$axios.isCancel = (0, $7CoXk.default);
$d520869c18a43ed2$var$axios.VERSION = (0, $bMHPm.VERSION);
$d520869c18a43ed2$var$axios.toFormData = (0, $8S0fp.default);
// Expose AxiosError class
$d520869c18a43ed2$var$axios.AxiosError = (0, $3B0hl.default);
// alias for CanceledError for backward compatibility
$d520869c18a43ed2$var$axios.Cancel = $d520869c18a43ed2$var$axios.CanceledError;
// Expose all/spread
$d520869c18a43ed2$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$d520869c18a43ed2$var$axios.spread = (0, $6lGMv.default);
// Expose isAxiosError
$d520869c18a43ed2$var$axios.isAxiosError = (0, $jvd11.default);
// Expose mergeConfig
$d520869c18a43ed2$var$axios.mergeConfig = (0, $3SOIK.default);
$d520869c18a43ed2$var$axios.AxiosHeaders = (0, $dgBgw.default);
$d520869c18a43ed2$var$axios.formToJSON = function(thing) {
    return (0, $vFFoL.default)((0, $bOBNq.default).isHTMLForm(thing) ? new FormData(thing) : thing);
};
$d520869c18a43ed2$var$axios.getAdapter = (0, $hJdf9.default).getAdapter;
$d520869c18a43ed2$var$axios.HttpStatusCode = (0, $bSaYg.default);
$d520869c18a43ed2$var$axios.default = $d520869c18a43ed2$var$axios;
var // this module should only have a default export
$d520869c18a43ed2$export$2e2bcd8739ae039 = $d520869c18a43ed2$var$axios;

});
parcelRegister("bOBNq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89a1aebdecfcf41b$export$2e2bcd8739ae039; });

var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $5djcY = parcelRequire("5djcY");

var $2Xvug = parcelRequire("2Xvug");
'use strict';
// utils is a library of generic helper functions non-specific to axios
var $89a1aebdecfcf41b$var$toString = Object.prototype.toString;
var $89a1aebdecfcf41b$var$getPrototypeOf = Object.getPrototypeOf;
var $89a1aebdecfcf41b$var$iterator = Symbol.iterator, $89a1aebdecfcf41b$var$toStringTag = Symbol.toStringTag;
/* Creating a function that will check if an object has a property. */ var $89a1aebdecfcf41b$var$hasOwnProperty = function(param) {
    var hasOwnProperty = param.hasOwnProperty;
    return function(obj, prop) {
        return hasOwnProperty.call(obj, prop);
    };
}(Object.prototype);
var $89a1aebdecfcf41b$var$isUnsafeObjectKey = function(prop) {
    return typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
};
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ var $89a1aebdecfcf41b$var$isPrototypeBoundary = function(obj, prototype, source) {
    return obj === Object.prototype || !source && prototype === null;
};
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ var $89a1aebdecfcf41b$var$isSafeAndFullyMutable = function(obj) {
    var _props;
    if (!Object.isExtensible(obj)) return false;
    var props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) (_props = props).push.apply(_props, (0, $jlUaU._)(Object.getOwnPropertySymbols(obj)));
    return props.every(function(prop) {
        if ($89a1aebdecfcf41b$var$isUnsafeObjectKey(prop)) return false;
        var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ var $89a1aebdecfcf41b$var$hasOwnInPrototypeChain = function(thing, prop) {
    var obj = thing;
    var seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        var prototype = $89a1aebdecfcf41b$var$getPrototypeOf(obj);
        if ($89a1aebdecfcf41b$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($89a1aebdecfcf41b$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ var $89a1aebdecfcf41b$var$getSafeProp = function(obj, prop) {
    return obj != null && $89a1aebdecfcf41b$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
};
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ var $89a1aebdecfcf41b$var$toSafeFlatObject = function(thing) {
    if (thing == null || (typeof thing === "undefined" ? "undefined" : (0, $5djcY._)(thing)) !== 'object' && typeof thing !== 'function') return thing;
    var sourcePrototype = $89a1aebdecfcf41b$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $89a1aebdecfcf41b$var$isSafeAndFullyMutable(thing)) return thing;
    var result = Object.create(null);
    var merged = Object.create(null);
    var seen = [];
    var current = thing;
    while(current != null){
        var _props;
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        var prototype = current === thing ? sourcePrototype : $89a1aebdecfcf41b$var$getPrototypeOf(current);
        if ($89a1aebdecfcf41b$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        var props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) (_props = props).push.apply(_props, (0, $jlUaU._)(Object.getOwnPropertySymbols(current)));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = props[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var prop = _step.value;
                if ($89a1aebdecfcf41b$var$isUnsafeObjectKey(prop)) continue;
                if (!$89a1aebdecfcf41b$var$hasOwnProperty(merged, prop)) {
                    result[prop] = thing[prop];
                    merged[prop] = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        current = prototype;
    }
    return result;
};
var $89a1aebdecfcf41b$var$kindOf = function(cache) {
    return function(thing) {
        var str = $89a1aebdecfcf41b$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
var $89a1aebdecfcf41b$var$kindOfTest = function(type) {
    type = type.toLowerCase();
    return function(thing) {
        return $89a1aebdecfcf41b$var$kindOf(thing) === type;
    };
};
var $89a1aebdecfcf41b$var$typeOfTest = function(type) {
    return function(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $5djcY._)(thing)) === type;
    };
};
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ var $89a1aebdecfcf41b$var$isArray = Array.isArray;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ var $89a1aebdecfcf41b$var$isUndefined = $89a1aebdecfcf41b$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $89a1aebdecfcf41b$var$isBuffer(val) {
    return val !== null && !$89a1aebdecfcf41b$var$isUndefined(val) && val.constructor !== null && !$89a1aebdecfcf41b$var$isUndefined(val.constructor) && $89a1aebdecfcf41b$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $89a1aebdecfcf41b$var$isArrayBuffer = $89a1aebdecfcf41b$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $89a1aebdecfcf41b$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $89a1aebdecfcf41b$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ var $89a1aebdecfcf41b$var$isString = $89a1aebdecfcf41b$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ var $89a1aebdecfcf41b$var$isFunction = $89a1aebdecfcf41b$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ var $89a1aebdecfcf41b$var$isNumber = $89a1aebdecfcf41b$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ var $89a1aebdecfcf41b$var$isObject = function(thing) {
    return thing !== null && (typeof thing === "undefined" ? "undefined" : (0, $5djcY._)(thing)) === 'object';
};
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ var $89a1aebdecfcf41b$var$isBoolean = function(thing) {
    return thing === true || thing === false;
};
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ var $89a1aebdecfcf41b$var$isPlainObject = function(val) {
    if (!$89a1aebdecfcf41b$var$isObject(val)) return false;
    var prototype = $89a1aebdecfcf41b$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $89a1aebdecfcf41b$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$89a1aebdecfcf41b$var$hasOwnInPrototypeChain(val, $89a1aebdecfcf41b$var$toStringTag) && !$89a1aebdecfcf41b$var$hasOwnInPrototypeChain(val, $89a1aebdecfcf41b$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ var $89a1aebdecfcf41b$var$isEmptyObject = function(val) {
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$89a1aebdecfcf41b$var$isObject(val) || $89a1aebdecfcf41b$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $89a1aebdecfcf41b$var$isDate = $89a1aebdecfcf41b$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $89a1aebdecfcf41b$var$isFile = $89a1aebdecfcf41b$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ var $89a1aebdecfcf41b$var$isReactNativeBlob = function(value) {
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ var $89a1aebdecfcf41b$var$isReactNative = function(formData) {
    return formData && typeof formData.getParts !== 'undefined';
};
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $89a1aebdecfcf41b$var$isBlob = $89a1aebdecfcf41b$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ var $89a1aebdecfcf41b$var$isFileList = $89a1aebdecfcf41b$var$kindOfTest('FileList');
var $89a1aebdecfcf41b$var$isSet = $89a1aebdecfcf41b$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ var $89a1aebdecfcf41b$var$isStream = function(val) {
    return $89a1aebdecfcf41b$var$isObject(val) && $89a1aebdecfcf41b$var$isFunction(val.pipe);
};
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $89a1aebdecfcf41b$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
var $89a1aebdecfcf41b$var$G = $89a1aebdecfcf41b$var$getGlobal();
var $89a1aebdecfcf41b$var$FormDataCtor = typeof $89a1aebdecfcf41b$var$G.FormData !== 'undefined' ? $89a1aebdecfcf41b$var$G.FormData : undefined;
var $89a1aebdecfcf41b$var$isFormData = function(thing) {
    if (!thing) return false;
    if ($89a1aebdecfcf41b$var$FormDataCtor && thing instanceof $89a1aebdecfcf41b$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    var proto = $89a1aebdecfcf41b$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$89a1aebdecfcf41b$var$isFunction(thing.append)) return false;
    var kind = $89a1aebdecfcf41b$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $89a1aebdecfcf41b$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $89a1aebdecfcf41b$var$isURLSearchParams = $89a1aebdecfcf41b$var$kindOfTest('URLSearchParams');
var $89a1aebdecfcf41b$var$_map = (0, $6ZpBv._)([
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($89a1aebdecfcf41b$var$kindOfTest), 4), $89a1aebdecfcf41b$var$isReadableStream = $89a1aebdecfcf41b$var$_map[0], $89a1aebdecfcf41b$var$isRequest = $89a1aebdecfcf41b$var$_map[1], $89a1aebdecfcf41b$var$isResponse = $89a1aebdecfcf41b$var$_map[2], $89a1aebdecfcf41b$var$isHeaders = $89a1aebdecfcf41b$var$_map[3];
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ var $89a1aebdecfcf41b$var$trim = function(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $89a1aebdecfcf41b$var$forEach(obj, fn) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_allOwnKeys = _ref.allOwnKeys, allOwnKeys = _ref_allOwnKeys === void 0 ? false : _ref_allOwnKeys;
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    var i;
    var l;
    // Force an array if not already something iterable
    if ((typeof obj === "undefined" ? "undefined" : (0, $5djcY._)(obj)) !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($89a1aebdecfcf41b$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($89a1aebdecfcf41b$var$isBuffer(obj)) return;
        // Iterate over object keys
        var keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        var len = keys.length;
        var key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $89a1aebdecfcf41b$var$findKey(obj, key) {
    if ($89a1aebdecfcf41b$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    var keys = Object.keys(obj);
    var i = keys.length;
    var _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
var $89a1aebdecfcf41b$var$_global = function() {
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
}();
var $89a1aebdecfcf41b$var$isContextDefined = function(context) {
    return !$89a1aebdecfcf41b$var$isUndefined(context) && context !== $89a1aebdecfcf41b$var$_global;
};
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $89a1aebdecfcf41b$var$merge() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++){
        objs[_key] = arguments[_key];
    }
    var _ref = $89a1aebdecfcf41b$var$isContextDefined(this) && this || {}, caseless = _ref.caseless, skipUndefined = _ref.skipUndefined;
    var result = {};
    var assignValue = function(val, key) {
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        var targetKey = caseless && typeof key === 'string' && $89a1aebdecfcf41b$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        var existing = $89a1aebdecfcf41b$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($89a1aebdecfcf41b$var$isPlainObject(existing) && $89a1aebdecfcf41b$var$isPlainObject(val)) result[targetKey] = $89a1aebdecfcf41b$var$merge(existing, val);
        else if ($89a1aebdecfcf41b$var$isPlainObject(val)) result[targetKey] = $89a1aebdecfcf41b$var$merge({}, val);
        else if ($89a1aebdecfcf41b$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$89a1aebdecfcf41b$var$isUndefined(val)) result[targetKey] = val;
    };
    for(var i = 0, l = objs.length; i < l; i++){
        var source = objs[i];
        if (!source || $89a1aebdecfcf41b$var$isBuffer(source)) continue;
        $89a1aebdecfcf41b$var$forEach(source, assignValue);
        if ((typeof source === "undefined" ? "undefined" : (0, $5djcY._)(source)) !== 'object' || $89a1aebdecfcf41b$var$isArray(source)) continue;
        var symbols = Object.getOwnPropertySymbols(source);
        for(var j = 0; j < symbols.length; j++){
            var symbol = symbols[j];
            if ($89a1aebdecfcf41b$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ var $89a1aebdecfcf41b$var$extend = function(a, b, thisArg) {
    var allOwnKeys = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).allOwnKeys;
    $89a1aebdecfcf41b$var$forEach(b, function(val, key) {
        if (thisArg && $89a1aebdecfcf41b$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $2Xvug.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ var $89a1aebdecfcf41b$var$stripBOM = function(content) {
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ var $89a1aebdecfcf41b$var$inherits = function(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ var $89a1aebdecfcf41b$var$toFlatObject = function(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $89a1aebdecfcf41b$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ var $89a1aebdecfcf41b$var$endsWith = function(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ var $89a1aebdecfcf41b$var$toArray = function(thing) {
    if (!thing) return null;
    if ($89a1aebdecfcf41b$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$89a1aebdecfcf41b$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
var $89a1aebdecfcf41b$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && $89a1aebdecfcf41b$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ var $89a1aebdecfcf41b$var$forEachEntry = function(obj, fn) {
    var generator = obj && obj[$89a1aebdecfcf41b$var$iterator];
    var _iterator = generator.call(obj);
    var result;
    while((result = _iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ var $89a1aebdecfcf41b$var$matchAll = function(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ var $89a1aebdecfcf41b$var$isHTMLForm = $89a1aebdecfcf41b$var$kindOfTest('HTMLFormElement');
var $89a1aebdecfcf41b$var$toCamelCase = function(str) {
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
var $89a1aebdecfcf41b$var$propertyIsEnumerable = Object.prototype.propertyIsEnumerable;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ var $89a1aebdecfcf41b$var$isRegExp = $89a1aebdecfcf41b$var$kindOfTest('RegExp');
var $89a1aebdecfcf41b$var$reduceDescriptors = function(obj, reducer) {
    var descriptors = Object.getOwnPropertyDescriptors(obj);
    var reducedDescriptors = {};
    $89a1aebdecfcf41b$var$forEach(descriptors, function(descriptor, name) {
        var ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ var $89a1aebdecfcf41b$var$freezeMethods = function(obj) {
    $89a1aebdecfcf41b$var$reduceDescriptors(obj, function(descriptor, name) {
        // skip restricted props in strict mode
        if ($89a1aebdecfcf41b$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        var value = obj[name];
        if (!$89a1aebdecfcf41b$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = function() {
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ var $89a1aebdecfcf41b$var$toObjectSet = function(arrayOrString, delimiter) {
    var obj = {};
    var define = function(arr) {
        arr.forEach(function(value) {
            obj[value] = true;
        });
    };
    $89a1aebdecfcf41b$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
var $89a1aebdecfcf41b$var$noop = function() {};
var $89a1aebdecfcf41b$var$toFiniteNumber = function(value, defaultValue) {
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $89a1aebdecfcf41b$var$isSpecCompliantForm(thing) {
    return !!(thing && $89a1aebdecfcf41b$var$isFunction(thing.append) && thing[$89a1aebdecfcf41b$var$toStringTag] === 'FormData' && thing[$89a1aebdecfcf41b$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ var $89a1aebdecfcf41b$var$toJSONObject = function(obj) {
    var visited = new WeakSet();
    var visit = function(source) {
        if ($89a1aebdecfcf41b$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($89a1aebdecfcf41b$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                var target;
                if ($89a1aebdecfcf41b$var$isSet(source)) {
                    target = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = source[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var value = _step.value;
                            var reducedValue = visit(value);
                            !$89a1aebdecfcf41b$var$isUndefined(reducedValue) && target.push(reducedValue);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else {
                    target = $89a1aebdecfcf41b$var$isArray(source) ? [] : {};
                    $89a1aebdecfcf41b$var$forEach(source, function(value, key) {
                        var reducedValue = visit(value);
                        !$89a1aebdecfcf41b$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ var $89a1aebdecfcf41b$var$isAsyncFn = $89a1aebdecfcf41b$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ var $89a1aebdecfcf41b$var$isThenable = function(thing) {
    return thing && ($89a1aebdecfcf41b$var$isObject(thing) || $89a1aebdecfcf41b$var$isFunction(thing)) && $89a1aebdecfcf41b$var$isFunction(thing.then) && $89a1aebdecfcf41b$var$isFunction(thing.catch);
};
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ var $89a1aebdecfcf41b$var$_setImmediate = function(setImmediateSupported, postMessageSupported) {
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? function(token, callbacks) {
        $89a1aebdecfcf41b$var$_global.addEventListener('message', function(param) {
            var source = param.source, data = param.data;
            if (source === $89a1aebdecfcf41b$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return function(cb) {
            callbacks.push(cb);
            $89a1aebdecfcf41b$var$_global.postMessage(token, '*');
        };
    }("axios@".concat(Math.random()), []) : function(cb) {
        return setTimeout(cb);
    };
}(typeof setImmediate === 'function', $89a1aebdecfcf41b$var$isFunction($89a1aebdecfcf41b$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ var $89a1aebdecfcf41b$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($89a1aebdecfcf41b$var$_global) : $89a1aebdecfcf41b$var$_setImmediate;
// *********************
var $89a1aebdecfcf41b$var$isIterable = function(thing) {
    return thing != null && $89a1aebdecfcf41b$var$isFunction(thing[$89a1aebdecfcf41b$var$iterator]);
};
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ var $89a1aebdecfcf41b$var$isSafeIterable = function(thing) {
    return thing != null && $89a1aebdecfcf41b$var$hasOwnInPrototypeChain(thing, $89a1aebdecfcf41b$var$iterator) && $89a1aebdecfcf41b$var$isIterable(thing);
};
var $89a1aebdecfcf41b$export$2e2bcd8739ae039 = {
    isArray: $89a1aebdecfcf41b$var$isArray,
    isArrayBuffer: $89a1aebdecfcf41b$var$isArrayBuffer,
    isBuffer: $89a1aebdecfcf41b$var$isBuffer,
    isFormData: $89a1aebdecfcf41b$var$isFormData,
    isArrayBufferView: $89a1aebdecfcf41b$var$isArrayBufferView,
    isString: $89a1aebdecfcf41b$var$isString,
    isNumber: $89a1aebdecfcf41b$var$isNumber,
    isBoolean: $89a1aebdecfcf41b$var$isBoolean,
    isObject: $89a1aebdecfcf41b$var$isObject,
    isPlainObject: $89a1aebdecfcf41b$var$isPlainObject,
    isEmptyObject: $89a1aebdecfcf41b$var$isEmptyObject,
    isReadableStream: $89a1aebdecfcf41b$var$isReadableStream,
    isRequest: $89a1aebdecfcf41b$var$isRequest,
    isResponse: $89a1aebdecfcf41b$var$isResponse,
    isHeaders: $89a1aebdecfcf41b$var$isHeaders,
    isUndefined: $89a1aebdecfcf41b$var$isUndefined,
    isDate: $89a1aebdecfcf41b$var$isDate,
    isFile: $89a1aebdecfcf41b$var$isFile,
    isReactNativeBlob: $89a1aebdecfcf41b$var$isReactNativeBlob,
    isReactNative: $89a1aebdecfcf41b$var$isReactNative,
    isBlob: $89a1aebdecfcf41b$var$isBlob,
    isRegExp: $89a1aebdecfcf41b$var$isRegExp,
    isFunction: $89a1aebdecfcf41b$var$isFunction,
    isStream: $89a1aebdecfcf41b$var$isStream,
    isURLSearchParams: $89a1aebdecfcf41b$var$isURLSearchParams,
    isTypedArray: $89a1aebdecfcf41b$var$isTypedArray,
    isFileList: $89a1aebdecfcf41b$var$isFileList,
    forEach: $89a1aebdecfcf41b$var$forEach,
    merge: $89a1aebdecfcf41b$var$merge,
    extend: $89a1aebdecfcf41b$var$extend,
    trim: $89a1aebdecfcf41b$var$trim,
    stripBOM: $89a1aebdecfcf41b$var$stripBOM,
    inherits: $89a1aebdecfcf41b$var$inherits,
    toFlatObject: $89a1aebdecfcf41b$var$toFlatObject,
    kindOf: $89a1aebdecfcf41b$var$kindOf,
    kindOfTest: $89a1aebdecfcf41b$var$kindOfTest,
    endsWith: $89a1aebdecfcf41b$var$endsWith,
    toArray: $89a1aebdecfcf41b$var$toArray,
    forEachEntry: $89a1aebdecfcf41b$var$forEachEntry,
    matchAll: $89a1aebdecfcf41b$var$matchAll,
    isHTMLForm: $89a1aebdecfcf41b$var$isHTMLForm,
    hasOwnProperty: $89a1aebdecfcf41b$var$hasOwnProperty,
    hasOwnProp: $89a1aebdecfcf41b$var$hasOwnProperty,
    hasOwnInPrototypeChain: $89a1aebdecfcf41b$var$hasOwnInPrototypeChain,
    getSafeProp: $89a1aebdecfcf41b$var$getSafeProp,
    toSafeFlatObject: $89a1aebdecfcf41b$var$toSafeFlatObject,
    reduceDescriptors: $89a1aebdecfcf41b$var$reduceDescriptors,
    freezeMethods: $89a1aebdecfcf41b$var$freezeMethods,
    toObjectSet: $89a1aebdecfcf41b$var$toObjectSet,
    toCamelCase: $89a1aebdecfcf41b$var$toCamelCase,
    noop: $89a1aebdecfcf41b$var$noop,
    toFiniteNumber: $89a1aebdecfcf41b$var$toFiniteNumber,
    findKey: $89a1aebdecfcf41b$var$findKey,
    global: $89a1aebdecfcf41b$var$_global,
    isContextDefined: $89a1aebdecfcf41b$var$isContextDefined,
    isSpecCompliantForm: $89a1aebdecfcf41b$var$isSpecCompliantForm,
    toJSONObject: $89a1aebdecfcf41b$var$toJSONObject,
    isAsyncFn: $89a1aebdecfcf41b$var$isAsyncFn,
    isThenable: $89a1aebdecfcf41b$var$isThenable,
    setImmediate: $89a1aebdecfcf41b$var$_setImmediate,
    asap: $89a1aebdecfcf41b$var$asap,
    isIterable: $89a1aebdecfcf41b$var$isIterable,
    isSafeIterable: $89a1aebdecfcf41b$var$isSafeIterable
};

});
parcelRegister("jlUaU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e16b8da7da809cdc$export$71511d61b312f219; });

var $dTQYG = parcelRequire("dTQYG");

var $d95Qy = parcelRequire("d95Qy");

var $eanwW = parcelRequire("eanwW");

var $J66Jb = parcelRequire("J66Jb");
function $e16b8da7da809cdc$export$71511d61b312f219(arr) {
    return (0, $dTQYG._)(arr) || (0, $d95Qy._)(arr) || (0, $J66Jb._)(arr) || (0, $eanwW._)();
}

});
parcelRegister("dTQYG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a1e981ac9d7864a0$export$71511d61b312f219; });

var $2PuG4 = parcelRequire("2PuG4");
function $a1e981ac9d7864a0$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $2PuG4._)(arr);
}

});

parcelRegister("d95Qy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9920a6ac5bee97c9$export$71511d61b312f219; });
function $9920a6ac5bee97c9$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("eanwW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a504407b7f865a13$export$71511d61b312f219; });
function $a504407b7f865a13$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("2Xvug", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22798429cb17e9d7$export$2e2bcd8739ae039; });
'use strict';
function $22798429cb17e9d7$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("lAX1b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb8abd8616745d5b$export$2e2bcd8739ae039; });

var $dxEC4 = parcelRequire("dxEC4");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $jlUaU = parcelRequire("jlUaU");

var $gh3Df = parcelRequire("gh3Df");

var $bOBNq = parcelRequire("bOBNq");

var $49f9T = parcelRequire("49f9T");

var $hvI7H = parcelRequire("hvI7H");

var $bS0vJ = parcelRequire("bS0vJ");

var $3SOIK = parcelRequire("3SOIK");

var $jLdcF = parcelRequire("jLdcF");

var $kjGZu = parcelRequire("kjGZu");

var $4K2og = parcelRequire("4K2og");

var $dgBgw = parcelRequire("dgBgw");

var $4zgkz = parcelRequire("4zgkz");
'use strict';
var $fb8abd8616745d5b$var$validators = (0, $4K2og.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ var $fb8abd8616745d5b$var$Axios = /*#__PURE__*/ function() {
    function Axios(instanceConfig) {
        (0, $4QweW._)(this, Axios);
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $hvI7H.default)(),
            response: new (0, $hvI7H.default)()
        };
    }
    (0, $6hK4i._)(Axios, [
        {
            key: "request",
            value: /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ function request(configOrUrl, config) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                    var err, dummy, dummyStack, stack, firstNewlineIndex, firstNewlineIndex1, secondNewlineIndex, stackWithoutTwoTopLines;
                    return (0, $gh3Df._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    this._request(configOrUrl, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                err = _state.sent();
                                if (err instanceof Error) try {
                                    dummy = {};
                                    Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                                    dummyStack = dummy.stack;
                                    stack = '';
                                    // slice off the Error: ... line
                                    if (typeof dummyStack === 'string') {
                                        firstNewlineIndex = dummyStack.indexOf('\n');
                                        stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                                    }
                                    if (!err.stack) err.stack = stack;
                                    else if (stack) {
                                        firstNewlineIndex1 = stack.indexOf('\n');
                                        secondNewlineIndex = firstNewlineIndex1 === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex1 + 1);
                                        stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                                    }
                                } catch (e) {
                                // Ignore failures from custom stack hooks or un-writable stack properties.
                                }
                                throw err;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "_request",
            value: function _request(configOrUrl, config) {
                var _this = this;
                /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                if (typeof configOrUrl === 'string') {
                    config = config || {};
                    config.url = configOrUrl;
                } else config = configOrUrl || {};
                config = (0, $3SOIK.default)(this.defaults, config);
                var transitional = config.transitional, paramsSerializer = config.paramsSerializer, headers = config.headers;
                if (transitional !== undefined) (0, $4K2og.default).assertOptions(transitional, {
                    silentJSONParsing: $fb8abd8616745d5b$var$validators.transitional($fb8abd8616745d5b$var$validators.boolean),
                    forcedJSONParsing: $fb8abd8616745d5b$var$validators.transitional($fb8abd8616745d5b$var$validators.boolean),
                    clarifyTimeoutError: $fb8abd8616745d5b$var$validators.transitional($fb8abd8616745d5b$var$validators.boolean),
                    legacyInterceptorReqResOrdering: $fb8abd8616745d5b$var$validators.transitional($fb8abd8616745d5b$var$validators.boolean),
                    advertiseZstdAcceptEncoding: $fb8abd8616745d5b$var$validators.transitional($fb8abd8616745d5b$var$validators.boolean),
                    validateStatusUndefinedResolves: $fb8abd8616745d5b$var$validators.transitional($fb8abd8616745d5b$var$validators.boolean)
                }, false);
                if (paramsSerializer != null) {
                    if ((0, $bOBNq.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                        serialize: paramsSerializer
                    };
                    else (0, $4K2og.default).assertOptions(paramsSerializer, {
                        encode: $fb8abd8616745d5b$var$validators.function,
                        serialize: $fb8abd8616745d5b$var$validators.function
                    }, true);
                }
                // Set config.allowAbsoluteUrls
                if (config.allowAbsoluteUrls !== undefined) ;
                else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
                else config.allowAbsoluteUrls = true;
                (0, $4K2og.default).assertOptions(config, {
                    baseUrl: $fb8abd8616745d5b$var$validators.spelling('baseURL'),
                    withXsrfToken: $fb8abd8616745d5b$var$validators.spelling('withXSRFToken')
                }, true);
                // Set config.method
                config.method = ((0, $bOBNq.default).getSafeProp(config, 'method') || (0, $bOBNq.default).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
                // Flatten headers
                var contextHeaders = headers && (0, $bOBNq.default).merge(headers.common, headers[config.method]);
                headers && (0, $bOBNq.default).forEach((0, $kjGZu.default).concat('common'), function(method) {
                    delete headers[method];
                });
                config.headers = (0, $dgBgw.default).concat(contextHeaders, headers);
                // filter out skipped interceptors
                var requestInterceptorChain = [];
                var synchronousRequestInterceptors = true;
                this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
                    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
                    var transitional = config.transitional || (0, $4zgkz.default);
                    var legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
                    if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
                    else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var responseInterceptorChain = [];
                this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var promise;
                var i = 0;
                var len;
                if (!synchronousRequestInterceptors) {
                    var _chain, _chain1;
                    var chain = [
                        (0, $bS0vJ.default).bind(this),
                        undefined
                    ];
                    (_chain = chain).unshift.apply(_chain, (0, $jlUaU._)(requestInterceptorChain));
                    (_chain1 = chain).push.apply(_chain1, (0, $jlUaU._)(responseInterceptorChain));
                    len = chain.length;
                    promise = Promise.resolve(config);
                    while(i < len)promise = promise.then(chain[i++], chain[i++]);
                    return promise;
                }
                len = requestInterceptorChain.length;
                var newConfig = config;
                while(i < len){
                    var onFulfilled = requestInterceptorChain[i++];
                    var onRejected = requestInterceptorChain[i++];
                    try {
                        newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
                    } catch (error) {
                        if (!onRejected) {
                            promise = Promise.reject(error);
                            break;
                        }
                        try {
                            var rejectedResult = onRejected.call(this, error);
                            if ((0, $bOBNq.default).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(function() {
                                return (0, $bS0vJ.default).call(_this, newConfig);
                            });
                        } catch (rejectedError) {
                            promise = Promise.reject(rejectedError);
                        }
                        break;
                    }
                }
                if (!promise) try {
                    promise = (0, $bS0vJ.default).call(this, newConfig);
                } catch (error) {
                    promise = Promise.reject(error);
                }
                i = 0;
                len = responseInterceptorChain.length;
                while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
                return promise;
            }
        },
        {
            key: "getUri",
            value: function getUri(config) {
                config = (0, $3SOIK.default)(this.defaults, config);
                var fullPath = (0, $jLdcF.default)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
                return (0, $49f9T.default)(fullPath, config.params, config.paramsSerializer);
            }
        }
    ]);
    return Axios;
}();
// Provide aliases for supported request methods
(0, $bOBNq.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $fb8abd8616745d5b$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $3SOIK.default)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $bOBNq.default).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $bOBNq.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $3SOIK.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $fb8abd8616745d5b$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $fb8abd8616745d5b$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $fb8abd8616745d5b$export$2e2bcd8739ae039 = $fb8abd8616745d5b$var$Axios;

});
parcelRegister("4QweW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $387506f4e8043722$export$71511d61b312f219; });
function $387506f4e8043722$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6hK4i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $493810cfcf480a5a$export$71511d61b312f219; });
function $493810cfcf480a5a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $493810cfcf480a5a$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $493810cfcf480a5a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $493810cfcf480a5a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("49f9T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3053c2df177d9cd9$export$2e2bcd8739ae039; });

var $bOBNq = parcelRequire("bOBNq");

var $cAx8n = parcelRequire("cAx8n");
'use strict';
function $3053c2df177d9cd9$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $3053c2df177d9cd9$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    var _options = (0, $bOBNq.default).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    var _encode = (0, $bOBNq.default).getSafeProp(_options, 'encode') || $3053c2df177d9cd9$export$c564cdbbe6da493;
    var serializeFn = (0, $bOBNq.default).getSafeProp(_options, 'serialize');
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $bOBNq.default).isURLSearchParams(params) ? params.toString() : new (0, $cAx8n.default)(params, _options).toString(_encode);
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("cAx8n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92a28c8d588c0281$export$2e2bcd8739ae039; });

var $8S0fp = parcelRequire("8S0fp");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $92a28c8d588c0281$var$encode(str) {
    var charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $92a28c8d588c0281$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $8S0fp.default)(params, this, options);
}
var $92a28c8d588c0281$var$prototype = $92a28c8d588c0281$var$AxiosURLSearchParams.prototype;
$92a28c8d588c0281$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$92a28c8d588c0281$var$prototype.toString = function toString(encoder) {
    var _this = this;
    var _encode = encoder ? function(value) {
        return encoder.call(_this, value, $92a28c8d588c0281$var$encode);
    } : $92a28c8d588c0281$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $92a28c8d588c0281$export$2e2bcd8739ae039 = $92a28c8d588c0281$var$AxiosURLSearchParams;

});
parcelRegister("8S0fp", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FORM_DATA_MAX_DEPTH", function () { return $67538f014ecba2b0$export$659081b45d03227d; });
$parcel$export(module.exports, "default", function () { return $67538f014ecba2b0$export$2e2bcd8739ae039; });

var $5djcY = parcelRequire("5djcY");

var $bOBNq = parcelRequire("bOBNq");

var $3B0hl = parcelRequire("3B0hl");

var $hOl4E = parcelRequire("hOl4E");

var $hOl4E = parcelRequire("hOl4E");
'use strict';
var $67538f014ecba2b0$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $67538f014ecba2b0$var$isVisitable(thing) {
    return (0, $bOBNq.default).isPlainObject(thing) || (0, $bOBNq.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $67538f014ecba2b0$var$removeBrackets(key) {
    return (0, $bOBNq.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $67538f014ecba2b0$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $67538f014ecba2b0$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $67538f014ecba2b0$var$isFlatArray(arr) {
    return (0, $bOBNq.default).isArray(arr) && !arr.some($67538f014ecba2b0$var$isVisitable);
}
var $67538f014ecba2b0$var$predicates = (0, $bOBNq.default).toFlatObject((0, $bOBNq.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $67538f014ecba2b0$var$toFormData(obj, formData, options) {
    if (!(0, $bOBNq.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $hOl4E.default) || FormData)();
    var option = function(name, fallback) {
        var value = (0, $bOBNq.default).getSafeProp(options, name);
        return (0, $bOBNq.default).isUndefined(value) ? fallback : value;
    };
    var metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    var visitor = option('visitor') || defaultVisitor;
    var dots = option('dots', false);
    var indexes = option('indexes', false);
    var _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    var maxDepth = option('maxDepth', $67538f014ecba2b0$export$659081b45d03227d);
    var useBlob = _Blob && (0, $bOBNq.default).isSpecCompliantForm(formData);
    var stack = [];
    if (!(0, $bOBNq.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $bOBNq.default).isDate(value)) return value.toISOString();
        if ((0, $bOBNq.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $bOBNq.default).isBlob(value)) throw new (0, $3B0hl.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $bOBNq.default).isArrayBuffer(value) || (0, $bOBNq.default).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $hOl4E.default) && (0, $hOl4E.default).isBufferAvailable()) return (0, $hOl4E.default).from(value);
            throw new (0, $3B0hl.default)('Blob is not supported. Use a Buffer instead.', (0, $3B0hl.default).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $3B0hl.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $3B0hl.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        var ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $bOBNq.default).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if ((0, $bOBNq.default).isReactNative(formData) && (0, $bOBNq.default).isReactNativeBlob(value)) {
            formData.append($67538f014ecba2b0$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && (typeof value === "undefined" ? "undefined" : (0, $5djcY._)(value)) === 'object') {
            if ((0, $bOBNq.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $bOBNq.default).isArray(value) && $67538f014ecba2b0$var$isFlatArray(value) || ((0, $bOBNq.default).isFileList(value) || (0, $bOBNq.default).endsWith(key, '[]')) && (arr = (0, $bOBNq.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $67538f014ecba2b0$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $bOBNq.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $67538f014ecba2b0$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($67538f014ecba2b0$var$isVisitable(value)) return true;
        formData.append($67538f014ecba2b0$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var exposedHelpers = Object.assign($67538f014ecba2b0$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $67538f014ecba2b0$var$isVisitable
    });
    function build(value, path) {
        var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        if ((0, $bOBNq.default).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $bOBNq.default).forEach(value, function each(el, key) {
            var result = !((0, $bOBNq.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $bOBNq.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $bOBNq.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $67538f014ecba2b0$export$2e2bcd8739ae039 = $67538f014ecba2b0$var$toFormData;

});
parcelRegister("3B0hl", function(module, exports) {

$parcel$export(module.exports, "REDACTED", function () { return $29e50b2b8117dffb$export$6acd2efa8ac62a1b; });
$parcel$export(module.exports, "default", function () { return $29e50b2b8117dffb$export$2e2bcd8739ae039; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $6ZpBv = parcelRequire("6ZpBv");

var $5djcY = parcelRequire("5djcY");

var $67kUy = parcelRequire("67kUy");

var $bOBNq = parcelRequire("bOBNq");

var $dgBgw = parcelRequire("dgBgw");
'use strict';
var $29e50b2b8117dffb$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $29e50b2b8117dffb$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $bOBNq.default).hasOwnProp(source, 'toJSON')) return true;
    var prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $bOBNq.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $29e50b2b8117dffb$var$redactConfig(config, redactKeys) {
    var lowerKeys = new Set(redactKeys.map(function(k) {
        return String(k).toLowerCase();
    }));
    var seen = [];
    var visit = function(source) {
        if (source === null || (typeof source === "undefined" ? "undefined" : (0, $5djcY._)(source)) !== 'object') return source;
        if ((0, $bOBNq.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $dgBgw.default)) source = source.toJSON();
        seen.push(source);
        var result;
        if ((0, $bOBNq.default).isArray(source)) {
            result = [];
            source.forEach(function(v, i) {
                var reducedValue = visit(v);
                if (!(0, $bOBNq.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $bOBNq.default).isPlainObject(source) && $29e50b2b8117dffb$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $6ZpBv._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    var reducedValue = lowerKeys.has(key.toLowerCase()) ? $29e50b2b8117dffb$export$6acd2efa8ac62a1b : visit(value);
                    if (!(0, $bOBNq.default).isUndefined(reducedValue)) result[key] = reducedValue;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $29e50b2b8117dffb$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $29e50b2b8117dffb$var$aggregateErrorMessage(error) {
    var message = error.errors.map(function(entry) {
        try {
            return entry && entry.message ? $29e50b2b8117dffb$var$stringifySafely(entry.message) : $29e50b2b8117dffb$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
var $29e50b2b8117dffb$var$AxiosError = /*#__PURE__*/ function(Error1) {
    (0, $c2MhV._)(AxiosError, Error1);
    function AxiosError(message, code, config, request, response) {
        (0, $4QweW._)(this, AxiosError);
        var _this;
        _this = (0, $ehF45._)(this, AxiosError, [
            message
        ]);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(_this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        _this.name = 'AxiosError';
        _this.isAxiosError = true;
        code && (_this.code = code);
        config && (_this.config = config);
        request && (_this.request = request);
        if (response) {
            _this.response = response;
            _this.status = response.status;
        }
        return _this;
    }
    (0, $6hK4i._)(AxiosError, [
        {
            key: "toJSON",
            value: function toJSON() {
                // Opt-in redaction: when the request config carries a `redact` array, the
                // value of any matching key (case-insensitive, at any depth) is replaced
                // with REDACTED in the serialized snapshot. Undefined or empty leaves the
                // existing serialization behavior unchanged.
                var config = this.config;
                var redactKeys = config && (0, $bOBNq.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
                var serializedConfig = (0, $bOBNq.default).isArray(redactKeys) && redactKeys.length > 0 ? $29e50b2b8117dffb$var$redactConfig(config, redactKeys) : (0, $bOBNq.default).toJSONObject(config);
                return {
                    // Standard
                    message: this.message,
                    name: this.name,
                    // Microsoft
                    description: this.description,
                    number: this.number,
                    // Mozilla
                    fileName: this.fileName,
                    lineNumber: this.lineNumber,
                    columnNumber: this.columnNumber,
                    stack: this.stack,
                    // Axios
                    config: serializedConfig,
                    code: this.code,
                    status: this.status
                };
            }
        }
    ], [
        {
            key: "from",
            value: function from(error, code, config, request, response, customProps) {
                // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
                // failures) has an empty `message`; its detail lives in `errors[]`. Without
                // this, the wrapped error surfaces with a blank message (see #6721).
                var message = error.message;
                if (!message && (0, $bOBNq.default).isArray(error.errors) && error.errors.length) message = $29e50b2b8117dffb$var$aggregateErrorMessage(error);
                var axiosError = new AxiosError(message, code || error.code, config, request, response);
                // Match native `Error` `cause` semantics: non-enumerable. The wrapped
                // error often carries circular internals (sockets, requests, agents), so
                // an enumerable `cause` makes structured loggers (pino/winston) and any
                // own-property walk throw "Converting circular structure to JSON".
                // Regression from #6982; see #7205. `__proto__: null` mirrors the
                // `message` descriptor below (prototype-pollution-safe descriptor).
                Object.defineProperty(axiosError, 'cause', {
                    __proto__: null,
                    value: error,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                axiosError.name = error.name;
                // Preserve status from the original error if not already set from response
                if (error.status != null && axiosError.status == null) axiosError.status = error.status;
                customProps && Object.assign(axiosError, customProps);
                return axiosError;
            }
        }
    ]);
    return AxiosError;
}((0, $67kUy._)(Error));
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$29e50b2b8117dffb$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$29e50b2b8117dffb$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$29e50b2b8117dffb$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$29e50b2b8117dffb$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$29e50b2b8117dffb$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$29e50b2b8117dffb$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$29e50b2b8117dffb$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$29e50b2b8117dffb$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$29e50b2b8117dffb$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$29e50b2b8117dffb$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$29e50b2b8117dffb$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$29e50b2b8117dffb$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$29e50b2b8117dffb$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$29e50b2b8117dffb$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $29e50b2b8117dffb$export$2e2bcd8739ae039 = $29e50b2b8117dffb$var$AxiosError;

});
parcelRegister("ehF45", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a66281e0cb61a131$export$71511d61b312f219; });

var $9atk1 = parcelRequire("9atk1");

var $guZS9 = parcelRequire("guZS9");

var $hvep1 = parcelRequire("hvep1");
function $a66281e0cb61a131$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $9atk1._)(derived);
    return (0, $hvep1._)(_this, (0, $guZS9._)() ? Reflect.construct(derived, args || [], (0, $9atk1._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("9atk1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6acbcaee24263e7e$export$71511d61b312f219; });
function $6acbcaee24263e7e$export$71511d61b312f219(o) {
    $6acbcaee24263e7e$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6acbcaee24263e7e$export$71511d61b312f219(o);
}

});

parcelRegister("guZS9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c02f7145f7333f96$export$71511d61b312f219; });
function $c02f7145f7333f96$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($c02f7145f7333f96$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("hvep1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbe080f489d283a9$export$71511d61b312f219; });

var $kE8SG = parcelRequire("kE8SG");

var $5djcY = parcelRequire("5djcY");
function $cbe080f489d283a9$export$71511d61b312f219(self, call) {
    if (call && ((0, $5djcY._)(call) === "object" || typeof call === "function")) return call;
    return (0, $kE8SG._)(self);
}

});
parcelRegister("kE8SG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f07e6eacebc6356c$export$71511d61b312f219; });
function $f07e6eacebc6356c$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("c2MhV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8c4b20f88f3acc70$export$71511d61b312f219; });

var $lwwt5 = parcelRequire("lwwt5");
function $8c4b20f88f3acc70$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $lwwt5._)(subClass, superClass);
}

});
parcelRegister("lwwt5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fab5c5a3fca5294c$export$71511d61b312f219; });
function $fab5c5a3fca5294c$export$71511d61b312f219(o, p) {
    $fab5c5a3fca5294c$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fab5c5a3fca5294c$export$71511d61b312f219(o, p);
}

});


parcelRegister("67kUy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $47439e10dae4d647$export$71511d61b312f219; });

var $2IRoN = parcelRequire("2IRoN");

var $9atk1 = parcelRequire("9atk1");

var $dcYQL = parcelRequire("dcYQL");

var $lwwt5 = parcelRequire("lwwt5");
function $47439e10dae4d647$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $47439e10dae4d647$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $dcYQL._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $2IRoN._)(Class, arguments, (0, $9atk1._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $lwwt5._)(Wrapper, Class);
    };
    return $47439e10dae4d647$export$71511d61b312f219(Class);
}

});
parcelRegister("2IRoN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1fb91cc0e14bc157$export$71511d61b312f219; });

var $guZS9 = parcelRequire("guZS9");

var $lwwt5 = parcelRequire("lwwt5");
function $1fb91cc0e14bc157$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $guZS9._)()) $1fb91cc0e14bc157$export$71511d61b312f219 = Reflect.construct;
    else $1fb91cc0e14bc157$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $lwwt5._)(instance, Class.prototype);
        return instance;
    };
    return $1fb91cc0e14bc157$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("dcYQL", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99db98e27fceb262$export$71511d61b312f219; });
function $99db98e27fceb262$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("dgBgw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a89ad2091d34e72$export$2e2bcd8739ae039; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $bOBNq = parcelRequire("bOBNq");

var $lNFJZ = parcelRequire("lNFJZ");

var $9F8ZO = parcelRequire("9F8ZO");
'use strict';
var $9a89ad2091d34e72$var$$internals = Symbol('internals');
function $9a89ad2091d34e72$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $9a89ad2091d34e72$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $bOBNq.default).isArray(value) ? value.map($9a89ad2091d34e72$var$normalizeValue) : (0, $9F8ZO.sanitizeHeaderValue)(String(value));
}
function $9a89ad2091d34e72$var$parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
var $9a89ad2091d34e72$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $9a89ad2091d34e72$var$trimOWS(value) {
    var start = 0;
    var end = value.length;
    while(start < end){
        var code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        var code1 = value.charCodeAt(end - 1);
        if (code1 !== 0x09 && code1 !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $9a89ad2091d34e72$var$decodeQuotedString(value) {
    var last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    var decoded = '';
    for(var i = 1; i < last; i++){
        var code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $9a89ad2091d34e72$var$parseParameters(value) {
    var parameters = Object.create(null);
    var str = String(value);
    var start = 0;
    var quoted = false;
    var escaped = false;
    function parseParameter(end) {
        var part = $9a89ad2091d34e72$var$trimOWS(str.slice(start, end));
        var equals = part.indexOf('=');
        if (equals < 1) return;
        var name = $9a89ad2091d34e72$var$trimOWS(part.slice(0, equals));
        if (!$9a89ad2091d34e72$var$parameterNameRE.test(name)) return;
        var normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        var parameterValue = $9a89ad2091d34e72$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $9a89ad2091d34e72$var$decodeQuotedString(parameterValue);
    }
    for(var i = 0; i < str.length; i++){
        var code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
var $9a89ad2091d34e72$var$isValidHeaderName = function(str) {
    return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
};
function $9a89ad2091d34e72$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $bOBNq.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $bOBNq.default).isString(value)) return;
    if ((0, $bOBNq.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $bOBNq.default).isRegExp(filter)) return filter.test(value);
}
function $9a89ad2091d34e72$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function(w, char, str) {
        return char.toUpperCase() + str;
    });
}
function $9a89ad2091d34e72$var$buildAccessors(obj, header) {
    var accessorName = (0, $bOBNq.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach(function(methodName) {
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function value(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
var $9a89ad2091d34e72$var$AxiosHeaders = /*#__PURE__*/ function() {
    function AxiosHeaders(headers) {
        (0, $4QweW._)(this, AxiosHeaders);
        headers && this.set(headers);
    }
    (0, $6hK4i._)(AxiosHeaders, [
        {
            key: "set",
            value: function set(header, valueOrRewrite, rewrite) {
                var self = this;
                function setHeader(_value, _header, _rewrite) {
                    var lHeader = $9a89ad2091d34e72$var$normalizeHeader(_header);
                    if (!lHeader) return;
                    var key = (0, $bOBNq.default).findKey(self, lHeader);
                    if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $9a89ad2091d34e72$var$normalizeValue(_value);
                }
                var setHeaders = function(headers, _rewrite) {
                    return (0, $bOBNq.default).forEach(headers, function(_value, _header) {
                        return setHeader(_value, _header, _rewrite);
                    });
                };
                if ((0, $bOBNq.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
                else if ((0, $bOBNq.default).isString(header) && (header = header.trim()) && !$9a89ad2091d34e72$var$isValidHeaderName(header)) setHeaders((0, $lNFJZ.default)(header), valueOrRewrite);
                else if ((0, $bOBNq.default).isObject(header) && (0, $bOBNq.default).isSafeIterable(header)) {
                    var obj = Object.create(null), dest, key;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = header[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            if (!(0, $bOBNq.default).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                            key = entry[0];
                            if ((0, $bOBNq.default).hasOwnProp(obj, key)) {
                                dest = obj[key];
                                obj[key] = (0, $bOBNq.default).isArray(dest) ? (0, $jlUaU._)(dest).concat([
                                    entry[1]
                                ]) : [
                                    dest,
                                    entry[1]
                                ];
                            } else obj[key] = entry[1];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    setHeaders(obj, valueOrRewrite);
                } else header != null && setHeader(valueOrRewrite, header, rewrite);
                return this;
            }
        },
        {
            key: "get",
            value: function get(header, parser) {
                header = $9a89ad2091d34e72$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $bOBNq.default).findKey(this, header);
                    if (key) {
                        var value = this[key];
                        if (!parser) return value;
                        if (parser === true) return $9a89ad2091d34e72$var$parseTokens(value);
                        if ((0, $bOBNq.default).isFunction(parser)) return parser.call(this, value, key);
                        if ((0, $bOBNq.default).isRegExp(parser)) return parser.exec(value);
                        throw new TypeError('parser must be boolean|regexp|function');
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(header, matcher) {
                header = $9a89ad2091d34e72$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $bOBNq.default).findKey(this, header);
                    return !!(key && this[key] !== undefined && (!matcher || $9a89ad2091d34e72$var$matchHeaderValue(this, this[key], key, matcher)));
                }
                return false;
            }
        },
        {
            key: "delete",
            value: function _delete(header, matcher) {
                var self = this;
                var deleted = false;
                function deleteHeader(_header) {
                    _header = $9a89ad2091d34e72$var$normalizeHeader(_header);
                    if (_header) {
                        var key = (0, $bOBNq.default).findKey(self, _header);
                        if (key && (!matcher || $9a89ad2091d34e72$var$matchHeaderValue(self, self[key], key, matcher))) {
                            delete self[key];
                            deleted = true;
                        }
                    }
                }
                if ((0, $bOBNq.default).isArray(header)) header.forEach(deleteHeader);
                else deleteHeader(header);
                return deleted;
            }
        },
        {
            key: "clear",
            value: function clear(matcher) {
                var keys = Object.keys(this);
                var i = keys.length;
                var deleted = false;
                while(i--){
                    var key = keys[i];
                    if (!matcher || $9a89ad2091d34e72$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                        delete this[key];
                        deleted = true;
                    }
                }
                return deleted;
            }
        },
        {
            key: "normalize",
            value: function normalize(format) {
                var self = this;
                var headers = {};
                (0, $bOBNq.default).forEach(this, function(value, header) {
                    var key = (0, $bOBNq.default).findKey(headers, header);
                    if (key) {
                        self[key] = $9a89ad2091d34e72$var$normalizeValue(value);
                        delete self[header];
                        return;
                    }
                    var normalized = format ? $9a89ad2091d34e72$var$formatHeader(header) : String(header).trim();
                    if (normalized !== header) delete self[header];
                    self[normalized] = $9a89ad2091d34e72$var$normalizeValue(value);
                    headers[normalized] = true;
                });
                return this;
            }
        },
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++){
                    targets[_key] = arguments[_key];
                }
                var _this_constructor;
                return (_this_constructor = this.constructor).concat.apply(_this_constructor, [
                    this
                ].concat((0, $jlUaU._)(targets)));
            }
        },
        {
            key: "toJSON",
            value: function toJSON(asStrings) {
                var obj = Object.create(null);
                (0, $bOBNq.default).forEach(this, function(value, header) {
                    value != null && value !== false && (obj[header] = asStrings && (0, $bOBNq.default).isArray(value) ? value.join(', ') : value);
                });
                return obj;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return Object.entries(this.toJSON())[Symbol.iterator]();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return Object.entries(this.toJSON()).map(function(param) {
                    var _param = (0, $6ZpBv._)(param, 2), header = _param[0], value = _param[1];
                    return header + ': ' + value;
                }).join('\n');
            }
        },
        {
            key: "getSetCookie",
            value: function getSetCookie() {
                var value = this.get('set-cookie');
                return (0, $bOBNq.default).isArray(value) ? value : value == null || value === false ? [] : [
                    value
                ];
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return 'AxiosHeaders';
            }
        }
    ], [
        {
            key: "from",
            value: function from(thing) {
                return thing instanceof this ? thing : new this(thing);
            }
        },
        {
            key: "parseParameters",
            value: function parseParameters1(value) {
                return $9a89ad2091d34e72$var$parseParameters(value);
            }
        },
        {
            key: "concat",
            value: function concat(first) {
                for(var _len = arguments.length, targets = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    targets[_key - 1] = arguments[_key];
                }
                var computed = new this(first);
                targets.forEach(function(target) {
                    return computed.set(target);
                });
                return computed;
            }
        },
        {
            key: "accessor",
            value: function accessor(header) {
                var internals = this[$9a89ad2091d34e72$var$$internals] = this[$9a89ad2091d34e72$var$$internals] = {
                    accessors: {}
                };
                var accessors = internals.accessors;
                var prototype = this.prototype;
                function defineAccessor(_header) {
                    var lHeader = $9a89ad2091d34e72$var$normalizeHeader(_header);
                    if (!accessors[lHeader]) {
                        $9a89ad2091d34e72$var$buildAccessors(prototype, _header);
                        accessors[lHeader] = true;
                    }
                }
                (0, $bOBNq.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
                return this;
            }
        }
    ]);
    return AxiosHeaders;
}();
$9a89ad2091d34e72$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $bOBNq.default).reduceDescriptors($9a89ad2091d34e72$var$AxiosHeaders.prototype, function(param, key) {
    var value = param.value;
    var mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: function() {
            return value;
        },
        set: function(headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $bOBNq.default).freezeMethods($9a89ad2091d34e72$var$AxiosHeaders);
var $9a89ad2091d34e72$export$2e2bcd8739ae039 = $9a89ad2091d34e72$var$AxiosHeaders;

});
parcelRegister("lNFJZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdee8d6cac071450$export$2e2bcd8739ae039; });

var $bOBNq = parcelRequire("bOBNq");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fdee8d6cac071450$var$ignoreDuplicateOf = (0, $bOBNq.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fdee8d6cac071450$export$2e2bcd8739ae039 = function(rawHeaders) {
    var parsed = {};
    var key;
    var val;
    var i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        var hasKey = (0, $bOBNq.default).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $bOBNq.default).hasOwnProp($fdee8d6cac071450$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});

parcelRegister("9F8ZO", function(module, exports) {

$parcel$export(module.exports, "sanitizeHeaderValue", function () { return $708eebd34e922055$export$9e344cffce061a22; });
$parcel$export(module.exports, "toByteStringHeaderObject", function () { return $708eebd34e922055$export$c30c72bb7e677d54; });

var $bOBNq = parcelRequire("bOBNq");
'use strict';
function $708eebd34e922055$var$trimSPorHTAB(str) {
    var start = 0;
    var end = str.length;
    while(start < end){
        var code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        var code1 = str.charCodeAt(end - 1);
        if (code1 !== 0x09 && code1 !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
var $708eebd34e922055$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
var $708eebd34e922055$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $708eebd34e922055$var$sanitizeValue(value, invalidChars) {
    if ((0, $bOBNq.default).isArray(value)) return value.map(function(item) {
        return $708eebd34e922055$var$sanitizeValue(item, invalidChars);
    });
    return $708eebd34e922055$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
var $708eebd34e922055$export$9e344cffce061a22 = function(value) {
    return $708eebd34e922055$var$sanitizeValue(value, $708eebd34e922055$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
};
var $708eebd34e922055$export$59dd66c2a12d8f62 = function(value) {
    return $708eebd34e922055$var$sanitizeValue(value, $708eebd34e922055$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
};
function $708eebd34e922055$export$c30c72bb7e677d54(headers) {
    var byteStringHeaders = Object.create(null);
    (0, $bOBNq.default).forEach(headers.toJSON(), function(value, header) {
        byteStringHeaders[header] = $708eebd34e922055$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}

});



parcelRegister("hOl4E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf777405ea1be476$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $cf777405ea1be476$export$2e2bcd8739ae039 = null;

});




parcelRegister("hvI7H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbf78edf2a16e4d5$export$2e2bcd8739ae039; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $bOBNq = parcelRequire("bOBNq");
'use strict';
var $cbf78edf2a16e4d5$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $cbf78edf2a16e4d5$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $cbf78edf2a16e4d5$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $cbf78edf2a16e4d5$var$syncHandlerEntries(manager, internals) {
    var handlers = manager.handlers;
    var length = $cbf78edf2a16e4d5$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
var $cbf78edf2a16e4d5$var$InterceptorManager = /*#__PURE__*/ function() {
    function InterceptorManager() {
        (0, $4QweW._)(this, InterceptorManager);
        this.handlers = [];
        this[$cbf78edf2a16e4d5$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    (0, $6hK4i._)(InterceptorManager, [
        {
            /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ key: "use",
            value: function use(fulfilled, rejected, options) {
                var handler = {
                    fulfilled: fulfilled,
                    rejected: rejected,
                    synchronous: options ? options.synchronous : false,
                    runWhen: options ? options.runWhen : null
                };
                var internals = this[$cbf78edf2a16e4d5$var$$internals];
                if (this.handlers == null) this.handlers = [];
                $cbf78edf2a16e4d5$var$syncHandlerEntries(this, internals);
                var id = internals.nextId++;
                this.handlers.push(handler);
                internals.handlerEntries.set(id, {
                    handler: handler,
                    index: this.handlers.length - 1
                });
                internals.handlersLength = this.handlers.length;
                return id;
            }
        },
        {
            /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ key: "eject",
            value: function eject(id) {
                var internals = this[$cbf78edf2a16e4d5$var$$internals];
                $cbf78edf2a16e4d5$var$syncHandlerEntries(this, internals);
                var entry = internals.handlerEntries.get(id);
                if (entry) {
                    internals.handlerEntries.delete(id);
                    // Ignore IDs invalidated by clear or direct replacement of handlers.
                    if (this.handlers[entry.index] !== entry.handler) return;
                    this.handlers[entry.index] = null;
                    // Do not reuse an index while forEach is walking its length snapshot.
                    if (!internals.iterationDepth) {
                        $cbf78edf2a16e4d5$var$trimHandlers(this.handlers);
                        internals.handlersLength = this.handlers.length;
                    }
                }
            }
        },
        {
            /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ key: "clear",
            value: function clear() {
                if (this.handlers) {
                    this.handlers = [];
                    $cbf78edf2a16e4d5$var$syncHandlerEntries(this, this[$cbf78edf2a16e4d5$var$$internals]);
                }
            }
        },
        {
            /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ key: "forEach",
            value: function forEach(fn) {
                var internals = this[$cbf78edf2a16e4d5$var$$internals];
                $cbf78edf2a16e4d5$var$syncHandlerEntries(this, internals);
                internals.iterationDepth++;
                try {
                    (0, $bOBNq.default).forEach(this.handlers, function forEachHandler(h) {
                        if (h !== null) fn(h);
                    });
                } finally{
                    if (!--internals.iterationDepth) {
                        $cbf78edf2a16e4d5$var$syncHandlerEntries(this, internals);
                        $cbf78edf2a16e4d5$var$trimHandlers(this.handlers);
                        internals.handlersLength = $cbf78edf2a16e4d5$var$countHandlers(this.handlers);
                    }
                }
            }
        }
    ]);
    return InterceptorManager;
}();
var $cbf78edf2a16e4d5$export$2e2bcd8739ae039 = $cbf78edf2a16e4d5$var$InterceptorManager;

});

parcelRegister("bS0vJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a45224dae173a9e$export$2e2bcd8739ae039; });

var $6SZp0 = parcelRequire("6SZp0");

var $7CoXk = parcelRequire("7CoXk");

var $bF7tY = parcelRequire("bF7tY");

var $a6CVI = parcelRequire("a6CVI");

var $dgBgw = parcelRequire("dgBgw");

var $hJdf9 = parcelRequire("hJdf9");

var $bOBNq = parcelRequire("bOBNq");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $8a45224dae173a9e$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $a6CVI.default)(null, config);
}
function $8a45224dae173a9e$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    var config = (0, $bOBNq.default).toSafeFlatObject(_config);
    $8a45224dae173a9e$var$throwIfCancellationRequested(config);
    config.headers = (0, $dgBgw.default).from((0, $bOBNq.default).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $6SZp0.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    var adapter = (0, $hJdf9.default).getAdapter(config.adapter || (0, $bF7tY.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $8a45224dae173a9e$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $6SZp0.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $dgBgw.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7CoXk.default)(reason)) {
            $8a45224dae173a9e$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $6SZp0.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $dgBgw.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("6SZp0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50376a716e659ff6$export$2e2bcd8739ae039; });

var $bOBNq = parcelRequire("bOBNq");

var $bF7tY = parcelRequire("bF7tY");

var $dgBgw = parcelRequire("dgBgw");
'use strict';
function $50376a716e659ff6$export$2e2bcd8739ae039(fns, response) {
    var config = this || (0, $bF7tY.default);
    var context = response || config;
    var headers = (0, $dgBgw.default).from(context.headers);
    var data = context.data;
    (0, $bOBNq.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("bF7tY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87d953e7fda29da4$export$2e2bcd8739ae039; });

var $bOBNq = parcelRequire("bOBNq");

var $3B0hl = parcelRequire("3B0hl");

var $4zgkz = parcelRequire("4zgkz");

var $8S0fp = parcelRequire("8S0fp");

var $kI20S = parcelRequire("kI20S");

var $1VttG = parcelRequire("1VttG");

var $vFFoL = parcelRequire("vFFoL");

var $kjGZu = parcelRequire("kjGZu");
'use strict';
var $87d953e7fda29da4$var$own = function(obj, key) {
    return obj != null && (0, $bOBNq.default).hasOwnProp(obj, key) ? obj[key] : undefined;
};
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $87d953e7fda29da4$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $bOBNq.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $bOBNq.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $87d953e7fda29da4$var$defaults = {
    transitional: (0, $4zgkz.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            var contentType = headers.getContentType() || '';
            var hasJSONContentType = contentType.indexOf('application/json') > -1;
            var isObjectPayload = (0, $bOBNq.default).isObject(data);
            if (isObjectPayload && (0, $bOBNq.default).isHTMLForm(data)) data = new FormData(data);
            var isFormData = (0, $bOBNq.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $vFFoL.default)(data)) : data;
            if ((0, $bOBNq.default).isArrayBuffer(data) || (0, $bOBNq.default).isBuffer(data) || (0, $bOBNq.default).isStream(data) || (0, $bOBNq.default).isFile(data) || (0, $bOBNq.default).isBlob(data) || (0, $bOBNq.default).isReadableStream(data)) return data;
            if ((0, $bOBNq.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $bOBNq.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                var formSerializer = $87d953e7fda29da4$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $kI20S.default)(data, formSerializer).toString();
                if ((isFileList = (0, $bOBNq.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    var env = $87d953e7fda29da4$var$own(this, 'env');
                    var _FormData = env && env.FormData;
                    return (0, $8S0fp.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $87d953e7fda29da4$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = $87d953e7fda29da4$var$own(this, 'transitional') || $87d953e7fda29da4$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var responseType = $87d953e7fda29da4$var$own(this, 'responseType');
            var JSONRequested = responseType === 'json';
            if ((0, $bOBNq.default).isResponse(data) || (0, $bOBNq.default).isReadableStream(data)) return data;
            if (data && (0, $bOBNq.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $87d953e7fda29da4$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $3B0hl.default).from(e, (0, $3B0hl.default).ERR_BAD_RESPONSE, this, null, $87d953e7fda29da4$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $1VttG.default).classes.FormData,
        Blob: (0, $1VttG.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $bOBNq.default).forEach((0, $kjGZu.default), function(method) {
    $87d953e7fda29da4$var$defaults.headers[method] = {};
});
var $87d953e7fda29da4$export$2e2bcd8739ae039 = $87d953e7fda29da4$var$defaults;

});
parcelRegister("4zgkz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35371941cab60435$export$2e2bcd8739ae039; });
'use strict';
var $35371941cab60435$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};

});

parcelRegister("kI20S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1397a7c05a98243$export$2e2bcd8739ae039; });

var $kWfK0 = parcelRequire("kWfK0");

var $bOBNq = parcelRequire("bOBNq");

var $8S0fp = parcelRequire("8S0fp");

var $1VttG = parcelRequire("1VttG");
'use strict';
function $f1397a7c05a98243$export$2e2bcd8739ae039(data, options) {
    return (0, $8S0fp.default)(data, new (0, $1VttG.default).classes.URLSearchParams(), (0, $kWfK0._)({
        visitor: function visitor(value, key, path, helpers) {
            if ((0, $1VttG.default).isNode && (0, $bOBNq.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("1VttG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1671faf6ba507113$export$2e2bcd8739ae039; });

var $kWfK0 = parcelRequire("kWfK0");

var $bId3R = parcelRequire("bId3R");

var $e2pRo = parcelRequire("e2pRo");
var $1671faf6ba507113$export$2e2bcd8739ae039 = (0, $kWfK0._)({}, $e2pRo, (0, $bId3R.default));

});
parcelRegister("bId3R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $886def79add7f624$export$2e2bcd8739ae039; });

var $fZIfx = parcelRequire("fZIfx");

var $7duli = parcelRequire("7duli");

var $guy8g = parcelRequire("guy8g");
var $886def79add7f624$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, $fZIfx.default),
        FormData: (0, $7duli.default),
        Blob: (0, $guy8g.default)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("fZIfx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba4ee0974c157b4e$export$2e2bcd8739ae039; });

var $cAx8n = parcelRequire("cAx8n");
'use strict';
var $ba4ee0974c157b4e$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $cAx8n.default);

});

parcelRegister("7duli", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $541148b5a59ddb5e$export$2e2bcd8739ae039; });
'use strict';
var $541148b5a59ddb5e$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("guy8g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c019eca75ff2feee$export$2e2bcd8739ae039; });
'use strict';
var $c019eca75ff2feee$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("e2pRo", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $a3854fe3daec4385$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $a3854fe3daec4385$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $a3854fe3daec4385$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $a3854fe3daec4385$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $a3854fe3daec4385$export$f710a83a91838a36; });

var $5djcY = parcelRequire("5djcY");
var $a3854fe3daec4385$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
var $a3854fe3daec4385$export$ec7c8efa7f5790ae = (typeof navigator === "undefined" ? "undefined" : (0, $5djcY._)(navigator)) === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ var $a3854fe3daec4385$export$c0bcc9250309d66 = $a3854fe3daec4385$export$c4996c4b7b93b0bf && (!$a3854fe3daec4385$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($a3854fe3daec4385$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ var $a3854fe3daec4385$export$c81692cf5af97dac = function() {
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
}();
var $a3854fe3daec4385$export$f710a83a91838a36 = $a3854fe3daec4385$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("vFFoL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05f33781bfc81a97$export$2e2bcd8739ae039; });

var $bOBNq = parcelRequire("bOBNq");

var $3B0hl = parcelRequire("3B0hl");

var $8S0fp = parcelRequire("8S0fp");
'use strict';
var $05f33781bfc81a97$var$MAX_DEPTH = (0, $8S0fp.DEFAULT_FORM_DATA_MAX_DEPTH);
function $05f33781bfc81a97$var$throwIfDepthExceeded(index) {
    if (index > $05f33781bfc81a97$var$MAX_DEPTH) throw new (0, $3B0hl.default)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $05f33781bfc81a97$var$MAX_DEPTH, (0, $3B0hl.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $05f33781bfc81a97$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    var path = [];
    var pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    var match;
    while((match = pattern.exec(name)) !== null){
        $05f33781bfc81a97$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $05f33781bfc81a97$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $05f33781bfc81a97$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $05f33781bfc81a97$var$throwIfDepthExceeded(index);
        var name = path[index++];
        if (name === '__proto__') return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && (0, $bOBNq.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $bOBNq.default).hasOwnProp(target, name)) target[name] = (0, $bOBNq.default).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $bOBNq.default).hasOwnProp(target, name) || !(0, $bOBNq.default).isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && (0, $bOBNq.default).isArray(target[name])) target[name] = $05f33781bfc81a97$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $bOBNq.default).isFormData(formData) && (0, $bOBNq.default).isFunction(formData.entries)) {
        var obj = {};
        (0, $bOBNq.default).forEachEntry(formData, function(name, value) {
            buildPath($05f33781bfc81a97$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $05f33781bfc81a97$export$2e2bcd8739ae039 = $05f33781bfc81a97$var$formDataToJSON;

});

parcelRegister("kjGZu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eca6ee1512b27f7d$export$2e2bcd8739ae039; });
'use strict';
var $eca6ee1512b27f7d$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $eca6ee1512b27f7d$export$2e2bcd8739ae039 = $eca6ee1512b27f7d$var$methodList;

});



parcelRegister("7CoXk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58bf70b642244835$export$2e2bcd8739ae039; });
'use strict';
function $58bf70b642244835$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("a6CVI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75b8a99970638488$export$2e2bcd8739ae039; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $c2MhV = parcelRequire("c2MhV");

var $3B0hl = parcelRequire("3B0hl");
'use strict';
var $75b8a99970638488$var$CanceledError = /*#__PURE__*/ function(AxiosError1) {
    (0, $c2MhV._)(CanceledError, AxiosError1);
    function CanceledError(message, config, request) {
        (0, $4QweW._)(this, CanceledError);
        var _this;
        _this = (0, $ehF45._)(this, CanceledError, [
            message == null ? 'canceled' : message,
            (0, $3B0hl.default).ERR_CANCELED,
            config,
            request
        ]);
        _this.name = 'CanceledError';
        _this.__CANCEL__ = true;
        return _this;
    }
    return CanceledError;
}((0, $3B0hl.default));
var $75b8a99970638488$export$2e2bcd8739ae039 = $75b8a99970638488$var$CanceledError;

});

parcelRegister("hJdf9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce80e979ab4155f1$export$2e2bcd8739ae039; });

var $6ZpBv = parcelRequire("6ZpBv");

var $bOBNq = parcelRequire("bOBNq");

var $hOl4E = parcelRequire("hOl4E");

var $dUoj9 = parcelRequire("dUoj9");

var $bccjl = parcelRequire("bccjl");

var $3B0hl = parcelRequire("3B0hl");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ var $ce80e979ab4155f1$var$knownAdapters = {
    http: (0, $hOl4E.default),
    xhr: (0, $dUoj9.default),
    fetch: {
        get: $bccjl.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $bOBNq.default).forEach($ce80e979ab4155f1$var$knownAdapters, function(fn, value) {
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ var $ce80e979ab4155f1$var$renderReason = function(reason) {
    return "- ".concat(reason);
};
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ var $ce80e979ab4155f1$var$isResolvedHandle = function(adapter) {
    return (0, $bOBNq.default).isFunction(adapter) || adapter === null || adapter === false;
};
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $ce80e979ab4155f1$var$getAdapter(adapters, config) {
    adapters = (0, $bOBNq.default).isArray(adapters) ? adapters : [
        adapters
    ];
    var length = adapters.length;
    var nameOrAdapter;
    var adapter;
    var rejectedReasons = {};
    for(var i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        var id = void 0;
        adapter = nameOrAdapter;
        if (!$ce80e979ab4155f1$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $ce80e979ab4155f1$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $3B0hl.default)("Unknown adapter '".concat(id, "'"));
        }
        if (adapter && ((0, $bOBNq.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        var reasons = Object.entries(rejectedReasons).map(function(param) {
            var _param = (0, $6ZpBv._)(param, 2), id = _param[0], state = _param[1];
            return "adapter ".concat(id, " ") + (state === false ? 'is not supported by the environment' : 'is not available in the build');
        });
        var s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($ce80e979ab4155f1$var$renderReason).join('\n') : ' ' + $ce80e979ab4155f1$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $3B0hl.default)("There is no suitable adapter to dispatch the request " + s, (0, $3B0hl.default).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $ce80e979ab4155f1$export$2e2bcd8739ae039 = {
    /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ getAdapter: $ce80e979ab4155f1$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $ce80e979ab4155f1$var$knownAdapters
};

});
parcelRegister("dUoj9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2035c589c2927e6$export$2e2bcd8739ae039; });

var $6ZpBv = parcelRequire("6ZpBv");

var $bOBNq = parcelRequire("bOBNq");

var $9FJ60 = parcelRequire("9FJ60");

var $4zgkz = parcelRequire("4zgkz");

var $3B0hl = parcelRequire("3B0hl");

var $a6CVI = parcelRequire("a6CVI");

var $ev3Uy = parcelRequire("ev3Uy");

var $ku8Pv = parcelRequire("ku8Pv");

var $1VttG = parcelRequire("1VttG");

var $dgBgw = parcelRequire("dgBgw");

var $kyiIx = parcelRequire("kyiIx");

var $cnoMi = parcelRequire("cnoMi");

var $9F8ZO = parcelRequire("9F8ZO");
var $a2035c589c2927e6$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $a2035c589c2927e6$export$2e2bcd8739ae039 = $a2035c589c2927e6$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var _config = (0, $cnoMi.default)(config);
        var requestData = _config.data;
        var requestHeaders = (0, $dgBgw.default).from(_config.headers).normalize();
        var responseType = _config.responseType, onUploadProgress = _config.onUploadProgress, onDownloadProgress = _config.onDownloadProgress;
        var onCanceled;
        var uploadThrottled, downloadThrottled;
        var flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        var request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $ku8Pv.default)((0, $ev3Uy.default)(_config.url)) || (0, $ku8Pv.default)((0, $1VttG.default).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $3B0hl.default)('Request aborted', (0, $3B0hl.default).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(function() {
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            var responseHeaders = (0, $dgBgw.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $9FJ60.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $3B0hl.default)('Request aborted', (0, $3B0hl.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            var msg = event && event.message ? event.message : 'Network Error';
            var err = new (0, $3B0hl.default)(msg, (0, $3B0hl.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = _config.transitional || (0, $4zgkz.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $3B0hl.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $3B0hl.default).ETIMEDOUT : (0, $3B0hl.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $bOBNq.default).forEach((0, $9F8ZO.toByteStringHeaderObject)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $bOBNq.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            var ref;
            ref = (0, $6ZpBv._)((0, $kyiIx.progressEventReducer)(onDownloadProgress, true), 3), downloadThrottled = ref[0], flushDownload = ref[1], flushDownloadWithEvent = ref[2], ref;
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            var ref1;
            ref1 = (0, $6ZpBv._)((0, $kyiIx.progressEventReducer)(onUploadProgress), 2), uploadThrottled = ref1[0], flushUpload = ref1[1], ref1;
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $a6CVI.default)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        var protocol = (0, $ku8Pv.default)(_config.url);
        if (protocol && !(0, $1VttG.default).protocols.includes(protocol)) {
            reject(new (0, $3B0hl.default)('Unsupported protocol ' + protocol + ':', (0, $3B0hl.default).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("9FJ60", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70aaec78be9fa3d9$export$2e2bcd8739ae039; });

var $3B0hl = parcelRequire("3B0hl");
'use strict';
function $70aaec78be9fa3d9$export$2e2bcd8739ae039(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $3B0hl.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $3B0hl.default).ERR_BAD_REQUEST : (0, $3B0hl.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

});

parcelRegister("ev3Uy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8e6fe9f37ab0d68$export$2e2bcd8739ae039; });
'use strict';
var $a8e6fe9f37ab0d68$var$urlParserControlCharacters = /[\t\n\r]/g;
function $a8e6fe9f37ab0d68$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    var start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($a8e6fe9f37ab0d68$var$urlParserControlCharacters, '');
}

});

parcelRegister("ku8Pv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee9d755f9b4606f7$export$2e2bcd8739ae039; });
'use strict';
function $ee9d755f9b4606f7$export$2e2bcd8739ae039(url) {
    var match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("kyiIx", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $ef6580834aa2651b$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $ef6580834aa2651b$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $ef6580834aa2651b$export$5d35863c355a22a9; });

var $6tY97 = parcelRequire("6tY97");

var $jlUaU = parcelRequire("jlUaU");

var $69EC6 = parcelRequire("69EC6");

var $eOeQk = parcelRequire("eOeQk");

var $bOBNq = parcelRequire("bOBNq");
var $ef6580834aa2651b$export$c1b28109d46c3592 = function(listener, isDownloadStream) {
    var freq = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    var bytesNotified = 0;
    var _speedometer = (0, $69EC6.default)(50, 250);
    return (0, $eOeQk.default)(function(e) {
        if (!e || !(0, $bOBNq.default).isNumber(e.loaded)) return;
        var rawLoaded = e.loaded;
        var total = e.lengthComputable ? e.total : undefined;
        var loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        var progressBytes = Math.max(0, loaded - bytesNotified);
        var rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        var data = (0, $6tY97._)({
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        }, isDownloadStream ? 'download' : 'upload', true);
        listener(data);
    }, freq);
};
var $ef6580834aa2651b$export$d9fadd12586c18d6 = function(total, throttled) {
    var lengthComputable = total != null;
    return [
        function(loaded) {
            return throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            });
        },
        throttled[1]
    ];
};
var $ef6580834aa2651b$export$5d35863c355a22a9 = function(fn) {
    var scheduler = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $bOBNq.default).asap;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return scheduler(function() {
            return fn.apply(void 0, (0, $jlUaU._)(args));
        });
    };
};

});
parcelRegister("69EC6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47b3165e53b19be2$export$2e2bcd8739ae039; });
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $47b3165e53b19be2$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    var bytes = new Array(samplesCount);
    var timestamps = new Array(samplesCount);
    var head = 0;
    var tail = 0;
    var firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        var now = Date.now();
        var startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        var i = tail;
        var bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        var passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $47b3165e53b19be2$export$2e2bcd8739ae039 = $47b3165e53b19be2$var$speedometer;

});

parcelRegister("eOeQk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac813fb2b56dbfc7$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ 
var $jlUaU = parcelRequire("jlUaU");
function $ac813fb2b56dbfc7$var$throttle(fn, freq) {
    var timestamp = 0;
    var threshold = 1000 / freq;
    var lastArgs;
    var timer;
    var invoke = function(args) {
        var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(void 0, (0, $jlUaU._)(args));
    };
    var throttled = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        var passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(function() {
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    var flush = function() {
        return lastArgs && invoke(lastArgs);
    };
    var flushWith = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return invoke(args);
    };
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $ac813fb2b56dbfc7$export$2e2bcd8739ae039 = $ac813fb2b56dbfc7$var$throttle;

});


parcelRegister("cnoMi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $902ada6a6f0b8981$export$2e2bcd8739ae039; });

var $1VttG = parcelRequire("1VttG");

var $bOBNq = parcelRequire("bOBNq");

var $3B0hl = parcelRequire("3B0hl");

var $4ZtXk = parcelRequire("4ZtXk");

var $bkSS7 = parcelRequire("bkSS7");

var $jLdcF = parcelRequire("jLdcF");

var $3SOIK = parcelRequire("3SOIK");

var $dgBgw = parcelRequire("dgBgw");

var $wylfa = parcelRequire("wylfa");

var $49f9T = parcelRequire("49f9T");
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ var $902ada6a6f0b8981$var$encodeUTF8 = function(str) {
    return encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, function(_, hex) {
        return String.fromCharCode(parseInt(hex, 16));
    });
};
function $902ada6a6f0b8981$var$resolveConfig(config) {
    var newConfig = (0, $3SOIK.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    var own = function(key) {
        return (0, $bOBNq.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    };
    var data = own('data');
    var withXSRFToken = own('withXSRFToken');
    var xsrfHeaderName = own('xsrfHeaderName');
    var xsrfCookieName = own('xsrfCookieName');
    var headers = own('headers');
    var auth = own('auth');
    var baseURL = own('baseURL');
    var allowAbsoluteUrls = own('allowAbsoluteUrls');
    var url = own('url');
    newConfig.headers = headers = (0, $dgBgw.default).from(headers);
    newConfig.url = (0, $49f9T.default)((0, $jLdcF.default)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        var username = (0, $bOBNq.default).getSafeProp(auth, 'username') || '';
        var password = (0, $bOBNq.default).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $902ada6a6f0b8981$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $3B0hl.default).from(e, (0, $3B0hl.default).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $bOBNq.default).isFormData(data)) {
        var getHeaders = (0, $bOBNq.default).getSafeProp(data, 'getHeaders');
        if ((0, $1VttG.default).hasStandardBrowserEnv || (0, $1VttG.default).hasStandardBrowserWebWorkerEnv || (0, $bOBNq.default).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $bOBNq.default).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $wylfa.default)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $1VttG.default).hasStandardBrowserEnv) {
        if ((0, $bOBNq.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        var shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $4ZtXk.default)(newConfig.url);
        if (shouldSendXSRF) {
            var xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $bkSS7.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $902ada6a6f0b8981$export$2e2bcd8739ae039 = $902ada6a6f0b8981$var$resolveConfig;

});
parcelRegister("4ZtXk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a24188b26c64664$export$2e2bcd8739ae039; });

var $1VttG = parcelRequire("1VttG");
var $3a24188b26c64664$export$2e2bcd8739ae039 = (0, $1VttG.default).hasStandardBrowserEnv ? function(origin, isMSIE) {
    return function(url) {
        url = new URL(url, (0, $1VttG.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    };
}(new URL((0, $1VttG.default).origin), (0, $1VttG.default).navigator && /(msie|trident)/i.test((0, $1VttG.default).navigator.userAgent)) : function() {
    return true;
};

});

parcelRegister("bkSS7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $840c206755cca946$export$2e2bcd8739ae039; });

var $bOBNq = parcelRequire("bOBNq");

var $1VttG = parcelRequire("1VttG");
var $840c206755cca946$export$2e2bcd8739ae039 = (0, $1VttG.default).hasStandardBrowserEnv ? {
    write: function(name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        var cookie = [
            "".concat(name, "=").concat(encodeURIComponent(value))
        ];
        if ((0, $bOBNq.default).isNumber(expires)) cookie.push("expires=".concat(new Date(expires).toUTCString()));
        if ((0, $bOBNq.default).isString(path)) cookie.push("path=".concat(path));
        if ((0, $bOBNq.default).isString(domain)) cookie.push("domain=".concat(domain));
        if (secure === true) cookie.push('secure');
        if ((0, $bOBNq.default).isString(sameSite)) cookie.push("SameSite=".concat(sameSite));
        document.cookie = cookie.join('; ');
    },
    read: function(name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        var cookies = document.cookie.split(';');
        for(var i = 0; i < cookies.length; i++){
            var cookie = cookies[i].replace(/^\s+/, '');
            var eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove: function(name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write: function() {},
    read: function() {
        return null;
    },
    remove: function() {}
};

});

parcelRegister("jLdcF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e62ca606e79d8973$export$2e2bcd8739ae039; });

var $3B0hl = parcelRequire("3B0hl");

var $ghsmo = parcelRequire("ghsmo");

var $igQnl = parcelRequire("igQnl");

var $ev3Uy = parcelRequire("ev3Uy");
'use strict';
var $e62ca606e79d8973$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $e62ca606e79d8973$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, function(match, separator) {
        var parameterName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';
        return "".concat(separator).concat(parameterName).concat((0, $3B0hl.REDACTED));
    });
}
function $e62ca606e79d8973$var$redactSensitiveURLParts(url) {
    var redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, "$1".concat((0, $3B0hl.REDACTED), "@"));
    var fragmentIndex = redactedURL.indexOf('#');
    var urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    var redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, "$1".concat((0, $3B0hl.REDACTED)));
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return "".concat(redactedURLWithoutFragment, "#").concat($e62ca606e79d8973$var$redactFragment(redactedURL.slice(fragmentIndex + 1)));
}
function $e62ca606e79d8973$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        var normalizedURL = (0, $ev3Uy.default)(url);
        if ($e62ca606e79d8973$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $3B0hl.default)("Invalid URL ".concat(JSON.stringify($e62ca606e79d8973$var$redactSensitiveURLParts(normalizedURL)), ': missing "//" after protocol'), (0, $3B0hl.default).ERR_INVALID_URL, config);
    }
}
function $e62ca606e79d8973$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $e62ca606e79d8973$var$assertValidHttpProtocolURL(requestedURL, config);
    var isRelativeUrl = !(0, $ghsmo.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $e62ca606e79d8973$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $igQnl.default)(baseURL, requestedURL);
    }
    return requestedURL;
}

});
parcelRegister("ghsmo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bda43b97e498eea2$export$2e2bcd8739ae039; });
'use strict';
function $bda43b97e498eea2$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("igQnl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4d2594bfe419509$export$2e2bcd8739ae039; });
'use strict';
function $d4d2594bfe419509$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    var end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}

});


parcelRegister("3SOIK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d3dc24dcdf2e1a3$export$2e2bcd8739ae039; });

var $kWfK0 = parcelRequire("kWfK0");

var $bOBNq = parcelRequire("bOBNq");

var $dgBgw = parcelRequire("dgBgw");
'use strict';
var $2d3dc24dcdf2e1a3$var$headersToObject = function(thing) {
    return thing instanceof (0, $dgBgw.default) ? (0, $kWfK0._)({}, thing) : thing;
};
var $2d3dc24dcdf2e1a3$var$ownEnumerableKeys = function(thing) {
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter(function(symbol) {
        return Object.getOwnPropertyDescriptor(thing, symbol).enumerable;
    }));
    return Object.keys(thing);
};
function $2d3dc24dcdf2e1a3$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    var config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $bOBNq.default).isPlainObject(target) && (0, $bOBNq.default).isPlainObject(source)) return (0, $bOBNq.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $bOBNq.default).isPlainObject(source)) return (0, $bOBNq.default).merge({}, source);
        else if ((0, $bOBNq.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $bOBNq.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $bOBNq.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $bOBNq.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $bOBNq.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $bOBNq.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        var transitional2 = (0, $bOBNq.default).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $bOBNq.default).isUndefined(transitional2)) {
            if ((0, $bOBNq.default).isPlainObject(transitional2)) {
                if ((0, $bOBNq.default).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        var transitional1 = (0, $bOBNq.default).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $bOBNq.default).isPlainObject(transitional1) && (0, $bOBNq.default).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $bOBNq.default).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $bOBNq.default).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    var mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: function(a, b, prop) {
            return mergeDeepProperties($2d3dc24dcdf2e1a3$var$headersToObject(a), $2d3dc24dcdf2e1a3$var$headersToObject(b), prop, true);
        }
    };
    (0, $bOBNq.default).forEach($2d3dc24dcdf2e1a3$var$ownEnumerableKeys((0, $kWfK0._)({}, config1, config2)), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        var merge = (0, $bOBNq.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        var a = (0, $bOBNq.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        var b = (0, $bOBNq.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        var configValue = merge(a, b, prop);
        (0, $bOBNq.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $bOBNq.default).hasOwnProp(config2, 'validateStatus') && (0, $bOBNq.default).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $bOBNq.default).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}

});

parcelRegister("wylfa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $061da0cedac92213$export$2e2bcd8739ae039; });

var $6ZpBv = parcelRequire("6ZpBv");
'use strict';
var $061da0cedac92213$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $061da0cedac92213$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(function(param) {
        var _param = (0, $6ZpBv._)(param, 2), key = _param[0], val = _param[1];
        if ($061da0cedac92213$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}

});



parcelRegister("bccjl", function(module, exports) {

$parcel$export(module.exports, "getFetch", function () { return $826a5d657928624a$export$3105c6651375d4fa; });

var $dxEC4 = parcelRequire("dxEC4");

var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $gh3Df = parcelRequire("gh3Df");

var $1VttG = parcelRequire("1VttG");

var $bOBNq = parcelRequire("bOBNq");

var $3B0hl = parcelRequire("3B0hl");

var $3ZsY7 = parcelRequire("3ZsY7");

var $MkiRa = parcelRequire("MkiRa");

var $dgBgw = parcelRequire("dgBgw");

var $kyiIx = parcelRequire("kyiIx");

var $cnoMi = parcelRequire("cnoMi");

var $9FJ60 = parcelRequire("9FJ60");

var $byZUr = parcelRequire("byZUr");

var $bMHPm = parcelRequire("bMHPm");

var $9F8ZO = parcelRequire("9F8ZO");
var $826a5d657928624a$var$DEFAULT_CHUNK_SIZE = 65536;
var $826a5d657928624a$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
var $826a5d657928624a$var$isFunction = (0, $bOBNq.default).isFunction;
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ var $826a5d657928624a$var$encodeUTF8 = function(str) {
    return encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, function(_, hex) {
        return String.fromCharCode(parseInt(hex, 16));
    });
};
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
var $826a5d657928624a$var$decodeURIComponentSafe = function(value) {
    if (!(0, $bOBNq.default).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
var $826a5d657928624a$var$test = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    try {
        return !!fn.apply(void 0, (0, $jlUaU._)(args));
    } catch (e) {
        return false;
    }
};
var $826a5d657928624a$var$maybeWithAuthCredentials = function(url) {
    var protocolIndex = url.indexOf('://');
    var urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
var $826a5d657928624a$var$factory = function(env) {
    var globalObject = (0, $bOBNq.default).global !== undefined && (0, $bOBNq.default).global !== null ? (0, $bOBNq.default).global : globalThis;
    var ReadableStream = globalObject.ReadableStream, TextEncoder = globalObject.TextEncoder;
    env = (0, $bOBNq.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    var envFetch = env.fetch, Request = env.Request, Response = env.Response;
    var isFetchSupported = envFetch ? $826a5d657928624a$var$isFunction(envFetch) : typeof fetch === 'function';
    var isRequestSupported = $826a5d657928624a$var$isFunction(Request);
    var isResponseSupported = $826a5d657928624a$var$isFunction(Response);
    if (!isFetchSupported) return false;
    var isReadableStreamSupported = isFetchSupported && $826a5d657928624a$var$isFunction(ReadableStream);
    var encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? function(encoder) {
        return function(str) {
            return encoder.encode(str);
        };
    }(new TextEncoder()) : function(str) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = Uint8Array.bind;
                        return [
                            4,
                            new Request(str).arrayBuffer()
                        ];
                    case 1:
                        return [
                            2,
                            new (_.apply(Uint8Array, [
                                void 0,
                                _state.sent()
                            ]))
                        ];
                }
            });
        })();
    });
    var supportsRequestStream = isRequestSupported && isReadableStreamSupported && $826a5d657928624a$var$test(function() {
        var duplexAccessed = false;
        var request = new Request((0, $1VttG.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        var hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    var supportsResponseStream = isResponseSupported && isReadableStreamSupported && $826a5d657928624a$var$test(function() {
        return (0, $bOBNq.default).isReadableStream(new Response('').body);
    });
    var resolvers = {
        stream: supportsResponseStream && function(res) {
            return res.body;
        }
    };
    isFetchSupported && function() {
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach(function(type) {
            !resolvers[type] && (resolvers[type] = function(res, config) {
                var method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $3B0hl.default)("Response type '".concat(type, "' is not supported"), (0, $3B0hl.default).ERR_NOT_SUPPORT, config);
            });
        });
    }();
    var getBodyLength = function(body) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _request;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (body == null) return [
                            2,
                            0
                        ];
                        if ((0, $bOBNq.default).isBlob(body)) return [
                            2,
                            body.size
                        ];
                        if (!(0, $bOBNq.default).isSpecCompliantForm(body)) return [
                            3,
                            2
                        ];
                        _request = new Request((0, $1VttG.default).origin, {
                            method: 'POST',
                            body: body
                        });
                        return [
                            4,
                            _request.arrayBuffer()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent().byteLength
                        ];
                    case 2:
                        if ((0, $bOBNq.default).isArrayBufferView(body) || (0, $bOBNq.default).isArrayBuffer(body)) return [
                            2,
                            body.byteLength
                        ];
                        if ((0, $bOBNq.default).isURLSearchParams(body)) body = body + '';
                        if (!(0, $bOBNq.default).isString(body)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            encodeText(body)
                        ];
                    case 3:
                        return [
                            2,
                            _state.sent().byteLength
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var resolveBodyLength = function(headers, body) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var length;
            return (0, $gh3Df._)(this, function(_state) {
                length = (0, $bOBNq.default).toFiniteNumber(headers.getContentLength());
                return [
                    2,
                    length == null ? getBodyLength(body) : length
                ];
            });
        })();
    };
    return function(config) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var _resolveConfig, url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, _resolveConfig_withCredentials, withCredentials, fetchOptions, maxContentLength, maxBodyLength, maxRedirects, hasMaxContentLength, hasMaxBodyLength, own, _fetch, composedSignal, request, unsubscribe, requestContentLength, pendingBodyError, maxBodyLengthError, auth, configAuth, username, password, parsedURL, urlUsername, urlPassword, estimated, outboundLength, mustEnforceStreamBody, trackRequestStream, _tmp, _request, contentTypeHeader, _ref, onProgress, flush, isCredentialsSupported, contentType, safeFetchOptions, resolvedOptions, response, responseHeaders, declaredLength, isStreamResponse, options, responseContentLength, _ref1, onProgress1, flush1, bytesRead, onChunkProgress, responseData, materializedSize, err, canceledError, networkError;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _resolveConfig = (0, $cnoMi.default)(config), url = _resolveConfig.url, method = _resolveConfig.method, data = _resolveConfig.data, signal = _resolveConfig.signal, cancelToken = _resolveConfig.cancelToken, timeout = _resolveConfig.timeout, onDownloadProgress = _resolveConfig.onDownloadProgress, onUploadProgress = _resolveConfig.onUploadProgress, responseType = _resolveConfig.responseType, headers = _resolveConfig.headers, _resolveConfig_withCredentials = _resolveConfig.withCredentials, withCredentials = _resolveConfig_withCredentials === void 0 ? 'same-origin' : _resolveConfig_withCredentials, fetchOptions = _resolveConfig.fetchOptions, maxContentLength = _resolveConfig.maxContentLength, maxBodyLength = _resolveConfig.maxBodyLength, maxRedirects = _resolveConfig.maxRedirects;
                        hasMaxContentLength = (0, $bOBNq.default).isNumber(maxContentLength) && maxContentLength > -1;
                        hasMaxBodyLength = (0, $bOBNq.default).isNumber(maxBodyLength) && maxBodyLength > -1;
                        own = function(key) {
                            return (0, $bOBNq.default).hasOwnProp(config, key) ? config[key] : undefined;
                        };
                        _fetch = envFetch || fetch;
                        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
                        composedSignal = (0, $3ZsY7.default)([
                            signal,
                            cancelToken && cancelToken.toAbortSignal()
                        ], timeout);
                        request = null;
                        unsubscribe = composedSignal && composedSignal.unsubscribe && function() {
                            composedSignal.unsubscribe();
                        };
                        // AxiosError we raise while the request body is being streamed. Captured
                        // by identity so the catch block can surface it directly, regardless of
                        // how the runtime wraps the resulting fetch rejection (undici exposes it
                        // as `err.cause`; some browsers drop the original error entirely).
                        pendingBodyError = null;
                        maxBodyLengthError = function() {
                            return new (0, $3B0hl.default)('Request body larger than maxBodyLength limit', (0, $3B0hl.default).ERR_BAD_REQUEST, config, request);
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            12,
                            ,
                            13
                        ]);
                        // HTTP basic authentication
                        auth = undefined;
                        configAuth = own('auth');
                        if (configAuth) {
                            username = (0, $bOBNq.default).getSafeProp(configAuth, 'username') || '';
                            password = (0, $bOBNq.default).getSafeProp(configAuth, 'password') || '';
                            auth = {
                                username: username,
                                password: password
                            };
                        }
                        if ($826a5d657928624a$var$maybeWithAuthCredentials(url)) {
                            parsedURL = new URL(url, (0, $1VttG.default).origin);
                            if (!auth && (parsedURL.username || parsedURL.password)) {
                                urlUsername = $826a5d657928624a$var$decodeURIComponentSafe(parsedURL.username);
                                urlPassword = $826a5d657928624a$var$decodeURIComponentSafe(parsedURL.password);
                                auth = {
                                    username: urlUsername,
                                    password: urlPassword
                                };
                            }
                            if (parsedURL.username || parsedURL.password) {
                                parsedURL.username = '';
                                parsedURL.password = '';
                                url = parsedURL.href;
                            }
                        }
                        if (auth) {
                            headers.delete('authorization');
                            headers.set('Authorization', 'Basic ' + btoa($826a5d657928624a$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
                        }
                        // Enforce maxContentLength for data: URLs up-front so we never materialize
                        // an oversized payload. The HTTP adapter applies the same check (see http.js
                        // "if (protocol === 'data:')" branch).
                        if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                            estimated = (0, $byZUr.default)(url);
                            if (estimated > maxContentLength) throw new (0, $3B0hl.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $3B0hl.default).ERR_BAD_RESPONSE, config, request);
                        }
                        if (!(hasMaxBodyLength && method !== 'get' && method !== 'head')) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            getBodyLength(data)
                        ];
                    case 2:
                        outboundLength = _state.sent();
                        if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                            requestContentLength = outboundLength;
                            if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                        }
                        _state.label = 3;
                    case 3:
                        // A streamed body under maxBodyLength must be counted as fetch consumes
                        // it; its size is never trusted from a caller-declared Content-Length.
                        mustEnforceStreamBody = hasMaxBodyLength && ((0, $bOBNq.default).isReadableStream(data) || (0, $bOBNq.default).isStream(data));
                        trackRequestStream = function(stream, onProgress, flush) {
                            return (0, $MkiRa.trackStream)(stream, $826a5d657928624a$var$DEFAULT_CHUNK_SIZE, function(loadedBytes) {
                                if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                                onProgress && onProgress(loadedBytes);
                            }, flush);
                        };
                        if (!(supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody))) return [
                            3,
                            7
                        ];
                        if (!(requestContentLength == null)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            resolveBodyLength(headers, data)
                        ];
                    case 4:
                        _tmp = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        _tmp = requestContentLength;
                        _state.label = 6;
                    case 6:
                        requestContentLength = _tmp;
                        // A declared length of 0 is only trusted to skip the wrap when we are
                        // not enforcing a stream limit (which must not rely on that header).
                        if (requestContentLength !== 0 || mustEnforceStreamBody) {
                            _request = new Request(url, {
                                method: 'POST',
                                body: data,
                                duplex: 'half'
                            });
                            ;
                            if ((0, $bOBNq.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                            if (_request.body) {
                                _ref = (0, $6ZpBv._)(onUploadProgress && (0, $kyiIx.progressEventDecorator)(requestContentLength, (0, $kyiIx.progressEventReducer)((0, $kyiIx.asyncDecorator)(onUploadProgress))) || [], 2), onProgress = _ref[0], flush = _ref[1];
                                data = trackRequestStream(_request.body, onProgress, flush);
                            }
                        }
                        return [
                            3,
                            8
                        ];
                    case 7:
                        if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
                        else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $3B0hl.default)('Stream request bodies are not supported by the current fetch implementation', (0, $3B0hl.default).ERR_NOT_SUPPORT, config, request);
                        _state.label = 8;
                    case 8:
                        if (!(0, $bOBNq.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
                        // Cloudflare Workers throws when credentials are defined
                        // see https://github.com/cloudflare/workerd/issues/902
                        isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
                        // If data is FormData and Content-Type is multipart/form-data without boundary,
                        // delete it so fetch can set it correctly with the boundary
                        if ((0, $bOBNq.default).isFormData(data)) {
                            contentType = headers.getContentType();
                            if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
                        }
                        // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
                        headers.set('User-Agent', 'axios/' + (0, $bMHPm.VERSION), false);
                        safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
                        if (safeFetchOptions) {
                            // These options are owned by Axios and are already reflected in the
                            // resolved Request passed to fetch.
                            delete safeFetchOptions.body;
                            delete safeFetchOptions.headers;
                            delete safeFetchOptions.method;
                            delete safeFetchOptions.signal;
                            delete safeFetchOptions.duplex;
                            delete safeFetchOptions.credentials;
                        }
                        resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                            signal: composedSignal,
                            method: method.toUpperCase(),
                            headers: (0, $9F8ZO.toByteStringHeaderObject)(headers.normalize()),
                            body: data,
                            duplex: 'half',
                            credentials: isCredentialsSupported ? withCredentials : undefined
                        });
                        if (isRequestSupported) {
                            (0, $bOBNq.default).forEach($826a5d657928624a$var$DEFAULT_REQUEST_OPTIONS, function(value, key) {
                                if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                            });
                            if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                            if (resolvedOptions.body === undefined) resolvedOptions.body = null;
                        }
                        if (maxRedirects === 0) {
                            resolvedOptions.redirect = 'manual';
                            if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
                        }
                        request = isRequestSupported && new Request(url, resolvedOptions);
                        return [
                            4,
                            isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions)
                        ];
                    case 9:
                        response = _state.sent();
                        responseHeaders = (0, $dgBgw.default).from(response.headers);
                        // Cheap pre-check: if the server honestly declares a content-length that
                        // already exceeds the cap, reject before we start streaming.
                        if (hasMaxContentLength) {
                            declaredLength = (0, $bOBNq.default).toFiniteNumber(responseHeaders.getContentLength());
                            if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $3B0hl.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $3B0hl.default).ERR_BAD_RESPONSE, config, request);
                        }
                        isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
                        if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                            options = {};
                            [
                                'status',
                                'statusText',
                                'headers'
                            ].forEach(function(prop) {
                                options[prop] = response[prop];
                            });
                            responseContentLength = (0, $bOBNq.default).toFiniteNumber(responseHeaders.getContentLength());
                            _ref1 = (0, $6ZpBv._)(onDownloadProgress && (0, $kyiIx.progressEventDecorator)(responseContentLength, (0, $kyiIx.progressEventReducer)((0, $kyiIx.asyncDecorator)(onDownloadProgress), true)) || [], 2), onProgress1 = _ref1[0], flush1 = _ref1[1];
                            bytesRead = 0;
                            onChunkProgress = function(loadedBytes) {
                                if (hasMaxContentLength) {
                                    bytesRead = loadedBytes;
                                    if (bytesRead > maxContentLength) throw new (0, $3B0hl.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $3B0hl.default).ERR_BAD_RESPONSE, config, request);
                                }
                                onProgress1 && onProgress1(loadedBytes);
                            };
                            response = new Response((0, $MkiRa.trackStream)(response.body, $826a5d657928624a$var$DEFAULT_CHUNK_SIZE, onChunkProgress, function() {
                                flush1 && flush1();
                                unsubscribe && unsubscribe();
                            }), options);
                        }
                        responseType = responseType || 'text';
                        return [
                            4,
                            resolvers[(0, $bOBNq.default).findKey(resolvers, responseType) || 'text'](response, config)
                        ];
                    case 10:
                        responseData = _state.sent();
                        // Fallback enforcement for environments without ReadableStream support
                        // (legacy runtimes). Detect materialized size from typed output; skip
                        // streams/Response passthrough since the user will read those themselves.
                        if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                            ;
                            if (responseData != null) {
                                if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                                else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                                else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                            }
                            if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $3B0hl.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $3B0hl.default).ERR_BAD_RESPONSE, config, request);
                        }
                        !isStreamResponse && unsubscribe && unsubscribe();
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                (0, $9FJ60.default)(resolve, reject, {
                                    data: responseData,
                                    headers: (0, $dgBgw.default).from(response.headers),
                                    status: response.status,
                                    statusText: response.statusText,
                                    config: config,
                                    request: request
                                });
                            })
                        ];
                    case 11:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 12:
                        err = _state.sent();
                        unsubscribe && unsubscribe();
                        // Safari can surface fetch aborts as a DOMException-like object whose
                        // branded getters throw. Prefer our composed signal reason before reading
                        // the caught error, preserving timeout vs cancellation semantics.
                        if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $3B0hl.default)) {
                            canceledError = composedSignal.reason;
                            canceledError.config = config;
                            request && (canceledError.request = request);
                            if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                            // don't recurse into circular fetch internals (see #7205).
                            Object.defineProperty(canceledError, 'cause', {
                                __proto__: null,
                                value: err,
                                writable: true,
                                enumerable: false,
                                configurable: true
                            });
                            throw canceledError;
                        }
                        // Surface a maxBodyLength violation we raised while the request body was
                        // being streamed. Matching by identity (rather than reading
                        // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
                        // and avoids both prototype-pollution reads and mis-attributing a foreign
                        // AxiosError that merely happened to land in `err.cause`.
                        if (pendingBodyError) {
                            request && !pendingBodyError.request && (pendingBodyError.request = request);
                            throw pendingBodyError;
                        }
                        // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
                        // pre-checks, response size enforcement) without re-wrapping them.
                        if (err instanceof (0, $3B0hl.default)) {
                            request && !err.request && (err.request = request);
                            throw err;
                        }
                        if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                            networkError = new (0, $3B0hl.default)('Network Error', (0, $3B0hl.default).ERR_NETWORK, config, request, err && err.response);
                            // Non-enumerable to match native Error `cause` semantics so loggers
                            // don't recurse into circular fetch internals (see #7205).
                            Object.defineProperty(networkError, 'cause', {
                                __proto__: null,
                                value: err.cause || err,
                                writable: true,
                                enumerable: false,
                                configurable: true
                            });
                            throw networkError;
                        }
                        throw (0, $3B0hl.default).from(err, err && err.code, config, request, err && err.response);
                    case 13:
                        return [
                            2
                        ];
                }
            });
        })();
    };
};
var $826a5d657928624a$var$seedCache = new Map();
var $826a5d657928624a$export$3105c6651375d4fa = function(config) {
    var env = config && config.env || {};
    var fetch1 = env.fetch, Request = env.Request, Response = env.Response;
    var seeds = [
        Request,
        Response,
        fetch1
    ];
    var len = seeds.length, i = len, seed, target, map = $826a5d657928624a$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $826a5d657928624a$var$factory(env));
        map = target;
    }
    return target;
};
var $826a5d657928624a$var$adapter = $826a5d657928624a$export$3105c6651375d4fa();
var $826a5d657928624a$export$2e2bcd8739ae039 = $826a5d657928624a$var$adapter;

});
parcelRegister("3ZsY7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e7d8a2925c70586$export$2e2bcd8739ae039; });

var $a6CVI = parcelRequire("a6CVI");

var $3B0hl = parcelRequire("3B0hl");

var $bOBNq = parcelRequire("bOBNq");
var $2e7d8a2925c70586$var$composeSignals = function(signals, timeout) {
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    var controller = new AbortController();
    var aborted = false;
    var onabort = function onabort(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            var err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $3B0hl.default) ? err : new (0, $a6CVI.default)(err instanceof Error ? err.message : err));
        }
    };
    var timer = timeout && setTimeout(function() {
        timer = null;
        onabort(new (0, $3B0hl.default)("timeout of ".concat(timeout, "ms exceeded"), (0, $3B0hl.default).ETIMEDOUT));
    }, timeout);
    var unsubscribe = function() {
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(function(signal) {
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach(function(signal) {
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    var signal = controller.signal;
    signal.unsubscribe = function() {
        return (0, $bOBNq.default).asap(unsubscribe);
    };
    return signal;
};
var $2e7d8a2925c70586$export$2e2bcd8739ae039 = $2e7d8a2925c70586$var$composeSignals;

});

parcelRegister("MkiRa", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $09143b9702493898$export$b0119225647bd83; });

var $3AkVG = parcelRequire("3AkVG");

var $l2oQm = parcelRequire("l2oQm");

var $dxEC4 = parcelRequire("dxEC4");

var $5JVIZ = parcelRequire("5JVIZ");

var $48tGp = parcelRequire("48tGp");

var $gh3Df = parcelRequire("gh3Df");

var $2TaHn = parcelRequire("2TaHn");
var $09143b9702493898$export$71b051935044bd5d = function streamChunk(chunk, chunkSize) {
    var len, pos, end;
    return (0, $gh3Df._)(this, function(_state) {
        switch(_state.label){
            case 0:
                len = chunk.byteLength;
                if (!(!chunkSize || len < chunkSize)) return [
                    3,
                    2
                ];
                return [
                    4,
                    chunk
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                pos = 0;
                _state.label = 3;
            case 3:
                if (!(pos < len)) return [
                    3,
                    5
                ];
                end = pos + chunkSize;
                return [
                    4,
                    chunk.slice(pos, end)
                ];
            case 4:
                _state.sent();
                pos = end;
                return [
                    3,
                    3
                ];
            case 5:
                return [
                    2
                ];
        }
    });
};
var $09143b9702493898$export$f9f241124ee3198e = function readBytes(iterable, chunkSize) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $48tGp._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        13
                    ]);
                    _iterator = (0, $l2oQm._)($09143b9702493898$var$readStream(iterable));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $5JVIZ._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        6
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        5,
                        (0, $2TaHn.__values)((0, $3AkVG._)((0, $l2oQm._)($09143b9702493898$export$71b051935044bd5d(chunk, chunkSize))))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        ,
                        11,
                        12
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (0, $5JVIZ._)(_iterator.return())
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $09143b9702493898$var$readStream = function readStream(stream) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $48tGp._)(function() {
        var reader, _ref, done, value;
        return (0, $gh3Df._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!stream[Symbol.asyncIterator]) return [
                        3,
                        2
                    ];
                    return [
                        5,
                        (0, $2TaHn.__values)((0, $3AkVG._)((0, $l2oQm._)(stream)))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
                case 2:
                    reader = stream.getReader();
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        9,
                        11
                    ]);
                    _state.label = 4;
                case 4:
                    return [
                        4,
                        (0, $5JVIZ._)(reader.read())
                    ];
                case 5:
                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                    if (done) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        value
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        4
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    return [
                        4,
                        (0, $5JVIZ._)(reader.cancel())
                    ];
                case 10:
                    _state.sent();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $09143b9702493898$export$b0119225647bd83 = function(stream, chunkSize, onProgress, onFinish) {
    var iterator = $09143b9702493898$export$f9f241124ee3198e(stream, chunkSize);
    var bytes = 0;
    var done;
    var _onFinish = function(e) {
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        pull: function(controller) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                var _ref, done, value, len, loadedBytes, err;
                return (0, $gh3Df._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                iterator.next()
                            ];
                        case 1:
                            _ref = _state.sent(), done = _ref.done, value = _ref.value;
                            if (done) {
                                _onFinish();
                                controller.close();
                                return [
                                    2
                                ];
                            }
                            len = value.byteLength;
                            if (onProgress) {
                                loadedBytes = bytes += len;
                                onProgress(loadedBytes);
                            }
                            controller.enqueue(new Uint8Array(value));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            _onFinish(err);
                            throw err;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        cancel: function(reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});
parcelRegister("3AkVG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $29c4f8057000d0b8$export$71511d61b312f219; });

var $4Vwi4 = parcelRequire("4Vwi4");
function $29c4f8057000d0b8$export$71511d61b312f219(inner) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: new (0, $4Vwi4._)(value, /* kind: delegate */ 1)
        };
    }
    iter[typeof Symbol !== "undefined" && Symbol.iterator || "@@iterator"] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("return", value);
    };
    return iter;
}

});
parcelRegister("4Vwi4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $39658880e8a663ea$export$71511d61b312f219; });
function $39658880e8a663ea$export$71511d61b312f219(value, /** 0: await 1: delegate */ kind) {
    this.v = value;
    this.k = kind;
}

});


parcelRegister("l2oQm", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f50d0e464195ac0b$export$71511d61b312f219; });
function $f50d0e464195ac0b$export$71511d61b312f219(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $f50d0e464195ac0b$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $f50d0e464195ac0b$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $f50d0e464195ac0b$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $f50d0e464195ac0b$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $f50d0e464195ac0b$var$AsyncFromSyncIterator(s);
}

});

parcelRegister("5JVIZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $42ddeea20d941966$export$71511d61b312f219; });

var $4Vwi4 = parcelRequire("4Vwi4");
function $42ddeea20d941966$export$71511d61b312f219(value) {
    return new (0, $4Vwi4._)(value, /* kind: await */ 0);
}

});

parcelRegister("48tGp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $302eef3233a48ce5$export$71511d61b312f219; });

var $l2tnh = parcelRequire("l2tnh");
function $302eef3233a48ce5$export$71511d61b312f219(fn) {
    return function() {
        return new (0, $l2tnh._)(fn.apply(this, arguments));
    };
}

});
parcelRegister("l2tnh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f5109207aaf64b9a$export$71511d61b312f219; });

var $4Vwi4 = parcelRequire("4Vwi4");
function $f5109207aaf64b9a$export$71511d61b312f219(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var overloaded = value instanceof (0, $4Vwi4._);
            Promise.resolve(overloaded ? value.v : value).then(function(arg) {
                if (overloaded) {
                    var nextKey = key === "return" ? "return" : "next";
                    if (!value.k || arg.done) return resume(nextKey, arg);
                    else arg = gen[nextKey](arg).value;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
$f5109207aaf64b9a$export$71511d61b312f219.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
};
$f5109207aaf64b9a$export$71511d61b312f219.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$f5109207aaf64b9a$export$71511d61b312f219.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$f5109207aaf64b9a$export$71511d61b312f219.prototype.return = function(arg) {
    return this._invoke("return", arg);
};

});


parcelRegister("2TaHn", function(module, exports) {

$parcel$export(module.exports, "__values", function () { return $e8d611dd65e01992$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $5djcY = parcelRequire("5djcY");
var $e8d611dd65e01992$var$extendStatics = function extendStatics1(d, b) {
    $e8d611dd65e01992$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e8d611dd65e01992$var$extendStatics(d, b);
};
function $e8d611dd65e01992$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e8d611dd65e01992$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e8d611dd65e01992$export$18ce0697a983be9b = function __assign1() {
    $e8d611dd65e01992$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e8d611dd65e01992$export$18ce0697a983be9b.apply(this, arguments);
};
function $e8d611dd65e01992$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e8d611dd65e01992$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $5djcY._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e8d611dd65e01992$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e8d611dd65e01992$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5djcY._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e8d611dd65e01992$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e8d611dd65e01992$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $5djcY._)(x)) === "symbol" ? x : "".concat(x);
}
function $e8d611dd65e01992$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5djcY._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e8d611dd65e01992$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $5djcY._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e8d611dd65e01992$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e8d611dd65e01992$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e8d611dd65e01992$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e8d611dd65e01992$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e8d611dd65e01992$export$45d3717a4c69092e(o, m, p);
}
function $e8d611dd65e01992$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e8d611dd65e01992$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e8d611dd65e01992$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e8d611dd65e01992$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e8d611dd65e01992$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e8d611dd65e01992$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e8d611dd65e01992$export$10c90e4f7922046c(v) {
    return this instanceof $e8d611dd65e01992$export$10c90e4f7922046c ? (this.v = v, this) : new $e8d611dd65e01992$export$10c90e4f7922046c(v);
}
function $e8d611dd65e01992$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e8d611dd65e01992$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e8d611dd65e01992$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e8d611dd65e01992$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e8d611dd65e01992$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e8d611dd65e01992$export$19a8beecd37a4c45 === "function" ? $e8d611dd65e01992$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e8d611dd65e01992$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e8d611dd65e01992$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $e8d611dd65e01992$var$ownKeys = function ownKeys1(o) {
    $e8d611dd65e01992$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $e8d611dd65e01992$var$ownKeys(o);
};
function $e8d611dd65e01992$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $e8d611dd65e01992$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $e8d611dd65e01992$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $e8d611dd65e01992$var$__setModuleDefault(result, mod);
    return result;
}
function $e8d611dd65e01992$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e8d611dd65e01992$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e8d611dd65e01992$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e8d611dd65e01992$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $5djcY._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e8d611dd65e01992$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $5djcY._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e8d611dd65e01992$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e8d611dd65e01992$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e8d611dd65e01992$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $e8d611dd65e01992$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $e8d611dd65e01992$export$2e2bcd8739ae039 = {
    __extends: $e8d611dd65e01992$export$a8ba968b8961cb8a,
    __assign: $e8d611dd65e01992$export$18ce0697a983be9b,
    __rest: $e8d611dd65e01992$export$3c9a16f847548506,
    __decorate: $e8d611dd65e01992$export$29e00dfd3077644b,
    __param: $e8d611dd65e01992$export$d5ad3fd78186038f,
    __esDecorate: $e8d611dd65e01992$export$3a84e1ae4e97e9b0,
    __runInitializers: $e8d611dd65e01992$export$d831c04e792af3d,
    __propKey: $e8d611dd65e01992$export$6a2a36740a146cb8,
    __setFunctionName: $e8d611dd65e01992$export$d1a06452d3489bc7,
    __metadata: $e8d611dd65e01992$export$f1db080c865becb9,
    __awaiter: $e8d611dd65e01992$export$1050f835b63b671e,
    __generator: $e8d611dd65e01992$export$67ebef60e6f28a6,
    __createBinding: $e8d611dd65e01992$export$45d3717a4c69092e,
    __exportStar: $e8d611dd65e01992$export$f33643c0debef087,
    __values: $e8d611dd65e01992$export$19a8beecd37a4c45,
    __read: $e8d611dd65e01992$export$8d051b38c9118094,
    __spread: $e8d611dd65e01992$export$afc72e2116322959,
    __spreadArrays: $e8d611dd65e01992$export$6388937ca91ccae8,
    __spreadArray: $e8d611dd65e01992$export$1216008129fb82ed,
    __await: $e8d611dd65e01992$export$10c90e4f7922046c,
    __asyncGenerator: $e8d611dd65e01992$export$e427f37a30a4de9b,
    __asyncDelegator: $e8d611dd65e01992$export$bbd80228419bb833,
    __asyncValues: $e8d611dd65e01992$export$e3b29a3d6162315f,
    __makeTemplateObject: $e8d611dd65e01992$export$4fb47efe1390b86f,
    __importStar: $e8d611dd65e01992$export$c21735bcef00d192,
    __importDefault: $e8d611dd65e01992$export$da59b14a69baef04,
    __classPrivateFieldGet: $e8d611dd65e01992$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e8d611dd65e01992$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e8d611dd65e01992$export$81fdc39f203e4e04,
    __addDisposableResource: $e8d611dd65e01992$export$88ac25d8e944e405,
    __disposeResources: $e8d611dd65e01992$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $e8d611dd65e01992$export$889dfb5d17574b0b
};

});


parcelRegister("byZUr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86b2e498197fee43$export$2e2bcd8739ae039; });
/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ var $86b2e498197fee43$var$isHexDigit = function(charCode) {
    return charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
};
var $86b2e498197fee43$var$isPercentEncodedByte = function(str, i, len) {
    return i + 2 < len && $86b2e498197fee43$var$isHexDigit(str.charCodeAt(i + 1)) && $86b2e498197fee43$var$isHexDigit(str.charCodeAt(i + 2));
};
var $86b2e498197fee43$var$hexValue = function(charCode) {
    return charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
};
var $86b2e498197fee43$var$isBase64Char = function(charCode) {
    return charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95;
}; // _ (base64url)
var $86b2e498197fee43$var$isBase64Whitespace = function(charCode) {
    return charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
};
var $86b2e498197fee43$var$base64Bytes = function(significant) {
    var groups = Math.floor(significant / 4);
    var remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
var $86b2e498197fee43$var$estimateBase64BufferAllocation = function(body) {
    var len = body.length;
    var padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
var $86b2e498197fee43$var$estimatePercentDecodedBase64Bytes = function(body) {
    var len = body.length;
    var significant = 0;
    var padding = 0;
    var invalid = false;
    for(var i = 0; i < len; i++){
        var code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $86b2e498197fee43$var$isPercentEncodedByte(body, i, len)) {
            code = $86b2e498197fee43$var$hexValue(body.charCodeAt(i + 1)) * 16 + $86b2e498197fee43$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($86b2e498197fee43$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$86b2e498197fee43$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $86b2e498197fee43$var$estimateBase64BufferAllocation(body);
    return $86b2e498197fee43$var$base64Bytes(significant);
};
var $86b2e498197fee43$var$estimateDataURLBytes = function(url, estimateBase64) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    var comma = url.indexOf(',');
    if (comma < 0) return 0;
    var meta = url.slice(5, comma);
    var body = url.slice(comma + 1);
    var isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    var bytes = 0;
    for(var i = 0, len = body.length; i < len; i++){
        var c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $86b2e498197fee43$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            var next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $86b2e498197fee43$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    var fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $86b2e498197fee43$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $86b2e498197fee43$var$estimatePercentDecodedBase64Bytes);
}
function $86b2e498197fee43$export$1f39e64b554a246f(url) {
    return $86b2e498197fee43$var$estimateDataURLBytes(url, $86b2e498197fee43$var$estimateBase64BufferAllocation);
}

});

parcelRegister("bMHPm", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $89462c977a08f960$export$a4ad2735b021c132; });
var $89462c977a08f960$export$a4ad2735b021c132 = "1.20.0";

});




parcelRegister("4K2og", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $373d4ff3ba8a78c5$export$2e2bcd8739ae039; });

var $5djcY = parcelRequire("5djcY");

var $bMHPm = parcelRequire("bMHPm");

var $3B0hl = parcelRequire("3B0hl");
'use strict';
var $373d4ff3ba8a78c5$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $373d4ff3ba8a78c5$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $5djcY._)(thing)) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $373d4ff3ba8a78c5$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $373d4ff3ba8a78c5$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $bMHPm.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new (0, $3B0hl.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $3B0hl.default).ERR_DEPRECATED);
        if (version && !$373d4ff3ba8a78c5$var$deprecatedWarnings[opt]) {
            $373d4ff3ba8a78c5$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$373d4ff3ba8a78c5$var$validators.spelling = function spelling(correctSpelling) {
    return function(value, opt) {
        // eslint-disable-next-line no-console
        console.warn("".concat(opt, " is likely a misspelling of ").concat(correctSpelling));
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $373d4ff3ba8a78c5$var$assertOptions(options, schema, allowUnknown) {
    if ((typeof options === "undefined" ? "undefined" : (0, $5djcY._)(options)) !== 'object' || options === null) throw new (0, $3B0hl.default)('options must be an object', (0, $3B0hl.default).ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        var validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $3B0hl.default)('option ' + opt + ' must be ' + result, (0, $3B0hl.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $3B0hl.default)('Unknown option ' + opt, (0, $3B0hl.default).ERR_BAD_OPTION);
    }
}
var $373d4ff3ba8a78c5$export$2e2bcd8739ae039 = {
    assertOptions: $373d4ff3ba8a78c5$var$assertOptions,
    validators: $373d4ff3ba8a78c5$var$validators
};

});


parcelRegister("6eLzy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48a8f3c4fd6d35d1$export$2e2bcd8739ae039; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $a6CVI = parcelRequire("a6CVI");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ var $48a8f3c4fd6d35d1$var$CancelToken = /*#__PURE__*/ function() {
    function CancelToken(executor) {
        (0, $4QweW._)(this, CancelToken);
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        var token = this;
        // eslint-disable-next-line func-names
        this.promise.then(function(cancel) {
            if (!token._listeners) return;
            var i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = function(onfulfilled) {
            var _resolve;
            // eslint-disable-next-line func-names
            var promise = new Promise(function(resolve) {
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $a6CVI.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    (0, $6hK4i._)(CancelToken, [
        {
            /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ key: "throwIfRequested",
            value: function throwIfRequested() {
                if (this.reason) throw this.reason;
            }
        },
        {
            /**
   * Subscribe to the cancel signal
   */ key: "subscribe",
            value: function subscribe(listener) {
                if (this.reason) {
                    listener(this.reason);
                    return;
                }
                if (this._listeners) this._listeners.push(listener);
                else this._listeners = [
                    listener
                ];
            }
        },
        {
            /**
   * Unsubscribe from the cancel signal
   */ key: "unsubscribe",
            value: function unsubscribe(listener) {
                if (!this._listeners) return;
                var index = this._listeners.indexOf(listener);
                if (index !== -1) this._listeners.splice(index, 1);
            }
        },
        {
            key: "toAbortSignal",
            value: function toAbortSignal() {
                var _this = this;
                var controller = new AbortController();
                var abort = function(err) {
                    controller.abort(err);
                };
                this.subscribe(abort);
                controller.signal.unsubscribe = function() {
                    return _this.unsubscribe(abort);
                };
                return controller.signal;
            }
        }
    ], [
        {
            key: "source",
            value: /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ function source() {
                var cancel;
                var token = new CancelToken(function executor(c) {
                    cancel = c;
                });
                return {
                    token: token,
                    cancel: cancel
                };
            }
        }
    ]);
    return CancelToken;
}();
var $48a8f3c4fd6d35d1$export$2e2bcd8739ae039 = $48a8f3c4fd6d35d1$var$CancelToken;

});

parcelRegister("6lGMv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49f5e3bb281c576d$export$2e2bcd8739ae039; });
'use strict';
function $49f5e3bb281c576d$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("jvd11", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e32b0226dcb13d48$export$2e2bcd8739ae039; });

var $bOBNq = parcelRequire("bOBNq");
'use strict';
function $e32b0226dcb13d48$export$2e2bcd8739ae039(payload) {
    return (0, $bOBNq.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("bSaYg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a4d3f79617f3c90$export$2e2bcd8739ae039; });

var $6ZpBv = parcelRequire("6ZpBv");
var $8a4d3f79617f3c90$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($8a4d3f79617f3c90$var$HttpStatusCode).forEach(function(param) {
    var _param = (0, $6ZpBv._)(param, 2), key = _param[0], value = _param[1];
    if ($8a4d3f79617f3c90$var$HttpStatusCode[value] === undefined) $8a4d3f79617f3c90$var$HttpStatusCode[value] = key;
});
var $8a4d3f79617f3c90$export$2e2bcd8739ae039 = $8a4d3f79617f3c90$var$HttpStatusCode;

});



parcelRegister("bW2QE", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", function () { return $8bcc05c5008d8dc6$export$3ae376d12526dd6f; });

var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $9HB6H = parcelRequire("9HB6H");

var $iD6kw = parcelRequire("iD6kw");

var $8Js66 = parcelRequire("8Js66");

var $57sx1 = parcelRequire("57sx1");

var $24ePD = parcelRequire("24ePD");

var $aSOpV = parcelRequire("aSOpV");

var $aYbxD = parcelRequire("aYbxD");

var $4Mjbh = parcelRequire("4Mjbh");
"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ var $8bcc05c5008d8dc6$export$3ae376d12526dd6f = function(param) {
    var children = param.children, custom = param.custom, _param_initial = param.initial, initial = _param_initial === void 0 ? true : _param_initial, onExitComplete = param.onExitComplete, _param_presenceAffectsLayout = param.presenceAffectsLayout, presenceAffectsLayout = _param_presenceAffectsLayout === void 0 ? true : _param_presenceAffectsLayout, _param_mode = param.mode, mode = _param_mode === void 0 ? "sync" : _param_mode, _param_propagate = param.propagate, propagate = _param_propagate === void 0 ? false : _param_propagate, _param_anchorX = param.anchorX, anchorX = _param_anchorX === void 0 ? "left" : _param_anchorX, _param_anchorY = param.anchorY, anchorY = _param_anchorY === void 0 ? "top" : _param_anchorY, root = param.root;
    var _usePresence = (0, $6ZpBv._)((0, $aYbxD.usePresence)(propagate), 2), isParentPresent = _usePresence[0], safeToRemove = _usePresence[1];
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ var presentChildren = (0, $iD6kw.useMemo)(function() {
        return (0, $4Mjbh.onlyElements)(children);
    }, [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ var presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, $4Mjbh.getChildKey));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ var isInitialRender = (0, $iD6kw.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ var pendingPresentChildren = (0, $iD6kw.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ var exitComplete = (0, $57sx1.useConstant)(function() {
        return new Map();
    });
    /**
     * Track which components are currently processing exit to prevent duplicate processing.
     */ var exitingComponents = (0, $iD6kw.useRef)(new Set());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ var _useState = (0, $6ZpBv._)((0, $iD6kw.useState)(presentChildren), 2), diffedChildren = _useState[0], setDiffedChildren = _useState[1];
    var _useState1 = (0, $6ZpBv._)((0, $iD6kw.useState)(presentChildren), 2), renderedChildren = _useState1[0], setRenderedChildren = _useState1[1];
    (0, $24ePD.useIsomorphicLayoutEffect)(function() {
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(var i = 0; i < renderedChildren.length; i++){
            var key = (0, $4Mjbh.getChildKey)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else {
                exitComplete.delete(key);
                exitingComponents.current.delete(key);
            }
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    var exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        var nextChildren = (0, $jlUaU._)(presentChildren);
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(var i = 0; i < renderedChildren.length; i++){
            var child = renderedChildren[i];
            var key = (0, $4Mjbh.getChildKey)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $4Mjbh.onlyElements)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return null;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ var forceRender = (0, $iD6kw.useContext)((0, $8Js66.LayoutGroupContext)).forceRender;
    return (0, $9HB6H.jsx)((0, $9HB6H.Fragment), {
        children: renderedChildren.map(function(child) {
            var key = (0, $4Mjbh.getChildKey)(child);
            var isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            var onExit = function() {
                if (exitingComponents.current.has(key)) return;
                if (exitComplete.has(key)) {
                    exitingComponents.current.add(key);
                    exitComplete.set(key, true);
                } else return;
                var isEveryExitComplete = true;
                exitComplete.forEach(function(isExitComplete) {
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 ? void 0 : forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && (safeToRemove === null || safeToRemove === void 0 ? void 0 : safeToRemove());
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $9HB6H.jsx)((0, $aSOpV.PresenceChild), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                root: root,
                onExitComplete: isPresent ? undefined : onExit,
                anchorX: anchorX,
                anchorY: anchorY,
                children: child
            }, key);
        })
    });
};

});
parcelRegister("8Js66", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", function () { return $b3b7dab448517709$export$a3579ca508007a95; });

var $iD6kw = parcelRequire("iD6kw");
"use client";
var $b3b7dab448517709$export$a3579ca508007a95 = (0, $iD6kw.createContext)({});

});

parcelRegister("57sx1", function(module, exports) {

$parcel$export(module.exports, "useConstant", function () { return $712fe860ac4dd1b7$export$fe4300aa8eebea86; });

var $iD6kw = parcelRequire("iD6kw");
"use client";
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $712fe860ac4dd1b7$export$fe4300aa8eebea86(init) {
    var ref = (0, $iD6kw.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});

parcelRegister("24ePD", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $ab7ef8a3bd81711d$export$700979bc83e7db82; });

var $iD6kw = parcelRequire("iD6kw");

var $3KXXq = parcelRequire("3KXXq");
"use client";
var $ab7ef8a3bd81711d$export$700979bc83e7db82 = (0, $3KXXq.isBrowser) ? (0, $iD6kw.useLayoutEffect) : (0, $iD6kw.useEffect);

});
parcelRegister("3KXXq", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $959232e9a469b07c$export$4e09c449d6c407f7; });
var $959232e9a469b07c$export$4e09c449d6c407f7 = typeof window !== "undefined";

});


parcelRegister("aSOpV", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", function () { return $902d37076f80eb86$export$979daf65881a382a; });

var $kWfK0 = parcelRequire("kWfK0");

var $9HB6H = parcelRequire("9HB6H");

var $iD6kw = parcelRequire("iD6kw");

var $hH50e = parcelRequire("hH50e");

var $57sx1 = parcelRequire("57sx1");

var $24ePD = parcelRequire("24ePD");

var $2kobm = parcelRequire("2kobm");
"use client";
var $902d37076f80eb86$export$979daf65881a382a = function(param) {
    var children = param.children, initial = param.initial, isPresent = param.isPresent, onExitComplete = param.onExitComplete, custom = param.custom, presenceAffectsLayout = param.presenceAffectsLayout, mode = param.mode, anchorX = param.anchorX, anchorY = param.anchorY, root = param.root;
    var presenceChildren = (0, $57sx1.useConstant)($902d37076f80eb86$var$newChildrenMap);
    var id = (0, $iD6kw.useId)();
    // Written in a layout effect (not render) so discarded concurrent
    // renders can't leave the refs pointing at uncommitted state.
    var isPresentRef = (0, $iD6kw.useRef)(isPresent);
    var onExitCompleteRef = (0, $iD6kw.useRef)(onExitComplete);
    (0, $24ePD.useIsomorphicLayoutEffect)(function() {
        isPresentRef.current = isPresent;
        onExitCompleteRef.current = onExitComplete;
    });
    var isReusedContext = true;
    var context = (0, $iD6kw.useMemo)(function() {
        isReusedContext = false;
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: function(childId) {
                presenceChildren.set(childId, true);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = presenceChildren.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var isComplete = _step.value;
                        if (!isComplete) return; // can stop searching when any is incomplete
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                onExitComplete && onExitComplete();
            },
            register: function(childId) {
                presenceChildren.set(childId, false);
                return function() {
                    var _onExitCompleteRef_current;
                    presenceChildren.delete(childId);
                    !isPresentRef.current && !presenceChildren.size && ((_onExitCompleteRef_current = onExitCompleteRef.current) === null || _onExitCompleteRef_current === void 0 ? void 0 : _onExitCompleteRef_current.call(onExitCompleteRef));
                };
            }
        };
    }, [
        isPresent,
        presenceChildren,
        onExitComplete
    ]);
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ if (presenceAffectsLayout && isReusedContext) context = (0, $kWfK0._)({}, context);
    (0, $iD6kw.useMemo)(function() {
        presenceChildren.forEach(function(_, key) {
            return presenceChildren.set(key, false);
        });
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $iD6kw.useEffect(function() {
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    children = (0, $9HB6H.jsx)((0, $2kobm.PopChild), {
        pop: mode === "popLayout",
        isPresent: isPresent,
        anchorX: anchorX,
        anchorY: anchorY,
        root: root,
        children: children
    });
    return (0, $9HB6H.jsx)((0, $hH50e.PresenceContext).Provider, {
        value: context,
        children: children
    });
};
function $902d37076f80eb86$var$newChildrenMap() {
    return new Map();
}

});
parcelRegister("hH50e", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", function () { return $4df59b6249ea89bd$export$f224e4635b6f8ce2; });

var $iD6kw = parcelRequire("iD6kw");
"use client";
/**
 * @public
 */ var $4df59b6249ea89bd$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $iD6kw.createContext)(null);

});

parcelRegister("2kobm", function(module, exports) {

$parcel$export(module.exports, "PopChild", function () { return $cf3ce852e5a5577f$export$1d6cdde0c6816c6d; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $9HB6H = parcelRequire("9HB6H");

var $dDCFH = parcelRequire("dDCFH");

var $iD6kw = parcelRequire("iD6kw");

var $iCxNR = parcelRequire("iCxNR");

var $f6rVZ = parcelRequire("f6rVZ");
"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ var $cf3ce852e5a5577f$var$PopChildMeasure = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $c2MhV._)(PopChildMeasure, _React_Component);
    function PopChildMeasure() {
        (0, $4QweW._)(this, PopChildMeasure);
        return (0, $ehF45._)(this, PopChildMeasure, arguments);
    }
    (0, $6hK4i._)(PopChildMeasure, [
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var element = this.props.childRef.current;
                if ((0, $dDCFH.isHTMLElement)(element) && prevProps.isPresent && !this.props.isPresent && this.props.pop !== false) {
                    var parent = element.offsetParent;
                    var parentWidth = (0, $dDCFH.isHTMLElement)(parent) ? parent.offsetWidth || 0 : 0;
                    var parentHeight = (0, $dDCFH.isHTMLElement)(parent) ? parent.offsetHeight || 0 : 0;
                    var computedStyle = getComputedStyle(element);
                    var size = this.props.sizeRef.current;
                    size.height = parseFloat(computedStyle.height);
                    size.width = parseFloat(computedStyle.width);
                    size.top = element.offsetTop;
                    size.left = element.offsetLeft;
                    size.right = parentWidth - size.width - size.left;
                    size.bottom = parentHeight - size.height - size.top;
                    size.direction = computedStyle.direction;
                }
                return null;
            }
        },
        {
            /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ key: "componentDidUpdate",
            value: function componentDidUpdate() {}
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return PopChildMeasure;
}($iD6kw.Component);
function $cf3ce852e5a5577f$export$1d6cdde0c6816c6d(param) {
    var children = param.children, isPresent = param.isPresent, anchorX = param.anchorX, anchorY = param.anchorY, root = param.root, pop = param.pop;
    var _children_props;
    var id = (0, $iD6kw.useId)();
    var ref = (0, $iD6kw.useRef)(null);
    var size = (0, $iD6kw.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        direction: "ltr"
    });
    var nonce = (0, $iD6kw.useContext)((0, $iCxNR.MotionConfigContext)).nonce;
    var _children_props_ref;
    /**
     * In React 19, refs are passed via props.ref instead of element.ref.
     * We check props.ref first (React 19) and fall back to element.ref (React 18).
     *
     * The composed ref is only used when popping the child out (pop !== false),
     * so we avoid reading children.props.ref otherwise. In React 18.3 that read
     * triggers a spurious "`ref` is not a prop" warning getter (#3745).
     */ var childRef = pop !== false ? (_children_props_ref = (_children_props = children.props) === null || _children_props === void 0 ? void 0 : _children_props.ref) !== null && _children_props_ref !== void 0 ? _children_props_ref : children === null || children === void 0 ? void 0 : children.ref : undefined;
    var composedRef = (0, $f6rVZ.useComposedRefs)(ref, childRef);
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $iD6kw.useInsertionEffect)(function() {
        var _size_current = size.current, width = _size_current.width, height = _size_current.height, top = _size_current.top, left = _size_current.left, right = _size_current.right, bottom = _size_current.bottom, direction = _size_current.direction;
        if (isPresent || pop === false || !ref.current || !width || !height) return;
        var isRTL = direction === "rtl";
        var x = anchorX === "left" ? isRTL ? "right: ".concat(right) : "left: ".concat(left) : isRTL ? "left: ".concat(left) : "right: ".concat(right);
        var y = anchorY === "bottom" ? "bottom: ".concat(bottom) : "top: ".concat(top);
        ref.current.dataset.motionPopId = id;
        var style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        var parent = root !== null && root !== void 0 ? root : document.head;
        parent.appendChild(style);
        if (style.sheet) style.sheet.insertRule('\n          [data-motion-pop-id="'.concat(id, '"] {\n            position: absolute !important;\n            width: ').concat(width, "px !important;\n            height: ").concat(height, "px !important;\n            ").concat(x, "px !important;\n            ").concat(y, "px !important;\n          }\n        "));
        return function() {
            var _ref_current;
            (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.removeAttribute("data-motion-pop-id");
            if (parent.contains(style)) parent.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $9HB6H.jsx)($cf3ce852e5a5577f$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        pop: pop,
        children: pop === false ? children : $iD6kw.cloneElement(children, {
            ref: composedRef
        })
    });
}

});
parcelRegister("dDCFH", function(module, exports) {

$parcel$export(module.exports, "isHTMLElement", function () { return $7e04ab9d3d0bea20$export$1b3bfaa9684536aa; });

var $gmphp = parcelRequire("gmphp");
/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function $7e04ab9d3d0bea20$export$1b3bfaa9684536aa(element) {
    return (0, $gmphp.isObject)(element) && "offsetHeight" in element && !("ownerSVGElement" in element);
}

});
parcelRegister("gmphp", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $f1d32e5743639179$export$a6cdc56e425d0d0a; });

var $5djcY = parcelRequire("5djcY");
var $f1d32e5743639179$export$a6cdc56e425d0d0a = function(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $5djcY._)(value)) === "object" && value !== null;
};

});


parcelRegister("iCxNR", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", function () { return $7ba2fda709301917$export$22a697fb29aac98d; });

var $iD6kw = parcelRequire("iD6kw");
"use client";
/**
 * @public
 */ var $7ba2fda709301917$export$22a697fb29aac98d = (0, $iD6kw.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false,
    reducedMotion: "never"
});

});

parcelRegister("f6rVZ", function(module, exports) {

$parcel$export(module.exports, "useComposedRefs", function () { return $a1eb61ad93524c0a$export$c7b2cbe3552a0d05; });

var $jlUaU = parcelRequire("jlUaU");

var $iD6kw = parcelRequire("iD6kw");
/**
 * Taken from https://github.com/radix-ui/primitives/blob/main/packages/react/compose-refs/src/compose-refs.tsx
 */ /**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $a1eb61ad93524c0a$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $a1eb61ad93524c0a$var$composeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(node) {
        var hasCleanup = false;
        var cleanups = refs.map(function(ref) {
            var cleanup = $a1eb61ad93524c0a$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        // React <19 will log an error to the console if a callback ref returns a
        // value. We don't use ref cleanups internally so this will only happen if a
        // user's ref callback returns a value, which we only expect if they are
        // using the cleanup functionality added in React 19.
        if (hasCleanup) return function() {
            for(var i = 0; i < cleanups.length; i++){
                var cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else $a1eb61ad93524c0a$var$setRef(refs[i], null);
            }
        };
    };
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $a1eb61ad93524c0a$export$c7b2cbe3552a0d05() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return $iD6kw.useCallback($a1eb61ad93524c0a$var$composeRefs.apply(void 0, (0, $jlUaU._)(refs)), refs);
}

});



parcelRegister("aYbxD", function(module, exports) {

$parcel$export(module.exports, "usePresence", function () { return $4979ff88c2b74d23$export$2a8c16d82a0a0e26; });

var $iD6kw = parcelRequire("iD6kw");

var $hH50e = parcelRequire("hH50e");
"use client";
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed from the tree,
 * but `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $4979ff88c2b74d23$export$2a8c16d82a0a0e26() {
    var subscribe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var context = (0, $iD6kw.useContext)((0, $hH50e.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    var id = (0, $iD6kw.useId)();
    (0, $iD6kw.useEffect)(function() {
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    var safeToRemove = (0, $iD6kw.useCallback)(function() {
        return subscribe && onExitComplete && onExitComplete(id);
    }, [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $4979ff88c2b74d23$export$8249053f690ea39a() {
    return $4979ff88c2b74d23$export$ee27c052bca048fb((0, $iD6kw.useContext)((0, $hH50e.PresenceContext)));
}
function $4979ff88c2b74d23$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}

});

parcelRegister("4Mjbh", function(module, exports) {

$parcel$export(module.exports, "getChildKey", function () { return $f51af107ebca1aa1$export$10e61aed958678dd; });
$parcel$export(module.exports, "onlyElements", function () { return $f51af107ebca1aa1$export$872a3a1281f4b357; });

var $iD6kw = parcelRequire("iD6kw");
var $f51af107ebca1aa1$export$10e61aed958678dd = function(child) {
    return child.key || "";
};
function $f51af107ebca1aa1$export$872a3a1281f4b357(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $iD6kw.Children).forEach(children, function(child) {
        if ((0, $iD6kw.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}

});


parcelRegister("fZKlV", function(module, exports) {
$parcel$export(module.exports, "AnimatePresence", function () { return (parcelRequire("bW2QE")).AnimatePresence; });

$parcel$export(module.exports, "motion", function () { return (parcelRequire("56VF7")).motion; });
parcelRequire("bW2QE");
var $56VF7 = parcelRequire("56VF7");

});
parcelRegister("56VF7", function(module, exports) {

$parcel$export(module.exports, "motion", function () { return $92af9719964c1a1b$export$e25e478948902b8b; });

var $dYu0Z = parcelRequire("dYu0Z");

var $7xsoA = parcelRequire("7xsoA");

var $gaXdb = parcelRequire("gaXdb");
var $92af9719964c1a1b$export$e25e478948902b8b = /*@__PURE__*/ (0, $7xsoA.createMotionProxy)((0, $gaXdb.featureBundle), (0, $dYu0Z.createDomVisualElement));

});
parcelRegister("dYu0Z", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", function () { return $3e60012b15832dd0$export$56ba0183203348f5; });

var $n7jZe = parcelRequire("n7jZe");
var $f8rCK = parcelRequire("f8rCK");

var $iD6kw = parcelRequire("iD6kw");

var $vRFnt = parcelRequire("vRFnt");
var $3e60012b15832dd0$export$56ba0183203348f5 = function(Component, options) {
    var _options_isSVG;
    /**
     * Use explicit isSVG override if provided, otherwise auto-detect
     */ var isSVG = (_options_isSVG = options.isSVG) !== null && _options_isSVG !== void 0 ? _options_isSVG : (0, $vRFnt.isSVGComponent)(Component);
    return isSVG ? new (0, $f8rCK.SVGVisualElement)(options) : new (0, $n7jZe.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, $iD6kw.Fragment)
    });
};

});
parcelRegister("n7jZe", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", function () { return $cf68a855833b8988$export$23fea75b03ac16b3; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $hC9N3 = parcelRequire("hC9N3");

var $9atk1 = parcelRequire("9atk1");

var $c2MhV = parcelRequire("c2MhV");

var $8FnrH = parcelRequire("8FnrH");

var $1575y = parcelRequire("1575y");

var $d4bUS = parcelRequire("d4bUS");

var $1QLzK = parcelRequire("1QLzK");

var $gpPFl = parcelRequire("gpPFl");

var $hg8z5 = parcelRequire("hg8z5");

var $7SGHq = parcelRequire("7SGHq");

var $asY06 = parcelRequire("asY06");

var $cVifk = parcelRequire("cVifk");
function $cf68a855833b8988$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
var $cf68a855833b8988$export$23fea75b03ac16b3 = /*#__PURE__*/ function(DOMVisualElement) {
    "use strict";
    (0, $c2MhV._)(HTMLVisualElement, DOMVisualElement);
    function HTMLVisualElement() {
        (0, $4QweW._)(this, HTMLVisualElement);
        var _this;
        _this = (0, $ehF45._)(this, HTMLVisualElement, arguments);
        _this.type = "html";
        _this.renderInstance = (0, $asY06.renderHTML);
        return _this;
    }
    (0, $6hK4i._)(HTMLVisualElement, [
        {
            key: "mount",
            value: function mount(instance) {
                /**
         * If a custom component forwards its ref to something other than a
         * HTML/SVG element (a class instance, an imperative handle) there's
         * nothing for Motion to style, measure or attach gestures to. #2777
         */ (0, $8FnrH.invariant)(Boolean(instance.style), "motion.create() components must forward their ref to a HTML or SVG element", "custom-component-ref");
                (0, $hC9N3._)((0, $9atk1._)(HTMLVisualElement.prototype), "mount", this).call(this, instance);
            }
        },
        {
            key: "readValueFromInstance",
            value: function readValueFromInstance(instance, key) {
                var _this_projection;
                if ((0, $d4bUS.transformProps).has(key)) return ((_this_projection = this.projection) === null || _this_projection === void 0 ? void 0 : _this_projection.isProjecting) ? (0, $1QLzK.defaultTransformValue)(key) : (0, $1QLzK.readTransformValue)(instance, key);
                else {
                    var computedStyle = $cf68a855833b8988$export$3735103072e4a80(instance);
                    var value = ((0, $1575y.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
                    return typeof value === "string" ? value.trim() : value;
                }
            }
        },
        {
            key: "measureInstanceViewportBox",
            value: function measureInstanceViewportBox(instance, param) {
                var transformPagePoint = param.transformPagePoint;
                return (0, $gpPFl.measureViewportBox)(instance, transformPagePoint);
            }
        },
        {
            key: "build",
            value: function build(renderState, latestValues, props) {
                (0, $7SGHq.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
            }
        },
        {
            key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps1(props, prevProps, visualElement) {
                return (0, $cVifk.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
            }
        }
    ]);
    return HTMLVisualElement;
}((0, $hg8z5.DOMVisualElement));

});
parcelRegister("hC9N3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cd2d94639e35f6ff$export$71511d61b312f219; });

var $3wHsP = parcelRequire("3wHsP");
function $cd2d94639e35f6ff$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $cd2d94639e35f6ff$export$71511d61b312f219 = Reflect.get;
    else $cd2d94639e35f6ff$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $3wHsP._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $cd2d94639e35f6ff$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("3wHsP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2916134f4529eca2$export$71511d61b312f219; });

var $9atk1 = parcelRequire("9atk1");
function $2916134f4529eca2$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $9atk1._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("8FnrH", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $9da673eabfaa274d$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $9da673eabfaa274d$export$f5708dca728d7177; });

var $9da673eabfaa274d$export$491112666e282270 = function() {};
var $9da673eabfaa274d$export$f5708dca728d7177 = function() {};
var $9da673eabfaa274d$var$check, $9da673eabfaa274d$var$message, $9da673eabfaa274d$var$errorCode, $9da673eabfaa274d$var$check1, $9da673eabfaa274d$var$message1, $9da673eabfaa274d$var$errorCode1;

});

parcelRegister("1575y", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", function () { return $02498a8278bd193c$export$9de1236619d9e756; });
$parcel$export(module.exports, "isCSSVariableToken", function () { return $02498a8278bd193c$export$31f9caa2600b5723; });
$parcel$export(module.exports, "containsCSSVariable", function () { return $02498a8278bd193c$export$df8f90ab5d0b05fa; });
var $02498a8278bd193c$var$checkStringStartsWith = function(token) {
    return function(key) {
        return typeof key === "string" && key.startsWith(token);
    };
};
var $02498a8278bd193c$export$9de1236619d9e756 = /*@__PURE__*/ $02498a8278bd193c$var$checkStringStartsWith("--");
var $02498a8278bd193c$var$startsAsVariableToken = /*@__PURE__*/ $02498a8278bd193c$var$checkStringStartsWith("var(--");
var $02498a8278bd193c$export$31f9caa2600b5723 = function(value) {
    var startsWithToken = $02498a8278bd193c$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $02498a8278bd193c$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
var $02498a8278bd193c$var$singleCssVariableRegex = RegExp("var\\(--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)$", "iu");
/**
 * Check if a value contains a CSS variable anywhere (e.g. inside calc()).
 * Unlike isCSSVariableToken which checks if the value IS a var() token,
 * this checks if the value CONTAINS var() somewhere in the string.
 */ function $02498a8278bd193c$export$df8f90ab5d0b05fa(value) {
    if (typeof value !== "string") return false;
    // Strip comments to avoid false positives
    return value.split("/*")[0].includes("var(--");
}

});

parcelRegister("d4bUS", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", function () { return $9dcdd5ecb907dbf8$export$280dc01950909d86; });
$parcel$export(module.exports, "transformProps", function () { return $9dcdd5ecb907dbf8$export$7b42a0094fb00b6e; });
/**
 * Generate a list of every possible transform key.
 */ 
var $jlUaU = parcelRequire("jlUaU");
var $9dcdd5ecb907dbf8$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 *
 * `pathRotation` is a transform for routing purposes (skipped from raw
 * style application, wired to the transform composite, flags transform
 * dirty) but is intentionally NOT in `transformPropOrder` — it is
 * composed onto `rotate` at the build sites, not serialized in its own
 * slot, and must stay out of the order-array consumers (parse-transform,
 * unit-conversion, keys-position).
 */ var $9dcdd5ecb907dbf8$export$7b42a0094fb00b6e = /*@__PURE__*/ function() {
    return new Set((0, $jlUaU._)($9dcdd5ecb907dbf8$export$280dc01950909d86).concat([
        "pathRotation"
    ]));
}();

});

parcelRegister("1QLzK", function(module, exports) {

$parcel$export(module.exports, "defaultTransformValue", function () { return $ad0db9a2d6adf591$export$1f10c01143b9f089; });
$parcel$export(module.exports, "parseValueFromTransform", function () { return $ad0db9a2d6adf591$export$f9111f9e16b73a26; });
$parcel$export(module.exports, "readTransformValue", function () { return $ad0db9a2d6adf591$export$bcd97e0e03ba17f6; });
var $ad0db9a2d6adf591$var$radToDeg = function(rad) {
    return rad * 180 / Math.PI;
};
var $ad0db9a2d6adf591$var$rotate = function(v) {
    var angle = $ad0db9a2d6adf591$var$radToDeg(Math.atan2(v[1], v[0]));
    return $ad0db9a2d6adf591$var$rebaseAngle(angle);
};
var $ad0db9a2d6adf591$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: function(v) {
        return (Math.abs(v[0]) + Math.abs(v[3])) / 2;
    },
    rotate: $ad0db9a2d6adf591$var$rotate,
    rotateZ: $ad0db9a2d6adf591$var$rotate,
    skewX: function(v) {
        return $ad0db9a2d6adf591$var$radToDeg(Math.atan(v[1]));
    },
    skewY: function(v) {
        return $ad0db9a2d6adf591$var$radToDeg(Math.atan(v[2]));
    },
    skew: function(v) {
        return (Math.abs(v[1]) + Math.abs(v[2])) / 2;
    }
};
var $ad0db9a2d6adf591$var$rebaseAngle = function(angle) {
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
var $ad0db9a2d6adf591$var$rotateZ = $ad0db9a2d6adf591$var$rotate;
var $ad0db9a2d6adf591$var$scaleX = function(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
};
var $ad0db9a2d6adf591$var$scaleY = function(v) {
    return Math.sqrt(v[4] * v[4] + v[5] * v[5]);
};
var $ad0db9a2d6adf591$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $ad0db9a2d6adf591$var$scaleX,
    scaleY: $ad0db9a2d6adf591$var$scaleY,
    scale: function(v) {
        return ($ad0db9a2d6adf591$var$scaleX(v) + $ad0db9a2d6adf591$var$scaleY(v)) / 2;
    },
    rotateX: function(v) {
        return $ad0db9a2d6adf591$var$rebaseAngle($ad0db9a2d6adf591$var$radToDeg(Math.atan2(v[6], v[5])));
    },
    rotateY: function(v) {
        return $ad0db9a2d6adf591$var$rebaseAngle($ad0db9a2d6adf591$var$radToDeg(Math.atan2(-v[2], v[0])));
    },
    rotateZ: $ad0db9a2d6adf591$var$rotateZ,
    rotate: $ad0db9a2d6adf591$var$rotateZ,
    skewX: function(v) {
        return $ad0db9a2d6adf591$var$radToDeg(Math.atan(v[4]));
    },
    skewY: function(v) {
        return $ad0db9a2d6adf591$var$radToDeg(Math.atan(v[1]));
    },
    skew: function(v) {
        return (Math.abs(v[1]) + Math.abs(v[4])) / 2;
    }
};
function $ad0db9a2d6adf591$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $ad0db9a2d6adf591$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $ad0db9a2d6adf591$export$1f10c01143b9f089(name);
    var matrix3dMatch = transform.match(RegExp("^matrix3d\\(([-\\d.e\\s,]+)\\)$", "u"));
    var parsers;
    var match;
    if (matrix3dMatch) {
        parsers = $ad0db9a2d6adf591$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        var matrix2dMatch = transform.match(RegExp("^matrix\\(([-\\d.e\\s,]+)\\)$", "u"));
        parsers = $ad0db9a2d6adf591$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $ad0db9a2d6adf591$export$1f10c01143b9f089(name);
    var valueParser = parsers[name];
    var values = match[1].split(",").map($ad0db9a2d6adf591$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
var $ad0db9a2d6adf591$export$bcd97e0e03ba17f6 = function(instance, name) {
    var _getComputedStyle = getComputedStyle(instance), _getComputedStyle_transform = _getComputedStyle.transform, transform = _getComputedStyle_transform === void 0 ? "none" : _getComputedStyle_transform;
    return $ad0db9a2d6adf591$export$f9111f9e16b73a26(transform, name);
};
function $ad0db9a2d6adf591$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}

});

parcelRegister("gpPFl", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", function () { return $9da02fb0ee25d805$export$d8718b6a7e5c624e; });
$parcel$export(module.exports, "measurePageBox", function () { return $9da02fb0ee25d805$export$6a597be7a7940a96; });

var $bidYk = parcelRequire("bidYk");

var $1QgJK = parcelRequire("1QgJK");
function $9da02fb0ee25d805$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $bidYk.convertBoundingBoxToBox)((0, $bidYk.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $9da02fb0ee25d805$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    var viewportBox = $9da02fb0ee25d805$export$d8718b6a7e5c624e(element, transformPagePoint);
    var scroll = rootProjectionNode.scroll;
    if (scroll) {
        (0, $1QgJK.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $1QgJK.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("bidYk", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", function () { return $72fb606bbf1a1834$export$d3955c6a8f65a36b; });
$parcel$export(module.exports, "convertBoxToBoundingBox", function () { return $72fb606bbf1a1834$export$b6b9cd4198191a47; });
$parcel$export(module.exports, "transformBoxPoints", function () { return $72fb606bbf1a1834$export$21543fb75483a50; });
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $72fb606bbf1a1834$export$d3955c6a8f65a36b(param) {
    var top = param.top, left = param.left, right = param.right, bottom = param.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $72fb606bbf1a1834$export$b6b9cd4198191a47(param) {
    var x = param.x, y = param.y;
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $72fb606bbf1a1834$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    var topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    var bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("1QgJK", function(module, exports) {

$parcel$export(module.exports, "scalePoint", function () { return $2c906df7cb79923f$export$2290ec7febe36dd6; });
$parcel$export(module.exports, "applyBoxDelta", function () { return $2c906df7cb79923f$export$d80074982803af5c; });
$parcel$export(module.exports, "applyTreeDeltas", function () { return $2c906df7cb79923f$export$e2a980535c55eabb; });
$parcel$export(module.exports, "translateAxis", function () { return $2c906df7cb79923f$export$a807a5ce5ebb3895; });
$parcel$export(module.exports, "transformBox", function () { return $2c906df7cb79923f$export$58b16271041fbfb; });

var $gcS1k = parcelRequire("gcS1k");

var $b0Bmd = parcelRequire("b0Bmd");
/**
 * Scales a point based on a factor and an originPoint
 */ function $2c906df7cb79923f$export$2290ec7febe36dd6(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $2c906df7cb79923f$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $2c906df7cb79923f$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $2c906df7cb79923f$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $2c906df7cb79923f$export$e8e3a712e9ebf422(axis) {
    var translate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, scale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, originPoint = arguments.length > 3 ? arguments[3] : void 0, boxScale = arguments.length > 4 ? arguments[4] : void 0;
    axis.min = $2c906df7cb79923f$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $2c906df7cb79923f$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $2c906df7cb79923f$export$d80074982803af5c(box, param) {
    var x = param.x, y = param.y;
    $2c906df7cb79923f$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $2c906df7cb79923f$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
var $2c906df7cb79923f$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
var $2c906df7cb79923f$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $2c906df7cb79923f$export$e2a980535c55eabb(box, treeScale, treePath) {
    var isSharedTransition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        var _node_layout;
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ var visualElement = node.options.visualElement;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
            $2c906df7cb79923f$export$a807a5ce5ebb3895(box.x, -node.scroll.offset.x);
            $2c906df7cb79923f$export$a807a5ce5ebb3895(box.y, -node.scroll.offset.y);
        }
        if (delta) {
            // Incoporate each ancestor's scale into a cumulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $2c906df7cb79923f$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $b0Bmd.hasTransform)(node.latestValues)) $2c906df7cb79923f$export$58b16271041fbfb(box, node.latestValues, (_node_layout = node.layout) === null || _node_layout === void 0 ? void 0 : _node_layout.layoutBox);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $2c906df7cb79923f$var$TREE_SCALE_SNAP_MAX && treeScale.x > $2c906df7cb79923f$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $2c906df7cb79923f$var$TREE_SCALE_SNAP_MAX && treeScale.y > $2c906df7cb79923f$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $2c906df7cb79923f$export$a807a5ce5ebb3895(axis, distance) {
    axis.min += distance;
    axis.max += distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $2c906df7cb79923f$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale) {
    var axisOrigin = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.5;
    var originPoint = (0, $gcS1k.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $2c906df7cb79923f$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
function $2c906df7cb79923f$var$resolveAxisTranslate(value, axis) {
    if (typeof value === "string") return parseFloat(value) / 100 * (axis.max - axis.min);
    return value;
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $2c906df7cb79923f$export$58b16271041fbfb(box, transform, sourceBox) {
    var resolveBox = sourceBox !== null && sourceBox !== void 0 ? sourceBox : box;
    $2c906df7cb79923f$export$625f1dd140a2f5e7(box.x, $2c906df7cb79923f$var$resolveAxisTranslate(transform.x, resolveBox.x), transform.scaleX, transform.scale, transform.originX);
    $2c906df7cb79923f$export$625f1dd140a2f5e7(box.y, $2c906df7cb79923f$var$resolveAxisTranslate(transform.y, resolveBox.y), transform.scaleY, transform.scale, transform.originY);
}

});
parcelRegister("gcS1k", function(module, exports) {

$parcel$export(module.exports, "mixNumber", function () { return $fda4f7db0324cfe3$export$3bb0b4ff1037b8dd; });
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ var $fda4f7db0324cfe3$export$3bb0b4ff1037b8dd = function(from, to, progress) {
    return from + (to - from) * progress;
};

});

parcelRegister("b0Bmd", function(module, exports) {

$parcel$export(module.exports, "hasScale", function () { return $4632f8127cc6e4f9$export$bdf30dca883ea463; });
$parcel$export(module.exports, "hasTransform", function () { return $4632f8127cc6e4f9$export$a545127cf1fbb600; });
$parcel$export(module.exports, "has2DTranslate", function () { return $4632f8127cc6e4f9$export$bf80f5f8f4dc327f; });
function $4632f8127cc6e4f9$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $4632f8127cc6e4f9$export$bdf30dca883ea463(param) {
    var scale = param.scale, scaleX = param.scaleX, scaleY = param.scaleY;
    return !$4632f8127cc6e4f9$var$isIdentityScale(scale) || !$4632f8127cc6e4f9$var$isIdentityScale(scaleX) || !$4632f8127cc6e4f9$var$isIdentityScale(scaleY);
}
function $4632f8127cc6e4f9$export$a545127cf1fbb600(values) {
    return $4632f8127cc6e4f9$export$bdf30dca883ea463(values) || $4632f8127cc6e4f9$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $4632f8127cc6e4f9$export$bf80f5f8f4dc327f(values) {
    return $4632f8127cc6e4f9$var$is2DTranslate(values.x) || $4632f8127cc6e4f9$var$is2DTranslate(values.y);
}
function $4632f8127cc6e4f9$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("hg8z5", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", function () { return $f2ad96e4eeb47e18$export$e49735c2a366bdc7; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $kbjZS = parcelRequire("kbjZS");

var $cOoUV = parcelRequire("cOoUV");

var $5NNrB = parcelRequire("5NNrB");
var $f2ad96e4eeb47e18$export$e49735c2a366bdc7 = /*#__PURE__*/ function(VisualElement) {
    "use strict";
    (0, $c2MhV._)(DOMVisualElement, VisualElement);
    function DOMVisualElement() {
        (0, $4QweW._)(this, DOMVisualElement);
        var _this;
        _this = (0, $ehF45._)(this, DOMVisualElement, arguments);
        _this.KeyframeResolver = (0, $cOoUV.DOMKeyframesResolver);
        return _this;
    }
    (0, $6hK4i._)(DOMVisualElement, [
        {
            key: "sortInstanceNodePosition",
            value: function sortInstanceNodePosition(a, b) {
                /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
            }
        },
        {
            key: "getBaseTargetFromProps",
            value: function getBaseTargetFromProps(props, key) {
                var style = props.style;
                return style ? style[key] : undefined;
            }
        },
        {
            key: "removeValueFromRenderState",
            value: function removeValueFromRenderState(key, param) {
                var vars = param.vars, style = param.style;
                delete vars[key];
                delete style[key];
            }
        },
        {
            key: "handleChildMotionValue",
            value: function handleChildMotionValue() {
                var _this = this;
                if (this.childSubscription) {
                    this.childSubscription();
                    delete this.childSubscription;
                }
                var children = this.props.children;
                if ((0, $kbjZS.isMotionValue)(children)) this.childSubscription = children.on("change", function(latest) {
                    if (_this.current) _this.current.textContent = "".concat(latest);
                });
            }
        }
    ]);
    return DOMVisualElement;
}((0, $5NNrB.VisualElement));

});
parcelRegister("kbjZS", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $22954bfb04120422$export$605d60a2578142d3; });
var $22954bfb04120422$export$605d60a2578142d3 = function(value) {
    return Boolean(value && value.getVelocity);
};

});

parcelRegister("cOoUV", function(module, exports) {

$parcel$export(module.exports, "DOMKeyframesResolver", function () { return $1509fb192824ad34$export$4983792d11b61017; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $hC9N3 = parcelRequire("hC9N3");

var $9atk1 = parcelRequire("9atk1");

var $c2MhV = parcelRequire("c2MhV");

var $6ZpBv = parcelRequire("6ZpBv");

var $ke5oA = parcelRequire("ke5oA");

var $fFwSr = parcelRequire("fFwSr");

var $KC1Xb = parcelRequire("KC1Xb");

var $1575y = parcelRequire("1575y");

var $1VyrA = parcelRequire("1VyrA");

var $75PL6 = parcelRequire("75PL6");

var $gmC1b = parcelRequire("gmC1b");

var $gQFXj = parcelRequire("gQFXj");
var $1509fb192824ad34$export$4983792d11b61017 = /*#__PURE__*/ function(KeyframeResolver) {
    "use strict";
    (0, $c2MhV._)(DOMKeyframesResolver, KeyframeResolver);
    function DOMKeyframesResolver(unresolvedKeyframes, onComplete, name, motionValue, element) {
        (0, $4QweW._)(this, DOMKeyframesResolver);
        return (0, $ehF45._)(this, DOMKeyframesResolver, [
            unresolvedKeyframes,
            onComplete,
            name,
            motionValue,
            element,
            true
        ]);
    }
    (0, $6hK4i._)(DOMKeyframesResolver, [
        {
            key: "readKeyframes",
            value: function readKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, element = _this.element, name = _this.name;
                if (!element || !element.current) return;
                (0, $hC9N3._)((0, $9atk1._)(DOMKeyframesResolver.prototype), "readKeyframes", this).call(this);
                /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(var i = 0; i < unresolvedKeyframes.length; i++){
                    var keyframe = unresolvedKeyframes[i];
                    if (typeof keyframe === "string") {
                        keyframe = keyframe.trim();
                        if ((0, $1575y.isCSSVariableToken)(keyframe)) {
                            var resolved = (0, $KC1Xb.getVariableValue)(keyframe, element.current);
                            if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                            if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                        }
                    }
                }
                /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
                /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $ke5oA.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
                var _unresolvedKeyframes = (0, $6ZpBv._)(unresolvedKeyframes, 2), origin = _unresolvedKeyframes[0], target = _unresolvedKeyframes[1];
                var originType = (0, $fFwSr.findDimensionValueType)(origin);
                var targetType = (0, $fFwSr.findDimensionValueType)(target);
                /**
         * If one keyframe contains embedded CSS variables (e.g. in calc()) and the other
         * doesn't, we need to measure to convert to pixels. This handles GitHub issue #3410.
         */ var originHasVar = (0, $1575y.containsCSSVariable)(origin);
                var targetHasVar = (0, $1575y.containsCSSVariable)(target);
                if (originHasVar !== targetHasVar && (0, $gQFXj.positionalValues)[name]) {
                    this.needsMeasurement = true;
                    return;
                }
                /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
                /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $gQFXj.isNumOrPxType)(originType) && (0, $gQFXj.isNumOrPxType)(targetType)) for(var i1 = 0; i1 < unresolvedKeyframes.length; i1++){
                    var value = unresolvedKeyframes[i1];
                    if (typeof value === "string") unresolvedKeyframes[i1] = parseFloat(value);
                }
                else if ((0, $gQFXj.positionalValues)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
            }
        },
        {
            key: "resolveNoneKeyframes",
            value: function resolveNoneKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name;
                var noneKeyframeIndexes = [];
                for(var i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $75PL6.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
                if (noneKeyframeIndexes.length) (0, $gmC1b.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
            }
        },
        {
            key: "measureInitialState",
            value: function measureInitialState() {
                var _this = this, element = _this.element, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name;
                if (!element || !element.current) return;
                if (name === "height") this.suspendedScrollY = window.pageYOffset;
                this.measuredOrigin = (0, $gQFXj.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
                unresolvedKeyframes[0] = this.measuredOrigin;
                // Set final key frame to measure after next render
                var measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
            }
        },
        {
            key: "measureEndState",
            value: function measureEndState() {
                var _this_removedTransforms;
                var _this = this, element = _this.element, name = _this.name, unresolvedKeyframes = _this.unresolvedKeyframes;
                if (!element || !element.current) return;
                var value = element.getValue(name);
                value && value.jump(this.measuredOrigin, false);
                var finalKeyframeIndex = unresolvedKeyframes.length - 1;
                var finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
                unresolvedKeyframes[finalKeyframeIndex] = (0, $gQFXj.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
                if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
                // If we removed transform values, reapply them before the next render
                if ((_this_removedTransforms = this.removedTransforms) === null || _this_removedTransforms === void 0 ? void 0 : _this_removedTransforms.length) this.removedTransforms.forEach(function(param) {
                    var _param = (0, $6ZpBv._)(param, 2), unsetTransformName = _param[0], unsetTransformValue = _param[1];
                    element.getValue(unsetTransformName).set(unsetTransformValue);
                });
                this.resolveNoneKeyframes();
            }
        }
    ]);
    return DOMKeyframesResolver;
}((0, $1VyrA.KeyframeResolver));

});
parcelRegister("ke5oA", function(module, exports) {

$parcel$export(module.exports, "positionalKeys", function () { return $0616a74c9159d86a$export$c66c0d5db2a205d; });

var $jlUaU = parcelRequire("jlUaU");

var $d4bUS = parcelRequire("d4bUS");
var $0616a74c9159d86a$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom"
].concat((0, $jlUaU._)((0, $d4bUS.transformPropOrder))));

});

parcelRegister("fFwSr", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $b907ddf7722bfca5$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $b907ddf7722bfca5$export$eefdd52e3ccae428; });

var $9E5VB = parcelRequire("9E5VB");

var $dr13F = parcelRequire("dr13F");

var $huIQG = parcelRequire("huIQG");

var $cy0Dn = parcelRequire("cy0Dn");
/**
 * A list of value types commonly used for dimensions
 */ var $b907ddf7722bfca5$export$d176691c1998a1f5 = [
    (0, $dr13F.number),
    (0, $huIQG.px),
    (0, $huIQG.percent),
    (0, $huIQG.degrees),
    (0, $huIQG.vw),
    (0, $huIQG.vh),
    (0, $9E5VB.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var $b907ddf7722bfca5$export$eefdd52e3ccae428 = function(v) {
    return $b907ddf7722bfca5$export$d176691c1998a1f5.find((0, $cy0Dn.testValueType)(v));
};

});
parcelRegister("9E5VB", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $69eaae341d231679$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ var $69eaae341d231679$export$dfb5619354ba860 = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};

});

parcelRegister("dr13F", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $d20fc92636a9e76c$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $d20fc92636a9e76c$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $d20fc92636a9e76c$export$dcdf75081b88279d; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $4ceSY = parcelRequire("4ceSY");
var $d20fc92636a9e76c$export$98e628dec113755e = {
    test: function(v) {
        return typeof v === "number";
    },
    parse: parseFloat,
    transform: function(v) {
        return v;
    }
};
var $d20fc92636a9e76c$export$58f0f39f63f3cf42 = (0, $hApvp._)((0, $kWfK0._)({}, $d20fc92636a9e76c$export$98e628dec113755e), {
    transform: function(v) {
        return (0, $4ceSY.clamp)(0, 1, v);
    }
});
var $d20fc92636a9e76c$export$dcdf75081b88279d = (0, $hApvp._)((0, $kWfK0._)({}, $d20fc92636a9e76c$export$98e628dec113755e), {
    default: 1
});

});
parcelRegister("4ceSY", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $6aa34e90f9c7716c$export$7d15b64cf5a3a4c4; });
var $6aa34e90f9c7716c$export$7d15b64cf5a3a4c4 = function(min, max, v) {
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

});


parcelRegister("huIQG", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $dff8d5673e40f016$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $dff8d5673e40f016$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $dff8d5673e40f016$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $dff8d5673e40f016$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $dff8d5673e40f016$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $dff8d5673e40f016$export$44e2e1705876d7ed; });
/*#__NO_SIDE_EFFECTS__*/ 
var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");
var $dff8d5673e40f016$var$createUnitType = function(unit) {
    return {
        test: function(v) {
            return typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1;
        },
        parse: parseFloat,
        transform: function(v) {
            return "".concat(v).concat(unit);
        }
    };
};
var $dff8d5673e40f016$export$41fc368e1a942b97 = /*@__PURE__*/ $dff8d5673e40f016$var$createUnitType("deg");
var $dff8d5673e40f016$export$626336c2cd4b14de = /*@__PURE__*/ $dff8d5673e40f016$var$createUnitType("%");
var $dff8d5673e40f016$export$91c0eda1d06bf008 = /*@__PURE__*/ $dff8d5673e40f016$var$createUnitType("px");
var $dff8d5673e40f016$export$f91e8c45a95a32f2 = /*@__PURE__*/ $dff8d5673e40f016$var$createUnitType("vh");
var $dff8d5673e40f016$export$aed3d7b7d206c196 = /*@__PURE__*/ $dff8d5673e40f016$var$createUnitType("vw");
var $dff8d5673e40f016$export$44e2e1705876d7ed = /*@__PURE__*/ function() {
    return (0, $hApvp._)((0, $kWfK0._)({}, $dff8d5673e40f016$export$626336c2cd4b14de), {
        parse: function(v) {
            return $dff8d5673e40f016$export$626336c2cd4b14de.parse(v) / 100;
        },
        transform: function(v) {
            return $dff8d5673e40f016$export$626336c2cd4b14de.transform(v * 100);
        }
    });
}();

});

parcelRegister("cy0Dn", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $1c1102e5b2a43e77$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ var $1c1102e5b2a43e77$export$6eae4d0a6a7ca7cd = function(v) {
    return function(type) {
        return type.test(v);
    };
};

});


parcelRegister("KC1Xb", function(module, exports) {

$parcel$export(module.exports, "getVariableValue", function () { return $9578519ac1de612e$export$289398774300c991; });

var $6ZpBv = parcelRequire("6ZpBv");

var $8FnrH = parcelRequire("8FnrH");
var $d00Io = parcelRequire("d00Io");

var $1575y = parcelRequire("1575y");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var $9578519ac1de612e$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
RegExp("^var\\(--(?:([\\w-]+)|([\\w-]+), ?([a-zA-Z\\d ()%#.,-]+))\\)", "u");
function $9578519ac1de612e$export$b9f0c1f373aee2b0(current) {
    var match = $9578519ac1de612e$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    var _match = (0, $6ZpBv._)(match, 4), token1 = _match[1], token2 = _match[2], fallback = _match[3];
    return [
        "--".concat(token1 !== null && token1 !== void 0 ? token1 : token2),
        fallback
    ];
}
var $9578519ac1de612e$var$maxDepth = 4;
function $9578519ac1de612e$export$289398774300c991(current, element) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    (0, $8FnrH.invariant)(depth <= $9578519ac1de612e$var$maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(current, '". This may indicate a circular fallback dependency.'), "max-css-var-depth");
    var _parseCSSVariable = (0, $6ZpBv._)($9578519ac1de612e$export$b9f0c1f373aee2b0(current), 2), token = _parseCSSVariable[0], fallback = _parseCSSVariable[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        var trimmed = resolved.trim();
        return (0, $d00Io.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $1575y.isCSSVariableToken)(fallback) ? $9578519ac1de612e$export$289398774300c991(fallback, element, depth + 1) : fallback;
}

});
parcelRegister("d00Io", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $1b7d2770b1215510$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var $1b7d2770b1215510$export$65583ed5a868f2d9 = function(v) {
    return RegExp("^-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)$", "u").test(v);
};

});


parcelRegister("1VyrA", function(module, exports) {

$parcel$export(module.exports, "flushKeyframeResolvers", function () { return $bbe6a3a5a744b0b6$export$78b96d2a12593b05; });
$parcel$export(module.exports, "KeyframeResolver", function () { return $bbe6a3a5a744b0b6$export$74d34ca3182f1750; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $hmQCQ = parcelRequire("hmQCQ");

var $gQFXj = parcelRequire("gQFXj");

var $dbdHF = parcelRequire("dbdHF");
var $bbe6a3a5a744b0b6$var$toResolve = new Set();
var $bbe6a3a5a744b0b6$var$isScheduled = false;
var $bbe6a3a5a744b0b6$var$anyNeedsMeasurement = false;
var $bbe6a3a5a744b0b6$var$isForced = false;
function $bbe6a3a5a744b0b6$var$measureAllKeyframes() {
    if ($bbe6a3a5a744b0b6$var$anyNeedsMeasurement) {
        var resolversToMeasure = Array.from($bbe6a3a5a744b0b6$var$toResolve).filter(function(resolver) {
            return resolver.needsMeasurement;
        });
        var elementsToMeasure = new Set(resolversToMeasure.map(function(resolver) {
            return resolver.element;
        }));
        var transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach(function(element) {
            var removedTransforms = (0, $gQFXj.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach(function(resolver) {
            return resolver.measureInitialState();
        });
        // Write
        elementsToMeasure.forEach(function(element) {
            element.render();
            var restore = transformsToRestore.get(element);
            if (restore) restore.forEach(function(param) {
                var _param = (0, $6ZpBv._)(param, 2), key = _param[0], value = _param[1];
                var _element_getValue;
                (_element_getValue = element.getValue(key)) === null || _element_getValue === void 0 ? void 0 : _element_getValue.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach(function(resolver) {
            return resolver.measureEndState();
        });
        // Write
        resolversToMeasure.forEach(function(resolver) {
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $bbe6a3a5a744b0b6$var$anyNeedsMeasurement = false;
    $bbe6a3a5a744b0b6$var$isScheduled = false;
    $bbe6a3a5a744b0b6$var$toResolve.forEach(function(resolver) {
        return resolver.complete($bbe6a3a5a744b0b6$var$isForced);
    });
    $bbe6a3a5a744b0b6$var$toResolve.clear();
}
function $bbe6a3a5a744b0b6$var$readAllKeyframes() {
    $bbe6a3a5a744b0b6$var$toResolve.forEach(function(resolver) {
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $bbe6a3a5a744b0b6$var$anyNeedsMeasurement = true;
    });
}
function $bbe6a3a5a744b0b6$export$78b96d2a12593b05() {
    $bbe6a3a5a744b0b6$var$isForced = true;
    $bbe6a3a5a744b0b6$var$readAllKeyframes();
    $bbe6a3a5a744b0b6$var$measureAllKeyframes();
    $bbe6a3a5a744b0b6$var$isForced = false;
}
var $bbe6a3a5a744b0b6$export$74d34ca3182f1750 = /*#__PURE__*/ function() {
    "use strict";
    function KeyframeResolver(unresolvedKeyframes, onComplete, name, motionValue, element) {
        var isAsync = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        (0, $4QweW._)(this, KeyframeResolver);
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = (0, $jlUaU._)(unresolvedKeyframes);
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    (0, $6hK4i._)(KeyframeResolver, [
        {
            key: "scheduleResolve",
            value: function scheduleResolve() {
                this.state = "scheduled";
                if (this.isAsync) {
                    $bbe6a3a5a744b0b6$var$toResolve.add(this);
                    if (!$bbe6a3a5a744b0b6$var$isScheduled) {
                        $bbe6a3a5a744b0b6$var$isScheduled = true;
                        (0, $dbdHF.frame).read($bbe6a3a5a744b0b6$var$readAllKeyframes);
                        (0, $dbdHF.frame).resolveKeyframes($bbe6a3a5a744b0b6$var$measureAllKeyframes);
                    }
                } else {
                    this.readKeyframes();
                    this.complete();
                }
            }
        },
        {
            key: "readKeyframes",
            value: function readKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name, element = _this.element, motionValue = _this.motionValue;
                // If initial keyframe is null we need to read it from the DOM
                if (unresolvedKeyframes[0] === null) {
                    var currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                    // TODO: This doesn't work if the final keyframe is a wildcard
                    var finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                    if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                    else if (element && name) {
                        var valueAsRead = element.readValue(name, finalKeyframe);
                        if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                    }
                    if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                    if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
                }
                (0, $hmQCQ.fillWildcards)(unresolvedKeyframes);
            }
        },
        {
            key: "setFinalKeyframe",
            value: function setFinalKeyframe() {}
        },
        {
            key: "measureInitialState",
            value: function measureInitialState() {}
        },
        {
            key: "renderEndStyles",
            value: function renderEndStyles() {}
        },
        {
            key: "measureEndState",
            value: function measureEndState() {}
        },
        {
            key: "complete",
            value: function complete() {
                var isForcedComplete = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                this.state = "complete";
                this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
                $bbe6a3a5a744b0b6$var$toResolve.delete(this);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.state === "scheduled") {
                    $bbe6a3a5a744b0b6$var$toResolve.delete(this);
                    this.state = "pending";
                }
            }
        },
        {
            key: "resume",
            value: function resume() {
                if (this.state === "pending") this.scheduleResolve();
            }
        }
    ]);
    return KeyframeResolver;
}();

});
parcelRegister("hmQCQ", function(module, exports) {

$parcel$export(module.exports, "fillWildcards", function () { return $ec7513447cd97abd$export$5a98a90409277f5a; });
function $ec7513447cd97abd$export$5a98a90409277f5a(keyframes) {
    var _keyframes_i;
    for(var i = 1; i < keyframes.length; i++)(_keyframes_i = keyframes[i]) !== null && _keyframes_i !== void 0 ? _keyframes_i : keyframes[i] = keyframes[i - 1];
}

});

parcelRegister("gQFXj", function(module, exports) {

$parcel$export(module.exports, "isNumOrPxType", function () { return $a676a25caf7ac960$export$8e5250d1aa9bf370; });
$parcel$export(module.exports, "removeNonTranslationalTransform", function () { return $a676a25caf7ac960$export$39d4bc9655f3f632; });
$parcel$export(module.exports, "positionalValues", function () { return $a676a25caf7ac960$export$781d46a8aa670d52; });

var $1QLzK = parcelRequire("1QLzK");

var $d4bUS = parcelRequire("d4bUS");

var $dr13F = parcelRequire("dr13F");

var $huIQG = parcelRequire("huIQG");
var $a676a25caf7ac960$export$8e5250d1aa9bf370 = function(v) {
    return v === (0, $dr13F.number) || v === (0, $huIQG.px);
};
var $a676a25caf7ac960$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var $a676a25caf7ac960$var$nonTranslationalTransformKeys = (0, $d4bUS.transformPropOrder).filter(function(key) {
    return !$a676a25caf7ac960$var$transformKeys.has(key);
});
function $a676a25caf7ac960$export$39d4bc9655f3f632(visualElement) {
    var removedTransforms = [];
    $a676a25caf7ac960$var$nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
var $a676a25caf7ac960$export$781d46a8aa670d52 = {
    // Dimensions
    width: function(param, param1) {
        var x = param.x, _param_paddingLeft = param1.paddingLeft, paddingLeft = _param_paddingLeft === void 0 ? "0" : _param_paddingLeft, _param_paddingRight = param1.paddingRight, paddingRight = _param_paddingRight === void 0 ? "0" : _param_paddingRight, boxSizing = param1.boxSizing;
        var width = x.max - x.min;
        return boxSizing === "border-box" ? width : width - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: function(param, param1) {
        var y = param.y, _param_paddingTop = param1.paddingTop, paddingTop = _param_paddingTop === void 0 ? "0" : _param_paddingTop, _param_paddingBottom = param1.paddingBottom, paddingBottom = _param_paddingBottom === void 0 ? "0" : _param_paddingBottom, boxSizing = param1.boxSizing;
        var height = y.max - y.min;
        return boxSizing === "border-box" ? height : height - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: function(_bbox, param) {
        var top = param.top;
        return parseFloat(top);
    },
    left: function(_bbox, param) {
        var left = param.left;
        return parseFloat(left);
    },
    bottom: function(param, param1) {
        var y = param.y, top = param1.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(param, param1) {
        var x = param.x, left = param1.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: function(_bbox, param) {
        var transform = param.transform;
        return (0, $1QLzK.parseValueFromTransform)(transform, "x");
    },
    y: function(_bbox, param) {
        var transform = param.transform;
        return (0, $1QLzK.parseValueFromTransform)(transform, "y");
    }
};
// Alias translate longform names
$a676a25caf7ac960$export$781d46a8aa670d52.translateX = $a676a25caf7ac960$export$781d46a8aa670d52.x;
$a676a25caf7ac960$export$781d46a8aa670d52.translateY = $a676a25caf7ac960$export$781d46a8aa670d52.y;

});

parcelRegister("dbdHF", function(module, exports) {

$parcel$export(module.exports, "frame", function () { return $eb4cbfd872d92625$export$2cef06c20297c17d; });
$parcel$export(module.exports, "cancelFrame", function () { return $eb4cbfd872d92625$export$ec99c0ef4978dccb; });
$parcel$export(module.exports, "frameData", function () { return $eb4cbfd872d92625$export$fff89137e9e818ce; });
$parcel$export(module.exports, "frameSteps", function () { return $eb4cbfd872d92625$export$1811c3a7e3af92f0; });

var $386Yo = parcelRequire("386Yo");

var $i2Hx6 = parcelRequire("i2Hx6");
var /* @__PURE__ */ $eb4cbfd872d92625$var$_createRenderBatcher = (0, $i2Hx6.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $386Yo.noop), true), $eb4cbfd872d92625$export$2cef06c20297c17d = $eb4cbfd872d92625$var$_createRenderBatcher.schedule, $eb4cbfd872d92625$export$ec99c0ef4978dccb = $eb4cbfd872d92625$var$_createRenderBatcher.cancel, $eb4cbfd872d92625$export$fff89137e9e818ce = $eb4cbfd872d92625$var$_createRenderBatcher.state, $eb4cbfd872d92625$export$1811c3a7e3af92f0 = $eb4cbfd872d92625$var$_createRenderBatcher.steps;

});
parcelRegister("386Yo", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $8d7fd89d88678088$export$8793edee2d425525; });
/*#__NO_SIDE_EFFECTS__*/ var $8d7fd89d88678088$export$8793edee2d425525 = function(any) {
    return any;
};

});

parcelRegister("i2Hx6", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", function () { return $2f5ce6a3bd5455af$export$510b0596a933801a; });

var $beX9F = parcelRequire("beX9F");

var $O2AuX = parcelRequire("O2AuX");

var $cL4wu = parcelRequire("cL4wu");
var $2f5ce6a3bd5455af$var$maxElapsed = 40;
function $2f5ce6a3bd5455af$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    var runNextFrame = false;
    var useDefaultElapsed = true;
    var state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    var flagRunNextFrame = function() {
        return runNextFrame = true;
    };
    var steps = (0, $O2AuX.stepsOrder).reduce(function(acc, key) {
        acc[key] = (0, $cL4wu.createRenderStep)(flagRunNextFrame);
        return acc;
    }, {});
    var setup = steps.setup, read = steps.read, resolveKeyframes = steps.resolveKeyframes, preUpdate = steps.preUpdate, update = steps.update, preRender = steps.preRender, render = steps.render, postRender = steps.postRender;
    var processBatch = function() {
        var useManualTiming = (0, $beX9F.MotionGlobalConfig).useManualTiming;
        var timestamp = useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $2f5ce6a3bd5455af$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    var wake = function() {
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    var schedule = (0, $O2AuX.stepsOrder).reduce(function(acc, key) {
        var step = steps[key];
        acc[key] = function(process) {
            var keepAlive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, immediate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    var cancel = function(process) {
        for(var i = 0; i < (0, $O2AuX.stepsOrder).length; i++)steps[(0, $O2AuX.stepsOrder)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("beX9F", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", function () { return $8ee90401e359a0b3$export$dd826089e3c5e502; });
var $8ee90401e359a0b3$export$dd826089e3c5e502 = {};

});

parcelRegister("O2AuX", function(module, exports) {

$parcel$export(module.exports, "stepsOrder", function () { return $ce3f39fb5edbc0dd$export$71ecace0a033b35a; });
var $ce3f39fb5edbc0dd$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];

});

parcelRegister("cL4wu", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $a65730901ed81fb8$export$b995e5e85f5c8289; });
function $a65730901ed81fb8$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ var thisFrame = new Set();
    var nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ var isProcessing = false;
    var flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ var toKeepAlive = new WeakSet();
    var latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    var step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: function(callback) {
            var keepAlive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, immediate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var addToCurrentFrame = immediate && isProcessing;
            var queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: function(callback) {
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: function(frameData) {
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            // Swap this frame and the next to avoid GC
            var prevFrame = thisFrame;
            thisFrame = nextFrame;
            nextFrame = prevFrame;
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});




parcelRegister("75PL6", function(module, exports) {

$parcel$export(module.exports, "isNone", function () { return $52ed1231c8da753f$export$e56af863d5645d5f; });

var $jnSp3 = parcelRequire("jnSp3");
function $52ed1231c8da753f$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $jnSp3.isZeroValueString)(value);
    else return true;
}

});
parcelRegister("jnSp3", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", function () { return $c31cfc85b6da4d26$export$ade84c85e44a6cb1; });
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var $c31cfc85b6da4d26$export$ade84c85e44a6cb1 = function(v) {
    return RegExp("^0[^.\\s]+$", "u").test(v);
};

});


parcelRegister("gmC1b", function(module, exports) {

$parcel$export(module.exports, "makeNoneKeyframesAnimatable", function () { return $3ff61c1270a066d5$export$8cc4958f8e540f37; });

var $eyJsx = parcelRequire("eyJsx");

var $1VpxQ = parcelRequire("1VpxQ");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ var $3ff61c1270a066d5$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $3ff61c1270a066d5$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    var i = 0;
    var animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        var keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$3ff61c1270a066d5$var$invalidTemplates.has(keyframe) && (0, $eyJsx.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (animatableTemplate && name) try {
        for(var _iterator = noneKeyframeIndexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var noneIndex = _step.value;
            unresolvedKeyframes[noneIndex] = (0, $1VpxQ.getAnimatableNone)(name, animatableTemplate);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

});
parcelRegister("eyJsx", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", function () { return $86f1dc12c05f6f7c$export$b61fc7c44bf646d5; });
$parcel$export(module.exports, "complex", function () { return $86f1dc12c05f6f7c$export$83a0e34f1302825b; });

var $h5K91 = parcelRequire("h5K91");

var $lVpI6 = parcelRequire("lVpI6");

var $lb6Tv = parcelRequire("lb6Tv");

var $iFpHv = parcelRequire("iFpHv");
function $86f1dc12c05f6f7c$var$test(v) {
    var _v_match, _v_match1;
    return isNaN(v) && typeof v === "string" && (((_v_match = v.match((0, $lb6Tv.floatRegex))) === null || _v_match === void 0 ? void 0 : _v_match.length) || 0) + (((_v_match1 = v.match((0, $lVpI6.colorRegex))) === null || _v_match1 === void 0 ? void 0 : _v_match1.length) || 0) > 0;
}
var $86f1dc12c05f6f7c$var$NUMBER_TOKEN = "number";
var $86f1dc12c05f6f7c$var$COLOR_TOKEN = "color";
var $86f1dc12c05f6f7c$var$VAR_TOKEN = "var";
var $86f1dc12c05f6f7c$var$VAR_FUNCTION_TOKEN = "var(";
var $86f1dc12c05f6f7c$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
var $86f1dc12c05f6f7c$var$complexRegex = RegExp("var\\s*\\(\\s*--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)|#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\)|-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "giu");
function $86f1dc12c05f6f7c$export$b61fc7c44bf646d5(value) {
    var originalValue = value.toString();
    var values = [];
    var indexes = {
        color: [],
        number: [],
        var: []
    };
    var types = [];
    var i = 0;
    var tokenised = originalValue.replace($86f1dc12c05f6f7c$var$complexRegex, function(parsedValue) {
        if ((0, $h5K91.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push($86f1dc12c05f6f7c$var$COLOR_TOKEN);
            values.push((0, $h5K91.color).parse(parsedValue));
        } else if (parsedValue.startsWith($86f1dc12c05f6f7c$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($86f1dc12c05f6f7c$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($86f1dc12c05f6f7c$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $86f1dc12c05f6f7c$var$SPLIT_TOKEN;
    });
    var split = tokenised.split($86f1dc12c05f6f7c$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $86f1dc12c05f6f7c$var$parseComplexValue(v) {
    return $86f1dc12c05f6f7c$export$b61fc7c44bf646d5(v).values;
}
function $86f1dc12c05f6f7c$var$buildTransformer(param) {
    var split = param.split, types = param.types;
    var numSections = split.length;
    return function(v) {
        var output = "";
        for(var i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                var type = types[i];
                if (type === $86f1dc12c05f6f7c$var$NUMBER_TOKEN) output += (0, $iFpHv.sanitize)(v[i]);
                else if (type === $86f1dc12c05f6f7c$var$COLOR_TOKEN) output += (0, $h5K91.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
function $86f1dc12c05f6f7c$var$createTransformer(source) {
    return $86f1dc12c05f6f7c$var$buildTransformer($86f1dc12c05f6f7c$export$b61fc7c44bf646d5(source));
}
var $86f1dc12c05f6f7c$var$convertNumbersToZero = function(v) {
    return typeof v === "number" ? 0 : (0, $h5K91.color).test(v) ? (0, $h5K91.color).getAnimatableNone(v) : v;
};
/**
 * Convert a parsed value to its zero equivalent, but preserve numbers
 * that act as divisors in CSS calc() expressions.
 *
 * analyseComplexValue extracts numbers from CSS strings and puts the
 * surrounding text into a `split` template array. For example:
 *   "calc(var(--gap) / 5)"  →  values: [var(--gap), 5]
 *                               split:  ["calc(", " / ", ")"]
 *
 * When building a zero-equivalent for animation, naively zeroing all
 * numbers turns the divisor into 0 → "calc(var(--gap) / 0)" → NaN.
 * We detect this by checking whether the text preceding a number
 * (split[i]) ends with "/" — the CSS calc division operator.
 */ var $86f1dc12c05f6f7c$var$convertToZero = function(value, splitBefore) {
    if (typeof value === "number") return (splitBefore === null || splitBefore === void 0 ? void 0 : splitBefore.trim().endsWith("/")) ? value : 0;
    return $86f1dc12c05f6f7c$var$convertNumbersToZero(value);
};
function $86f1dc12c05f6f7c$var$getAnimatableNone(v) {
    var info = $86f1dc12c05f6f7c$export$b61fc7c44bf646d5(v);
    var transformer = $86f1dc12c05f6f7c$var$buildTransformer(info);
    return transformer(info.values.map(function(value, i) {
        return $86f1dc12c05f6f7c$var$convertToZero(value, info.split[i]);
    }));
}
var $86f1dc12c05f6f7c$export$83a0e34f1302825b = {
    test: $86f1dc12c05f6f7c$var$test,
    parse: $86f1dc12c05f6f7c$var$parseComplexValue,
    createTransformer: $86f1dc12c05f6f7c$var$createTransformer,
    getAnimatableNone: $86f1dc12c05f6f7c$var$getAnimatableNone
};

});
parcelRegister("h5K91", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $87ca2cd44752b1e8$export$35e9368ef982300f; });

var $jEwEJ = parcelRequire("jEwEJ");

var $1NpYK = parcelRequire("1NpYK");

var $eMwxO = parcelRequire("eMwxO");
var $87ca2cd44752b1e8$export$35e9368ef982300f = {
    test: function(v) {
        return (0, $eMwxO.rgba).test(v) || (0, $jEwEJ.hex).test(v) || (0, $1NpYK.hsla).test(v);
    },
    parse: function(v) {
        if ((0, $eMwxO.rgba).test(v)) return (0, $eMwxO.rgba).parse(v);
        else if ((0, $1NpYK.hsla).test(v)) return (0, $1NpYK.hsla).parse(v);
        else return (0, $jEwEJ.hex).parse(v);
    },
    transform: function(v) {
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $eMwxO.rgba).transform(v) : (0, $1NpYK.hsla).transform(v);
    },
    getAnimatableNone: function(v) {
        var parsed = $87ca2cd44752b1e8$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $87ca2cd44752b1e8$export$35e9368ef982300f.transform(parsed);
    }
};

});
parcelRegister("jEwEJ", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $fa686667b87c6361$export$834dfc94dde4b3d8; });

var $eMwxO = parcelRequire("eMwxO");

var $jFTCj = parcelRequire("jFTCj");
function $fa686667b87c6361$var$parseHex(v) {
    var r = "";
    var g = "";
    var b = "";
    var a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
var $fa686667b87c6361$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $jFTCj.isColorString)("#"),
    parse: $fa686667b87c6361$var$parseHex,
    transform: (0, $eMwxO.rgba).transform
};

});
parcelRegister("eMwxO", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $4d54ff985b7ef57d$export$4e46ac54fc82cf3b; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $4ceSY = parcelRequire("4ceSY");

var $dr13F = parcelRequire("dr13F");

var $iFpHv = parcelRequire("iFpHv");

var $jFTCj = parcelRequire("jFTCj");
var $4d54ff985b7ef57d$var$clampRgbUnit = function(v) {
    return (0, $4ceSY.clamp)(0, 255, v);
};
var $4d54ff985b7ef57d$export$7a99c86b5b1f4c9e = (0, $hApvp._)((0, $kWfK0._)({}, (0, $dr13F.number)), {
    transform: function(v) {
        return Math.round($4d54ff985b7ef57d$var$clampRgbUnit(v));
    }
});
var $4d54ff985b7ef57d$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $jFTCj.isColorString)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $jFTCj.splitColor)("red", "green", "blue"),
    transform: function(param) {
        var red = param.red, green = param.green, blue = param.blue, tmp = param.alpha, alpha$1 = tmp === void 0 ? 1 : tmp;
        return "rgba(" + $4d54ff985b7ef57d$export$7a99c86b5b1f4c9e.transform(red) + ", " + $4d54ff985b7ef57d$export$7a99c86b5b1f4c9e.transform(green) + ", " + $4d54ff985b7ef57d$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $iFpHv.sanitize)((0, $dr13F.alpha).transform(alpha$1)) + ")";
    }
};

});
parcelRegister("iFpHv", function(module, exports) {

$parcel$export(module.exports, "sanitize", function () { return $e2d7217d62ab9056$export$83d2e9e3e4ee39ed; });
// If this number is a decimal, make it just five decimal places
// to avoid exponents
var $e2d7217d62ab9056$export$83d2e9e3e4ee39ed = function(v) {
    return Math.round(v * 100000) / 100000;
};

});

parcelRegister("jFTCj", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $83c0d0d79575ca51$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $83c0d0d79575ca51$export$73d6f35be992df24; });

var $6tY97 = parcelRequire("6tY97");

var $6ZpBv = parcelRequire("6ZpBv");

var $lb6Tv = parcelRequire("lb6Tv");

var $kriu0 = parcelRequire("kriu0");

var $eOD5W = parcelRequire("eOD5W");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ var $83c0d0d79575ca51$export$2c8400d58aca05e = function(type, testProp) {
    return function(v) {
        return Boolean(typeof v === "string" && (0, $eOD5W.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, $kriu0.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
};
var $83c0d0d79575ca51$export$73d6f35be992df24 = function(aName, bName, cName) {
    return function(v) {
        if (typeof v !== "string") return v;
        var _v_match = (0, $6ZpBv._)(v.match((0, $lb6Tv.floatRegex)), 4), a = _v_match[0], b = _v_match[1], c = _v_match[2], alpha = _v_match[3];
        var _obj;
        return _obj = {}, (0, $6tY97._)(_obj, aName, parseFloat(a)), (0, $6tY97._)(_obj, bName, parseFloat(b)), (0, $6tY97._)(_obj, cName, parseFloat(c)), (0, $6tY97._)(_obj, "alpha", alpha !== undefined ? parseFloat(alpha) : 1), _obj;
    };
};

});
parcelRegister("lb6Tv", function(module, exports) {

$parcel$export(module.exports, "floatRegex", function () { return $1666d3bc7a24a7b1$export$2444ca58c08448e4; });
var $1666d3bc7a24a7b1$export$2444ca58c08448e4 = RegExp("-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "gu");

});

parcelRegister("kriu0", function(module, exports) {

$parcel$export(module.exports, "isNullish", function () { return $f319f064d6e1902d$export$b931b78cbb3caf86; });
function $f319f064d6e1902d$export$b931b78cbb3caf86(v) {
    return v == null;
}

});

parcelRegister("eOD5W", function(module, exports) {

$parcel$export(module.exports, "singleColorRegex", function () { return $7e84f64cf58e68b4$export$ed808ff6ecd39e8d; });
var $7e84f64cf58e68b4$export$ed808ff6ecd39e8d = RegExp("^(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))$", "iu");

});




parcelRegister("1NpYK", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $80d93a09fbd90f03$export$810b04175080204c; });

var $dr13F = parcelRequire("dr13F");

var $huIQG = parcelRequire("huIQG");

var $iFpHv = parcelRequire("iFpHv");

var $jFTCj = parcelRequire("jFTCj");
var $80d93a09fbd90f03$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $jFTCj.isColorString)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $jFTCj.splitColor)("hue", "saturation", "lightness"),
    transform: function(param) {
        var hue = param.hue, saturation = param.saturation, lightness = param.lightness, tmp = param.alpha, alpha$1 = tmp === void 0 ? 1 : tmp;
        return "hsla(" + Math.round(hue) + ", " + (0, $huIQG.percent).transform((0, $iFpHv.sanitize)(saturation)) + ", " + (0, $huIQG.percent).transform((0, $iFpHv.sanitize)(lightness)) + ", " + (0, $iFpHv.sanitize)((0, $dr13F.alpha).transform(alpha$1)) + ")";
    }
};

});


parcelRegister("lVpI6", function(module, exports) {

$parcel$export(module.exports, "colorRegex", function () { return $a5a446fd501fa67e$export$740b69c5fad25dba; });
var $a5a446fd501fa67e$export$740b69c5fad25dba = RegExp("(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))", "giu");

});


parcelRegister("1VpxQ", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $5136d57ece350c7b$export$cea0cedcb94873b5; });

var $eyJsx = parcelRequire("eyJsx");

var $djm2x = parcelRequire("djm2x");

var $b1iLc = parcelRequire("b1iLc");

var $k1C7V = parcelRequire("k1C7V");
var $5136d57ece350c7b$var$customTypes = /*@__PURE__*/ new Set([
    (0, $djm2x.filter),
    (0, $b1iLc.mask)
]);
function $5136d57ece350c7b$export$cea0cedcb94873b5(key, value) {
    var defaultValueType = (0, $k1C7V.getDefaultValueType)(key);
    if (!$5136d57ece350c7b$var$customTypes.has(defaultValueType)) defaultValueType = (0, $eyJsx.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("djm2x", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $0722b9841846cdf8$export$3dea766d36a8935f; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $6ZpBv = parcelRequire("6ZpBv");

var $eyJsx = parcelRequire("eyJsx");

var $lb6Tv = parcelRequire("lb6Tv");
/**
 * Properties that should default to 1 or 100%
 */ var $0722b9841846cdf8$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $0722b9841846cdf8$var$applyDefaultFilter(v) {
    var _v_slice_split = (0, $6ZpBv._)(v.slice(0, -1).split("("), 2), name = _v_slice_split[0], value = _v_slice_split[1];
    if (name === "drop-shadow") return v;
    var _ref = (0, $6ZpBv._)(value.match((0, $lb6Tv.floatRegex)) || [], 1), number = _ref[0];
    if (!number) return v;
    var unit = value.replace(number, "");
    var defaultValue = $0722b9841846cdf8$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
var $0722b9841846cdf8$var$functionRegex = RegExp("\\b([a-z-]*)\\(.*?\\)", "gu");
var $0722b9841846cdf8$export$3dea766d36a8935f = (0, $hApvp._)((0, $kWfK0._)({}, (0, $eyJsx.complex)), {
    getAnimatableNone: function(v) {
        var functions = v.match($0722b9841846cdf8$var$functionRegex);
        return functions ? functions.map($0722b9841846cdf8$var$applyDefaultFilter).join(" ") : v;
    }
});

});

parcelRegister("b1iLc", function(module, exports) {

$parcel$export(module.exports, "mask", function () { return $c7b0daa3232398dc$export$d99f0801a68bbcf1; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $5djcY = parcelRequire("5djcY");

var $eyJsx = parcelRequire("eyJsx");
var $c7b0daa3232398dc$export$d99f0801a68bbcf1 = (0, $hApvp._)((0, $kWfK0._)({}, (0, $eyJsx.complex)), {
    getAnimatableNone: function(v) {
        var parsed = (0, $eyJsx.complex).parse(v);
        var transformer = (0, $eyJsx.complex).createTransformer(v);
        return transformer(parsed.map(function(v) {
            return typeof v === "number" ? 0 : (typeof v === "undefined" ? "undefined" : (0, $5djcY._)(v)) === "object" ? (0, $hApvp._)((0, $kWfK0._)({}, v), {
                alpha: 1
            }) : v;
        }));
    }
});

});

parcelRegister("k1C7V", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $d167322ef55ee06b$export$67d1babe0338d23b; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $h5K91 = parcelRequire("h5K91");

var $djm2x = parcelRequire("djm2x");

var $b1iLc = parcelRequire("b1iLc");

var $gbCHm = parcelRequire("gbCHm");
/**
 * A map of default value types for common values
 */ var $d167322ef55ee06b$export$98cd7c72c5a731fb = (0, $hApvp._)((0, $kWfK0._)({}, (0, $gbCHm.numberValueTypes)), {
    // Color props
    color: (0, $h5K91.color),
    backgroundColor: (0, $h5K91.color),
    outlineColor: (0, $h5K91.color),
    fill: (0, $h5K91.color),
    stroke: (0, $h5K91.color),
    // Border props
    borderColor: (0, $h5K91.color),
    borderTopColor: (0, $h5K91.color),
    borderRightColor: (0, $h5K91.color),
    borderBottomColor: (0, $h5K91.color),
    borderLeftColor: (0, $h5K91.color),
    filter: (0, $djm2x.filter),
    WebkitFilter: (0, $djm2x.filter),
    mask: (0, $b1iLc.mask),
    WebkitMask: (0, $b1iLc.mask)
});
/**
 * Gets the default ValueType for the provided value key
 */ var $d167322ef55ee06b$export$67d1babe0338d23b = function(key) {
    return $d167322ef55ee06b$export$98cd7c72c5a731fb[key];
};

});
parcelRegister("gbCHm", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $350de97feb6d16e7$export$eec14432cd1cb67b; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $lUiV7 = parcelRequire("lUiV7");

var $dr13F = parcelRequire("dr13F");

var $huIQG = parcelRequire("huIQG");

var $1shMc = parcelRequire("1shMc");
var $350de97feb6d16e7$export$eec14432cd1cb67b = (0, $hApvp._)((0, $kWfK0._)({
    // Border props
    borderWidth: (0, $huIQG.px),
    borderTopWidth: (0, $huIQG.px),
    borderRightWidth: (0, $huIQG.px),
    borderBottomWidth: (0, $huIQG.px),
    borderLeftWidth: (0, $huIQG.px),
    borderRadius: (0, $huIQG.px),
    borderTopLeftRadius: (0, $huIQG.px),
    borderTopRightRadius: (0, $huIQG.px),
    borderBottomRightRadius: (0, $huIQG.px),
    borderBottomLeftRadius: (0, $huIQG.px),
    // Positioning props
    width: (0, $huIQG.px),
    maxWidth: (0, $huIQG.px),
    height: (0, $huIQG.px),
    maxHeight: (0, $huIQG.px),
    top: (0, $huIQG.px),
    right: (0, $huIQG.px),
    bottom: (0, $huIQG.px),
    left: (0, $huIQG.px),
    inset: (0, $huIQG.px),
    insetBlock: (0, $huIQG.px),
    insetBlockStart: (0, $huIQG.px),
    insetBlockEnd: (0, $huIQG.px),
    insetInline: (0, $huIQG.px),
    insetInlineStart: (0, $huIQG.px),
    insetInlineEnd: (0, $huIQG.px),
    // Spacing props
    padding: (0, $huIQG.px),
    paddingTop: (0, $huIQG.px),
    paddingRight: (0, $huIQG.px),
    paddingBottom: (0, $huIQG.px),
    paddingLeft: (0, $huIQG.px),
    paddingBlock: (0, $huIQG.px),
    paddingBlockStart: (0, $huIQG.px),
    paddingBlockEnd: (0, $huIQG.px),
    paddingInline: (0, $huIQG.px),
    paddingInlineStart: (0, $huIQG.px),
    paddingInlineEnd: (0, $huIQG.px),
    margin: (0, $huIQG.px),
    marginTop: (0, $huIQG.px),
    marginRight: (0, $huIQG.px),
    marginBottom: (0, $huIQG.px),
    marginLeft: (0, $huIQG.px),
    marginBlock: (0, $huIQG.px),
    marginBlockStart: (0, $huIQG.px),
    marginBlockEnd: (0, $huIQG.px),
    marginInline: (0, $huIQG.px),
    marginInlineStart: (0, $huIQG.px),
    marginInlineEnd: (0, $huIQG.px),
    // Typography
    fontSize: (0, $huIQG.px),
    // Misc
    backgroundPositionX: (0, $huIQG.px),
    backgroundPositionY: (0, $huIQG.px)
}, (0, $1shMc.transformValueTypes)), {
    zIndex: (0, $lUiV7.int),
    // SVG
    fillOpacity: (0, $dr13F.alpha),
    strokeOpacity: (0, $dr13F.alpha),
    numOctaves: (0, $lUiV7.int)
});

});
parcelRegister("lUiV7", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $b9f9ab53ba50557b$export$7d260a2a5f8bc19e; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $dr13F = parcelRequire("dr13F");
var $b9f9ab53ba50557b$export$7d260a2a5f8bc19e = (0, $hApvp._)((0, $kWfK0._)({}, (0, $dr13F.number)), {
    transform: Math.round
});

});

parcelRegister("1shMc", function(module, exports) {

$parcel$export(module.exports, "transformValueTypes", function () { return $27fc93e621f9d515$export$f2e4285fee37e26; });

var $dr13F = parcelRequire("dr13F");

var $huIQG = parcelRequire("huIQG");
var $27fc93e621f9d515$export$f2e4285fee37e26 = {
    rotate: (0, $huIQG.degrees),
    /**
     * Internal channel for `transition.path` orientToPath. Composed onto
     * `rotate` at the transform-build sites so the user's `rotate` is
     * never read or overwritten. Not part of `transformPropOrder`.
     */ pathRotation: (0, $huIQG.degrees),
    rotateX: (0, $huIQG.degrees),
    rotateY: (0, $huIQG.degrees),
    rotateZ: (0, $huIQG.degrees),
    scale: (0, $dr13F.scale),
    scaleX: (0, $dr13F.scale),
    scaleY: (0, $dr13F.scale),
    scaleZ: (0, $dr13F.scale),
    skew: (0, $huIQG.degrees),
    skewX: (0, $huIQG.degrees),
    skewY: (0, $huIQG.degrees),
    distance: (0, $huIQG.px),
    translateX: (0, $huIQG.px),
    translateY: (0, $huIQG.px),
    translateZ: (0, $huIQG.px),
    x: (0, $huIQG.px),
    y: (0, $huIQG.px),
    z: (0, $huIQG.px),
    perspective: (0, $huIQG.px),
    transformPerspective: (0, $huIQG.px),
    opacity: (0, $dr13F.alpha),
    originX: (0, $huIQG.progressPercentage),
    originY: (0, $huIQG.progressPercentage),
    originZ: (0, $huIQG.px)
};

});






parcelRegister("5NNrB", function(module, exports) {

$parcel$export(module.exports, "setFeatureDefinitions", function () { return $c7aa98f10761cbdc$export$8ad214844176d967; });
$parcel$export(module.exports, "getFeatureDefinitions", function () { return $c7aa98f10761cbdc$export$e183cb9c018608ba; });
$parcel$export(module.exports, "VisualElement", function () { return $c7aa98f10761cbdc$export$fa8b653c0f3714e5; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $kWfK0 = parcelRequire("kWfK0");

var $1DiK7 = parcelRequire("1DiK7");

var $jlUaU = parcelRequire("jlUaU");

var $5djcY = parcelRequire("5djcY");

var $d00Io = parcelRequire("d00Io");
var $jnSp3 = parcelRequire("jnSp3");
var $8wJkX = parcelRequire("8wJkX");
var $32hw3 = parcelRequire("32hw3");

var $1VyrA = parcelRequire("1VyrA");

var $k2a4F = parcelRequire("k2a4F");

var $6LQSm = parcelRequire("6LQSm");

var $2NaEP = parcelRequire("2NaEP");

var $i1wr7 = parcelRequire("i1wr7");

var $fQu9K = parcelRequire("fQu9K");

var $c1b8l = parcelRequire("c1b8l");

var $eyJsx = parcelRequire("eyJsx");

var $1VpxQ = parcelRequire("1VpxQ");

var $8tRqX = parcelRequire("8tRqX");

var $kbjZS = parcelRequire("kbjZS");

var $4di6S = parcelRequire("4di6S");

var $g2y4Z = parcelRequire("g2y4Z");

var $d4bUS = parcelRequire("d4bUS");

var $2u3Qo = parcelRequire("2u3Qo");

var $9WvS8 = parcelRequire("9WvS8");

var $lHseB = parcelRequire("lHseB");

var $9bAyI = parcelRequire("9bAyI");

var $dbdHF = parcelRequire("dbdHF");
var $c7aa98f10761cbdc$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * Static feature definitions - can be injected by framework layer
 */ var $c7aa98f10761cbdc$var$featureDefinitions = {};
/**
 * Set feature definitions for all VisualElements.
 * This should be called by the framework layer (e.g., framer-motion) during initialization.
 */ function $c7aa98f10761cbdc$export$8ad214844176d967(definitions) {
    $c7aa98f10761cbdc$var$featureDefinitions = definitions;
}
/**
 * Get the current feature definitions
 */ function $c7aa98f10761cbdc$export$e183cb9c018608ba() {
    return $c7aa98f10761cbdc$var$featureDefinitions;
}
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ var $c7aa98f10761cbdc$export$fa8b653c0f3714e5 = /*#__PURE__*/ function() {
    "use strict";
    function VisualElement(param) {
        var _this = this;
        var parent = param.parent, props = param.props, presenceContext = param.presenceContext, reducedMotionConfig = param.reducedMotionConfig, skipAnimations = param.skipAnimations, blockInitialAnimation = param.blockInitialAnimation, visualState = param.visualState, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4QweW._)(this, VisualElement);
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * Decides whether animations should be skipped for this VisualElement.
         * Useful for E2E tests and visual regression testing.
         */ this.shouldSkipAnimations = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $1VyrA.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * Track whether this element has been mounted before, to detect
         * remounts after Suspense unmount/remount cycles.
         */ this.hasBeenMounted = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = function() {
            return _this.notify("Update", _this.latestValues);
        };
        this.render = function() {
            if (!_this.current) return;
            _this.triggerBuild();
            _this.renderInstance(_this.current, _this.renderState, _this.props.style, _this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = function() {
            var now = (0, $i1wr7.time).now();
            if (_this.renderScheduledAt < now) {
                _this.renderScheduledAt = now;
                (0, $dbdHF.frame).render(_this.render, false, true);
            }
        };
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        this.latestValues = latestValues;
        this.baseTarget = (0, $kWfK0._)({}, latestValues);
        this.initialValues = props.initial ? (0, $kWfK0._)({}, latestValues) : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.skipAnimationsConfig = skipAnimations;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $g2y4Z.isControllingVariants)(props);
        this.isVariantNode = (0, $g2y4Z.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ var _this_scrapeMotionValuesFromProps = this.scrapeMotionValuesFromProps(props, {}, this), willChange = _this_scrapeMotionValuesFromProps.willChange, initialMotionValues = (0, $1DiK7._)(_this_scrapeMotionValuesFromProps, [
            "willChange"
        ]);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $kbjZS.isMotionValue)(value)) value.set(latestValues[key]);
        }
    }
    (0, $6hK4i._)(VisualElement, [
        {
            /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
                return {};
            }
        },
        {
            key: "mount",
            value: function mount(instance) {
                var _this = this;
                var _this_parent;
                /**
         * If this element has been mounted before (e.g. after a Suspense
         * unmount/remount), reset motion values to their initial state
         * so animations replay correctly from initial → animate.
         */ if (this.hasBeenMounted) for(var key in this.initialValues){
                    var _this_values_get;
                    (_this_values_get = this.values.get(key)) === null || _this_values_get === void 0 ? void 0 : _this_values_get.jump(this.initialValues[key]);
                    this.latestValues[key] = this.initialValues[key];
                }
                this.current = instance;
                (0, $4di6S.visualElementStore).set(instance, this);
                if (this.projection && !this.projection.instance) this.projection.mount(instance);
                if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
                this.values.forEach(function(value, key) {
                    return _this.bindToMotionValue(key, value);
                });
                /**
         * Determine reduced motion preference. Only initialize the matchMedia
         * listener if we actually need the dynamic value (i.e., when config
         * is neither "never" nor "always").
         */ if (this.reducedMotionConfig === "never") this.shouldReduceMotion = false;
                else if (this.reducedMotionConfig === "always") this.shouldReduceMotion = true;
                else {
                    if (!(0, $9bAyI.hasReducedMotionListener).current) (0, $9WvS8.initPrefersReducedMotion)();
                    this.shouldReduceMotion = (0, $9bAyI.prefersReducedMotion).current;
                }
                var _this_skipAnimationsConfig;
                /**
         * Set whether animations should be skipped based on the config.
         */ this.shouldSkipAnimations = (_this_skipAnimationsConfig = this.skipAnimationsConfig) !== null && _this_skipAnimationsConfig !== void 0 ? _this_skipAnimationsConfig : false;
                (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.addChild(this);
                this.update(this.props, this.presenceContext);
                this.hasBeenMounted = true;
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                var _this_parent;
                this.projection && this.projection.unmount();
                (0, $dbdHF.cancelFrame)(this.notifyUpdate);
                (0, $dbdHF.cancelFrame)(this.render);
                this.valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                this.valueSubscriptions.clear();
                this.removeFromVariantTree && this.removeFromVariantTree();
                (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.removeChild(this);
                for(var key in this.events)this.events[key].clear();
                for(var key1 in this.features){
                    var feature = this.features[key1];
                    if (feature) {
                        feature.unmount();
                        feature.isMounted = false;
                    }
                }
                this.current = null;
            }
        },
        {
            key: "addChild",
            value: function addChild(child) {
                this.children.add(child);
                var _this_enteringChildren;
                (_this_enteringChildren = this.enteringChildren) !== null && _this_enteringChildren !== void 0 ? _this_enteringChildren : this.enteringChildren = new Set();
                this.enteringChildren.add(child);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(child) {
                this.children.delete(child);
                this.enteringChildren && this.enteringChildren.delete(child);
            }
        },
        {
            key: "bindToMotionValue",
            value: function bindToMotionValue(key, value) {
                var _this = this;
                if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
                if (value.accelerate && (0, $6LQSm.acceleratedValues).has(key) && this.current instanceof HTMLElement) {
                    var _value_accelerate = value.accelerate, factory = _value_accelerate.factory, keyframes = _value_accelerate.keyframes, times = _value_accelerate.times, ease = _value_accelerate.ease, duration = _value_accelerate.duration;
                    var animation = new (0, $k2a4F.NativeAnimation)({
                        element: this.current,
                        name: key,
                        keyframes: keyframes,
                        times: times,
                        ease: ease,
                        duration: (0, $8wJkX.secondsToMilliseconds)(duration)
                    });
                    var cleanup = factory(animation);
                    this.valueSubscriptions.set(key, function() {
                        cleanup();
                        animation.cancel();
                    });
                    return;
                }
                var valueIsTransform = (0, $d4bUS.transformProps).has(key);
                if (valueIsTransform && this.onBindTransform) this.onBindTransform();
                var removeOnChange = value.on("change", function(latestValue) {
                    _this.latestValues[key] = latestValue;
                    _this.props.onUpdate && (0, $dbdHF.frame).preRender(_this.notifyUpdate);
                    if (valueIsTransform && _this.projection) _this.projection.isTransformDirty = true;
                    _this.scheduleRender();
                });
                var removeSyncCheck;
                if (typeof window !== "undefined" && window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
                this.valueSubscriptions.set(key, function() {
                    removeOnChange();
                    if (removeSyncCheck) removeSyncCheck();
                // Defer to MotionValue.on("change") auto-stop so React 19 remounts
                // can resubscribe before the animation is cancelled (#3315).
                });
            }
        },
        {
            key: "sortNodePosition",
            value: function sortNodePosition(other) {
                /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
                return this.sortInstanceNodePosition(this.current, other.current);
            }
        },
        {
            key: "updateFeatures",
            value: function updateFeatures() {
                var key = "animation";
                for(key in $c7aa98f10761cbdc$var$featureDefinitions){
                    var featureDefinition = $c7aa98f10761cbdc$var$featureDefinitions[key];
                    if (!featureDefinition) continue;
                    var isEnabled = featureDefinition.isEnabled, FeatureConstructor = featureDefinition.Feature;
                    /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
                    /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                        var feature = this.features[key];
                        if (feature.isMounted) feature.update();
                        else {
                            feature.mount();
                            feature.isMounted = true;
                        }
                    }
                }
            }
        },
        {
            key: "triggerBuild",
            value: function triggerBuild() {
                this.build(this.renderState, this.latestValues, this.props);
            }
        },
        {
            /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ key: "measureViewportBox",
            value: function measureViewportBox() {
                return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $fQu9K.createBox)();
            }
        },
        {
            key: "getStaticValue",
            value: function getStaticValue(key) {
                return this.latestValues[key];
            }
        },
        {
            key: "setStaticValue",
            value: function setStaticValue(key, value) {
                this.latestValues[key] = value;
            }
        },
        {
            /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ key: "update",
            value: function update(props, presenceContext) {
                if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
                this.prevProps = this.props;
                this.props = props;
                this.prevPresenceContext = this.presenceContext;
                this.presenceContext = presenceContext;
                /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(var i = 0; i < $c7aa98f10761cbdc$var$propEventHandlers.length; i++){
                    var key = $c7aa98f10761cbdc$var$propEventHandlers[i];
                    if (this.propEventSubscriptions[key]) {
                        this.propEventSubscriptions[key]();
                        delete this.propEventSubscriptions[key];
                    }
                    var listenerName = "on" + key;
                    var listener = props[listenerName];
                    if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
                }
                this.prevMotionValues = (0, $2u3Qo.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps || {}, this), this.prevMotionValues);
                if (this.handleChildMotionValue) this.handleChildMotionValue();
            }
        },
        {
            key: "getProps",
            value: function getProps() {
                return this.props;
            }
        },
        {
            /**
     * Returns the variant definition with a given name.
     */ key: "getVariant",
            value: function getVariant(name) {
                return this.props.variants ? this.props.variants[name] : undefined;
            }
        },
        {
            /**
     * Returns the defined default transition on this component.
     */ key: "getDefaultTransition",
            value: function getDefaultTransition() {
                return this.props.transition;
            }
        },
        {
            key: "getTransformPagePoint",
            value: function getTransformPagePoint() {
                return this.props.transformPagePoint;
            }
        },
        {
            key: "getClosestVariantNode",
            value: function getClosestVariantNode() {
                return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
            }
        },
        {
            /**
     * Add a child visual element to our set of children.
     */ key: "addVariantChild",
            value: function addVariantChild(child) {
                var closestVariantNode = this.getClosestVariantNode();
                if (closestVariantNode) {
                    closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            }
        },
        {
            /**
     * Add a motion value and bind it to this visual element.
     */ key: "addValue",
            value: function addValue(key, value) {
                // Remove existing value if it exists
                var existingValue = this.values.get(key);
                if (value !== existingValue) {
                    if (existingValue) this.removeValue(key);
                    this.bindToMotionValue(key, value);
                    this.values.set(key, value);
                    this.latestValues[key] = value.get();
                }
            }
        },
        {
            /**
     * Remove a motion value and unbind any active subscriptions.
     */ key: "removeValue",
            value: function removeValue(key) {
                this.values.delete(key);
                var unsubscribe = this.valueSubscriptions.get(key);
                if (unsubscribe) {
                    unsubscribe();
                    this.valueSubscriptions.delete(key);
                }
                delete this.latestValues[key];
                this.removeValueFromRenderState(key, this.renderState);
            }
        },
        {
            /**
     * Check whether we have a motion value for this key
     */ key: "hasValue",
            value: function hasValue(key) {
                return this.values.has(key);
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (this.props.values && this.props.values[key]) return this.props.values[key];
                var value = this.values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $c1b8l.motionValue)(defaultValue === null ? undefined : defaultValue, {
                        owner: this
                    });
                    this.addValue(key, value);
                }
                return value;
            }
        },
        {
            /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ key: "readValue",
            value: function readValue(key, target) {
                var _this_getBaseTargetFromProps;
                var value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_this_getBaseTargetFromProps = this.getBaseTargetFromProps(this.props, key)) !== null && _this_getBaseTargetFromProps !== void 0 ? _this_getBaseTargetFromProps : this.readValueFromInstance(this.current, key, this.options);
                if (value !== undefined && value !== null) {
                    if (typeof value === "string" && ((0, $d00Io.isNumericalString)(value) || (0, $jnSp3.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
                    value = parseFloat(value);
                    else if (!(0, $8tRqX.findValueType)(value) && (0, $eyJsx.complex).test(target)) value = (0, $1VpxQ.getAnimatableNone)(key, target);
                    this.setBaseTarget(key, (0, $kbjZS.isMotionValue)(value) ? value.get() : value);
                }
                return (0, $kbjZS.isMotionValue)(value) ? value.get() : value;
            }
        },
        {
            /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ key: "setBaseTarget",
            value: function setBaseTarget(key, value) {
                this.baseTarget[key] = value;
            }
        },
        {
            /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ key: "getBaseTarget",
            value: function getBaseTarget(key) {
                var initial = this.props.initial;
                var valueFromInitial;
                if (typeof initial === "string" || (typeof initial === "undefined" ? "undefined" : (0, $5djcY._)(initial)) === "object") {
                    var _this_presenceContext;
                    var variant = (0, $lHseB.resolveVariantFromProps)(this.props, initial, (_this_presenceContext = this.presenceContext) === null || _this_presenceContext === void 0 ? void 0 : _this_presenceContext.custom);
                    if (variant) valueFromInitial = variant[key];
                }
                /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
                /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ var target = this.getBaseTargetFromProps(this.props, key);
                if (target !== undefined && !(0, $kbjZS.isMotionValue)(target)) return target;
                /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                if (!this.events[eventName]) this.events[eventName] = new (0, $32hw3.SubscriptionManager)();
                return this.events[eventName].add(callback);
            }
        },
        {
            key: "notify",
            value: function notify(eventName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this_events_eventName;
                if (this.events[eventName]) (_this_events_eventName = this.events[eventName]).notify.apply(_this_events_eventName, (0, $jlUaU._)(args));
            }
        },
        {
            key: "scheduleRenderMicrotask",
            value: function scheduleRenderMicrotask() {
                (0, $2NaEP.microtask).render(this.render);
            }
        }
    ]);
    return VisualElement;
}();

});
parcelRegister("1DiK7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1307f8e9916ec00c$export$71511d61b312f219; });

var $fD3AT = parcelRequire("fD3AT");
function $1307f8e9916ec00c$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $fD3AT._)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("fD3AT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b60d49377240381a$export$71511d61b312f219; });
function $b60d49377240381a$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("8wJkX", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $6e5175f1993e720e$export$fc3e7e8557f8c8c7; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return $6e5175f1993e720e$export$f64c3bfbc58eec0f; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ var $6e5175f1993e720e$export$fc3e7e8557f8c8c7 = function(seconds) {
    return seconds * 1000;
};
/*#__NO_SIDE_EFFECTS__*/ var $6e5175f1993e720e$export$f64c3bfbc58eec0f = function(milliseconds) {
    return milliseconds / 1000;
};

});

parcelRegister("32hw3", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $485d1d69ca09b311$export$e7dff9482a5fd23c; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $GsJqF = parcelRequire("GsJqF");
var $485d1d69ca09b311$export$e7dff9482a5fd23c = /*#__PURE__*/ function() {
    "use strict";
    function SubscriptionManager() {
        (0, $4QweW._)(this, SubscriptionManager);
        this.subscriptions = [];
    }
    (0, $6hK4i._)(SubscriptionManager, [
        {
            key: "add",
            value: function add(handler) {
                var _this = this;
                (0, $GsJqF.addUniqueItem)(this.subscriptions, handler);
                return function() {
                    return (0, $GsJqF.removeItem)(_this.subscriptions, handler);
                };
            }
        },
        {
            key: "notify",
            value: function notify(a, b, c) {
                var numSubscriptions = this.subscriptions.length;
                if (!numSubscriptions) return;
                if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
                else for(var i = 0; i < numSubscriptions; i++){
                    /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
                    handler && handler(a, b, c);
                }
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.subscriptions.length;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.subscriptions.length = 0;
            }
        }
    ]);
    return SubscriptionManager;
}();

});
parcelRegister("GsJqF", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $e923aae77294e27a$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $e923aae77294e27a$export$fe2d9b4e03920b4c; });

var $6ZpBv = parcelRequire("6ZpBv");

var $5qmJn = parcelRequire("5qmJn");
function $e923aae77294e27a$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $e923aae77294e27a$export$fe2d9b4e03920b4c(arr, item) {
    var index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $e923aae77294e27a$export$ec937e64de6c1257(param, fromIndex, toIndex) {
    var _param = (0, $5qmJn._)(param), arr = _param.slice(0);
    var startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        var endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        var _arr_splice = (0, $6ZpBv._)(arr.splice(fromIndex, 1), 1), item = _arr_splice[0];
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});
parcelRegister("5qmJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3f31035a756f4f38$export$71511d61b312f219; });

var $ceUCx = parcelRequire("ceUCx");

var $d95Qy = parcelRequire("d95Qy");

var $OKxK3 = parcelRequire("OKxK3");

var $J66Jb = parcelRequire("J66Jb");
function $3f31035a756f4f38$export$71511d61b312f219(arr) {
    return (0, $ceUCx._)(arr) || (0, $d95Qy._)(arr) || (0, $J66Jb._)(arr) || (0, $OKxK3._)();
}

});



parcelRegister("k2a4F", function(module, exports) {

$parcel$export(module.exports, "NativeAnimation", function () { return $af3bf5d143114b5e$export$6c0f9803d8aa7219; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $hvep1 = parcelRequire("hvep1");

var $8FnrH = parcelRequire("8FnrH");
var $8wJkX = parcelRequire("8wJkX");
var $386Yo = parcelRequire("386Yo");

var $nrOms = parcelRequire("nrOms");

var $2PaVC = parcelRequire("2PaVC");

var $8padT = parcelRequire("8padT");

var $vu8m8 = parcelRequire("vu8m8");

var $3poaa = parcelRequire("3poaa");

var $iRwJs = parcelRequire("iRwJs");
/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ var $af3bf5d143114b5e$export$6c0f9803d8aa7219 = /*#__PURE__*/ function(WithPromise) {
    "use strict";
    (0, $c2MhV._)(NativeAnimation, WithPromise);
    function NativeAnimation(options) {
        (0, $4QweW._)(this, NativeAnimation);
        var _this;
        _this = (0, $ehF45._)(this, NativeAnimation);
        _this.finishedTime = null;
        _this.isStopped = false;
        /**
         * Tracks a manually-set start time that takes precedence over WAAPI's
         * dynamic startTime. This is cleared when play() or time setter is called,
         * allowing WAAPI to take over timing.
         */ _this.manualStartTime = null;
        if (!options) return (0, $hvep1._)(_this);
        var element = options.element, name = options.name, keyframes = options.keyframes, pseudoElement = options.pseudoElement, _options_allowFlatten = options.allowFlatten, allowFlatten = _options_allowFlatten === void 0 ? false : _options_allowFlatten, finalKeyframe = options.finalKeyframe, onComplete = options.onComplete;
        _this.isPseudoElement = Boolean(pseudoElement);
        _this.allowFlatten = allowFlatten;
        _this.options = options;
        (0, $8FnrH.invariant)(typeof options.type !== "string", 'Mini animate() doesn\'t support "type" as a string.', "mini-spring");
        var transition = (0, $iRwJs.applyGeneratorOptions)(options);
        _this.animation = (0, $3poaa.startWaapiAnimation)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) _this.animation.pause();
        _this.animation.onfinish = function() {
            _this.finishedTime = _this.time;
            if (!pseudoElement) {
                var keyframe = (0, $8padT.getFinalKeyframe)(keyframes, _this.options, finalKeyframe, _this.speed);
                if (_this.updateMotionValue) _this.updateMotionValue(keyframe);
                /**
                 * If we can, we want to commit the final style as set by the user,
                 * rather than the computed keyframe value supplied by the animation.
                 * We always do this, even when a motion value is present, to prevent
                 * a visual flash in Firefox where the WAAPI animation's fill is removed
                 * during cancel() before the scheduled render can apply the correct value.
                 */ (0, $nrOms.setStyle)(element, name, keyframe);
                _this.animation.cancel();
            }
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
            _this.notifyFinished();
        };
        return _this;
    }
    (0, $6hK4i._)(NativeAnimation, [
        {
            key: "play",
            value: function play() {
                if (this.isStopped) return;
                this.manualStartTime = null;
                this.animation.play();
                if (this.state === "finished") this.updateFinished();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.animation.pause();
            }
        },
        {
            key: "complete",
            value: function complete() {
                var _this_animation_finish, _this_animation;
                (_this_animation_finish = (_this_animation = this.animation).finish) === null || _this_animation_finish === void 0 ? void 0 : _this_animation_finish.call(_this_animation);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                try {
                    this.animation.cancel();
                } catch (e) {}
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.isStopped) return;
                this.isStopped = true;
                var state = this.state;
                if (state === "idle" || state === "finished") return;
                if (this.updateMotionValue) this.updateMotionValue();
                else this.commitStyles();
                if (!this.isPseudoElement) this.cancel();
            }
        },
        {
            /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ key: "commitStyles",
            value: function commitStyles() {
                var _this_options, _this_animation_commitStyles, _this_animation;
                var element = (_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.element;
                if (!this.isPseudoElement && (element === null || element === void 0 ? void 0 : element.isConnected)) (_this_animation_commitStyles = (_this_animation = this.animation).commitStyles) === null || _this_animation_commitStyles === void 0 ? void 0 : _this_animation_commitStyles.call(_this_animation);
            }
        },
        {
            key: "duration",
            get: function get() {
                var _this_animation_effect_getComputedTiming, _this_animation_effect;
                var duration = ((_this_animation_effect = this.animation.effect) === null || _this_animation_effect === void 0 ? void 0 : (_this_animation_effect_getComputedTiming = _this_animation_effect.getComputedTiming) === null || _this_animation_effect_getComputedTiming === void 0 ? void 0 : _this_animation_effect_getComputedTiming.call(_this_animation_effect).duration) || 0;
                return (0, $8wJkX.millisecondsToSeconds)(Number(duration));
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                var _ref = this.options || {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay;
                return this.duration + (0, $8wJkX.millisecondsToSeconds)(delay);
            }
        },
        {
            key: "time",
            get: function get() {
                return (0, $8wJkX.millisecondsToSeconds)(Number(this.animation.currentTime) || 0);
            },
            set: function set(newTime) {
                var wasFinished = this.finishedTime !== null;
                this.manualStartTime = null;
                this.finishedTime = null;
                this.animation.currentTime = (0, $8wJkX.secondsToMilliseconds)(newTime);
                if (wasFinished) this.animation.pause();
            }
        },
        {
            key: "speed",
            get: /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ function get() {
                return this.animation.playbackRate;
            },
            set: function set(newSpeed) {
                // Allow backwards playback after finishing
                if (newSpeed < 0) this.finishedTime = null;
                this.animation.playbackRate = newSpeed;
            }
        },
        {
            key: "state",
            get: function get() {
                return this.finishedTime !== null ? "finished" : this.animation.playState;
            }
        },
        {
            key: "startTime",
            get: function get() {
                var _this_manualStartTime;
                return (_this_manualStartTime = this.manualStartTime) !== null && _this_manualStartTime !== void 0 ? _this_manualStartTime : Number(this.animation.startTime);
            },
            set: function set(newStartTime) {
                this.manualStartTime = this.animation.startTime = newStartTime;
            }
        },
        {
            /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ key: "attachTimeline",
            value: function attachTimeline(param) {
                var timeline = param.timeline, rangeStart = param.rangeStart, rangeEnd = param.rangeEnd, observe = param.observe;
                var _this_animation_effect;
                if (this.allowFlatten) (_this_animation_effect = this.animation.effect) === null || _this_animation_effect === void 0 ? void 0 : _this_animation_effect.updateTiming({
                    easing: "linear"
                });
                this.animation.onfinish = null;
                if (timeline && (0, $2PaVC.supportsScrollTimeline)()) {
                    this.animation.timeline = timeline;
                    if (rangeStart) this.animation.rangeStart = rangeStart;
                    if (rangeEnd) this.animation.rangeEnd = rangeEnd;
                    return 0, $386Yo.noop;
                } else return observe(this);
            }
        }
    ]);
    return NativeAnimation;
}((0, $vu8m8.WithPromise));

});
parcelRegister("nrOms", function(module, exports) {

$parcel$export(module.exports, "setStyle", function () { return $7dea602cef822693$export$37a5fde709c1db82; });

var $dVxQs = parcelRequire("dVxQs");
function $7dea602cef822693$export$37a5fde709c1db82(element, name, value) {
    (0, $dVxQs.isCSSVar)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}

});
parcelRegister("dVxQs", function(module, exports) {

$parcel$export(module.exports, "isCSSVar", function () { return $ee2f05804be576ad$export$c9f584638d388483; });
var $ee2f05804be576ad$export$c9f584638d388483 = function(name) {
    return name.startsWith("--");
};

});


parcelRegister("2PaVC", function(module, exports) {

$parcel$export(module.exports, "supportsScrollTimeline", function () { return $e0e775a02cda32bd$export$20d68f04f30763a5; });

var $euELC = parcelRequire("euELC");
var $e0e775a02cda32bd$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $euELC.memoSupports)(function() {
    return window.ScrollTimeline !== undefined;
}, "scrollTimeline");
var $e0e775a02cda32bd$export$206321d8c5f8fd38 = /* @__PURE__ */ (0, $euELC.memoSupports)(function() {
    return window.ViewTimeline !== undefined;
}, "viewTimeline");

});
parcelRegister("euELC", function(module, exports) {

$parcel$export(module.exports, "memoSupports", function () { return $c4e506ffed961072$export$1964673d5ec13c3a; });

var $7y43T = parcelRequire("7y43T");

var $j0CG8 = parcelRequire("j0CG8");
function $c4e506ffed961072$export$1964673d5ec13c3a(callback, supportsFlag) {
    var memoized = (0, $7y43T.memo)(callback);
    return function() {
        var _supportsFlags_supportsFlag;
        return (_supportsFlags_supportsFlag = (0, $j0CG8.supportsFlags)[supportsFlag]) !== null && _supportsFlags_supportsFlag !== void 0 ? _supportsFlags_supportsFlag : memoized();
    };
}

});
parcelRegister("7y43T", function(module, exports) {

$parcel$export(module.exports, "memo", function () { return $256fc20f586f26d9$export$7c73462e0d25e514; });
/*#__NO_SIDE_EFFECTS__*/ function $256fc20f586f26d9$export$7c73462e0d25e514(callback) {
    var result;
    return function() {
        if (result === undefined) result = callback();
        return result;
    };
}

});

parcelRegister("j0CG8", function(module, exports) {

$parcel$export(module.exports, "supportsFlags", function () { return $4a0062fa54c29901$export$e3ad02c335474dee; });
/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ var $4a0062fa54c29901$export$e3ad02c335474dee = {};

});



parcelRegister("8padT", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", function () { return $e714b15dad9cdb07$export$14de59408fad90b; });
var $e714b15dad9cdb07$var$isNotNull = function(value) {
    return value !== null;
};
function $e714b15dad9cdb07$export$14de59408fad90b(keyframes, param, finalKeyframe) {
    var repeat = param.repeat, _param_repeatType = param.repeatType, repeatType = _param_repeatType === void 0 ? "loop" : _param_repeatType, speed = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    var resolvedKeyframes = keyframes.filter($e714b15dad9cdb07$var$isNotNull);
    var useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    var index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("vu8m8", function(module, exports) {

$parcel$export(module.exports, "WithPromise", function () { return $c8f1bc25d7f0b7ef$export$655db786091c33e0; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");
var $c8f1bc25d7f0b7ef$export$655db786091c33e0 = /*#__PURE__*/ function() {
    "use strict";
    function WithPromise() {
        (0, $4QweW._)(this, WithPromise);
        this.updateFinished();
    }
    (0, $6hK4i._)(WithPromise, [
        {
            key: "finished",
            get: function get() {
                return this._finished;
            }
        },
        {
            key: "updateFinished",
            value: function updateFinished() {
                var _this = this;
                this._finished = new Promise(function(resolve) {
                    _this.resolve = resolve;
                });
            }
        },
        {
            key: "notifyFinished",
            value: function notifyFinished() {
                this.resolve();
            }
        },
        {
            /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ key: "then",
            value: function then(onResolve, onReject) {
                return this.finished.then(onResolve, onReject);
            }
        }
    ]);
    return WithPromise;
}();

});

parcelRegister("3poaa", function(module, exports) {

$parcel$export(module.exports, "startWaapiAnimation", function () { return $f121b857c340b4ee$export$d896de52f97cb615; });

var $6tY97 = parcelRequire("6tY97");

var $57Qnv = parcelRequire("57Qnv");
function $f121b857c340b4ee$export$d896de52f97cb615(element, valueName, keyframes) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay, _ref_duration = _ref.duration, duration = _ref_duration === void 0 ? 300 : _ref_duration, _ref_repeat = _ref.repeat, repeat = _ref_repeat === void 0 ? 0 : _ref_repeat, _ref_repeatType = _ref.repeatType, repeatType = _ref_repeatType === void 0 ? "loop" : _ref_repeatType, _ref_ease = _ref.ease, ease = _ref_ease === void 0 ? "easeOut" : _ref_ease, times = _ref.times, pseudoElement = arguments.length > 4 ? arguments[4] : void 0;
    var keyframeOptions = (0, $6tY97._)({}, valueName, keyframes);
    if (times) keyframeOptions.offset = times;
    var easing = (0, $57Qnv.mapEasingToNativeEasing)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    var options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    return element.animate(keyframeOptions, options);
}

});
parcelRegister("57Qnv", function(module, exports) {

$parcel$export(module.exports, "mapEasingToNativeEasing", function () { return $b398bbe17c494417$export$916ea73bcd3a6030; });

var $9059e = parcelRequire("9059e");

var $4VsZ3 = parcelRequire("4VsZ3");

var $1iHAC = parcelRequire("1iHAC");

var $7Xcd8 = parcelRequire("7Xcd8");

var $3Ar1M = parcelRequire("3Ar1M");
function $b398bbe17c494417$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $4VsZ3.supportsLinearEasing)() ? (0, $1iHAC.generateLinearEasing)(easing, duration) : "ease-out";
    else if ((0, $9059e.isBezierDefinition)(easing)) return (0, $7Xcd8.cubicBezierAsString)(easing);
    else if (Array.isArray(easing)) return easing.map(function(segmentEasing) {
        return $b398bbe17c494417$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $3Ar1M.supportedWaapiEasing).easeOut;
    });
    else return (0, $3Ar1M.supportedWaapiEasing)[easing];
}

});
parcelRegister("9059e", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", function () { return $f3e74f66dbf35fbb$export$ff43f99925d7366b; });
/*#__NO_SIDE_EFFECTS__*/ var $f3e74f66dbf35fbb$export$ff43f99925d7366b = function(easing) {
    return Array.isArray(easing) && typeof easing[0] === "number";
};

});

parcelRegister("4VsZ3", function(module, exports) {

$parcel$export(module.exports, "supportsLinearEasing", function () { return $521e8a965fd0866e$export$866c1d07a1ac2ab; });

var $euELC = parcelRequire("euELC");
var $521e8a965fd0866e$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $euELC.memoSupports)(function() {
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

});

parcelRegister("1iHAC", function(module, exports) {

$parcel$export(module.exports, "generateLinearEasing", function () { return $7fc2cc7060457027$export$66d3851e2b1ec912; });
var $7fc2cc7060457027$export$66d3851e2b1ec912 = function(easing, duration) {
    var resolution = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10 // as milliseconds
    ;
    var points = "";
    var numPoints = Math.max(Math.round(duration / resolution), 2);
    for(var i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return "linear(".concat(points.substring(0, points.length - 2), ")");
};

});

parcelRegister("7Xcd8", function(module, exports) {

$parcel$export(module.exports, "cubicBezierAsString", function () { return $e9ca5320c72de055$export$2523b8f0bd8f44cb; });

var $6ZpBv = parcelRequire("6ZpBv");
var $e9ca5320c72de055$export$2523b8f0bd8f44cb = function(param) {
    var _param = (0, $6ZpBv._)(param, 4), a = _param[0], b = _param[1], c = _param[2], d = _param[3];
    return "cubic-bezier(".concat(a, ", ").concat(b, ", ").concat(c, ", ").concat(d, ")");
};

});

parcelRegister("3Ar1M", function(module, exports) {

$parcel$export(module.exports, "supportedWaapiEasing", function () { return $c4feff16e7ea1b63$export$2cf569f5e2221176; });

var $7Xcd8 = parcelRequire("7Xcd8");
var $c4feff16e7ea1b63$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $7Xcd8.cubicBezierAsString)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $7Xcd8.cubicBezierAsString)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $7Xcd8.cubicBezierAsString)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $7Xcd8.cubicBezierAsString)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};

});



parcelRegister("iRwJs", function(module, exports) {

$parcel$export(module.exports, "applyGeneratorOptions", function () { return $e6ac39c2cdcacf7f$export$a31269144d66b4a; });

var $1DiK7 = parcelRequire("1DiK7");

var $4VsZ3 = parcelRequire("4VsZ3");

var $kicPc = parcelRequire("kicPc");
function $e6ac39c2cdcacf7f$export$a31269144d66b4a(_param) {
    var type = _param.type, options = (0, $1DiK7._)(_param, [
        "type"
    ]);
    if ((0, $kicPc.isGenerator)(type) && (0, $4VsZ3.supportsLinearEasing)()) return type.applyToOptions(options);
    else {
        var _options_duration;
        (_options_duration = options.duration) !== null && _options_duration !== void 0 ? _options_duration : options.duration = 300;
        var _options_ease;
        (_options_ease = options.ease) !== null && _options_ease !== void 0 ? _options_ease : options.ease = "easeOut";
    }
    return options;
}

});
parcelRegister("kicPc", function(module, exports) {

$parcel$export(module.exports, "isGenerator", function () { return $a9e79857072617b8$export$6ab7812f1bac68be; });
function $a9e79857072617b8$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}

});



parcelRegister("6LQSm", function(module, exports) {

$parcel$export(module.exports, "acceleratedValues", function () { return $783152822997b594$export$a27eefbd8fb5e404; });
/**
 * A list of values that can be hardware-accelerated.
 */ var $783152822997b594$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);

});

parcelRegister("2NaEP", function(module, exports) {

$parcel$export(module.exports, "microtask", function () { return $1e3eeeb8f591a840$export$bb76eed83315504c; });

var $i2Hx6 = parcelRequire("i2Hx6");
var /* @__PURE__ */ $1e3eeeb8f591a840$var$_createRenderBatcher = (0, $i2Hx6.createRenderBatcher)(queueMicrotask, false), $1e3eeeb8f591a840$export$bb76eed83315504c = $1e3eeeb8f591a840$var$_createRenderBatcher.schedule, $1e3eeeb8f591a840$export$3252729004b8456e = $1e3eeeb8f591a840$var$_createRenderBatcher.cancel;

});

parcelRegister("i1wr7", function(module, exports) {

$parcel$export(module.exports, "time", function () { return $fb113f3400d8eb36$export$2da9be4cfdb689b1; });

var $beX9F = parcelRequire("beX9F");

var $dbdHF = parcelRequire("dbdHF");
var $fb113f3400d8eb36$var$now;
function $fb113f3400d8eb36$var$clearTime() {
    $fb113f3400d8eb36$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ var $fb113f3400d8eb36$export$2da9be4cfdb689b1 = {
    now: function() {
        if ($fb113f3400d8eb36$var$now === undefined) $fb113f3400d8eb36$export$2da9be4cfdb689b1.set((0, $dbdHF.frameData).isProcessing || (0, $beX9F.MotionGlobalConfig).useManualTiming ? (0, $dbdHF.frameData).timestamp : performance.now());
        return $fb113f3400d8eb36$var$now;
    },
    set: function(newTime) {
        $fb113f3400d8eb36$var$now = newTime;
        queueMicrotask($fb113f3400d8eb36$var$clearTime);
    }
};

});

parcelRegister("fQu9K", function(module, exports) {

$parcel$export(module.exports, "createDelta", function () { return $0783ed6a47877f24$export$3d227df54007d73a; });
$parcel$export(module.exports, "createBox", function () { return $0783ed6a47877f24$export$6459fc9e86be362e; });
var $0783ed6a47877f24$export$ff25708b37f72782 = function() {
    return {
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    };
};
var $0783ed6a47877f24$export$3d227df54007d73a = function() {
    return {
        x: $0783ed6a47877f24$export$ff25708b37f72782(),
        y: $0783ed6a47877f24$export$ff25708b37f72782()
    };
};
var $0783ed6a47877f24$export$6db76765312617ac = function() {
    return {
        min: 0,
        max: 0
    };
};
var $0783ed6a47877f24$export$6459fc9e86be362e = function() {
    return {
        x: $0783ed6a47877f24$export$6db76765312617ac(),
        y: $0783ed6a47877f24$export$6db76765312617ac()
    };
};

});

parcelRegister("c1b8l", function(module, exports) {

$parcel$export(module.exports, "motionValue", function () { return $343c15b8f0f45b2b$export$ce8bdc721e76545f; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $32hw3 = parcelRequire("32hw3");
var $dVjOS = parcelRequire("dVjOS");

var $i1wr7 = parcelRequire("i1wr7");

var $dbdHF = parcelRequire("dbdHF");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ var $343c15b8f0f45b2b$var$MAX_VELOCITY_DELTA = 30;
var $343c15b8f0f45b2b$var$isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
var $343c15b8f0f45b2b$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var $343c15b8f0f45b2b$export$8cea36d14ee64562 = /*#__PURE__*/ function() {
    "use strict";
    function MotionValue(init) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4QweW._)(this, MotionValue);
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = function(v) {
            var currentTime = (0, $i1wr7.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (_this.updatedAt !== currentTime) _this.setPrevFrameValue();
            _this.prev = _this.current;
            _this.setCurrent(v);
            // Update update subscribers
            if (_this.current !== _this.prev) {
                var _this_events_change;
                (_this_events_change = _this.events.change) === null || _this_events_change === void 0 ? void 0 : _this_events_change.notify(_this.current);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (_this.dependents) try {
                    for(var _iterator = _this.dependents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dependent = _step.value;
                        dependent.dirty();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    (0, $6hK4i._)(MotionValue, [
        {
            key: "setCurrent",
            value: function setCurrent(current) {
                this.current = current;
                this.updatedAt = (0, $i1wr7.time).now();
                if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $343c15b8f0f45b2b$var$isFloat(this.current);
            }
        },
        {
            key: "setPrevFrameValue",
            value: function setPrevFrameValue() {
                var prevFrameValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.current;
                this.prevFrameValue = prevFrameValue;
                this.prevUpdatedAt = this.updatedAt;
            }
        },
        {
            /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ key: "onChange",
            value: function onChange(subscription) {
                return this.on("change", subscription);
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                var _this = this;
                if (!this.events[eventName]) this.events[eventName] = new (0, $32hw3.SubscriptionManager)();
                var unsubscribe = this.events[eventName].add(callback);
                if (eventName === "change") return function() {
                    unsubscribe();
                    /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $dbdHF.frame).read(function() {
                        if (!_this.events.change.getSize()) _this.stop();
                    });
                };
                return unsubscribe;
            }
        },
        {
            key: "clearListeners",
            value: function clearListeners() {
                for(var eventManagers in this.events)this.events[eventManagers].clear();
            }
        },
        {
            /**
     * Attaches a passive effect to the `MotionValue`.
     */ key: "attach",
            value: function attach(passiveEffect, stopPassiveEffect) {
                this.passiveEffect = passiveEffect;
                this.stopPassiveEffect = stopPassiveEffect;
            }
        },
        {
            /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ key: "set",
            value: function set(v) {
                if (!this.passiveEffect) this.updateAndNotify(v);
                else this.passiveEffect(v, this.updateAndNotify);
            }
        },
        {
            key: "setWithVelocity",
            value: function setWithVelocity(prev, current, delta) {
                this.set(current);
                this.prev = undefined;
                this.prevFrameValue = prev;
                this.prevUpdatedAt = this.updatedAt - delta;
            }
        },
        {
            /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ key: "jump",
            value: function jump(v) {
                var endAnimation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                this.updateAndNotify(v);
                this.prev = v;
                this.prevUpdatedAt = this.prevFrameValue = undefined;
                endAnimation && this.stop();
                if (this.stopPassiveEffect) this.stopPassiveEffect();
            }
        },
        {
            key: "dirty",
            value: function dirty() {
                var _this_events_change;
                (_this_events_change = this.events.change) === null || _this_events_change === void 0 ? void 0 : _this_events_change.notify(this.current);
            }
        },
        {
            key: "addDependent",
            value: function addDependent(dependent) {
                if (!this.dependents) this.dependents = new Set();
                this.dependents.add(dependent);
            }
        },
        {
            key: "removeDependent",
            value: function removeDependent(dependent) {
                if (this.dependents) this.dependents.delete(dependent);
            }
        },
        {
            /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ key: "get",
            value: function get() {
                if ($343c15b8f0f45b2b$export$67fcd818a264039d.current) $343c15b8f0f45b2b$export$67fcd818a264039d.current.push(this);
                return this.current;
            }
        },
        {
            /**
     * @public
     */ key: "getPrevious",
            value: function getPrevious() {
                return this.prev;
            }
        },
        {
            /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ key: "getVelocity",
            value: function getVelocity() {
                var currentTime = (0, $i1wr7.time).now();
                if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $343c15b8f0f45b2b$var$MAX_VELOCITY_DELTA) return 0;
                var delta = Math.min(this.updatedAt - this.prevUpdatedAt, $343c15b8f0f45b2b$var$MAX_VELOCITY_DELTA);
                // Casts because of parseFloat's poor typing
                return (0, $dVjOS.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
            }
        },
        {
            /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ key: "start",
            value: function start(startAnimation) {
                var _this = this;
                this.stop();
                return new Promise(function(resolve) {
                    _this.hasAnimated = true;
                    _this.animation = startAnimation(resolve);
                    if (_this.events.animationStart) _this.events.animationStart.notify();
                }).then(function() {
                    if (_this.events.animationComplete) _this.events.animationComplete.notify();
                    _this.clearAnimation();
                });
            }
        },
        {
            /**
     * Stop the currently active animation.
     *
     * @public
     */ key: "stop",
            value: function stop() {
                if (this.animation) {
                    this.animation.stop();
                    if (this.events.animationCancel) this.events.animationCancel.notify();
                }
                this.clearAnimation();
            }
        },
        {
            /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ key: "isAnimating",
            value: function isAnimating() {
                return !!this.animation;
            }
        },
        {
            key: "clearAnimation",
            value: function clearAnimation() {
                delete this.animation;
            }
        },
        {
            /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ key: "destroy",
            value: function destroy() {
                var _this_dependents, _this_events_destroy;
                (_this_dependents = this.dependents) === null || _this_dependents === void 0 ? void 0 : _this_dependents.clear();
                (_this_events_destroy = this.events.destroy) === null || _this_events_destroy === void 0 ? void 0 : _this_events_destroy.notify();
                this.clearListeners();
                this.stop();
                if (this.stopPassiveEffect) this.stopPassiveEffect();
            }
        }
    ]);
    return MotionValue;
}();
function $343c15b8f0f45b2b$export$ce8bdc721e76545f(init, options) {
    return new $343c15b8f0f45b2b$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("dVjOS", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $efab2df06fa7ccff$export$eab0632f7ad4f9d7; });
/*
  Convert velocity into velocity per second
*/ /*#__NO_SIDE_EFFECTS__*/ var $efab2df06fa7ccff$export$eab0632f7ad4f9d7 = function(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
};

});


parcelRegister("8tRqX", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $e7bc780caa8542f3$export$950e7e59ea1ffed7; });

var $jlUaU = parcelRequire("jlUaU");

var $h5K91 = parcelRequire("h5K91");

var $eyJsx = parcelRequire("eyJsx");

var $fFwSr = parcelRequire("fFwSr");

var $cy0Dn = parcelRequire("cy0Dn");
/**
 * A list of all ValueTypes
 */ var $e7bc780caa8542f3$var$valueTypes = (0, $jlUaU._)((0, $fFwSr.dimensionValueTypes)).concat([
    (0, $h5K91.color),
    (0, $eyJsx.complex)
]);
/**
 * Tests a value against the list of ValueTypes
 */ var $e7bc780caa8542f3$export$950e7e59ea1ffed7 = function(v) {
    return $e7bc780caa8542f3$var$valueTypes.find((0, $cy0Dn.testValueType)(v));
};

});

parcelRegister("4di6S", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", function () { return $9694ee7b383329cd$export$bc2a978a17abfdde; });
var $9694ee7b383329cd$export$bc2a978a17abfdde = new WeakMap();

});

parcelRegister("g2y4Z", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", function () { return $90682bd79b43b1b4$export$4b3c3bd8d910d78d; });
$parcel$export(module.exports, "isVariantNode", function () { return $90682bd79b43b1b4$export$ce46fa4165cdec40; });

var $fZjU9 = parcelRequire("fZjU9");

var $e5exQ = parcelRequire("e5exQ");

var $51Z5p = parcelRequire("51Z5p");
function $90682bd79b43b1b4$export$4b3c3bd8d910d78d(props) {
    return (0, $fZjU9.isAnimationControls)(props.animate) || (0, $51Z5p.variantProps).some(function(name) {
        return (0, $e5exQ.isVariantLabel)(props[name]);
    });
}
function $90682bd79b43b1b4$export$ce46fa4165cdec40(props) {
    return Boolean($90682bd79b43b1b4$export$4b3c3bd8d910d78d(props) || props.variants);
}

});
parcelRegister("fZjU9", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $a7894a2b55c6d2ef$export$aa71198ceeaf53ce; });

var $5djcY = parcelRequire("5djcY");
function $a7894a2b55c6d2ef$export$aa71198ceeaf53ce(v) {
    return v !== null && (typeof v === "undefined" ? "undefined" : (0, $5djcY._)(v)) === "object" && typeof v.start === "function";
}

});

parcelRegister("e5exQ", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", function () { return $f85e32aab0913974$export$720b90e312cea233; });
/**
 * Decides if the supplied variable is variant label
 */ function $f85e32aab0913974$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("51Z5p", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", function () { return $7418fe25a3549963$export$16e45afcc206d3a8; });
$parcel$export(module.exports, "variantProps", function () { return $7418fe25a3549963$export$1405a65085f40b9; });

var $jlUaU = parcelRequire("jlUaU");
var $7418fe25a3549963$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
var $7418fe25a3549963$export$1405a65085f40b9 = [
    "initial"
].concat((0, $jlUaU._)($7418fe25a3549963$export$16e45afcc206d3a8));

});


parcelRegister("2u3Qo", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $c43c080e5cb8ad81$export$9a552858d5197f6e; });

var $c1b8l = parcelRequire("c1b8l");

var $kbjZS = parcelRequire("kbjZS");
/**
 * Updates motion values from props changes.
 * Uses `any` type for element to avoid circular dependencies with VisualElement.
 */ function $c43c080e5cb8ad81$export$9a552858d5197f6e(element, next, prev) {
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, $kbjZS.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $kbjZS.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $c1b8l.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                var latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $c1b8l.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(var key1 in prev)if (next[key1] === undefined) element.removeValue(key1);
    return next;
}

});

parcelRegister("9WvS8", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", function () { return $846d518930b09d0e$export$ca9f41fb23dded3d; });

var $9bAyI = parcelRequire("9bAyI");
var $846d518930b09d0e$var$isBrowser = typeof window !== "undefined";
function $846d518930b09d0e$export$ca9f41fb23dded3d() {
    (0, $9bAyI.hasReducedMotionListener).current = true;
    if (!$846d518930b09d0e$var$isBrowser) return;
    if (window.matchMedia) {
        var motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        var setReducedMotionPreferences = function() {
            return (0, $9bAyI.prefersReducedMotion).current = motionMediaQuery.matches;
        };
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $9bAyI.prefersReducedMotion).current = false;
}

});
parcelRegister("9bAyI", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", function () { return $d9d272b7d04ff5f1$export$ff7706047246b98b; });
$parcel$export(module.exports, "hasReducedMotionListener", function () { return $d9d272b7d04ff5f1$export$6476d16e2fd2d0db; });
// Does this device prefer reduced motion? Returns `null` server-side.
var $d9d272b7d04ff5f1$export$ff7706047246b98b = {
    current: null
};
var $d9d272b7d04ff5f1$export$6476d16e2fd2d0db = {
    current: false
};

});


parcelRegister("lHseB", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", function () { return $f09fd35f01281cb8$export$d68f140c4d9b48bc; });

var $6ZpBv = parcelRequire("6ZpBv");
function $f09fd35f01281cb8$var$getValueState(visualElement) {
    var state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 ? void 0 : visualElement.values.forEach(function(value, key) {
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $f09fd35f01281cb8$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        var _getValueState = (0, $6ZpBv._)($f09fd35f01281cb8$var$getValueState(visualElement), 2), current = _getValueState[0], velocity = _getValueState[1];
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        var _getValueState1 = (0, $6ZpBv._)($f09fd35f01281cb8$var$getValueState(visualElement), 2), current1 = _getValueState1[0], velocity1 = _getValueState1[1];
        definition = definition(custom !== undefined ? custom : props.custom, current1, velocity1);
    }
    return definition;
}

});



parcelRegister("7SGHq", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $3c441ba7edc1910f$export$bb517f8b40f8e99d; });

var $cH85j = parcelRequire("cH85j");

var $gbCHm = parcelRequire("gbCHm");

var $d4bUS = parcelRequire("d4bUS");

var $1575y = parcelRequire("1575y");

var $ehD8A = parcelRequire("ehD8A");
function $3c441ba7edc1910f$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    var style = state.style, vars = state.vars, transformOrigin = state.transformOrigin;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        if ((0, $d4bUS.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $1575y.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            var valueAsType = (0, $cH85j.getValueAsType)(value, (0, $gbCHm.numberValueTypes)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $ehD8A.buildTransform)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        var _transformOrigin_originX = transformOrigin.originX, originX = _transformOrigin_originX === void 0 ? "50%" : _transformOrigin_originX, _transformOrigin_originY = transformOrigin.originY, originY = _transformOrigin_originY === void 0 ? "50%" : _transformOrigin_originY, _transformOrigin_originZ = transformOrigin.originZ, originZ = _transformOrigin_originZ === void 0 ? 0 : _transformOrigin_originZ;
        style.transformOrigin = "".concat(originX, " ").concat(originY, " ").concat(originZ);
    }
}

});
parcelRegister("cH85j", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $c3172e817a958153$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var $c3172e817a958153$export$453ef540a9a1bd6b = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("ehD8A", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $de170d1f18d51e57$export$bdc96e0d5c8f914; });

var $cH85j = parcelRequire("cH85j");

var $gbCHm = parcelRequire("gbCHm");

var $d4bUS = parcelRequire("d4bUS");
var $de170d1f18d51e57$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
var $de170d1f18d51e57$var$numTransforms = (0, $d4bUS.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $de170d1f18d51e57$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    var transformString = "";
    var transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(var i = 0; i < $de170d1f18d51e57$var$numTransforms; i++){
        var key = (0, $d4bUS.transformPropOrder)[i];
        var value = latestValues[key];
        if (value === undefined) continue;
        var valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else {
            var parsed = parseFloat(value);
            valueIsDefault = key.startsWith("scale") ? parsed === 1 : parsed === 0;
        }
        if (!valueIsDefault || transformTemplate) {
            var valueAsType = (0, $cH85j.getValueAsType)(value, (0, $gbCHm.numberValueTypes)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                var transformName = $de170d1f18d51e57$var$translateAlias[key] || key;
                transformString += "".concat(transformName, "(").concat(valueAsType, ") ");
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    // `pathRotation` composes onto `rotate` as a separate additive term so
    // the user's `rotate` is never clobbered. Deliberately not a slot in
    // `transformPropOrder`.
    var pathRotation = latestValues.pathRotation;
    if (pathRotation) {
        transformIsDefault = false;
        transformString += "rotate(".concat((0, $cH85j.getValueAsType)(pathRotation, (0, $gbCHm.numberValueTypes).pathRotation), ") ");
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

});


parcelRegister("asY06", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $981d9a111237b495$export$1a32bf6229c258c0; });
function $981d9a111237b495$export$1a32bf6229c258c0(element, param, styleProp, projection) {
    var style = param.style, vars = param.vars;
    var elementStyle = element.style;
    var key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection === null || projection === void 0 ? void 0 : projection.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}

});

parcelRegister("cVifk", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $cf817307e333b947$export$16da615486abaa45; });

var $kbjZS = parcelRequire("kbjZS");

var $eWai9 = parcelRequire("eWai9");
function $cf817307e333b947$export$16da615486abaa45(props, prevProps, visualElement) {
    var _visualElement_getValue;
    var style = props.style;
    var prevStyle = prevProps === null || prevProps === void 0 ? void 0 : prevProps.style;
    var newValues = {};
    if (!style) return newValues;
    for(var key in style)if ((0, $kbjZS.isMotionValue)(style[key]) || prevStyle && (0, $kbjZS.isMotionValue)(prevStyle[key]) || (0, $eWai9.isForcedMotionValue)(key, props) || (visualElement === null || visualElement === void 0 ? void 0 : (_visualElement_getValue = visualElement.getValue(key)) === null || _visualElement_getValue === void 0 ? void 0 : _visualElement_getValue.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}

});
parcelRegister("eWai9", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $fc2776a93148de8b$export$6d27ce8e3de1c3cf; });

var $d4bUS = parcelRequire("d4bUS");

var $dlAPu = parcelRequire("dlAPu");
function $fc2776a93148de8b$export$6d27ce8e3de1c3cf(key, param) {
    var layout = param.layout, layoutId = param.layoutId;
    return (0, $d4bUS.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $dlAPu.scaleCorrectors)[key] || key === "opacity");
}

});
parcelRegister("dlAPu", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", function () { return $137fdec17fec3ccb$export$91ddd985b97788d1; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $jlUaU = parcelRequire("jlUaU");

var $1575y = parcelRequire("1575y");

var $9dNjD = parcelRequire("9dNjD");

var $7a2gX = parcelRequire("7a2gX");

var $jPpNQ = parcelRequire("jPpNQ");
var $137fdec17fec3ccb$export$91ddd985b97788d1 = {
    borderRadius: (0, $hApvp._)((0, $kWfK0._)({}, (0, $7a2gX.correctBorderRadius)), {
        applyTo: (0, $jlUaU._)((0, $9dNjD.cornerRadiusProps))
    }),
    borderTopLeftRadius: (0, $7a2gX.correctBorderRadius),
    borderTopRightRadius: (0, $7a2gX.correctBorderRadius),
    borderBottomLeftRadius: (0, $7a2gX.correctBorderRadius),
    borderBottomRightRadius: (0, $7a2gX.correctBorderRadius),
    boxShadow: (0, $jPpNQ.correctBoxShadow)
};
function $137fdec17fec3ccb$export$de9e7791c71225fd(correctors) {
    for(var key in correctors){
        $137fdec17fec3ccb$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $1575y.isCSSVariableName)(key)) $137fdec17fec3ccb$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}

});
parcelRegister("9dNjD", function(module, exports) {

$parcel$export(module.exports, "cornerRadiusProps", function () { return $abf499c89e0f813f$export$41ef21965ed84e7a; });
/**
 * The four corner-radius longhands. Shared so the projection mixer, scale
 * corrector, WAAPI px-value set and view-transition crop pass don't each carry
 * their own copy. Order is irrelevant - every consumer mixes/corrects/animates
 * each corner independently.
 */ var $abf499c89e0f813f$export$41ef21965ed84e7a = [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomRightRadius",
    "borderBottomLeftRadius"
];

});

parcelRegister("7a2gX", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", function () { return $659652e964d58fd9$export$5eafb6257a5844c; });

var $huIQG = parcelRequire("huIQG");
function $659652e964d58fd9$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ var $659652e964d58fd9$export$5eafb6257a5844c = {
    correct: function(latest, node) {
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $huIQG.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ var x = $659652e964d58fd9$export$fafff692be55225d(latest, node.target.x);
        var y = $659652e964d58fd9$export$fafff692be55225d(latest, node.target.y);
        return "".concat(x, "% ").concat(y, "%");
    }
};

});

parcelRegister("jPpNQ", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", function () { return $3851944414e744fc$export$eb0bc629e74dcf8; });

var $eyJsx = parcelRequire("eyJsx");

var $gcS1k = parcelRequire("gcS1k");
var $3851944414e744fc$export$eb0bc629e74dcf8 = {
    correct: function(latest, param) {
        var treeScale = param.treeScale, projectionDelta = param.projectionDelta;
        var original = latest;
        var shadow = (0, $eyJsx.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        var template = (0, $eyJsx.complex).createTransformer(latest);
        var offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        var xScale = projectionDelta.x.scale * treeScale.x;
        var yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ var averageScale = (0, $gcS1k.mixNumber)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

});





parcelRegister("f8rCK", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", function () { return $3dd3b1381f5c40f8$export$86bcdffbaf733d84; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $hC9N3 = parcelRequire("hC9N3");

var $9atk1 = parcelRequire("9atk1");

var $c2MhV = parcelRequire("c2MhV");

var $d4bUS = parcelRequire("d4bUS");

var $k1C7V = parcelRequire("k1C7V");

var $fQu9K = parcelRequire("fQu9K");

var $hg8z5 = parcelRequire("hg8z5");

var $kxr67 = parcelRequire("kxr67");

var $gCTzq = parcelRequire("gCTzq");

var $kveDw = parcelRequire("kveDw");

var $3Puot = parcelRequire("3Puot");

var $kVxN7 = parcelRequire("kVxN7");

var $1MczN = parcelRequire("1MczN");
var $3dd3b1381f5c40f8$export$86bcdffbaf733d84 = /*#__PURE__*/ function(DOMVisualElement) {
    "use strict";
    (0, $c2MhV._)(SVGVisualElement, DOMVisualElement);
    function SVGVisualElement() {
        (0, $4QweW._)(this, SVGVisualElement);
        var _this;
        _this = (0, $ehF45._)(this, SVGVisualElement, arguments);
        _this.type = "svg";
        _this.isSVGTag = false;
        _this.measureInstanceViewportBox = (0, $fQu9K.createBox);
        return _this;
    }
    (0, $6hK4i._)(SVGVisualElement, [
        {
            key: "getBaseTargetFromProps",
            value: function getBaseTargetFromProps(props, key) {
                return props[key];
            }
        },
        {
            key: "readValueFromInstance",
            value: function readValueFromInstance(instance, key) {
                if ((0, $d4bUS.transformProps).has(key)) {
                    var defaultType = (0, $k1C7V.getDefaultValueType)(key);
                    return defaultType ? defaultType.default || 0 : 0;
                }
                key = !(0, $kveDw.camelCaseAttributes).has(key) ? (0, $kxr67.camelToDash)(key) : key;
                return instance.getAttribute(key);
            }
        },
        {
            key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps1(props, prevProps, visualElement) {
                return (0, $1MczN.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
            }
        },
        {
            key: "build",
            value: function build(renderState, latestValues, props) {
                (0, $gCTzq.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
            }
        },
        {
            key: "renderInstance",
            value: function renderInstance(instance, renderState, styleProp, projection) {
                (0, $kVxN7.renderSVG)(instance, renderState, styleProp, projection);
            }
        },
        {
            key: "mount",
            value: function mount(instance) {
                this.isSVGTag = (0, $3Puot.isSVGTag)(instance.tagName);
                (0, $hC9N3._)((0, $9atk1._)(SVGVisualElement.prototype), "mount", this).call(this, instance);
            }
        }
    ]);
    return SVGVisualElement;
}((0, $hg8z5.DOMVisualElement));

});
parcelRegister("kxr67", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $47c663c94707b009$export$9fd24a634729c672; });
function $47c663c94707b009$export$9fd24a634729c672(str) {
    return str.replace(/([A-Z])/g, function(match) {
        return "-".concat(match.toLowerCase());
    });
}

});

parcelRegister("gCTzq", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $7bbac2333e079d62$export$5475d24f125d7053; });

var $1DiK7 = parcelRequire("1DiK7");

var $7SGHq = parcelRequire("7SGHq");

var $bqVdW = parcelRequire("bqVdW");
/**
 * CSS Motion Path properties that should remain as CSS styles on SVG elements.
 */ var $7bbac2333e079d62$var$cssMotionPathProperties = [
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "offsetAnchor"
];
/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $7bbac2333e079d62$export$5475d24f125d7053(state, _param, isSVGTag, transformTemplate, styleProp) {
    var attrX = _param.attrX, attrY = _param.attrY, attrScale = _param.attrScale, pathLength = _param.pathLength, _param_pathSpacing = _param.pathSpacing, pathSpacing = _param_pathSpacing === void 0 ? 1 : _param_pathSpacing, _param_pathOffset = _param.pathOffset, pathOffset = _param_pathOffset === void 0 ? 0 : _param_pathOffset, latest = (0, $1DiK7._)(_param, [
        "attrX",
        "attrY",
        "attrScale",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $7SGHq.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        var _attrs_transformOrigin;
        style.transformOrigin = (_attrs_transformOrigin = attrs.transformOrigin) !== null && _attrs_transformOrigin !== void 0 ? _attrs_transformOrigin : "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        var _styleProp_transformBox;
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = (_styleProp_transformBox = styleProp === null || styleProp === void 0 ? void 0 : styleProp.transformBox) !== null && _styleProp_transformBox !== void 0 ? _styleProp_transformBox : "fill-box";
        delete attrs.transformBox;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $7bbac2333e079d62$var$cssMotionPathProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (attrs[key] !== undefined) {
                style[key] = attrs[key];
                delete attrs[key];
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $bqVdW.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("bqVdW", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $8eb700a475075c0f$export$311b43f666da1d82; });
var $8eb700a475075c0f$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var $8eb700a475075c0f$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 *
 * Note: We use unitless values for stroke-dasharray and stroke-dashoffset
 * because Safari incorrectly scales px values when the page is zoomed.
 */ function $8eb700a475075c0f$export$311b43f666da1d82(attrs, length) {
    var spacing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, offset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, useDashCase = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? $8eb700a475075c0f$var$dashKeys : $8eb700a475075c0f$var$camelKeys;
    // Build the dash offset (unitless to avoid Safari zoom bug)
    attrs[keys.offset] = "".concat(-offset);
    // Build the dash array (unitless to avoid Safari zoom bug)
    attrs[keys.array] = "".concat(length, " ").concat(spacing);
}

});


parcelRegister("kveDw", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $9be1e67793c3d06b$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ var $9be1e67793c3d06b$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});

parcelRegister("3Puot", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", function () { return $0c6fe412dfb6347f$export$6328ce7565ea1049; });
var $0c6fe412dfb6347f$export$6328ce7565ea1049 = function(tag) {
    return typeof tag === "string" && tag.toLowerCase() === "svg";
};

});

parcelRegister("kVxN7", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $902965b335e3e54b$export$c5f8399d19a7394b; });

var $kxr67 = parcelRequire("kxr67");

var $asY06 = parcelRequire("asY06");

var $kveDw = parcelRequire("kveDw");
function $902965b335e3e54b$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $asY06.renderHTML)(element, renderState, undefined, projection);
    for(var key in renderState.attrs)element.setAttribute(!(0, $kveDw.camelCaseAttributes).has(key) ? (0, $kxr67.camelToDash)(key) : key, renderState.attrs[key]);
}

});

parcelRegister("1MczN", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $1828d44683ac0529$export$16da615486abaa45; });

var $kbjZS = parcelRequire("kbjZS");

var $d4bUS = parcelRequire("d4bUS");

var $cVifk = parcelRequire("cVifk");
function $1828d44683ac0529$export$16da615486abaa45(props, prevProps, visualElement) {
    var newValues = (0, $cVifk.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(var key in props)if ((0, $kbjZS.isMotionValue)(props[key]) || (0, $kbjZS.isMotionValue)(prevProps[key])) {
        var targetKey = (0, $d4bUS.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});


parcelRegister("vRFnt", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", function () { return $4a8e30bc1559f759$export$88f3fc2fd3766989; });

var $cMSlZ = parcelRequire("cMSlZ");
function $4a8e30bc1559f759$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $cMSlZ.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ RegExp("[A-Z]", "u").test(Component)) return true;
    return false;
}

});
parcelRegister("cMSlZ", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", function () { return $b4df28e776fc7c70$export$40209c4c512158e6; });
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var $b4df28e776fc7c70$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

});



parcelRegister("7xsoA", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", function () { return $4a01744c772845fe$export$a28d6df673050e18; });


var $iWx36 = parcelRequire("iWx36");
function $4a01744c772845fe$export$a28d6df673050e18(preloadedFeatures, createVisualElement) {
    if (typeof Proxy === "undefined") return 0, $iWx36.createMotionComponent;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    var factory = function(Component, options) {
        return (0, $iWx36.createMotionComponent)(Component, options, preloadedFeatures, createVisualElement);
    };
    /**
     * Support for deprecated`motion(Component)` pattern
     */ var deprecatedFactoryFunction = function(Component, options) {
        return factory(Component, options);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            if (key === "create") return factory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, (0, $iWx36.createMotionComponent)(key, undefined, preloadedFeatures, createVisualElement));
            return componentCache.get(key);
        }
    });
}

});
parcelRegister("iWx36", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", function () { return $9e23ca6683ba2056$export$46b7e4b9dc6110c3; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $9HB6H = parcelRequire("9HB6H");


var $iD6kw = parcelRequire("iD6kw");

var $8Js66 = parcelRequire("8Js66");

var $fZVkQ = parcelRequire("fZVkQ");

var $iCxNR = parcelRequire("iCxNR");

var $9T8oF = parcelRequire("9T8oF");

var $iRbbr = parcelRequire("iRbbr");

var $jsNIF = parcelRequire("jsNIF");

var $vRFnt = parcelRequire("vRFnt");

var $iiVW1 = parcelRequire("iiVW1");

var $hjpLv = parcelRequire("hjpLv");

var $kwXD1 = parcelRequire("kwXD1");

var $eW5lZ = parcelRequire("eW5lZ");

var $70GCe = parcelRequire("70GCe");

var $fsxP1 = parcelRequire("fsxP1");

var $9VOS0 = parcelRequire("9VOS0");
"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $9e23ca6683ba2056$export$46b7e4b9dc6110c3(Component) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_forwardMotionProps = _ref.forwardMotionProps, forwardMotionProps = _ref_forwardMotionProps === void 0 ? false : _ref_forwardMotionProps, type = _ref.type, preloadedFeatures = arguments.length > 2 ? arguments[2] : void 0, createVisualElement = arguments.length > 3 ? arguments[3] : void 0;
    preloadedFeatures && (0, $eW5lZ.loadFeatures)(preloadedFeatures);
    /**
     * Determine whether to use SVG or HTML rendering based on:
     * 1. Explicit `type` option (highest priority)
     * 2. Auto-detection via `isSVGComponent`
     */ var isSVG = type ? type === "svg" : (0, $vRFnt.isSVGComponent)(Component);
    var useVisualState = isSVG ? (0, $hjpLv.useSVGVisualState) : (0, $iiVW1.useHTMLVisualState);
    function MotionDOMComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ var MeasureLayout;
        var configAndProps = (0, $hApvp._)((0, $kWfK0._)({}, (0, $iD6kw.useContext)((0, $iCxNR.MotionConfigContext)), props), {
            layoutId: $9e23ca6683ba2056$var$useLayoutId(props)
        });
        var isStatic = configAndProps.isStatic;
        var context = (0, $iRbbr.useCreateMotionContext)(props);
        var visualState = useVisualState(props, isStatic);
        if (!isStatic && typeof window !== "undefined") {
            $9e23ca6683ba2056$var$useStrictMode(configAndProps, preloadedFeatures);
            var layoutProjection = $9e23ca6683ba2056$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $9VOS0.useVisualElement)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode, isSVG);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $9HB6H.jsxs)((0, $9T8oF.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $9HB6H.jsx)(MeasureLayout, (0, $kWfK0._)({
                    visualElement: context.visualElement
                }, configAndProps)) : null,
                (0, $jsNIF.useRender)(Component, props, (0, $fsxP1.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, forwardMotionProps, isSVG)
            ]
        });
    }
    var _Component_displayName, _ref1;
    MotionDOMComponent.displayName = "motion.".concat(typeof Component === "string" ? Component : "create(".concat((_ref1 = (_Component_displayName = Component.displayName) !== null && _Component_displayName !== void 0 ? _Component_displayName : Component.name) !== null && _ref1 !== void 0 ? _ref1 : "", ")"));
    var ForwardRefMotionComponent = (0, $iD6kw.forwardRef)(MotionDOMComponent);
    ForwardRefMotionComponent[0, $70GCe.motionComponentSymbol] = Component;
    return ForwardRefMotionComponent;
}
function $9e23ca6683ba2056$var$useLayoutId(param) {
    var layoutId = param.layoutId;
    var layoutGroupId = (0, $iD6kw.useContext)((0, $8Js66.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $9e23ca6683ba2056$var$useStrictMode(configAndProps, preloadedFeatures) {
    var isStrict = (0, $iD6kw.useContext)((0, $fZVkQ.LazyContext)).strict;
}
function $9e23ca6683ba2056$var$getProjectionFunctionality(props) {
    var featureDefinitions = (0, $kwXD1.getInitializedFeatureDefinitions)();
    var drag = featureDefinitions.drag, layout = featureDefinitions.layout;
    if (!drag && !layout) return {};
    var combined = (0, $kWfK0._)({}, drag, layout);
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}

});
parcelRegister("fZVkQ", function(module, exports) {

$parcel$export(module.exports, "LazyContext", function () { return $b6af598940919d9a$export$40f10139ecf1f171; });

var $iD6kw = parcelRequire("iD6kw");
"use client";
var $b6af598940919d9a$export$40f10139ecf1f171 = (0, $iD6kw.createContext)({
    strict: false
});

});

parcelRegister("9T8oF", function(module, exports) {

$parcel$export(module.exports, "MotionContext", function () { return $4e9ff7314f777bb1$export$2285bbca2c666415; });

var $iD6kw = parcelRequire("iD6kw");
"use client";
var $4e9ff7314f777bb1$export$2285bbca2c666415 = /* @__PURE__ */ (0, $iD6kw.createContext)({});

});

parcelRegister("iRbbr", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", function () { return $72b6c26ac9b6bbf7$export$c5638d843b37a176; });

var $iD6kw = parcelRequire("iD6kw");

var $9T8oF = parcelRequire("9T8oF");

var $lkWh7 = parcelRequire("lkWh7");
"use client";
function $72b6c26ac9b6bbf7$export$c5638d843b37a176(props) {
    var _getCurrentTreeVariants = (0, $lkWh7.getCurrentTreeVariants)(props, (0, $iD6kw.useContext)((0, $9T8oF.MotionContext))), initial = _getCurrentTreeVariants.initial, animate = _getCurrentTreeVariants.animate;
    return (0, $iD6kw.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, [
        $72b6c26ac9b6bbf7$var$variantLabelsAsDependency(initial),
        $72b6c26ac9b6bbf7$var$variantLabelsAsDependency(animate)
    ]);
}
function $72b6c26ac9b6bbf7$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("lkWh7", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", function () { return $a905f977988626a8$export$12fc32fc096a04a3; });

var $g2y4Z = parcelRequire("g2y4Z");
var $e5exQ = parcelRequire("e5exQ");
function $a905f977988626a8$export$12fc32fc096a04a3(props, context) {
    if ((0, $g2y4Z.isControllingVariants)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0, $e5exQ.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $e5exQ.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});


parcelRegister("jsNIF", function(module, exports) {

$parcel$export(module.exports, "useRender", function () { return $6198d13e29d13c12$export$e25bb1e5b53cbdff; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $kbjZS = parcelRequire("kbjZS");

var $iD6kw = parcelRequire("iD6kw");

var $iFt4v = parcelRequire("iFt4v");

var $2Oj7R = parcelRequire("2Oj7R");

var $Dyjte = parcelRequire("Dyjte");

var $vRFnt = parcelRequire("vRFnt");
"use client";
function $6198d13e29d13c12$export$e25bb1e5b53cbdff(Component, props, ref, param, isStatic) {
    var latestValues = param.latestValues, forwardMotionProps = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, isSVG = arguments.length > 6 ? arguments[6] : void 0;
    var useVisualProps = (isSVG !== null && isSVG !== void 0 ? isSVG : (0, $vRFnt.isSVGComponent)(Component)) ? (0, $2Oj7R.useSVGProps) : (0, $iFt4v.useHTMLProps);
    var visualProps = useVisualProps(props, latestValues, isStatic, Component);
    var filteredProps = (0, $Dyjte.filterProps)(props, typeof Component === "string", forwardMotionProps);
    var elementProps = Component !== (0, $iD6kw.Fragment) ? (0, $hApvp._)((0, $kWfK0._)({}, filteredProps, visualProps), {
        ref: ref
    }) : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */ var children = props.children;
    var renderedChildren = (0, $iD6kw.useMemo)(function() {
        return (0, $kbjZS.isMotionValue)(children) ? children.get() : children;
    }, [
        children
    ]);
    return (0, $iD6kw.createElement)(Component, (0, $hApvp._)((0, $kWfK0._)({}, elementProps), {
        children: renderedChildren
    }));
}

});
parcelRegister("iFt4v", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", function () { return $fcaf671c749229c6$export$40dafdb8630c956b; });
$parcel$export(module.exports, "useHTMLProps", function () { return $fcaf671c749229c6$export$57be0a314572d87d; });

var $7SGHq = parcelRequire("7SGHq");
var $eWai9 = parcelRequire("eWai9");
var $kbjZS = parcelRequire("kbjZS");

var $iD6kw = parcelRequire("iD6kw");

var $kxeUH = parcelRequire("kxeUH");
"use client";
function $fcaf671c749229c6$export$40dafdb8630c956b(target, source, props) {
    for(var key in source)if (!(0, $kbjZS.isMotionValue)(source[key]) && !(0, $eWai9.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $fcaf671c749229c6$var$useInitialMotionValues(param, visualState) {
    var transformTemplate = param.transformTemplate;
    return (0, $iD6kw.useMemo)(function() {
        var state = (0, $kxeUH.createHtmlRenderState)();
        (0, $7SGHq.buildHTMLStyles)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $fcaf671c749229c6$var$useStyle(props, visualState) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $fcaf671c749229c6$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $fcaf671c749229c6$var$useInitialMotionValues(props, visualState));
    return style;
}
function $fcaf671c749229c6$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = $fcaf671c749229c6$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-".concat(props.drag === "x" ? "y" : "x");
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("kxeUH", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", function () { return $b48679eea7832c18$export$8940b483cf52eeda; });
var $b48679eea7832c18$export$8940b483cf52eeda = function() {
    return {
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    };
};

});


parcelRegister("2Oj7R", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", function () { return $d12db5b523f45882$export$84309c4f53cb1bd5; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $gCTzq = parcelRequire("gCTzq");
var $3Puot = parcelRequire("3Puot");

var $iD6kw = parcelRequire("iD6kw");

var $iFt4v = parcelRequire("iFt4v");

var $agNrS = parcelRequire("agNrS");
"use client";
function $d12db5b523f45882$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    var visualProps = (0, $iD6kw.useMemo)(function() {
        var state = (0, $agNrS.createSvgRenderState)();
        (0, $gCTzq.buildSVGAttrs)(state, visualState, (0, $3Puot.isSVGTag)(Component), props.transformTemplate, props.style);
        return (0, $hApvp._)((0, $kWfK0._)({}, state.attrs), {
            style: (0, $kWfK0._)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        (0, $iFt4v.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = (0, $kWfK0._)({}, rawStyles, visualProps.style);
    }
    return visualProps;
}

});
parcelRegister("agNrS", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", function () { return $829e4c4a961cd2b2$export$41be8b43e1c4d4f9; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $kxeUH = parcelRequire("kxeUH");
var $829e4c4a961cd2b2$export$41be8b43e1c4d4f9 = function() {
    return (0, $hApvp._)((0, $kWfK0._)({}, (0, $kxeUH.createHtmlRenderState)()), {
        attrs: {}
    });
};

});


parcelRegister("Dyjte", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $6573709ec813d148$export$d697c39a2985a4c; });

var $5djcY = parcelRequire("5djcY");

var $kbjZS = parcelRequire("kbjZS");

var $6nm2s = parcelRequire("6nm2s");
var $6573709ec813d148$var$shouldForward = function(key) {
    return !(0, $6nm2s.isValidMotionProp)(key);
};
function $6573709ec813d148$export$59d6962c470509a5(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    $6573709ec813d148$var$shouldForward = function(key) {
        return key.startsWith("on") ? !(0, $6nm2s.isValidMotionProp)(key) : isValidProp(key);
    };
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     *
     * String concatenation prevents bundlers like webpack (e.g. Storybook)
     * from statically resolving this optional dependency at build time.
     */ var $6573709ec813d148$var$emotionPkg = "@emotion/is-prop-valid";
    $6573709ec813d148$export$59d6962c470509a5(require($6573709ec813d148$var$emotionPkg).default);
} catch (e) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $6573709ec813d148$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && (0, $5djcY._)(props.values) === "object") continue;
        if ((0, $kbjZS.isMotionValue)(props[key])) continue;
        if ($6573709ec813d148$var$shouldForward(key) || forwardMotionProps === true && (0, $6nm2s.isValidMotionProp)(key) || !isDom && !(0, $6nm2s.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

});
parcelRegister("6nm2s", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", function () { return $f310ad276d60eed9$export$2f9c46555243bf04; });
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var $f310ad276d60eed9$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "propagate",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $f310ad276d60eed9$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $f310ad276d60eed9$var$validMotionProps.has(key);
}

});



parcelRegister("iiVW1", function(module, exports) {

$parcel$export(module.exports, "useHTMLVisualState", function () { return $52fa5b42ead16def$export$851cf1f78cb3feac; });

var $cVifk = parcelRequire("cVifk");

var $hHlOe = parcelRequire("hHlOe");

var $kxeUH = parcelRequire("kxeUH");
"use client";
var $52fa5b42ead16def$export$851cf1f78cb3feac = /*@__PURE__*/ (0, $hHlOe.makeUseVisualState)({
    scrapeMotionValuesFromProps: (0, $cVifk.scrapeMotionValuesFromProps),
    createRenderState: (0, $kxeUH.createHtmlRenderState)
});

});
parcelRegister("hHlOe", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", function () { return $aeb907352cdd0d68$export$e91e107bc6d03a8e; });

var $1DiK7 = parcelRequire("1DiK7");

var $fZjU9 = parcelRequire("fZjU9");
var $g2y4Z = parcelRequire("g2y4Z");
var $hQ81U = parcelRequire("hQ81U");
var $lHseB = parcelRequire("lHseB");

var $iD6kw = parcelRequire("iD6kw");

var $9T8oF = parcelRequire("9T8oF");

var $hH50e = parcelRequire("hH50e");

var $57sx1 = parcelRequire("57sx1");
"use client";
function $aeb907352cdd0d68$var$makeState(param, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = param.scrapeMotionValuesFromProps, createRenderState = param.createRenderState;
    var state = {
        latestValues: $aeb907352cdd0d68$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
function $aeb907352cdd0d68$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var motionValues = scrapeMotionValues(props, {});
    for(var key in motionValues)values[key] = (0, $hQ81U.resolveMotionValue)(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants$1 = (0, $g2y4Z.isControllingVariants)(props);
    var isVariantNode$1 = (0, $g2y4Z.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    var isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    var variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $fZjU9.isAnimationControls)(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(var i = 0; i < list.length; i++){
            var resolved = (0, $lHseB.resolveVariantFromProps)(props, list[i]);
            if (resolved) {
                var transitionEnd = resolved.transitionEnd, transition = resolved.transition, target = (0, $1DiK7._)(resolved, [
                    "transitionEnd",
                    "transition"
                ]);
                for(var key1 in target){
                    var valueTarget = target[key1];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ var index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key1] = valueTarget;
                }
                for(var key2 in transitionEnd)values[key2] = transitionEnd[key2];
            }
        }
    }
    return values;
}
var $aeb907352cdd0d68$export$e91e107bc6d03a8e = function(config) {
    return function(props, isStatic) {
        var context = (0, $iD6kw.useContext)((0, $9T8oF.MotionContext));
        var presenceContext = (0, $iD6kw.useContext)((0, $hH50e.PresenceContext));
        var make = function() {
            return $aeb907352cdd0d68$var$makeState(config, props, context, presenceContext);
        };
        return isStatic ? make() : (0, $57sx1.useConstant)(make);
    };
};

});
parcelRegister("hQ81U", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", function () { return $14ba04f94d2d4652$export$fcc2206ecb6d74b; });

var $kbjZS = parcelRequire("kbjZS");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 */ function $14ba04f94d2d4652$export$fcc2206ecb6d74b(value) {
    return (0, $kbjZS.isMotionValue)(value) ? value.get() : value;
}

});



parcelRegister("hjpLv", function(module, exports) {

$parcel$export(module.exports, "useSVGVisualState", function () { return $d7ab2d6a953cfb34$export$9922240e40b88c48; });

var $1MczN = parcelRequire("1MczN");

var $hHlOe = parcelRequire("hHlOe");

var $agNrS = parcelRequire("agNrS");
"use client";
var $d7ab2d6a953cfb34$export$9922240e40b88c48 = /*@__PURE__*/ (0, $hHlOe.makeUseVisualState)({
    scrapeMotionValuesFromProps: (0, $1MczN.scrapeMotionValuesFromProps),
    createRenderState: (0, $agNrS.createSvgRenderState)
});

});

parcelRegister("kwXD1", function(module, exports) {

$parcel$export(module.exports, "getInitializedFeatureDefinitions", function () { return $fc7bf744e52310e7$export$350148171c356c79; });

var $5NNrB = parcelRequire("5NNrB");
var $fc7bf744e52310e7$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
var $fc7bf744e52310e7$var$isInitialized = false;
/**
 * Initialize feature definitions with isEnabled checks.
 * This must be called before any motion components are rendered.
 */ function $fc7bf744e52310e7$export$e7d3655c4e2f701f() {
    var _loop = function(key) {
        initialFeatureDefinitions[key] = {
            isEnabled: function(props) {
                return $fc7bf744e52310e7$var$featureProps[key].some(function(name) {
                    return !!props[name];
                });
            }
        };
    };
    if ($fc7bf744e52310e7$var$isInitialized) return;
    var initialFeatureDefinitions = {};
    for(var key in $fc7bf744e52310e7$var$featureProps)_loop(key);
    (0, $5NNrB.setFeatureDefinitions)(initialFeatureDefinitions);
    $fc7bf744e52310e7$var$isInitialized = true;
}
/**
 * Get the current feature definitions, initializing if needed.
 */ function $fc7bf744e52310e7$export$350148171c356c79() {
    $fc7bf744e52310e7$export$e7d3655c4e2f701f();
    return (0, $5NNrB.getFeatureDefinitions)();
}

});

parcelRegister("eW5lZ", function(module, exports) {

$parcel$export(module.exports, "loadFeatures", function () { return $61318a55c9856b6e$export$449561ec5703cdc8; });

var $kWfK0 = parcelRequire("kWfK0");

var $5NNrB = parcelRequire("5NNrB");

var $kwXD1 = parcelRequire("kwXD1");
function $61318a55c9856b6e$export$449561ec5703cdc8(features) {
    var featureDefinitions = (0, $kwXD1.getInitializedFeatureDefinitions)();
    for(var key in features)featureDefinitions[key] = (0, $kWfK0._)({}, featureDefinitions[key], features[key]);
    (0, $5NNrB.setFeatureDefinitions)(featureDefinitions);
}

});

parcelRegister("70GCe", function(module, exports) {

$parcel$export(module.exports, "motionComponentSymbol", function () { return $91ddf4694596f3d0$export$28e2e4cce424ae23; });
var $91ddf4694596f3d0$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");

});

parcelRegister("fsxP1", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", function () { return $73e64ac5b3a1fb5f$export$c684914703d321fd; });

var $iD6kw = parcelRequire("iD6kw");
"use client";
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $73e64ac5b3a1fb5f$export$c684914703d321fd(visualState, visualElement, externalRef) {
    /**
     * Store externalRef in a ref to avoid including it in the useCallback
     * dependency array. Including externalRef in dependencies causes issues
     * with libraries like Radix UI that create new callback refs on each render
     * when using asChild - this would cause the callback to be recreated,
     * triggering element remounts and breaking AnimatePresence exit animations.
     */ var externalRefContainer = (0, $iD6kw.useRef)(externalRef);
    (0, $iD6kw.useInsertionEffect)(function() {
        externalRefContainer.current = externalRef;
    });
    // Store cleanup function returned by callback refs (React 19 feature)
    var refCleanup = (0, $iD6kw.useRef)(null);
    return (0, $iD6kw.useCallback)(function(instance) {
        var _visualState_onMount;
        if (instance) (_visualState_onMount = visualState.onMount) === null || _visualState_onMount === void 0 ? void 0 : _visualState_onMount.call(visualState, instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        var ref = externalRefContainer.current;
        if (typeof ref === "function") {
            if (instance) {
                var cleanup = ref(instance);
                if (typeof cleanup === "function") refCleanup.current = cleanup;
            } else if (refCleanup.current) {
                refCleanup.current();
                refCleanup.current = null;
            } else ref(instance);
        } else if (ref) ref.current = instance;
    }, [
        visualElement
    ]);
}

});

parcelRegister("9VOS0", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", function () { return $e066fa8232bf96e5$export$dc0335d73ab0b115; });

var $keCnA = parcelRequire("keCnA");

var $iD6kw = parcelRequire("iD6kw");

var $fZVkQ = parcelRequire("fZVkQ");

var $iCxNR = parcelRequire("iCxNR");

var $9T8oF = parcelRequire("9T8oF");

var $hH50e = parcelRequire("hH50e");

var $1BC3b = parcelRequire("1BC3b");

var $iXA5j = parcelRequire("iXA5j");

var $24ePD = parcelRequire("24ePD");
"use client";
function $e066fa8232bf96e5$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor, isSVG) {
    var _window_MotionHandoffIsComplete, _window, _window_MotionHasOptimisedAnimation, _window1;
    var _useContext = (0, $iD6kw.useContext)((0, $9T8oF.MotionContext)), parent = _useContext.visualElement;
    var lazyContext = (0, $iD6kw.useContext)((0, $fZVkQ.LazyContext));
    var presenceContext = (0, $iD6kw.useContext)((0, $hH50e.PresenceContext));
    var motionConfig = (0, $iD6kw.useContext)((0, $iCxNR.MotionConfigContext));
    var reducedMotionConfig = motionConfig.reducedMotion;
    var skipAnimations = motionConfig.skipAnimations;
    var visualElementRef = (0, $iD6kw.useRef)(null);
    /**
     * Track whether the component has been through React's commit phase.
     * Used to detect when LazyMotion features load after the component has mounted.
     */ var hasMountedOnce = (0, $iD6kw.useRef)(false);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState: visualState,
            parent: parent,
            props: props,
            presenceContext: presenceContext,
            blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
            reducedMotionConfig: reducedMotionConfig,
            skipAnimations: skipAnimations,
            isSVG: isSVG
        });
        /**
         * If the component has already mounted before features loaded (e.g. via
         * LazyMotion with async feature loading), we need to force the initial
         * animation to run. Otherwise state changes that occurred before features
         * loaded will be lost and the element will snap to its final state.
         */ if (hasMountedOnce.current && visualElementRef.current) visualElementRef.current.manuallyAnimateOnMount = true;
    }
    var visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ var initialLayoutGroupConfig = (0, $iD6kw.useContext)((0, $1BC3b.SwitchLayoutGroupContext));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $e066fa8232bf96e5$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    var isMounted = (0, $iD6kw.useRef)(false);
    (0, $iD6kw.useInsertionEffect)(function() {
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ var optimisedAppearId = props[0, $keCnA.optimizedAppearDataAttribute];
    var wantsHandoff = (0, $iD6kw.useRef)(Boolean(optimisedAppearId) && typeof window !== "undefined" && !((_window_MotionHandoffIsComplete = (_window = window).MotionHandoffIsComplete) === null || _window_MotionHandoffIsComplete === void 0 ? void 0 : _window_MotionHandoffIsComplete.call(_window, optimisedAppearId)) && ((_window_MotionHasOptimisedAnimation = (_window1 = window).MotionHasOptimisedAnimation) === null || _window_MotionHasOptimisedAnimation === void 0 ? void 0 : _window_MotionHasOptimisedAnimation.call(_window1, optimisedAppearId)));
    (0, $24ePD.useIsomorphicLayoutEffect)(function() {
        /**
         * Track that this component has mounted. This is used to detect when
         * LazyMotion features load after the component has already committed.
         */ hasMountedOnce.current = true;
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        visualElement.scheduleRenderMicrotask();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $iD6kw.useEffect)(function() {
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(function() {
                var _window_MotionHandoffMarkAsComplete, _window;
                (_window_MotionHandoffMarkAsComplete = (_window = window).MotionHandoffMarkAsComplete) === null || _window_MotionHandoffMarkAsComplete === void 0 ? void 0 : _window_MotionHandoffMarkAsComplete.call(_window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
        /**
         * Now we've finished triggering animations for this element we
         * can wipe the enteringChildren set for the next render.
         */ visualElement.enteringChildren = undefined;
    });
    return visualElement;
}
function $e066fa8232bf96e5$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    var layoutId = props.layoutId, layout = props.layout, drag = props.drag, dragConstraints = props.dragConstraints, layoutScroll = props.layoutScroll, layoutRoot = props.layoutRoot, layoutAnchor = props.layoutAnchor, layoutCrossfade = props.layoutCrossfade;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $e066fa8232bf96e5$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $iXA5j.isRefObject)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot,
        layoutAnchor: layoutAnchor
    });
}
function $e066fa8232bf96e5$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $e066fa8232bf96e5$var$getClosestProjectingNode(visualElement.parent);
}

});
parcelRegister("keCnA", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", function () { return $3a4844c1aedd2695$export$8592e1c077c890a6; });

var $kxr67 = parcelRequire("kxr67");
var $3a4844c1aedd2695$export$ed7b8fa9dbf0105d = "framerAppearId";
var $3a4844c1aedd2695$export$8592e1c077c890a6 = "data-" + (0, $kxr67.camelToDash)($3a4844c1aedd2695$export$ed7b8fa9dbf0105d);

});

parcelRegister("1BC3b", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", function () { return $f285e54c318cc550$export$da5f7b802957459a; });

var $iD6kw = parcelRequire("iD6kw");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ var $f285e54c318cc550$export$da5f7b802957459a = (0, $iD6kw.createContext)({});

});

parcelRegister("iXA5j", function(module, exports) {

$parcel$export(module.exports, "isRefObject", function () { return $c5c3f1ab794872ea$export$dedd81df7bc1307; });

var $5djcY = parcelRequire("5djcY");
function $c5c3f1ab794872ea$export$dedd81df7bc1307(ref) {
    return ref && (typeof ref === "undefined" ? "undefined" : (0, $5djcY._)(ref)) === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});




parcelRegister("gaXdb", function(module, exports) {

$parcel$export(module.exports, "featureBundle", function () { return $3531e27027133d53$export$d596cd8841d25433; });

var $kWfK0 = parcelRequire("kWfK0");

var $8VYpy = parcelRequire("8VYpy");

var $iOlxx = parcelRequire("iOlxx");

var $9pvbx = parcelRequire("9pvbx");

var $iGham = parcelRequire("iGham");
var $3531e27027133d53$export$d596cd8841d25433 = (0, $kWfK0._)({}, (0, $8VYpy.animations), (0, $9pvbx.gestureAnimations), (0, $iOlxx.drag), (0, $iGham.layout));

});
parcelRegister("8VYpy", function(module, exports) {

$parcel$export(module.exports, "animations", function () { return $f843ec01d03c596f$export$7f9953c70dacfd7f; });

var $bHaTU = parcelRequire("bHaTU");

var $1DKqI = parcelRequire("1DKqI");
var $f843ec01d03c596f$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $bHaTU.AnimationFeature)
    },
    exit: {
        Feature: (0, $1DKqI.ExitAnimationFeature)
    }
};

});
parcelRegister("bHaTU", function(module, exports) {

$parcel$export(module.exports, "AnimationFeature", function () { return $106c7c8f2a3efbb6$export$b45b3fe5caabdca; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $hCZm2 = parcelRequire("hCZm2");
var $ledP3 = parcelRequire("ledP3");
var $fZjU9 = parcelRequire("fZjU9");
var $106c7c8f2a3efbb6$export$b45b3fe5caabdca = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $c2MhV._)(AnimationFeature, Feature);
    function AnimationFeature(node) {
        (0, $4QweW._)(this, AnimationFeature);
        var _this;
        _this = (0, $ehF45._)(this, AnimationFeature, [
            node
        ]);
        node.animationState || (node.animationState = (0, $hCZm2.createAnimationState)(node));
        return _this;
    }
    (0, $6hK4i._)(AnimationFeature, [
        {
            key: "updateAnimationControlsSubscription",
            value: function updateAnimationControlsSubscription() {
                var animate = this.node.getProps().animate;
                if ((0, $fZjU9.isAnimationControls)(animate)) this.unmountControls = animate.subscribe(this.node);
            }
        },
        {
            /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ key: "mount",
            value: function mount() {
                this.updateAnimationControlsSubscription();
            }
        },
        {
            key: "update",
            value: function update() {
                var animate = this.node.getProps().animate;
                var _ref = this.node.prevProps || {}, prevAnimate = _ref.animate;
                if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                var _this_unmountControls, _this;
                this.node.animationState.reset();
                (_this_unmountControls = (_this = this).unmountControls) === null || _this_unmountControls === void 0 ? void 0 : _this_unmountControls.call(_this);
            }
        }
    ]);
    return AnimationFeature;
}((0, $ledP3.Feature));

});
parcelRegister("hCZm2", function(module, exports) {

$parcel$export(module.exports, "createAnimationState", function () { return $328da01fc15dfeaa$export$bb53502b7a672aa8; });

var $kWfK0 = parcelRequire("kWfK0");

var $1DiK7 = parcelRequire("1DiK7");

var $jlUaU = parcelRequire("jlUaU");

var $g1FfY = parcelRequire("g1FfY");

var $4lzx3 = parcelRequire("4lzx3");

var $6N7qi = parcelRequire("6N7qi");

var $fZjU9 = parcelRequire("fZjU9");

var $cfiLd = parcelRequire("cfiLd");

var $e5exQ = parcelRequire("e5exQ");

var $2uK8F = parcelRequire("2uK8F");

var $kOzWk = parcelRequire("kOzWk");

var $51Z5p = parcelRequire("51Z5p");
var $328da01fc15dfeaa$var$reversePriorityOrder = (0, $jlUaU._)((0, $51Z5p.variantPriorityOrder)).reverse();
var $328da01fc15dfeaa$var$numAnimationTypes = (0, $51Z5p.variantPriorityOrder).length;
function $328da01fc15dfeaa$var$createAnimateFunction(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(param) {
            var animation = param.animation, options = param.options;
            return (0, $g1FfY.animateVisualElement)(visualElement, animation, options);
        }));
    };
}
function $328da01fc15dfeaa$export$bb53502b7a672aa8(visualElement) {
    var animate = $328da01fc15dfeaa$var$createAnimateFunction(visualElement);
    var state = $328da01fc15dfeaa$var$createState();
    var isInitialRender = true;
    /**
     * Track whether the animation state has been reset (e.g. via StrictMode
     * double-invocation or Suspense unmount/remount). On the first
     * animateChanges() call after a reset we need to behave like the initial
     * render for variant-inheritance checks, even though isInitialRender is
     * already false.
     */ var wasReset = false;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(type) {
        return function(acc, definition) {
            var _visualElement_presenceContext;
            var resolved = (0, $2uK8F.resolveVariant)(visualElement, definition, type === "exit" ? (_visualElement_presenceContext = visualElement.presenceContext) === null || _visualElement_presenceContext === void 0 ? void 0 : _visualElement_presenceContext.custom : undefined);
            if (resolved) {
                var transition = resolved.transition, transitionEnd = resolved.transitionEnd, target = (0, $1DiK7._)(resolved, [
                    "transition",
                    "transitionEnd"
                ]);
                acc = (0, $kWfK0._)({}, acc, target, transitionEnd);
            }
            return acc;
        };
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        var _loop = function(i) {
            var _animations;
            var type = $328da01fc15dfeaa$var$reversePriorityOrder[i];
            var typeState = state[type];
            var prop = props[type] !== undefined ? props[type] : context[type];
            var propIsVariant = (0, $e5exQ.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited && (isInitialRender || wasReset) && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $kWfK0._)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $fZjU9.isAnimationControls)(prop) || typeof prop === "boolean") return "continue";
            /**
             * If exit is already active and wasn't just activated, skip
             * re-processing to prevent interrupting running exit animations.
             * Re-resolving exit with a changed custom value can start new
             * value animations that stop the originals, leaving the exit
             * animation promise unresolved and the component stuck in the DOM.
             */ if (type === "exit" && typeState.isActive && activeDelta !== true) {
                if (typeState.prevResolvedValues) encounteredKeys = (0, $kWfK0._)({}, encounteredKeys, typeState.prevResolvedValues);
                return "continue";
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var variantDidChange = $328da01fc15dfeaa$export$68651800594fd43c(typeState.prevProp, prop);
            var shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            var handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _typeState_prevResolvedValues = typeState.prevResolvedValues, prevResolvedValues = _typeState_prevResolvedValues === void 0 ? {} : _typeState_prevResolvedValues;
            var allKeys = (0, $kWfK0._)({}, prevResolvedValues, resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                var motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ var valueHasChanged = false;
                if ((0, $cfiLd.isKeyframesTarget)(next) && (0, $cfiLd.isKeyframesTarget)(prev)) valueHasChanged = !(0, $kOzWk.shallowCompare)(next, prev) || variantDidChange;
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) encounteredKeys = (0, $kWfK0._)({}, encounteredKeys, resolvedValues);
            if ((isInitialRender || wasReset) && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ var willAnimateViaParent = isInherited && variantDidChange;
            var needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) (_animations = animations).push.apply(_animations, (0, $jlUaU._)(definitionList.map(function(animation) {
                var options = {
                    type: type
                };
                /**
                     * If we're performing the initial animation, but we're not
                     * rendering at the same time as the variant-controlling parent,
                     * we want to use the parent's transition to calculate the stagger.
                     */ if (typeof animation === "string" && (isInitialRender || wasReset) && !willAnimateViaParent && visualElement.manuallyAnimateOnMount && visualElement.parent) {
                    var parent = visualElement.parent;
                    var parentVariant = (0, $2uK8F.resolveVariant)(parent, animation);
                    if (parent.enteringChildren && parentVariant) {
                        var delayChildren = (parentVariant.transition || {}).delayChildren;
                        options.delay = (0, $4lzx3.calcChildStagger)(parent.enteringChildren, visualElement, delayChildren);
                    }
                }
                return {
                    animation: animation,
                    options: options
                };
            })));
        };
        var props = visualElement.props;
        var context = (0, $6N7qi.getVariantContext)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < $328da01fc15dfeaa$var$numAnimationTypes; i++)_loop(i);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                var initialTransition = (0, $2uK8F.resolveVariant)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                var motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        wasReset = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var // Propagate active change to children
        _visualElement_variantChildren;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        (_visualElement_variantChildren = visualElement.variantChildren) === null || _visualElement_variantChildren === void 0 ? void 0 : _visualElement_variantChildren.forEach(function(child) {
            var _child_animationState;
            return (_child_animationState = child.animationState) === null || _child_animationState === void 0 ? void 0 : _child_animationState.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        var animations = animateChanges(type);
        for(var key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        },
        reset: function() {
            state = $328da01fc15dfeaa$var$createState();
            wasReset = true;
        }
    };
}
function $328da01fc15dfeaa$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $kOzWk.shallowCompare)(next, prev);
    return false;
}
function $328da01fc15dfeaa$var$createTypeState() {
    var isActive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $328da01fc15dfeaa$var$createState() {
    return {
        animate: $328da01fc15dfeaa$var$createTypeState(true),
        whileInView: $328da01fc15dfeaa$var$createTypeState(),
        whileHover: $328da01fc15dfeaa$var$createTypeState(),
        whileTap: $328da01fc15dfeaa$var$createTypeState(),
        whileDrag: $328da01fc15dfeaa$var$createTypeState(),
        whileFocus: $328da01fc15dfeaa$var$createTypeState(),
        exit: $328da01fc15dfeaa$var$createTypeState()
    };
}

});
parcelRegister("g1FfY", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", function () { return $b8255ba25984e67b$export$ff62cf473653f109; });

var $2uK8F = parcelRequire("2uK8F");

var $bWT6d = parcelRequire("bWT6d");

var $dIGEy = parcelRequire("dIGEy");
function $b8255ba25984e67b$export$ff62cf473653f109(visualElement, definition) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    visualElement.notify("AnimationStart", definition);
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return (0, $dIGEy.animateVariant)(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $dIGEy.animateVariant)(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? (0, $2uK8F.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $bWT6d.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(function() {
        visualElement.notify("AnimationComplete", definition);
    });
}

});
parcelRegister("2uK8F", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", function () { return $e6428161e3003d33$export$7b1b1c981f4f0558; });

var $lHseB = parcelRequire("lHseB");
function $e6428161e3003d33$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return (0, $lHseB.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

});

parcelRegister("bWT6d", function(module, exports) {

$parcel$export(module.exports, "animateTarget", function () { return $16977dc4b204de34$export$68cacfeee78d98d2; });

var $kWfK0 = parcelRequire("kWfK0");

var $1DiK7 = parcelRequire("1DiK7");

var $1Ul7u = parcelRequire("1Ul7u");

var $fxDsk = parcelRequire("fxDsk");

var $ke5oA = parcelRequire("ke5oA");

var $lktHx = parcelRequire("lktHx");

var $fvijA = parcelRequire("fvijA");

var $6Oi7A = parcelRequire("6Oi7A");

var $6addk = parcelRequire("6addk");

var $dbdHF = parcelRequire("dbdHF");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $16977dc4b204de34$var$shouldBlockAnimation(param, key) {
    var protectedKeys = param.protectedKeys, needsAnimating = param.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $16977dc4b204de34$export$68cacfeee78d98d2(visualElement, targetAndTransition) {
    var _loop = function(key) {
        var _visualElement_latestValues_key;
        var value = visualElement.getValue(key, (_visualElement_latestValues_key = visualElement.latestValues[key]) !== null && _visualElement_latestValues_key !== void 0 ? _visualElement_latestValues_key : null);
        var valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $16977dc4b204de34$var$shouldBlockAnimation(animationTypeState, key)) return "continue";
        var valueTransition = (0, $kWfK0._)({
            delay: delay
        }, (0, $1Ul7u.getValueTransition)(transition || {}, key));
        if (skipAnimations) valueTransition.skipAnimations = true;
        /**
         * If the value is already at the defined target, skip the animation.
         * We still re-assert the value via frame.update to take precedence
         * over any stale transitionEnd callbacks from previous animations.
         */ var currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating() && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) {
            (0, $dbdHF.frame).update(function() {
                return value.set(valueTarget);
            });
            return "continue";
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ var isHandoff = false;
        if (window.MotionHandoffAnimation) {
            var appearId = (0, $6Oi7A.getOptimisedAppearId)(visualElement);
            if (appearId) {
                var startTime = window.MotionHandoffAnimation(appearId, key, (0, $dbdHF.frame));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $fvijA.addValueToWillChange)(visualElement, key);
        var shouldReduceMotion = reduceMotion !== null && reduceMotion !== void 0 ? reduceMotion : visualElement.shouldReduceMotion;
        value.start((0, $6addk.animateMotionValue)(key, value, valueTarget, shouldReduceMotion && (0, $ke5oA.positionalKeys).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        var animation = value.animation;
        if (animation) animations.push(animation);
    };
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay, transitionOverride = _ref.transitionOverride, type = _ref.type;
    var transition = targetAndTransition.transition, transitionEnd = targetAndTransition.transitionEnd, target = (0, $1DiK7._)(targetAndTransition, [
        "transition",
        "transitionEnd"
    ]);
    var defaultTransition = visualElement.getDefaultTransition();
    transition = transition ? (0, $fxDsk.resolveTransition)(transition, defaultTransition) : defaultTransition;
    var reduceMotion = transition === null || transition === void 0 ? void 0 : transition.reduceMotion;
    var skipAnimations = transition === null || transition === void 0 ? void 0 : transition.skipAnimations;
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    var path = transition === null || transition === void 0 ? void 0 : transition.path;
    if (path) // path mutates `target` to claim x/y; loop below skips them.
    path.animateVisualElement(visualElement, target, transition, delay, animations);
    for(var key in target)_loop(key);
    if (transitionEnd) {
        var applyTransitionEnd = function() {
            return (0, $dbdHF.frame).update(function() {
                transitionEnd && (0, $lktHx.setTarget)(visualElement, transitionEnd);
            });
        };
        if (animations.length) Promise.all(animations).then(applyTransitionEnd);
        else applyTransitionEnd();
    }
    return animations;
}

});
parcelRegister("1Ul7u", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", function () { return $0238896f62433195$export$7c1391340308742e; });

var $fxDsk = parcelRequire("fxDsk");
function $0238896f62433195$export$7c1391340308742e(transition, key) {
    var _transition_key, _ref;
    var valueTransition = (_ref = (_transition_key = transition === null || transition === void 0 ? void 0 : transition[key]) !== null && _transition_key !== void 0 ? _transition_key : transition === null || transition === void 0 ? void 0 : transition["default"]) !== null && _ref !== void 0 ? _ref : transition;
    if (valueTransition !== transition) return (0, $fxDsk.resolveTransition)(valueTransition, transition);
    return valueTransition;
}

});
parcelRegister("fxDsk", function(module, exports) {

$parcel$export(module.exports, "resolveTransition", function () { return $12b8a478eacca2b8$export$b180037f8f468d61; });
/**
 * If `transition` has `inherit: true`, shallow-merge it with
 * `parentTransition` (child keys win) and strip the `inherit` key.
 * Otherwise return `transition` unchanged.
 */ 
var $kWfK0 = parcelRequire("kWfK0");

var $1DiK7 = parcelRequire("1DiK7");
function $12b8a478eacca2b8$export$b180037f8f468d61(transition, parentTransition) {
    if ((transition === null || transition === void 0 ? void 0 : transition.inherit) && parentTransition) {
        var _ = transition.inherit, rest = (0, $1DiK7._)(transition, [
            "inherit"
        ]);
        return (0, $kWfK0._)({}, parentTransition, rest);
    }
    return transition;
}

});


parcelRegister("lktHx", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $3d5bbd142590813c$export$1f61c53461aff4a5; });

var $kWfK0 = parcelRequire("kWfK0");

var $1DiK7 = parcelRequire("1DiK7");

var $c1b8l = parcelRequire("c1b8l");

var $2uK8F = parcelRequire("2uK8F");

var $cfiLd = parcelRequire("cfiLd");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $3d5bbd142590813c$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $c1b8l.motionValue)(value));
}
function $3d5bbd142590813c$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $cfiLd.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
}
function $3d5bbd142590813c$export$1f61c53461aff4a5(visualElement, definition) {
    var resolved = (0, $2uK8F.resolveVariant)(visualElement, definition);
    var _ref = resolved || {}, _ref_transitionEnd = _ref.transitionEnd, transitionEnd = _ref_transitionEnd === void 0 ? {} : _ref_transitionEnd, _ref_transition = _ref.transition, transition = _ref_transition === void 0 ? {} : _ref_transition, target = (0, $1DiK7._)(_ref, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $kWfK0._)({}, target, transitionEnd);
    for(var key in target){
        var value = $3d5bbd142590813c$var$resolveFinalValueInKeyframes(target[key]);
        $3d5bbd142590813c$var$setMotionValue(visualElement, key, value);
    }
}

});
parcelRegister("cfiLd", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $af477c9cc20e8ee4$export$9153ad4c4999f4a0; });
var $af477c9cc20e8ee4$export$9153ad4c4999f4a0 = function(v) {
    return Array.isArray(v);
};

});


parcelRegister("fvijA", function(module, exports) {

$parcel$export(module.exports, "addValueToWillChange", function () { return $9790ca34f7f5fc66$export$3ac5aed310be0bee; });

var $beX9F = parcelRequire("beX9F");

var $7CksJ = parcelRequire("7CksJ");
function $9790ca34f7f5fc66$export$3ac5aed310be0bee(visualElement, key) {
    var willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $7CksJ.isWillChangeMotionValue)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $beX9F.MotionGlobalConfig).WillChange) {
        var newWillChange = new (0, $beX9F.MotionGlobalConfig).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}

});
parcelRegister("7CksJ", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", function () { return $99131340dbf8c93a$export$98397f3adbf6259f; });

var $kbjZS = parcelRequire("kbjZS");
function $99131340dbf8c93a$export$98397f3adbf6259f(value) {
    return Boolean((0, $kbjZS.isMotionValue)(value) && value.add);
}

});


parcelRegister("6Oi7A", function(module, exports) {

$parcel$export(module.exports, "getOptimisedAppearId", function () { return $e8d869ca34a8d77f$export$5f8d21e84d1d84fc; });

var $keCnA = parcelRequire("keCnA");
function $e8d869ca34a8d77f$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $keCnA.optimizedAppearDataAttribute];
}

});

parcelRegister("6addk", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", function () { return $69c2d63788de8732$export$90b3dfc33ff3548; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $beX9F = parcelRequire("beX9F");
var $8wJkX = parcelRequire("8wJkX");

var $cUrnE = parcelRequire("cUrnE");

var $7YhfA = parcelRequire("7YhfA");

var $1Ul7u = parcelRequire("1Ul7u");

var $lV2DB = parcelRequire("lV2DB");

var $lcKGj = parcelRequire("lcKGj");

var $8padT = parcelRequire("8padT");

var $aRGnK = parcelRequire("aRGnK");

var $dbdHF = parcelRequire("dbdHF");
var $69c2d63788de8732$export$90b3dfc33ff3548 = function(name, value, target) {
    var transition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, element = arguments.length > 4 ? arguments[4] : void 0, isHandoff = arguments.length > 5 ? arguments[5] : void 0;
    return function(onComplete) {
        var valueTransition = (0, $1Ul7u.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ var delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ var _transition_elapsed = transition.elapsed, elapsed = _transition_elapsed === void 0 ? 0 : _transition_elapsed;
        elapsed = elapsed - (0, $8wJkX.secondsToMilliseconds)(delay);
        var options = (0, $hApvp._)((0, $kWfK0._)({
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity()
        }, valueTransition), {
            delay: -elapsed,
            onUpdate: function(v) {
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: function() {
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        });
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $aRGnK.isTransitionDefined)(valueTransition)) Object.assign(options, (0, $lcKGj.getDefaultTransition)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $8wJkX.secondsToMilliseconds)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $8wJkX.secondsToMilliseconds)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        var shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $lV2DB.makeAnimationInstant)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $beX9F.MotionGlobalConfig).instantAnimations || (0, $beX9F.MotionGlobalConfig).skipAnimations || (element === null || element === void 0 ? void 0 : element.shouldSkipAnimations) || valueTransition.skipAnimations) {
            shouldSkip = true;
            (0, $lV2DB.makeAnimationInstant)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            var finalKeyframe = (0, $8padT.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $dbdHF.frame).update(function() {
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $7YhfA.JSAnimation)(options) : new (0, $cUrnE.AsyncMotionValueAnimation)(options);
    };
};

});
parcelRegister("cUrnE", function(module, exports) {

$parcel$export(module.exports, "AsyncMotionValueAnimation", function () { return $fb095030cf034e83$export$b9855e2a7dee3dd2; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $1DiK7 = parcelRequire("1DiK7");

var $beX9F = parcelRequire("beX9F");
var $386Yo = parcelRequire("386Yo");

var $i1wr7 = parcelRequire("i1wr7");

var $7YhfA = parcelRequire("7YhfA");

var $8padT = parcelRequire("8padT");

var $1VyrA = parcelRequire("1VyrA");

var $f27wR = parcelRequire("f27wR");

var $ha2sx = parcelRequire("ha2sx");

var $lV2DB = parcelRequire("lV2DB");

var $vu8m8 = parcelRequire("vu8m8");

var $26meB = parcelRequire("26meB");
/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ var $fb095030cf034e83$var$MAX_RESOLVE_DELAY = 40;
var $fb095030cf034e83$export$b9855e2a7dee3dd2 = /*#__PURE__*/ function(WithPromise) {
    "use strict";
    (0, $c2MhV._)(AsyncMotionValueAnimation, WithPromise);
    function AsyncMotionValueAnimation(_param) {
        (0, $4QweW._)(this, AsyncMotionValueAnimation);
        var _this;
        var _param_autoplay = _param.autoplay, autoplay = _param_autoplay === void 0 ? true : _param_autoplay, _param_delay = _param.delay, delay = _param_delay === void 0 ? 0 : _param_delay, _param_type = _param.type, type = _param_type === void 0 ? "keyframes" : _param_type, _param_repeat = _param.repeat, repeat = _param_repeat === void 0 ? 0 : _param_repeat, _param_repeatDelay = _param.repeatDelay, repeatDelay = _param_repeatDelay === void 0 ? 0 : _param_repeatDelay, _param_repeatType = _param.repeatType, repeatType = _param_repeatType === void 0 ? "loop" : _param_repeatType, keyframes = _param.keyframes, name = _param.name, motionValue = _param.motionValue, element = _param.element, options = (0, $1DiK7._)(_param, [
            "autoplay",
            "delay",
            "type",
            "repeat",
            "repeatDelay",
            "repeatType",
            "keyframes",
            "name",
            "motionValue",
            "element"
        ]);
        var _this_keyframeResolver;
        _this = (0, $ehF45._)(this, AsyncMotionValueAnimation);
        /**
         * Bound to support return animation.stop pattern
         */ _this.stop = function() {
            var _this_keyframeResolver;
            if (_this._animation) {
                var _this_stopTimeline, _this1;
                _this._animation.stop();
                (_this_stopTimeline = (_this1 = _this).stopTimeline) === null || _this_stopTimeline === void 0 ? void 0 : _this_stopTimeline.call(_this1);
            }
            (_this_keyframeResolver = _this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.cancel();
        };
        _this.createdAt = (0, $i1wr7.time).now();
        var optionsWithDefaults = (0, $kWfK0._)({
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element
        }, options);
        var KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $1VyrA.KeyframeResolver);
        _this.keyframeResolver = new KeyframeResolver$1(keyframes, function(resolvedKeyframes, finalKeyframe, forced) {
            return _this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced);
        }, name, motionValue, element);
        (_this_keyframeResolver = _this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.scheduleResolve();
        return _this;
    }
    (0, $6hK4i._)(AsyncMotionValueAnimation, [
        {
            key: "onKeyframesResolved",
            value: function onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
                var _this = this;
                var _resolvedOptions_motionValue_owner, _resolvedOptions_motionValue;
                this.keyframeResolver = undefined;
                var name = options.name, type = options.type, velocity = options.velocity, delay = options.delay, isHandoff = options.isHandoff, onUpdate = options.onUpdate;
                this.resolvedAt = (0, $i1wr7.time).now();
                /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ var canAnimateValue = true;
                if (!(0, $ha2sx.canAnimate)(keyframes, name, type, velocity)) {
                    canAnimateValue = false;
                    if ((0, $beX9F.MotionGlobalConfig).instantAnimations || !delay) onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate((0, $8padT.getFinalKeyframe)(keyframes, options, finalKeyframe));
                    keyframes[0] = keyframes[keyframes.length - 1];
                    (0, $lV2DB.makeAnimationInstant)(options);
                    options.repeat = 0;
                }
                /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first committed frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ var startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $fb095030cf034e83$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
                var resolvedOptions = (0, $hApvp._)((0, $kWfK0._)({
                    startTime: startTime,
                    finalKeyframe: finalKeyframe
                }, options), {
                    keyframes: keyframes
                });
                /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         *
         * Also skip WAAPI when keyframes aren't animatable, as the resolved
         * values may not be valid CSS and would trigger browser warnings.
         */ var useWaapi = canAnimateValue && !isHandoff && (0, $26meB.supportsBrowserAnimation)(resolvedOptions);
                var element = (_resolvedOptions_motionValue = resolvedOptions.motionValue) === null || _resolvedOptions_motionValue === void 0 ? void 0 : (_resolvedOptions_motionValue_owner = _resolvedOptions_motionValue.owner) === null || _resolvedOptions_motionValue_owner === void 0 ? void 0 : _resolvedOptions_motionValue_owner.current;
                var animation;
                if (useWaapi) try {
                    animation = new (0, $f27wR.NativeAnimationExtended)((0, $hApvp._)((0, $kWfK0._)({}, resolvedOptions), {
                        element: element
                    }));
                } catch (e) {
                    animation = new (0, $7YhfA.JSAnimation)(resolvedOptions);
                }
                else animation = new (0, $7YhfA.JSAnimation)(resolvedOptions);
                animation.finished.then(function() {
                    _this.notifyFinished();
                }).catch((0, $386Yo.noop));
                if (this.pendingTimeline) {
                    this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
                    this.pendingTimeline = undefined;
                }
                this._animation = animation;
            }
        },
        {
            key: "finished",
            get: function get() {
                if (!this._animation) return this._finished;
                else return this.animation.finished;
            }
        },
        {
            key: "then",
            value: function then(onResolve, _onReject) {
                return this.finished.finally(onResolve).then(function() {});
            }
        },
        {
            key: "animation",
            get: function get() {
                if (!this._animation) {
                    var _this_keyframeResolver;
                    (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.resume();
                    (0, $1VyrA.flushKeyframeResolvers)();
                }
                return this._animation;
            }
        },
        {
            key: "duration",
            get: function get() {
                return this.animation.duration;
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                return this.animation.iterationDuration;
            }
        },
        {
            key: "time",
            get: function get() {
                return this.animation.time;
            },
            set: function set(newTime) {
                this.animation.time = newTime;
            }
        },
        {
            key: "speed",
            get: function get() {
                return this.animation.speed;
            },
            set: function set(newSpeed) {
                this.animation.speed = newSpeed;
            }
        },
        {
            key: "state",
            get: function get() {
                return this.animation.state;
            }
        },
        {
            key: "startTime",
            get: function get() {
                return this.animation.startTime;
            }
        },
        {
            key: "attachTimeline",
            value: function attachTimeline(timeline) {
                var _this = this;
                if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
                else this.pendingTimeline = timeline;
                return function() {
                    return _this.stop();
                };
            }
        },
        {
            key: "play",
            value: function play() {
                this.animation.play();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.animation.pause();
            }
        },
        {
            key: "complete",
            value: function complete() {
                this.animation.complete();
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this_keyframeResolver;
                if (this._animation) this.animation.cancel();
                (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.cancel();
            }
        }
    ]);
    return AsyncMotionValueAnimation;
}((0, $vu8m8.WithPromise));

});
parcelRegister("7YhfA", function(module, exports) {

$parcel$export(module.exports, "JSAnimation", function () { return $c7f972233f627670$export$3394f837405475c7; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $jlUaU = parcelRequire("jlUaU");

var $4ceSY = parcelRequire("4ceSY");
var $8wJkX = parcelRequire("8wJkX");
var $5Hogw = parcelRequire("5Hogw");

var $i1wr7 = parcelRequire("i1wr7");

var $jIkoR = parcelRequire("jIkoR");

var $3CXci = parcelRequire("3CXci");

var $9EfU4 = parcelRequire("9EfU4");

var $lVcPj = parcelRequire("lVcPj");

var $4T81O = parcelRequire("4T81O");

var $gl5UY = parcelRequire("gl5UY");

var $8padT = parcelRequire("8padT");

var $klo3G = parcelRequire("klo3G");

var $vu8m8 = parcelRequire("vu8m8");
var $c7f972233f627670$var$percentToProgress = function(percent) {
    return percent / 100;
};
var $c7f972233f627670$export$3394f837405475c7 = /*#__PURE__*/ function(WithPromise) {
    "use strict";
    (0, $c2MhV._)(JSAnimation, WithPromise);
    function JSAnimation(options) {
        (0, $4QweW._)(this, JSAnimation);
        var _this;
        _this = (0, $ehF45._)(this, JSAnimation);
        _this.state = "idle";
        _this.startTime = null;
        _this.isStopped = false;
        /**
         * The current time of the animation.
         */ _this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ _this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ _this.playbackSpeed = 1;
        /**
         * Reusable state object for the delay phase to avoid
         * allocating a new object every frame.
         */ _this.delayState = {
            done: false,
            value: undefined
        };
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ _this.stop = function() {
            var _this_options_onStop, _this_options;
            var motionValue = _this.options.motionValue;
            if (motionValue && motionValue.updatedAt !== (0, $i1wr7.time).now()) _this.tick((0, $i1wr7.time).now());
            _this.isStopped = true;
            if (_this.state === "idle") return;
            _this.teardown();
            (_this_options_onStop = (_this_options = _this.options).onStop) === null || _this_options_onStop === void 0 ? void 0 : _this_options_onStop.call(_this_options);
        };
        _this.options = options;
        _this.initAnimation();
        _this.play();
        if (options.autoplay === false) _this.pause();
        return _this;
    }
    (0, $6hK4i._)(JSAnimation, [
        {
            key: "initAnimation",
            value: function initAnimation() {
                var options = this.options;
                (0, $klo3G.replaceTransitionType)(options);
                var _options_type = options.type, type = _options_type === void 0 ? (0, $lVcPj.keyframes) : _options_type, _options_repeat = options.repeat, repeat = _options_repeat === void 0 ? 0 : _options_repeat, _options_repeatDelay = options.repeatDelay, repeatDelay = _options_repeatDelay === void 0 ? 0 : _options_repeatDelay, repeatType = options.repeatType, _options_velocity = options.velocity, velocity = _options_velocity === void 0 ? 0 : _options_velocity;
                var keyframes$1 = options.keyframes;
                var generatorFactory = type || (0, $lVcPj.keyframes);
                if (generatorFactory !== (0, $lVcPj.keyframes) && typeof keyframes$1[0] !== "number") {
                    this.mixKeyframes = (0, $5Hogw.pipe)($c7f972233f627670$var$percentToProgress, (0, $jIkoR.mix)(keyframes$1[0], keyframes$1[1]));
                    keyframes$1 = [
                        0,
                        100
                    ];
                }
                var generator = generatorFactory((0, $hApvp._)((0, $kWfK0._)({}, options), {
                    keyframes: keyframes$1
                }));
                /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory((0, $hApvp._)((0, $kWfK0._)({}, options), {
                    keyframes: (0, $jlUaU._)(keyframes$1).reverse(),
                    velocity: -velocity
                }));
                /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $4T81O.calcGeneratorDuration)(generator);
                var calculatedDuration = generator.calculatedDuration;
                this.calculatedDuration = calculatedDuration;
                this.resolvedDuration = calculatedDuration + repeatDelay;
                this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
                this.generator = generator;
            }
        },
        {
            key: "updateTime",
            value: function updateTime(timestamp) {
                var animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
                // Update currentTime
                if (this.holdTime !== null) this.currentTime = this.holdTime;
                else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
                // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
                // example.
                this.currentTime = animationTime;
            }
        },
        {
            key: "tick",
            value: function tick(timestamp) {
                var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this, generator = _this.generator, totalDuration = _this.totalDuration, mixKeyframes = _this.mixKeyframes, mirroredGenerator = _this.mirroredGenerator, resolvedDuration = _this.resolvedDuration, calculatedDuration = _this.calculatedDuration;
                if (this.startTime === null) return generator.next(0);
                var _this_options = this.options, _this_options_delay = _this_options.delay, delay = _this_options_delay === void 0 ? 0 : _this_options_delay, keyframes = _this_options.keyframes, repeat = _this_options.repeat, repeatType = _this_options.repeatType, repeatDelay = _this_options.repeatDelay, type = _this_options.type, onUpdate = _this_options.onUpdate, finalKeyframe = _this_options.finalKeyframe;
                /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
                else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
                if (sample) this.currentTime = timestamp;
                else this.updateTime(timestamp);
                // Rebase on delay
                var timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
                var isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
                this.currentTime = Math.max(timeWithoutDelay, 0);
                // If this animation has finished, set the current time  to the total duration.
                if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
                var elapsed = this.currentTime;
                var frameGenerator = generator;
                if (repeat) {
                    /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ var progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
                    /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ var currentIteration = Math.floor(progress);
                    /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ var iterationProgress = progress % 1.0;
                    /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
                    iterationProgress === 1 && currentIteration--;
                    currentIteration = Math.min(currentIteration, repeat + 1);
                    /**
             * Reverse progress if we're not running in "normal" direction
             */ var isOddIteration = Boolean(currentIteration % 2);
                    if (isOddIteration) {
                        if (repeatType === "reverse") {
                            iterationProgress = 1 - iterationProgress;
                            if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                        } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
                    }
                    elapsed = (0, $4ceSY.clamp)(0, 1, iterationProgress) * resolvedDuration;
                }
                /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ var state;
                if (isInDelayPhase) {
                    this.delayState.value = keyframes[0];
                    state = this.delayState;
                } else state = frameGenerator.next(elapsed);
                if (mixKeyframes && !isInDelayPhase) state.value = mixKeyframes(state.value);
                var done = state.done;
                if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
                var isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
                // TODO: The exception for inertia could be cleaner here
                if (isAnimationFinished && type !== (0, $9EfU4.inertia)) state.value = (0, $8padT.getFinalKeyframe)(keyframes, this.options, finalKeyframe, this.speed);
                if (onUpdate) onUpdate(state.value);
                if (isAnimationFinished) this.finish();
                return state;
            }
        },
        {
            /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ key: "then",
            value: function then(resolve, reject) {
                return this.finished.then(resolve, reject);
            }
        },
        {
            key: "duration",
            get: function get() {
                return (0, $8wJkX.millisecondsToSeconds)(this.calculatedDuration);
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                var _ref = this.options || {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay;
                return this.duration + (0, $8wJkX.millisecondsToSeconds)(delay);
            }
        },
        {
            key: "time",
            get: function get() {
                return (0, $8wJkX.millisecondsToSeconds)(this.currentTime);
            },
            set: function set(newTime) {
                newTime = (0, $8wJkX.secondsToMilliseconds)(newTime);
                this.currentTime = newTime;
                if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
                else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
                if (this.driver) this.driver.start(false);
                else {
                    this.startTime = 0;
                    this.state = "paused";
                    this.holdTime = newTime;
                    this.tick(newTime);
                }
            }
        },
        {
            /**
     * Returns the generator's velocity at the current time in units/second.
     * Uses the analytical derivative when available (springs), avoiding
     * the MotionValue's frame-dependent velocity estimation.
     */ key: "getGeneratorVelocity",
            value: function getGeneratorVelocity1() {
                var _this = this;
                var t = this.currentTime;
                if (t <= 0) return this.options.velocity || 0;
                if (this.generator.velocity) return this.generator.velocity(t);
                // Fallback: finite difference
                var current = this.generator.next(t).value;
                return (0, $gl5UY.getGeneratorVelocity)(function(s) {
                    return _this.generator.next(s).value;
                }, t, current);
            }
        },
        {
            key: "speed",
            get: function get() {
                return this.playbackSpeed;
            },
            set: function set(newSpeed) {
                var hasChanged = this.playbackSpeed !== newSpeed;
                if (hasChanged && this.driver) this.updateTime((0, $i1wr7.time).now());
                this.playbackSpeed = newSpeed;
                if (hasChanged && this.driver) this.time = (0, $8wJkX.millisecondsToSeconds)(this.currentTime);
            }
        },
        {
            key: "play",
            value: function play() {
                var _this = this;
                var _this_options_onPlay, _this_options;
                if (this.isStopped) return;
                var _this_options1 = this.options, _this_options_driver = _this_options1.driver, driver = _this_options_driver === void 0 ? (0, $3CXci.frameloopDriver) : _this_options_driver, startTime = _this_options1.startTime;
                if (!this.driver) this.driver = driver(function(timestamp) {
                    return _this.tick(timestamp);
                });
                (_this_options_onPlay = (_this_options = this.options).onPlay) === null || _this_options_onPlay === void 0 ? void 0 : _this_options_onPlay.call(_this_options);
                var now = this.driver.now();
                if (this.state === "finished") {
                    this.updateFinished();
                    this.startTime = now;
                } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
                else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : now;
                if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
                this.holdTime = null;
                /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
                this.driver.start();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.state = "paused";
                this.updateTime((0, $i1wr7.time).now());
                this.holdTime = this.currentTime;
            }
        },
        {
            key: "complete",
            value: function complete() {
                if (this.state !== "running") this.play();
                this.state = "finished";
                this.holdTime = null;
            }
        },
        {
            key: "finish",
            value: function finish() {
                var _this_options_onComplete, _this_options;
                this.notifyFinished();
                this.teardown();
                this.state = "finished";
                (_this_options_onComplete = (_this_options = this.options).onComplete) === null || _this_options_onComplete === void 0 ? void 0 : _this_options_onComplete.call(_this_options);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this_options_onCancel, _this_options;
                this.holdTime = null;
                this.startTime = 0;
                this.tick(0);
                this.teardown();
                (_this_options_onCancel = (_this_options = this.options).onCancel) === null || _this_options_onCancel === void 0 ? void 0 : _this_options_onCancel.call(_this_options);
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                this.state = "idle";
                this.stopDriver();
                this.startTime = this.holdTime = null;
            }
        },
        {
            key: "stopDriver",
            value: function stopDriver() {
                if (!this.driver) return;
                this.driver.stop();
                this.driver = undefined;
            }
        },
        {
            key: "sample",
            value: function sample(sampleTime) {
                this.startTime = 0;
                return this.tick(sampleTime, true);
            }
        },
        {
            key: "attachTimeline",
            value: function attachTimeline(timeline) {
                var _this_driver;
                if (this.options.allowFlatten) {
                    this.options.type = "keyframes";
                    this.options.ease = "linear";
                    this.initAnimation();
                }
                (_this_driver = this.driver) === null || _this_driver === void 0 ? void 0 : _this_driver.stop();
                return timeline.observe(this);
            }
        }
    ]);
    return JSAnimation;
}((0, $vu8m8.WithPromise));
// Legacy function support
function $c7f972233f627670$export$ee9b76de7353d815(options) {
    return new $c7f972233f627670$export$3394f837405475c7(options);
}

});
parcelRegister("5Hogw", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $6c27b34b573a47cb$export$a4627e546088548d; });
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ var $6c27b34b573a47cb$export$a4627e546088548d = function() {
    for(var _len = arguments.length, transformers = new Array(_len), _key = 0; _key < _len; _key++){
        transformers[_key] = arguments[_key];
    }
    return transformers.reduce(function(a, b) {
        return function(v) {
            return b(a(v));
        };
    });
};

});

parcelRegister("jIkoR", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $0bd81ff54466bea7$export$2c9e8a9632a706b2; });

var $gUuIH = parcelRequire("gUuIH");

var $gcS1k = parcelRequire("gcS1k");
function $0bd81ff54466bea7$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $gcS1k.mixNumber)(from, to, p);
    var mixer = (0, $gUuIH.getMixer)(from);
    return mixer(from, to);
}

});
parcelRegister("gUuIH", function(module, exports) {

$parcel$export(module.exports, "getMixer", function () { return $6d2939203143a384$export$36ec24672cd098e0; });

var $kWfK0 = parcelRequire("kWfK0");

var $jlUaU = parcelRequire("jlUaU");

var $5djcY = parcelRequire("5djcY");

var $5Hogw = parcelRequire("5Hogw");
var $8FnrH = parcelRequire("8FnrH");

var $1575y = parcelRequire("1575y");

var $h5K91 = parcelRequire("h5K91");

var $eyJsx = parcelRequire("eyJsx");

var $59TjH = parcelRequire("59TjH");

var $6WZHv = parcelRequire("6WZHv");

var $gcS1k = parcelRequire("gcS1k");

var $gYhRS = parcelRequire("gYhRS");
function $6d2939203143a384$var$mixNumber(a, b) {
    return function(p) {
        return (0, $gcS1k.mixNumber)(a, b, p);
    };
}
function $6d2939203143a384$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $6d2939203143a384$var$mixNumber;
    else if (typeof a === "string") return (0, $1575y.isCSSVariableToken)(a) ? (0, $6WZHv.mixImmediate) : (0, $h5K91.color).test(a) ? (0, $59TjH.mixColor) : $6d2939203143a384$export$65516310a87d8205;
    else if (Array.isArray(a)) return $6d2939203143a384$export$3bbefa2f402845c4;
    else if ((typeof a === "undefined" ? "undefined" : (0, $5djcY._)(a)) === "object") return (0, $h5K91.color).test(a) ? (0, $59TjH.mixColor) : $6d2939203143a384$export$ebc23b6840c51ba1;
    return 0, $6WZHv.mixImmediate;
}
function $6d2939203143a384$export$3bbefa2f402845c4(a, b) {
    var output = (0, $jlUaU._)(a);
    var numValues = output.length;
    var blendValue = a.map(function(v, i) {
        return $6d2939203143a384$export$36ec24672cd098e0(v)(v, b[i]);
    });
    return function(p) {
        for(var i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $6d2939203143a384$export$ebc23b6840c51ba1(a, b) {
    var output = (0, $kWfK0._)({}, a, b);
    var blendValue = {};
    for(var key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $6d2939203143a384$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return function(v) {
        for(var key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $6d2939203143a384$var$matchOrder(origin, target) {
    var orderedOrigin = [];
    var pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(var i = 0; i < target.values.length; i++){
        var type = target.types[i];
        var originIndex = origin.indexes[type][pointers[type]];
        var _origin_values_originIndex;
        var originValue = (_origin_values_originIndex = origin.values[originIndex]) !== null && _origin_values_originIndex !== void 0 ? _origin_values_originIndex : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
var $6d2939203143a384$export$65516310a87d8205 = function(origin, target) {
    var template = (0, $eyJsx.complex).createTransformer(target);
    var originStats = (0, $eyJsx.analyseComplexValue)(origin);
    var targetStats = (0, $eyJsx.analyseComplexValue)(target);
    var canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $gYhRS.invisibleValues).has(origin) && !targetStats.values.length || (0, $gYhRS.invisibleValues).has(target) && !originStats.values.length) return (0, $gYhRS.mixVisibility)(origin, target);
        return (0, $5Hogw.pipe)($6d2939203143a384$export$3bbefa2f402845c4($6d2939203143a384$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $8FnrH.warning)(true, "Complex values '".concat(origin, "' and '").concat(target, "' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition."), "complex-values-different");
        return (0, $6WZHv.mixImmediate)(origin, target);
    }
};

});
parcelRegister("59TjH", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $2beb23ef4c0e5b16$export$51e568cf5c039bac; });

var $kWfK0 = parcelRequire("kWfK0");

var $8FnrH = parcelRequire("8FnrH");

var $jEwEJ = parcelRequire("jEwEJ");

var $1NpYK = parcelRequire("1NpYK");

var $cS5ux = parcelRequire("cS5ux");

var $eMwxO = parcelRequire("eMwxO");

var $6WZHv = parcelRequire("6WZHv");

var $gcS1k = parcelRequire("gcS1k");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
var $2beb23ef4c0e5b16$export$d4ecea248cce73c = function(from, to, v) {
    var fromExpo = from * from;
    var expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
var $2beb23ef4c0e5b16$var$colorTypes = [
    (0, $jEwEJ.hex),
    (0, $eMwxO.rgba),
    (0, $1NpYK.hsla)
];
var $2beb23ef4c0e5b16$var$getColorType = function(v) {
    return $2beb23ef4c0e5b16$var$colorTypes.find(function(type) {
        return type.test(v);
    });
};
function $2beb23ef4c0e5b16$var$asRGBA(color) {
    var type = $2beb23ef4c0e5b16$var$getColorType(color);
    (0, $8FnrH.warning)(Boolean(type), "'".concat(color, "' is not an animatable color. Use the equivalent color code instead."), "color-not-animatable");
    if (!Boolean(type)) return false;
    var model = type.parse(color);
    if (type === (0, $1NpYK.hsla)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $cS5ux.hslaToRgba)(model);
    return model;
}
var $2beb23ef4c0e5b16$export$51e568cf5c039bac = function(from, to) {
    var fromRGBA = $2beb23ef4c0e5b16$var$asRGBA(from);
    var toRGBA = $2beb23ef4c0e5b16$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $6WZHv.mixImmediate)(from, to);
    var blended = (0, $kWfK0._)({}, fromRGBA);
    return function(v) {
        blended.red = $2beb23ef4c0e5b16$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $2beb23ef4c0e5b16$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $2beb23ef4c0e5b16$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $gcS1k.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $eMwxO.rgba).transform(blended);
    };
};

});
parcelRegister("cS5ux", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", function () { return $ba4bc9d67660679f$export$6ae64dbcd6bfc33e; });
// Adapted from https://gist.github.com/mjackson/5311256
function $ba4bc9d67660679f$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $ba4bc9d67660679f$export$6ae64dbcd6bfc33e(param) {
    var hue = param.hue, saturation = param.saturation, lightness = param.lightness, alpha = param.alpha;
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    var red = 0;
    var green = 0;
    var blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        var q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        var p = 2 * lightness - q;
        red = $ba4bc9d67660679f$var$hueToRgb(p, q, hue + 1 / 3);
        green = $ba4bc9d67660679f$var$hueToRgb(p, q, hue);
        blue = $ba4bc9d67660679f$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});

parcelRegister("6WZHv", function(module, exports) {

$parcel$export(module.exports, "mixImmediate", function () { return $21976f0fd1ec5957$export$a6f92d4bae65c0f1; });
function $21976f0fd1ec5957$export$a6f92d4bae65c0f1(a, b) {
    return function(p) {
        return p > 0 ? b : a;
    };
}

});


parcelRegister("gYhRS", function(module, exports) {

$parcel$export(module.exports, "invisibleValues", function () { return $ea16dad48041be8a$export$e5a55ae567dd4ac7; });
$parcel$export(module.exports, "mixVisibility", function () { return $ea16dad48041be8a$export$fed62ccc3fb1a568; });
var $ea16dad48041be8a$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $ea16dad48041be8a$export$fed62ccc3fb1a568(origin, target) {
    if ($ea16dad48041be8a$export$e5a55ae567dd4ac7.has(origin)) return function(p) {
        return p <= 0 ? origin : target;
    };
    else return function(p) {
        return p >= 1 ? target : origin;
    };
}

});



parcelRegister("3CXci", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", function () { return $676a2fb3ae553c3a$export$c1033964b5ad7fef; });

var $i1wr7 = parcelRequire("i1wr7");

var $dbdHF = parcelRequire("dbdHF");
var $676a2fb3ae553c3a$export$c1033964b5ad7fef = function(update) {
    var passTimestamp = function(param) {
        var timestamp = param.timestamp;
        return update(timestamp);
    };
    return {
        start: function() {
            var keepAlive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
            return (0, $dbdHF.frame).update(passTimestamp, keepAlive);
        },
        stop: function() {
            return (0, $dbdHF.cancelFrame)(passTimestamp);
        },
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: function() {
            return (0, $dbdHF.frameData).isProcessing ? (0, $dbdHF.frameData).timestamp : (0, $i1wr7.time).now();
        }
    };
};

});

parcelRegister("9EfU4", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $59ea98a27c7c6d40$export$ee3ff3a17106998; });

var $gVjFf = parcelRequire("gVjFf");

var $gl5UY = parcelRequire("gl5UY");
function $59ea98a27c7c6d40$export$ee3ff3a17106998(param) {
    var keyframes = param.keyframes, _param_velocity = param.velocity, velocity = _param_velocity === void 0 ? 0.0 : _param_velocity, _param_power = param.power, power = _param_power === void 0 ? 0.8 : _param_power, _param_timeConstant = param.timeConstant, timeConstant = _param_timeConstant === void 0 ? 325 : _param_timeConstant, _param_bounceDamping = param.bounceDamping, bounceDamping = _param_bounceDamping === void 0 ? 10 : _param_bounceDamping, _param_bounceStiffness = param.bounceStiffness, bounceStiffness = _param_bounceStiffness === void 0 ? 500 : _param_bounceStiffness, modifyTarget = param.modifyTarget, min = param.min, max = param.max, _param_restDelta = param.restDelta, restDelta = _param_restDelta === void 0 ? 0.5 : _param_restDelta, restSpeed = param.restSpeed;
    var origin = keyframes[0];
    var state = {
        done: false,
        value: origin
    };
    var isOutOfBounds = function(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    };
    var nearestBoundary = function(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    var amplitude = power * velocity;
    var ideal = origin + amplitude;
    var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    var calcDelta = function(t) {
        return -amplitude * Math.exp(-t / timeConstant);
    };
    var calcLatest = function(t) {
        return target + calcDelta(t);
    };
    var applyFriction = function(t) {
        var delta = calcDelta(t);
        var latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ var timeReachedBoundary;
    var spring$1;
    var checkCatchBoundary = function(t) {
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $gVjFf.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $gl5UY.getGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: function(t) {
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ var hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});
parcelRegister("gVjFf", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $6400aba9425dc66d$export$b36281d89752ae66; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $5djcY = parcelRequire("5djcY");

var $4ceSY = parcelRequire("4ceSY");
var $8wJkX = parcelRequire("8wJkX");
var $8FnrH = parcelRequire("8FnrH");

var $1iHAC = parcelRequire("1iHAC");

var $4T81O = parcelRequire("4T81O");

var $dOlMO = parcelRequire("dOlMO");
var $6400aba9425dc66d$var$springDefaults = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};
function $6400aba9425dc66d$var$calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
var $6400aba9425dc66d$var$rootIterations = 12;
function $6400aba9425dc66d$var$approximateRoot(envelope, derivative, initialGuess) {
    var result = initialGuess;
    for(var i = 1; i < $6400aba9425dc66d$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
/**
 * This is ported from the Framer implementation of duration-based spring resolution.
 */ var $6400aba9425dc66d$var$safeMin = 0.001;
function $6400aba9425dc66d$var$findSpring(param) {
    var _param_duration = param.duration, duration = _param_duration === void 0 ? $6400aba9425dc66d$var$springDefaults.duration : _param_duration, _param_bounce = param.bounce, bounce = _param_bounce === void 0 ? $6400aba9425dc66d$var$springDefaults.bounce : _param_bounce, _param_velocity = param.velocity, velocity = _param_velocity === void 0 ? $6400aba9425dc66d$var$springDefaults.velocity : _param_velocity, _param_mass = param.mass, mass = _param_mass === void 0 ? $6400aba9425dc66d$var$springDefaults.mass : _param_mass;
    var envelope;
    var derivative;
    (0, $8FnrH.warning)(duration <= (0, $8wJkX.secondsToMilliseconds)($6400aba9425dc66d$var$springDefaults.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    var dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $4ceSY.clamp)($6400aba9425dc66d$var$springDefaults.minDamping, $6400aba9425dc66d$var$springDefaults.maxDamping, dampingRatio);
    duration = (0, $4ceSY.clamp)($6400aba9425dc66d$var$springDefaults.minDuration, $6400aba9425dc66d$var$springDefaults.maxDuration, (0, $8wJkX.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var a = exponentialDecay - velocity;
            var b = $6400aba9425dc66d$var$calcAngularFreq(undampedFreq, dampingRatio);
            var c = Math.exp(-delta);
            return $6400aba9425dc66d$var$safeMin - a / b * c;
        };
        derivative = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var d = delta * velocity + velocity;
            var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            var f = Math.exp(-delta);
            var g = $6400aba9425dc66d$var$calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            var factor = -envelope(undampedFreq) + $6400aba9425dc66d$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (undampedFreq - velocity) * duration + 1;
            return -$6400aba9425dc66d$var$safeMin + a * b;
        };
        derivative = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    var initialGuess = 5 / duration;
    var undampedFreq = $6400aba9425dc66d$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $8wJkX.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: $6400aba9425dc66d$var$springDefaults.stiffness,
        damping: $6400aba9425dc66d$var$springDefaults.damping,
        duration: duration
    };
    else {
        var stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
var $6400aba9425dc66d$var$durationKeys = [
    "duration",
    "bounce"
];
var $6400aba9425dc66d$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $6400aba9425dc66d$var$isSpringType(options, keys) {
    return keys.some(function(key) {
        return options[key] !== undefined;
    });
}
function $6400aba9425dc66d$var$getSpringOptions(options) {
    var springOptions = (0, $kWfK0._)({
        velocity: $6400aba9425dc66d$var$springDefaults.velocity,
        stiffness: $6400aba9425dc66d$var$springDefaults.stiffness,
        damping: $6400aba9425dc66d$var$springDefaults.damping,
        mass: $6400aba9425dc66d$var$springDefaults.mass,
        isResolvedFromDuration: false
    }, options);
    // stiffness/damping/mass overrides duration/bounce
    if (!$6400aba9425dc66d$var$isSpringType(options, $6400aba9425dc66d$var$physicsKeys) && $6400aba9425dc66d$var$isSpringType(options, $6400aba9425dc66d$var$durationKeys)) {
        // Time-defined springs should ignore inherited velocity.
        // Velocity from interrupted animations can cause findSpring()
        // to compute wildly different spring parameters, leading to
        // massive oscillation on small-range animations.
        springOptions.velocity = 0;
        if (options.visualDuration) {
            var visualDuration = options.visualDuration;
            var root = 2 * Math.PI / (visualDuration * 1.2);
            var stiffness = root * root;
            var damping = 2 * (0, $4ceSY.clamp)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = (0, $hApvp._)((0, $kWfK0._)({}, springOptions), {
                mass: $6400aba9425dc66d$var$springDefaults.mass,
                stiffness: stiffness,
                damping: damping
            });
        } else {
            var derived = $6400aba9425dc66d$var$findSpring((0, $hApvp._)((0, $kWfK0._)({}, options), {
                velocity: 0
            }));
            springOptions = (0, $hApvp._)((0, $kWfK0._)({}, springOptions, derived), {
                mass: $6400aba9425dc66d$var$springDefaults.mass
            });
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $6400aba9425dc66d$export$b36281d89752ae66() {
    var optionsOrVisualDuration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $6400aba9425dc66d$var$springDefaults.visualDuration, bounce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $6400aba9425dc66d$var$springDefaults.bounce;
    var options = (typeof optionsOrVisualDuration === "undefined" ? "undefined" : (0, $5djcY._)(optionsOrVisualDuration)) !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    var restSpeed = options.restSpeed, restDelta = options.restDelta;
    var origin = options.keyframes[0];
    var target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ var state = {
        done: false,
        value: origin
    };
    var _getSpringOptions = $6400aba9425dc66d$var$getSpringOptions((0, $hApvp._)((0, $kWfK0._)({}, options), {
        velocity: -(0, $8wJkX.millisecondsToSeconds)(options.velocity || 0)
    })), stiffness = _getSpringOptions.stiffness, damping = _getSpringOptions.damping, mass = _getSpringOptions.mass, duration = _getSpringOptions.duration, velocity = _getSpringOptions.velocity, isResolvedFromDuration = _getSpringOptions.isResolvedFromDuration;
    var initialVelocity = velocity || 0.0;
    var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    var initialDelta = target - origin;
    var undampedAngularFreq = (0, $8wJkX.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ var isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? $6400aba9425dc66d$var$springDefaults.restSpeed.granular : $6400aba9425dc66d$var$springDefaults.restSpeed.default);
    restDelta || (restDelta = isGranularScale ? $6400aba9425dc66d$var$springDefaults.restDelta.granular : $6400aba9425dc66d$var$springDefaults.restDelta.default);
    var resolveSpring;
    var resolveVelocity;
    // Underdamped coefficients, hoisted for use in the inlined next() hot path
    var angularFreq;
    var A;
    var sinCoeff;
    var cosCoeff;
    if (dampingRatio < 1) {
        angularFreq = $6400aba9425dc66d$var$calcAngularFreq(undampedAngularFreq, dampingRatio);
        A = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq;
        // Underdamped spring
        resolveSpring = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * (A * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
        // Analytical derivative of underdamped spring (px/ms)
        sinCoeff = dampingRatio * undampedAngularFreq * A + initialDelta * angularFreq;
        cosCoeff = dampingRatio * undampedAngularFreq * initialDelta - A * angularFreq;
        resolveVelocity = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return envelope * (sinCoeff * Math.sin(angularFreq * t) + cosCoeff * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) {
        // Critically damped spring
        resolveSpring = function(t) {
            return target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        };
        // Analytical derivative of critically damped spring (px/ms)
        var C = initialVelocity + undampedAngularFreq * initialDelta;
        resolveVelocity = function(t) {
            return Math.exp(-undampedAngularFreq * t) * (undampedAngularFreq * C * t - initialVelocity);
        };
    } else {
        // Overdamped spring
        var dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            var freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
        // Analytical derivative of overdamped spring (px/ms)
        var P = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / dampedAngularFreq;
        var sinhCoeff = dampingRatio * undampedAngularFreq * P - initialDelta * dampedAngularFreq;
        var coshCoeff = dampingRatio * undampedAngularFreq * initialDelta - P * dampedAngularFreq;
        resolveVelocity = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            var freqForT = Math.min(dampedAngularFreq * t, 300);
            return envelope * (sinhCoeff * Math.sinh(freqForT) + coshCoeff * Math.cosh(freqForT));
        };
    }
    var generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        velocity: function(t) {
            return (0, $8wJkX.secondsToMilliseconds)(resolveVelocity(t));
        },
        next: function(t) {
            /**
             * For underdamped physics springs we need both position and
             * velocity each tick. Compute shared trig values once to avoid
             * duplicate Math.exp/sin/cos calls on the hot path.
             */ if (!isResolvedFromDuration && dampingRatio < 1) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                var sin = Math.sin(angularFreq * t);
                var cos = Math.cos(angularFreq * t);
                var current = target - envelope * (A * sin + initialDelta * cos);
                var currentVelocity = (0, $8wJkX.secondsToMilliseconds)(envelope * (sinCoeff * sin + cosCoeff * cos));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
                state.value = state.done ? target : current;
                return state;
            }
            var current1 = resolveSpring(t);
            if (!isResolvedFromDuration) {
                var currentVelocity1 = (0, $8wJkX.secondsToMilliseconds)(resolveVelocity(t));
                state.done = Math.abs(currentVelocity1) <= restSpeed && Math.abs(target - current1) <= restDelta;
            } else state.done = t >= duration;
            state.value = state.done ? target : current1;
            return state;
        },
        toString: function() {
            var calculatedDuration = Math.min((0, $4T81O.calcGeneratorDuration)(generator), (0, $4T81O.maxGeneratorDuration));
            var easing = (0, $1iHAC.generateLinearEasing)(function(progress) {
                return generator.next(calculatedDuration * progress).value;
            }, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: function() {}
    };
    return generator;
}
$6400aba9425dc66d$export$b36281d89752ae66.applyToOptions = function(options) {
    var generatorOptions = (0, $dOlMO.createGeneratorEasing)(options, 100, $6400aba9425dc66d$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $8wJkX.secondsToMilliseconds)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};

});
parcelRegister("4T81O", function(module, exports) {

$parcel$export(module.exports, "maxGeneratorDuration", function () { return $85c28b61866144dd$export$f4ff70a5b4808fd8; });
$parcel$export(module.exports, "calcGeneratorDuration", function () { return $85c28b61866144dd$export$cbdd6b3d40ea54e2; });
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ var $85c28b61866144dd$export$f4ff70a5b4808fd8 = 20000;
function $85c28b61866144dd$export$cbdd6b3d40ea54e2(generator) {
    var duration = 0;
    var timeStep = 50;
    var state = generator.next(duration);
    while(!state.done && duration < $85c28b61866144dd$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $85c28b61866144dd$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});

parcelRegister("dOlMO", function(module, exports) {

$parcel$export(module.exports, "createGeneratorEasing", function () { return $509c3e019cd11439$export$7f1511d09ee75a99; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $8wJkX = parcelRequire("8wJkX");

var $4T81O = parcelRequire("4T81O");
/**
 * Create a progress => progress easing function from a generator.
 */ function $509c3e019cd11439$export$7f1511d09ee75a99(options) {
    var scale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, createGenerator = arguments.length > 2 ? arguments[2] : void 0;
    var generator = createGenerator((0, $hApvp._)((0, $kWfK0._)({}, options), {
        keyframes: [
            0,
            scale
        ]
    }));
    var duration = Math.min((0, $4T81O.calcGeneratorDuration)(generator), (0, $4T81O.maxGeneratorDuration));
    return {
        type: "keyframes",
        ease: function(progress) {
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $8wJkX.millisecondsToSeconds)(duration)
    };
}

});


parcelRegister("gl5UY", function(module, exports) {

$parcel$export(module.exports, "getGeneratorVelocity", function () { return $b4f1cc7e051d5a9c$export$279c5e002bb29070; });

var $dVjOS = parcelRequire("dVjOS");
var $b4f1cc7e051d5a9c$var$velocitySampleDuration = 5; // ms
function $b4f1cc7e051d5a9c$export$279c5e002bb29070(resolveValue, t, current) {
    var prevT = Math.max(t - $b4f1cc7e051d5a9c$var$velocitySampleDuration, 0);
    return (0, $dVjOS.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});


parcelRegister("lVcPj", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $080f8745aee1f1b7$export$d25ddfdf17c3ad3e; });

var $iPfEp = parcelRequire("iPfEp");
var $iq30R = parcelRequire("iq30R");
var $alL4I = parcelRequire("alL4I");

var $l7zl4 = parcelRequire("l7zl4");

var $3xdMZ = parcelRequire("3xdMZ");

var $iXHuq = parcelRequire("iXHuq");
function $080f8745aee1f1b7$export$6b60b58e4ea7d715(values, easing) {
    return values.map(function() {
        return easing || (0, $iPfEp.easeInOut);
    }).splice(0, values.length - 1);
}
function $080f8745aee1f1b7$export$d25ddfdf17c3ad3e(param) {
    var _param_duration = param.duration, duration = _param_duration === void 0 ? 300 : _param_duration, keyframeValues = param.keyframes, times = param.times, _param_ease = param.ease, ease = _param_ease === void 0 ? "easeInOut" : _param_ease;
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ var easingFunctions = (0, $alL4I.isEasingArray)(ease) ? ease.map((0, $iq30R.easingDefinitionToFunction)) : (0, $iq30R.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ var state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ var absoluteTimes = (0, $iXHuq.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $3xdMZ.defaultOffset)(keyframeValues), duration);
    var mapTimeToKeyframe = (0, $l7zl4.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $080f8745aee1f1b7$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: function(t) {
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("iPfEp", function(module, exports) {

$parcel$export(module.exports, "easeIn", function () { return $593ec72d511ff552$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $593ec72d511ff552$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $593ec72d511ff552$export$c07234257a03d5e9; });

var $xmDzF = parcelRequire("xmDzF");
var $593ec72d511ff552$export$929e5a82286172a6 = /*@__PURE__*/ (0, $xmDzF.cubicBezier)(0.42, 0, 1, 1);
var $593ec72d511ff552$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $xmDzF.cubicBezier)(0, 0, 0.58, 1);
var $593ec72d511ff552$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $xmDzF.cubicBezier)(0.42, 0, 0.58, 1);

});
parcelRegister("xmDzF", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $6f54b7457ea3c21b$export$2c575fa1d20488bd; });

var $386Yo = parcelRequire("386Yo");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
var $6f54b7457ea3c21b$var$calcBezier = function(t, a1, a2) {
    return (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
};
var $6f54b7457ea3c21b$var$subdivisionPrecision = 0.0000001;
var $6f54b7457ea3c21b$var$subdivisionMaxIterations = 12;
function $6f54b7457ea3c21b$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    var currentX;
    var currentT;
    var i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $6f54b7457ea3c21b$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $6f54b7457ea3c21b$var$subdivisionPrecision && ++i < $6f54b7457ea3c21b$var$subdivisionMaxIterations);
    return currentT;
}
/*#__NO_SIDE_EFFECTS__*/ function $6f54b7457ea3c21b$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $386Yo.noop;
    var getTForX = function(aX) {
        return $6f54b7457ea3c21b$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    };
    // If animation is at start/end, return t without easing
    return function(t) {
        return t === 0 || t === 1 ? t : $6f54b7457ea3c21b$var$calcBezier(getTForX(t), mY1, mY2);
    };
}

});


parcelRegister("iq30R", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $4e94ad421a1537ff$export$ef97fe084f156ca4; });

var $6ZpBv = parcelRequire("6ZpBv");

var $8FnrH = parcelRequire("8FnrH");

var $386Yo = parcelRequire("386Yo");

var $3hytw = parcelRequire("3hytw");

var $9RsJC = parcelRequire("9RsJC");

var $6XAIX = parcelRequire("6XAIX");

var $xmDzF = parcelRequire("xmDzF");

var $iPfEp = parcelRequire("iPfEp");

var $9059e = parcelRequire("9059e");
var $4e94ad421a1537ff$var$easingLookup = {
    linear: (0, $386Yo.noop),
    easeIn: (0, $iPfEp.easeIn),
    easeInOut: (0, $iPfEp.easeInOut),
    easeOut: (0, $iPfEp.easeOut),
    circIn: (0, $6XAIX.circIn),
    circInOut: (0, $6XAIX.circInOut),
    circOut: (0, $6XAIX.circOut),
    backIn: (0, $9RsJC.backIn),
    backInOut: (0, $9RsJC.backInOut),
    backOut: (0, $9RsJC.backOut),
    anticipate: (0, $3hytw.anticipate)
};
var $4e94ad421a1537ff$var$isValidEasing = function(easing) {
    return typeof easing === "string";
};
var $4e94ad421a1537ff$export$ef97fe084f156ca4 = function(definition) {
    if ((0, $9059e.isBezierDefinition)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $8FnrH.invariant)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
        var _definition = (0, $6ZpBv._)(definition, 4), x1 = _definition[0], y1 = _definition[1], x2 = _definition[2], y2 = _definition[3];
        return (0, $xmDzF.cubicBezier)(x1, y1, x2, y2);
    } else if ($4e94ad421a1537ff$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $8FnrH.invariant)($4e94ad421a1537ff$var$easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"), "invalid-easing-type");
        return $4e94ad421a1537ff$var$easingLookup[definition];
    }
    return definition;
};

});
parcelRegister("3hytw", function(module, exports) {

$parcel$export(module.exports, "anticipate", function () { return $dd66ca0f3c433fb7$export$6b0af63b873d419e; });

var $9RsJC = parcelRequire("9RsJC");
var $dd66ca0f3c433fb7$export$6b0af63b873d419e = function(p) {
    return p >= 1 ? 1 : (p *= 2) < 1 ? 0.5 * (0, $9RsJC.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};

});
parcelRegister("9RsJC", function(module, exports) {

$parcel$export(module.exports, "backOut", function () { return $4915c11b84ee9059$export$77edfce482316a60; });
$parcel$export(module.exports, "backIn", function () { return $4915c11b84ee9059$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backInOut", function () { return $4915c11b84ee9059$export$ddc5fd596f6c71b2; });

var $xmDzF = parcelRequire("xmDzF");

var $lt9ia = parcelRequire("lt9ia");

var $cZ6iT = parcelRequire("cZ6iT");
var $4915c11b84ee9059$export$77edfce482316a60 = /*@__PURE__*/ (0, $xmDzF.cubicBezier)(0.33, 1.53, 0.69, 0.99);
var $4915c11b84ee9059$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $cZ6iT.reverseEasing)($4915c11b84ee9059$export$77edfce482316a60);
var $4915c11b84ee9059$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $lt9ia.mirrorEasing)($4915c11b84ee9059$export$b01116c84cdfe1a2);

});
parcelRegister("lt9ia", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", function () { return $2d9a8f556ef3872d$export$f946554fb8aeaf0d; });
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
/*#__NO_SIDE_EFFECTS__*/ var $2d9a8f556ef3872d$export$f946554fb8aeaf0d = function(easing) {
    return function(p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};

});

parcelRegister("cZ6iT", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $7fb43c4373d99679$export$2c07eeff45156d4d; });
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
/*#__NO_SIDE_EFFECTS__*/ var $7fb43c4373d99679$export$2c07eeff45156d4d = function(easing) {
    return function(p) {
        return 1 - easing(1 - p);
    };
};

});



parcelRegister("6XAIX", function(module, exports) {

$parcel$export(module.exports, "circIn", function () { return $debb9be549a4df7d$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $debb9be549a4df7d$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $debb9be549a4df7d$export$30d3455eee55bed5; });

var $lt9ia = parcelRequire("lt9ia");

var $cZ6iT = parcelRequire("cZ6iT");
var $debb9be549a4df7d$export$e444123e42d03385 = function(p) {
    return 1 - Math.sin(Math.acos(p));
};
var $debb9be549a4df7d$export$c8d67a19199d1a50 = (0, $cZ6iT.reverseEasing)($debb9be549a4df7d$export$e444123e42d03385);
var $debb9be549a4df7d$export$30d3455eee55bed5 = (0, $lt9ia.mirrorEasing)($debb9be549a4df7d$export$e444123e42d03385);

});


parcelRegister("alL4I", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", function () { return $2c0d42011e752151$export$216948827bbdc797; });
/*#__NO_SIDE_EFFECTS__*/ var $2c0d42011e752151$export$216948827bbdc797 = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});

parcelRegister("l7zl4", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $b733c5337e5fa137$export$89e29e4ab65e70a9; });

var $jlUaU = parcelRequire("jlUaU");

var $4ceSY = parcelRequire("4ceSY");
var $8FnrH = parcelRequire("8FnrH");
var $beX9F = parcelRequire("beX9F");
var $386Yo = parcelRequire("386Yo");
var $5Hogw = parcelRequire("5Hogw");
var $brqzr = parcelRequire("brqzr");

var $jIkoR = parcelRequire("jIkoR");
function $b733c5337e5fa137$var$createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || (0, $beX9F.MotionGlobalConfig).mix || (0, $jIkoR.mix);
    var numMixers = output.length - 1;
    for(var i = 0; i < numMixers; i++){
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] || (0, $386Yo.noop) : ease;
            mixer = (0, $5Hogw.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $b733c5337e5fa137$export$89e29e4ab65e70a9(input, output) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tmp = _ref.clamp, isClamp = tmp === void 0 ? true : tmp, ease = _ref.ease, mixer = _ref.mixer;
    var inputLength = input.length;
    (0, $8FnrH.invariant)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return function() {
        return output[0];
    };
    if (inputLength === 2 && output[0] === output[1]) return function() {
        return output[1];
    };
    var isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = (0, $jlUaU._)(input).reverse();
        output = (0, $jlUaU._)(output).reverse();
    }
    var mixers = $b733c5337e5fa137$var$createMixers(output, ease, mixer);
    var numMixers = mixers.length;
    var interpolator = function(v) {
        if (isZeroDeltaRange && v < input[0]) return output[0];
        var i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        var progressInRange = (0, $brqzr.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? function(v) {
        return interpolator((0, $4ceSY.clamp)(input[0], input[inputLength - 1], v));
    } : interpolator;
}

});
parcelRegister("brqzr", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $2dc83516fea3ddbf$export$504d7abb21fa8c9; });
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.
*/ /*#__NO_SIDE_EFFECTS__*/ var $2dc83516fea3ddbf$export$504d7abb21fa8c9 = function(from, to, value) {
    var range = to - from;
    return range ? (value - from) / range : 1;
};

});


parcelRegister("3xdMZ", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", function () { return $10a0b460281a0659$export$24dbcec0b26e6d9d; });

var $16mQh = parcelRequire("16mQh");
function $10a0b460281a0659$export$24dbcec0b26e6d9d(arr) {
    var offset = [
        0
    ];
    (0, $16mQh.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("16mQh", function(module, exports) {

$parcel$export(module.exports, "fillOffset", function () { return $6e94f226dd352612$export$dafee61230cf05c6; });

var $brqzr = parcelRequire("brqzr");

var $gcS1k = parcelRequire("gcS1k");
function $6e94f226dd352612$export$dafee61230cf05c6(offset, remaining) {
    var min = offset[offset.length - 1];
    for(var i = 1; i <= remaining; i++){
        var offsetProgress = (0, $brqzr.progress)(0, remaining, i);
        offset.push((0, $gcS1k.mixNumber)(min, 1, offsetProgress));
    }
}

});


parcelRegister("iXHuq", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", function () { return $2bc94295056f651d$export$2a91b4e3a4539316; });
function $2bc94295056f651d$export$2a91b4e3a4539316(offset, duration) {
    return offset.map(function(o) {
        return o * duration;
    });
}

});


parcelRegister("klo3G", function(module, exports) {

$parcel$export(module.exports, "replaceTransitionType", function () { return $d5e785826b4c88b2$export$98db6ef1242dfa2; });

var $9EfU4 = parcelRequire("9EfU4");

var $lVcPj = parcelRequire("lVcPj");

var $gVjFf = parcelRequire("gVjFf");
var $d5e785826b4c88b2$var$transitionTypeMap = {
    decay: (0, $9EfU4.inertia),
    inertia: (0, $9EfU4.inertia),
    tween: (0, $lVcPj.keyframes),
    keyframes: (0, $lVcPj.keyframes),
    spring: (0, $gVjFf.spring)
};
function $d5e785826b4c88b2$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $d5e785826b4c88b2$var$transitionTypeMap[transition.type];
}

});


parcelRegister("f27wR", function(module, exports) {

$parcel$export(module.exports, "NativeAnimationExtended", function () { return $c1a013664ba7de18$export$bd2cd6a048093d96; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $1DiK7 = parcelRequire("1DiK7");

var $4ceSY = parcelRequire("4ceSY");

var $i1wr7 = parcelRequire("i1wr7");

var $nrOms = parcelRequire("nrOms");

var $7YhfA = parcelRequire("7YhfA");

var $k2a4F = parcelRequire("k2a4F");

var $klo3G = parcelRequire("klo3G");

var $hpcLw = parcelRequire("hpcLw");
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ var $c1a013664ba7de18$var$sampleDelta = 10; //ms
var $c1a013664ba7de18$export$bd2cd6a048093d96 = /*#__PURE__*/ function(NativeAnimation) {
    "use strict";
    (0, $c2MhV._)(NativeAnimationExtended, NativeAnimation);
    function NativeAnimationExtended(options) {
        (0, $4QweW._)(this, NativeAnimationExtended);
        var _this;
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $hpcLw.replaceStringEasing)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $klo3G.replaceTransitionType)(options);
        _this = (0, $ehF45._)(this, NativeAnimationExtended, [
            options
        ]);
        /**
         * Only set startTime when the animation should autoplay.
         * Setting startTime on a paused WAAPI animation unpauses it
         * (per the WAAPI spec), which breaks autoplay: false.
         */ if (options.startTime !== undefined && options.autoplay !== false) _this.startTime = options.startTime;
        _this.options = options;
        return _this;
    }
    (0, $6hK4i._)(NativeAnimationExtended, [
        {
            /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read committed styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ key: "updateMotionValue",
            value: function updateMotionValue(value) {
                var _this_options = this.options, motionValue = _this_options.motionValue, onUpdate = _this_options.onUpdate, onComplete = _this_options.onComplete, element = _this_options.element, options = (0, $1DiK7._)(_this_options, [
                    "motionValue",
                    "onUpdate",
                    "onComplete",
                    "element"
                ]);
                if (!motionValue) return;
                if (value !== undefined) {
                    motionValue.set(value);
                    return;
                }
                var sampleAnimation = new (0, $7YhfA.JSAnimation)((0, $hApvp._)((0, $kWfK0._)({}, options), {
                    autoplay: false
                }));
                /**
         * Use wall-clock elapsed time for sampling.
         * Under CPU load, WAAPI's currentTime may not reflect actual
         * elapsed time, causing incorrect sampling and visual jumps.
         */ var sampleTime = Math.max($c1a013664ba7de18$var$sampleDelta, (0, $i1wr7.time).now() - this.startTime);
                var delta = (0, $4ceSY.clamp)(0, $c1a013664ba7de18$var$sampleDelta, sampleTime - $c1a013664ba7de18$var$sampleDelta);
                var current = sampleAnimation.sample(sampleTime).value;
                /**
         * Write the estimated value to inline style so it persists
         * after cancel(), covering the async gap before the next
         * animation starts.
         */ var name = this.options.name;
                if (element && name) (0, $nrOms.setStyle)(element, name, current);
                motionValue.setWithVelocity(sampleAnimation.sample(Math.max(0, sampleTime - delta)).value, current, delta);
                sampleAnimation.stop();
            }
        }
    ]);
    return NativeAnimationExtended;
}((0, $k2a4F.NativeAnimation));

});
parcelRegister("hpcLw", function(module, exports) {

$parcel$export(module.exports, "replaceStringEasing", function () { return $ae9cf4902b2ad344$export$5195f232c29d1f82; });

var $3hytw = parcelRequire("3hytw");
var $9RsJC = parcelRequire("9RsJC");
var $6XAIX = parcelRequire("6XAIX");
var $ae9cf4902b2ad344$var$unsupportedEasingFunctions = {
    anticipate: (0, $3hytw.anticipate),
    backInOut: (0, $9RsJC.backInOut),
    circInOut: (0, $6XAIX.circInOut)
};
function $ae9cf4902b2ad344$var$isUnsupportedEase(key) {
    return key in $ae9cf4902b2ad344$var$unsupportedEasingFunctions;
}
function $ae9cf4902b2ad344$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $ae9cf4902b2ad344$var$isUnsupportedEase(transition.ease)) transition.ease = $ae9cf4902b2ad344$var$unsupportedEasingFunctions[transition.ease];
}

});


parcelRegister("ha2sx", function(module, exports) {

$parcel$export(module.exports, "canAnimate", function () { return $e9d778cb225f3eca$export$1b109e6c9968df4f; });

var $8FnrH = parcelRequire("8FnrH");

var $kicPc = parcelRequire("kicPc");

var $9lWzX = parcelRequire("9lWzX");
function $e9d778cb225f3eca$var$hasKeyframesChanged(keyframes) {
    var current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(var i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $e9d778cb225f3eca$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ var originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    var targetKeyframe = keyframes[keyframes.length - 1];
    var isOriginAnimatable = (0, $9lWzX.isAnimatable)(originKeyframe, name);
    var isTargetAnimatable = (0, $9lWzX.isAnimatable)(targetKeyframe, name);
    (0, $8FnrH.warning)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(name, ' from "').concat(originKeyframe, '" to "').concat(targetKeyframe, '". "').concat(isOriginAnimatable ? targetKeyframe : originKeyframe, '" is not an animatable value.'), "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $e9d778cb225f3eca$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $kicPc.isGenerator)(type)) && velocity;
}

});
parcelRegister("9lWzX", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $dfa9ff5107cfe365$export$65676b58b122bc38; });

var $eyJsx = parcelRequire("eyJsx");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var $dfa9ff5107cfe365$export$65676b58b122bc38 = function(value, name) {
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $eyJsx.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});


parcelRegister("lV2DB", function(module, exports) {

$parcel$export(module.exports, "makeAnimationInstant", function () { return $c6a574950c1aa2de$export$b2585dd3c345da47; });
function $c6a574950c1aa2de$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}

});

parcelRegister("26meB", function(module, exports) {

$parcel$export(module.exports, "supportsBrowserAnimation", function () { return $4cfb1ed0a3b3c148$export$ea92bde116fda821; });

var $7y43T = parcelRequire("7y43T");

var $6LQSm = parcelRequire("6LQSm");

var $6hbdV = parcelRequire("6hbdV");
var $4cfb1ed0a3b3c148$var$colorProperties = new Set([
    "color",
    "backgroundColor",
    "outlineColor",
    "fill",
    "stroke",
    "borderColor",
    "borderTopColor",
    "borderRightColor",
    "borderBottomColor",
    "borderLeftColor"
]);
var $4cfb1ed0a3b3c148$var$supportsWaapi = /*@__PURE__*/ (0, $7y43T.memo)(function() {
    return Object.hasOwnProperty.call(Element.prototype, "animate");
});
function $4cfb1ed0a3b3c148$export$ea92bde116fda821(options) {
    var _motionValue_owner;
    var motionValue = options.motionValue, name = options.name, repeatDelay = options.repeatDelay, repeatType = options.repeatType, damping = options.damping, type = options.type, keyframes = options.keyframes;
    var subject = motionValue === null || motionValue === void 0 ? void 0 : (_motionValue_owner = motionValue.owner) === null || _motionValue_owner === void 0 ? void 0 : _motionValue_owner.current;
    /**
     * We use instanceof checks instead of isHTMLElement()/isSVGElement()
     * because we explicitly **don't** want elements in different timing
     * contexts (i.e. popups) to be accelerated, as it's not possible to sync
     * these animations properly with those driven from the main window
     * frameloop.
     */ if (!(subject instanceof HTMLElement) && !(subject instanceof SVGElement)) return false;
    var _motionValue_owner_getProps = motionValue.owner.getProps(), onUpdate = _motionValue_owner_getProps.onUpdate, transformTemplate = _motionValue_owner_getProps.transformTemplate;
    return $4cfb1ed0a3b3c148$var$supportsWaapi() && name && /**
         * Force WAAPI for color properties with browser-only color formats
         * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
         */ ((0, $6LQSm.acceleratedValues).has(name) || $4cfb1ed0a3b3c148$var$colorProperties.has(name) && (0, $6hbdV.hasBrowserOnlyColors)(keyframes)) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}

});
parcelRegister("6hbdV", function(module, exports) {

$parcel$export(module.exports, "hasBrowserOnlyColors", function () { return $73878b76f0822bbf$export$1af9e65d1501d15; });
var $73878b76f0822bbf$var$browserColorFunctions = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function $73878b76f0822bbf$export$1af9e65d1501d15(keyframes) {
    for(var i = 0; i < keyframes.length; i++){
        if (typeof keyframes[i] === "string" && $73878b76f0822bbf$var$browserColorFunctions.test(keyframes[i])) return true;
    }
    return false;
}

});



parcelRegister("lcKGj", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $7d9f1ddeeed26279$export$262124b154b9f1c0; });

var $d4bUS = parcelRequire("d4bUS");
var $7d9f1ddeeed26279$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
var $7d9f1ddeeed26279$var$criticallyDampedSpring = function(target) {
    return {
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    };
};
var $7d9f1ddeeed26279$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ var $7d9f1ddeeed26279$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
var $7d9f1ddeeed26279$export$262124b154b9f1c0 = function(valueKey, param) {
    var keyframes = param.keyframes;
    if (keyframes.length > 2) return $7d9f1ddeeed26279$var$keyframesTransition;
    else if ((0, $d4bUS.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $7d9f1ddeeed26279$var$criticallyDampedSpring(keyframes[1]) : $7d9f1ddeeed26279$var$underDampedSpring;
    return $7d9f1ddeeed26279$var$ease;
};

});

parcelRegister("aRGnK", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", function () { return $be985919c18d197d$export$ca8e47dc8ed5a9d7; });
var $be985919c18d197d$var$orchestrationKeys = new Set([
    "when",
    "delay",
    "delayChildren",
    "staggerChildren",
    "staggerDirection",
    "repeat",
    "repeatType",
    "repeatDelay",
    "from",
    "elapsed"
]);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $be985919c18d197d$export$ca8e47dc8ed5a9d7(transition) {
    for(var key in transition){
        if (!$be985919c18d197d$var$orchestrationKeys.has(key)) return true;
    }
    return false;
}

});



parcelRegister("dIGEy", function(module, exports) {

$parcel$export(module.exports, "animateVariant", function () { return $bc0ab95c6dfc2bb6$export$4709dc300705b2af; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $6ZpBv = parcelRequire("6ZpBv");

var $2uK8F = parcelRequire("2uK8F");

var $4lzx3 = parcelRequire("4lzx3");

var $bWT6d = parcelRequire("bWT6d");
function $bc0ab95c6dfc2bb6$export$4709dc300705b2af(visualElement, variant) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _visualElement_presenceContext;
    var resolved = (0, $2uK8F.resolveVariant)(visualElement, variant, options.type === "exit" ? (_visualElement_presenceContext = visualElement.presenceContext) === null || _visualElement_presenceContext === void 0 ? void 0 : _visualElement_presenceContext.custom : undefined);
    var _ref = resolved || {}, _ref_transition = _ref.transition, transition = _ref_transition === void 0 ? visualElement.getDefaultTransition() || {} : _ref_transition;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return Promise.all((0, $bWT6d.animateTarget)(visualElement, resolved, options));
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? function() {
        var forwardDelay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        var _transition_delayChildren = transition.delayChildren, delayChildren = _transition_delayChildren === void 0 ? 0 : _transition_delayChildren, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return $bc0ab95c6dfc2bb6$var$animateChildren(visualElement, variant, forwardDelay, delayChildren, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _ref1 = (0, $6ZpBv._)(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _ref1[0], last = _ref1[1];
        return first().then(function() {
            return last();
        });
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $bc0ab95c6dfc2bb6$var$animateChildren(visualElement, variant) {
    var delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, delayChildren = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, staggerChildren = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, staggerDirection = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 1, options = arguments.length > 6 ? arguments[6] : void 0;
    var animations = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var child = _step.value;
            child.notify("AnimationStart", variant);
            animations.push($bc0ab95c6dfc2bb6$export$4709dc300705b2af(child, variant, (0, $hApvp._)((0, $kWfK0._)({}, options), {
                delay: delay + (typeof delayChildren === "function" ? 0 : delayChildren) + (0, $4lzx3.calcChildStagger)(visualElement.variantChildren, child, delayChildren, staggerChildren, staggerDirection)
            })).then(function() {
                return child.notify("AnimationComplete", variant);
            }));
        };
        for(var _iterator = visualElement.variantChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Promise.all(animations);
}

});
parcelRegister("4lzx3", function(module, exports) {

$parcel$export(module.exports, "calcChildStagger", function () { return $e69cfb2023abc467$export$6e01cb2cb232d79b; });
function $e69cfb2023abc467$export$6e01cb2cb232d79b(children, child, delayChildren) {
    var staggerChildren = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, staggerDirection = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1;
    var index = Array.from(children).sort(function(a, b) {
        return a.sortNodePosition(b);
    }).indexOf(child);
    var numChildren = children.size;
    var maxStaggerDuration = (numChildren - 1) * staggerChildren;
    var delayIsFunction = typeof delayChildren === "function";
    return delayIsFunction ? delayChildren(index, numChildren) : staggerDirection === 1 ? index * staggerChildren : maxStaggerDuration - index * staggerChildren;
}

});



parcelRegister("6N7qi", function(module, exports) {

$parcel$export(module.exports, "getVariantContext", function () { return $aaa2c4c7d152fda6$export$6669f52f7ffa343b; });

var $e5exQ = parcelRequire("e5exQ");

var $51Z5p = parcelRequire("51Z5p");
var $aaa2c4c7d152fda6$var$numVariantProps = (0, $51Z5p.variantProps).length;
/**
 * Get variant context from a visual element's parent chain.
 * Uses `any` type for visualElement to avoid circular dependencies.
 */ function $aaa2c4c7d152fda6$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        var context = visualElement.parent ? $aaa2c4c7d152fda6$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    var context1 = {};
    for(var i = 0; i < $aaa2c4c7d152fda6$var$numVariantProps; i++){
        var name = (0, $51Z5p.variantProps)[i];
        var prop = visualElement.props[name];
        if ((0, $e5exQ.isVariantLabel)(prop) || prop === false) context1[name] = prop;
    }
    return context1;
}

});

parcelRegister("kOzWk", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", function () { return $4c5065c7189230aa$export$90e866afbd6b9f1a; });
function $4c5065c7189230aa$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});


parcelRegister("ledP3", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return $ffdf413a9d99b741$export$6e91cf7616333d5; });
/**
 * Feature base class for extending VisualElement functionality.
 * Features are plugins that can be mounted/unmounted to add behavior
 * like gestures, animations, or layout tracking.
 */ 
var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");
var $ffdf413a9d99b741$export$6e91cf7616333d5 = /*#__PURE__*/ function() {
    "use strict";
    function Feature(node) {
        (0, $4QweW._)(this, Feature);
        this.isMounted = false;
        this.node = node;
    }
    (0, $6hK4i._)(Feature, [
        {
            key: "update",
            value: function update() {}
        }
    ]);
    return Feature;
}();

});


parcelRegister("1DKqI", function(module, exports) {

$parcel$export(module.exports, "ExitAnimationFeature", function () { return $4adffd10c3750828$export$4989d1eb6104cc6c; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $1DiK7 = parcelRequire("1DiK7");

var $5djcY = parcelRequire("5djcY");

var $ledP3 = parcelRequire("ledP3");
var $2uK8F = parcelRequire("2uK8F");
var $4adffd10c3750828$var$id = 0;
var $4adffd10c3750828$export$4989d1eb6104cc6c = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $c2MhV._)(ExitAnimationFeature, Feature);
    function ExitAnimationFeature() {
        (0, $4QweW._)(this, ExitAnimationFeature);
        var _this;
        _this = (0, $ehF45._)(this, ExitAnimationFeature, arguments);
        _this.id = $4adffd10c3750828$var$id++;
        _this.isExitComplete = false;
        return _this;
    }
    (0, $6hK4i._)(ExitAnimationFeature, [
        {
            key: "update",
            value: function update() {
                var _this = this;
                if (!this.node.presenceContext) return;
                var _this_node_presenceContext = this.node.presenceContext, isPresent = _this_node_presenceContext.isPresent, onExitComplete = _this_node_presenceContext.onExitComplete;
                var _ref = this.node.prevPresenceContext || {}, prevIsPresent = _ref.isPresent;
                if (!this.node.animationState || isPresent === prevIsPresent) return;
                if (isPresent && prevIsPresent === false) {
                    /**
             * When re-entering, if the exit animation already completed
             * (element is at rest), reset to initial values so the enter
             * animation replays from the correct position.
             */ if (this.isExitComplete) {
                        var _this_node_getProps = this.node.getProps(), initial = _this_node_getProps.initial, custom = _this_node_getProps.custom;
                        if (typeof initial === "string" || (typeof initial === "undefined" ? "undefined" : (0, $5djcY._)(initial)) === "object" && initial !== null && !Array.isArray(initial)) {
                            var resolved = (0, $2uK8F.resolveVariant)(this.node, initial, custom);
                            if (resolved) {
                                var _this_node_getValue;
                                var transition = resolved.transition, transitionEnd = resolved.transitionEnd, target = (0, $1DiK7._)(resolved, [
                                    "transition",
                                    "transitionEnd"
                                ]);
                                for(var key in target)(_this_node_getValue = this.node.getValue(key)) === null || _this_node_getValue === void 0 ? void 0 : _this_node_getValue.jump(target[key]);
                            }
                        }
                        this.node.animationState.reset();
                        this.node.animationState.animateChanges();
                    } else this.node.animationState.setActive("exit", false);
                    this.isExitComplete = false;
                    return;
                }
                var exitAnimation = this.node.animationState.setActive("exit", !isPresent);
                if (onExitComplete && !isPresent) exitAnimation.then(function() {
                    _this.isExitComplete = true;
                    onExitComplete(_this.id);
                });
            }
        },
        {
            key: "mount",
            value: function mount() {
                var _ref = this.node.presenceContext || {}, register = _ref.register, onExitComplete = _ref.onExitComplete;
                if (onExitComplete) onExitComplete(this.id);
                if (register) this.unmount = register(this.id);
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return ExitAnimationFeature;
}((0, $ledP3.Feature));

});


parcelRegister("iOlxx", function(module, exports) {

$parcel$export(module.exports, "drag", function () { return $7de33889caa15546$export$d7d5d435647ed5a0; });

var $6kPd5 = parcelRequire("6kPd5");

var $hHCtc = parcelRequire("hHCtc");

var $gQoGI = parcelRequire("gQoGI");

var $40ppk = parcelRequire("40ppk");
var $7de33889caa15546$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $hHCtc.PanGesture)
    },
    drag: {
        Feature: (0, $6kPd5.DragGesture),
        ProjectionNode: (0, $40ppk.HTMLProjectionNode),
        MeasureLayout: (0, $gQoGI.MeasureLayout)
    }
};

});
parcelRegister("6kPd5", function(module, exports) {

$parcel$export(module.exports, "DragGesture", function () { return $f3e30ef24f7e33ce$export$5d97dc2872682820; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $ledP3 = parcelRequire("ledP3");

var $386Yo = parcelRequire("386Yo");

var $1ZO3p = parcelRequire("1ZO3p");
var $f3e30ef24f7e33ce$export$5d97dc2872682820 = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $c2MhV._)(DragGesture, Feature);
    function DragGesture(node) {
        (0, $4QweW._)(this, DragGesture);
        var _this;
        _this = (0, $ehF45._)(this, DragGesture, [
            node
        ]);
        _this.removeGroupControls = (0, $386Yo.noop);
        _this.removeListeners = (0, $386Yo.noop);
        _this.controls = new (0, $1ZO3p.VisualElementDragControls)(node);
        return _this;
    }
    (0, $6hK4i._)(DragGesture, [
        {
            key: "mount",
            value: function mount() {
                // If we've been provided a DragControls for manual control over the drag gesture,
                // subscribe this component to it on mount.
                var dragControls = this.node.getProps().dragControls;
                if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
                this.removeListeners = this.controls.addListeners() || (0, $386Yo.noop);
            }
        },
        {
            key: "update",
            value: function update() {
                var dragControls = this.node.getProps().dragControls;
                var _ref = this.node.prevProps || {}, prevDragControls = _ref.dragControls;
                if (dragControls !== prevDragControls) {
                    this.removeGroupControls();
                    if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
                }
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                this.removeGroupControls();
                this.removeListeners();
                /**
         * In React 19, during list reorder reconciliation, components may
         * briefly unmount and remount while the drag is still active. If we're
         * actively dragging, we should NOT end the pan session - it will
         * continue tracking pointer events via its window-level listeners.
         *
         * The pan session will be properly cleaned up when:
         * 1. The drag ends naturally (pointerup/pointercancel)
         * 2. The component is truly removed from the DOM
         */ if (!this.controls.isDragging) this.controls.endPanSession();
            }
        }
    ]);
    return DragGesture;
}((0, $ledP3.Feature));

});
parcelRegister("1ZO3p", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", function () { return $8c20a74abb330703$export$86bff71f18910307; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $gdlUx = parcelRequire("gdlUx");
var $fvijA = parcelRequire("fvijA");
var $6addk = parcelRequire("6addk");
var $7uBfQ = parcelRequire("7uBfQ");
var $bidYk = parcelRequire("bidYk");
var $fQu9K = parcelRequire("fQu9K");
var $90ti6 = parcelRequire("90ti6");
var $dbdHF = parcelRequire("dbdHF");
var $5g9nM = parcelRequire("5g9nM");
var $gpPFl = parcelRequire("gpPFl");
var $gcS1k = parcelRequire("gcS1k");
var $huIQG = parcelRequire("huIQG");
var $8C7sU = parcelRequire("8C7sU");
var $1hhV8 = parcelRequire("1hhV8");

var $8FnrH = parcelRequire("8FnrH");

var $6d4Ki = parcelRequire("6d4Ki");

var $4WE5h = parcelRequire("4WE5h");

var $f7KXA = parcelRequire("f7KXA");

var $iXA5j = parcelRequire("iXA5j");

var $eCtR0 = parcelRequire("eCtR0");

var $3T9di = parcelRequire("3T9di");
var $8c20a74abb330703$export$f0a15892c27dc07c = new WeakMap();
var $8c20a74abb330703$export$86bff71f18910307 = /*#__PURE__*/ function() {
    "use strict";
    function VisualElementDragControls(visualElement) {
        (0, $4QweW._)(this, VisualElementDragControls);
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $fQu9K.createBox)();
        /**
         * The latest pointer event. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPointerEvent = null;
        /**
         * The latest pan info. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPanInfo = null;
        this.visualElement = visualElement;
    }
    (0, $6hK4i._)(VisualElementDragControls, [
        {
            key: "start",
            value: function start(originEvent) {
                var _this = this;
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_snapToCursor = _ref.snapToCursor, snapToCursor = _ref_snapToCursor === void 0 ? false : _ref_snapToCursor, distanceThreshold = _ref.distanceThreshold;
                /**
         * Don't start dragging if this component is exiting
         */ var presenceContext = this.visualElement.presenceContext;
                if (presenceContext && presenceContext.isPresent === false) return;
                var onSessionStart = function(event) {
                    if (snapToCursor) _this.snapToCursor((0, $4WE5h.extractEventInfo)(event).point);
                    _this.stopAnimation();
                };
                var onStart = function(event, info) {
                    // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
                    var _this_getProps = _this.getProps(), drag = _this_getProps.drag, dragPropagation = _this_getProps.dragPropagation, onDragStart = _this_getProps.onDragStart;
                    if (drag && !dragPropagation) {
                        if (_this.openDragLock) _this.openDragLock();
                        _this.openDragLock = (0, $1hhV8.setDragLock)(drag);
                        // If we don 't have the lock, don't start dragging
                        if (!_this.openDragLock) return;
                    }
                    _this.latestPointerEvent = event;
                    _this.latestPanInfo = info;
                    _this.isDragging = true;
                    _this.currentDirection = null;
                    _this.resolveConstraints();
                    if (_this.visualElement.projection) {
                        _this.visualElement.projection.isAnimationBlocked = true;
                        _this.visualElement.projection.target = undefined;
                    }
                    /**
             * Record gesture origin and pointer offset
             */ (0, $90ti6.eachAxis)(function(axis) {
                        var current = _this.getAxisMotionValue(axis).get() || 0;
                        /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $huIQG.percent).test(current)) {
                            var projection = _this.visualElement.projection;
                            if (projection && projection.layout) {
                                var measuredAxis = projection.layout.layoutBox[axis];
                                if (measuredAxis) {
                                    var length = (0, $7uBfQ.calcLength)(measuredAxis);
                                    current = length * (parseFloat(current) / 100);
                                }
                            }
                        }
                        _this.originPoint[axis] = current;
                    });
                    // Fire onDragStart event
                    if (onDragStart) (0, $dbdHF.frame).update(function() {
                        return onDragStart(event, info);
                    }, false, true);
                    (0, $fvijA.addValueToWillChange)(_this.visualElement, "transform");
                    var animationState = _this.visualElement.animationState;
                    animationState && animationState.setActive("whileDrag", true);
                };
                var onMove = function(event, info) {
                    _this.latestPointerEvent = event;
                    _this.latestPanInfo = info;
                    var _this_getProps = _this.getProps(), dragPropagation = _this_getProps.dragPropagation, dragDirectionLock = _this_getProps.dragDirectionLock, onDirectionLock = _this_getProps.onDirectionLock, onDrag = _this_getProps.onDrag;
                    // If we didn't successfully receive the gesture lock, early return.
                    if (!dragPropagation && !_this.openDragLock) return;
                    var offset = info.offset;
                    // Attempt to detect drag direction if directionLock is true
                    if (dragDirectionLock && _this.currentDirection === null) {
                        _this.currentDirection = $8c20a74abb330703$var$getCurrentDirection(offset);
                        // If we've successfully set a direction, notify listener
                        if (_this.currentDirection !== null) onDirectionLock && onDirectionLock(_this.currentDirection);
                        return;
                    }
                    // Update each point with the latest position
                    _this.updateAxis("x", info.point, offset);
                    _this.updateAxis("y", info.point, offset);
                    /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ _this.visualElement.render();
                    /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ if (onDrag) (0, $dbdHF.frame).update(function() {
                        return onDrag(event, info);
                    }, false, true);
                };
                var onSessionEnd = function(event, info) {
                    _this.latestPointerEvent = event;
                    _this.latestPanInfo = info;
                    _this.stop(event, info);
                    _this.latestPointerEvent = null;
                    _this.latestPanInfo = null;
                };
                var resumeAnimation = function() {
                    var _this_getProps = _this.getProps(), snap = _this_getProps.dragSnapToOrigin;
                    if (snap || _this.constraints) _this.startAnimation({
                        x: 0,
                        y: 0
                    });
                };
                var dragSnapToOrigin = this.getProps().dragSnapToOrigin;
                this.panSession = new (0, $eCtR0.PanSession)(originEvent, {
                    onSessionStart: onSessionStart,
                    onStart: onStart,
                    onMove: onMove,
                    onSessionEnd: onSessionEnd,
                    resumeAnimation: resumeAnimation
                }, {
                    transformPagePoint: this.visualElement.getTransformPagePoint(),
                    dragSnapToOrigin: dragSnapToOrigin,
                    distanceThreshold: distanceThreshold,
                    contextWindow: (0, $f7KXA.getContextWindow)(this.visualElement),
                    element: this.visualElement.current
                });
            }
        },
        {
            /**
     * @internal
     */ key: "stop",
            value: function stop(event, panInfo) {
                var finalEvent = event || this.latestPointerEvent;
                var finalPanInfo = panInfo || this.latestPanInfo;
                var isDragging = this.isDragging;
                this.cancel();
                if (!isDragging || !finalPanInfo || !finalEvent) return;
                var velocity = finalPanInfo.velocity;
                this.startAnimation(velocity);
                var onDragEnd = this.getProps().onDragEnd;
                if (onDragEnd) (0, $dbdHF.frame).postRender(function() {
                    return onDragEnd(finalEvent, finalPanInfo);
                });
            }
        },
        {
            /**
     * @internal
     */ key: "cancel",
            value: function cancel() {
                this.isDragging = false;
                var _this_visualElement = this.visualElement, projection = _this_visualElement.projection, animationState = _this_visualElement.animationState;
                if (projection) projection.isAnimationBlocked = false;
                this.endPanSession();
                var dragPropagation = this.getProps().dragPropagation;
                if (!dragPropagation && this.openDragLock) {
                    this.openDragLock();
                    this.openDragLock = null;
                }
                animationState && animationState.setActive("whileDrag", false);
            }
        },
        {
            /**
     * Clean up the pan session without modifying other drag state.
     * This is used during unmount to ensure event listeners are removed
     * without affecting projection animations or drag locks.
     * @internal
     */ key: "endPanSession",
            value: function endPanSession() {
                this.panSession && this.panSession.end();
                this.panSession = undefined;
            }
        },
        {
            key: "updateAxis",
            value: function updateAxis(axis, _point, offset) {
                var drag = this.getProps().drag;
                // If we're not dragging this axis, do an early return.
                if (!offset || !$8c20a74abb330703$var$shouldDrag(axis, drag, this.currentDirection)) return;
                var axisValue = this.getAxisMotionValue(axis);
                var next = this.originPoint[axis] + offset[axis];
                // Apply constraints
                if (this.constraints && this.constraints[axis]) next = (0, $3T9di.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
                axisValue.set(next);
            }
        },
        {
            key: "resolveConstraints",
            value: function resolveConstraints() {
                var _this = this;
                var _this_visualElement_projection;
                var _this_getProps = this.getProps(), dragConstraints = _this_getProps.dragConstraints, dragElastic = _this_getProps.dragElastic;
                var layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_this_visualElement_projection = this.visualElement.projection) === null || _this_visualElement_projection === void 0 ? void 0 : _this_visualElement_projection.layout;
                var prevConstraints = this.constraints;
                if (dragConstraints && (0, $iXA5j.isRefObject)(dragConstraints)) {
                    if (!this.constraints) this.constraints = this.resolveRefConstraints();
                } else if (dragConstraints && layout) this.constraints = (0, $3T9di.calcRelativeConstraints)(layout.layoutBox, dragConstraints);
                else this.constraints = false;
                this.elastic = (0, $3T9di.resolveDragElastic)(dragElastic);
                /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative. This only applies to relative (non-ref)
         * constraints, as ref-based constraints from calcViewportConstraints are already in the
         * correct coordinate space for the motion value transform offset.
         */ if (prevConstraints !== this.constraints && !(0, $iXA5j.isRefObject)(dragConstraints) && layout && this.constraints && !this.hasMutatedConstraints) (0, $90ti6.eachAxis)(function(axis) {
                    if (_this.constraints !== false && _this.getAxisMotionValue(axis)) _this.constraints[axis] = (0, $3T9di.rebaseAxisConstraints)(layout.layoutBox[axis], _this.constraints[axis]);
                });
            }
        },
        {
            key: "resolveRefConstraints",
            value: function resolveRefConstraints() {
                var _this_getProps = this.getProps(), constraints = _this_getProps.dragConstraints, onMeasureDragConstraints = _this_getProps.onMeasureDragConstraints;
                if (!constraints || !(0, $iXA5j.isRefObject)(constraints)) return false;
                var constraintsElement = constraints.current;
                (0, $8FnrH.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
                var projection = this.visualElement.projection;
                // TODO
                if (!projection || !projection.layout) return false;
                /**
         * Refresh the root scroll offset so the constraint's viewport box
         * translates to correct page coordinates. The scroll captured at
         * drag mount can be stale if the document was scrolled afterwards —
         * e.g. via the browser restoring scroll on refresh, or an ancestor
         * layout effect running after this element's mount (#2829).
         *
         * Clear the cached scroll first so `updateScroll` bypasses its
         * per-animationId cache and re-reads the live value.
         */ if (projection.root) {
                    projection.root.scroll = undefined;
                    projection.root.updateScroll();
                }
                var constraintsBox = (0, $gpPFl.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
                var measuredConstraints = (0, $3T9di.calcViewportConstraints)(projection.layout.layoutBox, constraintsBox);
                /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
                    var userConstraints = onMeasureDragConstraints((0, $bidYk.convertBoxToBoundingBox)(measuredConstraints));
                    this.hasMutatedConstraints = !!userConstraints;
                    if (userConstraints) measuredConstraints = (0, $bidYk.convertBoundingBoxToBox)(userConstraints);
                }
                return measuredConstraints;
            }
        },
        {
            key: "startAnimation",
            value: function startAnimation(velocity) {
                var _this = this;
                var _this_getProps = this.getProps(), drag = _this_getProps.drag, dragMomentum = _this_getProps.dragMomentum, dragElastic = _this_getProps.dragElastic, dragTransition = _this_getProps.dragTransition, dragSnapToOrigin = _this_getProps.dragSnapToOrigin, onDragTransitionEnd = _this_getProps.onDragTransitionEnd;
                var constraints = this.constraints || {};
                var momentumAnimations = (0, $90ti6.eachAxis)(function(axis) {
                    if (!$8c20a74abb330703$var$shouldDrag(axis, drag, _this.currentDirection)) return;
                    var transition = constraints && constraints[axis] || {};
                    if (dragSnapToOrigin === true || dragSnapToOrigin === axis) transition = {
                        min: 0,
                        max: 0
                    };
                    /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
                    var bounceDamping = dragElastic ? 40 : 10000000;
                    var inertia = (0, $kWfK0._)({
                        type: "inertia",
                        velocity: dragMomentum ? velocity[axis] : 0,
                        bounceStiffness: bounceStiffness,
                        bounceDamping: bounceDamping,
                        timeConstant: 750,
                        restDelta: 1,
                        restSpeed: 10
                    }, dragTransition, transition);
                    // If we're not animating on an externally-provided `MotionValue` we can use the
                    // component's animation controls which will handle interactions with whileHover (etc),
                    // otherwise we just have to animate the `MotionValue` itself.
                    return _this.startAxisValueAnimation(axis, inertia);
                });
                // Run all animations and then resolve the new drag constraints.
                return Promise.all(momentumAnimations).then(onDragTransitionEnd);
            }
        },
        {
            key: "startAxisValueAnimation",
            value: function startAxisValueAnimation(axis, transition) {
                var axisValue = this.getAxisMotionValue(axis);
                (0, $fvijA.addValueToWillChange)(this.visualElement, axis);
                return axisValue.start((0, $6addk.animateMotionValue)(axis, axisValue, 0, transition, this.visualElement, false));
            }
        },
        {
            key: "stopAnimation",
            value: function stopAnimation() {
                var _this = this;
                (0, $90ti6.eachAxis)(function(axis) {
                    return _this.getAxisMotionValue(axis).stop();
                });
            }
        },
        {
            /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ key: "getAxisMotionValue",
            value: function getAxisMotionValue(axis) {
                var dragKey = "_drag".concat(axis.toUpperCase());
                var props = this.visualElement.getProps();
                var externalMotionValue = props[dragKey];
                var _this_visualElement_latestValues_axis;
                return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (_this_visualElement_latestValues_axis = this.visualElement.latestValues[axis]) !== null && _this_visualElement_latestValues_axis !== void 0 ? _this_visualElement_latestValues_axis : 0);
            }
        },
        {
            key: "snapToCursor",
            value: function snapToCursor(point) {
                var _this = this;
                (0, $90ti6.eachAxis)(function(axis) {
                    var drag = _this.getProps().drag;
                    // If we're not dragging this axis, do an early return.
                    if (!$8c20a74abb330703$var$shouldDrag(axis, drag, _this.currentDirection)) return;
                    var projection = _this.visualElement.projection;
                    var axisValue = _this.getAxisMotionValue(axis);
                    if (projection && projection.layout) {
                        var _projection_layout_layoutBox_axis = projection.layout.layoutBox[axis], min = _projection_layout_layoutBox_axis.min, max = _projection_layout_layoutBox_axis.max;
                        /**
                 * The layout measurement includes the current transform value,
                 * so we need to add it back to get the correct snap position.
                 * This fixes an issue where elements with initial coordinates
                 * would snap to the wrong position on the first drag.
                 */ var current = axisValue.get() || 0;
                        axisValue.set(point[axis] - (0, $gcS1k.mixNumber)(min, max, 0.5) + current);
                    }
                });
            }
        },
        {
            /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ key: "scalePositionWithinConstraints",
            value: function scalePositionWithinConstraints() {
                var _this = this;
                if (!this.visualElement.current) return;
                var _this_getProps = this.getProps(), drag = _this_getProps.drag, dragConstraints = _this_getProps.dragConstraints;
                var projection = this.visualElement.projection;
                if (!(0, $iXA5j.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
                /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
                /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ var boxProgress = {
                    x: 0,
                    y: 0
                };
                (0, $90ti6.eachAxis)(function(axis) {
                    var axisValue = _this.getAxisMotionValue(axis);
                    if (axisValue && _this.constraints !== false) {
                        var latest = axisValue.get();
                        boxProgress[axis] = (0, $3T9di.calcOrigin)({
                            min: latest,
                            max: latest
                        }, _this.constraints[axis]);
                    }
                });
                /**
         * Update the layout of this element and resolve the latest drag constraints
         */ var transformTemplate = this.visualElement.getProps().transformTemplate;
                this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
                projection.root && projection.root.updateScroll();
                projection.updateLayout();
                /**
         * Reset constraints so resolveConstraints() will recalculate them
         * with the freshly measured layout rather than returning the cached value.
         */ this.constraints = false;
                this.resolveConstraints();
                /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $90ti6.eachAxis)(function(axis) {
                    if (!$8c20a74abb330703$var$shouldDrag(axis, drag, null)) return;
                    /**
             * Calculate a new transform based on the previous box progress
             */ var axisValue = _this.getAxisMotionValue(axis);
                    var _this_constraints_axis = _this.constraints[axis], min = _this_constraints_axis.min, max = _this_constraints_axis.max;
                    axisValue.set((0, $gcS1k.mixNumber)(min, max, boxProgress[axis]));
                });
                /**
         * Flush the updated transform to the DOM synchronously to prevent
         * a visual flash at the element's CSS layout position (0,0) when
         * the transform was stripped for measurement.
         */ this.visualElement.render();
            }
        },
        {
            key: "addListeners",
            value: function addListeners() {
                var _this = this;
                if (!this.visualElement.current) return;
                $8c20a74abb330703$export$f0a15892c27dc07c.set(this.visualElement, this);
                var element = this.visualElement.current;
                /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = (0, $6d4Ki.addPointerEvent)(element, "pointerdown", function(event) {
                    var _this_getProps = _this.getProps(), drag = _this_getProps.drag, _this_getProps_dragListener = _this_getProps.dragListener, dragListener = _this_getProps_dragListener === void 0 ? true : _this_getProps_dragListener;
                    var target = event.target;
                    /**
             * Only block drag if clicking on a text input child element
             * (input, textarea, select, contenteditable) where users might
             * want to select text or interact with the control.
             *
             * Buttons and links don't block drag since they don't have
             * click-and-move actions of their own.
             */ var isClickingTextInputChild = target !== element && (0, $5g9nM.isElementTextInput)(target);
                    if (drag && dragListener && !isClickingTextInputChild) _this.start(event);
                });
                /**
         * If using ref-based constraints, observe both the draggable element
         * and the constraint container for size changes via ResizeObserver.
         * Setup is deferred because dragConstraints.current is null when
         * addListeners first runs (React hasn't committed the ref yet).
         */ var stopResizeObservers;
                var measureDragConstraints = function() {
                    var dragConstraints = _this.getProps().dragConstraints;
                    if ((0, $iXA5j.isRefObject)(dragConstraints) && dragConstraints.current) {
                        _this.constraints = _this.resolveRefConstraints();
                        if (!stopResizeObservers) stopResizeObservers = $8c20a74abb330703$var$startResizeObservers(element, dragConstraints.current, function() {
                            return _this.scalePositionWithinConstraints();
                        });
                    }
                };
                var projection = this.visualElement.projection;
                var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
                if (projection && !projection.layout) {
                    projection.root && projection.root.updateScroll();
                    projection.updateLayout();
                }
                (0, $dbdHF.frame).read(measureDragConstraints);
                /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ var stopResizeListener = (0, $gdlUx.addDomEvent)(window, "resize", function() {
                    return _this.scalePositionWithinConstraints();
                });
                /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ var stopLayoutUpdateListener = projection.addEventListener("didUpdate", function(param) {
                    var delta = param.delta, hasLayoutChanged = param.hasLayoutChanged;
                    if (_this.isDragging && hasLayoutChanged) {
                        (0, $90ti6.eachAxis)(function(axis) {
                            var motionValue = _this.getAxisMotionValue(axis);
                            if (!motionValue) return;
                            _this.originPoint[axis] += delta[axis].translate;
                            motionValue.set(motionValue.get() + delta[axis].translate);
                        });
                        _this.visualElement.render();
                    }
                });
                return function() {
                    stopResizeListener();
                    stopPointerListener();
                    stopMeasureLayoutListener();
                    stopLayoutUpdateListener && stopLayoutUpdateListener();
                    stopResizeObservers && stopResizeObservers();
                };
            }
        },
        {
            key: "getProps",
            value: function getProps() {
                var props = this.visualElement.getProps();
                var _props_drag = props.drag, drag = _props_drag === void 0 ? false : _props_drag, _props_dragDirectionLock = props.dragDirectionLock, dragDirectionLock = _props_dragDirectionLock === void 0 ? false : _props_dragDirectionLock, _props_dragPropagation = props.dragPropagation, dragPropagation = _props_dragPropagation === void 0 ? false : _props_dragPropagation, _props_dragConstraints = props.dragConstraints, dragConstraints = _props_dragConstraints === void 0 ? false : _props_dragConstraints, _props_dragElastic = props.dragElastic, dragElastic = _props_dragElastic === void 0 ? (0, $3T9di.defaultElastic) : _props_dragElastic, _props_dragMomentum = props.dragMomentum, dragMomentum = _props_dragMomentum === void 0 ? true : _props_dragMomentum;
                return (0, $hApvp._)((0, $kWfK0._)({}, props), {
                    drag: drag,
                    dragDirectionLock: dragDirectionLock,
                    dragPropagation: dragPropagation,
                    dragConstraints: dragConstraints,
                    dragElastic: dragElastic,
                    dragMomentum: dragMomentum
                });
            }
        }
    ]);
    return VisualElementDragControls;
}();
function $8c20a74abb330703$var$skipFirstCall(callback) {
    var isFirst = true;
    return function() {
        if (isFirst) {
            isFirst = false;
            return;
        }
        callback();
    };
}
function $8c20a74abb330703$var$startResizeObservers(element, constraintsElement, onResize) {
    var stopElement = (0, $8C7sU.resize)(element, $8c20a74abb330703$var$skipFirstCall(onResize));
    var stopContainer = (0, $8C7sU.resize)(constraintsElement, $8c20a74abb330703$var$skipFirstCall(onResize));
    return function() {
        stopElement();
        stopContainer();
    };
}
function $8c20a74abb330703$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $8c20a74abb330703$var$getCurrentDirection(offset) {
    var lockThreshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("gdlUx", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", function () { return $1f3b701f7a52bcf5$export$b1d829ddf82884aa; });
function $1f3b701f7a52bcf5$export$b1d829ddf82884aa(target, eventName, handler) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        passive: true
    };
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler, options);
    };
}

});

parcelRegister("7uBfQ", function(module, exports) {

$parcel$export(module.exports, "calcLength", function () { return $6f0c634dc8a396d7$export$c1c127004b72a37; });
$parcel$export(module.exports, "isNear", function () { return $6f0c634dc8a396d7$export$28d0384c4b79bde2; });
$parcel$export(module.exports, "calcBoxDelta", function () { return $6f0c634dc8a396d7$export$c0d25e96fc67d310; });
$parcel$export(module.exports, "calcRelativeBox", function () { return $6f0c634dc8a396d7$export$426154f9d100f99; });
$parcel$export(module.exports, "calcRelativePosition", function () { return $6f0c634dc8a396d7$export$2785bfcc929c5650; });

var $gcS1k = parcelRequire("gcS1k");
var $6f0c634dc8a396d7$var$SCALE_PRECISION = 0.0001;
var $6f0c634dc8a396d7$var$SCALE_MIN = 1 - $6f0c634dc8a396d7$var$SCALE_PRECISION;
var $6f0c634dc8a396d7$var$SCALE_MAX = 1 + $6f0c634dc8a396d7$var$SCALE_PRECISION;
var $6f0c634dc8a396d7$var$TRANSLATE_PRECISION = 0.01;
var $6f0c634dc8a396d7$var$TRANSLATE_MIN = 0 - $6f0c634dc8a396d7$var$TRANSLATE_PRECISION;
var $6f0c634dc8a396d7$var$TRANSLATE_MAX = 0 + $6f0c634dc8a396d7$var$TRANSLATE_PRECISION;
function $6f0c634dc8a396d7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $6f0c634dc8a396d7$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $6f0c634dc8a396d7$export$e90fc1ae5e3e48ed(delta, source, target) {
    var origin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
    delta.origin = origin;
    delta.originPoint = (0, $gcS1k.mixNumber)(source.min, source.max, delta.origin);
    delta.scale = $6f0c634dc8a396d7$export$c1c127004b72a37(target) / $6f0c634dc8a396d7$export$c1c127004b72a37(source);
    delta.translate = (0, $gcS1k.mixNumber)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $6f0c634dc8a396d7$var$SCALE_MIN && delta.scale <= $6f0c634dc8a396d7$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $6f0c634dc8a396d7$var$TRANSLATE_MIN && delta.translate <= $6f0c634dc8a396d7$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $6f0c634dc8a396d7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $6f0c634dc8a396d7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $6f0c634dc8a396d7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $6f0c634dc8a396d7$export$cabef5b392704b41(target, relative, parent) {
    var anchor = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var anchorPoint = anchor ? (0, $gcS1k.mixNumber)(parent.min, parent.max, anchor) : parent.min;
    target.min = anchorPoint + relative.min;
    target.max = target.min + $6f0c634dc8a396d7$export$c1c127004b72a37(relative);
}
function $6f0c634dc8a396d7$export$426154f9d100f99(target, relative, parent, anchor) {
    $6f0c634dc8a396d7$export$cabef5b392704b41(target.x, relative.x, parent.x, anchor === null || anchor === void 0 ? void 0 : anchor.x);
    $6f0c634dc8a396d7$export$cabef5b392704b41(target.y, relative.y, parent.y, anchor === null || anchor === void 0 ? void 0 : anchor.y);
}
function $6f0c634dc8a396d7$export$ecd3d3bef81102c3(target, layout, parent) {
    var anchor = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var anchorPoint = anchor ? (0, $gcS1k.mixNumber)(parent.min, parent.max, anchor) : parent.min;
    target.min = layout.min - anchorPoint;
    target.max = target.min + $6f0c634dc8a396d7$export$c1c127004b72a37(layout);
}
function $6f0c634dc8a396d7$export$2785bfcc929c5650(target, layout, parent, anchor) {
    $6f0c634dc8a396d7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x, anchor === null || anchor === void 0 ? void 0 : anchor.x);
    $6f0c634dc8a396d7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y, anchor === null || anchor === void 0 ? void 0 : anchor.y);
}

});

parcelRegister("90ti6", function(module, exports) {

$parcel$export(module.exports, "eachAxis", function () { return $427a9f1e5d2014a0$export$b789de563eb43b1; });
function $427a9f1e5d2014a0$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

});

parcelRegister("5g9nM", function(module, exports) {

$parcel$export(module.exports, "isElementKeyboardAccessible", function () { return $0f52bf394ac34410$export$5f6976e2f961e8b7; });
$parcel$export(module.exports, "isElementTextInput", function () { return $0f52bf394ac34410$export$41e5a41992b76128; });
var $0f52bf394ac34410$var$keyboardAccessibleElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
/**
 * Checks if an element is natively keyboard accessible (focusable).
 * Used by the press gesture to determine if we need to add tabIndex.
 */ function $0f52bf394ac34410$export$5f6976e2f961e8b7(element) {
    return $0f52bf394ac34410$var$keyboardAccessibleElements.has(element.tagName) || element.isContentEditable === true;
}
var $0f52bf394ac34410$var$textInputElements = new Set([
    "INPUT",
    "SELECT",
    "TEXTAREA"
]);
/**
 * Checks if an element has text selection or direct interaction behavior
 * that should block drag gestures from starting.
 *
 * This specifically targets form controls where the user might want to select
 * text or interact with the control (e.g., sliders, dropdowns).
 *
 * Buttons and links are NOT included because they don't have click-and-move
 * actions of their own - they only respond to click events, so dragging
 * should still work when initiated from these elements.
 */ function $0f52bf394ac34410$export$41e5a41992b76128(element) {
    return $0f52bf394ac34410$var$textInputElements.has(element.tagName) || element.isContentEditable === true;
}

});

parcelRegister("8C7sU", function(module, exports) {

$parcel$export(module.exports, "resize", function () { return $341f04376ef57047$export$4380c87abf28fdf; });

var $hJdyS = parcelRequire("hJdyS");

var $u0Ci5 = parcelRequire("u0Ci5");
function $341f04376ef57047$export$4380c87abf28fdf(a, b) {
    return typeof a === "function" ? (0, $u0Ci5.resizeWindow)(a) : (0, $hJdyS.resizeElement)(a, b);
}

});
parcelRegister("hJdyS", function(module, exports) {

$parcel$export(module.exports, "resizeElement", function () { return $93261986f5c08d07$export$81a0e12ec749d682; });

var $jAGjK = parcelRequire("jAGjK");

var $6aL4O = parcelRequire("6aL4O");
var $93261986f5c08d07$var$resizeHandlers = new WeakMap();
var $93261986f5c08d07$var$observer;
var $93261986f5c08d07$var$getSize = function(borderBoxAxis, svgAxis, htmlAxis) {
    return function(target, borderBoxSize) {
        if (borderBoxSize && borderBoxSize[0]) return borderBoxSize[0][borderBoxAxis + "Size"];
        else if ((0, $jAGjK.isSVGElement)(target) && "getBBox" in target) return target.getBBox()[svgAxis];
        else return target[htmlAxis];
    };
};
var $93261986f5c08d07$var$getWidth = /*@__PURE__*/ $93261986f5c08d07$var$getSize("inline", "width", "offsetWidth");
var $93261986f5c08d07$var$getHeight = /*@__PURE__*/ $93261986f5c08d07$var$getSize("block", "height", "offsetHeight");
function $93261986f5c08d07$var$notifyTarget(param) {
    var target = param.target, borderBoxSize = param.borderBoxSize;
    var _resizeHandlers_get;
    (_resizeHandlers_get = $93261986f5c08d07$var$resizeHandlers.get(target)) === null || _resizeHandlers_get === void 0 ? void 0 : _resizeHandlers_get.forEach(function(handler) {
        handler(target, {
            get width () {
                return $93261986f5c08d07$var$getWidth(target, borderBoxSize);
            },
            get height () {
                return $93261986f5c08d07$var$getHeight(target, borderBoxSize);
            }
        });
    });
}
function $93261986f5c08d07$var$notifyAll(entries) {
    entries.forEach($93261986f5c08d07$var$notifyTarget);
}
function $93261986f5c08d07$var$createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    $93261986f5c08d07$var$observer = new ResizeObserver($93261986f5c08d07$var$notifyAll);
}
function $93261986f5c08d07$export$81a0e12ec749d682(target, handler) {
    if (!$93261986f5c08d07$var$observer) $93261986f5c08d07$var$createResizeObserver();
    var elements = (0, $6aL4O.resolveElements)(target);
    elements.forEach(function(element) {
        var elementHandlers = $93261986f5c08d07$var$resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            $93261986f5c08d07$var$resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        $93261986f5c08d07$var$observer === null || $93261986f5c08d07$var$observer === void 0 ? void 0 : $93261986f5c08d07$var$observer.observe(element);
    });
    return function() {
        elements.forEach(function(element) {
            var elementHandlers = $93261986f5c08d07$var$resizeHandlers.get(element);
            elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.delete(handler);
            if (!(elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.size)) $93261986f5c08d07$var$observer === null || $93261986f5c08d07$var$observer === void 0 ? void 0 : $93261986f5c08d07$var$observer.unobserve(element);
        });
    };
}

});
parcelRegister("jAGjK", function(module, exports) {

$parcel$export(module.exports, "isSVGElement", function () { return $397c0e87327423ab$export$17eda790a720ec57; });

var $gmphp = parcelRequire("gmphp");
/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $397c0e87327423ab$export$17eda790a720ec57(element) {
    return (0, $gmphp.isObject)(element) && "ownerSVGElement" in element;
}

});

parcelRegister("6aL4O", function(module, exports) {

$parcel$export(module.exports, "resolveElements", function () { return $8377963ffbd9dcc2$export$90ceba2564a894f8; });
function $8377963ffbd9dcc2$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector == null) return [];
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        var root = document;
        if (scope) root = scope.current;
        var _selectorCache_elementOrSelector;
        var elements = (_selectorCache_elementOrSelector = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _selectorCache_elementOrSelector !== void 0 ? _selectorCache_elementOrSelector : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector).filter(function(element) {
        return element != null;
    });
}

});


parcelRegister("u0Ci5", function(module, exports) {

$parcel$export(module.exports, "resizeWindow", function () { return $cf348c708f08802e$export$7fc81011b72cd94d; });
var $cf348c708f08802e$var$windowCallbacks = new Set();
var $cf348c708f08802e$var$windowResizeHandler;
function $cf348c708f08802e$var$createWindowResizeHandler() {
    $cf348c708f08802e$var$windowResizeHandler = function() {
        var info = {
            get width () {
                return window.innerWidth;
            },
            get height () {
                return window.innerHeight;
            }
        };
        $cf348c708f08802e$var$windowCallbacks.forEach(function(callback) {
            return callback(info);
        });
    };
    window.addEventListener("resize", $cf348c708f08802e$var$windowResizeHandler);
}
function $cf348c708f08802e$export$7fc81011b72cd94d(callback) {
    $cf348c708f08802e$var$windowCallbacks.add(callback);
    if (!$cf348c708f08802e$var$windowResizeHandler) $cf348c708f08802e$var$createWindowResizeHandler();
    return function() {
        $cf348c708f08802e$var$windowCallbacks.delete(callback);
        if (!$cf348c708f08802e$var$windowCallbacks.size && typeof $cf348c708f08802e$var$windowResizeHandler === "function") {
            window.removeEventListener("resize", $cf348c708f08802e$var$windowResizeHandler);
            $cf348c708f08802e$var$windowResizeHandler = undefined;
        }
    };
}

});


parcelRegister("1hhV8", function(module, exports) {

$parcel$export(module.exports, "setDragLock", function () { return $3ec74dbc8fe9332b$export$64d8a3fd7eb621d5; });

var $lxJgL = parcelRequire("lxJgL");
function $3ec74dbc8fe9332b$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $lxJgL.isDragging)[axis]) return null;
        else {
            (0, $lxJgL.isDragging)[axis] = true;
            return function() {
                (0, $lxJgL.isDragging)[axis] = false;
            };
        }
    } else {
        if ((0, $lxJgL.isDragging).x || (0, $lxJgL.isDragging).y) return null;
        else {
            (0, $lxJgL.isDragging).x = (0, $lxJgL.isDragging).y = true;
            return function() {
                (0, $lxJgL.isDragging).x = (0, $lxJgL.isDragging).y = false;
            };
        }
    }
}

});
parcelRegister("lxJgL", function(module, exports) {

$parcel$export(module.exports, "isDragging", function () { return $ee6b662cb6d8b431$export$9e9bc3c487fccc00; });
$parcel$export(module.exports, "isDragActive", function () { return $ee6b662cb6d8b431$export$1b3dd616664938e4; });
var $ee6b662cb6d8b431$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $ee6b662cb6d8b431$export$1b3dd616664938e4() {
    return $ee6b662cb6d8b431$export$9e9bc3c487fccc00.x || $ee6b662cb6d8b431$export$9e9bc3c487fccc00.y;
}

});


parcelRegister("6d4Ki", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", function () { return $dfb38ee9a8260a81$export$fcff2e64e6676b81; });

var $gdlUx = parcelRequire("gdlUx");

var $4WE5h = parcelRequire("4WE5h");
function $dfb38ee9a8260a81$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $gdlUx.addDomEvent)(target, eventName, (0, $4WE5h.addPointerInfo)(handler), options);
}

});
parcelRegister("4WE5h", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", function () { return $b7d470c02ec89c30$export$12f84bb882d06e1a; });
$parcel$export(module.exports, "addPointerInfo", function () { return $b7d470c02ec89c30$export$c404e80f92c98d29; });

var $k8Wl0 = parcelRequire("k8Wl0");
function $b7d470c02ec89c30$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
var $b7d470c02ec89c30$export$c404e80f92c98d29 = function(handler) {
    return function(event) {
        return (0, $k8Wl0.isPrimaryPointer)(event) && handler(event, $b7d470c02ec89c30$export$12f84bb882d06e1a(event));
    };
};

});
parcelRegister("k8Wl0", function(module, exports) {

$parcel$export(module.exports, "isPrimaryPointer", function () { return $707440120b0e0e17$export$a4cf9c8a4b063a6e; });
var $707440120b0e0e17$export$a4cf9c8a4b063a6e = function(event) {
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

});



parcelRegister("f7KXA", function(module, exports) {

$parcel$export(module.exports, "getContextWindow", function () { return $76a4b24cd58f6694$export$d533d84f9871c879; });
// Fixes https://github.com/motiondivision/motion/issues/2270
var $76a4b24cd58f6694$export$d533d84f9871c879 = function(param) {
    var current = param.current;
    return current ? current.ownerDocument.defaultView : null;
};

});

parcelRegister("eCtR0", function(module, exports) {

$parcel$export(module.exports, "PanSession", function () { return $e1ce43997149259f$export$d9c66232c9c4689c; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $dbdHF = parcelRequire("dbdHF");
var $k8Wl0 = parcelRequire("k8Wl0");

var $8wJkX = parcelRequire("8wJkX");
var $5Hogw = parcelRequire("5Hogw");

var $6d4Ki = parcelRequire("6d4Ki");

var $4WE5h = parcelRequire("4WE5h");

var $bXWcj = parcelRequire("bXWcj");
var $e1ce43997149259f$var$overflowStyles = /*#__PURE__*/ new Set([
    "auto",
    "scroll"
]);
/**
 * @internal
 */ var $e1ce43997149259f$export$d9c66232c9c4689c = /*#__PURE__*/ function() {
    "use strict";
    function PanSession(event, handlers) {
        var _this = this;
        var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, transformPagePoint = _ref.transformPagePoint, _ref_contextWindow = _ref.contextWindow, contextWindow = _ref_contextWindow === void 0 ? window : _ref_contextWindow, _ref_dragSnapToOrigin = _ref.dragSnapToOrigin, dragSnapToOrigin = _ref_dragSnapToOrigin === void 0 ? false : _ref_dragSnapToOrigin, _ref_distanceThreshold = _ref.distanceThreshold, distanceThreshold = _ref_distanceThreshold === void 0 ? 3 : _ref_distanceThreshold, element = _ref.element;
        (0, $4QweW._)(this, PanSession);
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * Raw (untransformed) event info, re-transformed each frame
         * so transformPagePoint sees the current parent matrix.
         * @internal
         */ this.lastRawMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        /**
         * Scroll positions of scrollable ancestors and window.
         * @internal
         */ this.scrollPositions = new Map();
        /**
         * Cleanup function for scroll listeners.
         * @internal
         */ this.removeScrollListeners = null;
        this.onElementScroll = function(event) {
            _this.handleScroll(event.target);
        };
        this.onWindowScroll = function() {
            _this.handleScroll(window);
        };
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            // Re-transform raw point through current transformPagePoint so
            // animated parent transforms (e.g. rotation) are picked up each frame
            if (_this.lastRawMoveEventInfo) _this.lastMoveEventInfo = $e1ce43997149259f$var$transformPoint(_this.lastRawMoveEventInfo, _this.transformPagePoint);
            var info = $e1ce43997149259f$var$getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursor.
            var isDistancePastThreshold = (0, $bXWcj.distance2D)(info.offset, {
                x: 0,
                y: 0
            }) >= _this.distanceThreshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = (0, $dbdHF.frameData).timestamp;
            _this.history.push((0, $hApvp._)((0, $kWfK0._)({}, point), {
                timestamp: timestamp
            }));
            var _this_handlers = _this.handlers, onStart = _this_handlers.onStart, onMove = _this_handlers.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastRawMoveEventInfo = info;
            _this.lastMoveEventInfo = $e1ce43997149259f$var$transformPoint(info, _this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $dbdHF.frame).update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _this_handlers = _this.handlers, onEnd = _this_handlers.onEnd, onSessionEnd = _this_handlers.onSessionEnd, resumeAnimation = _this_handlers.resumeAnimation;
            // Resume animation if dragSnapToOrigin is set OR if no drag started (user just clicked)
            // This ensures constraint animations continue when interrupted by a click
            if (_this.dragSnapToOrigin || !_this.startEvent) resumeAnimation && resumeAnimation();
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var panInfo = $e1ce43997149259f$var$getPanInfo(event.type === "pointercancel" ? _this.lastMoveEventInfo : $e1ce43997149259f$var$transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $k8Wl0.isPrimaryPointer)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.distanceThreshold = distanceThreshold;
        this.contextWindow = contextWindow || window;
        var info = (0, $4WE5h.extractEventInfo)(event);
        var initialInfo = $e1ce43997149259f$var$transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0, $dbdHF.frameData).timestamp;
        this.history = [
            (0, $hApvp._)((0, $kWfK0._)({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, $e1ce43997149259f$var$getPanInfo(initialInfo, this.history));
        // Listen in the capture phase so a descendant calling
        // stopPropagation() (e.g. in its own pointerup handler) can't
        // prevent the gesture from ending. See #2794.
        var eventOptions = {
            passive: true,
            capture: true
        };
        this.removeListeners = (0, $5Hogw.pipe)((0, $6d4Ki.addPointerEvent)(this.contextWindow, "pointermove", this.handlePointerMove, eventOptions), (0, $6d4Ki.addPointerEvent)(this.contextWindow, "pointerup", this.handlePointerUp, eventOptions), (0, $6d4Ki.addPointerEvent)(this.contextWindow, "pointercancel", this.handlePointerUp, eventOptions));
        // Start scroll tracking if element provided
        if (element) this.startScrollTracking(element);
    }
    (0, $6hK4i._)(PanSession, [
        {
            /**
     * Start tracking scroll on ancestors and window.
     */ key: "startScrollTracking",
            value: function startScrollTracking(element) {
                var _this = this;
                // Store initial scroll positions for scrollable ancestors
                var current = element.parentElement;
                while(current){
                    var style = getComputedStyle(current);
                    if ($e1ce43997149259f$var$overflowStyles.has(style.overflowX) || $e1ce43997149259f$var$overflowStyles.has(style.overflowY)) this.scrollPositions.set(current, {
                        x: current.scrollLeft,
                        y: current.scrollTop
                    });
                    current = current.parentElement;
                }
                // Track window scroll
                this.scrollPositions.set(window, {
                    x: window.scrollX,
                    y: window.scrollY
                });
                // Capture listener catches element scroll events as they bubble
                window.addEventListener("scroll", this.onElementScroll, {
                    capture: true
                });
                // Direct window scroll listener (window scroll doesn't bubble)
                window.addEventListener("scroll", this.onWindowScroll);
                this.removeScrollListeners = function() {
                    window.removeEventListener("scroll", _this.onElementScroll, {
                        capture: true
                    });
                    window.removeEventListener("scroll", _this.onWindowScroll);
                };
            }
        },
        {
            /**
     * Handle scroll compensation during drag.
     *
     * For element scroll: adjusts history origin since pageX/pageY doesn't change.
     * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
     */ key: "handleScroll",
            value: function handleScroll(target) {
                var initial = this.scrollPositions.get(target);
                if (!initial) return;
                var isWindow = target === window;
                var current = isWindow ? {
                    x: window.scrollX,
                    y: window.scrollY
                } : {
                    x: target.scrollLeft,
                    y: target.scrollTop
                };
                var delta = {
                    x: current.x - initial.x,
                    y: current.y - initial.y
                };
                if (delta.x === 0 && delta.y === 0) return;
                if (isWindow) // Window scroll: pageX/pageY changes, so update lastMoveEventInfo
                {
                    if (this.lastMoveEventInfo) {
                        this.lastMoveEventInfo.point.x += delta.x;
                        this.lastMoveEventInfo.point.y += delta.y;
                    }
                } else // Element scroll: pageX/pageY unchanged, so adjust history origin
                if (this.history.length > 0) {
                    this.history[0].x -= delta.x;
                    this.history[0].y -= delta.y;
                }
                this.scrollPositions.set(target, current);
                (0, $dbdHF.frame).update(this.updatePoint, true);
            }
        },
        {
            key: "updateHandlers",
            value: function updateHandlers(handlers) {
                this.handlers = handlers;
            }
        },
        {
            key: "end",
            value: function end() {
                this.removeListeners && this.removeListeners();
                this.removeScrollListeners && this.removeScrollListeners();
                this.scrollPositions.clear();
                (0, $dbdHF.cancelFrame)(this.updatePoint);
            }
        }
    ]);
    return PanSession;
}();
function $e1ce43997149259f$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $e1ce43997149259f$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $e1ce43997149259f$var$getPanInfo(param, history) {
    var point = param.point;
    return {
        point: point,
        delta: $e1ce43997149259f$var$subtractPoint(point, $e1ce43997149259f$var$lastDevicePoint(history)),
        offset: $e1ce43997149259f$var$subtractPoint(point, $e1ce43997149259f$var$startDevicePoint(history)),
        velocity: $e1ce43997149259f$var$getVelocity(history, 0.1)
    };
}
function $e1ce43997149259f$var$startDevicePoint(history) {
    return history[0];
}
function $e1ce43997149259f$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $e1ce43997149259f$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $e1ce43997149259f$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $8wJkX.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    /**
     * If the selected point is the pointer-down origin (history[0]),
     * there are better movement points available, and the time gap
     * is suspiciously large (>2x timeDelta), use the next point instead.
     * This prevents stale pointer-down points from diluting velocity
     * in hold-then-flick gestures.
     */ if (timestampedPoint === history[0] && history.length > 2 && lastPoint.timestamp - timestampedPoint.timestamp > (0, $8wJkX.secondsToMilliseconds)(timeDelta) * 2) timestampedPoint = history[1];
    var time = (0, $8wJkX.millisecondsToSeconds)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("bXWcj", function(module, exports) {

$parcel$export(module.exports, "distance2D", function () { return $bbf8f9b8cbd446ec$export$503a1d513f12e38b; });
var $bbf8f9b8cbd446ec$export$9f17032d917177de = function(a, b) {
    return Math.abs(a - b);
};
function $bbf8f9b8cbd446ec$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    var xDelta = $bbf8f9b8cbd446ec$export$9f17032d917177de(a.x, b.x);
    var yDelta = $bbf8f9b8cbd446ec$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
}

});


parcelRegister("3T9di", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", function () { return $796d0bda3cbac366$export$b3c764d3fca3ffe3; });
$parcel$export(module.exports, "calcRelativeConstraints", function () { return $796d0bda3cbac366$export$4e9195bf7793bc78; });
$parcel$export(module.exports, "calcViewportConstraints", function () { return $796d0bda3cbac366$export$4228500f19d4cdf7; });
$parcel$export(module.exports, "calcOrigin", function () { return $796d0bda3cbac366$export$13abbfca044ca46d; });
$parcel$export(module.exports, "rebaseAxisConstraints", function () { return $796d0bda3cbac366$export$e9672cc4c36a8b87; });
$parcel$export(module.exports, "defaultElastic", function () { return $796d0bda3cbac366$export$a3366d3bac43a742; });
$parcel$export(module.exports, "resolveDragElastic", function () { return $796d0bda3cbac366$export$7c5eaef8f4723d22; });

var $7uBfQ = parcelRequire("7uBfQ");
var $gcS1k = parcelRequire("gcS1k");

var $4ceSY = parcelRequire("4ceSY");
var $brqzr = parcelRequire("brqzr");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $796d0bda3cbac366$export$b3c764d3fca3ffe3(point, param, elastic) {
    var min = param.min, max = param.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $gcS1k.mixNumber)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $gcS1k.mixNumber)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $796d0bda3cbac366$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $796d0bda3cbac366$export$4e9195bf7793bc78(layoutBox, param) {
    var top = param.top, left = param.left, bottom = param.bottom, right = param.right;
    return {
        x: $796d0bda3cbac366$export$690c180aa5775042(layoutBox.x, left, right),
        y: $796d0bda3cbac366$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $796d0bda3cbac366$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    var ref;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) ref = [
        max,
        min
    ], min = ref[0], max = ref[1], ref;
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $796d0bda3cbac366$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $796d0bda3cbac366$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $796d0bda3cbac366$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $796d0bda3cbac366$export$13abbfca044ca46d(source, target) {
    var origin = 0.5;
    var sourceLength = (0, $7uBfQ.calcLength)(source);
    var targetLength = (0, $7uBfQ.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, $brqzr.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $brqzr.progress)(source.min, source.max - targetLength, target.min);
    return (0, $4ceSY.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $796d0bda3cbac366$export$e9672cc4c36a8b87(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var $796d0bda3cbac366$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $796d0bda3cbac366$export$7c5eaef8f4723d22() {
    var dragElastic = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $796d0bda3cbac366$export$a3366d3bac43a742;
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $796d0bda3cbac366$export$a3366d3bac43a742;
    return {
        x: $796d0bda3cbac366$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $796d0bda3cbac366$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $796d0bda3cbac366$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $796d0bda3cbac366$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $796d0bda3cbac366$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $796d0bda3cbac366$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

});



parcelRegister("hHCtc", function(module, exports) {

$parcel$export(module.exports, "PanGesture", function () { return $a0840619637be800$export$b4f8f1ee75ce5859; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $ledP3 = parcelRequire("ledP3");
var $dbdHF = parcelRequire("dbdHF");

var $386Yo = parcelRequire("386Yo");

var $6d4Ki = parcelRequire("6d4Ki");

var $f7KXA = parcelRequire("f7KXA");

var $eCtR0 = parcelRequire("eCtR0");
var $a0840619637be800$var$asyncHandler = function(handler) {
    return function(event, info) {
        if (handler) (0, $dbdHF.frame).update(function() {
            return handler(event, info);
        }, false, true);
    };
};
var $a0840619637be800$export$b4f8f1ee75ce5859 = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $c2MhV._)(PanGesture, Feature);
    function PanGesture() {
        (0, $4QweW._)(this, PanGesture);
        var _this;
        _this = (0, $ehF45._)(this, PanGesture, arguments);
        _this.removePointerDownListener = (0, $386Yo.noop);
        return _this;
    }
    (0, $6hK4i._)(PanGesture, [
        {
            key: "onPointerDown",
            value: function onPointerDown(pointerDownEvent) {
                this.session = new (0, $eCtR0.PanSession)(pointerDownEvent, this.createPanHandlers(), {
                    transformPagePoint: this.node.getTransformPagePoint(),
                    contextWindow: (0, $f7KXA.getContextWindow)(this.node)
                });
            }
        },
        {
            key: "createPanHandlers",
            value: function createPanHandlers() {
                var _this = this;
                var _this_node_getProps = this.node.getProps(), onPanSessionStart = _this_node_getProps.onPanSessionStart, onPanStart = _this_node_getProps.onPanStart, onPan = _this_node_getProps.onPan, onPanEnd = _this_node_getProps.onPanEnd;
                return {
                    onSessionStart: $a0840619637be800$var$asyncHandler(onPanSessionStart),
                    onStart: $a0840619637be800$var$asyncHandler(onPanStart),
                    onMove: $a0840619637be800$var$asyncHandler(onPan),
                    onEnd: function(event, info) {
                        delete _this.session;
                        if (onPanEnd) (0, $dbdHF.frame).postRender(function() {
                            return onPanEnd(event, info);
                        });
                    }
                };
            }
        },
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                this.removePointerDownListener = (0, $6d4Ki.addPointerEvent)(this.node.current, "pointerdown", function(event) {
                    return _this.onPointerDown(event);
                });
            }
        },
        {
            key: "update",
            value: function update() {
                this.session && this.session.updateHandlers(this.createPanHandlers());
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                this.removePointerDownListener();
                this.session && this.session.end();
            }
        }
    ]);
    return PanGesture;
}((0, $ledP3.Feature));

});

parcelRegister("gQoGI", function(module, exports) {

$parcel$export(module.exports, "MeasureLayout", function () { return $7cb96471806084e8$export$779f5fb01ad751cd; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $6ZpBv = parcelRequire("6ZpBv");

var $9HB6H = parcelRequire("9HB6H");

var $dbdHF = parcelRequire("dbdHF");
var $bjxbh = parcelRequire("bjxbh");
var $2NaEP = parcelRequire("2NaEP");

var $iD6kw = parcelRequire("iD6kw");

var $aYbxD = parcelRequire("aYbxD");

var $8Js66 = parcelRequire("8Js66");

var $1BC3b = parcelRequire("1BC3b");
"use client";
/**
 * Track whether we've taken any snapshots yet. If not,
 * we can safely skip notification of didUpdate.
 *
 * Difficult to capture in a test but to prevent flickering
 * we must set this to true either on update or unmount.
 * Running `next-env/layout-id` in Safari will show this behaviour if broken.
 */ var $7cb96471806084e8$var$hasTakenAnySnapshot = false;
var $7cb96471806084e8$var$MeasureLayoutWithContext = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $c2MhV._)(MeasureLayoutWithContext, Component);
    function MeasureLayoutWithContext() {
        (0, $4QweW._)(this, MeasureLayoutWithContext);
        return (0, $ehF45._)(this, MeasureLayoutWithContext, arguments);
    }
    (0, $6hK4i._)(MeasureLayoutWithContext, [
        {
            /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                var _this_props = this.props, visualElement = _this_props.visualElement, layoutGroup = _this_props.layoutGroup, switchLayoutGroup = _this_props.switchLayoutGroup, layoutId = _this_props.layoutId;
                var projection = visualElement.projection;
                if (projection) {
                    if (layoutGroup.group) layoutGroup.group.add(projection);
                    if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
                    if ($7cb96471806084e8$var$hasTakenAnySnapshot) projection.root.didUpdate();
                    projection.addEventListener("animationComplete", function() {
                        _this.safeToRemove();
                    });
                    projection.setOptions((0, $hApvp._)((0, $kWfK0._)({}, projection.options), {
                        layoutDependency: this.props.layoutDependency,
                        onExitComplete: function() {
                            return _this.safeToRemove();
                        }
                    }));
                }
                (0, $bjxbh.globalProjectionState).hasEverUpdated = true;
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var _this = this;
                var _this_props = this.props, layoutDependency = _this_props.layoutDependency, visualElement = _this_props.visualElement, drag = _this_props.drag, isPresent = _this_props.isPresent;
                var projection = visualElement.projection;
                if (!projection) return null;
                /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
                if (prevProps.layoutDependency !== layoutDependency) projection.setOptions((0, $hApvp._)((0, $kWfK0._)({}, projection.options), {
                    layoutDependency: layoutDependency
                }));
                $7cb96471806084e8$var$hasTakenAnySnapshot = true;
                if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
                else this.safeToRemove();
                if (prevProps.isPresent !== isPresent) {
                    if (isPresent) projection.promote();
                    else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $dbdHF.frame).postRender(function() {
                        var stack = projection.getStack();
                        if (!stack || !stack.members.length) _this.safeToRemove();
                    });
                }
                return null;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this = this;
                var _this_props = this.props, visualElement = _this_props.visualElement, layoutAnchor = _this_props.layoutAnchor;
                var projection = visualElement.projection;
                if (projection) {
                    projection.options.layoutAnchor = layoutAnchor;
                    projection.root.didUpdate();
                    (0, $2NaEP.microtask).postRender(function() {
                        if (!projection.currentAnimation && projection.isLead()) _this.safeToRemove();
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this_props = this.props, visualElement = _this_props.visualElement, layoutGroup = _this_props.layoutGroup, promoteContext = _this_props.switchLayoutGroup;
                var projection = visualElement.projection;
                $7cb96471806084e8$var$hasTakenAnySnapshot = true;
                if (projection) {
                    projection.scheduleCheckAfterUnmount();
                    if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
                    if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
                }
            }
        },
        {
            key: "safeToRemove",
            value: function safeToRemove() {
                var safeToRemove = this.props.safeToRemove;
                safeToRemove && safeToRemove();
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return MeasureLayoutWithContext;
}((0, $iD6kw.Component));
function $7cb96471806084e8$export$779f5fb01ad751cd(props) {
    var _usePresence = (0, $6ZpBv._)((0, $aYbxD.usePresence)(), 2), isPresent = _usePresence[0], safeToRemove = _usePresence[1];
    var layoutGroup = (0, $iD6kw.useContext)((0, $8Js66.LayoutGroupContext));
    return (0, $9HB6H.jsx)($7cb96471806084e8$var$MeasureLayoutWithContext, (0, $hApvp._)((0, $kWfK0._)({}, props), {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $iD6kw.useContext)((0, $1BC3b.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}

});
parcelRegister("bjxbh", function(module, exports) {

$parcel$export(module.exports, "globalProjectionState", function () { return $018cd1f3dda1c95f$export$97db156a3ed1593b; });
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ var $018cd1f3dda1c95f$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

});


parcelRegister("40ppk", function(module, exports) {

$parcel$export(module.exports, "HTMLProjectionNode", function () { return $8e1a6cd6edc5285e$export$b61a9eb3dbde8858; });

var $2vdFJ = parcelRequire("2vdFJ");

var $jfppa = parcelRequire("jfppa");
var $8e1a6cd6edc5285e$export$b91509fcf893b648 = {
    current: undefined
};
var $8e1a6cd6edc5285e$export$b61a9eb3dbde8858 = (0, $2vdFJ.createProjectionNode)({
    measureScroll: function(instance) {
        return {
            x: instance.scrollLeft,
            y: instance.scrollTop
        };
    },
    defaultParent: function() {
        if (!$8e1a6cd6edc5285e$export$b91509fcf893b648.current) {
            var documentNode = new (0, $jfppa.DocumentProjectionNode)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $8e1a6cd6edc5285e$export$b91509fcf893b648.current = documentNode;
        }
        return $8e1a6cd6edc5285e$export$b91509fcf893b648.current;
    },
    resetTransform: function(instance, value) {
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: function(instance) {
        return Boolean(window.getComputedStyle(instance).position === "fixed");
    }
});

});
parcelRegister("2vdFJ", function(module, exports) {

$parcel$export(module.exports, "createProjectionNode", function () { return $b3e0b535a24e0dbd$export$a84b61f69daa9da0; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $jlUaU = parcelRequire("jlUaU");

var $4ceSY = parcelRequire("4ceSY");
var $386Yo = parcelRequire("386Yo");
var $32hw3 = parcelRequire("32hw3");

var $axJlk = parcelRequire("axJlk");

var $6Oi7A = parcelRequire("6Oi7A");

var $1Ul7u = parcelRequire("1Ul7u");

var $2NaEP = parcelRequire("2NaEP");

var $i1wr7 = parcelRequire("i1wr7");

var $dlAPu = parcelRequire("dlAPu");

var $gncsx = parcelRequire("gncsx");

var $92etN = parcelRequire("92etN");

var $jAGjK = parcelRequire("jAGjK");

var $iqAnM = parcelRequire("iqAnM");

var $gcS1k = parcelRequire("gcS1k");

var $c1b8l = parcelRequire("c1b8l");

var $hQ81U = parcelRequire("hQ81U");

var $fgArx = parcelRequire("fgArx");

var $kb1og = parcelRequire("kb1og");

var $1QgJK = parcelRequire("1QgJK");

var $7uBfQ = parcelRequire("7uBfQ");

var $iu6nW = parcelRequire("iu6nW");

var $fQu9K = parcelRequire("fQu9K");

var $cac53 = parcelRequire("cac53");

var $1thxW = parcelRequire("1thxW");

var $5Ps2W = parcelRequire("5Ps2W");

var $90ti6 = parcelRequire("90ti6");

var $ax5AE = parcelRequire("ax5AE");

var $b0Bmd = parcelRequire("b0Bmd");

var $bjxbh = parcelRequire("bjxbh");

var $dbdHF = parcelRequire("dbdHF");
var $b3e0b535a24e0dbd$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
var $b3e0b535a24e0dbd$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ var $b3e0b535a24e0dbd$var$animationTarget = 1000;
var $b3e0b535a24e0dbd$var$id = 0;
function $b3e0b535a24e0dbd$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    var latestValues = visualElement.latestValues;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $b3e0b535a24e0dbd$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    var visualElement = projectionNode.options.visualElement;
    if (!visualElement) return;
    var appearId = (0, $6Oi7A.getOptimisedAppearId)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        var _projectionNode_options = projectionNode.options, layout = _projectionNode_options.layout, layoutId = _projectionNode_options.layoutId;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $dbdHF.frame), !(layout || layoutId));
    }
    var parent = projectionNode.parent;
    if (parent && !parent.hasCheckedOptimisedAppear) $b3e0b535a24e0dbd$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $b3e0b535a24e0dbd$export$a84b61f69daa9da0(param) {
    var attachResizeListener = param.attachResizeListener, defaultParent = param.defaultParent, measureScroll = param.measureScroll, checkIsScrollRoot = param.checkIsScrollRoot, resetTransform = param.resetTransform;
    return /*#__PURE__*/ function() {
        "use strict";
        function ProjectionNode() {
            var _this = this;
            var latestValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
            (0, $4QweW._)(this, ProjectionNode);
            /**
             * A unique ID generated for every projection node.
             */ this.id = $b3e0b535a24e0dbd$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            this.layoutVersion = 0;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = function() {
                return _this.update();
            };
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = function() {
                if (_this.isUpdating) {
                    _this.isUpdating = false;
                    _this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = function() {
                _this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $gncsx.statsBuffer).value) $b3e0b535a24e0dbd$var$metrics.nodes = $b3e0b535a24e0dbd$var$metrics.calculatedTargetDeltas = $b3e0b535a24e0dbd$var$metrics.calculatedProjections = 0;
                _this.nodes.forEach($b3e0b535a24e0dbd$export$131f2f0cc5fe9609);
                _this.nodes.forEach($b3e0b535a24e0dbd$var$resolveTargetDelta);
                _this.nodes.forEach($b3e0b535a24e0dbd$var$calcProjection);
                _this.nodes.forEach($b3e0b535a24e0dbd$export$c2664f37bc951031);
                if ((0, $gncsx.statsBuffer).addProjectionMetrics) (0, $gncsx.statsBuffer).addProjectionMetrics($b3e0b535a24e0dbd$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.linkedParentVersion = 0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? (0, $jlUaU._)(parent.path).concat([
                parent
            ]) : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(var i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $ax5AE.FlatTree)();
        }
        (0, $6hK4i._)(ProjectionNode, [
            {
                key: "addEventListener",
                value: function addEventListener(name, handler) {
                    if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $32hw3.SubscriptionManager)());
                    return this.eventHandlers.get(name).add(handler);
                }
            },
            {
                key: "notifyListeners",
                value: function notifyListeners(name) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _subscriptionManager;
                    var subscriptionManager = this.eventHandlers.get(name);
                    subscriptionManager && (_subscriptionManager = subscriptionManager).notify.apply(_subscriptionManager, (0, $jlUaU._)(args));
                }
            },
            {
                key: "hasListeners",
                value: function hasListeners(name) {
                    return this.eventHandlers.has(name);
                }
            },
            {
                /**
         * Lifecycles
         */ key: "mount",
                value: function mount(instance) {
                    var _this = this;
                    if (this.instance) return;
                    this.isSVG = (0, $jAGjK.isSVGElement)(instance) && !(0, $iqAnM.isSVGSVGElement)(instance);
                    this.instance = instance;
                    var _this_options = this.options, layoutId = _this_options.layoutId, layout = _this_options.layout, visualElement = _this_options.visualElement;
                    if (visualElement && !visualElement.current) visualElement.mount(instance);
                    this.root.nodes.add(this);
                    this.parent && this.parent.children.add(this);
                    if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
                    if (attachResizeListener) {
                        var cancelDelay;
                        var innerWidth = 0;
                        var resizeUnblockUpdate = function() {
                            return _this.root.updateBlockedByResize = false;
                        };
                        // Set initial innerWidth in a frame.read callback to batch the read
                        (0, $dbdHF.frame).read(function() {
                            innerWidth = window.innerWidth;
                        });
                        attachResizeListener(instance, function() {
                            var newInnerWidth = window.innerWidth;
                            if (newInnerWidth === innerWidth) return;
                            innerWidth = newInnerWidth;
                            _this.root.updateBlockedByResize = true;
                            cancelDelay && cancelDelay();
                            cancelDelay = (0, $92etN.delay)(resizeUnblockUpdate, 250);
                            if ((0, $bjxbh.globalProjectionState).hasAnimatedSinceResize) {
                                (0, $bjxbh.globalProjectionState).hasAnimatedSinceResize = false;
                                _this.nodes.forEach($b3e0b535a24e0dbd$var$finishAnimation);
                            }
                        });
                    }
                    if (layoutId) this.root.registerSharedNode(layoutId, this);
                    // Only register the handler if it requires layout animation
                    if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", function(param) {
                        var delta = param.delta, hasLayoutChanged = param.hasLayoutChanged, hasRelativeLayoutChanged = param.hasRelativeLayoutChanged, newLayout = param.layout;
                        if (_this.isTreeAnimationBlocked()) {
                            _this.target = undefined;
                            _this.relativeTarget = undefined;
                            return;
                        }
                        // TODO: Check here if an animation exists
                        var layoutTransition = _this.options.transition || visualElement.getDefaultTransition() || $b3e0b535a24e0dbd$var$defaultLayoutTransition;
                        var _visualElement_getProps = visualElement.getProps(), onLayoutAnimationStart = _visualElement_getProps.onLayoutAnimationStart, onLayoutAnimationComplete = _visualElement_getProps.onLayoutAnimationComplete;
                        /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ var hasTargetChanged = !_this.targetLayout || !(0, $cac53.boxEqualsRounded)(_this.targetLayout, newLayout);
                        /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                        /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                        if (_this.options.layoutRoot || _this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !_this.currentAnimation)) {
                            if (_this.resumeFrom) {
                                _this.resumingFrom = _this.resumeFrom;
                                _this.resumingFrom.resumingFrom = undefined;
                            }
                            var animationOptions = (0, $hApvp._)((0, $kWfK0._)({}, (0, $1Ul7u.getValueTransition)(layoutTransition, "layout")), {
                                onPlay: onLayoutAnimationStart,
                                onComplete: onLayoutAnimationComplete
                            });
                            if (visualElement.shouldReduceMotion || _this.options.layoutRoot) {
                                animationOptions.delay = 0;
                                animationOptions.type = false;
                            }
                            _this.startAnimation(animationOptions);
                            /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged, animationOptions.path);
                        } else {
                            /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never committed to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $b3e0b535a24e0dbd$var$finishAnimation(_this);
                            if (_this.isLead() && _this.options.onExitComplete) _this.options.onExitComplete();
                        }
                        _this.targetLayout = newLayout;
                    });
                }
            },
            {
                key: "unmount",
                value: function unmount() {
                    this.options.layoutId && this.willUpdate();
                    this.root.nodes.remove(this);
                    var stack = this.getStack();
                    stack && stack.remove(this);
                    this.parent && this.parent.children.delete(this);
                    this.instance = undefined;
                    this.eventHandlers.clear();
                    (0, $dbdHF.cancelFrame)(this.updateProjection);
                }
            },
            {
                // only on the root
                key: "blockUpdate",
                value: function blockUpdate() {
                    this.updateManuallyBlocked = true;
                }
            },
            {
                key: "unblockUpdate",
                value: function unblockUpdate() {
                    this.updateManuallyBlocked = false;
                }
            },
            {
                key: "isUpdateBlocked",
                value: function isUpdateBlocked() {
                    return this.updateManuallyBlocked || this.updateBlockedByResize;
                }
            },
            {
                key: "isTreeAnimationBlocked",
                value: function isTreeAnimationBlocked() {
                    return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
                }
            },
            {
                // Note: currently only running on root node
                key: "startUpdate",
                value: function startUpdate() {
                    if (this.isUpdateBlocked()) return;
                    this.isUpdating = true;
                    this.nodes && this.nodes.forEach($b3e0b535a24e0dbd$var$resetSkewAndRotation);
                    this.animationId++;
                }
            },
            {
                key: "getTransformTemplate",
                value: function getTransformTemplate() {
                    var visualElement = this.options.visualElement;
                    return visualElement && visualElement.getProps().transformTemplate;
                }
            },
            {
                key: "willUpdate",
                value: function willUpdate() {
                    var shouldNotifyListeners = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    this.root.hasTreeAnimated = true;
                    if (this.root.isUpdateBlocked()) {
                        this.options.onExitComplete && this.options.onExitComplete();
                        return;
                    }
                    /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $b3e0b535a24e0dbd$var$cancelTreeOptimisedTransformAnimations(this);
                    !this.root.isUpdating && this.root.startUpdate();
                    if (this.isLayoutDirty) return;
                    this.isLayoutDirty = true;
                    for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        node.shouldResetTransform = true;
                        /**
                 * Percentage translates resolve against layoutBox dimensions,
                 * so ancestors with them must be re-measured after transform reset.
                 */ if (typeof node.latestValues.x === "string" || typeof node.latestValues.y === "string") node.isLayoutDirty = true;
                        node.updateScroll("snapshot");
                        if (node.options.layoutRoot) node.willUpdate(false);
                    }
                    var _this_options = this.options, layoutId = _this_options.layoutId, layout = _this_options.layout;
                    if (layoutId === undefined && !layout) return;
                    var transformTemplate = this.getTransformTemplate();
                    this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
                    this.updateSnapshot();
                    shouldNotifyListeners && this.notifyListeners("willUpdate");
                }
            },
            {
                key: "update",
                value: function update() {
                    this.updateScheduled = false;
                    var updateWasBlocked = this.isUpdateBlocked();
                    // When doing an instant transition, we skip the layout update,
                    // but should still clean up the measurements so that the next
                    // snapshot could be taken correctly.
                    if (updateWasBlocked) {
                        var wasBlockedByResize = this.updateBlockedByResize;
                        this.unblockUpdate();
                        this.updateBlockedByResize = false;
                        this.clearAllSnapshots();
                        /**
                 * When blocked by resize, still measure layouts so
                 * callbacks like onLayoutMeasure fire (e.g. Reorder).
                 * Skip notifyLayoutUpdate to prevent animations.
                 */ if (wasBlockedByResize) this.nodes.forEach($b3e0b535a24e0dbd$var$forceLayoutMeasure);
                        this.nodes.forEach($b3e0b535a24e0dbd$var$clearMeasurements);
                        return;
                    }
                    /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                        this.nodes.forEach($b3e0b535a24e0dbd$var$clearIsLayoutDirty);
                        return;
                    }
                    this.animationCommitId = this.animationId;
                    if (!this.isUpdating) this.nodes.forEach($b3e0b535a24e0dbd$var$clearIsLayoutDirty);
                    else {
                        this.isUpdating = false;
                        /**
                 * Ensure animation-blocked nodes (e.g. during drag)
                 * get measured even when memoized (willUpdate skipped).
                 */ this.nodes.forEach($b3e0b535a24e0dbd$var$ensureDraggedNodesSnapshotted);
                        /**
                 * Write
                 */ this.nodes.forEach($b3e0b535a24e0dbd$var$resetTransformStyle);
                        /**
                 * Read ==================
                 */ // Update layout measurements of updated children
                        this.nodes.forEach($b3e0b535a24e0dbd$var$updateLayout);
                        /**
                 * Write
                 */ // Notify listeners that the layout is updated
                        this.nodes.forEach($b3e0b535a24e0dbd$var$notifyLayoutUpdate);
                    }
                    this.clearAllSnapshots();
                    /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ var now = (0, $i1wr7.time).now();
                    (0, $dbdHF.frameData).delta = (0, $4ceSY.clamp)(0, 1000 / 60, now - (0, $dbdHF.frameData).timestamp);
                    (0, $dbdHF.frameData).timestamp = now;
                    (0, $dbdHF.frameData).isProcessing = true;
                    (0, $dbdHF.frameSteps).update.process((0, $dbdHF.frameData));
                    (0, $dbdHF.frameSteps).preRender.process((0, $dbdHF.frameData));
                    (0, $dbdHF.frameSteps).render.process((0, $dbdHF.frameData));
                    (0, $dbdHF.frameData).isProcessing = false;
                }
            },
            {
                key: "didUpdate",
                value: function didUpdate() {
                    if (!this.updateScheduled) {
                        this.updateScheduled = true;
                        (0, $2NaEP.microtask).read(this.scheduleUpdate);
                    }
                }
            },
            {
                key: "clearAllSnapshots",
                value: function clearAllSnapshots() {
                    this.nodes.forEach($b3e0b535a24e0dbd$var$clearSnapshot);
                    this.sharedNodes.forEach($b3e0b535a24e0dbd$var$removeLeadSnapshots);
                }
            },
            {
                key: "scheduleUpdateProjection",
                value: function scheduleUpdateProjection() {
                    if (!this.projectionUpdateScheduled) {
                        this.projectionUpdateScheduled = true;
                        (0, $dbdHF.frame).preRender(this.updateProjection, false, true);
                    }
                }
            },
            {
                key: "scheduleCheckAfterUnmount",
                value: function scheduleCheckAfterUnmount() {
                    var _this = this;
                    /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $dbdHF.frame).postRender(function() {
                        if (_this.isLayoutDirty) _this.root.didUpdate();
                        else _this.root.checkUpdateFailed();
                    });
                }
            },
            {
                /**
         * Update measurements
         */ key: "updateSnapshot",
                value: function updateSnapshot() {
                    if (this.snapshot || !this.instance) return;
                    this.snapshot = this.measure();
                    if (this.snapshot && !(0, $7uBfQ.calcLength)(this.snapshot.measuredBox.x) && !(0, $7uBfQ.calcLength)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
                }
            },
            {
                key: "updateLayout",
                value: function updateLayout() {
                    if (!this.instance) return;
                    this.updateScroll();
                    if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
                    /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        node.updateScroll();
                    }
                    var prevLayout = this.layout;
                    this.layout = this.measure(false);
                    this.layoutVersion++;
                    if (!this.layoutCorrected) this.layoutCorrected = (0, $fQu9K.createBox)();
                    this.isLayoutDirty = false;
                    this.projectionDelta = undefined;
                    this.notifyListeners("measure", this.layout.layoutBox);
                    var visualElement = this.options.visualElement;
                    visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
                }
            },
            {
                key: "updateScroll",
                value: function updateScroll() {
                    var phase = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "measure";
                    var needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
                    if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
                    if (needsMeasurement && this.instance) {
                        var isRoot = checkIsScrollRoot(this.instance);
                        this.scroll = {
                            animationId: this.root.animationId,
                            phase: phase,
                            isRoot: isRoot,
                            offset: measureScroll(this.instance),
                            wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                        };
                    }
                }
            },
            {
                key: "resetTransform",
                value: function resetTransform1() {
                    if (!resetTransform) return;
                    var isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
                    var hasProjection = this.projectionDelta && !(0, $cac53.isDeltaZero)(this.projectionDelta);
                    var transformTemplate = this.getTransformTemplate();
                    var transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
                    var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
                    if (isResetRequested && this.instance && (hasProjection || (0, $b0Bmd.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                        resetTransform(this.instance, transformTemplateValue);
                        this.shouldResetTransform = false;
                        this.scheduleRender();
                    }
                }
            },
            {
                key: "measure",
                value: function measure() {
                    var removeTransform = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    var pageBox = this.measurePageBox();
                    var layoutBox = this.removeElementScroll(pageBox);
                    /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
                    $b3e0b535a24e0dbd$var$roundBox(layoutBox);
                    return {
                        animationId: this.root.animationId,
                        measuredBox: pageBox,
                        layoutBox: layoutBox,
                        latestValues: {},
                        source: this.id
                    };
                }
            },
            {
                key: "measurePageBox",
                value: function measurePageBox() {
                    var _this_scroll;
                    var visualElement = this.options.visualElement;
                    if (!visualElement) return (0, $fQu9K.createBox)();
                    var box = visualElement.measureViewportBox();
                    var wasInScrollRoot = ((_this_scroll = this.scroll) === null || _this_scroll === void 0 ? void 0 : _this_scroll.wasRoot) || this.path.some($b3e0b535a24e0dbd$var$checkNodeWasScrollRoot);
                    if (!wasInScrollRoot) {
                        // Remove viewport scroll to give page-relative coordinates
                        var scroll = this.root.scroll;
                        if (scroll) {
                            (0, $1QgJK.translateAxis)(box.x, scroll.offset.x);
                            (0, $1QgJK.translateAxis)(box.y, scroll.offset.y);
                        }
                    }
                    return box;
                }
            },
            {
                key: "removeElementScroll",
                value: function removeElementScroll(box) {
                    var _this_scroll;
                    var boxWithoutScroll = (0, $fQu9K.createBox)();
                    (0, $kb1og.copyBoxInto)(boxWithoutScroll, box);
                    if ((_this_scroll = this.scroll) === null || _this_scroll === void 0 ? void 0 : _this_scroll.wasRoot) return boxWithoutScroll;
                    /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(var i = 0; i < this.path.length; i++){
                        var node = this.path[i];
                        var scroll = node.scroll, options = node.options;
                        if (node !== this.root && scroll && options.layoutScroll) {
                            /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $kb1og.copyBoxInto)(boxWithoutScroll, box);
                            (0, $1QgJK.translateAxis)(boxWithoutScroll.x, scroll.offset.x);
                            (0, $1QgJK.translateAxis)(boxWithoutScroll.y, scroll.offset.y);
                        }
                    }
                    return boxWithoutScroll;
                }
            },
            {
                key: "applyTransform",
                value: function applyTransform(box) {
                    var transformOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, output = arguments.length > 2 ? arguments[2] : void 0;
                    var _this_layout;
                    var withTransforms = output || (0, $fQu9K.createBox)();
                    (0, $kb1og.copyBoxInto)(withTransforms, box);
                    for(var i = 0; i < this.path.length; i++){
                        var _node_layout;
                        var node = this.path[i];
                        if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) {
                            (0, $1QgJK.translateAxis)(withTransforms.x, -node.scroll.offset.x);
                            (0, $1QgJK.translateAxis)(withTransforms.y, -node.scroll.offset.y);
                        }
                        if (!(0, $b0Bmd.hasTransform)(node.latestValues)) continue;
                        (0, $1QgJK.transformBox)(withTransforms, node.latestValues, (_node_layout = node.layout) === null || _node_layout === void 0 ? void 0 : _node_layout.layoutBox);
                    }
                    if ((0, $b0Bmd.hasTransform)(this.latestValues)) (0, $1QgJK.transformBox)(withTransforms, this.latestValues, (_this_layout = this.layout) === null || _this_layout === void 0 ? void 0 : _this_layout.layoutBox);
                    return withTransforms;
                }
            },
            {
                key: "removeTransform",
                value: function removeTransform(box) {
                    var boxWithoutTransform = (0, $fQu9K.createBox)();
                    (0, $kb1og.copyBoxInto)(boxWithoutTransform, box);
                    for(var i = 0; i < this.path.length; i++){
                        var _node_snapshot;
                        var node = this.path[i];
                        if (!(0, $b0Bmd.hasTransform)(node.latestValues)) continue;
                        var sourceBox = void 0;
                        if (node.instance) {
                            (0, $b0Bmd.hasScale)(node.latestValues) && node.updateSnapshot();
                            sourceBox = (0, $fQu9K.createBox)();
                            (0, $kb1og.copyBoxInto)(sourceBox, node.measurePageBox());
                        }
                        (0, $iu6nW.removeBoxTransforms)(boxWithoutTransform, node.latestValues, (_node_snapshot = node.snapshot) === null || _node_snapshot === void 0 ? void 0 : _node_snapshot.layoutBox, sourceBox);
                    }
                    if ((0, $b0Bmd.hasTransform)(this.latestValues)) (0, $iu6nW.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
                    return boxWithoutTransform;
                }
            },
            {
                key: "setTargetDelta",
                value: function setTargetDelta(delta) {
                    this.targetDelta = delta;
                    this.root.scheduleUpdateProjection();
                    this.isProjectionDirty = true;
                }
            },
            {
                key: "setOptions",
                value: function setOptions(options) {
                    this.options = (0, $hApvp._)((0, $kWfK0._)({}, this.options, options), {
                        crossfade: options.crossfade !== undefined ? options.crossfade : true
                    });
                }
            },
            {
                key: "clearMeasurements",
                value: function clearMeasurements() {
                    this.scroll = undefined;
                    this.layout = undefined;
                    this.snapshot = undefined;
                    this.prevTransformTemplateValue = undefined;
                    this.targetDelta = undefined;
                    this.target = undefined;
                    this.isLayoutDirty = false;
                }
            },
            {
                key: "forceRelativeParentToResolveTarget",
                value: function forceRelativeParentToResolveTarget() {
                    if (!this.relativeParent) return;
                    /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $dbdHF.frameData).timestamp) this.relativeParent.resolveTargetDelta(true);
                }
            },
            {
                key: "resolveTargetDelta",
                value: function resolveTargetDelta() {
                    var forceRecalculation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    var _this_parent;
                    /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ var lead = this.getLead();
                    this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
                    this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
                    this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
                    var isShared = Boolean(this.resumingFrom) || this !== lead;
                    /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ var canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
                    if (canSkip) return;
                    var _this_options = this.options, layout = _this_options.layout, layoutId = _this_options.layoutId;
                    /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
                    this.resolvedRelativeTargetAt = (0, $dbdHF.frameData).timestamp;
                    var relativeParent = this.getClosestProjectingParent();
                    if (relativeParent && this.linkedParentVersion !== relativeParent.layoutVersion && !relativeParent.options.layoutRoot) this.removeRelativeTarget();
                    /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                        if (this.options.layoutAnchor !== false && relativeParent && relativeParent.layout) this.createRelativeTarget(relativeParent, this.layout.layoutBox, relativeParent.layout.layoutBox);
                        else this.removeRelativeTarget();
                    }
                    /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
                    /**
             * Lazy-init target data structure
             */ if (!this.target) {
                        this.target = (0, $fQu9K.createBox)();
                        this.targetWithTransforms = (0, $fQu9K.createBox)();
                    }
                    /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                        this.forceRelativeParentToResolveTarget();
                        (0, $7uBfQ.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || undefined);
                    /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                        if (Boolean(this.resumingFrom)) this.applyTransform(this.layout.layoutBox, false, this.target);
                        else (0, $kb1og.copyBoxInto)(this.target, this.layout.layoutBox);
                        (0, $1QgJK.applyBoxDelta)(this.target, this.targetDelta);
                    } else /**
                 * If no target, use own layout as target
                 */ (0, $kb1og.copyBoxInto)(this.target, this.layout.layoutBox);
                    /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                        this.attemptToResolveRelativeTarget = false;
                        if (this.options.layoutAnchor !== false && relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) this.createRelativeTarget(relativeParent, this.target, relativeParent.target);
                        else this.relativeParent = this.relativeTarget = undefined;
                    }
                    /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $gncsx.statsBuffer).value) $b3e0b535a24e0dbd$var$metrics.calculatedTargetDeltas++;
                }
            },
            {
                key: "getClosestProjectingParent",
                value: function getClosestProjectingParent() {
                    if (!this.parent || (0, $b0Bmd.hasScale)(this.parent.latestValues) || (0, $b0Bmd.has2DTranslate)(this.parent.latestValues)) return undefined;
                    if (this.parent.isProjecting()) return this.parent;
                    else return this.parent.getClosestProjectingParent();
                }
            },
            {
                key: "isProjecting",
                value: function isProjecting() {
                    return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
                }
            },
            {
                key: "createRelativeTarget",
                value: function createRelativeTarget(relativeParent, layout, parentLayout) {
                    this.relativeParent = relativeParent;
                    this.linkedParentVersion = relativeParent.layoutVersion;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $fQu9K.createBox)();
                    this.relativeTargetOrigin = (0, $fQu9K.createBox)();
                    (0, $7uBfQ.calcRelativePosition)(this.relativeTargetOrigin, layout, parentLayout, this.options.layoutAnchor || undefined);
                    (0, $kb1og.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                }
            },
            {
                key: "removeRelativeTarget",
                value: function removeRelativeTarget() {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            },
            {
                key: "calcProjection",
                value: function calcProjection() {
                    var _this_parent;
                    var lead = this.getLead();
                    var isShared = Boolean(this.resumingFrom) || this !== lead;
                    var canSkip = true;
                    /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.isProjectionDirty)) canSkip = false;
                    /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
                    /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $dbdHF.frameData).timestamp) canSkip = false;
                    if (canSkip) return;
                    var _this_options = this.options, layout = _this_options.layout, layoutId = _this_options.layoutId;
                    /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
                    if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
                    if (!this.layout || !(layout || layoutId)) return;
                    /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $kb1og.copyBoxInto)(this.layoutCorrected, this.layout.layoutBox);
                    /**
             * Record previous tree scales before updating.
             */ var prevTreeScaleX = this.treeScale.x;
                    var prevTreeScaleY = this.treeScale.y;
                    /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $1QgJK.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, isShared);
                    /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                        lead.target = lead.layout.layoutBox;
                        lead.targetWithTransforms = (0, $fQu9K.createBox)();
                    }
                    var target = lead.target;
                    if (!target) {
                        /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                            this.createProjectionDeltas();
                            this.scheduleRender();
                        }
                        return;
                    }
                    if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
                    else {
                        (0, $kb1og.copyAxisDeltaInto)(this.prevProjectionDelta.x, this.projectionDelta.x);
                        (0, $kb1og.copyAxisDeltaInto)(this.prevProjectionDelta.y, this.projectionDelta.y);
                    }
                    /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $7uBfQ.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
                    if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $cac53.axisDeltaEquals)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $cac53.axisDeltaEquals)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                        this.hasProjected = true;
                        this.scheduleRender();
                        this.notifyListeners("projectionUpdate", target);
                    }
                    /**
             * Increase debug counter for recalculated projections
             */ if ((0, $gncsx.statsBuffer).value) $b3e0b535a24e0dbd$var$metrics.calculatedProjections++;
                }
            },
            {
                key: "hide",
                value: function hide() {
                    this.isVisible = false;
                // TODO: Schedule render
                }
            },
            {
                key: "show",
                value: function show() {
                    this.isVisible = true;
                // TODO: Schedule render
                }
            },
            {
                key: "scheduleRender",
                value: function scheduleRender() {
                    var notifyAll = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    var _this_options_visualElement;
                    (_this_options_visualElement = this.options.visualElement) === null || _this_options_visualElement === void 0 ? void 0 : _this_options_visualElement.scheduleRender();
                    if (notifyAll) {
                        var stack = this.getStack();
                        stack && stack.scheduleRender();
                    }
                    if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
                }
            },
            {
                key: "createProjectionDeltas",
                value: function createProjectionDeltas() {
                    this.prevProjectionDelta = (0, $fQu9K.createDelta)();
                    this.projectionDelta = (0, $fQu9K.createDelta)();
                    this.projectionDeltaWithTransform = (0, $fQu9K.createDelta)();
                }
            },
            {
                key: "setAnimationOrigin",
                value: function setAnimationOrigin(delta) {
                    var _this = this;
                    var hasOnlyRelativeTargetChanged = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, pathFn = arguments.length > 2 ? arguments[2] : void 0;
                    var snapshot = this.snapshot;
                    var snapshotLatestValues = snapshot ? snapshot.latestValues : {};
                    var mixedValues = (0, $kWfK0._)({}, this.latestValues);
                    var targetDelta = (0, $fQu9K.createDelta)();
                    if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
                    this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
                    var relativeLayout = (0, $fQu9K.createBox)();
                    var snapshotSource = snapshot ? snapshot.source : undefined;
                    var layoutSource = this.layout ? this.layout.source : undefined;
                    var isSharedLayoutAnimation = snapshotSource !== layoutSource;
                    var stack = this.getStack();
                    var isOnlyMember = !stack || stack.members.length <= 1;
                    var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($b3e0b535a24e0dbd$var$hasOpacityCrossfade));
                    this.animationProgress = 0;
                    var prevRelativeTarget;
                    // The path decides whether the layout shift is worth curving
                    // (distance floor) and resolves the interpolator from the delta.
                    var interpolate = pathFn === null || pathFn === void 0 ? void 0 : pathFn.interpolateProjection(delta);
                    this.mixTargetDelta = function(latest) {
                        var progress = latest / 1000;
                        var point = interpolate === null || interpolate === void 0 ? void 0 : interpolate(progress);
                        if (point) {
                            targetDelta.x.translate = point.x;
                            targetDelta.x.scale = (0, $gcS1k.mixNumber)(delta.x.scale, 1, progress);
                            targetDelta.x.origin = delta.x.origin;
                            targetDelta.x.originPoint = delta.x.originPoint;
                            targetDelta.y.translate = point.y;
                            targetDelta.y.scale = (0, $gcS1k.mixNumber)(delta.y.scale, 1, progress);
                            targetDelta.y.origin = delta.y.origin;
                            targetDelta.y.originPoint = delta.y.originPoint;
                        } else {
                            $b3e0b535a24e0dbd$var$mixAxisDeltaLinear(targetDelta.x, delta.x, progress);
                            $b3e0b535a24e0dbd$var$mixAxisDeltaLinear(targetDelta.y, delta.y, progress);
                        }
                        _this.setTargetDelta(targetDelta);
                        if (_this.relativeTarget && _this.relativeTargetOrigin && _this.layout && _this.relativeParent && _this.relativeParent.layout) {
                            (0, $7uBfQ.calcRelativePosition)(relativeLayout, _this.layout.layoutBox, _this.relativeParent.layout.layoutBox, _this.options.layoutAnchor || undefined);
                            $b3e0b535a24e0dbd$export$6ffd3e6ae339a132(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress);
                            /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $cac53.boxEquals)(_this.relativeTarget, prevRelativeTarget)) _this.isProjectionDirty = false;
                            if (!prevRelativeTarget) prevRelativeTarget = (0, $fQu9K.createBox)();
                            (0, $kb1og.copyBoxInto)(prevRelativeTarget, _this.relativeTarget);
                        }
                        if (isSharedLayoutAnimation) {
                            _this.animationValues = mixedValues;
                            (0, $fgArx.mixValues)(mixedValues, snapshotLatestValues, _this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                        }
                        if (point && point.rotate !== undefined) {
                            // Dedicated `pathRotation` channel, not `rotate`, so an
                            // animating `rotate` is composed with, never clobbered.
                            if (!_this.animationValues) _this.animationValues = mixedValues;
                            _this.animationValues.pathRotation = point.rotate;
                        }
                        _this.root.scheduleUpdateProjection();
                        _this.scheduleRender();
                        _this.animationProgress = progress;
                    };
                    this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
                }
            },
            {
                key: "startAnimation",
                value: function startAnimation(options) {
                    var _this = this;
                    var _this_currentAnimation, _this_resumingFrom_currentAnimation, _this_resumingFrom;
                    this.notifyListeners("animationStart");
                    (_this_currentAnimation = this.currentAnimation) === null || _this_currentAnimation === void 0 ? void 0 : _this_currentAnimation.stop();
                    (_this_resumingFrom = this.resumingFrom) === null || _this_resumingFrom === void 0 ? void 0 : (_this_resumingFrom_currentAnimation = _this_resumingFrom.currentAnimation) === null || _this_resumingFrom_currentAnimation === void 0 ? void 0 : _this_resumingFrom_currentAnimation.stop();
                    if (this.pendingAnimation) {
                        (0, $dbdHF.cancelFrame)(this.pendingAnimation);
                        this.pendingAnimation = undefined;
                    }
                    /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $dbdHF.frame).update(function() {
                        (0, $bjxbh.globalProjectionState).hasAnimatedSinceResize = true;
                        _this.motionValue || (_this.motionValue = (0, $c1b8l.motionValue)(0));
                        _this.motionValue.jump(0, false);
                        _this.currentAnimation = (0, $axJlk.animateSingleValue)(_this.motionValue, [
                            0,
                            1000
                        ], (0, $hApvp._)((0, $kWfK0._)({}, options), {
                            velocity: 0,
                            isSync: true,
                            onUpdate: function(latest) {
                                _this.mixTargetDelta(latest);
                                options.onUpdate && options.onUpdate(latest);
                            },
                            onComplete: function() {
                                options.onComplete && options.onComplete();
                                _this.completeAnimation();
                            }
                        }));
                        if (_this.resumingFrom) _this.resumingFrom.currentAnimation = _this.currentAnimation;
                        _this.pendingAnimation = undefined;
                    });
                }
            },
            {
                key: "completeAnimation",
                value: function completeAnimation() {
                    if (this.resumingFrom) {
                        this.resumingFrom.currentAnimation = undefined;
                        this.resumingFrom.preserveOpacity = undefined;
                    }
                    var stack = this.getStack();
                    stack && stack.exitAnimationComplete();
                    this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
                    this.notifyListeners("animationComplete");
                }
            },
            {
                key: "finishAnimation",
                value: function finishAnimation() {
                    if (this.currentAnimation) {
                        this.mixTargetDelta && this.mixTargetDelta($b3e0b535a24e0dbd$var$animationTarget);
                        this.currentAnimation.stop();
                    }
                    this.completeAnimation();
                }
            },
            {
                key: "applyTransformsToTarget",
                value: function applyTransformsToTarget() {
                    var lead = this.getLead();
                    var targetWithTransforms = lead.targetWithTransforms, target = lead.target, layout = lead.layout, latestValues = lead.latestValues;
                    if (!targetWithTransforms || !target || !layout) return;
                    /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $b3e0b535a24e0dbd$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                        target = this.target || (0, $fQu9K.createBox)();
                        var xLength = (0, $7uBfQ.calcLength)(this.layout.layoutBox.x);
                        target.x.min = lead.target.x.min;
                        target.x.max = target.x.min + xLength;
                        var yLength = (0, $7uBfQ.calcLength)(this.layout.layoutBox.y);
                        target.y.min = lead.target.y.min;
                        target.y.max = target.y.min + yLength;
                    }
                    (0, $kb1og.copyBoxInto)(targetWithTransforms, target);
                    /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $1QgJK.transformBox)(targetWithTransforms, latestValues);
                    /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $7uBfQ.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
                }
            },
            {
                key: "registerSharedNode",
                value: function registerSharedNode(layoutId, node) {
                    if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $1thxW.NodeStack)());
                    var stack = this.sharedNodes.get(layoutId);
                    stack.add(node);
                    var config = node.options.initialPromotionConfig;
                    node.promote({
                        transition: config ? config.transition : undefined,
                        preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
                    });
                }
            },
            {
                key: "isLead",
                value: function isLead() {
                    var stack = this.getStack();
                    return stack ? stack.lead === this : true;
                }
            },
            {
                key: "getLead",
                value: function getLead() {
                    var _this_getStack;
                    var layoutId = this.options.layoutId;
                    return layoutId ? ((_this_getStack = this.getStack()) === null || _this_getStack === void 0 ? void 0 : _this_getStack.lead) || this : this;
                }
            },
            {
                key: "getPrevLead",
                value: function getPrevLead() {
                    var _this_getStack;
                    var layoutId = this.options.layoutId;
                    return layoutId ? (_this_getStack = this.getStack()) === null || _this_getStack === void 0 ? void 0 : _this_getStack.prevLead : undefined;
                }
            },
            {
                key: "getStack",
                value: function getStack() {
                    var layoutId = this.options.layoutId;
                    if (layoutId) return this.root.sharedNodes.get(layoutId);
                }
            },
            {
                key: "promote",
                value: function promote() {
                    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, needsReset = _ref.needsReset, transition = _ref.transition, preserveFollowOpacity = _ref.preserveFollowOpacity;
                    var stack = this.getStack();
                    if (stack) stack.promote(this, preserveFollowOpacity);
                    if (needsReset) {
                        this.projectionDelta = undefined;
                        this.needsReset = true;
                    }
                    if (transition) this.setOptions({
                        transition: transition
                    });
                }
            },
            {
                key: "relegate",
                value: function relegate() {
                    var stack = this.getStack();
                    if (stack) return stack.relegate(this);
                    else return false;
                }
            },
            {
                key: "resetSkewAndRotation",
                value: function resetSkewAndRotation() {
                    var visualElement = this.options.visualElement;
                    if (!visualElement) return;
                    // If there's no detected skew or rotation values, we can early return without a forced render.
                    var hasDistortingTransform = false;
                    /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ var latestValues = visualElement.latestValues;
                    if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
                    // If there's no distorting values, we don't need to do any more.
                    if (!hasDistortingTransform) return;
                    var resetValues = {};
                    if (latestValues.z) $b3e0b535a24e0dbd$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
                    // Check the skew and rotate value of all axes and reset to 0
                    for(var i = 0; i < $b3e0b535a24e0dbd$var$transformAxes.length; i++){
                        $b3e0b535a24e0dbd$var$resetDistortingTransform("rotate".concat($b3e0b535a24e0dbd$var$transformAxes[i]), visualElement, resetValues, this.animationValues);
                        $b3e0b535a24e0dbd$var$resetDistortingTransform("skew".concat($b3e0b535a24e0dbd$var$transformAxes[i]), visualElement, resetValues, this.animationValues);
                    }
                    // Force a render of this element to apply the transform with all skews and rotations
                    // set to 0.
                    visualElement.render();
                    // Put back all the values we reset
                    for(var key in resetValues){
                        visualElement.setStaticValue(key, resetValues[key]);
                        if (this.animationValues) this.animationValues[key] = resetValues[key];
                    }
                    // Schedule a render for the next frame. This ensures we won't visually
                    // see the element with the reset rotate value applied.
                    visualElement.scheduleRender();
                }
            },
            {
                key: "applyProjectionStyles",
                value: function applyProjectionStyles(targetStyle, styleProp) {
                    if (!this.instance || this.isSVG) return;
                    if (!this.isVisible) {
                        targetStyle.visibility = "hidden";
                        return;
                    }
                    var transformTemplate = this.getTransformTemplate();
                    if (this.needsReset) {
                        this.needsReset = false;
                        targetStyle.visibility = "";
                        targetStyle.opacity = "";
                        targetStyle.pointerEvents = (0, $hQ81U.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                        targetStyle.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                        return;
                    }
                    var lead = this.getLead();
                    if (!this.projectionDelta || !this.layout || !lead.target) {
                        if (this.options.layoutId) {
                            targetStyle.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                            targetStyle.pointerEvents = (0, $hQ81U.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                        }
                        if (this.hasProjected && !(0, $b0Bmd.hasTransform)(this.latestValues)) {
                            targetStyle.transform = transformTemplate ? transformTemplate({}, "") : "none";
                            this.hasProjected = false;
                        }
                        return;
                    }
                    targetStyle.visibility = "";
                    var valuesToRender = lead.animationValues || lead.latestValues;
                    this.applyTransformsToTarget();
                    var transform = (0, $5Ps2W.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
                    if (transformTemplate) transform = transformTemplate(valuesToRender, transform);
                    targetStyle.transform = transform;
                    var _this_projectionDelta = this.projectionDelta, x = _this_projectionDelta.x, y = _this_projectionDelta.y;
                    targetStyle.transformOrigin = "".concat(x.origin * 100, "% ").concat(y.origin * 100, "% 0");
                    var _valuesToRender_opacity, _ref;
                    if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ targetStyle.opacity = lead === this ? (_ref = (_valuesToRender_opacity = valuesToRender.opacity) !== null && _valuesToRender_opacity !== void 0 ? _valuesToRender_opacity : this.latestValues.opacity) !== null && _ref !== void 0 ? _ref : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
                    else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
                    /**
             * Apply scale correction
             */ for(var key in 0, $dlAPu.scaleCorrectors){
                        if (valuesToRender[key] === undefined) continue;
                        var _scaleCorrectors_key = (0, $dlAPu.scaleCorrectors)[key], correct = _scaleCorrectors_key.correct, applyTo = _scaleCorrectors_key.applyTo, isCSSVariable = _scaleCorrectors_key.isCSSVariable;
                        /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ var corrected = transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                        if (applyTo) {
                            var num = applyTo.length;
                            for(var i = 0; i < num; i++)targetStyle[applyTo[i]] = corrected;
                        } else // If this is a CSS variable, set it directly on the instance.
                        // Replacing this function from creating styles to setting them
                        // would be a good place to remove per frame object creation
                        if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                        else targetStyle[key] = corrected;
                    }
                    /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) targetStyle.pointerEvents = lead === this ? (0, $hQ81U.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
                }
            },
            {
                key: "clearSnapshot",
                value: function clearSnapshot() {
                    this.resumeFrom = this.snapshot = undefined;
                }
            },
            {
                // Only run on root
                key: "resetTree",
                value: function resetTree() {
                    this.root.nodes.forEach(function(node) {
                        var _node_currentAnimation;
                        return (_node_currentAnimation = node.currentAnimation) === null || _node_currentAnimation === void 0 ? void 0 : _node_currentAnimation.stop();
                    });
                    this.root.nodes.forEach($b3e0b535a24e0dbd$var$clearMeasurements);
                    this.root.sharedNodes.clear();
                }
            }
        ]);
        return ProjectionNode;
    }();
}
function $b3e0b535a24e0dbd$var$updateLayout(node) {
    node.updateLayout();
}
function $b3e0b535a24e0dbd$var$notifyLayoutUpdate(node) {
    var _node_resumeFrom;
    var snapshot = ((_node_resumeFrom = node.resumeFrom) === null || _node_resumeFrom === void 0 ? void 0 : _node_resumeFrom.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        var _node_layout = node.layout, layout = _node_layout.layoutBox, measuredLayout = _node_layout.measuredBox;
        var animationType = node.options.animationType;
        var isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $90ti6.eachAxis)(function(axis) {
            var axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            var length = (0, $7uBfQ.calcLength)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (animationType === "x" || animationType === "y") {
            var snapAxis = animationType === "x" ? "y" : "x";
            (0, $kb1og.copyAxisInto)(isShared ? snapshot.measuredBox[snapAxis] : snapshot.layoutBox[snapAxis], layout[snapAxis]);
        } else if ($b3e0b535a24e0dbd$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $90ti6.eachAxis)(function(axis) {
            var axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            var length = (0, $7uBfQ.calcLength)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        var layoutDelta = (0, $fQu9K.createDelta)();
        (0, $7uBfQ.calcBoxDelta)(layoutDelta, layout, snapshot.layoutBox);
        var visualDelta = (0, $fQu9K.createDelta)();
        if (isShared) (0, $7uBfQ.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $7uBfQ.calcBoxDelta)(visualDelta, layout, snapshot.layoutBox);
        var hasLayoutChanged = !(0, $cac53.isDeltaZero)(layoutDelta);
        var hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            var relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                var parentSnapshot = relativeParent.snapshot, parentLayout = relativeParent.layout;
                if (parentSnapshot && parentLayout) {
                    var anchor = node.options.layoutAnchor || undefined;
                    var relativeSnapshot = (0, $fQu9K.createBox)();
                    (0, $7uBfQ.calcRelativePosition)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox, anchor);
                    var relativeLayout = (0, $fQu9K.createBox)();
                    (0, $7uBfQ.calcRelativePosition)(relativeLayout, layout, parentLayout.layoutBox, anchor);
                    if (!(0, $cac53.boxEqualsRounded)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        var onExitComplete = node.options.onExitComplete;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $b3e0b535a24e0dbd$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $gncsx.statsBuffer).value) $b3e0b535a24e0dbd$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $b3e0b535a24e0dbd$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $b3e0b535a24e0dbd$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $b3e0b535a24e0dbd$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $b3e0b535a24e0dbd$var$forceLayoutMeasure(node) {
    node.isLayoutDirty = true;
    node.updateLayout();
}
function $b3e0b535a24e0dbd$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
/**
 * When a node is animation-blocked (e.g. during drag) and its component
 * didn't re-render (memoized), willUpdate() is never called so there's
 * no snapshot. Use the previous layout as a snapshot and mark dirty so
 * resetTransform/updateLayout/notifyLayoutUpdate process it normally.
 */ function $b3e0b535a24e0dbd$var$ensureDraggedNodesSnapshotted(node) {
    if (node.isAnimationBlocked && node.layout && !node.isLayoutDirty) {
        node.snapshot = node.layout;
        node.isLayoutDirty = true;
    }
}
function $b3e0b535a24e0dbd$var$resetTransformStyle(node) {
    var visualElement = node.options.visualElement;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $b3e0b535a24e0dbd$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $b3e0b535a24e0dbd$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $b3e0b535a24e0dbd$var$calcProjection(node) {
    node.calcProjection();
}
function $b3e0b535a24e0dbd$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $b3e0b535a24e0dbd$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $b3e0b535a24e0dbd$var$mixAxisDeltaLinear(output, delta, p) {
    output.translate = (0, $gcS1k.mixNumber)(delta.translate, 0, p);
    output.scale = (0, $gcS1k.mixNumber)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $b3e0b535a24e0dbd$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $gcS1k.mixNumber)(from.min, to.min, p);
    output.max = (0, $gcS1k.mixNumber)(from.max, to.max, p);
}
function $b3e0b535a24e0dbd$export$6ffd3e6ae339a132(output, from, to, p) {
    $b3e0b535a24e0dbd$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $b3e0b535a24e0dbd$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $b3e0b535a24e0dbd$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
var $b3e0b535a24e0dbd$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
var $b3e0b535a24e0dbd$var$userAgentContains = function(string) {
    return typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
};
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ var $b3e0b535a24e0dbd$var$roundPoint = $b3e0b535a24e0dbd$var$userAgentContains("applewebkit/") && !$b3e0b535a24e0dbd$var$userAgentContains("chrome/") ? Math.round : (0, $386Yo.noop);
function $b3e0b535a24e0dbd$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $b3e0b535a24e0dbd$var$roundPoint(axis.min);
    axis.max = $b3e0b535a24e0dbd$var$roundPoint(axis.max);
}
function $b3e0b535a24e0dbd$var$roundBox(box) {
    $b3e0b535a24e0dbd$var$roundAxis(box.x);
    $b3e0b535a24e0dbd$var$roundAxis(box.y);
}
function $b3e0b535a24e0dbd$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $7uBfQ.isNear)((0, $cac53.aspectRatio)(snapshot), (0, $cac53.aspectRatio)(layout), 0.2);
}
function $b3e0b535a24e0dbd$var$checkNodeWasScrollRoot(node) {
    var _node_scroll;
    return node !== node.root && ((_node_scroll = node.scroll) === null || _node_scroll === void 0 ? void 0 : _node_scroll.wasRoot);
}

});
parcelRegister("axJlk", function(module, exports) {

$parcel$export(module.exports, "animateSingleValue", function () { return $b1d29f940ca76d80$export$335a17c977067b99; });

var $6addk = parcelRequire("6addk");

var $c1b8l = parcelRequire("c1b8l");

var $kbjZS = parcelRequire("kbjZS");
function $b1d29f940ca76d80$export$335a17c977067b99(value, keyframes, options) {
    var motionValue$1 = (0, $kbjZS.isMotionValue)(value) ? value : (0, $c1b8l.motionValue)(value);
    motionValue$1.start((0, $6addk.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

});

parcelRegister("gncsx", function(module, exports) {

$parcel$export(module.exports, "statsBuffer", function () { return $11fc68809afb7c13$export$84ce9a476f53d110; });
var $11fc68809afb7c13$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};

});

parcelRegister("92etN", function(module, exports) {

$parcel$export(module.exports, "delay", function () { return $6806e06597a5480a$export$1391212d75b2ee65; });

var $i1wr7 = parcelRequire("i1wr7");

var $8wJkX = parcelRequire("8wJkX");

var $dbdHF = parcelRequire("dbdHF");
/**
 * Timeout defined in ms
 */ function $6806e06597a5480a$export$1391212d75b2ee65(callback, timeout) {
    var start = (0, $i1wr7.time).now();
    var checkElapsed = function(param) {
        var timestamp = param.timestamp;
        var elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $dbdHF.cancelFrame)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $dbdHF.frame).setup(checkElapsed, true);
    return function() {
        return (0, $dbdHF.cancelFrame)(checkElapsed);
    };
}
function $6806e06597a5480a$export$fcd451ca460f8a2a(callback, timeout) {
    return $6806e06597a5480a$export$1391212d75b2ee65(callback, (0, $8wJkX.secondsToMilliseconds)(timeout));
}

});

parcelRegister("iqAnM", function(module, exports) {

$parcel$export(module.exports, "isSVGSVGElement", function () { return $c5504953f6a59e04$export$66957ea77182581d; });

var $jAGjK = parcelRequire("jAGjK");
/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $c5504953f6a59e04$export$66957ea77182581d(element) {
    return (0, $jAGjK.isSVGElement)(element) && element.tagName === "svg";
}

});

parcelRegister("fgArx", function(module, exports) {

$parcel$export(module.exports, "mixValues", function () { return $a4801f6e0e7cae22$export$739e279c17d51c3d; });

var $gcS1k = parcelRequire("gcS1k");

var $huIQG = parcelRequire("huIQG");

var $6XAIX = parcelRequire("6XAIX");
var $386Yo = parcelRequire("386Yo");
var $brqzr = parcelRequire("brqzr");

var $9dNjD = parcelRequire("9dNjD");
var $a4801f6e0e7cae22$var$numBorders = (0, $9dNjD.cornerRadiusProps).length;
var $a4801f6e0e7cae22$var$asNumber = function(value) {
    return typeof value === "string" ? parseFloat(value) : value;
};
var $a4801f6e0e7cae22$var$isPx = function(value) {
    return typeof value === "number" || (0, $huIQG.px).test(value);
};
function $a4801f6e0e7cae22$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _follow_opacity, _lead_opacity;
    if (shouldCrossfadeOpacity) {
        var _lead_opacity1;
        target.opacity = (0, $gcS1k.mixNumber)(0, (_lead_opacity1 = lead.opacity) !== null && _lead_opacity1 !== void 0 ? _lead_opacity1 : 1, $a4801f6e0e7cae22$var$easeCrossfadeIn(progress));
        var _follow_opacity1;
        target.opacityExit = (0, $gcS1k.mixNumber)((_follow_opacity1 = follow.opacity) !== null && _follow_opacity1 !== void 0 ? _follow_opacity1 : 1, 0, $a4801f6e0e7cae22$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $gcS1k.mixNumber)((_follow_opacity = follow.opacity) !== null && _follow_opacity !== void 0 ? _follow_opacity : 1, (_lead_opacity = lead.opacity) !== null && _lead_opacity !== void 0 ? _lead_opacity : 1, progress);
    /**
     * Mix border radius
     */ for(var i = 0; i < $a4801f6e0e7cae22$var$numBorders; i++){
        var borderLabel = (0, $9dNjD.cornerRadiusProps)[i];
        var followRadius = $a4801f6e0e7cae22$var$getRadius(follow, borderLabel);
        var leadRadius = $a4801f6e0e7cae22$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        var canMix = followRadius === 0 || leadRadius === 0 || $a4801f6e0e7cae22$var$isPx(followRadius) === $a4801f6e0e7cae22$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $gcS1k.mixNumber)($a4801f6e0e7cae22$var$asNumber(followRadius), $a4801f6e0e7cae22$var$asNumber(leadRadius), progress), 0);
            if ((0, $huIQG.percent).test(leadRadius) || (0, $huIQG.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $gcS1k.mixNumber)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $a4801f6e0e7cae22$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
var $a4801f6e0e7cae22$var$easeCrossfadeIn = /*@__PURE__*/ $a4801f6e0e7cae22$var$compress(0, 0.5, (0, $6XAIX.circOut));
var $a4801f6e0e7cae22$var$easeCrossfadeOut = /*@__PURE__*/ $a4801f6e0e7cae22$var$compress(0.5, 0.95, (0, $386Yo.noop));
function $a4801f6e0e7cae22$var$compress(min, max, easing) {
    return function(p) {
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $brqzr.progress)(min, max, p));
    };
}

});

parcelRegister("kb1og", function(module, exports) {

$parcel$export(module.exports, "copyAxisInto", function () { return $545aee9c438caf08$export$a0230ae482601ae8; });
$parcel$export(module.exports, "copyBoxInto", function () { return $545aee9c438caf08$export$c53fd88f45d77e4b; });
$parcel$export(module.exports, "copyAxisDeltaInto", function () { return $545aee9c438caf08$export$8ead6a7d6b225ef; });
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $545aee9c438caf08$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $545aee9c438caf08$export$c53fd88f45d77e4b(box, originBox) {
    $545aee9c438caf08$export$a0230ae482601ae8(box.x, originBox.x);
    $545aee9c438caf08$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $545aee9c438caf08$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}

});

parcelRegister("iu6nW", function(module, exports) {

$parcel$export(module.exports, "removeBoxTransforms", function () { return $78af50879d71c5b5$export$73e1ad0a9694e25c; });

var $6ZpBv = parcelRequire("6ZpBv");

var $gcS1k = parcelRequire("gcS1k");

var $huIQG = parcelRequire("huIQG");

var $1QgJK = parcelRequire("1QgJK");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $78af50879d71c5b5$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $1QgJK.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $1QgJK.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $78af50879d71c5b5$export$cc12a0672fae5b4a(axis) {
    var translate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, scale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, origin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5, boxScale = arguments.length > 4 ? arguments[4] : void 0, originAxis = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : axis, sourceAxis = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : axis;
    if ((0, $huIQG.percent).test(translate)) {
        translate = parseFloat(translate);
        var relativeProgress = (0, $gcS1k.mixNumber)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    var originPoint = (0, $gcS1k.mixNumber)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $78af50879d71c5b5$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $78af50879d71c5b5$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $78af50879d71c5b5$export$42b76f1d0d16d5b(axis, transforms, param, origin, sourceAxis) {
    var _param = (0, $6ZpBv._)(param, 3), key = _param[0], scaleKey = _param[1], originKey = _param[2];
    $78af50879d71c5b5$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $78af50879d71c5b5$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $78af50879d71c5b5$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $78af50879d71c5b5$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $78af50879d71c5b5$export$42b76f1d0d16d5b(box.x, transforms, $78af50879d71c5b5$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $78af50879d71c5b5$export$42b76f1d0d16d5b(box.y, transforms, $78af50879d71c5b5$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

});

parcelRegister("cac53", function(module, exports) {

$parcel$export(module.exports, "isDeltaZero", function () { return $3e2fc7f47774de68$export$a7ec7642fe550fb6; });
$parcel$export(module.exports, "boxEquals", function () { return $3e2fc7f47774de68$export$8d5cf76bb7daff09; });
$parcel$export(module.exports, "boxEqualsRounded", function () { return $3e2fc7f47774de68$export$ef641b782d85522; });
$parcel$export(module.exports, "aspectRatio", function () { return $3e2fc7f47774de68$export$c5706146bc63213; });
$parcel$export(module.exports, "axisDeltaEquals", function () { return $3e2fc7f47774de68$export$444620505e28fe92; });

var $7uBfQ = parcelRequire("7uBfQ");
function $3e2fc7f47774de68$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $3e2fc7f47774de68$export$a7ec7642fe550fb6(delta) {
    return $3e2fc7f47774de68$var$isAxisDeltaZero(delta.x) && $3e2fc7f47774de68$var$isAxisDeltaZero(delta.y);
}
function $3e2fc7f47774de68$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $3e2fc7f47774de68$export$8d5cf76bb7daff09(a, b) {
    return $3e2fc7f47774de68$export$7a9a6f114ddd0fdb(a.x, b.x) && $3e2fc7f47774de68$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $3e2fc7f47774de68$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $3e2fc7f47774de68$export$ef641b782d85522(a, b) {
    return $3e2fc7f47774de68$export$22adf28bfca1c186(a.x, b.x) && $3e2fc7f47774de68$export$22adf28bfca1c186(a.y, b.y);
}
function $3e2fc7f47774de68$export$c5706146bc63213(box) {
    return (0, $7uBfQ.calcLength)(box.x) / (0, $7uBfQ.calcLength)(box.y);
}
function $3e2fc7f47774de68$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}

});

parcelRegister("1thxW", function(module, exports) {

$parcel$export(module.exports, "NodeStack", function () { return $9db1e0afbc594f28$export$39be5b2d82fc9dc7; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $GsJqF = parcelRequire("GsJqF");
var $9db1e0afbc594f28$export$39be5b2d82fc9dc7 = /*#__PURE__*/ function() {
    "use strict";
    function NodeStack() {
        (0, $4QweW._)(this, NodeStack);
        this.members = [];
    }
    (0, $6hK4i._)(NodeStack, [
        {
            key: "add",
            value: function add(node) {
                (0, $GsJqF.addUniqueItem)(this.members, node);
                for(var i = this.members.length - 1; i >= 0; i--){
                    var member = this.members[i];
                    if (member === node || member === this.lead || member === this.prevLead) continue;
                    var inst = member.instance;
                    if ((!inst || inst.isConnected === false) && !member.snapshot) {
                        (0, $GsJqF.removeItem)(this.members, member);
                        member.unmount();
                    }
                }
                node.scheduleRender();
            }
        },
        {
            key: "remove",
            value: function remove(node) {
                (0, $GsJqF.removeItem)(this.members, node);
                if (node === this.prevLead) this.prevLead = undefined;
                if (node === this.lead) {
                    var prevLead = this.members[this.members.length - 1];
                    if (prevLead) this.promote(prevLead);
                }
            }
        },
        {
            key: "relegate",
            value: function relegate(node) {
                for(var i = this.members.indexOf(node) - 1; i >= 0; i--){
                    var _member_instance;
                    var member = this.members[i];
                    if (member.isPresent !== false && ((_member_instance = member.instance) === null || _member_instance === void 0 ? void 0 : _member_instance.isConnected) !== false) {
                        this.promote(member);
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "promote",
            value: function promote(node, preserveFollowOpacity) {
                var prevLead = this.lead;
                if (node === prevLead) return;
                this.prevLead = prevLead;
                this.lead = node;
                node.show();
                if (prevLead) {
                    prevLead.updateSnapshot();
                    node.scheduleRender();
                    var _prevLead_options = prevLead.options, prevDep = _prevLead_options.layoutDependency;
                    var _node_options = node.options, nextDep = _node_options.layoutDependency;
                    if (prevDep === undefined || prevDep !== nextDep) {
                        var _node_root;
                        node.resumeFrom = prevLead;
                        if (preserveFollowOpacity) prevLead.preserveOpacity = true;
                        if (prevLead.snapshot) {
                            node.snapshot = prevLead.snapshot;
                            node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                        }
                        if ((_node_root = node.root) === null || _node_root === void 0 ? void 0 : _node_root.isUpdating) node.isLayoutDirty = true;
                    }
                    if (node.options.crossfade === false) prevLead.hide();
                }
            }
        },
        {
            key: "exitAnimationComplete",
            value: function exitAnimationComplete() {
                this.members.forEach(function(member) {
                    var _member_options_onExitComplete, _member_options, _member_resumingFrom_options_onExitComplete, _member_resumingFrom, _member_resumingFrom_options;
                    (_member_options_onExitComplete = (_member_options = member.options).onExitComplete) === null || _member_options_onExitComplete === void 0 ? void 0 : _member_options_onExitComplete.call(_member_options);
                    (_member_resumingFrom = member.resumingFrom) === null || _member_resumingFrom === void 0 ? void 0 : (_member_resumingFrom_options_onExitComplete = (_member_resumingFrom_options = _member_resumingFrom.options).onExitComplete) === null || _member_resumingFrom_options_onExitComplete === void 0 ? void 0 : _member_resumingFrom_options_onExitComplete.call(_member_resumingFrom_options);
                });
            }
        },
        {
            key: "scheduleRender",
            value: function scheduleRender() {
                this.members.forEach(function(member) {
                    return member.instance && member.scheduleRender(false);
                });
            }
        },
        {
            key: "removeLeadSnapshot",
            value: function removeLeadSnapshot() {
                var _this_lead;
                if ((_this_lead = this.lead) === null || _this_lead === void 0 ? void 0 : _this_lead.snapshot) this.lead.snapshot = undefined;
            }
        }
    ]);
    return NodeStack;
}();

});

parcelRegister("5Ps2W", function(module, exports) {

$parcel$export(module.exports, "buildProjectionTransform", function () { return $9771b7e097ce68e9$export$d33653b270fe725c; });
function $9771b7e097ce68e9$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    var transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = delta.x.translate / treeScale.x;
    var yTranslate = delta.y.translate / treeScale.y;
    var zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, ").concat(zTranslate, "px) ");
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += "scale(".concat(1 / treeScale.x, ", ").concat(1 / treeScale.y, ") ");
    if (latestTransform) {
        var transformPerspective = latestTransform.transformPerspective, rotate = latestTransform.rotate, pathRotation = latestTransform.pathRotation, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY, skewX = latestTransform.skewX, skewY = latestTransform.skewY;
        if (transformPerspective) transform = "perspective(".concat(transformPerspective, "px) ").concat(transform);
        if (rotate) transform += "rotate(".concat(rotate, "deg) ");
        // Additive `rotate()` so user `rotate` isn't clobbered.
        if (pathRotation) transform += "rotate(".concat(pathRotation, "deg) ");
        if (rotateX) transform += "rotateX(".concat(rotateX, "deg) ");
        if (rotateY) transform += "rotateY(".concat(rotateY, "deg) ");
        if (skewX) transform += "skewX(".concat(skewX, "deg) ");
        if (skewY) transform += "skewY(".concat(skewY, "deg) ");
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ var elementScaleX = delta.x.scale * treeScale.x;
    var elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += "scale(".concat(elementScaleX, ", ").concat(elementScaleY, ")");
    return transform || "none";
}

});

parcelRegister("ax5AE", function(module, exports) {

$parcel$export(module.exports, "FlatTree", function () { return $2049e42891ddd2b7$export$1465d17e3de78a96; });

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $GsJqF = parcelRequire("GsJqF");

var $dWD1V = parcelRequire("dWD1V");
var $2049e42891ddd2b7$export$1465d17e3de78a96 = /*#__PURE__*/ function() {
    "use strict";
    function FlatTree() {
        (0, $4QweW._)(this, FlatTree);
        this.children = [];
        this.isDirty = false;
    }
    (0, $6hK4i._)(FlatTree, [
        {
            key: "add",
            value: function add(child) {
                (0, $GsJqF.addUniqueItem)(this.children, child);
                this.isDirty = true;
            }
        },
        {
            key: "remove",
            value: function remove(child) {
                (0, $GsJqF.removeItem)(this.children, child);
                this.isDirty = true;
            }
        },
        {
            key: "forEach",
            value: function forEach(callback) {
                this.isDirty && this.children.sort((0, $dWD1V.compareByDepth));
                this.isDirty = false;
                this.children.forEach(callback);
            }
        }
    ]);
    return FlatTree;
}();

});
parcelRegister("dWD1V", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", function () { return $902ed94d0b8a223e$export$d689d9dec5ad338; });
var $902ed94d0b8a223e$export$d689d9dec5ad338 = function(a, b) {
    return a.depth - b.depth;
};

});



parcelRegister("jfppa", function(module, exports) {

$parcel$export(module.exports, "DocumentProjectionNode", function () { return $23a18502530a8893$export$2d029a49a09b6177; });

var $gdlUx = parcelRequire("gdlUx");

var $2vdFJ = parcelRequire("2vdFJ");
var $23a18502530a8893$export$2d029a49a09b6177 = (0, $2vdFJ.createProjectionNode)({
    attachResizeListener: function(ref, notify) {
        return (0, $gdlUx.addDomEvent)(ref, "resize", notify);
    },
    measureScroll: function() {
        var _document_body, _document_body1;
        return {
            x: document.documentElement.scrollLeft || ((_document_body = document.body) === null || _document_body === void 0 ? void 0 : _document_body.scrollLeft) || 0,
            y: document.documentElement.scrollTop || ((_document_body1 = document.body) === null || _document_body1 === void 0 ? void 0 : _document_body1.scrollTop) || 0
        };
    },
    checkIsScrollRoot: function() {
        return true;
    }
});

});



parcelRegister("9pvbx", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", function () { return $ea07f08ad92d594e$export$e5b72898e5a201f1; });

var $2rqhW = parcelRequire("2rqhW");

var $6DRcK = parcelRequire("6DRcK");

var $c16C2 = parcelRequire("c16C2");

var $kxeSa = parcelRequire("kxeSa");
var $ea07f08ad92d594e$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $kxeSa.InViewFeature)
    },
    tap: {
        Feature: (0, $c16C2.PressGesture)
    },
    focus: {
        Feature: (0, $6DRcK.FocusGesture)
    },
    hover: {
        Feature: (0, $2rqhW.HoverGesture)
    }
};

});
parcelRegister("2rqhW", function(module, exports) {

$parcel$export(module.exports, "HoverGesture", function () { return $7e59f41cc959a562$export$93a81ea037eac456; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $ledP3 = parcelRequire("ledP3");
var $dbdHF = parcelRequire("dbdHF");
var $1tbge = parcelRequire("1tbge");

var $4WE5h = parcelRequire("4WE5h");
function $7e59f41cc959a562$var$handleHoverEvent(node, event, lifecycle) {
    var props = node.props;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    var eventName = "onHover" + lifecycle;
    var callback = props[eventName];
    if (callback) (0, $dbdHF.frame).postRender(function() {
        return callback(event, (0, $4WE5h.extractEventInfo)(event));
    });
}
var $7e59f41cc959a562$export$93a81ea037eac456 = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $c2MhV._)(HoverGesture, Feature);
    function HoverGesture() {
        (0, $4QweW._)(this, HoverGesture);
        return (0, $ehF45._)(this, HoverGesture, arguments);
    }
    (0, $6hK4i._)(HoverGesture, [
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                var current = this.node.current;
                if (!current) return;
                this.unmount = (0, $1tbge.hover)(current, function(_element, startEvent) {
                    $7e59f41cc959a562$var$handleHoverEvent(_this.node, startEvent, "Start");
                    return function(endEvent) {
                        return $7e59f41cc959a562$var$handleHoverEvent(_this.node, endEvent, "End");
                    };
                });
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return HoverGesture;
}((0, $ledP3.Feature));

});
parcelRegister("1tbge", function(module, exports) {

$parcel$export(module.exports, "hover", function () { return $328e381ff42c5688$export$3f60957f5dbf3876; });

var $6ZpBv = parcelRequire("6ZpBv");

var $lxJgL = parcelRequire("lxJgL");

var $fTVhK = parcelRequire("fTVhK");
function $328e381ff42c5688$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $lxJgL.isDragActive)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $328e381ff42c5688$export$3f60957f5dbf3876(elementOrSelector, onHoverStart) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _setupGesture = (0, $6ZpBv._)((0, $fTVhK.setupGesture)(elementOrSelector, options), 3), elements = _setupGesture[0], eventOptions = _setupGesture[1], cancel = _setupGesture[2];
    elements.forEach(function(element) {
        var isPressed = false;
        var deferredHoverEnd = false;
        var hoverEndCallback;
        var removePointerLeave = function() {
            element.removeEventListener("pointerleave", onPointerLeave);
        };
        var endHover = function(event) {
            if (hoverEndCallback) {
                hoverEndCallback(event);
                hoverEndCallback = undefined;
            }
            removePointerLeave();
        };
        var onPointerUp = function(event) {
            isPressed = false;
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerUp);
            if (deferredHoverEnd) {
                deferredHoverEnd = false;
                endHover(event);
            }
        };
        var onPointerDown = function() {
            isPressed = true;
            window.addEventListener("pointerup", onPointerUp, eventOptions);
            window.addEventListener("pointercancel", onPointerUp, eventOptions);
        };
        var onPointerLeave = function(leaveEvent) {
            if (leaveEvent.pointerType === "touch") return;
            if (isPressed) {
                deferredHoverEnd = true;
                return;
            }
            endHover(leaveEvent);
        };
        var onPointerEnter = function(enterEvent) {
            if (!$328e381ff42c5688$var$isValidHover(enterEvent)) return;
            deferredHoverEnd = false;
            var onHoverEnd = onHoverStart(element, enterEvent);
            if (typeof onHoverEnd !== "function") return;
            hoverEndCallback = onHoverEnd;
            element.addEventListener("pointerleave", onPointerLeave, eventOptions);
        };
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
        element.addEventListener("pointerdown", onPointerDown, eventOptions);
    });
    return cancel;
}

});
parcelRegister("fTVhK", function(module, exports) {

$parcel$export(module.exports, "setupGesture", function () { return $f4651a6ccd368a47$export$edc0ace9d5e7e842; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $6aL4O = parcelRequire("6aL4O");
function $f4651a6ccd368a47$export$edc0ace9d5e7e842(elementOrSelector, options) {
    var elements = (0, $6aL4O.resolveElements)(elementOrSelector);
    var gestureAbortController = new AbortController();
    var eventOptions = (0, $hApvp._)((0, $kWfK0._)({
        passive: true
    }, options), {
        signal: gestureAbortController.signal
    });
    var cancel = function() {
        return gestureAbortController.abort();
    };
    return [
        elements,
        eventOptions,
        cancel
    ];
}

});



parcelRegister("6DRcK", function(module, exports) {

$parcel$export(module.exports, "FocusGesture", function () { return $b0046c8f23fa00ee$export$d4826db40d47595b; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $gdlUx = parcelRequire("gdlUx");
var $ledP3 = parcelRequire("ledP3");

var $5Hogw = parcelRequire("5Hogw");
var $b0046c8f23fa00ee$export$d4826db40d47595b = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $c2MhV._)(FocusGesture, Feature);
    function FocusGesture() {
        (0, $4QweW._)(this, FocusGesture);
        var _this;
        _this = (0, $ehF45._)(this, FocusGesture, arguments);
        _this.isActive = false;
        return _this;
    }
    (0, $6hK4i._)(FocusGesture, [
        {
            key: "onFocus",
            value: function onFocus() {
                var isFocusVisible = false;
                /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
                    isFocusVisible = this.node.current.matches(":focus-visible");
                } catch (e) {
                    isFocusVisible = true;
                }
                if (!isFocusVisible || !this.node.animationState) return;
                this.node.animationState.setActive("whileFocus", true);
                this.isActive = true;
            }
        },
        {
            key: "onBlur",
            value: function onBlur() {
                if (!this.isActive || !this.node.animationState) return;
                this.node.animationState.setActive("whileFocus", false);
                this.isActive = false;
            }
        },
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                this.unmount = (0, $5Hogw.pipe)((0, $gdlUx.addDomEvent)(this.node.current, "focus", function() {
                    return _this.onFocus();
                }), (0, $gdlUx.addDomEvent)(this.node.current, "blur", function() {
                    return _this.onBlur();
                }));
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return FocusGesture;
}((0, $ledP3.Feature));

});

parcelRegister("c16C2", function(module, exports) {

$parcel$export(module.exports, "PressGesture", function () { return $e59c9008873e152d$export$f026abdbba7f0c9e; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $ledP3 = parcelRequire("ledP3");
var $dbdHF = parcelRequire("dbdHF");
var $e0zlZ = parcelRequire("e0zlZ");

var $4WE5h = parcelRequire("4WE5h");
function $e59c9008873e152d$var$handlePressEvent(node, event, lifecycle) {
    var props = node.props;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    var eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    var callback = props[eventName];
    if (callback) (0, $dbdHF.frame).postRender(function() {
        return callback(event, (0, $4WE5h.extractEventInfo)(event));
    });
}
var $e59c9008873e152d$export$f026abdbba7f0c9e = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $c2MhV._)(PressGesture, Feature);
    function PressGesture() {
        (0, $4QweW._)(this, PressGesture);
        return (0, $ehF45._)(this, PressGesture, arguments);
    }
    (0, $6hK4i._)(PressGesture, [
        {
            key: "mount",
            value: function mount() {
                var _this = this;
                var current = this.node.current;
                if (!current) return;
                var _this_node_props = this.node.props, globalTapTarget = _this_node_props.globalTapTarget, propagate = _this_node_props.propagate;
                this.unmount = (0, $e0zlZ.press)(current, function(_element, startEvent) {
                    $e59c9008873e152d$var$handlePressEvent(_this.node, startEvent, "Start");
                    return function(endEvent, param) {
                        var success = param.success;
                        return $e59c9008873e152d$var$handlePressEvent(_this.node, endEvent, success ? "End" : "Cancel");
                    };
                }, {
                    useGlobalTarget: globalTapTarget,
                    stopPropagation: (propagate === null || propagate === void 0 ? void 0 : propagate.tap) === false
                });
            }
        },
        {
            key: "unmount",
            value: function unmount() {}
        }
    ]);
    return PressGesture;
}((0, $ledP3.Feature));

});
parcelRegister("e0zlZ", function(module, exports) {

$parcel$export(module.exports, "press", function () { return $ba6c665c9afcb286$export$dbe9198142dace0c; });

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $6ZpBv = parcelRequire("6ZpBv");

var $dDCFH = parcelRequire("dDCFH");

var $lxJgL = parcelRequire("lxJgL");

var $2MNAC = parcelRequire("2MNAC");

var $k8Wl0 = parcelRequire("k8Wl0");

var $fTVhK = parcelRequire("fTVhK");

var $5g9nM = parcelRequire("5g9nM");

var $fnTzo = parcelRequire("fnTzo");

var $ffU57 = parcelRequire("ffU57");
/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $ba6c665c9afcb286$var$isValidPressEvent(event) {
    return (0, $k8Wl0.isPrimaryPointer)(event) && !(0, $lxJgL.isDragActive)();
}
var $ba6c665c9afcb286$var$claimedPointerDownEvents = new WeakSet();
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $ba6c665c9afcb286$export$dbe9198142dace0c(targetOrSelector, onPressStart) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _setupGesture = (0, $6ZpBv._)((0, $fTVhK.setupGesture)(targetOrSelector, options), 3), targets = _setupGesture[0], eventOptions = _setupGesture[1], cancelEvents = _setupGesture[2];
    var startPress = function(startEvent) {
        var target = startEvent.currentTarget;
        if (!$ba6c665c9afcb286$var$isValidPressEvent(startEvent)) return;
        if ($ba6c665c9afcb286$var$claimedPointerDownEvents.has(startEvent)) return;
        (0, $ffU57.isPressing).add(target);
        if (options.stopPropagation) $ba6c665c9afcb286$var$claimedPointerDownEvents.add(startEvent);
        var onPressEnd = onPressStart(target, startEvent);
        /**
         * End listeners run in the capture phase so a descendant calling
         * stopPropagation() in its own pointerup handler can't prevent the
         * press gesture from ending. This also keeps the gesture-end
         * ordering consistent with the drag gesture. See #2794.
         */ var endEventOptions = (0, $hApvp._)((0, $kWfK0._)({}, eventOptions), {
            capture: true
        });
        var onPointerEnd = function(endEvent, success) {
            window.removeEventListener("pointerup", onPointerUp, endEventOptions);
            window.removeEventListener("pointercancel", onPointerCancel, endEventOptions);
            if ((0, $ffU57.isPressing).has(target)) (0, $ffU57.isPressing).delete(target);
            if (!$ba6c665c9afcb286$var$isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        var onPointerUp = function(upEvent) {
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $2MNAC.isNodeOrChild)(target, upEvent.target));
        };
        var onPointerCancel = function(cancelEvent) {
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, endEventOptions);
        window.addEventListener("pointercancel", onPointerCancel, endEventOptions);
    };
    targets.forEach(function(target) {
        var pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, $dDCFH.isHTMLElement)(target)) {
            target.addEventListener("focus", function(event) {
                return (0, $fnTzo.enableKeyboardPress)(event, eventOptions);
            });
            if (!(0, $5g9nM.isElementKeyboardAccessible)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}

});
parcelRegister("2MNAC", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", function () { return $faa01d0a965af9b8$export$e841ada32ff745b; });
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var $faa01d0a965af9b8$export$e841ada32ff745b = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return $faa01d0a965af9b8$export$e841ada32ff745b(parent, child.parentElement);
};

});

parcelRegister("fnTzo", function(module, exports) {

$parcel$export(module.exports, "enableKeyboardPress", function () { return $494fe4895ce604d1$export$4b5790288fe12a79; });

var $ffU57 = parcelRequire("ffU57");
/**
 * Filter out events that are not "Enter" keys.
 */ function $494fe4895ce604d1$var$filterEvents(callback) {
    return function(event) {
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $494fe4895ce604d1$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
var $494fe4895ce604d1$export$4b5790288fe12a79 = function(focusEvent, eventOptions) {
    var element = focusEvent.currentTarget;
    if (!element) return;
    var handleKeydown = $494fe4895ce604d1$var$filterEvents(function() {
        if ((0, $ffU57.isPressing).has(element)) return;
        $494fe4895ce604d1$var$firePointerEvent(element, "down");
        var handleKeyup = $494fe4895ce604d1$var$filterEvents(function() {
            $494fe4895ce604d1$var$firePointerEvent(element, "up");
        });
        var handleBlur = function() {
            return $494fe4895ce604d1$var$firePointerEvent(element, "cancel");
        };
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", function() {
        return element.removeEventListener("keydown", handleKeydown);
    }, eventOptions);
};

});
parcelRegister("ffU57", function(module, exports) {

$parcel$export(module.exports, "isPressing", function () { return $01797c23335de13a$export$7987404a4e35b84b; });
var $01797c23335de13a$export$7987404a4e35b84b = new WeakSet();

});




parcelRegister("kxeSa", function(module, exports) {

$parcel$export(module.exports, "InViewFeature", function () { return $28948ec44bff3d15$export$150851c8cc2f0c72; });

var $ehF45 = parcelRequire("ehF45");

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $c2MhV = parcelRequire("c2MhV");

var $ledP3 = parcelRequire("ledP3");

var $j8hhx = parcelRequire("j8hhx");
var $28948ec44bff3d15$var$thresholdNames = {
    some: 0,
    all: 1
};
var $28948ec44bff3d15$export$150851c8cc2f0c72 = /*#__PURE__*/ function(Feature) {
    "use strict";
    (0, $c2MhV._)(InViewFeature, Feature);
    function InViewFeature() {
        (0, $4QweW._)(this, InViewFeature);
        var _this;
        _this = (0, $ehF45._)(this, InViewFeature, arguments);
        _this.hasEnteredView = false;
        _this.isInView = false;
        return _this;
    }
    (0, $6hK4i._)(InViewFeature, [
        {
            key: "startObserver",
            value: function startObserver() {
                var _this = this;
                var _this_stopObserver, _this1;
                (_this_stopObserver = (_this1 = this).stopObserver) === null || _this_stopObserver === void 0 ? void 0 : _this_stopObserver.call(_this1);
                var _this_node_getProps = this.node.getProps(), _this_node_getProps_viewport = _this_node_getProps.viewport, viewport = _this_node_getProps_viewport === void 0 ? {} : _this_node_getProps_viewport;
                var root = viewport.root, rootMargin = viewport.margin, _viewport_amount = viewport.amount, amount = _viewport_amount === void 0 ? "some" : _viewport_amount, once = viewport.once;
                var options = {
                    root: root ? root.current : undefined,
                    rootMargin: rootMargin,
                    threshold: typeof amount === "number" ? amount : $28948ec44bff3d15$var$thresholdNames[amount]
                };
                var onIntersectionUpdate = function(entry) {
                    var isIntersecting = entry.isIntersecting;
                    /**
             * If there's been no change in the viewport state, early return.
             */ if (_this.isInView === isIntersecting) return;
                    _this.isInView = isIntersecting;
                    /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && _this.hasEnteredView) return;
                    else if (isIntersecting) _this.hasEnteredView = true;
                    if (_this.node.animationState) _this.node.animationState.setActive("whileInView", isIntersecting);
                    /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ var _this_node_getProps = _this.node.getProps(), onViewportEnter = _this_node_getProps.onViewportEnter, onViewportLeave = _this_node_getProps.onViewportLeave;
                    var callback = isIntersecting ? onViewportEnter : onViewportLeave;
                    callback && callback(entry);
                };
                this.stopObserver = (0, $j8hhx.observeIntersection)(this.node.current, options, onIntersectionUpdate);
            }
        },
        {
            key: "mount",
            value: function mount() {
                this.startObserver();
            }
        },
        {
            key: "update",
            value: function update() {
                if (typeof IntersectionObserver === "undefined") return;
                var _this_node = this.node, props = _this_node.props, prevProps = _this_node.prevProps;
                var hasOptionsChanged = [
                    "amount",
                    "margin",
                    "root"
                ].some($28948ec44bff3d15$var$hasViewportOptionChanged(props, prevProps));
                if (hasOptionsChanged) this.startObserver();
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                var _this_stopObserver, _this;
                (_this_stopObserver = (_this = this).stopObserver) === null || _this_stopObserver === void 0 ? void 0 : _this_stopObserver.call(_this);
                this.hasEnteredView = false;
                this.isInView = false;
            }
        }
    ]);
    return InViewFeature;
}((0, $ledP3.Feature));
function $28948ec44bff3d15$var$hasViewportOptionChanged(param) {
    var _param_viewport = param.viewport, viewport = _param_viewport === void 0 ? {} : _param_viewport, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.viewport, prevViewport = tmp === void 0 ? {} : tmp;
    return function(name) {
        return viewport[name] !== prevViewport[name];
    };
}

});
parcelRegister("j8hhx", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", function () { return $311ab1d9c07c10cf$export$b2bcd62fb7925aa5; });
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ 
var $kWfK0 = parcelRequire("kWfK0");

var $1DiK7 = parcelRequire("1DiK7");
var $311ab1d9c07c10cf$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ var $311ab1d9c07c10cf$var$observers = new WeakMap();
var $311ab1d9c07c10cf$var$fireObserverCallback = function(entry) {
    var callback = $311ab1d9c07c10cf$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
var $311ab1d9c07c10cf$var$fireAllObserverCallbacks = function(entries) {
    entries.forEach($311ab1d9c07c10cf$var$fireObserverCallback);
};
function $311ab1d9c07c10cf$var$initIntersectionObserver(_param) {
    var root = _param.root, options = (0, $1DiK7._)(_param, [
        "root"
    ]);
    var lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$311ab1d9c07c10cf$var$observers.has(lookupRoot)) $311ab1d9c07c10cf$var$observers.set(lookupRoot, {});
    var rootObservers = $311ab1d9c07c10cf$var$observers.get(lookupRoot);
    var key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($311ab1d9c07c10cf$var$fireAllObserverCallbacks, (0, $kWfK0._)({
        root: root
    }, options));
    return rootObservers[key];
}
function $311ab1d9c07c10cf$export$b2bcd62fb7925aa5(element, options, callback) {
    var rootInteresectionObserver = $311ab1d9c07c10cf$var$initIntersectionObserver(options);
    $311ab1d9c07c10cf$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return function() {
        $311ab1d9c07c10cf$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});



parcelRegister("iGham", function(module, exports) {

$parcel$export(module.exports, "layout", function () { return $7807e2ec847e690a$export$b3219800bda33a1f; });

var $40ppk = parcelRequire("40ppk");

var $gQoGI = parcelRequire("gQoGI");
var $7807e2ec847e690a$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $40ppk.HTMLProjectionNode),
        MeasureLayout: (0, $gQoGI.MeasureLayout)
    }
};

});




parcelRegister("60cC9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f799e50bf8f2114e$export$2e2bcd8739ae039; });
/**
 * Fuse.js v7.5.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2026 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ //#region src/helpers/typeGuards.ts

var $4QweW = parcelRequire("4QweW");

var $6hK4i = parcelRequire("6hK4i");

var $6tY97 = parcelRequire("6tY97");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $1DiK7 = parcelRequire("1DiK7");

var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $5djcY = parcelRequire("5djcY");
function $f799e50bf8f2114e$var$isArray(value) {
    return !Array.isArray ? $f799e50bf8f2114e$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
function $f799e50bf8f2114e$var$baseToString(value) {
    if (typeof value == "string") return value;
    if ((typeof value === "undefined" ? "undefined" : (0, $5djcY._)(value)) === "bigint") return value.toString();
    var result = value + "";
    return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function $f799e50bf8f2114e$var$toString(value) {
    return value == null ? "" : $f799e50bf8f2114e$var$baseToString(value);
}
function $f799e50bf8f2114e$var$isString(value) {
    return typeof value === "string";
}
function $f799e50bf8f2114e$var$isNumber(value) {
    return typeof value === "number";
}
function $f799e50bf8f2114e$var$isBoolean(value) {
    return value === true || value === false || $f799e50bf8f2114e$var$isObjectLike(value) && $f799e50bf8f2114e$var$getTag(value) == "[object Boolean]";
}
function $f799e50bf8f2114e$var$isObject(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $5djcY._)(value)) === "object";
}
function $f799e50bf8f2114e$var$isObjectLike(value) {
    return $f799e50bf8f2114e$var$isObject(value) && value !== null;
}
function $f799e50bf8f2114e$var$isDefined(value) {
    return value !== void 0 && value !== null;
}
function $f799e50bf8f2114e$var$isBlank(value) {
    return !value.trim().length;
}
function $f799e50bf8f2114e$var$getTag(value) {
    return value == null ? value === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
//#endregion
//#region src/core/errorMessages.ts
var $f799e50bf8f2114e$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
var $f799e50bf8f2114e$var$INVALID_DOC_INDEX = "Invalid doc index: must be a non-negative integer within the bounds of the docs array";
var $f799e50bf8f2114e$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = function(key) {
    return "Invalid value for key ".concat(key);
};
var $f799e50bf8f2114e$var$PATTERN_LENGTH_TOO_LARGE = function(max) {
    return "Pattern length exceeds max of ".concat(max, ".");
};
var $f799e50bf8f2114e$var$MISSING_KEY_PROPERTY = function(name) {
    return "Missing ".concat(name, " property in key");
};
var $f799e50bf8f2114e$var$INVALID_KEY_WEIGHT_VALUE = function(key) {
    return "Property 'weight' in key '".concat(key, "' must be a positive integer");
};
var $f799e50bf8f2114e$var$FUSE_MATCH_TOKEN_SEARCH_UNSUPPORTED = "Fuse.match does not support useTokenSearch: token search requires corpus-level statistics (df, fieldCount) that a one-off string comparison does not have. Use new Fuse(...).search(...) instead.";
//#endregion
//#region src/tools/KeyStore.ts
var $f799e50bf8f2114e$var$hasOwn = Object.prototype.hasOwnProperty;
var $f799e50bf8f2114e$var$KeyStore = /*#__PURE__*/ function() {
    "use strict";
    function KeyStore(keys) {
        var _this = this;
        (0, $4QweW._)(this, KeyStore);
        this._keys = [];
        this._keyMap = {};
        var totalWeight = 0;
        keys.forEach(function(key) {
            var obj = $f799e50bf8f2114e$var$createKey(key);
            _this._keys.push(obj);
            _this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        this._keys.forEach(function(key) {
            key.weight /= totalWeight;
        });
    }
    (0, $6hK4i._)(KeyStore, [
        {
            key: "get",
            value: function get(keyId) {
                return this._keyMap[keyId];
            }
        },
        {
            key: "keys",
            value: function keys() {
                return this._keys;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return JSON.stringify(this._keys);
            }
        }
    ]);
    return KeyStore;
}();
function $f799e50bf8f2114e$var$createKey(key) {
    var path = null;
    var id = null;
    var src = null;
    var weight = 1;
    var getFn = null;
    if ($f799e50bf8f2114e$var$isString(key) || $f799e50bf8f2114e$var$isArray(key)) {
        src = key;
        path = $f799e50bf8f2114e$var$createKeyPath(key);
        id = $f799e50bf8f2114e$var$createKeyId(key);
    } else {
        if (!$f799e50bf8f2114e$var$hasOwn.call(key, "name")) throw new Error($f799e50bf8f2114e$var$MISSING_KEY_PROPERTY("name"));
        var name = key.name;
        src = name;
        if ($f799e50bf8f2114e$var$hasOwn.call(key, "weight") && key.weight !== void 0) {
            weight = key.weight;
            if (weight <= 0) throw new Error($f799e50bf8f2114e$var$INVALID_KEY_WEIGHT_VALUE($f799e50bf8f2114e$var$createKeyId(name)));
        }
        path = $f799e50bf8f2114e$var$createKeyPath(name);
        id = $f799e50bf8f2114e$var$createKeyId(name);
        var _key_getFn;
        getFn = (_key_getFn = key.getFn) !== null && _key_getFn !== void 0 ? _key_getFn : null;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $f799e50bf8f2114e$var$createKeyPath(key) {
    return $f799e50bf8f2114e$var$isArray(key) ? key : key.split(".");
}
function $f799e50bf8f2114e$var$createKeyId(key) {
    return $f799e50bf8f2114e$var$isArray(key) ? key.join(".") : key;
}
//#endregion
//#region src/helpers/get.ts
function $f799e50bf8f2114e$var$get(obj, path) {
    var list = [];
    var arr = false;
    var deepGet = function(obj, path, index, arrayIndex) {
        if (!$f799e50bf8f2114e$var$isDefined(obj)) return;
        if (!path[index]) list.push(arrayIndex !== void 0 ? {
            v: obj,
            i: arrayIndex
        } : obj);
        else {
            var value = obj[path[index]];
            if (!$f799e50bf8f2114e$var$isDefined(value)) return;
            if (index === path.length - 1 && ($f799e50bf8f2114e$var$isString(value) || $f799e50bf8f2114e$var$isNumber(value) || $f799e50bf8f2114e$var$isBoolean(value) || (typeof value === "undefined" ? "undefined" : (0, $5djcY._)(value)) === "bigint")) list.push(arrayIndex !== void 0 ? {
                v: $f799e50bf8f2114e$var$toString(value),
                i: arrayIndex
            } : $f799e50bf8f2114e$var$toString(value));
            else if ($f799e50bf8f2114e$var$isArray(value)) {
                arr = true;
                for(var i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1, i);
            } else if (path.length) deepGet(value, path, index + 1, arrayIndex);
        }
    };
    deepGet(obj, $f799e50bf8f2114e$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
//#endregion
//#region src/core/config.ts
var $f799e50bf8f2114e$var$MatchOptions = {
    includeMatches: false,
    findAllMatches: false,
    minMatchCharLength: 1
};
var $f799e50bf8f2114e$var$BasicOptions = {
    isCaseSensitive: false,
    ignoreDiacritics: false,
    includeScore: false,
    keys: [],
    shouldSort: true,
    sortFn: function(a, b) {
        return a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1;
    }
};
var $f799e50bf8f2114e$var$FuzzyOptions = {
    location: 0,
    threshold: .6,
    distance: 100
};
var $f799e50bf8f2114e$var$AdvancedOptions = {
    useExtendedSearch: false,
    useTokenSearch: false,
    tokenize: void 0,
    tokenMatch: "any",
    getFn: $f799e50bf8f2114e$var$get,
    ignoreLocation: false,
    ignoreFieldNorm: false,
    fieldNormWeight: 1
};
var $f799e50bf8f2114e$var$Config = Object.freeze((0, $kWfK0._)({}, $f799e50bf8f2114e$var$BasicOptions, $f799e50bf8f2114e$var$MatchOptions, $f799e50bf8f2114e$var$FuzzyOptions, $f799e50bf8f2114e$var$AdvancedOptions));
//#endregion
//#region src/tools/fieldNorm.ts
function $f799e50bf8f2114e$var$isWordSeparator(code) {
    return code >= 9 && code <= 13 || code === 32 || code === 160;
}
function $f799e50bf8f2114e$var$norm() {
    var weight = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, mantissa = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    var cache = /* @__PURE__ */ new Map();
    var m = Math.pow(10, mantissa);
    return {
        get: function(value) {
            var numTokens = 0;
            var inWord = false;
            for(var i = 0; i < value.length; i++)if (!$f799e50bf8f2114e$var$isWordSeparator(value.charCodeAt(i))) {
                if (!inWord) {
                    numTokens++;
                    inWord = true;
                }
            } else inWord = false;
            if (numTokens === 0) numTokens = 1;
            if (cache.has(numTokens)) return cache.get(numTokens);
            var n = Math.round(m / Math.pow(numTokens, .5 * weight)) / m;
            cache.set(numTokens, n);
            return n;
        },
        clear: function() {
            cache.clear();
        }
    };
}
//#endregion
//#region src/tools/FuseIndex.ts
var $f799e50bf8f2114e$var$FuseIndex = /*#__PURE__*/ function() {
    "use strict";
    function FuseIndex() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_getFn = _ref.getFn, getFn = _ref_getFn === void 0 ? $f799e50bf8f2114e$var$Config.getFn : _ref_getFn, _ref_fieldNormWeight = _ref.fieldNormWeight, fieldNormWeight = _ref_fieldNormWeight === void 0 ? $f799e50bf8f2114e$var$Config.fieldNormWeight : _ref_fieldNormWeight;
        (0, $4QweW._)(this, FuseIndex);
        this.norm = $f799e50bf8f2114e$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.docs = [];
        this.keys = [];
        this._keysMap = {};
        this.setIndexRecords();
    }
    (0, $6hK4i._)(FuseIndex, [
        {
            key: "setSources",
            value: function setSources() {
                var docs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                this.docs = docs;
            }
        },
        {
            key: "setIndexRecords",
            value: function setIndexRecords() {
                var records = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                this.records = records;
            }
        },
        {
            key: "setKeys",
            value: function setKeys() {
                var _this = this;
                var keys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                this.keys = keys;
                this._keysMap = {};
                keys.forEach(function(key, idx) {
                    _this._keysMap[key.id] = idx;
                });
            }
        },
        {
            key: "create",
            value: function create() {
                if (this.isCreated || !this.docs.length) return;
                this.isCreated = true;
                var len = this.docs.length;
                this.records = new Array(len);
                var recordCount = 0;
                if ($f799e50bf8f2114e$var$isString(this.docs[0])) for(var i = 0; i < len; i++){
                    var record = this._createStringRecord(this.docs[i], i);
                    if (record) this.records[recordCount++] = record;
                }
                else for(var i1 = 0; i1 < len; i1++)this.records[recordCount++] = this._createObjectRecord(this.docs[i1], i1);
                this.records.length = recordCount;
                this.norm.clear();
            }
        },
        {
            key: "add",
            value: function add(doc, docIndex) {
                if (!Number.isInteger(docIndex) || docIndex < 0) throw new Error($f799e50bf8f2114e$var$INVALID_DOC_INDEX);
                if ($f799e50bf8f2114e$var$isString(doc)) {
                    var record = this._createStringRecord(doc, docIndex);
                    if (record) this.records.push(record);
                    return record;
                }
                var record1 = this._createObjectRecord(doc, docIndex);
                this.records.push(record1);
                return record1;
            }
        },
        {
            key: "removeAt",
            value: function removeAt(idx) {
                if (!Number.isInteger(idx) || idx < 0) throw new Error($f799e50bf8f2114e$var$INVALID_DOC_INDEX);
                for(var i = 0, len = this.records.length; i < len; i += 1)if (this.records[i].i === idx) {
                    this.records.splice(i, 1);
                    break;
                }
                for(var i1 = 0, len1 = this.records.length; i1 < len1; i1 += 1)if (this.records[i1].i > idx) this.records[i1].i -= 1;
            }
        },
        {
            key: "removeAll",
            value: function removeAll(indices) {
                var toRemove = /* @__PURE__ */ new Set();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = indices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var v = _step.value;
                        if (Number.isInteger(v) && v >= 0) toRemove.add(v);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (toRemove.size === 0) return;
                this.records = this.records.filter(function(r) {
                    return !toRemove.has(r.i);
                });
                var sorted = Array.from(toRemove).sort(function(a, b) {
                    return a - b;
                });
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = this.records[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var record = _step1.value;
                        var lo = 0;
                        var hi = sorted.length;
                        while(lo < hi){
                            var mid = lo + hi >>> 1;
                            if (sorted[mid] < record.i) lo = mid + 1;
                            else hi = mid;
                        }
                        record.i -= lo;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "getValueForItemAtKeyId",
            value: function getValueForItemAtKeyId(item, keyId) {
                return item[this._keysMap[keyId]];
            }
        },
        {
            key: "size",
            value: function size() {
                return this.records.length;
            }
        },
        {
            key: "_createStringRecord",
            value: function _createStringRecord(doc, docIndex) {
                if (!$f799e50bf8f2114e$var$isDefined(doc) || $f799e50bf8f2114e$var$isBlank(doc)) return null;
                return {
                    v: doc,
                    i: docIndex,
                    n: this.norm.get(doc)
                };
            }
        },
        {
            key: "_createObjectRecord",
            value: function _createObjectRecord(doc, docIndex) {
                var record = {
                    i: docIndex,
                    $: {}
                };
                for(var keyIndex = 0, keyLen = this.keys.length; keyIndex < keyLen; keyIndex++){
                    var key = this.keys[keyIndex];
                    var value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
                    if (!$f799e50bf8f2114e$var$isDefined(value)) continue;
                    if ($f799e50bf8f2114e$var$isArray(value)) {
                        var subRecords = [];
                        for(var i = 0, len = value.length; i < len; i += 1){
                            var item = value[i];
                            if (!$f799e50bf8f2114e$var$isDefined(item)) continue;
                            if ($f799e50bf8f2114e$var$isString(item)) {
                                if (!$f799e50bf8f2114e$var$isBlank(item)) {
                                    var subRecord = {
                                        v: item,
                                        i: i,
                                        n: this.norm.get(item)
                                    };
                                    subRecords.push(subRecord);
                                }
                            } else if ($f799e50bf8f2114e$var$isDefined(item.v)) {
                                var text = $f799e50bf8f2114e$var$isString(item.v) ? item.v : $f799e50bf8f2114e$var$toString(item.v);
                                if (!$f799e50bf8f2114e$var$isBlank(text)) {
                                    var subRecord1 = {
                                        v: text,
                                        i: item.i,
                                        n: this.norm.get(text)
                                    };
                                    subRecords.push(subRecord1);
                                }
                            }
                        }
                        record.$[keyIndex] = subRecords;
                    } else if ($f799e50bf8f2114e$var$isString(value) && !$f799e50bf8f2114e$var$isBlank(value)) {
                        var subRecord2 = {
                            v: value,
                            n: this.norm.get(value)
                        };
                        record.$[keyIndex] = subRecord2;
                    }
                }
                return record;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    keys: this.keys.map(function(_param) {
                        var getFn = _param.getFn, key = (0, $1DiK7._)(_param, [
                            "getFn"
                        ]);
                        return key;
                    }),
                    records: this.records
                };
            }
        }
    ]);
    return FuseIndex;
}();
function $f799e50bf8f2114e$var$createIndex(keys, docs) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_getFn = _ref.getFn, getFn = _ref_getFn === void 0 ? $f799e50bf8f2114e$var$Config.getFn : _ref_getFn, _ref_fieldNormWeight = _ref.fieldNormWeight, fieldNormWeight = _ref_fieldNormWeight === void 0 ? $f799e50bf8f2114e$var$Config.fieldNormWeight : _ref_fieldNormWeight;
    var myIndex = new $f799e50bf8f2114e$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($f799e50bf8f2114e$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $f799e50bf8f2114e$var$parseIndex(data) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_getFn = _ref.getFn, getFn = _ref_getFn === void 0 ? $f799e50bf8f2114e$var$Config.getFn : _ref_getFn, _ref_fieldNormWeight = _ref.fieldNormWeight, fieldNormWeight = _ref_fieldNormWeight === void 0 ? $f799e50bf8f2114e$var$Config.fieldNormWeight : _ref_fieldNormWeight;
    var keys = data.keys, records = data.records;
    var myIndex = new $f799e50bf8f2114e$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
//#endregion
//#region src/search/bitap/convertMaskToIndices.ts
function $f799e50bf8f2114e$var$convertMaskToIndices() {
    var matchmask = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], minMatchCharLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f799e50bf8f2114e$var$Config.minMatchCharLength;
    var indices = [];
    var start = -1;
    var end = -1;
    var i = 0;
    for(var len = matchmask.length; i < len; i += 1){
        var match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
//#endregion
//#region src/search/bitap/search.ts
function $f799e50bf8f2114e$var$search(text, pattern, patternAlphabet) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref_location = _ref.location, location = _ref_location === void 0 ? $f799e50bf8f2114e$var$Config.location : _ref_location, _ref_distance = _ref.distance, distance = _ref_distance === void 0 ? $f799e50bf8f2114e$var$Config.distance : _ref_distance, _ref_threshold = _ref.threshold, threshold = _ref_threshold === void 0 ? $f799e50bf8f2114e$var$Config.threshold : _ref_threshold, _ref_findAllMatches = _ref.findAllMatches, findAllMatches = _ref_findAllMatches === void 0 ? $f799e50bf8f2114e$var$Config.findAllMatches : _ref_findAllMatches, _ref_minMatchCharLength = _ref.minMatchCharLength, minMatchCharLength = _ref_minMatchCharLength === void 0 ? $f799e50bf8f2114e$var$Config.minMatchCharLength : _ref_minMatchCharLength, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $f799e50bf8f2114e$var$Config.includeMatches : _ref_includeMatches, _ref_ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref_ignoreLocation === void 0 ? $f799e50bf8f2114e$var$Config.ignoreLocation : _ref_ignoreLocation;
    if (pattern.length > 32) throw new Error($f799e50bf8f2114e$var$PATTERN_LENGTH_TOO_LARGE(32));
    var patternLen = pattern.length;
    var textLen = text.length;
    var expectedLocation = Math.max(0, Math.min(location, textLen));
    var currentThreshold = threshold;
    var bestLocation = expectedLocation;
    var calcScore = function(errors, currentLocation) {
        var accuracy = errors / patternLen;
        if (ignoreLocation) return accuracy;
        var proximity = Math.abs(expectedLocation - currentLocation);
        if (!distance) return proximity ? 1 : accuracy;
        return accuracy + proximity / distance;
    };
    var computeMatches = minMatchCharLength > 1 || includeMatches;
    var matchMask = computeMatches ? Array(textLen) : [];
    var index;
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        var score = calcScore(0, index);
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            var i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    bestLocation = -1;
    var lastBitArr = [];
    var finalScore = 1;
    var bestErrors = 0;
    var binMax = patternLen + textLen;
    var mask = 1 << patternLen - 1;
    for(var i1 = 0; i1 < patternLen; i1 += 1){
        var binMin = 0;
        var binMid = binMax;
        while(binMin < binMid){
            if (calcScore(i1, expectedLocation + binMid) <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        binMax = binMid;
        var start = Math.max(1, expectedLocation - binMid + 1);
        var finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        var bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i1) - 1;
        for(var j = finish; j >= start; j -= 1){
            var currentLocation = j - 1;
            var charMatch = patternAlphabet[text[currentLocation]];
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            if (i1) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = calcScore(i1, currentLocation);
                if (finalScore <= currentThreshold) {
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    bestErrors = i1;
                    if (bestLocation <= expectedLocation) break;
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        if (calcScore(i1 + 1, expectedLocation) > currentThreshold) break;
        lastBitArr = bitArr;
    }
    if (computeMatches && bestLocation >= 0) {
        var matchEnd = Math.min(textLen - 1, bestLocation + patternLen - 1 + bestErrors);
        for(var k = bestLocation; k <= matchEnd; k += 1)if (patternAlphabet[text[k]]) matchMask[k] = 1;
    }
    var result = {
        isMatch: bestLocation >= 0,
        score: Math.max(.001, finalScore)
    };
    if (computeMatches) {
        var indices = $f799e50bf8f2114e$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
//#endregion
//#region src/search/bitap/createPatternAlphabet.ts
function $f799e50bf8f2114e$var$createPatternAlphabet(pattern) {
    var mask = {};
    for(var i = 0, len = pattern.length; i < len; i += 1){
        var char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
//#endregion
//#region src/helpers/mergeIndices.ts
function $f799e50bf8f2114e$var$mergeIndices(indices) {
    if (indices.length <= 1) return indices;
    indices.sort(function(a, b) {
        return a[0] - b[0] || a[1] - b[1];
    });
    var merged = [
        indices[0]
    ];
    for(var i = 1, len = indices.length; i < len; i += 1){
        var last = merged[merged.length - 1];
        var curr = indices[i];
        if (curr[0] <= last[1] + 1) last[1] = Math.max(last[1], curr[1]);
        else merged.push(curr);
    }
    return merged;
}
//#endregion
//#region src/helpers/diacritics.ts
var $f799e50bf8f2114e$var$NON_DECOMPOSABLE_MAP = {
    "\u0142": "l",
    "\u0141": "L",
    "\u0111": "d",
    "\u0110": "D",
    "\xf8": "o",
    "\xd8": "O",
    "\u0127": "h",
    "\u0126": "H",
    "\u0167": "t",
    "\u0166": "T",
    "\u0131": "i",
    "\xdf": "ss"
};
var $f799e50bf8f2114e$var$NON_DECOMPOSABLE_RE = new RegExp("[" + Object.keys($f799e50bf8f2114e$var$NON_DECOMPOSABLE_MAP).join("") + "]", "g");
var $f799e50bf8f2114e$var$stripDiacritics = typeof String.prototype.normalize === "function" ? function(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]/g, "").replace($f799e50bf8f2114e$var$NON_DECOMPOSABLE_RE, function(ch) {
        return $f799e50bf8f2114e$var$NON_DECOMPOSABLE_MAP[ch];
    });
} : function(str) {
    return str;
};
//#endregion
//#region src/search/bitap/index.ts
var $f799e50bf8f2114e$var$BitapSearch = /*#__PURE__*/ function() {
    "use strict";
    function BitapSearch(pattern) {
        var _this = this;
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_location = _ref.location, location = _ref_location === void 0 ? $f799e50bf8f2114e$var$Config.location : _ref_location, _ref_threshold = _ref.threshold, threshold = _ref_threshold === void 0 ? $f799e50bf8f2114e$var$Config.threshold : _ref_threshold, _ref_distance = _ref.distance, distance = _ref_distance === void 0 ? $f799e50bf8f2114e$var$Config.distance : _ref_distance, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $f799e50bf8f2114e$var$Config.includeMatches : _ref_includeMatches, _ref_findAllMatches = _ref.findAllMatches, findAllMatches = _ref_findAllMatches === void 0 ? $f799e50bf8f2114e$var$Config.findAllMatches : _ref_findAllMatches, _ref_minMatchCharLength = _ref.minMatchCharLength, minMatchCharLength = _ref_minMatchCharLength === void 0 ? $f799e50bf8f2114e$var$Config.minMatchCharLength : _ref_minMatchCharLength, _ref_isCaseSensitive = _ref.isCaseSensitive, isCaseSensitive = _ref_isCaseSensitive === void 0 ? $f799e50bf8f2114e$var$Config.isCaseSensitive : _ref_isCaseSensitive, _ref_ignoreDiacritics = _ref.ignoreDiacritics, ignoreDiacritics = _ref_ignoreDiacritics === void 0 ? $f799e50bf8f2114e$var$Config.ignoreDiacritics : _ref_ignoreDiacritics, _ref_ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref_ignoreLocation === void 0 ? $f799e50bf8f2114e$var$Config.ignoreLocation : _ref_ignoreLocation;
        (0, $4QweW._)(this, BitapSearch);
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreDiacritics: ignoreDiacritics,
            ignoreLocation: ignoreLocation
        };
        pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        pattern = ignoreDiacritics ? $f799e50bf8f2114e$var$stripDiacritics(pattern) : pattern;
        this.pattern = pattern;
        this.chunks = [];
        if (!this.pattern.length) return;
        var addChunk = function(pattern, startIndex) {
            _this.chunks.push({
                pattern: pattern,
                alphabet: $f799e50bf8f2114e$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        var len = this.pattern.length;
        if (len > 32) {
            var i = 0;
            var remainder = len % 32;
            var end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, 32), i);
                i += 32;
            }
            if (remainder) {
                var startIndex = len - 32;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    (0, $6hK4i._)(BitapSearch, [
        {
            key: "searchIn",
            value: function searchIn(text) {
                var _this_options = this.options, isCaseSensitive = _this_options.isCaseSensitive, ignoreDiacritics = _this_options.ignoreDiacritics, includeMatches = _this_options.includeMatches;
                text = isCaseSensitive ? text : text.toLowerCase();
                text = ignoreDiacritics ? $f799e50bf8f2114e$var$stripDiacritics(text) : text;
                if (this.pattern === text) {
                    if (text.length < this.options.minMatchCharLength) return {
                        isMatch: false,
                        score: 1
                    };
                    var result = {
                        isMatch: true,
                        score: 0
                    };
                    if (includeMatches) result.indices = [
                        [
                            0,
                            text.length - 1
                        ]
                    ];
                    return result;
                }
                var _this_options1 = this.options, location = _this_options1.location, distance = _this_options1.distance, threshold = _this_options1.threshold, findAllMatches = _this_options1.findAllMatches, minMatchCharLength = _this_options1.minMatchCharLength, ignoreLocation = _this_options1.ignoreLocation;
                var allIndices = [];
                var totalScore = 0;
                var hasMatches = false;
                this.chunks.forEach(function(param) {
                    var pattern = param.pattern, alphabet = param.alphabet, startIndex = param.startIndex;
                    var _allIndices;
                    var _search = $f799e50bf8f2114e$var$search(text, pattern, alphabet, {
                        location: location + startIndex,
                        distance: distance,
                        threshold: threshold,
                        findAllMatches: findAllMatches,
                        minMatchCharLength: minMatchCharLength,
                        includeMatches: includeMatches,
                        ignoreLocation: ignoreLocation
                    }), isMatch = _search.isMatch, score = _search.score, indices = _search.indices;
                    if (isMatch) hasMatches = true;
                    totalScore += score;
                    if (isMatch && indices) (_allIndices = allIndices).push.apply(_allIndices, (0, $jlUaU._)(indices));
                });
                var result1 = {
                    isMatch: hasMatches,
                    score: hasMatches ? totalScore / this.chunks.length : 1
                };
                if (hasMatches && includeMatches) result1.indices = $f799e50bf8f2114e$var$mergeIndices(allIndices);
                return result1;
            }
        }
    ]);
    return BitapSearch;
}();
//#endregion
//#region src/search/extended/matchers.ts
var $f799e50bf8f2114e$var$MULTI_MATCH_TYPES = new Set([
    "fuzzy",
    "include"
]);
function $f799e50bf8f2114e$var$isInverse(type) {
    return type.startsWith("inverse");
}
var $f799e50bf8f2114e$var$matchers = [
    {
        type: "exact",
        multiRegex: /^="(.*)"$/,
        singleRegex: /^=(.*)$/,
        create: function(pattern) {
            return {
                type: "exact",
                search: function(text) {
                    var isMatch = text === pattern;
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: [
                            0,
                            pattern.length - 1
                        ]
                    };
                }
            };
        }
    },
    {
        type: "include",
        multiRegex: /^'"(.*)"$/,
        singleRegex: /^'(.*)$/,
        create: function(pattern) {
            return {
                type: "include",
                search: function(text) {
                    var location = 0;
                    var index;
                    var indices = [];
                    var patternLen = pattern.length;
                    while((index = text.indexOf(pattern, location)) > -1){
                        location = index + patternLen;
                        indices.push([
                            index,
                            location - 1
                        ]);
                    }
                    var isMatch = !!indices.length;
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: indices
                    };
                }
            };
        }
    },
    {
        type: "prefix-exact",
        multiRegex: /^\^"(.*)"$/,
        singleRegex: /^\^(.*)$/,
        create: function(pattern) {
            return {
                type: "prefix-exact",
                search: function(text) {
                    var isMatch = text.startsWith(pattern);
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: [
                            0,
                            pattern.length - 1
                        ]
                    };
                }
            };
        }
    },
    {
        type: "inverse-prefix-exact",
        multiRegex: /^!\^"(.*)"$/,
        singleRegex: /^!\^(.*)$/,
        create: function(pattern) {
            return {
                type: "inverse-prefix-exact",
                search: function(text) {
                    var isMatch = !text.startsWith(pattern);
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: [
                            0,
                            text.length - 1
                        ]
                    };
                }
            };
        }
    },
    {
        type: "inverse-suffix-exact",
        multiRegex: /^!"(.*)"\$$/,
        singleRegex: /^!(.*)\$$/,
        create: function(pattern) {
            return {
                type: "inverse-suffix-exact",
                search: function(text) {
                    var isMatch = !text.endsWith(pattern);
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: [
                            0,
                            text.length - 1
                        ]
                    };
                }
            };
        }
    },
    {
        type: "suffix-exact",
        multiRegex: /^"(.*)"\$$/,
        singleRegex: /^(.*)\$$/,
        create: function(pattern) {
            return {
                type: "suffix-exact",
                search: function(text) {
                    var isMatch = text.endsWith(pattern);
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: [
                            text.length - pattern.length,
                            text.length - 1
                        ]
                    };
                }
            };
        }
    },
    {
        type: "inverse-exact",
        multiRegex: /^!"(.*)"$/,
        singleRegex: /^!(.*)$/,
        create: function(pattern) {
            return {
                type: "inverse-exact",
                search: function(text) {
                    var isMatch = text.indexOf(pattern) === -1;
                    return {
                        isMatch: isMatch,
                        score: isMatch ? 0 : 1,
                        indices: [
                            0,
                            text.length - 1
                        ]
                    };
                }
            };
        }
    },
    {
        type: "fuzzy",
        multiRegex: /^"(.*)"$/,
        singleRegex: /^(.*)$/,
        create: function(pattern) {
            var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            var _options_location, _options_threshold, _options_distance, _options_includeMatches, _options_findAllMatches, _options_minMatchCharLength, _options_isCaseSensitive, _options_ignoreDiacritics, _options_ignoreLocation;
            var bitap = new $f799e50bf8f2114e$var$BitapSearch(pattern, {
                location: (_options_location = options.location) !== null && _options_location !== void 0 ? _options_location : $f799e50bf8f2114e$var$Config.location,
                threshold: (_options_threshold = options.threshold) !== null && _options_threshold !== void 0 ? _options_threshold : $f799e50bf8f2114e$var$Config.threshold,
                distance: (_options_distance = options.distance) !== null && _options_distance !== void 0 ? _options_distance : $f799e50bf8f2114e$var$Config.distance,
                includeMatches: (_options_includeMatches = options.includeMatches) !== null && _options_includeMatches !== void 0 ? _options_includeMatches : $f799e50bf8f2114e$var$Config.includeMatches,
                findAllMatches: (_options_findAllMatches = options.findAllMatches) !== null && _options_findAllMatches !== void 0 ? _options_findAllMatches : $f799e50bf8f2114e$var$Config.findAllMatches,
                minMatchCharLength: (_options_minMatchCharLength = options.minMatchCharLength) !== null && _options_minMatchCharLength !== void 0 ? _options_minMatchCharLength : $f799e50bf8f2114e$var$Config.minMatchCharLength,
                isCaseSensitive: (_options_isCaseSensitive = options.isCaseSensitive) !== null && _options_isCaseSensitive !== void 0 ? _options_isCaseSensitive : $f799e50bf8f2114e$var$Config.isCaseSensitive,
                ignoreDiacritics: (_options_ignoreDiacritics = options.ignoreDiacritics) !== null && _options_ignoreDiacritics !== void 0 ? _options_ignoreDiacritics : $f799e50bf8f2114e$var$Config.ignoreDiacritics,
                ignoreLocation: (_options_ignoreLocation = options.ignoreLocation) !== null && _options_ignoreLocation !== void 0 ? _options_ignoreLocation : $f799e50bf8f2114e$var$Config.ignoreLocation
            });
            return {
                type: "fuzzy",
                search: function(text) {
                    return bitap.searchIn(text);
                }
            };
        }
    }
];
//#endregion
//#region src/search/extended/parseQuery.ts
var $f799e50bf8f2114e$var$matchersLen = $f799e50bf8f2114e$var$matchers.length;
var $f799e50bf8f2114e$var$ESCAPED_PIPE = "\0";
var $f799e50bf8f2114e$var$OR_TOKEN = "|";
function $f799e50bf8f2114e$var$tokenize(pattern) {
    var tokens = [];
    var len = pattern.length;
    var i = 0;
    while(i < len){
        while(i < len && pattern[i] === " ")i++;
        if (i >= len) break;
        var j = i;
        while(j < len && pattern[j] !== " " && pattern[j] !== "\"")j++;
        if (j < len && pattern[j] === "\"") {
            j++;
            while(j < len){
                if (pattern[j] === "\"") {
                    var next = j + 1;
                    if (next >= len || pattern[next] === " ") {
                        j++;
                        break;
                    }
                    if (pattern[next] === "$" && (next + 1 >= len || pattern[next + 1] === " ")) {
                        j += 2;
                        break;
                    }
                }
                j++;
            }
            tokens.push(pattern.substring(i, j));
            i = j;
        } else {
            while(j < len && pattern[j] !== " ")j++;
            tokens.push(pattern.substring(i, j));
            i = j;
        }
    }
    return tokens;
}
function $f799e50bf8f2114e$var$getMatch(pattern, exp) {
    var matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
function $f799e50bf8f2114e$var$parseQuery(pattern) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return pattern.replace(/\\\|/g, $f799e50bf8f2114e$var$ESCAPED_PIPE).split($f799e50bf8f2114e$var$OR_TOKEN).map(function(item) {
        var query = $f799e50bf8f2114e$var$tokenize(item.replace(/\u0000/g, "|").trim()).filter(function(item) {
            return item && !!item.trim();
        });
        var results = [];
        for(var i = 0, len = query.length; i < len; i += 1){
            var queryItem = query[i];
            var found = false;
            var idx = -1;
            while(!found && ++idx < $f799e50bf8f2114e$var$matchersLen){
                var def = $f799e50bf8f2114e$var$matchers[idx];
                var token = $f799e50bf8f2114e$var$getMatch(queryItem, def.multiRegex);
                if (token) {
                    results.push(def.create(token, options));
                    found = true;
                }
            }
            if (found) continue;
            idx = -1;
            while(++idx < $f799e50bf8f2114e$var$matchersLen){
                var def1 = $f799e50bf8f2114e$var$matchers[idx];
                var token1 = $f799e50bf8f2114e$var$getMatch(queryItem, def1.singleRegex);
                if (token1) {
                    results.push(def1.create(token1, options));
                    break;
                }
            }
        }
        return results;
    });
}
//#endregion
//#region src/search/extended/index.ts
var $f799e50bf8f2114e$var$ExtendedSearch = /*#__PURE__*/ function() {
    "use strict";
    function ExtendedSearch(pattern) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_isCaseSensitive = _ref.isCaseSensitive, isCaseSensitive = _ref_isCaseSensitive === void 0 ? $f799e50bf8f2114e$var$Config.isCaseSensitive : _ref_isCaseSensitive, _ref_ignoreDiacritics = _ref.ignoreDiacritics, ignoreDiacritics = _ref_ignoreDiacritics === void 0 ? $f799e50bf8f2114e$var$Config.ignoreDiacritics : _ref_ignoreDiacritics, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $f799e50bf8f2114e$var$Config.includeMatches : _ref_includeMatches, _ref_minMatchCharLength = _ref.minMatchCharLength, minMatchCharLength = _ref_minMatchCharLength === void 0 ? $f799e50bf8f2114e$var$Config.minMatchCharLength : _ref_minMatchCharLength, _ref_ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref_ignoreLocation === void 0 ? $f799e50bf8f2114e$var$Config.ignoreLocation : _ref_ignoreLocation, _ref_findAllMatches = _ref.findAllMatches, findAllMatches = _ref_findAllMatches === void 0 ? $f799e50bf8f2114e$var$Config.findAllMatches : _ref_findAllMatches, _ref_location = _ref.location, location = _ref_location === void 0 ? $f799e50bf8f2114e$var$Config.location : _ref_location, _ref_threshold = _ref.threshold, threshold = _ref_threshold === void 0 ? $f799e50bf8f2114e$var$Config.threshold : _ref_threshold, _ref_distance = _ref.distance, distance = _ref_distance === void 0 ? $f799e50bf8f2114e$var$Config.distance : _ref_distance;
        (0, $4QweW._)(this, ExtendedSearch);
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            ignoreDiacritics: ignoreDiacritics,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        pattern = ignoreDiacritics ? $f799e50bf8f2114e$var$stripDiacritics(pattern) : pattern;
        this.pattern = pattern;
        this.query = $f799e50bf8f2114e$var$parseQuery(this.pattern, this.options);
    }
    (0, $6hK4i._)(ExtendedSearch, [
        {
            key: "searchIn",
            value: function searchIn(text) {
                var query = this.query;
                if (!query) return {
                    isMatch: false,
                    score: 1
                };
                var _this_options = this.options, includeMatches = _this_options.includeMatches, isCaseSensitive = _this_options.isCaseSensitive, ignoreDiacritics = _this_options.ignoreDiacritics;
                text = isCaseSensitive ? text : text.toLowerCase();
                text = ignoreDiacritics ? $f799e50bf8f2114e$var$stripDiacritics(text) : text;
                var numMatches = 0;
                var allIndices = [];
                var totalScore = 0;
                var hasInverse = false;
                for(var i = 0, qLen = query.length; i < qLen; i += 1){
                    var searchers = query[i];
                    allIndices.length = 0;
                    numMatches = 0;
                    hasInverse = false;
                    for(var j = 0, pLen = searchers.length; j < pLen; j += 1){
                        var matcher = searchers[j];
                        var _matcher_search = matcher.search(text), isMatch = _matcher_search.isMatch, indices = _matcher_search.indices, score = _matcher_search.score;
                        if (isMatch) {
                            numMatches += 1;
                            totalScore += score;
                            if ($f799e50bf8f2114e$var$isInverse(matcher.type)) hasInverse = true;
                            if (includeMatches) {
                                var _allIndices;
                                if ($f799e50bf8f2114e$var$MULTI_MATCH_TYPES.has(matcher.type)) (_allIndices = allIndices).push.apply(_allIndices, (0, $jlUaU._)(indices));
                                else allIndices.push(indices);
                            }
                        } else {
                            totalScore = 0;
                            numMatches = 0;
                            allIndices.length = 0;
                            hasInverse = false;
                            break;
                        }
                    }
                    if (numMatches) {
                        var result = {
                            isMatch: true,
                            score: totalScore / numMatches
                        };
                        if (hasInverse) result.hasInverse = true;
                        if (includeMatches) result.indices = $f799e50bf8f2114e$var$mergeIndices(allIndices);
                        return result;
                    }
                }
                return {
                    isMatch: false,
                    score: 1
                };
            }
        }
    ], [
        {
            key: "condition",
            value: function condition(_, options) {
                return options.useExtendedSearch;
            }
        }
    ]);
    return ExtendedSearch;
}();
//#endregion
//#region src/core/register.ts
var $f799e50bf8f2114e$var$registeredSearchers = [];
function $f799e50bf8f2114e$var$register() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _registeredSearchers;
    (_registeredSearchers = $f799e50bf8f2114e$var$registeredSearchers).push.apply(_registeredSearchers, (0, $jlUaU._)(args));
}
function $f799e50bf8f2114e$var$createSearcher(pattern, options) {
    for(var i = 0, len = $f799e50bf8f2114e$var$registeredSearchers.length; i < len; i += 1){
        var searcherClass = $f799e50bf8f2114e$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $f799e50bf8f2114e$var$BitapSearch(pattern, options);
}
//#endregion
//#region src/core/queryParser.ts
var $f799e50bf8f2114e$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
var $f799e50bf8f2114e$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
var $f799e50bf8f2114e$var$isExpression = function(query) {
    return !!(query[$f799e50bf8f2114e$var$LogicalOperator.AND] || query[$f799e50bf8f2114e$var$LogicalOperator.OR]);
};
var $f799e50bf8f2114e$var$isPath = function(query) {
    return !!query[$f799e50bf8f2114e$var$KeyType.PATH];
};
var $f799e50bf8f2114e$var$isLeaf = function(query) {
    return !$f799e50bf8f2114e$var$isArray(query) && $f799e50bf8f2114e$var$isObject(query) && !$f799e50bf8f2114e$var$isExpression(query);
};
var $f799e50bf8f2114e$var$convertToExplicit = function(query) {
    return (0, $6tY97._)({}, $f799e50bf8f2114e$var$LogicalOperator.AND, Object.keys(query).map(function(key) {
        return (0, $6tY97._)({}, key, query[key]);
    }));
};
function $f799e50bf8f2114e$var$parse(query, options) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_auto = _ref.auto, auto = _ref_auto === void 0 ? true : _ref_auto;
    var next = function(query) {
        if ($f799e50bf8f2114e$var$isString(query)) {
            var obj = {
                keyId: null,
                pattern: query
            };
            if (auto) obj.searcher = $f799e50bf8f2114e$var$createSearcher(query, options);
            return obj;
        }
        var keys = Object.keys(query);
        var isQueryPath = $f799e50bf8f2114e$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$f799e50bf8f2114e$var$isExpression(query)) return next($f799e50bf8f2114e$var$convertToExplicit(query));
        if ($f799e50bf8f2114e$var$isLeaf(query)) {
            var key = isQueryPath ? query[$f799e50bf8f2114e$var$KeyType.PATH] : keys[0];
            var pattern = isQueryPath ? query[$f799e50bf8f2114e$var$KeyType.PATTERN] : query[key];
            if (!$f799e50bf8f2114e$var$isString(pattern)) throw new Error($f799e50bf8f2114e$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            var obj1 = {
                keyId: $f799e50bf8f2114e$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj1.searcher = $f799e50bf8f2114e$var$createSearcher(pattern, options);
            return obj1;
        }
        var node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach(function(key) {
            var value = query[key];
            if ($f799e50bf8f2114e$var$isArray(value)) value.forEach(function(item) {
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$f799e50bf8f2114e$var$isExpression(query)) query = $f799e50bf8f2114e$var$convertToExplicit(query);
    return next(query);
}
//#endregion
//#region src/core/computeScore.ts
function $f799e50bf8f2114e$var$computeScoreSingle(matches, param) {
    var _param_ignoreFieldNorm = param.ignoreFieldNorm, ignoreFieldNorm = _param_ignoreFieldNorm === void 0 ? $f799e50bf8f2114e$var$Config.ignoreFieldNorm : _param_ignoreFieldNorm;
    var totalScore = 1;
    matches.forEach(function(param) {
        var key = param.key, norm = param.norm, score = param.score;
        var weight = key ? key.weight : null;
        totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
    });
    return totalScore;
}
function $f799e50bf8f2114e$var$computeScore(results, param) {
    var _param_ignoreFieldNorm = param.ignoreFieldNorm, ignoreFieldNorm = _param_ignoreFieldNorm === void 0 ? $f799e50bf8f2114e$var$Config.ignoreFieldNorm : _param_ignoreFieldNorm;
    results.forEach(function(result) {
        result.score = $f799e50bf8f2114e$var$computeScoreSingle(result.matches, {
            ignoreFieldNorm: ignoreFieldNorm
        });
    });
}
//#endregion
//#region src/tools/MaxHeap.ts
var $f799e50bf8f2114e$var$MaxHeap = /*#__PURE__*/ function() {
    "use strict";
    function MaxHeap(limit, comparator) {
        (0, $4QweW._)(this, MaxHeap);
        this.limit = limit;
        this.heap = [];
        this.comparator = comparator;
    }
    (0, $6hK4i._)(MaxHeap, [
        {
            key: "size",
            get: function get() {
                return this.heap.length;
            }
        },
        {
            key: "insert",
            value: function insert(item) {
                if (this.size < this.limit) {
                    this.heap.push(item);
                    this._bubbleUp(this.size - 1);
                } else if (this.comparator(item, this.heap[0]) < 0) {
                    this.heap[0] = item;
                    this._sinkDown(0);
                }
            }
        },
        {
            key: "extractSorted",
            value: function extractSorted() {
                return this.heap.sort(this.comparator);
            }
        },
        {
            key: "_bubbleUp",
            value: function _bubbleUp(i) {
                var heap = this.heap;
                while(i > 0){
                    var parent = i - 1 >> 1;
                    if (this.comparator(heap[i], heap[parent]) <= 0) break;
                    var tmp = heap[i];
                    heap[i] = heap[parent];
                    heap[parent] = tmp;
                    i = parent;
                }
            }
        },
        {
            key: "_sinkDown",
            value: function _sinkDown(i) {
                var heap = this.heap;
                var len = heap.length;
                var largest = i;
                do {
                    i = largest;
                    var left = 2 * i + 1;
                    var right = 2 * i + 2;
                    if (left < len && this.comparator(heap[left], heap[largest]) > 0) largest = left;
                    if (right < len && this.comparator(heap[right], heap[largest]) > 0) largest = right;
                    if (largest !== i) {
                        var tmp = heap[i];
                        heap[i] = heap[largest];
                        heap[largest] = tmp;
                    }
                }while (largest !== i);
            }
        }
    ]);
    return MaxHeap;
}();
//#endregion
//#region src/core/formatMatches.ts
function $f799e50bf8f2114e$var$formatMatches(result) {
    var matches = [];
    result.matches.forEach(function(match) {
        if (!$f799e50bf8f2114e$var$isDefined(match.indices) || !match.indices.length) return;
        var obj = {
            indices: match.indices,
            value: match.value
        };
        if (match.key) obj.key = match.key.id;
        if (match.idx > -1) obj.refIndex = match.idx;
        matches.push(obj);
    });
    return matches;
}
//#endregion
//#region src/core/format.ts
function $f799e50bf8f2114e$var$format(results, docs) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $f799e50bf8f2114e$var$Config.includeMatches : _ref_includeMatches, _ref_includeScore = _ref.includeScore, includeScore = _ref_includeScore === void 0 ? $f799e50bf8f2114e$var$Config.includeScore : _ref_includeScore;
    return results.map(function(result) {
        var idx = result.idx;
        var data = {
            item: docs[idx],
            refIndex: idx
        };
        if (includeMatches) data.matches = $f799e50bf8f2114e$var$formatMatches(result);
        if (includeScore) data.score = result.score;
        return data;
    });
}
//#endregion
//#region src/search/token/analyzer.ts
var $f799e50bf8f2114e$var$DEFAULT_TOKEN = RegExp("[\\p{L}\\p{M}\\p{N}_]+", "gu");
var $f799e50bf8f2114e$var$warned = /* @__PURE__ */ new WeakSet();
function $f799e50bf8f2114e$var$warnNonGlobal(regex) {
    if (!$f799e50bf8f2114e$var$warned.has(regex)) {
        $f799e50bf8f2114e$var$warned.add(regex);
        console.warn("[Fuse] tokenize regex ".concat(regex, " lacks the global flag; only the first match per text will be returned. Add the 'g' flag."));
    }
}
function $f799e50bf8f2114e$var$resolveTokenize(tokenize) {
    if (typeof tokenize === "function") {
        var validated = false;
        return function(text) {
            var result = tokenize(text);
            if (!validated) {
                validated = true;
                if (!Array.isArray(result) || result.some(function(t) {
                    return typeof t !== "string";
                })) throw new Error("[Fuse] tokenize function must return string[]; received ".concat(Array.isArray(result) ? "array containing non-strings" : typeof result === "undefined" ? "undefined" : (0, $5djcY._)(result), "."));
            }
            return result;
        };
    }
    if (tokenize instanceof RegExp) {
        if (!tokenize.global) $f799e50bf8f2114e$var$warnNonGlobal(tokenize);
        return function(text) {
            return text.match(tokenize) || [];
        };
    }
    return function(text) {
        return text.match($f799e50bf8f2114e$var$DEFAULT_TOKEN) || [];
    };
}
function $f799e50bf8f2114e$var$createAnalyzer() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_isCaseSensitive = _ref.isCaseSensitive, isCaseSensitive = _ref_isCaseSensitive === void 0 ? false : _ref_isCaseSensitive, _ref_ignoreDiacritics = _ref.ignoreDiacritics, ignoreDiacritics = _ref_ignoreDiacritics === void 0 ? false : _ref_ignoreDiacritics, tokenize = _ref.tokenize;
    var tokenizeFn = $f799e50bf8f2114e$var$resolveTokenize(tokenize);
    return {
        tokenize: function(text) {
            if (!isCaseSensitive) text = text.toLowerCase();
            if (ignoreDiacritics) text = $f799e50bf8f2114e$var$stripDiacritics(text);
            return tokenizeFn(text);
        }
    };
}
//#endregion
//#region src/search/token/index.ts
var $f799e50bf8f2114e$var$MAX_MASK_TERMS = 31;
var $f799e50bf8f2114e$var$TokenSearch = /*#__PURE__*/ function() {
    "use strict";
    function TokenSearch(pattern, options) {
        (0, $4QweW._)(this, TokenSearch);
        this.options = options;
        this.analyzer = $f799e50bf8f2114e$var$createAnalyzer({
            isCaseSensitive: options.isCaseSensitive,
            ignoreDiacritics: options.ignoreDiacritics,
            tokenize: options.tokenize
        });
        var queryTerms = this.analyzer.tokenize(pattern);
        var _options__invertedIndex = options._invertedIndex, df = _options__invertedIndex.df, fieldCount = _options__invertedIndex.fieldCount;
        this.termSearchers = [];
        this.idfWeights = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = queryTerms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var term = _step.value;
                this.termSearchers.push(new $f799e50bf8f2114e$var$BitapSearch(term, {
                    location: options.location,
                    threshold: options.threshold,
                    distance: options.distance,
                    includeMatches: options.includeMatches,
                    findAllMatches: options.findAllMatches,
                    minMatchCharLength: options.minMatchCharLength,
                    isCaseSensitive: options.isCaseSensitive,
                    ignoreDiacritics: options.ignoreDiacritics,
                    ignoreLocation: true
                }));
                var docFreq = df.get(term) || 0;
                var idf = Math.log(1 + (fieldCount - docFreq + .5) / (docFreq + .5));
                this.idfWeights.push(idf);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.combineAll = options.tokenMatch === "all";
        this.numTerms = this.termSearchers.length;
        this.useMask = this.numTerms <= 31;
    }
    (0, $6hK4i._)(TokenSearch, [
        {
            key: "searchIn",
            value: function searchIn(text) {
                if (!this.termSearchers.length) return {
                    isMatch: false,
                    score: 1
                };
                var allIndices = [];
                var weightedScore = 0;
                var maxPossibleScore = 0;
                var matchedCount = 0;
                var matchedMask = 0;
                var matchedTerms = this.combineAll && !this.useMask ? /* @__PURE__ */ new Set() : null;
                for(var i = 0; i < this.termSearchers.length; i++){
                    var result = this.termSearchers[i].searchIn(text);
                    var idf = this.idfWeights[i];
                    maxPossibleScore += idf;
                    if (result.isMatch) {
                        var _allIndices;
                        matchedCount++;
                        weightedScore += idf * (1 - result.score);
                        if (result.indices) (_allIndices = allIndices).push.apply(_allIndices, (0, $jlUaU._)(result.indices));
                        if (this.combineAll) {
                            if (this.useMask) matchedMask |= 1 << i;
                            else matchedTerms.add(i);
                        }
                    }
                }
                if (matchedCount === 0) return {
                    isMatch: false,
                    score: 1
                };
                var normalized = maxPossibleScore > 0 ? 1 - weightedScore / maxPossibleScore : 0;
                var searchResult = {
                    isMatch: true,
                    score: Math.max(.001, normalized)
                };
                if (this.options.includeMatches && allIndices.length) searchResult.indices = $f799e50bf8f2114e$var$mergeIndices(allIndices);
                if (this.combineAll) {
                    if (this.useMask) searchResult.matchedMask = matchedMask;
                    else searchResult.matchedTerms = matchedTerms;
                    searchResult.termCount = this.numTerms;
                }
                return searchResult;
            }
        }
    ], [
        {
            key: "condition",
            value: function condition(_, options) {
                return options.useTokenSearch;
            }
        }
    ]);
    return TokenSearch;
}();
//#endregion
//#region src/search/token/InvertedIndex.ts
function $f799e50bf8f2114e$var$addField(index, text, docIdx, analyzer) {
    var tokens = analyzer.tokenize(text);
    if (!tokens.length) return;
    index.fieldCount++;
    index.docFieldCount.set(docIdx, (index.docFieldCount.get(docIdx) || 0) + 1);
    var distinctTerms = new Set(tokens);
    var perDocTerms = index.docTermFieldHits.get(docIdx);
    if (!perDocTerms) {
        perDocTerms = /* @__PURE__ */ new Map();
        index.docTermFieldHits.set(docIdx, perDocTerms);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = distinctTerms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var term = _step.value;
            perDocTerms.set(term, (perDocTerms.get(term) || 0) + 1);
            index.df.set(term, (index.df.get(term) || 0) + 1);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $f799e50bf8f2114e$var$ingestRecord(index, record, keyCount, analyzer) {
    var docIdx = record.i, v = record.v, fields = record.$;
    if (v !== void 0) {
        $f799e50bf8f2114e$var$addField(index, v, docIdx, analyzer);
        return;
    }
    if (!fields) return;
    for(var keyIdx = 0; keyIdx < keyCount; keyIdx++){
        var value = fields[keyIdx];
        if (!value) continue;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (Array.isArray(value)) try {
            for(var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var sub = _step.value;
                $f799e50bf8f2114e$var$addField(index, sub.v, docIdx, analyzer);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        else $f799e50bf8f2114e$var$addField(index, value.v, docIdx, analyzer);
    }
}
function $f799e50bf8f2114e$var$buildInvertedIndex(records, keyCount, analyzer) {
    var index = {
        fieldCount: 0,
        df: /* @__PURE__ */ new Map(),
        docFieldCount: /* @__PURE__ */ new Map(),
        docTermFieldHits: /* @__PURE__ */ new Map()
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = records[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var record = _step.value;
            $f799e50bf8f2114e$var$ingestRecord(index, record, keyCount, analyzer);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return index;
}
function $f799e50bf8f2114e$var$addToInvertedIndex(index, record, keyCount, analyzer) {
    $f799e50bf8f2114e$var$ingestRecord(index, record, keyCount, analyzer);
}
function $f799e50bf8f2114e$var$removeFromInvertedIndex(index, docIdx) {
    var fieldCount = index.docFieldCount.get(docIdx);
    if (fieldCount === void 0) return;
    index.fieldCount -= fieldCount;
    index.docFieldCount.delete(docIdx);
    var perDocTerms = index.docTermFieldHits.get(docIdx);
    if (!perDocTerms) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = perDocTerms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $6ZpBv._)(_step.value, 2), term = _step_value[0], hits = _step_value[1];
            var next = (index.df.get(term) || 0) - hits;
            if (next <= 0) index.df.delete(term);
            else index.df.set(term, next);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    index.docTermFieldHits.delete(docIdx);
}
function $f799e50bf8f2114e$var$removeAndShiftInvertedIndex(index, removedIndices) {
    if (removedIndices.length === 0) return;
    var sorted = Array.from(new Set(removedIndices)).sort(function(a, b) {
        return a - b;
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sorted[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var idx = _step.value;
            $f799e50bf8f2114e$var$removeFromInvertedIndex(index, idx);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var shift = function(oldIdx) {
        var lo = 0;
        var hi = sorted.length;
        while(lo < hi){
            var mid = lo + hi >>> 1;
            if (sorted[mid] < oldIdx) lo = mid + 1;
            else hi = mid;
        }
        return oldIdx - lo;
    };
    var firstRemoved = sorted[0];
    var shiftedDocFieldCount = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = index.docFieldCount[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value = (0, $6ZpBv._)(_step1.value, 2), oldKey = _step_value[0], count = _step_value[1];
            shiftedDocFieldCount.set(oldKey > firstRemoved ? shift(oldKey) : oldKey, count);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    index.docFieldCount = shiftedDocFieldCount;
    var shiftedDocTermFieldHits = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = index.docTermFieldHits[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _step_value1 = (0, $6ZpBv._)(_step2.value, 2), oldKey1 = _step_value1[0], terms = _step_value1[1];
            shiftedDocTermFieldHits.set(oldKey1 > firstRemoved ? shift(oldKey1) : oldKey1, terms);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    index.docTermFieldHits = shiftedDocTermFieldHits;
}
//#endregion
//#region src/core/index.ts
var $f799e50bf8f2114e$var$Fuse = /*#__PURE__*/ function() {
    "use strict";
    function Fuse(docs, options, index) {
        (0, $4QweW._)(this, Fuse);
        this.options = (0, $kWfK0._)({}, $f799e50bf8f2114e$var$Config, options);
        this.options.useExtendedSearch;
        this.options.useTokenSearch;
        this._keyStore = new $f799e50bf8f2114e$var$KeyStore(this.options.keys);
        this._docs = docs;
        this._myIndex = null;
        this._invertedIndex = null;
        this.setCollection(docs, index);
        this._lastQuery = null;
        this._lastSearcher = null;
    }
    (0, $6hK4i._)(Fuse, [
        {
            key: "_getSearcher",
            value: function _getSearcher(query) {
                if (this._lastQuery === query) return this._lastSearcher;
                var searcher = $f799e50bf8f2114e$var$createSearcher(query, this._invertedIndex ? (0, $hApvp._)((0, $kWfK0._)({}, this.options), {
                    _invertedIndex: this._invertedIndex
                }) : this.options);
                this._lastQuery = query;
                this._lastSearcher = searcher;
                return searcher;
            }
        },
        {
            key: "setCollection",
            value: function setCollection(docs, index) {
                this._docs = docs;
                if (index && !(index instanceof $f799e50bf8f2114e$var$FuseIndex)) throw new Error($f799e50bf8f2114e$var$INCORRECT_INDEX_TYPE);
                this._myIndex = index || $f799e50bf8f2114e$var$createIndex(this.options.keys, this._docs, {
                    getFn: this.options.getFn,
                    fieldNormWeight: this.options.fieldNormWeight
                });
                if (this.options.useTokenSearch) {
                    var analyzer = $f799e50bf8f2114e$var$createAnalyzer({
                        isCaseSensitive: this.options.isCaseSensitive,
                        ignoreDiacritics: this.options.ignoreDiacritics,
                        tokenize: this.options.tokenize
                    });
                    this._invertedIndex = $f799e50bf8f2114e$var$buildInvertedIndex(this._myIndex.records, this._myIndex.keys.length, analyzer);
                }
                this._invalidateSearcherCache();
            }
        },
        {
            key: "add",
            value: function add(doc) {
                if (!$f799e50bf8f2114e$var$isDefined(doc)) return;
                this._docs.push(doc);
                var record = this._myIndex.add(doc, this._docs.length - 1);
                if (this._invertedIndex && record) {
                    var analyzer = $f799e50bf8f2114e$var$createAnalyzer({
                        isCaseSensitive: this.options.isCaseSensitive,
                        ignoreDiacritics: this.options.ignoreDiacritics,
                        tokenize: this.options.tokenize
                    });
                    $f799e50bf8f2114e$var$addToInvertedIndex(this._invertedIndex, record, this._myIndex.keys.length, analyzer);
                }
                this._invalidateSearcherCache();
            }
        },
        {
            key: "remove",
            value: function remove() {
                var predicate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
                    return false;
                };
                var results = [];
                var indicesToRemove = [];
                for(var i = 0, len = this._docs.length; i < len; i += 1)if (predicate(this._docs[i], i)) {
                    results.push(this._docs[i]);
                    indicesToRemove.push(i);
                }
                if (indicesToRemove.length) {
                    if (this._invertedIndex) $f799e50bf8f2114e$var$removeAndShiftInvertedIndex(this._invertedIndex, indicesToRemove);
                    var toRemove = new Set(indicesToRemove);
                    this._docs = this._docs.filter(function(_, i) {
                        return !toRemove.has(i);
                    });
                    this._myIndex.removeAll(indicesToRemove);
                    this._invalidateSearcherCache();
                }
                return results;
            }
        },
        {
            key: "removeAt",
            value: function removeAt(idx) {
                if (!Number.isInteger(idx) || idx < 0 || idx >= this._docs.length) throw new Error($f799e50bf8f2114e$var$INVALID_DOC_INDEX);
                if (this._invertedIndex) $f799e50bf8f2114e$var$removeAndShiftInvertedIndex(this._invertedIndex, [
                    idx
                ]);
                var doc = this._docs.splice(idx, 1)[0];
                this._myIndex.removeAt(idx);
                this._invalidateSearcherCache();
                return doc;
            }
        },
        {
            key: "_invalidateSearcherCache",
            value: function _invalidateSearcherCache() {
                this._lastQuery = null;
                this._lastSearcher = null;
            }
        },
        {
            key: "getIndex",
            value: function getIndex() {
                return this._myIndex;
            }
        },
        {
            key: "_normalizedKeys",
            value: function _normalizedKeys() {
                var _this = this;
                return this._myIndex.keys.map(function(key) {
                    return _this._keyStore.get(key.id) || key;
                });
            }
        },
        {
            key: "search",
            value: function search(query, options) {
                var _ref = options || {}, _ref_limit = _ref.limit, limit = _ref_limit === void 0 ? -1 : _ref_limit;
                var _this_options = this.options, includeMatches = _this_options.includeMatches, includeScore = _this_options.includeScore, shouldSort = _this_options.shouldSort, sortFn = _this_options.sortFn, ignoreFieldNorm = _this_options.ignoreFieldNorm;
                if ($f799e50bf8f2114e$var$isString(query) && !query.trim()) {
                    var docs = this._docs.map(function(item, idx) {
                        return {
                            item: item,
                            refIndex: idx
                        };
                    });
                    if ($f799e50bf8f2114e$var$isNumber(limit) && limit > -1) docs = docs.slice(0, limit);
                    return docs;
                }
                var useHeap = shouldSort && $f799e50bf8f2114e$var$isNumber(limit) && limit > 0 && $f799e50bf8f2114e$var$isString(query);
                var comparator = sortFn;
                var stable = function(a, b) {
                    return comparator(a, b) || a.idx - b.idx;
                };
                var results;
                if (useHeap) {
                    var heap = new $f799e50bf8f2114e$var$MaxHeap(limit, stable);
                    if ($f799e50bf8f2114e$var$isString(this._docs[0])) this._searchStringList(query, {
                        heap: heap,
                        ignoreFieldNorm: ignoreFieldNorm
                    });
                    else this._searchObjectList(query, {
                        heap: heap,
                        ignoreFieldNorm: ignoreFieldNorm
                    });
                    results = heap.extractSorted();
                } else {
                    results = $f799e50bf8f2114e$var$isString(query) ? $f799e50bf8f2114e$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
                    $f799e50bf8f2114e$var$computeScore(results, {
                        ignoreFieldNorm: ignoreFieldNorm
                    });
                    if (shouldSort) results.sort($f799e50bf8f2114e$var$isString(query) ? stable : comparator);
                    if ($f799e50bf8f2114e$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
                }
                return $f799e50bf8f2114e$var$format(results, this._docs, {
                    includeMatches: includeMatches,
                    includeScore: includeScore
                });
            }
        },
        {
            key: "_searchStringList",
            value: function _searchStringList(query) {
                var _this = this;
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, heap = _ref.heap, ignoreFieldNorm = _ref.ignoreFieldNorm;
                var searcher = this._getSearcher(query);
                var requireAllTokens = this.options.useTokenSearch && this.options.tokenMatch === "all";
                var records = this._myIndex.records;
                var results = heap ? null : [];
                records.forEach(function(param) {
                    var text = param.v, idx = param.i, norm = param.n;
                    if (!$f799e50bf8f2114e$var$isDefined(text)) return;
                    var searchResult = searcher.searchIn(text);
                    if (searchResult.isMatch) {
                        var match = {
                            score: searchResult.score,
                            value: text,
                            norm: norm,
                            indices: searchResult.indices
                        };
                        if (requireAllTokens) {
                            match.matchedMask = searchResult.matchedMask;
                            match.matchedTerms = searchResult.matchedTerms;
                            match.termCount = searchResult.termCount;
                        }
                        var matches = [
                            match
                        ];
                        if (!requireAllTokens || _this._coversAllTokens(matches)) {
                            var result = {
                                item: text,
                                idx: idx,
                                matches: matches
                            };
                            if (heap) {
                                result.score = $f799e50bf8f2114e$var$computeScoreSingle(result.matches, {
                                    ignoreFieldNorm: ignoreFieldNorm
                                });
                                heap.insert(result);
                            } else results.push(result);
                        }
                    }
                });
                return results;
            }
        },
        {
            key: "_searchLogical",
            value: function _searchLogical(query) {
                var _this = this;
                var expression = $f799e50bf8f2114e$var$parse(query, this.options);
                var keys = this._normalizedKeys();
                var evaluate = function(node, item, idx) {
                    if (!("children" in node)) {
                        var keyId = node.keyId, searcher = node.searcher;
                        var matches;
                        if (keyId === null) {
                            matches = [];
                            keys.forEach(function(key, keyIndex) {
                                var _matches;
                                (_matches = matches).push.apply(_matches, (0, $jlUaU._)(_this._findMatches({
                                    key: key,
                                    value: item[keyIndex],
                                    searcher: searcher
                                })));
                            });
                        } else matches = _this._findMatches({
                            key: _this._keyStore.get(keyId),
                            value: _this._myIndex.getValueForItemAtKeyId(item, keyId),
                            searcher: searcher
                        });
                        if (matches && matches.length) return [
                            {
                                idx: idx,
                                item: item,
                                matches: matches
                            }
                        ];
                        return [];
                    }
                    var children = node.children, operator = node.operator;
                    var res = [];
                    for(var i = 0, len = children.length; i < len; i += 1){
                        var _res;
                        var child = children[i];
                        var result = evaluate(child, item, idx);
                        if (result.length) (_res = res).push.apply(_res, (0, $jlUaU._)(result));
                        else if (operator === $f799e50bf8f2114e$var$LogicalOperator.AND) return [];
                    }
                    return res;
                };
                var records = this._myIndex.records;
                var resultMap = /* @__PURE__ */ new Map();
                var results = [];
                records.forEach(function(param) {
                    var item = param.$, idx = param.i;
                    if ($f799e50bf8f2114e$var$isDefined(item)) {
                        var expResults = evaluate(expression, item, idx);
                        if (expResults.length) {
                            if (!resultMap.has(idx)) {
                                resultMap.set(idx, {
                                    idx: idx,
                                    item: item,
                                    matches: []
                                });
                                results.push(resultMap.get(idx));
                            }
                            expResults.forEach(function(param) {
                                var matches = param.matches;
                                var _resultMap_get_matches;
                                (_resultMap_get_matches = resultMap.get(idx).matches).push.apply(_resultMap_get_matches, (0, $jlUaU._)(matches));
                            });
                        }
                    }
                });
                return results;
            }
        },
        {
            key: "_searchObjectList",
            value: function _searchObjectList(query) {
                var _this = this;
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, heap = _ref.heap, ignoreFieldNorm = _ref.ignoreFieldNorm;
                var searcher = this._getSearcher(query);
                var requireAllTokens = this.options.useTokenSearch && this.options.tokenMatch === "all";
                var records = this._myIndex.records;
                var keys = this._normalizedKeys();
                var results = heap ? null : [];
                records.forEach(function(param) {
                    var item = param.$, idx = param.i;
                    if (!$f799e50bf8f2114e$var$isDefined(item)) return;
                    var matches = [];
                    var anyKeyFailed = false;
                    var hasInverse = false;
                    keys.forEach(function(key, keyIndex) {
                        var keyMatches = _this._findMatches({
                            key: key,
                            value: item[keyIndex],
                            searcher: searcher
                        });
                        if (keyMatches.length) {
                            var _matches;
                            (_matches = matches).push.apply(_matches, (0, $jlUaU._)(keyMatches));
                            if (keyMatches[0].hasInverse) hasInverse = true;
                        } else anyKeyFailed = true;
                    });
                    if (hasInverse && anyKeyFailed) return;
                    if (matches.length && (!requireAllTokens || _this._coversAllTokens(matches))) {
                        var result = {
                            idx: idx,
                            item: item,
                            matches: matches
                        };
                        if (heap) {
                            result.score = $f799e50bf8f2114e$var$computeScoreSingle(result.matches, {
                                ignoreFieldNorm: ignoreFieldNorm
                            });
                            heap.insert(result);
                        } else results.push(result);
                    }
                });
                return results;
            }
        },
        {
            key: "_findMatches",
            value: function _findMatches(param) {
                var key = param.key, value = param.value, searcher = param.searcher;
                if (!$f799e50bf8f2114e$var$isDefined(value)) return [];
                var matches = [];
                if ($f799e50bf8f2114e$var$isArray(value)) value.forEach(function(param) {
                    var text = param.v, idx = param.i, norm = param.n;
                    if (!$f799e50bf8f2114e$var$isDefined(text)) return;
                    var searchResult = searcher.searchIn(text);
                    if (searchResult.isMatch) {
                        var match = {
                            score: searchResult.score,
                            key: key,
                            value: text,
                            idx: idx,
                            norm: norm,
                            indices: searchResult.indices,
                            hasInverse: searchResult.hasInverse
                        };
                        if (searchResult.termCount !== void 0) {
                            match.matchedMask = searchResult.matchedMask;
                            match.matchedTerms = searchResult.matchedTerms;
                            match.termCount = searchResult.termCount;
                        }
                        matches.push(match);
                    }
                });
                else {
                    var text = value.v, norm = value.n;
                    var searchResult = searcher.searchIn(text);
                    if (searchResult.isMatch) {
                        var match = {
                            score: searchResult.score,
                            key: key,
                            value: text,
                            norm: norm,
                            indices: searchResult.indices,
                            hasInverse: searchResult.hasInverse
                        };
                        if (searchResult.termCount !== void 0) {
                            match.matchedMask = searchResult.matchedMask;
                            match.matchedTerms = searchResult.matchedTerms;
                            match.termCount = searchResult.termCount;
                        }
                        matches.push(match);
                    }
                }
                return matches;
            }
        },
        {
            key: "_coversAllTokens",
            value: function _coversAllTokens(matches) {
                var termCount = matches.length ? matches[0].termCount : void 0;
                if (termCount === void 0) return true;
                if (termCount <= 31) {
                    var coverage = 0;
                    for(var i = 0; i < matches.length; i++)coverage |= matches[i].matchedMask || 0;
                    return coverage === Math.pow(2, termCount) - 1;
                }
                var coverage1 = /* @__PURE__ */ new Set();
                for(var i1 = 0; i1 < matches.length; i1++){
                    var terms = matches[i1].matchedTerms;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (terms) try {
                        for(var _iterator = terms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var t = _step.value;
                            coverage1.add(t);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return coverage1.size === termCount;
            }
        }
    ]);
    return Fuse;
}();
//#endregion
//#region src/entry.ts
$f799e50bf8f2114e$var$Fuse.version = "7.5.0";
$f799e50bf8f2114e$var$Fuse.createIndex = $f799e50bf8f2114e$var$createIndex;
$f799e50bf8f2114e$var$Fuse.parseIndex = $f799e50bf8f2114e$var$parseIndex;
$f799e50bf8f2114e$var$Fuse.config = $f799e50bf8f2114e$var$Config;
$f799e50bf8f2114e$var$Fuse.match = function(pattern, text, options) {
    if (options && options.useTokenSearch) throw new Error($f799e50bf8f2114e$var$FUSE_MATCH_TOKEN_SEARCH_UNSUPPORTED);
    return $f799e50bf8f2114e$var$createSearcher(pattern, (0, $kWfK0._)({}, $f799e50bf8f2114e$var$Config, options)).searchIn(text);
};
$f799e50bf8f2114e$var$Fuse.parseQuery = $f799e50bf8f2114e$var$parse;
$f799e50bf8f2114e$var$register($f799e50bf8f2114e$var$ExtendedSearch);
$f799e50bf8f2114e$var$register($f799e50bf8f2114e$var$TokenSearch);
$f799e50bf8f2114e$var$Fuse.use = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++){
        plugins[_key] = arguments[_key];
    }
    plugins.forEach(function(plugin) {
        return $f799e50bf8f2114e$var$register(plugin);
    });
};
var $f799e50bf8f2114e$export$2e2bcd8739ae039 = $f799e50bf8f2114e$var$Fuse;

});


var $9HB6H = parcelRequire("9HB6H");

var $iD6kw = parcelRequire("iD6kw");

var $kwI20 = parcelRequire("kwI20");

var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $6ZpBv = parcelRequire("6ZpBv");

var $9HB6H = parcelRequire("9HB6H");

var $lYyrX = parcelRequire("lYyrX");
var $6f2a73f4fdc93d35$exports = {};

var $5djcY = parcelRequire("5djcY");

(function() {
    var t = {
        194: function(t) {
            var e;
            self, e = function() {
                return function() {
                    "use strict";
                    var _$t = {
                        d: function(e, n) {
                            for(var o1 in n)_$t.o(n, o1) && !_$t.o(e, o1) && Object.defineProperty(e, o1, {
                                enumerable: !0,
                                get: n[o1]
                            });
                        },
                        o: function(t, e) {
                            return Object.prototype.hasOwnProperty.call(t, e);
                        },
                        r: function(t) {
                            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                                value: "Module"
                            }), Object.defineProperty(t, "__esModule", {
                                value: !0
                            });
                        }
                    }, e = {};
                    _$t.r(e), _$t.d(e, {
                        default: function() {
                            return Tt;
                        }
                    });
                    var _$n, i = "fslightbox-", s = "".concat(i, "styles"), r = "".concat(i, "full-dimension"), a = "".concat(i, "flex-centered"), c = "".concat(i, "open"), u = "".concat(i, "absoluted"), l = "".concat(i, "opacity-1"), d = "".concat(i, "slide-btn"), h = "".concat(d, "-container"), f = "".concat(i, "fade-in"), p = "".concat(i, "fade-out"), m = f + "-strong", b = p + "-strong", g = "".concat(i, "thumb"), v = g + "s", x = "".concat(v, "-loader"), y = "".concat(v, "-cursorer"), w = "".concat(v, "-inner"), C = g + "-wrapper", L = g + "-invalid";
                    function T(t) {
                        return T = "function" == typeof Symbol && "symbol" == (0, $5djcY._)(Symbol.iterator) ? function T(t) {
                            return typeof t === "undefined" ? "undefined" : (0, $5djcY._)(t);
                        } : function(t) {
                            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $5djcY._)(t);
                        }, T(t);
                    }
                    function z(t) {
                        var e = t.c, _$n = t.componentsServices, o1 = t.core.thumbsRenderDispatcher, i = t.data, s = t.ea, r = t.la, a = (t.stageIndexes, t.ui), c = t.z;
                        function u() {
                            for(var _$t = 0; _$t < e; _$t++)r.t(_$t);
                        }
                        this.o = function() {
                            c.r(), i.isThumbing = !0, s.uc(), a.sthc(), u(), o1.renderThumbsIfNotYetAndAllTypesDetected(), i.unloadedThumbsCount && _$n.appendThumbsLoaderIfNotYet();
                        }, this.x = function() {
                            c.r(), i.isThumbing = !1, s.dc(), a.htsc(), u();
                        };
                    }
                    function S(t, e) {
                        var _$n = t.classList;
                        _$n.contains(e) && _$n.remove(e);
                    }
                    function I(t, e) {
                        var _$n = t.classList;
                        _$n.contains(e) || _$n.add(e);
                    }
                    function A(t) {
                        var e = t.data, _$n = t.elements, o1 = t.stageIndexes;
                        this.runActions = function() {
                            S(_$n.thumbsContainer, a);
                            var _$t = innerWidth / 2, s = _$n.thumbsWrappers[o1.current], r = s.offsetLeft + s.offsetWidth / 2, c = e.thumbsInnerWidth - r;
                            r > _$t && c > _$t ? i(_$t - r) : r > _$t ? i(innerWidth - e.thumbsInnerWidth - 9) : c > _$t && i(0);
                        }, this.runToThinThumbsActions = function() {
                            I(_$n.thumbsContainer, a), i(0);
                        };
                        var i = function i(t) {
                            e.thumbsTransform = t, _$n.thumbsInner.style.transform = "translateX(".concat(t, "px)");
                        };
                    }
                    function E(t) {
                        var e = this, _$n = t.core, o1 = _$n.eventsDispatcher, i = _$n.globalEventsController, s = _$n.scrollbarRecompensor, r = (t.data, t.elements), a = t.fs, u = t.p, l = t.props, d = t.qs, h = t.ss, f = t.t, p = t.thumbsSwipingProps, m = t.ud, g = t.z;
                        this.i = 0, this.runActions = function() {
                            e.i = 1;
                            var _$n = r.container;
                            _$n.classList.add(b), i.removeListeners(), h.r(), l.exitFullscreenOnClose && t.ifs && a.x(), g.r(), f(function() {
                                e.i = 0;
                                for(var i = 0; i < t.ts.length; i++)clearTimeout(t.ts[i]);
                                for(t.ts = [], i = 0; i < d.length; i++)d[i] = 0;
                                u.i = !1, p && (p.i = !1), _$n.classList.remove(b), document.documentElement.classList.remove(c), s.removeRecompense(), m && _$n.close(), document.body.removeChild(_$n), o1.dispatch("onClose");
                            }, 270);
                        };
                    }
                    function F(t, e, n, o1) {
                        var i = t.isl, s = t.props.slideChangeAnimation, r = t.saw, a = t.smw, c = t.st, u = t.stageIndexes, l = t.sws, d = e.previous, h = e.current, f = e.next;
                        function m() {
                            c.i(h) ? h === u.previous ? a[h].ne() : h === u.next && a[h].p() : (a[h].h(), a[h].n());
                        }
                        function b(t, e, n) {
                            t && r[e].classList.add(n);
                        }
                        this.runJumpReflowedActions = function() {
                            b(n, h, p), b(o1, u.current, s), l.a(), void 0 !== u.previous && u.previous !== h && a[u.previous].ne(), a[u.current].n(), void 0 !== u.next && u.next !== h && a[u.next].p(), l.b(d), l.b(f), i[h] ? setTimeout(m, 260) : m();
                        };
                    }
                    function k(t) {
                        var e, _$n = t.core.slideChangeFacade, o1 = t.props, i = t.ss, s = t.stageIndexes, r = !1;
                        function a() {
                            r = !1, clearTimeout(e), t.ssb.classList.remove(l), t.ssx();
                        }
                        function c() {
                            var i = t.ssb;
                            i.style.transition = "opacity .2s", i.style.width = "0px", i.offsetWidth, i.style.transition = "opacity .2s, width linear ".concat(o1.slideshowTime, "ms"), i.style.width = innerWidth + "px", e = setTimeout(function() {
                                _$n.changeToNext(), o1.disableSlideshowLoop && s.current + 1 === o1.sources.length ? a() : c();
                            }, o1.slideshowTime);
                        }
                        i.t = function() {
                            r ? a() : (r = !0, t.sss(), t.ssb.classList.add(l), c());
                        }, i.r = function() {
                            r && a();
                        };
                    }
                    function N(t) {
                        var e = t.p, _$n = Object.keys(e), o1 = e[_$n[0]], i = e[_$n[1]];
                        return Math.hypot(o1.screenX - i.screenX, o1.screenY - i.screenY);
                    }
                    function M(t) {
                        t.componentsServices;
                        var e = t.core.pointeringBucket, _$n = t.elements, o1 = t.ms, i = t.p, s = t.smw, r = t.stageIndexes, a = t.z, c = t.zv;
                        function u(t, e) {
                            s[t].v(i.swipedX)[e]();
                        }
                        this.a = function(o1) {
                            e.runSwipingMoveActionsForPropsAndEvent(i, o1), !_$n.container.contains(t.h) && Math.abs(i.swipedX) > 5 && _$n.container.appendChild(t.h);
                        }, this.p = function() {
                            var _$t = N(i), e = o1[r.current] + .25;
                            if (i.pinchedHypot) {
                                var _$n = _$t - i.pinchedHypot, s = c + _$n / Math.hypot(innerWidth, innerHeight) * 10;
                                s < .9 ? s = .9 : s > e && (s = e), a.z(s), i.pinchedHypot = _$t;
                            } else i.pinchedHypot = _$t;
                        }, this.s = function() {
                            u(r.current, "z"), void 0 !== r.previous && i.swipedX > 0 ? u(r.previous, "ne") : void 0 !== r.next && i.swipedX < 0 && u(r.next, "p");
                        }, this.zs = function(t) {
                            i.swipedX = (t.screenX - i.downScreenX) / c, i.swipedY = (t.screenY - i.downScreenY) / c, s[r.current].v(i.ux + i.swipedX, i.uy + i.swipedY).z();
                        };
                    }
                    function B(t, e) {
                        var _$n = t.c, o1 = t.dss, i = t.p, s = t.r, r = t.zv, a = s(M);
                        if (i.isPinching) return a.a(e), void a.p();
                        2 !== i.pc && (1 === r ? 1 === _$n || o1 ? i.swipedX = 1 : (a.a(e), a.s()) : (a.a(e), a.zs(e)));
                    }
                    function W(t) {
                        var e = t.core, _$n = e.clickZoomer, o1 = e.slideIndexChanger, i = t.p, s = t.smw, r = t.stageIndexes, a = t.sws, c = t.zv;
                        function u(t) {
                            var e = s[r.current];
                            e.a(), e[t]();
                        }
                        function l(t, e) {
                            void 0 !== t && (s[t].s(), s[t][e]());
                        }
                        this.p = function() {
                            var _$t = r.previous;
                            if (void 0 === _$t) u("z");
                            else {
                                u("p");
                                var e = r.next;
                                o1.changeTo(_$t);
                                var _$n = r.previous;
                                a.d(_$n), a.b(e), u("z"), l(_$n, "ne");
                            }
                        }, this.n = function() {
                            var _$t = r.next;
                            if (void 0 === _$t) u("z");
                            else {
                                u("ne");
                                var e = r.previous;
                                o1.changeTo(_$t);
                                var _$n = r.next;
                                a.d(_$n), a.b(e), u("z"), l(_$n, "p");
                            }
                        }, this.s = function() {
                            var _$t = s[r.current];
                            i.ux = _$t.gx(), i.uy = _$t.gy();
                        }, this.d = function() {
                            c <= 1 ? _$n.zoomIn() : _$n.zoomOut();
                        };
                    }
                    function R(t, e) {
                        t.contains(e) && t.removeChild(e);
                    }
                    function H(t) {
                        t.componentsServices;
                        var e = t.core, _$n = e.lightboxCloser, o1 = e.pointeringBucket, i = t.dss, s = t.elements, r = t.p, a = t.props.disableBackgroundClose, c = t.r, u = t.swc, l = (t.ui, t.zv), d = c(W);
                        this.a = function() {
                            R(s.container, t.h), r.isPinching = !1, r.pinchedHypot = 0, o1.runSwipingTopActionsForPropsAndEvent(r), u.classList.remove("fslightboxswcp");
                        }, this.s = function() {
                            1 === l ? i || (r.swipedX > 0 ? d.p() : d.n()) : d.s();
                        }, this.n = function(t) {
                            "VIDEO" !== t.target.tagName && (r.sd ? d.d() : a || _$n.close());
                        };
                    }
                    function O(t, e) {
                        var _$n = t.p;
                        _$n.p[e.pointerId] = {
                            screenX: e.screenX,
                            screenY: e.screenY
                        };
                        var o1 = Object.keys(_$n.p).length;
                        return _$n.pc = o1, o1 <= 2;
                    }
                    function D(t) {
                        var e = t.core.pointeringBucket, _$n = t.data, o1 = t.elements, i = t.thumbsSwipingProps;
                        this.runActions = function(t) {
                            e.runSwipingMoveActionsForPropsAndEvent(i, t), o1.thumbsInner.style.transform = "translateX(".concat(_$n.thumbsTransform + i.swipedX, "px)"), !o1.thumbsContainer.contains(o1.thumbsCursorer) && Math.abs(i.swipedX) > 5 && o1.thumbsContainer.appendChild(o1.thumbsCursorer);
                        };
                    }
                    function P(t) {
                        var e = t.data, _$n = t.resolve, o1 = t.thumbsSwipingProps, i = _$n(D), s = window.innerWidth;
                        this.listener = function(t) {
                            e.thumbsInnerWidth > s && o1.i && i.runActions(t);
                        };
                    }
                    function q(t) {
                        var e = t.data, _$n = t.core, o1 = _$n.slideIndexChanger, i = _$n.thumbsTransformTransitioner, s = _$n.pointeringBucket, r = t.elements, a = t.thumbsSwipingProps, c = r.thumbsWrappers;
                        this.runNoSwipeActionsForEvent = function(t) {
                            R(r.thumbsContainer, r.thumbsCursorer), a.i = !1;
                            for(var e = 0; e < c.length; e++)if (c[e] && c[e].contains(t.target)) return void o1.jumpTo(e);
                        }, this.runActions = function() {
                            if (R(r.thumbsContainer, r.thumbsCursorer), e.thumbsTransform += a.swipedX, s.runSwipingTopActionsForPropsAndEvent(a), e.thumbsTransform > 0) return u(0);
                            e.thumbsTransform < innerWidth - e.thumbsInnerWidth - 9 && u(innerWidth - e.thumbsInnerWidth - 9);
                        };
                        var u = function u(t) {
                            e.thumbsTransform = t, i.callActionWithTransition(function() {
                                r.thumbsInner.style.transform = "translateX(".concat(t, "px)");
                            });
                        };
                    }
                    function X(t) {
                        var e = t.resolve, _$n = t.thumbsSwipingProps, o1 = e(q);
                        this.listener = function(t) {
                            _$n.i && (Math.abs(_$n.swipedX) > 5 ? o1.runActions() : o1.runNoSwipeActionsForEvent(t));
                        };
                    }
                    function Y(t) {
                        var e = t.m, _$n = t.props, o1 = t.r, i = t.ui, s = o1(X), r = o1(P), a = function() {
                            var _$t = !1;
                            return function() {
                                return !_$t && (_$t = !0, requestAnimationFrame(function() {
                                    _$t = !1;
                                }), !0);
                            };
                        }();
                        this.m = function(o1) {
                            i.qps(), t.p.i && e(B, O)(o1), _$n.disableThumbs || r.listener(o1);
                        }, this.u = function(e) {
                            !function(t, e) {
                                var _$n = t.ms, o1 = t.p, i = t.r, s = t.stageIndexes, r = t.z, a = t.zv, c = i(H), u = s.current;
                                o1.p = {}, o1.i && (o1.isPinching || (Math.abs(o1.swipedX) > 5 ? c.s() : c.n(e)), c.a(), a < 1 ? (r.z(1), r.e()) : a > _$n[u] && r.z(_$n[u]));
                            }(t, e), _$n.disableThumbs || s.listener(e), i.qps();
                        }, this.w = function(e) {
                            t.p.i || (i.qps(), a() && function(t, e) {
                                var _$n = t.z, o1 = t.zv;
                                if (1 === o1) {
                                    if (e.deltaY > 0) return;
                                    _$n.b();
                                }
                                var i = .1 * o1, s = o1;
                                e.deltaY < 0 ? s += i : (s -= i) < 1 && (s = 1), _$n.zm(s), 1 === s && _$n.e();
                            }(t, e));
                        };
                    }
                    function j(t, e) {
                        var _$n = t.core, i = _$n.clickZoomer, s = _$n.lightboxCloser, r = _$n.slideChangeFacade, a = _$n.thumbsToggler, c = t.fs, u = (t.middleware, t.props), l = t.ss;
                        if (t.ui.qps(), "Space" !== e.code) switch(e.key){
                            case "Escape":
                                s.close();
                                break;
                            case "ArrowLeft":
                                r.changeToPrevious();
                                break;
                            case "ArrowRight":
                                r.changeToNext();
                                break;
                            case "t":
                                u.disableThumbs || a.toggleThumbs();
                                break;
                            case "+":
                                o.p.i || i.zoomIn();
                                break;
                            case "-":
                                o.p.i || i.zoomOut();
                                break;
                            case "F11":
                                e.preventDefault(), c.t();
                        }
                        else l.t();
                    }
                    function V(t, e, n, o1) {
                        var i = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                        i.setAttributeNS(null, "viewBox", e), i.setAttributeNS(null, "class", o1);
                        var s = document.createElementNS("http://www.w3.org/2000/svg", "path");
                        return s.setAttributeNS(null, "class", "fslightboxsvgp"), s.setAttributeNS(null, "d", n), i.appendChild(s), t.appendChild(i), i;
                    }
                    function U(t, e) {
                        var _$n = document.createElement("button");
                        return _$n.className = "fslightboxb ".concat(i, "toolbar-button ").concat(a), _$n.title = e, t.appendChild(_$n), _$n;
                    }
                    function _(t, e, n) {
                        var o1 = U(t, e.title);
                        o1.onclick = n, V(o1, e.viewBox, e.d, e.class);
                    }
                    function Z(t, e) {
                        var _$n = t.c, o1 = t.core.pointeringBucket, i = t.elements.sources, s = t.p, r = t.smw, a = t.stageIndexes, c = t.swc, u = t.z, l = t.zv;
                        if ("touch" !== e.pointerType && "IMG" === e.target.tagName && e.preventDefault(), o1.runSwipingDownActionsForPropsAndEvent(s, e), s.downScreenY = e.screenY, 2 === s.pc) s.isPinching = !0, s.pinchedHypot = N(s), c.classList.add("fslightboxswcp"), 1 === l && u.b();
                        else for(var d = 0; d < _$n; d++)r[d].d();
                        var h = i[a.current];
                        s.sd = h && h.contains(e.target);
                    }
                    function J(t) {
                        var e = "fslightbox-loader", _$n = document.createElement("div");
                        _$n.className = e;
                        for(var o1 = 0; o1 < 3; o1++){
                            var i = document.createElement("div");
                            i.className = "".concat(e, "-child"), _$n.appendChild(i);
                        }
                        return t.appendChild(_$n), _$n;
                    }
                    function G(t, e) {
                        var _$n = t.smw, o1 = t.st, i = t.swc, s = document.createElement("div"), c = "".concat(u, " ").concat(r, " ").concat(a), l = 0, d = 0, h = 0;
                        function f(t) {
                            l = t + d, s.style.transform = "translate(".concat(l, "px,").concat(h, "px)"), d = 0;
                        }
                        function p() {
                            return (1 + t.props.slideDistance) * innerWidth;
                        }
                        s.className = c, s.s = function() {
                            s.style.display = "flex";
                        }, s.h = function() {
                            s.style.display = "none";
                        }, s.a = function() {
                            s.classList.add("fslightboxtt");
                        }, s.d = function() {
                            s.classList.remove("fslightboxtt");
                        }, s.n = function() {
                            s.style.removeProperty("transform");
                        }, s.v = function(t, e) {
                            return d = t, void 0 !== e && (h = e), s;
                        }, s.gx = function() {
                            return l;
                        }, s.gy = function() {
                            return h;
                        }, s.ne = function() {
                            f(-p());
                        }, s.z = function() {
                            f(0);
                        }, s.p = function() {
                            f(p());
                        }, i.appendChild(s), o1.i(e) || s.h(), _$n[e] = s, function(t, e) {
                            var _$n = t.smw, o1 = t.sew, i = document.createElement("div");
                            _$n[e].appendChild(i), o1[e] = i, function(t, e) {
                                var _$n = t.saw, o1 = t.sew, i = document.createElement("div");
                                J(i), o1[e].appendChild(i), _$n[e] = i;
                            }(t, e);
                        }(t, e);
                    }
                    function $(t, e) {
                        var _$n = t.data.isThumbing, o1 = t.elements, i = o1.captions, s = o1.container, r = t.props.captions, c = t.stageIndexes.current, u = t.tc, l = document.createElement("div"), d = document.createElement("div"), h = "fslightboxc ".concat(a);
                        (c !== e || _$n && !u) && (h += " fslightboxx"), _$n && u && (h += " fslightboxct"), l.className = h, d.className = "fslightboxci", r[e] instanceof Element ? d.appendChild(r[e]) : d.innerHTML = r[e], l.appendChild(d), i[e] = l, s.appendChild(l);
                    }
                    function K(t, e) {
                        var _$n = t.core.slideChangeFacade, o1 = t.elements, i = t.props.slideButtons, s = e.charAt(0).toUpperCase() + e.slice(1), r = "slideButton".concat(s), c = i[e];
                        o1[r] = document.createElement("div"), o1[r].className = "".concat(h, " ").concat(h, "-").concat(e), o1[r].title = c.title, o1[r].onclick = _$n["changeTo".concat(s)], function(t, e) {
                            var _$n = document.createElement("button");
                            _$n.className = "fslightboxb ".concat(d, " ").concat(a), V(_$n, e.viewBox, e.d, e.class), t.appendChild(_$n);
                        }(o1[r], c), o1.container.appendChild(o1[r]);
                    }
                    "object" === ("undefined" == typeof document ? "undefined" : T(document)) && ((_$n = document.createElement("style")).className = s, _$n.appendChild(document.createTextNode(".fslightbox-fade-in{animation:fslightbox-fade-in .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out{animation:fslightbox-fade-out .3s ease}.fslightbox-fade-in-strong{animation:fslightbox-fade-in-strong forwards .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out-strong{animation:fslightbox-fade-out-strong .3s ease}@keyframes fslightbox-fade-in{from{opacity:.65}to{opacity:1}}@keyframes fslightbox-fade-out{from{opacity:.35}to{opacity:0}}@keyframes fslightbox-fade-in-strong{from{opacity:.3}to{opacity:1}}@keyframes fslightbox-fade-out-strong{from{opacity:1}to{opacity:0}}.fslightbox-absoluted{position:absolute;top:0;left:0}.fslightboxcg{cursor:grabbing!important}.fslightbox-full-dimension{width:100%;height:100%}.fslightbox-open{overflow:hidden;height:100%}.fslightbox-flex-centered{display:flex;justify-content:center;align-items:center}.fslightbox-opacity-0{opacity:0!important}.fslightbox-opacity-1{opacity:1!important}.fslightboxx{opacity:0!important;z-index:-1!important}.fslightbox-scrollbarfix{padding-right:17px}.fslightboxtt{transition:transform .3s!important}.fslightbox-container::backdrop{display:none}.fslightbox-container{font-family:Arial,sans-serif;position:fixed;top:0;left:0;padding:0;border:0;max-width:none;max-height:none;background:linear-gradient(rgba(30,30,30,.9),#000 1810%);touch-action:none;z-index:1000000000;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.fslightbox-container *{box-sizing:border-box}.fslightboxsvg{width:20px;height:20px}.fslightboxsvgp{transition:fill .15s ease;fill:#ddd}.fslightbox-loader{display:block;margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:67px;height:67px}.fslightbox-loader-child{box-sizing:border-box;display:block;position:absolute;width:54px;height:54px;margin:6px;border:5px solid;border-color:#999 transparent transparent transparent;border-radius:50%;animation:fslightbox-loader 1.2s cubic-bezier(.5,0,.5,1) infinite}.fslightbox-loader-child:nth-child(1){animation-delay:-.45s}.fslightbox-loader-child:nth-child(2){animation-delay:-.3s}.fslightbox-loader-child:nth-child(3){animation-delay:-.15s}@keyframes fslightbox-loader{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}.fslightbox-thumbs-loader{width:54px!important;height:54px!important}.fslightbox-thumbs-loader div{border-width:4px!important;width:44px!important;height:44px!important}.fslightbox-nav{position:absolute;top:0;left:0;height:45px;width:100%;transition:opacity .3s}.fslightboxsn{z-index:0;display:flex;align-items:center;margin:14px 0 0 11px;font-size:15px;color:#d7d7d7}.fslightboxsn span{display:inline;vertical-align:middle}.fslightboxsl{display:inline-block!important;margin:0 5px;width:1px;height:12px;transform:rotate(15deg);background:#fff}.fslightbox-toolbar{position:absolute;z-index:2;right:0;top:0;height:100%;display:flex}.fslightbox-toolbar-button{height:100%;width:45px;cursor:pointer}.fslightboxb{border:0;background:rgba(35,35,35,.65);cursor:pointer}.fslightboxb:focus{outline:0}.fslightboxb:focus .fslightboxsvgp{fill:#fff}.fslightboxb:hover .fslightboxsvgp{fill:#fff}.fslightboxfsx{width:24px;height:24px}.fslightboxbss{width:16px;height:16px}.fslightboxbsp{width:14px;height:14px}.fslightboxbt{width:17px;height:17px}.fslightbox-slide-btn-container{display:flex;align-items:center;padding:12px 12px 12px 6px;position:absolute;top:50%;cursor:pointer;z-index:2;transform:translateY(-50%);transition:opacity .3s}.fslightbox-slide-btn-container:hover .fslightboxsvgp{fill:#fff}.fslightbox-slide-btn{padding:9px}.fslightbox-slide-btn-container-previous{left:0}.fslightbox-slide-btn-container-next{right:0;padding-left:12px;padding-right:3px}.fslightboxh{z-index:3}.fslightboxss{width:0;height:2px;z-index:3;opacity:0;background:#fff}.fslightboxin{font-size:24px;color:#eaebeb;margin:auto}.fslightboxv{cursor:default!important;object-fit:cover}.fslightboxyt{border:0}.fslightboxs{position:relative;z-index:3;display:block!important;opacity:0;margin:auto;cursor:zoom-in}.fslightboxswc{z-index:1;transition:transform .2s linear}.fslightboxswcp{transition:none!important}.fslightbox-thumbs{position:absolute;bottom:0;left:0;width:100%;z-index:2;background:linear-gradient(180deg,rgba(0,0,0,0),#1e1e1e 100%);transition:opacity .2s;padding:10px 5px 12px 5px;height:114px}.fslightbox-thumbs-inner{display:inline-flex;justify-content:flex-start;align-items:center;height:100%}.fslightbox-thumb-wrapper{position:relative;height:100%;margin:0 4px;opacity:0;transition:opacity .3s}.fslightbox-thumb-wrapper svg{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer;z-index:1}.fslightbox-thumb-wrapper path{fill:#fff}.fslightboxtd{position:absolute;top:2px;left:2px;width:calc(100% - 4px);height:calc(100% - 4px);background:rgba(0,0,0,.4);cursor:pointer}.fslightbox-thumb{cursor:pointer;border-radius:1px;height:100%;width:auto!important;border:2px solid transparent;max-width:unset;max-height:unset}.fslightboxta{border:2px solid #fff!important}.fslightbox-thumb-invalid{background:linear-gradient(to bottom,#0f0f0f,rgba(15,15,15,.5));display:inline-block;min-width:155px}.fslightbox-thumbs-cursorer{z-index:3;cursor:grabbing}.fslightboxc{position:absolute;bottom:0;left:50%;width:100%;transform:translateX(-50%);transition:opacity .2s,transform .3s;z-index:2;user-select:text}.fslightboxc:after{content:'';position:absolute;z-index:-1;top:0;left:0;opacity:1;transition:opacity 1s;width:100%;height:100%;background:linear-gradient(180deg,rgba(0,0,0,0),#1e1e1e 100%)}.fslightboxci{padding:20px 25px 30px 25px;max-width:1200px;color:#eee;text-align:center;font-size:14px}.fslightboxct{transform:translate(-50%,-88px)}.fslightboxct:after{opacity:0;transition:none}@media(max-width:475.99px){.fslightbox-slide-btn-container-previous{padding-left:3px}}@media(min-width:476px){.fslightbox-slide-btn-container{padding:22px 22px 22px 6px}.fslightbox-slide-btn-container-next{padding-right:6px!important;padding-left:22px}}@media (min-width:768px){.fslightbox-slide-btn-container{padding:30px 30px 30px 6px}.fslightbox-slide-btn-container-next{padding-left:30px}.fslightbox-slide-btn{padding:10px}}@media(min-width:992px){.fslightboxct{transform:translate(-50%,-93px)}.fslightbox-thumbs{padding-top:13px;height:120px}}@media(min-width:1200px){.fslightboxsn{margin:15px 0 0 12px;font-size:16px;display:block}.fslightboxsl{margin:0 6px 1px 6px;height:14px}.fslightbox-slide-btn{padding:11px}.fslightboxsvg{width:22px;height:22px}.fslightboxfsx{width:26px;height:26px}.fslightboxbss{width:18px;height:18px}.fslightboxbsp{width:15px;height:15px}.fslightboxbt{width:18px;height:18px}.fslightboxl div{width:60px;height:60px;border-width:6px;border-color:#999 transparent transparent transparent;border-radius:50%}}@media(min-width:1600px){.fslightbox-nav{height:50px}.fslightboxsn{display:flex;margin:19px 0 0 16px;font-size:20px}.fslightboxsl{margin:0 7px 1px 7px;width:2px;height:16px;background:#d7d7d7}.fslightbox-toolbar-button{width:50px}.fslightbox-slide-btn{padding:12px}.fslightboxsvg{width:23px;height:23px}.fslightboxfsx{width:25px;height:25px}.fslightboxbt{width:19px;height:19px}.fslightbox-thumbs{padding:14px 0;height:126px}}")), document.head.appendChild(_$n));
                    var Q = "fslightbox-types";
                    function tt(t) {
                        var e, _$n = t.props, o1 = 0, i = {};
                        this.getSourceTypeFromLocalStorageByUrl = function(t) {
                            return e[t] ? e[t] : s(t);
                        }, this.handleReceivedSourceTypeForUrl = function(t, n) {
                            if (!1 === i[n] && (o1--, "invalid" !== t ? i[n] = t : delete i[n], 0 === o1)) {
                                !function(t, e) {
                                    for(var _$n in e)t[_$n] = e[_$n];
                                }(e, i);
                                try {
                                    localStorage.setItem(Q, JSON.stringify(e));
                                } catch (t) {}
                            }
                        };
                        var s = function s(t) {
                            o1++, i[t] = !1;
                        };
                        if (_$n.disableLocalStorage) this.getSourceTypeFromLocalStorageByUrl = function() {}, this.handleReceivedSourceTypeForUrl = function() {};
                        else {
                            try {
                                e = JSON.parse(localStorage.getItem(Q));
                            } catch (t) {}
                            e || (e = {}, this.getSourceTypeFromLocalStorageByUrl = s);
                        }
                    }
                    var et = "image", nt = "video", ot = "youtube", it = "custom", st = "invalid";
                    function rt(t, e, n, o1) {
                        var i = this, s = (t.data, t.elements.sources), r = n / o1, a = 0, c = null;
                        this.s = function() {
                            var _$t = s[e].style;
                            c = i.g(), _$t.width = "".concat(c[0], "px"), _$t.height = "".concat(c[1], "px");
                        }, this.g = function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : t.mh, i = t.mw;
                            return (a = i / r) < e ? (n < i && (a = o1), [
                                a * r,
                                a
                            ]) : [
                                (a = o1 > e ? e : o1) * r,
                                a
                            ];
                        }, this.d = function() {
                            return c;
                        }, this.dw = function() {
                            return n;
                        };
                    }
                    function at(t, e) {
                        var _$n = this, o1 = t.elements.sources, i = t.isl, s = t.la, r = t.props, a = r.initialAnimation, c = r.onSourceLoad, u = t.resolve, d = t.saw, h = t.sew, f = t.sz;
                        function p(t, n) {
                            f[e] = u(rt, [
                                e,
                                t,
                                n
                            ]), f[e].s();
                        }
                        this.a = function(r, u) {
                            i[e] = !0, o1[e].classList.add(l), d[e].classList.add(a), d[e].removeChild(d[e].firstChild), requestAnimationFrame(function() {
                                requestAnimationFrame(function() {
                                    h[e].classList.add("fslightboxtt");
                                });
                            }), p(r, u), s.s(e), s.t(e), c && c(t, o1[e], e), _$n.a = p;
                        };
                    }
                    function ct(t, e) {
                        var _$n, o1 = this, i = t.elements.sources, s = t.props, r = (0, t.resolve)(at, [
                            e
                        ]);
                        this.handleImageLoad = function(t) {
                            var _$e = t.target, _$n = _$e.naturalWidth, o1 = _$e.naturalHeight;
                            r.a(_$n, o1);
                        }, this.handleVideoLoad = function(t) {
                            var _$e = t.target, o1 = _$e.videoWidth, i = _$e.videoHeight;
                            _$n = !0, r.a(o1, i);
                        }, this.handleNotMetaDatedVideoLoad = function() {
                            _$n || o1.handleYoutubeLoad();
                        }, this.handleYoutubeLoad = function() {
                            var _$t = 1920, _$e = 1080;
                            s.maxYoutubeDimensions && (_$t = s.maxYoutubeDimensions.width, _$e = s.maxYoutubeDimensions.height), r.a(_$t, _$e);
                        }, this.handleCustomLoad = function() {
                            var _$t = i[e];
                            _$t.offsetWidth && _$t.offsetHeight ? r.a(_$t.offsetWidth, _$t.offsetHeight) : setTimeout(o1.handleCustomLoad);
                        };
                    }
                    function ut(t, e) {
                        var _$n = t.elements.sources, o1 = t.props.customAttributes, i = _$n[e];
                        for(var s in o1[e]){
                            var r = o1[e][s];
                            "class" !== s ? i.setAttribute(s, r) : i.className += " " + r;
                        }
                    }
                    function lt(t, e) {
                        var _$n = t.collections.sourceLoadHandlers, o1 = t.elements.sources, i = t.props.sources, s = t.saw, r = document.createElement("img");
                        o1[e] = r, r.className = "fslightboxs", r.src = i[e], r.onload = _$n[e].handleImageLoad, ut(t, e), s[e].appendChild(r);
                    }
                    function dt(t, e) {
                        var _$n = t.ap, o1 = t.collections.sourceLoadHandlers, i = t.elements.sources, s = t.props.sources, r = t.saw, a = document.createElement("video"), c = document.createElement("source");
                        i[e] = a, a.className = "fslightboxs fslightboxv", a.src = s[e], a.onloadedmetadata = function(t) {
                            o1[e].handleVideoLoad(t);
                        }, a.controls = !0, a.autoplay = _$n.i(e), ut(t, e), a.appendChild(c), setTimeout(o1[e].handleNotMetaDatedVideoLoad, 3e3), r[e].appendChild(a);
                    }
                    function ht(t, e) {
                        var _$n = t.ap, o1 = t.collections.sourceLoadHandlers, i = t.elements, s = i.sources, r = i.saw, a = t.props.sources, c = (r = t.saw, document.createElement("iframe")), u = a[e], l = u.split("?")[1];
                        s[e] = c, c.className = "fslightboxs fslightboxyt", c.src = "https://www.youtube.com/embed/".concat(u.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/)[2], "?").concat(l || "").concat(_$n.i(e) ? "&mute=1&autoplay=1" : "", "&enablejsapi=1"), c.allowFullscreen = 1, ut(t, e), r[e].appendChild(c), o1[e].handleYoutubeLoad();
                    }
                    function ft(t, e) {
                        var _$n = t.collections.sourceLoadHandlers, o1 = t.elements.sources, i = t.props.sources, s = t.saw, r = i[e];
                        o1[e] = r, r.classList.add("fslightboxs"), ut(t, e), s[e].appendChild(r), _$n[e].handleCustomLoad();
                    }
                    function pt(t, e) {
                        t.data.isSourceLoaded;
                        var _$n, o1, i = t.elements.sources, s = t.props, r = s.initialAnimation;
                        return s.sources, _$n = t.saw, o1 = document.createElement("div"), _$n = _$n[e], o1.className = "fslightboxin ".concat(a), o1.innerHTML = "Invalid source", _$n.removeChild(_$n.firstChild), i[e] = o1, _$n.classList.add(r), void _$n.appendChild(o1);
                    }
                    function mt(t, e, n) {
                        var o1, i = t.props, s = i.thumbsIcon, r = i.thumbsIcons;
                        if (r && r[n]) o1 = r[n];
                        else {
                            if (!s) return;
                            o1 = s;
                        }
                        e.appendChild(o1.cloneNode(!0));
                        var a = document.createElement("div");
                        a.className = "fslightboxtd", e.appendChild(a);
                    }
                    function bt(t, e, n) {
                        var o1 = t.elements, i = o1.thumbsWrappers, s = o1.thumbsInner;
                        i[e] = document.createElement("div"), i[e].className = C, mt(t, i[e], e), function(t, e, n, o1) {
                            var i = t.core.thumbLoadHandler.handleLoad, s = t.elements.thumbs, r = t.stageIndexes.current;
                            s[n] = document.createElement("img"), s[n].src = o1;
                            var a = g;
                            r === n && (a += " fslightboxta"), s[n].className = a, s[n].onload = i, e.appendChild(s[n]);
                        }(t, i[e], e, n), s.appendChild(i[e]);
                    }
                    function gt(t) {
                        var e = t.core.thumbsRenderDispatcher, _$n = t.data, o1 = t.props, i = o1.showThumbsOnMount, s = o1.sources, r = o1.thumbs;
                        this.buildThumbForTypeAndIndex = function(o1, c) {
                            var u;
                            u = r[c] ? function u() {
                                return bt(t, c, r[c]);
                            } : o1 === et ? function() {
                                return bt(t, c, s[c]);
                            } : function() {
                                return function(t, e) {
                                    var _$n = t.elements, _$o = _$n.thumbsWrappers, i = _$n.thumbsInner;
                                    _$o[e] = document.createElement("div"), _$o[e].className = "".concat(L, " ").concat(C), mt(t, _$o[e], e), function(t, e, n) {
                                        var _$o = t.core.thumbLoadHandler.handleLoad, i = t.elements.thumbs, s = t.stageIndexes.current;
                                        i[n] = document.createElement("div");
                                        var r = "".concat(g, " ").concat(a);
                                        s === n && (r += " fslightboxta"), i[n].className = r, V(i[n], "0 0 30 30", "M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M16.212,8l-0.2,9h-2.024l-0.2-9 H16.212z M15.003,22.189c-0.828,0-1.323-0.441-1.323-1.182c0-0.755,0.494-1.196,1.323-1.196c0.822,0,1.316,0.441,1.316,1.196 C16.319,21.748,15.825,22.189,15.003,22.189z", "fslightboxsvg"), e.appendChild(i[n]), setTimeout(_$o);
                                    }(t, _$o[e], e), i.appendChild(_$o[e]);
                                }(t, c);
                            }, e.addFunctionToToBeRenderedAtIndex(u, c), (i || _$n.isThumbing) && e.renderThumbsIfNotYetAndAllTypesDetected();
                        };
                    }
                    function vt(t) {
                        var e, _$n = t.collections, o1 = _$n.sourceLoadHandlers, i = _$n.sourcesRenderFunctions, s = t.core.sourceDisplayFacade, r = t.props.disableThumbs, a = t.resolve;
                        r || (e = a(gt)), this.runActionsForSourceTypeAndIndex = function(n, c) {
                            var u;
                            switch(n !== st && (o1[c] = a(ct, [
                                c
                            ])), n){
                                case et:
                                    u = lt;
                                    break;
                                case nt:
                                    u = dt;
                                    break;
                                case ot:
                                    u = ht;
                                    break;
                                case it:
                                    u = ft;
                                    break;
                                default:
                                    u = pt;
                            }
                            i[c] = function() {
                                return u(t, c);
                            }, s.displaySourcesWhichShouldBeDisplayed(), r || e.buildThumbForTypeAndIndex(n, c);
                        };
                    }
                    function xt(t, e, n) {
                        var o1 = t.props, i = o1.types, s = o1.type, r = o1.sources;
                        this.getTypeSetByClientForIndex = function(t) {
                            var e;
                            return i && i[t] ? e = i[t] : s && (e = s), e;
                        }, this.retrieveTypeWithXhrForIndex = function(t) {
                            !function(t, e) {
                                var _$n = document.createElement("a");
                                _$n.href = t;
                                var o1 = _$n.hostname;
                                if ("www.youtube.com" === o1 || "youtu.be" === o1) return e(ot);
                                var i = new XMLHttpRequest;
                                i.onreadystatechange = function() {
                                    if (4 !== i.readyState) {
                                        if (2 === i.readyState) {
                                            var _$t, _$n = i.getResponseHeader("content-type");
                                            switch(_$n.slice(0, _$n.indexOf("/"))){
                                                case "image":
                                                    _$t = et;
                                                    break;
                                                case "video":
                                                    _$t = nt;
                                                    break;
                                                default:
                                                    _$t = st;
                                            }
                                            i.onreadystatechange = null, i.abort(), e(_$t);
                                        }
                                    } else e(st);
                                }, i.open("GET", t), i.send();
                            }(r[t], function(o1) {
                                e.handleReceivedSourceTypeForUrl(o1, r[t]), n.runActionsForSourceTypeAndIndex(o1, t);
                            });
                        };
                    }
                    function yt(t, e, n) {
                        return yt = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (t) {
                                return !1;
                            }
                        }() ? Reflect.construct.bind() : function yt(t, e, n) {
                            var o1 = [
                                null
                            ];
                            o1.push.apply(o1, e);
                            var i = new (Function.bind.apply(t, o1));
                            return n && wt(i, n.prototype), i;
                        }, yt.apply(null, arguments);
                    }
                    function wt(t, e) {
                        return wt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function wt(t, e) {
                            return t.__proto__ = e, t;
                        }, wt(t, e);
                    }
                    function Ct(t, e) {
                        (null == e || e > t.length) && (e = t.length);
                        for(var _$n = 0, o1 = new Array(e); _$n < e; _$n++)o1[_$n] = t[_$n];
                        return o1;
                    }
                    var Lt = "fslightboxsvg";
                    function Tt() {
                        var _$t = this;
                        this.props = {
                            sources: [],
                            maxYoutubeDimensions: null,
                            customAttributes: [],
                            autoplays: [],
                            types: [],
                            type: null,
                            thumbs: [],
                            thumbsIcons: [],
                            captions: [],
                            customToolbarButtons: [],
                            exitFullscreenOnClose: 1,
                            initialAnimation: m,
                            slideChangeAnimation: f,
                            sourceMargin: .05,
                            slideDistance: .3,
                            slideshowTime: 8e3,
                            UIFadeOutTime: 8e3,
                            zoomIncrement: .25,
                            toolbarButtons: {
                                thumbs: {
                                    viewBox: "0 0 22 22",
                                    d: "M 3 2 C 2.448 2 2 2.448 2 3 L 2 6 C 2 6.552 2.448 7 3 7 L 6 7 C 6.552 7 7 6.552 7 6 L 7 3 C 7 2.448 6.552 2 6 2 L 3 2 z M 10 2 C 9.448 2 9 2.448 9 3 L 9 6 C 9 6.552 9.448 7 10 7 L 13 7 C 13.552 7 14 6.552 14 6 L 14 3 C 14 2.448 13.552 2 13 2 L 10 2 z M 17 2 C 16.448 2 16 2.448 16 3 L 16 6 C 16 6.552 16.448 7 17 7 L 20 7 C 20.552 7 21 6.552 21 6 L 21 3 C 21 2.448 20.552 2 20 2 L 17 2 z M 3 9 C 2.448 9 2 9.448 2 10 L 2 13 C 2 13.552 2.448 14 3 14 L 6 14 C 6.552 14 7 13.552 7 13 L 7 10 C 7 9.448 6.552 9 6 9 L 3 9 z M 10 9 C 9.448 9 9 9.448 9 10 L 9 13 C 9 13.552 9.448 14 10 14 L 13 14 C 13.552 14 14 13.552 14 13 L 14 10 C 14 9.448 13.552 9 13 9 L 10 9 z M 17 9 C 16.448 9 16 9.448 16 10 L 16 13 C 16 13.552 16.448 14 17 14 L 20 14 C 20.552 14 21 13.552 21 13 L 21 10 C 21 9.448 20.552 9 20 9 L 17 9 z M 3 16 C 2.448 16 2 16.448 2 17 L 2 20 C 2 20.552 2.448 21 3 21 L 6 21 C 6.552 21 7 20.552 7 20 L 7 17 C 7 16.448 6.552 16 6 16 L 3 16 z M 10 16 C 9.448 16 9 16.448 9 17 L 9 20 C 9 20.552 9.448 21 10 21 L 13 21 C 13.552 21 14 20.552 14 20 L 14 17 C 14 16.448 13.552 16 13 16 L 10 16 z M 17 16 C 16.448 16 16 16.448 16 17 L 16 20 C 16 20.552 16.448 21 17 21 L 20 21 C 20.552 21 21 20.552 21 20 L 21 17 C 21 16.448 20.552 16 20 16 L 17 16 z",
                                    class: "fslightboxbt",
                                    title: "Thumbnails"
                                },
                                zoomIn: {
                                    viewBox: "0 0 30 30",
                                    d: "M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z M 12.984375 7.9863281 A 1.0001 1.0001 0 0 0 12 9 L 12 12 L 9 12 A 1.0001 1.0001 0 1 0 9 14 L 12 14 L 12 17 A 1.0001 1.0001 0 1 0 14 17 L 14 14 L 17 14 A 1.0001 1.0001 0 1 0 17 12 L 14 12 L 14 9 A 1.0001 1.0001 0 0 0 12.984375 7.9863281 z",
                                    class: Lt,
                                    title: "Zoom In"
                                },
                                zoomOut: {
                                    viewBox: "0 0 30 30",
                                    d: "M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z M 9 12 A 1.0001 1.0001 0 1 0 9 14 L 17 14 A 1.0001 1.0001 0 1 0 17 12 L 9 12 z",
                                    class: Lt,
                                    title: "Zoom Out"
                                },
                                slideshow: {
                                    start: {
                                        viewBox: "0 0 30 30",
                                        d: "M 6 3 A 1 1 0 0 0 5 4 A 1 1 0 0 0 5 4.0039062 L 5 15 L 5 25.996094 A 1 1 0 0 0 5 26 A 1 1 0 0 0 6 27 A 1 1 0 0 0 6.5800781 26.8125 L 6.5820312 26.814453 L 26.416016 15.908203 A 1 1 0 0 0 27 15 A 1 1 0 0 0 26.388672 14.078125 L 6.5820312 3.1855469 L 6.5800781 3.1855469 A 1 1 0 0 0 6 3 z",
                                        class: "fslightboxbss",
                                        title: "Turn on slideshow"
                                    },
                                    pause: {
                                        viewBox: "0 0 356.19 356.19",
                                        d: "M121,0c18,0,33,15,33,33v372c0,18-15,33-33,33s-32-15-32-33V33C89,15,103,0,121,0zM317,0c18,0,32,15,32,33v372c0,18-14,33-32,33s-33-15-33-33V33C284,15,299,0,317,0z",
                                        class: "fslightboxbsp",
                                        title: "Turn off slideshow"
                                    }
                                },
                                fullscreen: {
                                    enter: {
                                        viewBox: "0 0 18 18",
                                        d: "M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z",
                                        class: Lt,
                                        title: "Enter fullscreen"
                                    },
                                    exit: {
                                        viewBox: "0 0 950 1024",
                                        d: "M682 342h128v84h-212v-212h84v128zM598 810v-212h212v84h-128v128h-84zM342 342v-128h84v212h-212v-84h128zM214 682v-84h212v212h-84v-128h-128z",
                                        class: "fslightboxfsx",
                                        title: "Exit fullscreen"
                                    }
                                },
                                close: {
                                    viewBox: "0 0 24 24",
                                    d: "M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z",
                                    class: Lt,
                                    title: "Close"
                                }
                            },
                            slideButtons: {
                                previous: {
                                    viewBox: "0 0 20 20",
                                    d: "M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788S18.707,9.212,18.271,9.212z",
                                    class: Lt,
                                    title: "Previous"
                                },
                                next: {
                                    viewBox: "0 0 20 20",
                                    d: "M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788S1.293,9.212,1.729,9.212z",
                                    class: Lt,
                                    title: "Next"
                                }
                            }
                        }, this.data = {
                            isThumbing: !1,
                            scrollbarWidth: 0
                        }, this.isl = [], this.ms = [], this.qs = [], this.ts = [], this.zv = 1, this.p = {
                            p: {},
                            ux: 0,
                            uy: 0
                        }, this.stageIndexes = {}, this.elements = {
                            a: [],
                            captions: [],
                            container: null,
                            nav: null,
                            slideButtonPrevious: null,
                            slideButtonNext: null,
                            sources: []
                        }, this.saw = [], this.sew = [], this.smw = [], this.componentsServices = {}, this.sn = function() {}, this.f = function(e) {
                            for(var _$n = 0; _$n < _$t.c; _$n++)e(_$n);
                        }, this.m = function(e, n) {
                            return function() {
                                for(var o1 = arguments.length, i = new Array(o1), s = 0; s < o1; s++)i[s] = arguments[s];
                                i.unshift(_$t), n.apply(void 0, i) && e.apply(void 0, i);
                            };
                        }, this.resolve = function(e) {
                            var _$n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                            return _$n.unshift(_$t), yt(e, function(t) {
                                return function(t) {
                                    if (Array.isArray(t)) return Ct(t);
                                }(t) || function(t) {
                                    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                                }(t) || function(t, e) {
                                    if (t) {
                                        if ("string" == typeof t) return Ct(t, e);
                                        var _$n = Object.prototype.toString.call(t).slice(8, -1);
                                        return "Object" === _$n && t.constructor && (_$n = t.constructor.name), "Map" === _$n || "Set" === _$n ? Array.from(t) : "Arguments" === _$n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n) ? Ct(t, e) : void 0;
                                    }
                                }(t) || function() {
                                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            }(_$n));
                        }, this.r = this.resolve, this.collections = {
                            sourceLoadHandlers: [],
                            sourcesRenderFunctions: []
                        }, this.sz = [], this.core = {
                            classFacade: {},
                            clickZoomer: {},
                            eventsDispatcher: {},
                            globalEventsController: {},
                            lightboxCloser: {},
                            lightboxUpdater: {},
                            pointeringBucket: {},
                            scrollbarRecompensor: {},
                            slideChangeFacade: {},
                            slideIndexChanger: {},
                            sourceDisplayFacade: {},
                            swipingActioner: {}
                        }, this.ap = {}, this.ea = {}, this.fs = {}, this.la = {}, this.ss = {}, this.st = {}, this.sws = {}, this.ui = {}, this.z = {}, this.t = function(e, n) {
                            var o1 = _$t.ts.push(setTimeout(function() {
                                delete _$t.ts[o1 - 1], e();
                            }, n));
                        }, this.q = function(e, n) {
                            var o1 = _$t.qs.push(0) - 1;
                            return function() {
                                _$t.qs[o1]++, _$t.t(function() {
                                    _$t.qs[o1]--, _$t.qs[o1] || e();
                                }, n);
                            };
                        }, function(t) {
                            var e = t.ap, _$n = (t.componentsServices, t.core), o1 = _$n.eventsDispatcher, s = (_$n.lightboxOpener, _$n.globalEventsController), a = _$n.scrollbarRecompensor, d = _$n.sourceDisplayFacade, h = t.data, f = t.ea, b = t.elements, g = t.la, C = t.smw, L = t.st, _$T = t.stageIndexes, N = t.sws, M = t.ui, B = !1;
                            function W() {
                                var e, _$n = t.props, s = _$n.autoplay, a = _$n.autoplays, c = _$n.disableThumbs, d = _$n.showThumbsOnMount, f = _$n.sources;
                                B = !0, function(t) {
                                    var e = t.props, _$n = e.autoplays;
                                    t.c = e.sources.length;
                                    for(var o1 = 0; o1 < t.c; o1++)"false" === _$n[o1] && (_$n[o1] = 0), "" === _$n[o1] && (_$n[o1] = 1);
                                    t.dss = e.disableSlideSwiping, t.dt = e.disableThumbs, t.loc = e.loadOnlyCurrentSource, t.tc = e.showThumbsWithCaptions, t.ud = e.useDialog && "function" == typeof HTMLDialogElement;
                                }(t), h.scrollbarWidth = function() {
                                    var _$t = document.createElement("div"), e = _$t.style, _$n = document.createElement("div");
                                    e.visibility = "hidden", e.width = "100px", e.msOverflowStyle = "scrollbar", e.overflow = "scroll", _$n.style.width = "100%", document.body.appendChild(_$t);
                                    var o1 = _$t.offsetWidth;
                                    _$t.appendChild(_$n);
                                    var i = _$n.offsetWidth;
                                    return document.body.removeChild(_$t), o1 - i;
                                }(), (s || a.length > 0) && (t.loc = 1), h.unloadedThumbsCount = f.length, c || (h.isThumbing = d, function(t) {
                                    var e = t.core, _$n = t.data, o1 = t.elements, i = t.props;
                                    _$n.isThumbing = i.showThumbsOnMount, _$n.thumbsInnerWidth = null, _$n.thumbsTransform = 0, _$n.thumbedSourceEnhancementWrapperScale = null, _$n.thumbedSourceEnhancementWrapperTranslateY = null, _$n.unloadedThumbsCount = i.sources.length, t.thumbsSwipingProps = {
                                        i: !1,
                                        downScreenX: null,
                                        swipedX: null
                                    }, e.thumbLoadHandler = {}, e.thumbsRenderDispatcher = {}, e.thumbsSwipingDown = {}, e.thumbsToggler = {}, e.thumbsTransformer = {}, e.thumbsTransformTransitioner = {}, o1.thumbsContainer = null, o1.thumbs = [], o1.thumbsWrappers = [], o1.thumbsComponents = [], o1.thumbsInner = null, function(t) {
                                        var e = t.core.thumbLoadHandler, _$n = t.componentsServices, o1 = t.data, i = t.elements.thumbsWrappers, s = t.la;
                                        e.handleLoad = function() {
                                            if (o1.unloadedThumbsCount--, 0 === o1.unloadedThumbsCount) {
                                                for(var _$t = 0; _$t < i.length; _$t++)i[_$t].classList.add(l);
                                                s.rt(), _$n.hideThumbsLoader();
                                            }
                                        };
                                    }(t), function(t) {
                                        var e = t.core.thumbsRenderDispatcher, _$n = t.props.sources, o1 = [], i = !1, s = 0;
                                        e.addFunctionToToBeRenderedAtIndex = function(t, e) {
                                            o1[e] = t, s++;
                                        }, e.renderThumbsIfNotYetAndAllTypesDetected = function() {
                                            if (!i && s === _$n.length) {
                                                i = !0;
                                                for(var _$t = 0; _$t < _$n.length; _$t++)o1[_$t]();
                                            }
                                        };
                                    }(t), function(t) {
                                        var e = t.core, _$n = e.thumbsSwipingDown, o1 = e.pointeringBucket, i = t.thumbsSwipingProps;
                                        _$n.listener = function(t) {
                                            t.preventDefault(), o1.runSwipingDownActionsForPropsAndEvent(i, t);
                                        };
                                    }(t), function(t) {
                                        var e = t.core.thumbsToggler, _$n = t.data, o1 = (0, t.resolve)(z);
                                        e.toggleThumbs = function() {
                                            _$n.isThumbing ? o1.x() : o1.o();
                                        };
                                    }(t), function(t) {
                                        var e = t.core, _$n = e.thumbsTransformer, o1 = e.thumbsTransformTransitioner, i = t.data, s = (0, t.resolve)(A);
                                        _$n.transformToCurrent = function() {
                                            i.thumbsInnerWidth > innerWidth ? s.runActions() : s.runToThinThumbsActions();
                                        }, _$n.transformToCurrentWithTransition = function() {
                                            i.thumbsInnerWidth > innerWidth && o1.callActionWithTransition(s.runActions);
                                        };
                                    }(t), function(t) {
                                        var e = t.core.thumbsTransformTransitioner, _$n = t.elements, o1 = (0, t.q)(function() {
                                            _$n.thumbsInner.classList.remove("fslightboxtt");
                                        }, 300);
                                        e.callActionWithTransition = function(t) {
                                            _$n.thumbsInner.classList.add("fslightboxtt"), t(), o1();
                                        };
                                    }(t);
                                }(t)), function(t) {
                                    !function(t) {
                                        var e = t.ap, _$n = t.elements.sources, o1 = t.props, i = o1.autoplay, s = o1.autoplays;
                                        function r(t, o1) {
                                            if ("play" != o1 || e.i(t)) {
                                                var i = _$n[t];
                                                if (i) {
                                                    var s = i.tagName;
                                                    if ("VIDEO" == s) i[o1]();
                                                    else if ("IFRAME" == s) {
                                                        var r = i.contentWindow;
                                                        r && r.postMessage('{"event":"command","func":"'.concat(o1, 'Video","args":""}'), "*");
                                                    }
                                                }
                                            }
                                        }
                                        e.i = function(t) {
                                            return s[t] || i && 0 != s[t];
                                        }, e.p = function(t) {
                                            r(t, "play");
                                        }, e.c = function(t, e) {
                                            r(t, "pause"), r(e, "play");
                                        };
                                    }(t), function(t) {
                                        var e = t.core, _$n = e.classFacade, o1 = e.st, i = t.elements;
                                        _$n.removeFromEachElementClassIfContains = function(t, e) {
                                            for(var _$n = 0; _$n < i[t].length; _$n++)S(i[t][_$n], e);
                                        }, _$n.stagedRemovalAndOutstagedAddingOfClassIfContains = function(t, e) {
                                            for(var _$n = 0; _$n < i[t].length; _$n++)o1.i(_$n) ? S(i[t][_$n], e) : I(i[t][_$n], e);
                                        };
                                    }(t), function(t) {
                                        var e = t.core.clickZoomer, _$n = (t.elements, t.props.zoomIncrement), o1 = t.q, i = t.z, s = o1(function() {
                                            S(t.swc, "fslightboxtt");
                                        }, 300);
                                        e.zoomIn = function() {
                                            1 === t.zv && i.b(), r(t.zv + _$n);
                                        }, e.zoomOut = function() {
                                            t.zv - _$n <= 1 ? 1 !== t.zv && (r(1), i.e()) : (r(t.zv - _$n), 1 === t.zv && i.e());
                                        };
                                        var r = function r(e) {
                                            I(t.swc, "fslightboxtt"), i.zm(e), s();
                                        };
                                    }(t), function(t) {
                                        var e = t.ea, _$n = t.data, o1 = t.elements, i = o1.captions, s = o1.thumbs, r = (t.stageIndexes, t.tc), a = t.ui;
                                        function c(t) {
                                            if (r) for(var e = 0; e < i.length; e++){
                                                var _$n = i[e];
                                                _$n && _$n.classList[t]("fslightboxct");
                                            }
                                        }
                                        e.c = function(e, o1) {
                                            (r || !_$n.isThumbing || t.xu) && (a.hc(e), a.sc(o1));
                                        }, e.dc = function() {
                                            c("remove");
                                        }, e.uc = function() {
                                            c("add");
                                        }, e.t = function(t, e) {
                                            s && s[e] && (s[t].classList.remove("fslightboxta"), s[e].classList.add("fslightboxta"));
                                        };
                                    }(t), function(t) {
                                        var e = t.core.eventsDispatcher, _$n = t.props;
                                        e.dispatch = function(e) {
                                            _$n[e] && _$n[e](t);
                                        };
                                    }(t), function(t) {
                                        t.data;
                                        var e = t.fs, _$n = [
                                            "fullscreenchange",
                                            "webkitfullscreenchange",
                                            "mozfullscreenchange",
                                            "MSFullscreenChange"
                                        ], o1 = document.documentElement, i = o1.requestFullscreen;
                                        function s(t) {
                                            for(var e = 0; e < _$n.length; e++)document[t](_$n[e], r);
                                        }
                                        function r() {
                                            document.fullscreenElement || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement ? t.fso() : t.fsx();
                                        }
                                        e.i = function() {
                                            if (i || (i = o1.mozRequestFullScreen), i || (i = o1.webkitRequestFullscreen), i || (i = o1.msRequestFullscreen), !i) return t.hfs = 1, e.o = function() {}, e.x = function() {}, e.t = function() {}, e.l = function() {}, void (e.q = function() {});
                                            e.o = function() {
                                                t.fso();
                                                var e = document.documentElement;
                                                e.requestFullscreen ? e.requestFullscreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : e.webkitRequestFullscreen ? e.webkitRequestFullscreen() : e.msRequestFullscreen && e.msRequestFullscreen();
                                            }, e.x = function() {
                                                t.fsx(), document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen && document.msExitFullscreen();
                                            }, e.t = function() {
                                                t.ifs ? e.x() : e.o();
                                            }, e.l = function() {
                                                s("addEventListener");
                                            }, e.q = function() {
                                                s("removeEventListener");
                                            };
                                        };
                                    }(t), function(t) {
                                        var e, _$n = t.core.globalEventsController, o1 = t.fs, i = t.la, s = t.r, r = (t.ui, s(Y));
                                        _$n.addListeners = function() {
                                            document.addEventListener("pointermove", r.m), document.addEventListener("pointerup", r.u), addEventListener("resize", i.r), e = function e(_e) {
                                                j(t, _e);
                                            }, document.addEventListener("keydown", e), document.addEventListener("wheel", r.w), o1.l();
                                        }, _$n.removeListeners = function() {
                                            document.removeEventListener("pointermove", r.m), document.removeEventListener("pointerup", r.u), removeEventListener("resize", i.r), document.removeEventListener("keydown", e), document.removeEventListener("wheel", r.w), o1.q();
                                        };
                                    }(t), function(t) {
                                        t.c;
                                        var e = t.data, _$n = t.ea, o1 = t.elements, i = t.f, s = t.la, r = t.props.UIFadeOutTime, a = t.q, c = t.stageIndexes, u = t.tc, l = t.ui, d = o1.captions, h = a(function() {
                                            t.xu = !0, f(w), 1 === t.zv && e.isThumbing && (s.ut(), u ? _$n.dc() : l.sc(c.current));
                                        }, r);
                                        function f(t) {
                                            p(t), m(t), e.isThumbing && y(t);
                                        }
                                        function p(t) {
                                            t(o1.nav);
                                        }
                                        function m(t) {
                                            o1.slideButtonPrevious && (t(o1.slideButtonPrevious), t(o1.slideButtonNext));
                                        }
                                        function b(t, e) {
                                            x(t, e);
                                        }
                                        function g(t) {
                                            m(t), e.isThumbing ? (y(t), u && v(t)) : v(t);
                                        }
                                        function v(t) {
                                            x(t, c.current);
                                        }
                                        function x(t, e) {
                                            var _$n = d[e];
                                            _$n && t(_$n);
                                        }
                                        function y(t) {
                                            t(o1.thumbsContainer);
                                        }
                                        function w(t) {
                                            t.classList.add("fslightboxx");
                                        }
                                        function C(t) {
                                            t.classList.remove("fslightboxx");
                                        }
                                        r ? (l.qps = function() {
                                            h(), t.xu && (t.xu = !1, 1 === t.zv ? f(C) : p(C)), 1 === t.zv && e.isThumbing && (i(function(t) {
                                                s.t(t);
                                            }), u ? _$n.uc() : l.hc(c.current));
                                        }, l.q = function() {
                                            h();
                                        }) : (l.qps = function() {}, l.q = function() {}), l.sc = function(t) {
                                            b(C, t);
                                        }, l.hc = function(t) {
                                            b(w, t);
                                        }, l.zh = function() {
                                            g(w);
                                        }, l.zs = function() {
                                            g(C);
                                        }, l.sthc = function() {
                                            y(C), u || v(w);
                                        }, l.htsc = function() {
                                            y(w), u || v(C);
                                        };
                                    }(t), function(t) {
                                        var e = t.core.lightboxCloser, _$n = (0, t.resolve)(E);
                                        e.close = function() {
                                            _$n.isLightboxFadingOut || _$n.runActions();
                                        };
                                    }(t), function(t) {
                                        var e = t.core.pointeringBucket;
                                        t.elements, e.runSwipingDownActionsForPropsAndEvent = function(t, e) {
                                            t.i = !0, t.downScreenX = e.screenX, t.swipedX = 0;
                                        }, e.runSwipingMoveActionsForPropsAndEvent = function(e, n) {
                                            I(t.h, "fslightboxcg"), e.swipedX = n.screenX - e.downScreenX;
                                        }, e.runSwipingTopActionsForPropsAndEvent = function(e) {
                                            S(t.h, "fslightboxcg"), e.i = !1;
                                        };
                                    }(t), function(t) {
                                        var e = t.data, _$n = t.core.scrollbarRecompensor;
                                        _$n.addRecompense = function() {
                                            "complete" === document.readyState ? o1() : window.addEventListener("load", function() {
                                                o1(), _$n.addRecompense = o1;
                                            });
                                        };
                                        var o1 = function o1() {
                                            document.body.offsetHeight > window.innerHeight && (document.body.style.marginRight = e.scrollbarWidth + "px");
                                        };
                                        _$n.removeRecompense = function() {
                                            document.body.style.removeProperty("margin-right");
                                        };
                                    }(t), function(t) {
                                        var e = t.c, _$n = t.core.thumbsTransformer, o1 = t.data, i = t.dt, s = t.elements, r = t.f, a = t.isl, c = t.la, u = t.ms, l = t.props, d = l.maxScale, h = l.sourceMargin, f = t.sew, p = t.smw, m = t.sz, b = t.stageIndexes, g = t.tc, v = s.captions, x = s.thumbs, y = 1 - 2 * h, w = 1 - h, C = [], L = [], _$T = [], z = [], S = [], I = 0;
                                        function A() {
                                            var _$t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, _$n = arguments.length > 2 ? arguments[2] : void 0;
                                            u[_$n] = d ? m[_$n].dw() / (e * m[_$n].g()[0]) : 1e3, f[_$n].style.transform = "translateY(".concat(_$t, "px) scale(").concat(e, ")");
                                        }
                                        c.r = function() {
                                            innerWidth > 992 ? t.mw = y * innerWidth : t.mw = innerWidth, t.mh = y * innerHeight, 0 === o1.unloadedThumbsCount && c.rt(), void 0 !== b.previous && p[b.previous].ne(), void 0 !== b.next && p[b.next].p(), r(function(t) {
                                                var e = m[t], _$n = v[t];
                                                e && e.s(), _$n && (C[t] = _$n.offsetHeight), i || (I = s.thumbsContainer.offsetHeight), c.s(t), p[t].d(), c.t(t);
                                            });
                                        }, c.s = function(t) {
                                            var e = m[t];
                                            if (e) {
                                                var _$n = e.d(), o1 = _$n[0] + _$n[1];
                                                if (C[t]) {
                                                    var s = e.g(innerHeight * w - C[t]);
                                                    L[t] = (s[0] + s[1]) / o1, S[t] = -(C[t] - innerHeight / 2 + s[1] / 2), S[t] > 0 && (S[t] = 0);
                                                }
                                                if (!i) {
                                                    if (g && C[t]) {
                                                        var r = I + C[t];
                                                        a = e.g((innerHeight - r) * (1 - 1.4 * h) + 34), _$T[t] = (a[0] + a[1]) / o1, z[t] = -(r - 34 - innerHeight / 2 + a[1] / 2);
                                                    } else {
                                                        var a = e.g(innerHeight * w - I);
                                                        _$T[t] = (a[0] + a[1]) / o1, z[t] = -(I - innerHeight / 2 + a[1] / 2);
                                                    }
                                                    z[t] > 0 && (z[t] = 0);
                                                }
                                            }
                                        }, c.t = function(e) {
                                            a[e] && (1 !== t.zv ? A(0, 1, e) : o1.isThumbing ? A(z[e], _$T[e], e) : A(S[e], L[e], e));
                                        }, c.ut = function() {
                                            r(function(t) {
                                                a[t] && A(S[t], L[t], t);
                                            });
                                        }, c.rt = function() {
                                            o1.thumbsInnerWidth = 0;
                                            for(var _$t = 0; _$t < e; _$t++)o1.thumbsInnerWidth += x[_$t].offsetWidth + 8;
                                            _$n.transformToCurrent();
                                        };
                                    }(t), k(t), function(t) {
                                        var e = t.core, _$n = e.slideChangeFacade, o1 = e.slideIndexChanger, i = t.props.sources, s = t.st;
                                        i.length > 1 ? (_$n.changeToPrevious = function() {
                                            o1.jumpTo(s.getPreviousSlideIndex());
                                        }, _$n.changeToNext = function() {
                                            o1.jumpTo(s.getNextSlideIndex());
                                        }) : (_$n.changeToPrevious = function() {}, _$n.changeToNext = function() {});
                                    }(t), function(t) {
                                        var e = t.ap, _$n = (t.componentsServices, t.core), o1 = _$n.eventsDispatcher, i = _$n.slideIndexChanger, s = _$n.sourceDisplayFacade, r = _$n.thumbsTransformer, a = t.ea, c = t.isl, u = t.props.disableThumbs, l = t.resolve, d = t.smw, h = t.st, f = t.stageIndexes, p = t.sws, m = t.z;
                                        i.changeTo = function(n) {
                                            var i = f.current;
                                            m.r(), e.c(i, n), a.c(i, n), f.current = n, h.u(), t.sn(n + 1), u || (a.t(i, n), r.transformToCurrentWithTransition()), s.displaySourcesWhichShouldBeDisplayed(), o1.dispatch("onSlideChange");
                                        }, i.jumpTo = function(t) {
                                            var e = f.current;
                                            if (e !== t) {
                                                var _$n = l(F, [
                                                    {
                                                        previous: f.previous,
                                                        current: e,
                                                        next: f.next
                                                    },
                                                    c[e],
                                                    c[t]
                                                ]);
                                                i.changeTo(t);
                                                for(var o1 = 0; o1 < d.length; o1++)d[o1].d();
                                                p.d(e), p.c(), requestAnimationFrame(function() {
                                                    requestAnimationFrame(_$n.runJumpReflowedActions);
                                                });
                                            }
                                        };
                                    }(t), function(t) {
                                        var e = t.collections.sourcesRenderFunctions, _$n = t.core.sourceDisplayFacade, o1 = t.loc, i = t.stageIndexes;
                                        function s(t) {
                                            e[t] && (e[t](), delete e[t]);
                                        }
                                        _$n.displaySourcesWhichShouldBeDisplayed = function() {
                                            if (o1) s(i.current);
                                            else for(var _$t in i)s(i[_$t]);
                                        };
                                    }(t), function(t) {
                                        var e = t.isl, _$n = t.props, o1 = _$n.initialAnimation, i = _$n.slideChangeAnimation, s = t.stageIndexes, r = t.saw, a = t.smw, c = t.st, u = t.sws;
                                        u.a = function() {
                                            for(var _$t in s)a[s[_$t]].s();
                                        }, u.b = function(t) {
                                            void 0 === t || c.i(t) || (a[t].h(), a[t].n());
                                        }, u.c = function() {
                                            for(var _$t in s)u.d(s[_$t]);
                                        }, u.d = function(t) {
                                            if (e[t]) {
                                                var _$n = r[t];
                                                S(_$n, o1), S(_$n, i), S(_$n, p);
                                            }
                                        };
                                    }(t), function(t) {
                                        var e = t.elements, _$n = e.sources, o1 = e.smw, i = t.la, s = t.ms, r = t.p, a = (o1 = t.smw, t.stageIndexes), c = t.ui, u = t.z;
                                        function l(t) {
                                            var e = _$n[a.current];
                                            e && (e.style.cursor = t);
                                        }
                                        u.z = function(e) {
                                            t.zv = parseFloat(e.toPrecision(12)), t.swc.style.transform = "scale(".concat(t.zv, ")");
                                        }, u.zm = function(t) {
                                            var e = s[a.current];
                                            t > e && (t = e), u.z(t);
                                        }, u.r = function() {
                                            1 !== t.zv && (u.z(1), u.e());
                                        }, u.b = function() {
                                            1 != s[a.current] && (l("grab"), c.zh(), i.t());
                                        }, u.e = function() {
                                            l("zoom-in"), c.zs(), o1[a.current].a(), o1[a.current].v(0, 0).z(), r.ux = 0, r.uy = 0;
                                        };
                                    }(t);
                                }(t), t.fs.i(), function(t) {
                                    var e = t.elements, _$n = t.ud, o1 = document.createElement(_$n ? "dialog" : "div");
                                    o1.className = "".concat(i, "container ").concat(r, " ").concat(m), o1.setAttribute("tabindex", "0"), e.container = o1;
                                }(t), function(t) {
                                    t.h = document.createElement("div"), t.h.className = "fslightboxh ".concat(r, " ").concat(u);
                                }(t), function(t) {
                                    var e = t.props.sources, _$n = t.elements, o1 = document.createElement("div");
                                    _$n.nav = o1, o1.className = "".concat(i, "nav"), _$n.container.appendChild(o1), function(t, e) {
                                        var _$n = t.core, o1 = _$n.clickZoomer, s = o1.zoomIn, r = o1.zoomOut, a = _$n.lightboxCloser.close, c = _$n.thumbsToggler, u = t.props, l = u.customToolbarButtons, d = u.disableThumbs, h = u.toolbarButtons, f = document.createElement("div");
                                        f.className = "".concat(i, "toolbar"), e.appendChild(f);
                                        for(var p = function p(e) {
                                            _(f, l[e], function() {
                                                return l[e].onClick(t);
                                            });
                                        }, m = 0; m < l.length; m++)p(m);
                                        d || _(f, h.thumbs, c.toggleThumbs), _(f, h.zoomIn, s), _(f, h.zoomOut, r), function(t, e) {
                                            var _$n = t.props.toolbarButtons.slideshow, o1 = _$n.start, i = _$n.pause, s = t.ss, r = U(e, o1.title);
                                            r.onclick = s.t;
                                            var a = V(r, o1.viewBox, o1.d, o1.class);
                                            function c(t) {
                                                r.title = t.title, a.setAttributeNS(null, "viewBox", t.viewBox), a.setAttributeNS(null, "class", t.class), a.firstChild.setAttributeNS(null, "d", t.d);
                                            }
                                            t.sss = function() {
                                                c(i);
                                            }, t.ssx = function() {
                                                c(o1);
                                            };
                                        }(t, f), function(t, e) {
                                            if (!t.hfs) {
                                                var _$n = t.fs, o1 = t.props.toolbarButtons.fullscreen, i = o1.enter, s = o1.exit, r = U(e, i.title), a = V(r, i.viewBox, i.d, i.class);
                                                t.fso = function() {
                                                    t.ifs = 1, c(s);
                                                }, t.fsx = function() {
                                                    t.ifs = 0, c(i);
                                                }, r.onclick = _$n.t;
                                            }
                                            function c(t) {
                                                r.title = t.title, a.setAttributeNS(null, "viewBox", t.viewBox), a.setAttributeNS(null, "class", t.class), a.firstChild.setAttributeNS(null, "d", t.d);
                                            }
                                        }(t, f), _(f, h.close, a);
                                    }(t, o1), e.length > 1 && function(t, e) {
                                        var _$n = t.props.sources, o1 = (t.stageIndexes, document.createElement("div")), i = document.createElement("span"), s = document.createElement("span"), r = document.createElement("span");
                                        o1.className = "fslightboxsn", t.sn = function(t) {
                                            return i.innerHTML = t;
                                        }, s.className = "fslightboxsl", r.innerHTML = _$n.length, o1.appendChild(i), o1.appendChild(s), o1.appendChild(r), e.appendChild(o1);
                                    }(t, o1);
                                }(t), function(t) {
                                    t.ssb = document.createElement("div"), t.ssb.className = "fslightboxss ".concat(u), t.elements.container.appendChild(t.ssb);
                                }(t), function(t) {
                                    var e = t.c, _$n = t.elements, o1 = t.m, i = document.createElement("div");
                                    i.className = "fslightboxswc ".concat(u, " ").concat(r), _$n.container.appendChild(i), i.addEventListener("pointerdown", o1(Z, O)), t.swc = i;
                                    for(var s = 0; s < e; s++)G(t, s);
                                }(t), function(t) {
                                    for(var e = t.props.captions, _$n = 0; _$n < e.length; _$n++)e[_$n] && $(t, _$n);
                                }(t), f.length > 1 && (K(e = t, "previous"), K(e, "next")), c || function(t) {
                                    var e = t.componentsServices, _$n = t.elements, o1 = t.data;
                                    _$n.thumbsContainer = document.createElement("div");
                                    var i, s, a = v;
                                    function c() {
                                        s = !0, (i = J(_$n.thumbsContainer)).classList.add(x);
                                    }
                                    o1.isThumbing ? c() : a += " fslightboxx", e.appendThumbsLoaderIfNotYet = function() {
                                        s || c();
                                    }, e.hideThumbsLoader = function() {
                                        _$n.thumbsContainer.removeChild(i);
                                    }, _$n.thumbsContainer.className = a, _$n.container.appendChild(_$n.thumbsContainer), function(t) {
                                        var e = t.elements;
                                        e.thumbsCursorer = document.createElement("div"), e.thumbsCursorer.className = "".concat(y, " ").concat(r, " ").concat(u);
                                    }(t), function(t) {
                                        var e = t.core.thumbsSwipingDown.listener, _$n = t.elements;
                                        _$n.thumbsInner = document.createElement("div"), _$n.thumbsInner.className = w, _$n.thumbsInner.addEventListener("pointerdown", e), _$n.thumbsContainer.appendChild(_$n.thumbsInner);
                                    }(t);
                                }(t), function(t) {
                                    for(var e = t.props.sources, _$n = t.resolve, o1 = _$n(tt), i = _$n(vt), s = _$n(xt, [
                                        o1,
                                        i
                                    ]), r = 0; r < e.length; r++)if ("string" == typeof e[r]) {
                                        var a = s.getTypeSetByClientForIndex(r);
                                        if (a) i.runActionsForSourceTypeAndIndex(a, r);
                                        else {
                                            var c = o1.getSourceTypeFromLocalStorageByUrl(e[r]);
                                            c ? i.runActionsForSourceTypeAndIndex(c, r) : s.retrieveTypeWithXhrForIndex(r);
                                        }
                                    } else i.runActionsForSourceTypeAndIndex(it, r);
                                }(t), o1.dispatch("onInit");
                            }
                            t.open = function() {
                                var _$n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, i = _$T.previous, r = _$T.current, u = _$T.next;
                                _$T.current = _$n, B || function(t) {
                                    var e = t.props.sources, _$n = t.st, o1 = t.stageIndexes, i = e.length - 1;
                                    _$n.getPreviousSlideIndex = function() {
                                        return 0 === o1.current ? i : o1.current - 1;
                                    }, _$n.getNextSlideIndex = function() {
                                        return o1.current === i ? 0 : o1.current + 1;
                                    }, _$n.u = 0 === i ? function() {} : 1 === i ? function() {
                                        0 === o1.current ? (o1.next = 1, delete o1.previous) : (o1.previous = 0, delete o1.next);
                                    } : function() {
                                        o1.previous = _$n.getPreviousSlideIndex(), o1.next = _$n.getNextSlideIndex();
                                    }, _$n.i = i <= 2 ? function() {
                                        return !0;
                                    } : function(t) {
                                        var e = o1.current;
                                        if (0 === e && t === i || e === i && 0 === t) return !0;
                                        var _$n = e - t;
                                        return -1 === _$n || 0 === _$n || 1 === _$n;
                                    };
                                }(t), L.u(), B ? (N.c(), N.a(), N.b(i), N.b(r), N.b(u), f.c(r, _$n), f.t(r, _$n), o1.dispatch("onShow")) : W(), d.displaySourcesWhichShouldBeDisplayed(), t.sn(_$n + 1);
                                var l = b.container;
                                document.body.appendChild(l), t.ud && l.showModal(), l.focus(), document.documentElement.classList.add(c), a.addRecompense(), s.addListeners(), g.r(), C[_$n].n(), e.p(_$n), M.q(), o1.dispatch("onOpen");
                            };
                        }(this), this.close = function() {
                            return _$t.core.lightboxCloser.close();
                        };
                    }
                    return e;
                }();
            }, t.exports = e();
        }
    }, e = {};
    function n(o1) {
        var i = e[o1];
        if (void 0 !== i) return i.exports;
        var s = e[o1] = {
            exports: {}
        };
        return t[o1](s, s.exports, n), s.exports;
    }
    n.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default;
        } : function() {
            return t;
        };
        return n.d(e, {
            a: e
        }), e;
    }, n.d = function(t, e) {
        for(var o1 in e)n.o(e, o1) && !n.o(t, o1) && Object.defineProperty(t, o1, {
            enumerable: !0,
            get: e[o1]
        });
    }, n.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    }, n.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        });
    };
    var i = {};
    (function() {
        "use strict";
        n.r(i), n.d(i, {
            default: function() {
                return u;
            }
        });
        var t = (parcelRequire("iD6kw"));
        var e = n.n(t);
        function o1(t) {
            return o1 = "function" == typeof Symbol && "symbol" == (0, $5djcY._)(Symbol.iterator) ? function o1(t) {
                return typeof t === "undefined" ? "undefined" : (0, $5djcY._)(t);
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, $5djcY._)(t);
            }, o1(t);
        }
        var s, r = 0;
        function a(t, e) {
            if ("object" === o1(e)) for(var _$n in t)"object" === o1(e[_$n]) ? a(t[_$n], e[_$n]) : e[_$n] && (t[_$n] = e[_$n]);
        }
        function c(t) {
            var e = t.current;
            return e.childElementCount > 1 ? e : e.firstChild;
        }
        function u(o1) {
            var i, u = (0, t.useRef)(), l = (0, t.useRef)(), d = [], h = [], f = (0, t.useRef)(), p = [], m = (0, t.useRef)(o1.toggler);
            for(i = 0; i < o1.sources.length; i++)"string" != typeof o1.sources[i] && (d[i] = (0, t.useRef)()), o1.thumbsIcons && o1.thumbsIcons[i] && (p[i] = (0, t.useRef)()), o1.captions && o1.captions[i] && (h[i] = (0, t.useRef)());
            function b() {
                var t = o1.sourceIndex;
                void 0 === t && (t = o1.slide - 1), u.current.open(t || 0);
            }
            return e().useInsertionEffect && e().useInsertionEffect(function() {
                r || (s = n(194), r = 1);
            }, []), (0, t.useEffect)(function(t) {
                if (r || (s = n(194), r = 1), !u.current) {
                    var e = new s.default;
                    return Object.assign(e.props, o1), e.props.sources = o1.sources.map(function(t, e) {
                        return "string" == typeof t ? t : (l.current.removeChild(d[e].current), c(d[e]));
                    }), o1.captions && (e.props.captions = o1.captions.map(function(t, e) {
                        if (t) return l.current.removeChild(h[e].current), c(h[e]);
                    })), o1.thumbsIcons && (e.props.thumbsIcons = o1.thumbsIcons.map(function(t, e) {
                        if (t) return l.current.removeChild(p[e].current), c(p[e]);
                    })), o1.thumbsIcon && (e.props.thumbsIcon = c(f), l.current.removeChild(f.current)), e.props.maxYoutubeDimensions = o1.maxYoutubeVideoDimensions, o1.svg && (a(e.props.toolbarButtons, o1.svg.toolbarButtons), a(e.props.slideButtons, o1.svg.slideButtons)), u.current = e, void (o1.openOnMount && b());
                }
                o1.toggler != m.current && (m.current = o1.toggler, b());
            }, [
                o1.toggler
            ]), !u.current && e().createElement("div", {
                ref: l,
                style: {
                    display: "none"
                }
            }, o1.sources.map(function(t, n) {
                return "string" != typeof t && e().createElement("div", {
                    ref: d[n],
                    key: n
                }, t);
            }), o1.captions && o1.captions.map(function(t, n) {
                return t && e().createElement("div", {
                    ref: h[n],
                    key: n
                }, t);
            }), o1.thumbsIcons && o1.thumbsIcons.map(function(t, n) {
                return t && e().createElement("div", {
                    ref: p[n],
                    key: n
                }, t);
            }), o1.thumbsIcon && e().createElement("div", {
                ref: f
            }, o1.thumbsIcon));
        }
        "object" === ("undefined" == typeof window ? "undefined" : o1(window)) && (s = n(194), r = 1);
    })(), $6f2a73f4fdc93d35$exports = i;
})();



var $iD6kw = parcelRequire("iD6kw");

var $kqzqZ = parcelRequire("kqzqZ");

var $dxEC4 = parcelRequire("dxEC4");

var $6ZpBv = parcelRequire("6ZpBv");

var $gh3Df = parcelRequire("gh3Df");
parcelRequire("7w4mz");
var $iit9R = parcelRequire("iit9R");

var $iD6kw = parcelRequire("iD6kw");
var $eca3b2ac27e7650f$export$c1cf1cf4c5d51937 = function(url) {
    var _useState = (0, $6ZpBv._)((0, $iD6kw.useState)(/** @type {import('../types/feature').FeatureData | null} */ null), 2), data = _useState[0], setData = _useState[1];
    var _useState1 = (0, $6ZpBv._)((0, $iD6kw.useState)(true), 2), loading = _useState1[0], setLoading = _useState1[1];
    var _useState2 = (0, $6ZpBv._)((0, $iD6kw.useState)(/** @type {unknown} */ null), 2), error = _useState2[0], setError = _useState2[1];
    (0, $iD6kw.useEffect)(function() {
        var fetchData = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
                var response, err;
                return (0, $gh3Df._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            return [
                                4,
                                (0, $iit9R.default).get(url)
                            ];
                        case 1:
                            response = _state.sent();
                            setData(response.data);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            err = _state.sent();
                            setError(err);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            setLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        fetchData();
    }, []);
    return {
        data: data,
        loading: loading,
        error: error
    };
};



var $6ZpBv = parcelRequire("6ZpBv");

var $iD6kw = parcelRequire("iD6kw");
var $f4092a456d00538d$var$SEARCH_PARAM = 'filter_feature_search';
var $f4092a456d00538d$var$VIEW_PARAM = 'filter_feature_view';
var $f4092a456d00538d$var$CATEGORY_PARAM = 'filter_feature_category';
/**
 * @param {string} key
 * @param {string[] | null} [validValues]
 */ var $f4092a456d00538d$var$getUrlParam = function(key) {
    var validValues = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (typeof window === 'undefined') return null;
    var value = new URL(window.location).searchParams.get(key);
    return !validValues || validValues.includes(value) ? value : null;
};
/**
 * @param {string} key
 * @param {string} value
 * @param {string | null} [deleteIfValue]
 */ var $f4092a456d00538d$var$updateUrlParam = function(key, value) {
    var deleteIfValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var url = new URL(window.location);
    if (value === deleteIfValue) url.searchParams.delete(key);
    else url.searchParams.set(key, value);
    window.history.replaceState(null, '', url);
};
var $f4092a456d00538d$export$3274cf84b703fff = function(param) {
    var data = param.data, defaultView = param.defaultView;
    var userInteracted = (0, $iD6kw.useRef)(false);
    var _useState = (0, $6ZpBv._)((0, $iD6kw.useState)(function() {
        return $f4092a456d00538d$var$getUrlParam($f4092a456d00538d$var$CATEGORY_PARAM) || 'all';
    }), 2), categoryFilterTerm = _useState[0], setCategoryFilterTermState = _useState[1];
    var _useState1 = (0, $6ZpBv._)((0, $iD6kw.useState)(function() {
        return $f4092a456d00538d$var$getUrlParam($f4092a456d00538d$var$SEARCH_PARAM) || '';
    }), 2), searchValue = _useState1[0], setSearchValueState = _useState1[1];
    var _useState2 = (0, $6ZpBv._)((0, $iD6kw.useState)(/** @returns {import('../types/feature').FeatureView} */ function() {
        var urlView = $f4092a456d00538d$var$getUrlParam($f4092a456d00538d$var$VIEW_PARAM, [
            'grid',
            'list'
        ]);
        return urlView === 'grid' || urlView === 'list' ? urlView : defaultView;
    }), 2), view = _useState2[0], setViewState = _useState2[1];
    // Set the selection to 'staff_pick' if it exists in the categories and no URL filter is active
    (0, $iD6kw.useEffect)(function() {
        var hasUrlFilter = !!$f4092a456d00538d$var$getUrlParam($f4092a456d00538d$var$CATEGORY_PARAM);
        if (data && !data.isFiltered && !hasUrlFilter && !userInteracted.current && categoryFilterTerm === 'all' && 'staff_pick' in data.categories) setCategoryFilterTermState('staff_pick');
    }, [
        categoryFilterTerm,
        data
    ]);
    /** @param {string} slug */ var setCategoryFilterTerm = function(slug) {
        userInteracted.current = true;
        setCategoryFilterTermState(slug);
        $f4092a456d00538d$var$updateUrlParam($f4092a456d00538d$var$CATEGORY_PARAM, slug, 'all');
    };
    /** @param {string} value */ var setSearchValue = function(value) {
        setSearchValueState(value);
        $f4092a456d00538d$var$updateUrlParam($f4092a456d00538d$var$SEARCH_PARAM, value, '');
    };
    var clearSearchField = function() {
        return setSearchValue('');
    };
    var handleViewChange = function() {
        setViewState(function(current) {
            var next = current === 'grid' ? 'list' : 'grid';
            $f4092a456d00538d$var$updateUrlParam($f4092a456d00538d$var$VIEW_PARAM, next);
            return next;
        });
    };
    return {
        categoryFilterTerm: categoryFilterTerm,
        setCategoryFilterTerm: setCategoryFilterTerm,
        searchValue: searchValue,
        setSearchValue: setSearchValue,
        clearSearchField: clearSearchField,
        view: view,
        handleViewChange: handleViewChange
    };
};


/**
 * @param {Object} options
 * @param {import('../types/feature').FeatureData | null} options.data
 * @param {string} [options.customTitle]
 * @param {string} [options.customDescription]
 * @param {string} options.searchValue
 * @param {string} options.categoryFilterTerm
 * @param {import('../types/feature').GetLabel} options.getLabel
 */ var $31640fe148e66bac$export$97a37b1befbbf9b1 = function(param) {
    var data = param.data, customTitle = param.customTitle, customDescription = param.customDescription, searchValue = param.searchValue, categoryFilterTerm = param.categoryFilterTerm, getLabel = param.getLabel;
    var _data_categories_categoryFilterTerm, _data_categories_categoryFilterTerm1;
    if (searchValue) return {
        headingTitle: getLabel('search_title'),
        headingDescription: getLabel('search_desc')
    };
    else if (![
        'all',
        'staff_pick'
    ].includes(categoryFilterTerm)) return {
        headingTitle: data === null || data === void 0 ? void 0 : (_data_categories_categoryFilterTerm = data.categories[categoryFilterTerm]) === null || _data_categories_categoryFilterTerm === void 0 ? void 0 : _data_categories_categoryFilterTerm.title,
        headingDescription: data === null || data === void 0 ? void 0 : (_data_categories_categoryFilterTerm1 = data.categories[categoryFilterTerm]) === null || _data_categories_categoryFilterTerm1 === void 0 ? void 0 : _data_categories_categoryFilterTerm1.desc
    };
    else return {
        headingTitle: customTitle ? customTitle : getLabel('all_features_title'),
        headingDescription: customDescription ? customDescription : getLabel('all_features_desc')
    };
};



var $9HB6H = parcelRequire("9HB6H");

var $9HB6H = parcelRequire("9HB6H");

var $iD6kw = parcelRequire("iD6kw");
function $29454a465546113b$export$2e2bcd8739ae039(param) {
    var getLabel = param.getLabel, view = param.view, handleChange = param.handleChange;
    var options = [
        {
            value: 'grid',
            label: getLabel('layout_grid'),
            classes: 'option' + (view === 'grid' ? ' selected' : '')
        },
        {
            value: 'list',
            label: getLabel('layout_list'),
            classes: 'option' + (view === 'list' ? ' selected' : '')
        }
    ];
    var getOption = function(option) {
        return /*#__PURE__*/ (0, $9HB6H.jsx)("li", {
            className: option.classes,
            onClick: handleChange,
            children: /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                children: option.label
            })
        });
    };
    return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
        className: "feature__controls--option",
        children: /*#__PURE__*/ (0, $9HB6H.jsx)("ul", {
            className: "mcfly-options mcfly-options--small",
            "data-value": view,
            children: options.map(function(option, index) {
                return /*#__PURE__*/ (0, $9HB6H.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iD6kw))).Fragment, {
                    children: getOption(option)
                }, index);
            })
        })
    });
}



var $9HB6H = parcelRequire("9HB6H");
function $2e3037d5c24d84a7$export$2e2bcd8739ae039(param) {
    var searchValue = param.searchValue, setSearchValue = param.setSearchValue, getLabel = param.getLabel;
    var handleKeyDown = function(e) {
        if (e.key === 'Enter') e.preventDefault();
    };
    return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
        className: "feature__controls--search",
        children: /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
            className: "feature__controls--search-input",
            children: /*#__PURE__*/ (0, $9HB6H.jsxs)("form", {
                role: "search",
                className: "search-form",
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $9HB6H.jsx)("input", {
                        type: "search",
                        className: "search-field",
                        placeholder: getLabel('search_placeholder'),
                        value: searchValue,
                        name: "s",
                        onChange: function(event) {
                            return setSearchValue(event.target.value);
                        },
                        onKeyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                        className: "search-form__clear ".concat(searchValue ? 'show' : ''),
                        onClick: function() {
                            return setSearchValue('');
                        },
                        children: [
                            /*#__PURE__*/ (0, $9HB6H.jsx)("span", {}),
                            /*#__PURE__*/ (0, $9HB6H.jsx)("span", {})
                        ]
                    })
                ]
            })
        })
    });
}



var $6ZpBv = parcelRequire("6ZpBv");

var $9HB6H = parcelRequire("9HB6H");

var $iD6kw = parcelRequire("iD6kw");
var $63a66956ec9290f3$var$getCategoryStyle = function(color) {
    return {
        '--color': color
    };
};
function $63a66956ec9290f3$export$2e2bcd8739ae039(param) {
    var categories = param.categories, value = param.value, setValue = param.setValue, searchValue = param.searchValue, clearSearchField = param.clearSearchField;
    var _useState = (0, $6ZpBv._)((0, $iD6kw.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    // Event listener to close the select when clicking outside
    (0, $iD6kw.useEffect)(function() {
        var handleClickOutside = function(e) {
            if (!(e.target instanceof Element) || !e.target.closest('.feature__controls--select')) setIsOpen(false);
        };
        window.addEventListener('click', handleClickOutside);
        // Cleanup function to remove the event listener
        return function() {
            window.removeEventListener('click', handleClickOutside);
        };
    }, []);
    var handleOptionClick = function(slug) {
        if (searchValue !== '') clearSearchField();
        setValue(slug);
        setIsOpen(false);
    };
    var handleClearClick = function(e) {
        e.stopPropagation();
        handleOptionClick('all');
    };
    var getFeatureCount = function(value) {
        var allCount = categories.all.count;
        if (value === 'all') return /*#__PURE__*/ (0, $9HB6H.jsxs)("span", {
            className: "feature__controls--select-count",
            children: [
                "(",
                allCount,
                ")"
            ]
        });
        else return /*#__PURE__*/ (0, $9HB6H.jsxs)("span", {
            className: "feature__controls--select-count",
            children: [
                "(",
                categories[value].count,
                " / ",
                allCount,
                ")"
            ]
        });
    };
    return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
        className: "feature__controls--select",
        children: [
            /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                className: "feature__controls--select-trigger ".concat(isOpen ? 'open' : 'closed'),
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                children: [
                    /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                        className: "feature__controls--select-trigger-wrapper",
                        style: $63a66956ec9290f3$var$getCategoryStyle(categories[value].color),
                        children: [
                            categories[value].illustration ? /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: categories[value].illustration
                                }
                            }) : null,
                            /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                                className: "feature__controls--select-trigger-headline",
                                children: categories[value].title
                            }),
                            " ",
                            getFeatureCount(value)
                        ]
                    }),
                    /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                        className: "feature__controls--select__controls",
                        children: [
                            value !== 'all' && /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                                className: "feature__controls--select__controls-clear",
                                onClick: handleClearClick
                            }),
                            /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                                className: "feature__controls--select__controls-arrow"
                            })
                        ]
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $9HB6H.jsx)("ul", {
                className: "feature__controls--select-options",
                children: Object.values(categories).map(function(category) {
                    return /*#__PURE__*/ (0, $9HB6H.jsxs)("li", {
                        className: "feature__controls--select-option",
                        onClick: function() {
                            return handleOptionClick(category.slug);
                        },
                        style: $63a66956ec9290f3$var$getCategoryStyle(category.color),
                        children: [
                            category.illustration ? /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: category.illustration
                                }
                            }) : null,
                            /*#__PURE__*/ (0, $9HB6H.jsxs)("span", {
                                className: "feature__controls--select-option-headline",
                                children: [
                                    category.title,
                                    " ",
                                    getFeatureCount(category.slug)
                                ]
                            })
                        ]
                    }, category.slug);
                })
            })
        ]
    });
}


function $d4da02274984f02c$export$2e2bcd8739ae039(param) {
    var categories = param.categories, clearSearchField = param.clearSearchField, setSearchValue = param.setSearchValue, setCategoryFilterTerm = param.setCategoryFilterTerm, handleViewChange = param.handleViewChange, getLabel = param.getLabel, searchValue = param.searchValue, categoryFilterTerm = param.categoryFilterTerm, view = param.view, isFiltered = param.isFiltered;
    return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
        className: "feature__controls",
        children: [
            /*#__PURE__*/ (0, $9HB6H.jsx)((0, $29454a465546113b$export$2e2bcd8739ae039), {
                getLabel: getLabel,
                view: view,
                handleChange: handleViewChange
            }),
            !isFiltered && Object.keys(categories).length ? /*#__PURE__*/ (0, $9HB6H.jsx)((0, $63a66956ec9290f3$export$2e2bcd8739ae039), {
                categories: categories,
                value: categoryFilterTerm,
                setValue: setCategoryFilterTerm,
                searchValue: searchValue,
                clearSearchField: clearSearchField
            }) : null,
            /*#__PURE__*/ (0, $9HB6H.jsx)((0, $2e3037d5c24d84a7$export$2e2bcd8739ae039), {
                searchValue: searchValue,
                setSearchValue: setSearchValue,
                getLabel: getLabel
            })
        ]
    });
}



var $9HB6H = parcelRequire("9HB6H");

var $lYyrX = parcelRequire("lYyrX");

var $iD6kw = parcelRequire("iD6kw");

var $kqzqZ = parcelRequire("kqzqZ");

var $iD6kw = parcelRequire("iD6kw");
var $77a6dce973f88fd2$export$9e0acbc88557b05 = function(param) {
    var index = param.index, total = param.total, onNavigate = param.onNavigate, scrollRef = param.scrollRef, isDisabled = param.isDisabled;
    var hasNavigation = total > 1;
    var previousIndex = (index - 1 + total) % total;
    var nextIndex = (index + 1) % total;
    (0, $iD6kw.useEffect)(function() {
        var _scrollRef_current;
        scrollRef === null || scrollRef === void 0 ? void 0 : (_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.scrollTo({
            top: 0
        });
    }, [
        index
    ]);
    var goToPrevious = function() {
        return onNavigate(previousIndex);
    };
    var goToNext = function() {
        return onNavigate(nextIndex);
    };
    /** @param {import('react').KeyboardEvent<HTMLDialogElement>} event */ var handleKeyDown = function(event) {
        if (!hasNavigation || (isDisabled === null || isDisabled === void 0 ? void 0 : isDisabled())) return;
        if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goToPrevious();
        } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            goToNext();
        }
    };
    return {
        hasNavigation: hasNavigation,
        goToPrevious: goToPrevious,
        goToNext: goToNext,
        handleKeyDown: handleKeyDown
    };
};



var $iD6kw = parcelRequire("iD6kw");
var $b3364a52afc9857c$export$1e9ab8114847a87d = function(param) {
    var isOpen = param.isOpen, onRefChange = param.onRefChange, preventClose = param.preventClose;
    var dialogRef = (0, $iD6kw.useRef)(/** @type {HTMLDialogElement | null} */ null);
    (0, $iD6kw.useEffect)(function() {
        var dialog = dialogRef.current;
        if (!dialog) return;
        if (isOpen && !dialog.open) dialog.showModal();
        else if (!isOpen && dialog.open) dialog.close();
    }, [
        isOpen
    ]);
    var setDialogRef = (0, $iD6kw.useCallback)(/** @param {HTMLDialogElement | null} element */ function(element) {
        dialogRef.current = element;
        onRefChange === null || onRefChange === void 0 ? void 0 : onRefChange(element);
    }, [
        onRefChange
    ]);
    var close = function() {
        var _dialogRef_current;
        return (_dialogRef_current = dialogRef.current) === null || _dialogRef_current === void 0 ? void 0 : _dialogRef_current.close();
    };
    // Clicks on the backdrop target the dialog element itself.
    /** @param {import('react').MouseEvent<HTMLDialogElement>} event */ var handleBackdropClick = function(event) {
        if (event.target === dialogRef.current) close();
    };
    /** @param {import('react').SyntheticEvent<HTMLDialogElement>} event */ var handleCancel = function(event) {
        if (preventClose === null || preventClose === void 0 ? void 0 : preventClose()) event.preventDefault();
    };
    return {
        dialogRef: dialogRef,
        setDialogRef: setDialogRef,
        close: close,
        handleBackdropClick: handleBackdropClick,
        handleCancel: handleCancel
    };
};



var $9HB6H = parcelRequire("9HB6H");

var $lYyrX = parcelRequire("lYyrX");

var $6ZpBv = parcelRequire("6ZpBv");

var $9HB6H = parcelRequire("9HB6H");

var $bW2QE = parcelRequire("bW2QE");parcelRequire("fZKlV");
var $56VF7 = parcelRequire("56VF7");

var $iD6kw = parcelRequire("iD6kw");
var $57a8ffa0dbef0ec6$var$VISIBLE_ITEMS = 4;
var $57a8ffa0dbef0ec6$var$renderItem = function(param) {
    var _param = (0, $6ZpBv._)(param, 2), key = _param[0], value = _param[1];
    return /*#__PURE__*/ (0, $9HB6H.jsx)("li", {
        dangerouslySetInnerHTML: {
            __html: value
        },
        className: value ? 'check' : 'cross'
    }, key);
};
function $57a8ffa0dbef0ec6$export$2e2bcd8739ae039(param) {
    var items = param.items, getLabel = param.getLabel;
    var _useState = (0, $6ZpBv._)((0, $iD6kw.useState)(false), 2), isExpanded = _useState[0], setIsExpanded = _useState[1];
    var moreId = (0, $iD6kw.useId)();
    var entries = Object.entries(items);
    var visibleEntries = entries.slice(0, $57a8ffa0dbef0ec6$var$VISIBLE_ITEMS);
    var hiddenEntries = entries.slice($57a8ffa0dbef0ec6$var$VISIBLE_ITEMS);
    return /*#__PURE__*/ (0, $9HB6H.jsxs)((0, $9HB6H.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9HB6H.jsx)("ul", {
                className: "list list-item--key-points",
                children: visibleEntries.map($57a8ffa0dbef0ec6$var$renderItem)
            }),
            hiddenEntries.length > 0 && /*#__PURE__*/ (0, $9HB6H.jsxs)((0, $9HB6H.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9HB6H.jsx)((0, $bW2QE.AnimatePresence), {
                        initial: false,
                        children: isExpanded && /*#__PURE__*/ (0, $9HB6H.jsx)((0, $56VF7.motion).ul, {
                            id: moreId,
                            className: "list list-item--key-points list-item--key-points-more",
                            initial: {
                                height: 0,
                                opacity: 0
                            },
                            animate: {
                                height: 'auto',
                                opacity: 1
                            },
                            exit: {
                                height: 0,
                                opacity: 0
                            },
                            transition: {
                                duration: 0.3,
                                ease: 'easeInOut'
                            },
                            children: hiddenEntries.map($57a8ffa0dbef0ec6$var$renderItem)
                        })
                    }),
                    /*#__PURE__*/ (0, $9HB6H.jsxs)("button", {
                        type: "button",
                        className: "list-item--key-points-toggle",
                        "aria-expanded": isExpanded,
                        "aria-controls": moreId,
                        onClick: function() {
                            return setIsExpanded(!isExpanded);
                        },
                        children: [
                            isExpanded ? getLabel('show_less') : getLabel('show_more').replace('%d', String(hiddenEntries.length)),
                            /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                                className: "list-item--key-points-toggle-icon",
                                "aria-hidden": "true",
                                children: "keyboard_arrow_down"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


var $7c6a01a7ca7cb975$var$VARIANTS = {
    list: {
        headingTag: 'h6',
        primaryButton: false
    },
    dialog: {
        headingTag: 'h4',
        primaryButton: true
    }
};
var $7c6a01a7ca7cb975$var$getCategoryStyle = function(color) {
    return {
        '--color': color
    };
};
function $7c6a01a7ca7cb975$export$2e2bcd8739ae039(param) {
    var feature = param.feature, categories = param.categories, getLabel = param.getLabel, editions = param.editions, showLightbox = param.showLightbox, _param_variant = param.variant, variant = _param_variant === void 0 ? 'list' : _param_variant, _param_headerAction = param.headerAction, headerAction = _param_headerAction === void 0 ? null : _param_headerAction;
    var _ref = $7c6a01a7ca7cb975$var$VARIANTS[variant] || $7c6a01a7ca7cb975$var$VARIANTS.list, HeadingTag = _ref.headingTag, primaryButton = _ref.primaryButton;
    var displayGallery = function(feature) {
        if (feature.images === undefined && feature.popup_video === undefined) return null;
        var gallery = (feature === null || feature === void 0 ? void 0 : feature.images) || [];
        var videoID = (feature === null || feature === void 0 ? void 0 : feature.popup_video) || '';
        var thumbnail = '';
        if (videoID !== '') {
            thumbnail = "https://i.ytimg.com/vi/".concat(videoID, "/hqdefault.jpg");
            var videoUrl = "https://youtu.be/".concat(videoID, "?feature=shared&no-cookie");
            // if video not already in gallery
            if (!gallery.find(function(media) {
                return media.url === videoUrl;
            })) gallery.unshift({
                type: 'video',
                url: videoUrl,
                title: 'Video'
            });
        }
        return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
            className: "list-item--gallery",
            children: /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                className: "list-item--gallery-wrapper",
                children: gallery.map(function(media, index) {
                    return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                        className: "list-item--gallery-item",
                        onClick: function() {
                            return showLightbox(feature.id, gallery, index + 1);
                        },
                        children: 'video' === media.type ? /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                            className: "wrapper-video",
                            children: /*#__PURE__*/ (0, $9HB6H.jsx)("video", {
                                src: media.url,
                                poster: thumbnail
                            })
                        }) : /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                            className: "wrapper-image",
                            children: /*#__PURE__*/ (0, $9HB6H.jsx)("img", {
                                src: media.url,
                                alt: media.title
                            })
                        })
                    }, index);
                })
            })
        });
    };
    var getKeyPoints = function() {
        if (!Object.keys(feature.detail_func).length) return null;
        return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
            className: "list-item--key_points",
            children: [
                /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                    className: "list-item--sub-headline",
                    children: getLabel('key_points_headline')
                }),
                /*#__PURE__*/ (0, $9HB6H.jsx)((0, $57a8ffa0dbef0ec6$export$2e2bcd8739ae039), {
                    items: feature.detail_func,
                    getLabel: getLabel
                }, feature.id)
            ]
        });
    };
    var headline = /*#__PURE__*/ (0, $9HB6H.jsx)(HeadingTag, {
        className: "list-item--headline",
        dangerouslySetInnerHTML: {
            __html: feature.name
        }
    });
    return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
        className: "list-item-wrapper list-item-wrapper--".concat(variant, " list-item-wrapper--").concat(feature.images || feature.popup_video ? 'media' : 'no-media'),
        children: [
            headerAction ? /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                className: "list-item--header",
                children: [
                    headline,
                    headerAction
                ]
            }) : headline,
            displayGallery(feature),
            /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                className: "list-item--description",
                children: [
                    /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                        className: "list-item--sub-headline",
                        children: getLabel('description_headline')
                    }),
                    /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: feature.desc_list
                        }
                    })
                ]
            }),
            editions.length ? /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                className: "list-item--editions",
                children: [
                    /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                        className: "list-item--sub-headline",
                        children: getLabel('edition_headline')
                    }),
                    /*#__PURE__*/ (0, $9HB6H.jsx)("ul", {
                        className: "no-list",
                        children: editions.map(function(edition) {
                            return /*#__PURE__*/ (0, $9HB6H.jsx)("li", {
                                className: "list-item--icon",
                                "data-checked": feature.editions.includes(edition.slug),
                                children: edition.name
                            }, edition.slug);
                        })
                    })
                ]
            }) : null,
            getKeyPoints(),
            feature.primary_category && /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                className: "list-item--category",
                style: $7c6a01a7ca7cb975$var$getCategoryStyle(categories[feature.primary_category].color),
                children: categories[feature.primary_category].title
            }),
            feature.content_url && /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                className: "list-item--actions",
                children: /*#__PURE__*/ (0, $9HB6H.jsx)((0, $lYyrX.default), {
                    primary: primaryButton,
                    href: feature.content_url,
                    children: getLabel('read_more')
                })
            })
        ]
    });
}


var $24058f62c4537f1b$var$getPlainText = function(html) {
    var _parseFromString_body_textContent;
    return (_parseFromString_body_textContent = new DOMParser().parseFromString(html, 'text/html').body.textContent) !== null && _parseFromString_body_textContent !== void 0 ? _parseFromString_body_textContent : '';
};
function $24058f62c4537f1b$export$2e2bcd8739ae039(param) {
    var feature = param.feature, isOpen = param.isOpen, index = param.index, total = param.total, onNavigate = param.onNavigate, onClose = param.onClose, categories = param.categories, editions = param.editions, getLabel = param.getLabel, showLightbox = param.showLightbox;
    var _useModalDialog = (0, $b3364a52afc9857c$export$1e9ab8114847a87d)({
        isOpen: isOpen
    }), dialogRef = _useModalDialog.dialogRef, setDialogRef = _useModalDialog.setDialogRef, close = _useModalDialog.close, handleBackdropClick = _useModalDialog.handleBackdropClick, handleCancel = _useModalDialog.handleCancel;
    var closeButtonRef = (0, $iD6kw.useRef)(null);
    (0, $iD6kw.useLayoutEffect)(function() {
        var _dialogRef_current, _closeButtonRef_current;
        if (((_dialogRef_current = dialogRef.current) === null || _dialogRef_current === void 0 ? void 0 : _dialogRef_current.open) && document.activeElement === document.body) (_closeButtonRef_current = closeButtonRef.current) === null || _closeButtonRef_current === void 0 ? void 0 : _closeButtonRef_current.focus({
            preventScroll: true
        });
    }, [
        feature,
        index,
        dialogRef
    ]);
    var _useCyclicNavigation = (0, $77a6dce973f88fd2$export$9e0acbc88557b05)({
        index: index,
        total: total,
        onNavigate: onNavigate,
        scrollRef: dialogRef
    }), hasNavigation = _useCyclicNavigation.hasNavigation, goToPrevious = _useCyclicNavigation.goToPrevious, goToNext = _useCyclicNavigation.goToNext, handleKeyDown = _useCyclicNavigation.handleKeyDown;
    var label = (0, $iD6kw.useMemo)(function() {
        return feature ? $24058f62c4537f1b$var$getPlainText(feature.name) : undefined;
    }, [
        feature
    ]);
    var _feature_id;
    return /*#__PURE__*/ (0, $kqzqZ.createPortal)(/*#__PURE__*/ (0, $9HB6H.jsx)("dialog", {
        ref: setDialogRef,
        className: "feature-dialog",
        "aria-label": label,
        onClose: onClose,
        onCancel: handleCancel,
        onClick: handleBackdropClick,
        onKeyDown: handleKeyDown,
        children: feature && /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
            className: "feature-dialog__inner",
            children: [
                /*#__PURE__*/ (0, $9HB6H.jsx)((0, $7c6a01a7ca7cb975$export$2e2bcd8739ae039), {
                    feature: feature,
                    categories: categories,
                    getLabel: getLabel,
                    editions: editions,
                    showLightbox: showLightbox,
                    variant: "dialog",
                    headerAction: /*#__PURE__*/ (0, $9HB6H.jsx)("button", {
                        ref: closeButtonRef,
                        type: "button",
                        className: "feature-dialog__close",
                        "aria-label": getLabel('close'),
                        onClick: close,
                        children: /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                            "aria-hidden": "true",
                            children: "close"
                        })
                    })
                }, (_feature_id = feature.id) !== null && _feature_id !== void 0 ? _feature_id : index),
                hasNavigation && /*#__PURE__*/ (0, $9HB6H.jsxs)("nav", {
                    className: "feature-dialog__nav",
                    children: [
                        /*#__PURE__*/ (0, $9HB6H.jsxs)((0, $lYyrX.TertiaryButton), {
                            onClick: goToPrevious,
                            children: [
                                /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                                    className: "feature-dialog__nav-icon",
                                    "aria-hidden": "true",
                                    children: "keyboard_arrow_left"
                                }),
                                /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                                    className: "feature-dialog__nav-label",
                                    children: getLabel('previous')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9HB6H.jsxs)("span", {
                            className: "feature-dialog__nav-count",
                            "aria-live": "polite",
                            children: [
                                index + 1,
                                " / ",
                                total
                            ]
                        }),
                        /*#__PURE__*/ (0, $9HB6H.jsxs)((0, $lYyrX.TertiaryButton), {
                            onClick: goToNext,
                            children: [
                                /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                                    className: "feature-dialog__nav-label",
                                    children: getLabel('next')
                                }),
                                /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                                    className: "feature-dialog__nav-icon",
                                    "aria-hidden": "true",
                                    children: "keyboard_arrow_right"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }), document.body);
}



var $6ZpBv = parcelRequire("6ZpBv");

var $jlUaU = parcelRequire("jlUaU");

var $9HB6H = parcelRequire("9HB6H");

var $iD6kw = parcelRequire("iD6kw");

var $6ZpBv = parcelRequire("6ZpBv");

var $60cC9 = parcelRequire("60cC9");

var $iD6kw = parcelRequire("iD6kw");
var $d0c8c5e2bc04af1e$export$4a39035bacc4ed76 = function(features, categoryFilterTerm, searchValue) {
    var _useState = (0, $6ZpBv._)((0, $iD6kw.useState)(/** @type {import('../types/feature').Feature[]} */ []), 2), primaryFeatures = _useState[0], setPrimaryFeatures = _useState[1];
    var _useState1 = (0, $6ZpBv._)((0, $iD6kw.useState)(/** @type {import('../types/feature').Feature[]} */ []), 2), secondaryFeatures = _useState1[0], setSecondaryFeatures = _useState1[1];
    (0, $iD6kw.useEffect)(function() {
        setPrimaryFeatures(function() {
            if (searchValue !== '') return $d0c8c5e2bc04af1e$var$filterFeaturesBySearchTerm(features, searchValue);
            if (categoryFilterTerm === 'all') return features;
            else if (categoryFilterTerm === 'staff_pick') return features.filter(function(feature) {
                return feature.staff_pick;
            });
            else return features.filter(function(feature) {
                return feature.primary_category === categoryFilterTerm;
            });
        });
        setSecondaryFeatures(function() {
            var defaultFilterTerms = [
                'all',
                'staff_pick'
            ];
            if (searchValue === '' && !defaultFilterTerms.includes(categoryFilterTerm)) return features.filter(function(feature) {
                var _feature_secondary_categories;
                return (_feature_secondary_categories = feature.secondary_categories) === null || _feature_secondary_categories === void 0 ? void 0 : _feature_secondary_categories.includes(categoryFilterTerm);
            });
            return [];
        });
    }, [
        categoryFilterTerm,
        searchValue
    ]);
    return [
        primaryFeatures,
        secondaryFeatures
    ];
};
/**
 * @param {import('../types/feature').Feature[]} features
 * @param {string} term
 */ var $d0c8c5e2bc04af1e$var$filterFeaturesBySearchTerm = function(features, term) {
    var fuse = new (0, $60cC9.default)(features, {
        threshold: 0.3,
        keys: [
            'name',
            'desc_grid',
            'desc_list',
            'detail_func'
        ]
    });
    return fuse.search(term).map(function(result) {
        return result.item;
    });
};



var $9HB6H = parcelRequire("9HB6H");
function $a214459649f83fea$export$2e2bcd8739ae039(param) {
    var title = param.title, description = param.description, _param_type = param.type, type = _param_type === void 0 ? 'h2' : _param_type;
    var HeadingTag = type;
    return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
        className: "feature__heading",
        children: /*#__PURE__*/ (0, $9HB6H.jsxs)("hgroup", {
            className: "feature__heading",
            children: [
                /*#__PURE__*/ (0, $9HB6H.jsx)(HeadingTag, {
                    className: "feature__heading--headline",
                    children: title
                }),
                /*#__PURE__*/ (0, $9HB6H.jsx)("p", {
                    className: "feature__heading--sub-headline text-subline",
                    children: description
                })
            ]
        })
    });
}



var $9HB6H = parcelRequire("9HB6H");
function $0d792a4c37385e3d$export$2e2bcd8739ae039(param) {
    var children = param.children, _param_type = param.type, type = _param_type === void 0 ? 'primary' : _param_type;
    return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
        className: "feature__infobox",
        children: /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
            className: "infobox infobox--".concat(type),
            children: /*#__PURE__*/ (0, $9HB6H.jsx)("p", {
                children: children
            })
        })
    });
}




var $9HB6H = parcelRequire("9HB6H");
function $4726e32270df04c6$export$2e2bcd8739ae039(param) {
    var feature = param.feature, categories = param.categories, onClick = param.onClick;
    var category = feature.primary_category ? categories[feature.primary_category] : undefined;
    var style = category ? {
        '--color': category.color
    } : undefined;
    var _feature_icon;
    return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
        className: "tile tile--image-size-regular tile--action",
        style: style,
        "aria-haspopup": "dialog",
        role: "button",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
            className: "tile__container",
            children: [
                /*#__PURE__*/ (0, $9HB6H.jsxs)("header", {
                    className: "tile__header",
                    children: [
                        /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                            className: "tile__icon",
                            dangerouslySetInnerHTML: {
                                __html: (_feature_icon = feature.icon) !== null && _feature_icon !== void 0 ? _feature_icon : ''
                            }
                        }),
                        /*#__PURE__*/ (0, $9HB6H.jsx)("p", {
                            className: "h6",
                            dangerouslySetInnerHTML: {
                                __html: feature.name
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                    className: "tile__content",
                    children: /*#__PURE__*/ (0, $9HB6H.jsx)("p", {
                        dangerouslySetInnerHTML: {
                            __html: feature.desc_grid
                        }
                    })
                }),
                /*#__PURE__*/ (0, $9HB6H.jsx)("footer", {
                    className: "tile__footer",
                    children: category && /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                        className: "tile__category",
                        children: category.title
                    })
                })
            ]
        })
    });
}


function $eab63cd3f9b89896$export$2e2bcd8739ae039(param) {
    var categories = param.categories, editions = param.editions, features = param.features, categoryFilterTerm = param.categoryFilterTerm, getLabel = param.getLabel, searchValue = param.searchValue, showLightbox = param.showLightbox, showFeature = param.showFeature, useListView = param.useListView, isFiltered = param.isFiltered;
    var _useFeatures = (0, $6ZpBv._)((0, $d0c8c5e2bc04af1e$export$4a39035bacc4ed76)(features, categoryFilterTerm, searchValue), 2), filteredPrimaryFeatures = _useFeatures[0], filteredSecondaryFeatures = _useFeatures[1];
    var groupByCategory = categoryFilterTerm === 'all' && searchValue === '' && !isFiltered && Object.keys(categories).length > 0;
    // The primary feature groups in render order, so the dialog navigation follows the visible order.
    var primaryGroups = groupByCategory ? Object.entries(categories).filter(function(param) {
        var _param = (0, $6ZpBv._)(param, 1), key = _param[0];
        return ![
            'all',
            'staff_pick'
        ].includes(key);
    }).map(function(param) {
        var _param = (0, $6ZpBv._)(param, 2), key = _param[0], category = _param[1];
        return {
            key: key,
            category: category,
            features: filteredPrimaryFeatures.filter(function(feature) {
                return feature.primary_category === key;
            })
        };
    }) : [
        {
            key: 'all',
            category: null,
            features: filteredPrimaryFeatures
        }
    ];
    var orderedFeatures = (0, $jlUaU._)(primaryGroups.flatMap(function(group) {
        return group.features;
    })).concat((0, $jlUaU._)(filteredSecondaryFeatures));
    var renderFeatures = function(features, offset) {
        return useListView ? /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
            className: "feature-list",
            children: features.map(function(feature, index) {
                return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $7c6a01a7ca7cb975$export$2e2bcd8739ae039), {
                    feature: feature,
                    categories: categories,
                    getLabel: getLabel,
                    editions: editions,
                    showLightbox: showLightbox
                }, index);
            })
        }) : /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
            className: "tile-grid",
            children: features.map(function(feature, index) {
                return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $4726e32270df04c6$export$2e2bcd8739ae039), {
                    feature: feature,
                    categories: categories,
                    onClick: function() {
                        return showFeature === null || showFeature === void 0 ? void 0 : showFeature(orderedFeatures, offset + index);
                    }
                }, index);
            })
        });
    };
    var renderMainFeatures = function() {
        var offset = 0;
        return primaryGroups.map(function(group) {
            var groupOffset = offset;
            offset += group.features.length;
            if (!group.category) return /*#__PURE__*/ (0, $9HB6H.jsx)((0, $iD6kw.Fragment), {
                children: renderFeatures(group.features, groupOffset)
            }, group.key);
            return /*#__PURE__*/ (0, $9HB6H.jsxs)((0, $iD6kw.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9HB6H.jsx)((0, $a214459649f83fea$export$2e2bcd8739ae039), {
                        title: group.category.title,
                        description: group.category.desc,
                        type: "h3"
                    }),
                    renderFeatures(group.features, groupOffset)
                ]
            }, group.key);
        });
    };
    return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
        className: "feature__content",
        children: [
            /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
                className: "feature__content--primary",
                children: filteredPrimaryFeatures.length ? renderMainFeatures() : /*#__PURE__*/ (0, $9HB6H.jsx)((0, $0d792a4c37385e3d$export$2e2bcd8739ae039), {
                    type: "warning",
                    children: getLabel('no_entries_desc')
                })
            }),
            filteredSecondaryFeatures.length > 0 && /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
                className: "feature__content--additional",
                children: [
                    /*#__PURE__*/ (0, $9HB6H.jsx)((0, $a214459649f83fea$export$2e2bcd8739ae039), {
                        title: getLabel('additional_title'),
                        description: getLabel('additional_desc'),
                        type: "h3"
                    }),
                    renderFeatures(filteredSecondaryFeatures, orderedFeatures.length - filteredSecondaryFeatures.length)
                ]
            })
        ]
    });
}



function $fafb5ef51cfb128d$export$2e2bcd8739ae039(props) {
    var getLabels = function() {
        return (data === null || data === void 0 ? void 0 : data.labels) || {};
    };
    var getLabel = function(key) {
        return getLabels()[key] || '';
    };
    var rootRef = (0, $iD6kw.useRef)(null);
    var _useData = (0, $eca3b2ac27e7650f$export$c1cf1cf4c5d51937)(props.restUrl), data = _useData.data, loading = _useData.loading, error = _useData.error;
    var _useFilter = (0, $f4092a456d00538d$export$3274cf84b703fff)({
        data: data,
        defaultView: props.view
    }), categoryFilterTerm = _useFilter.categoryFilterTerm, setCategoryFilterTerm = _useFilter.setCategoryFilterTerm, searchValue = _useFilter.searchValue, setSearchValue = _useFilter.setSearchValue, clearSearchField = _useFilter.clearSearchField, view = _useFilter.view, handleViewChange = _useFilter.handleViewChange;
    var _useState = (0, $6ZpBv._)((0, $iD6kw.useState)([
        {
            url: '',
            title: ''
        }
    ]), 2), lightboxImages = _useState[0], setLightboxImages = _useState[1];
    var _useState1 = (0, $6ZpBv._)((0, $iD6kw.useState)(0), 2), lightboxKey = _useState1[0], setLightboxKey = _useState1[1];
    var _useState2 = (0, $6ZpBv._)((0, $iD6kw.useState)(1), 2), lightboxSlide = _useState2[0], setLightboxSlide = _useState2[1];
    var _useState3 = (0, $6ZpBv._)((0, $iD6kw.useState)(false), 2), toggler = _useState3[0], setToggler = _useState3[1];
    // The features are kept after closing so the content stays visible during the exit transition.
    var _useState4 = (0, $6ZpBv._)((0, $iD6kw.useState)({
        features: [],
        index: -1,
        isOpen: false
    }), 2), dialogState = _useState4[0], setDialogState = _useState4[1];
    var activeFeature = dialogState.features[dialogState.index] || null;
    var _useHeading = (0, $31640fe148e66bac$export$97a37b1befbbf9b1)({
        data: data,
        customTitle: props.customTitle,
        customDescription: props.customDescription,
        searchValue: searchValue,
        categoryFilterTerm: categoryFilterTerm,
        getLabel: getLabel
    }), headingTitle = _useHeading.headingTitle, headingDescription = _useHeading.headingDescription;
    var getAllFeaturesButton = function() {
        if (props.hideAllFeaturesButton || !data) return null;
        if (data.isFiltered) return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
            className: "feature__show-all btn-ctr",
            children: /*#__PURE__*/ (0, $9HB6H.jsx)((0, $lYyrX.default), {
                href: data.featurePageUrl,
                specifier: "center",
                children: getLabel('show_me_all')
            })
        });
        else if (categoryFilterTerm !== 'all') return /*#__PURE__*/ (0, $9HB6H.jsx)("div", {
            className: "feature__show-all btn-ctr",
            children: /*#__PURE__*/ (0, $9HB6H.jsx)((0, $lYyrX.default), {
                onClick: showAllFeatures,
                specifier: "center",
                children: getLabel('show_me_all')
            })
        });
    };
    var showAllFeatures = function() {
        var _rootRef_current;
        setCategoryFilterTerm('all');
        (_rootRef_current = rootRef.current) === null || _rootRef_current === void 0 ? void 0 : _rootRef_current.scrollIntoView({
            behavior: 'smooth'
        });
    };
    var showLightbox = function(key, images, slide) {
        setLightboxImages(images);
        setLightboxKey(key);
        setLightboxSlide(slide);
        setToggler(!toggler);
    };
    (0, $iD6kw.useEffect)(function() {
        setToggler(!toggler);
    }, [
        lightboxImages
    ]);
    var showFeature = function(features, index) {
        setDialogState({
            features: features,
            index: index,
            isOpen: true
        });
    };
    var navigateFeature = function(index) {
        setDialogState(function(state) {
            return (0, $hApvp._)((0, $kWfK0._)({}, state), {
                index: index
            });
        });
    };
    var lightboxPortal = function() {
        var lightboxWrapper = document.getElementById('lightbox-wrapper');
        if (!lightboxWrapper) throw new Error('Feature lightbox requires #lightbox-wrapper.');
        // `useDialog` opens the lightbox in its own modal dialog, so it stacks above the feature dialog in the top layer.
        return /*#__PURE__*/ (0, $kqzqZ.createPortal)(/*#__PURE__*/ (0, $9HB6H.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6f2a73f4fdc93d35$exports))), {
            toggler: toggler,
            useDialog: true,
            sources: lightboxImages.map(function(image) {
                return image['url'];
            }),
            slide: lightboxSlide,
            captions: lightboxImages.map(function(image, index) {
                return /*#__PURE__*/ (0, $9HB6H.jsx)("span", {
                    children: image['title']
                }, index);
            })
        }, lightboxKey), lightboxWrapper);
    };
    if (!loading && !error && data) return /*#__PURE__*/ (0, $9HB6H.jsxs)("div", {
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $9HB6H.jsx)((0, $a214459649f83fea$export$2e2bcd8739ae039), {
                type: "h2",
                title: headingTitle,
                description: headingDescription
            }),
            /*#__PURE__*/ (0, $9HB6H.jsx)((0, $d4da02274984f02c$export$2e2bcd8739ae039), {
                categories: data.categories,
                clearSearchField: clearSearchField,
                setSearchValue: setSearchValue,
                setCategoryFilterTerm: setCategoryFilterTerm,
                handleViewChange: handleViewChange,
                getLabel: getLabel,
                searchValue: searchValue,
                categoryFilterTerm: categoryFilterTerm,
                view: view,
                isFiltered: data.isFiltered
            }),
            /*#__PURE__*/ (0, $9HB6H.jsx)((0, $eab63cd3f9b89896$export$2e2bcd8739ae039), {
                categories: data.categories,
                categoryFilterTerm: categoryFilterTerm,
                editions: data.editions,
                features: data.features,
                getLabel: getLabel,
                searchValue: searchValue,
                showLightbox: showLightbox,
                showFeature: showFeature,
                useListView: view === 'list',
                isFiltered: data.isFiltered
            }),
            getAllFeaturesButton(),
            /*#__PURE__*/ (0, $9HB6H.jsx)((0, $24058f62c4537f1b$export$2e2bcd8739ae039), {
                feature: activeFeature,
                isOpen: dialogState.isOpen,
                index: dialogState.index,
                total: dialogState.features.length,
                onNavigate: navigateFeature,
                onClose: function() {
                    return setDialogState(function(state) {
                        return (0, $hApvp._)((0, $kWfK0._)({}, state), {
                            isOpen: false
                        });
                    });
                },
                categories: data.categories,
                editions: data.editions,
                getLabel: getLabel,
                showLightbox: showLightbox
            }),
            lightboxPortal()
        ]
    });
    return null;
}


var $b4f83ea26cf27019$var$el = document.querySelector('#feature');
var $b4f83ea26cf27019$var$lightboxWrapper = document.createElement('div');
$b4f83ea26cf27019$var$lightboxWrapper.id = 'lightbox-wrapper';
document.body.appendChild($b4f83ea26cf27019$var$lightboxWrapper);
if ($b4f83ea26cf27019$var$el) {
    var $b4f83ea26cf27019$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($kwI20))).createRoot($b4f83ea26cf27019$var$el);
    var $b4f83ea26cf27019$var$_el_dataset_customData;
    var $b4f83ea26cf27019$var$_JSON_parse = JSON.parse(($b4f83ea26cf27019$var$_el_dataset_customData = $b4f83ea26cf27019$var$el.dataset.customData) !== null && $b4f83ea26cf27019$var$_el_dataset_customData !== void 0 ? $b4f83ea26cf27019$var$_el_dataset_customData : '{}'), $b4f83ea26cf27019$var$default_view = $b4f83ea26cf27019$var$_JSON_parse.default_view, $b4f83ea26cf27019$var$hide_all_features_button = $b4f83ea26cf27019$var$_JSON_parse.hide_all_features_button, $b4f83ea26cf27019$var$custom_title = $b4f83ea26cf27019$var$_JSON_parse.custom_title, $b4f83ea26cf27019$var$custom_description = $b4f83ea26cf27019$var$_JSON_parse.custom_description;
    var $b4f83ea26cf27019$var$_el_dataset_restUrl;
    $b4f83ea26cf27019$var$root.render(/*#__PURE__*/ (0, $9HB6H.jsx)((0, $iD6kw.StrictMode), {
        children: /*#__PURE__*/ (0, $9HB6H.jsx)((0, $fafb5ef51cfb128d$export$2e2bcd8739ae039), {
            customDescription: $b4f83ea26cf27019$var$custom_description,
            customTitle: $b4f83ea26cf27019$var$custom_title,
            hideAllFeaturesButton: $b4f83ea26cf27019$var$hide_all_features_button,
            restUrl: ($b4f83ea26cf27019$var$_el_dataset_restUrl = $b4f83ea26cf27019$var$el.dataset.restUrl) !== null && $b4f83ea26cf27019$var$_el_dataset_restUrl !== void 0 ? $b4f83ea26cf27019$var$_el_dataset_restUrl : '',
            view: $b4f83ea26cf27019$var$default_view
        })
    }));
}

})();
//# sourceMappingURL=feature.min.js.map
